import './style.css';
var f4 = Object.defineProperty;
var p4 = (e, t, r) => t in e ? f4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var _o = (e, t, r) => (p4(e, typeof t != "symbol" ? t + "" : t, r), r);
import { inject as De, computed as W, onBeforeMount as ya, watchEffect as rr, ref as L, watch as at, provide as Et, onBeforeUnmount as vt, shallowRef as T1, isVNode as h4, Comment as qg, Fragment as qt, defineComponent as Z, h as S, TransitionGroup as g4, Transition as zn, onMounted as et, readonly as ui, toRef as We, nextTick as mn, useSlots as wr, openBlock as _, createBlock as se, unref as N, mergeProps as Ut, withCtx as Q, renderSlot as Re, createCommentVNode as Oe, getCurrentInstance as xa, createTextVNode as Qt, Teleport as N1, withDirectives as on, onActivated as S1, onDeactivated as Jg, vShow as ci, cloneVNode as C1, Text as m4, createElementVNode as de, createElementBlock as be, resolveDynamicComponent as Jn, normalizeClass as br, createSlots as Xg, toDisplayString as kt, createVNode as B, normalizeStyle as Fc, renderList as jl, onUpdated as Zt, onUnmounted as v4, withModifiers as em, vModelText as b4, resolveComponent as Po, onBeforeUpdate as wa, markRaw as M4, reactive as y4, pushScopeId as x4, popScopeId as w4 } from "vue";
const ov = {
  black: "#000",
  silver: "#C0C0C0",
  gray: "#808080",
  white: "#FFF",
  maroon: "#800000",
  red: "#F00",
  purple: "#800080",
  fuchsia: "#F0F",
  green: "#008000",
  lime: "#0F0",
  olive: "#808000",
  yellow: "#FF0",
  navy: "#000080",
  blue: "#00F",
  teal: "#008080",
  aqua: "#0FF",
  transparent: "#0000"
}, Ta = "^\\s*", Na = "\\s*$", Zo = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*", Go = "([0-9A-Fa-f])", Ko = "([0-9A-Fa-f]{2})", T4 = new RegExp(`${Ta}rgb\\s*\\(${Zo},${Zo},${Zo}\\)${Na}`), N4 = new RegExp(`${Ta}rgba\\s*\\(${Zo},${Zo},${Zo},${Zo}\\)${Na}`), S4 = new RegExp(`${Ta}#${Go}${Go}${Go}${Na}`), C4 = new RegExp(`${Ta}#${Ko}${Ko}${Ko}${Na}`), I4 = new RegExp(`${Ta}#${Go}${Go}${Go}${Go}${Na}`), A4 = new RegExp(`${Ta}#${Ko}${Ko}${Ko}${Ko}${Na}`);
function Cr(e) {
  return parseInt(e, 16);
}
function No(e) {
  try {
    let t;
    if (t = C4.exec(e))
      return [Cr(t[1]), Cr(t[2]), Cr(t[3]), 1];
    if (t = T4.exec(e))
      return [lr(t[1]), lr(t[5]), lr(t[9]), 1];
    if (t = N4.exec(e))
      return [
        lr(t[1]),
        lr(t[5]),
        lr(t[9]),
        il(t[13])
      ];
    if (t = S4.exec(e))
      return [
        Cr(t[1] + t[1]),
        Cr(t[2] + t[2]),
        Cr(t[3] + t[3]),
        1
      ];
    if (t = A4.exec(e))
      return [
        Cr(t[1]),
        Cr(t[2]),
        Cr(t[3]),
        il(Cr(t[4]) / 255)
      ];
    if (t = I4.exec(e))
      return [
        Cr(t[1] + t[1]),
        Cr(t[2] + t[2]),
        Cr(t[3] + t[3]),
        il(Cr(t[4] + t[4]) / 255)
      ];
    if (e in ov)
      return No(ov[e]);
    throw new Error(`[seemly/rgba]: Invalid color value ${e}.`);
  } catch (t) {
    throw t;
  }
}
function D4(e) {
  return e > 1 ? 1 : e < 0 ? 0 : e;
}
function Of(e, t, r, n) {
  return `rgba(${lr(e)}, ${lr(t)}, ${lr(r)}, ${D4(n)})`;
}
function Td(e, t, r, n, o) {
  return lr((e * t * (1 - n) + r * n) / o);
}
function ei(e, t) {
  Array.isArray(e) || (e = No(e)), Array.isArray(t) || (t = No(t));
  const r = e[3], n = t[3], o = il(r + n - r * n);
  return Of(Td(e[0], r, t[0], n, o), Td(e[1], r, t[1], n, o), Td(e[2], r, t[2], n, o), o);
}
function qe(e, t) {
  const [r, n, o, i = 1] = Array.isArray(e) ? e : No(e);
  return t.alpha ? Of(r, n, o, t.alpha) : Of(r, n, o, i);
}
function Es(e, t) {
  const [r, n, o, i = 1] = Array.isArray(e) ? e : No(e), { lightness: a = 1, alpha: l = 1 } = t;
  return k4([r * a, n * a, o * a, i * l]);
}
function il(e) {
  const t = Math.round(Number(e) * 100) / 100;
  return t > 1 ? 1 : t < 0 ? 0 : t;
}
function lr(e) {
  const t = Math.round(Number(e));
  return t > 255 ? 255 : t < 0 ? 0 : t;
}
function k4(e) {
  const [t, r, n] = e;
  return 3 in e ? `rgba(${lr(t)}, ${lr(r)}, ${lr(n)}, ${il(e[3])})` : `rgba(${lr(t)}, ${lr(r)}, ${lr(n)}, 1)`;
}
function Bo(e) {
  return ei(e, [255, 255, 255, 0.16]);
}
function Ls(e) {
  return ei(e, [0, 0, 0, 0.12]);
}
const E4 = "n-button-group", I1 = Symbol("@css-render/vue3-ssr");
function L4(e, t) {
  return `<style cssr-id="${e}">
${t}
</style>`;
}
function $4(e, t) {
  const r = De(I1, null);
  if (r === null) {
    console.error("[css-render/vue3-ssr]: no ssr context found.");
    return;
  }
  const { styles: n, ids: o } = r;
  o.has(e) || n !== null && (o.add(e), n.push(L4(e, t)));
}
const z4 = typeof document < "u";
function bi() {
  if (z4)
    return;
  const e = De(I1, null);
  if (e !== null)
    return {
      adapter: $4,
      context: e
    };
}
const Rl = "naive-ui-style";
function iv(e) {
  if (!e)
    return;
  const t = e.parentElement;
  t && t.removeChild(e);
}
function Uc(e) {
  return document.querySelector(`style[cssr-id="${e}"]`);
}
function O4(e) {
  const t = document.createElement("style");
  return t.setAttribute("cssr-id", e), t;
}
function $s(e) {
  return e ? /^\s*@(s|m)/.test(e) : !1;
}
function j4(e, t) {
  if (e === void 0)
    return !1;
  if (t) {
    const { context: { ids: r } } = t;
    return r.has(e);
  }
  return Uc(e) !== null;
}
function yn(e, t, r) {
  if (!t)
    return;
  const n = bi(), o = W(() => {
    const {
      value: a
    } = t;
    if (!a)
      return;
    const l = a[e];
    if (l)
      return l;
  }), i = () => {
    rr(() => {
      const {
        value: a
      } = r, l = `${a}${e}Rtl`;
      if (j4(l, n))
        return;
      const {
        value: s
      } = o;
      s && s.style.mount({
        id: l,
        head: !0,
        anchorMetaName: Rl,
        props: {
          bPrefix: a ? `.${a}-` : void 0
        },
        ssr: n
      });
    });
  };
  return n ? i() : ya(i), o;
}
const Sa = typeof document < "u" && typeof window < "u", R4 = Sa && "chrome" in window;
Sa && navigator.userAgent.includes("Firefox");
const A1 = Sa && navigator.userAgent.includes("Safari") && !R4;
function _4(e) {
  let t = 0;
  for (let r = 0; r < e.length; ++r)
    e[r] === "&" && ++t;
  return t;
}
const D1 = /\s*,(?![^(]*\))\s*/g, P4 = /\s+/g;
function B4(e, t) {
  const r = [];
  return t.split(D1).forEach((n) => {
    let o = _4(n);
    if (o) {
      if (o === 1) {
        e.forEach((a) => {
          r.push(n.replace("&", a));
        });
        return;
      }
    } else {
      e.forEach((a) => {
        r.push(
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          (a && a + " ") + n
        );
      });
      return;
    }
    let i = [
      n
    ];
    for (; o--; ) {
      const a = [];
      i.forEach((l) => {
        e.forEach((s) => {
          a.push(l.replace("&", s));
        });
      }), i = a;
    }
    i.forEach((a) => r.push(a));
  }), r;
}
function F4(e, t) {
  const r = [];
  return t.split(D1).forEach((n) => {
    e.forEach((o) => {
      r.push((o && o + " ") + n);
    });
  }), r;
}
function U4(e) {
  let t = [""];
  return e.forEach((r) => {
    r = r && r.trim(), // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    r && (r.includes("&") ? t = B4(t, r) : t = F4(t, r));
  }), t.join(", ").replace(P4, " ");
}
const H4 = /[A-Z]/g;
function k1(e) {
  return e.replace(H4, (t) => "-" + t.toLowerCase());
}
function Y4(e, t = "  ") {
  return typeof e == "object" && e !== null ? ` {
` + Object.entries(e).map((r) => t + `  ${k1(r[0])}: ${r[1]};`).join(`
`) + `
` + t + "}" : `: ${e};`;
}
function W4(e, t, r) {
  return typeof e == "function" ? e({
    context: t.context,
    props: r
  }) : e;
}
function av(e, t, r, n) {
  if (!t)
    return "";
  const o = W4(t, r, n);
  if (!o)
    return "";
  if (typeof o == "string")
    return `${e} {
${o}
}`;
  const i = Object.keys(o);
  if (i.length === 0)
    return r.config.keepEmptyBlock ? e + ` {
}` : "";
  const a = e ? [
    e + " {"
  ] : [];
  return i.forEach((l) => {
    const s = o[l];
    if (l === "raw") {
      a.push(`
` + s + `
`);
      return;
    }
    l = k1(l), s != null && a.push(`  ${l}${Y4(s)}`);
  }), e && a.push("}"), a.join(`
`);
}
function jf(e, t, r) {
  e && e.forEach((n) => {
    if (Array.isArray(n))
      jf(n, t, r);
    else if (typeof n == "function") {
      const o = n(t);
      Array.isArray(o) ? jf(o, t, r) : o && r(o);
    } else
      n && r(n);
  });
}
function E1(e, t, r, n, o, i) {
  const a = e.$;
  let l = "";
  if (!a || typeof a == "string")
    $s(a) ? l = a : t.push(a);
  else if (typeof a == "function") {
    const u = a({
      context: n.context,
      props: o
    });
    $s(u) ? l = u : t.push(u);
  } else if (a.before && a.before(n.context), !a.$ || typeof a.$ == "string")
    $s(a.$) ? l = a.$ : t.push(a.$);
  else if (a.$) {
    const u = a.$({
      context: n.context,
      props: o
    });
    $s(u) ? l = u : t.push(u);
  }
  const s = U4(t), c = av(s, e.props, n, o);
  l ? (r.push(`${l} {`), i && c && i.insertRule(`${l} {
${c}
}
`)) : (i && c && i.insertRule(c), !i && c.length && r.push(c)), e.children && jf(e.children, {
    context: n.context,
    props: o
  }, (u) => {
    if (typeof u == "string") {
      const d = av(s, { raw: u }, n, o);
      i ? i.insertRule(d) : r.push(d);
    } else
      E1(u, t, r, n, o, i);
  }), t.pop(), l && r.push("}"), a && a.after && a.after(n.context);
}
function L1(e, t, r, n = !1) {
  const o = [];
  return E1(e, [], o, t, r, n ? e.instance.__styleSheet : void 0), n ? "" : o.join(`

`);
}
function Rf(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
typeof window < "u" && (window.__cssrContext = {});
function Q4(e, t, r) {
  const { els: n } = t;
  if (r === void 0)
    n.forEach(iv), t.els = [];
  else {
    const o = Uc(r);
    o && n.includes(o) && (iv(o), t.els = n.filter((i) => i !== o));
  }
}
function lv(e, t) {
  e.push(t);
}
function V4(e, t, r, n, o, i, a, l, s) {
  if (i && !s) {
    if (r === void 0) {
      console.error("[css-render/mount]: `id` is required in `silent` mode.");
      return;
    }
    const f = window.__cssrContext;
    f[r] || (f[r] = !0, L1(t, e, n, i));
    return;
  }
  let c;
  if (r === void 0 && (c = t.render(n), r = Rf(c)), s) {
    s.adapter(r, c ?? t.render(n));
    return;
  }
  const u = Uc(r);
  if (u !== null && !a)
    return u;
  const d = u ?? O4(r);
  if (c === void 0 && (c = t.render(n)), d.textContent = c, u !== null)
    return u;
  if (l) {
    const f = document.head.querySelector(`meta[name="${l}"]`);
    if (f)
      return document.head.insertBefore(d, f), lv(t.els, d), d;
  }
  return o ? document.head.insertBefore(d, document.head.querySelector("style, link")) : document.head.appendChild(d), lv(t.els, d), d;
}
function Z4(e) {
  return L1(this, this.instance, e);
}
function G4(e = {}) {
  const { id: t, ssr: r, props: n, head: o = !1, silent: i = !1, force: a = !1, anchorMetaName: l } = e;
  return V4(this.instance, this, t, n, o, i, a, l, r);
}
function K4(e = {}) {
  const { id: t } = e;
  Q4(this.instance, this, t);
}
const zs = function(e, t, r, n) {
  return {
    instance: e,
    $: t,
    props: r,
    children: n,
    els: [],
    render: Z4,
    mount: G4,
    unmount: K4
  };
}, q4 = function(e, t, r, n) {
  return Array.isArray(t) ? zs(e, { $: null }, null, t) : Array.isArray(r) ? zs(e, t, null, r) : Array.isArray(n) ? zs(e, t, r, n) : zs(e, t, r, null);
};
function $1(e = {}) {
  let t = null;
  const r = {
    c: (...n) => q4(r, ...n),
    use: (n, ...o) => n.install(r, ...o),
    find: Uc,
    context: {},
    config: e,
    get __styleSheet() {
      if (!t) {
        const n = document.createElement("style");
        return document.head.appendChild(n), t = document.styleSheets[document.styleSheets.length - 1], t;
      }
      return t;
    }
  };
  return r;
}
function J4(e) {
  let t = ".", r = "__", n = "--", o;
  if (e) {
    let u = e.blockPrefix;
    u && (t = u), u = e.elementPrefix, u && (r = u), u = e.modifierPrefix, u && (n = u);
  }
  const i = {
    install(u) {
      o = u.c;
      const d = u.context;
      d.bem = {}, d.bem.b = null, d.bem.els = null;
    }
  };
  function a(u) {
    let d, f;
    return {
      before(p) {
        d = p.bem.b, f = p.bem.els, p.bem.els = null;
      },
      after(p) {
        p.bem.b = d, p.bem.els = f;
      },
      $({ context: p, props: h }) {
        return u = typeof u == "string" ? u : u({ context: p, props: h }), p.bem.b = u, `${(h == null ? void 0 : h.bPrefix) || t}${p.bem.b}`;
      }
    };
  }
  function l(u) {
    let d;
    return {
      before(f) {
        d = f.bem.els;
      },
      after(f) {
        f.bem.els = d;
      },
      $({ context: f, props: p }) {
        return u = typeof u == "string" ? u : u({ context: f, props: p }), f.bem.els = u.split(",").map((h) => h.trim()), f.bem.els.map((h) => `${(p == null ? void 0 : p.bPrefix) || t}${f.bem.b}${r}${h}`).join(", ");
      }
    };
  }
  function s(u) {
    return {
      $({ context: d, props: f }) {
        u = typeof u == "string" ? u : u({ context: d, props: f });
        const p = u.split(",").map((m) => m.trim());
        function h(m) {
          return p.map((v) => `&${(f == null ? void 0 : f.bPrefix) || t}${d.bem.b}${m !== void 0 ? `${r}${m}` : ""}${n}${v}`).join(", ");
        }
        const g = d.bem.els;
        if (g !== null) {
          if (process.env.NODE_ENV !== "production" && g.length >= 2)
            throw Error(`[css-render/plugin-bem]: m(${u}) is invalid, using modifier inside multiple elements is not allowed`);
          return h(g[0]);
        } else
          return h();
      }
    };
  }
  function c(u) {
    return {
      $({ context: d, props: f }) {
        u = typeof u == "string" ? u : u({ context: d, props: f });
        const p = d.bem.els;
        if (process.env.NODE_ENV !== "production" && p !== null && p.length >= 2)
          throw Error(`[css-render/plugin-bem]: notM(${u}) is invalid, using modifier inside multiple elements is not allowed`);
        return `&:not(${(f == null ? void 0 : f.bPrefix) || t}${d.bem.b}${p !== null && p.length > 0 ? `${r}${p[0]}` : ""}${n}${u})`;
      }
    };
  }
  return Object.assign(i, {
    cB: (...u) => o(a(u[0]), u[1], u[2]),
    cE: (...u) => o(l(u[0]), u[1], u[2]),
    cM: (...u) => o(s(u[0]), u[1], u[2]),
    cNotM: (...u) => o(c(u[0]), u[1], u[2])
  }), i;
}
const X4 = "n", _l = `.${X4}-`, e2 = "__", t2 = "--", z1 = $1(), O1 = J4({
  blockPrefix: _l,
  elementPrefix: e2,
  modifierPrefix: t2
});
z1.use(O1);
const {
  c: V,
  find: yue
} = z1, {
  cB: te,
  cE: F,
  cM: fe,
  cNotM: $t
} = O1;
function tm(e) {
  return V(({
    props: {
      bPrefix: t
    }
  }) => `${t || _l}modal, ${t || _l}drawer`, [e]);
}
function j1(e) {
  return V(({
    props: {
      bPrefix: t
    }
  }) => `${t || _l}popover`, [e]);
}
function R1(e) {
  return V(({
    props: {
      bPrefix: t
    }
  }) => `&${t || _l}modal`, e);
}
const r2 = (...e) => V(">", [te(...e)]);
function ve(e, t) {
  return e + (t === "default" ? "" : t.replace(/^[a-z]/, (r) => r.toUpperCase()));
}
const Mi = {
  fontFamily: 'v-sans, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
  fontWeight: "400",
  fontWeightStrong: "500",
  cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
  cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
  cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
  borderRadius: "3px",
  borderRadiusSmall: "2px",
  fontSize: "14px",
  fontSizeMini: "12px",
  fontSizeTiny: "12px",
  fontSizeSmall: "14px",
  fontSizeMedium: "14px",
  fontSizeLarge: "15px",
  fontSizeHuge: "16px",
  lineHeight: "1.6",
  heightMini: "16px",
  // private now, it's too small
  heightTiny: "22px",
  heightSmall: "28px",
  heightMedium: "34px",
  heightLarge: "40px",
  heightHuge: "46px"
}, {
  cubicBezierEaseInOut: uo
} = Mi;
function n2({
  duration: e = ".2s",
  delay: t = ".1s"
} = {}) {
  return [V("&.fade-in-width-expand-transition-leave-from, &.fade-in-width-expand-transition-enter-to", {
    opacity: 1
  }), V("&.fade-in-width-expand-transition-leave-to, &.fade-in-width-expand-transition-enter-from", `
 opacity: 0!important;
 margin-left: 0!important;
 margin-right: 0!important;
 `), V("&.fade-in-width-expand-transition-leave-active", `
 overflow: hidden;
 transition:
 opacity ${e} ${uo},
 max-width ${e} ${uo} ${t},
 margin-left ${e} ${uo} ${t},
 margin-right ${e} ${uo} ${t};
 `), V("&.fade-in-width-expand-transition-enter-active", `
 overflow: hidden;
 transition:
 opacity ${e} ${uo} ${t},
 max-width ${e} ${uo},
 margin-left ${e} ${uo},
 margin-right ${e} ${uo};
 `)];
}
const {
  cubicBezierEaseInOut: o2
} = Mi;
function Eu({
  originalTransform: e = "",
  left: t = 0,
  top: r = 0,
  transition: n = `all .3s ${o2} !important`
} = {}) {
  return [V("&.icon-switch-transition-enter-from, &.icon-switch-transition-leave-to", {
    transform: e + " scale(0.75)",
    left: t,
    top: r,
    opacity: 0
  }), V("&.icon-switch-transition-enter-to, &.icon-switch-transition-leave-from", {
    transform: `scale(1) ${e}`,
    left: t,
    top: r,
    opacity: 1
  }), V("&.icon-switch-transition-enter-active, &.icon-switch-transition-leave-active", {
    transformOrigin: "center",
    position: "absolute",
    left: t,
    top: r,
    transition: n
  })];
}
const i2 = V([te("button", `
 margin: 0;
 font-weight: var(--n-font-weight);
 line-height: 1;
 font-family: inherit;
 padding: var(--n-padding);
 height: var(--n-height);
 font-size: var(--n-font-size);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 width: var(--n-width);
 white-space: nowrap;
 outline: none;
 position: relative;
 z-index: auto;
 border: none;
 display: inline-flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 align-items: center;
 justify-content: center;
 user-select: none;
 -webkit-user-select: none;
 text-align: center;
 cursor: pointer;
 text-decoration: none;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [fe("color", [F("border", {
  borderColor: "var(--n-border-color)"
}), fe("disabled", [F("border", {
  borderColor: "var(--n-border-color-disabled)"
})]), $t("disabled", [V("&:focus", [F("state-border", {
  borderColor: "var(--n-border-color-focus)"
})]), V("&:hover", [F("state-border", {
  borderColor: "var(--n-border-color-hover)"
})]), V("&:active", [F("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})]), fe("pressed", [F("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})])])]), fe("disabled", {
  backgroundColor: "var(--n-color-disabled)",
  color: "var(--n-text-color-disabled)"
}, [F("border", {
  border: "var(--n-border-disabled)"
})]), $t("disabled", [V("&:focus", {
  backgroundColor: "var(--n-color-focus)",
  color: "var(--n-text-color-focus)"
}, [F("state-border", {
  border: "var(--n-border-focus)"
})]), V("&:hover", {
  backgroundColor: "var(--n-color-hover)",
  color: "var(--n-text-color-hover)"
}, [F("state-border", {
  border: "var(--n-border-hover)"
})]), V("&:active", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [F("state-border", {
  border: "var(--n-border-pressed)"
})]), fe("pressed", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [F("state-border", {
  border: "var(--n-border-pressed)"
})])]), fe("loading", "cursor: wait;"), te("base-wave", `
 pointer-events: none;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 animation-iteration-count: 1;
 animation-duration: var(--n-ripple-duration);
 animation-timing-function: var(--n-bezier-ease-out), var(--n-bezier-ease-out);
 `, [fe("active", {
  zIndex: 1,
  animationName: "button-wave-spread, button-wave-opacity"
})]), Sa && "MozBoxSizing" in document.createElement("div").style ? V("&::moz-focus-inner", {
  border: 0
}) : null, F("border, state-border", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 border-radius: inherit;
 transition: border-color .3s var(--n-bezier);
 pointer-events: none;
 `), F("border", {
  border: "var(--n-border)"
}), F("state-border", {
  border: "var(--n-border)",
  borderColor: "#0000",
  zIndex: 1
}), F("icon", `
 margin: var(--n-icon-margin);
 margin-left: 0;
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 max-width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 position: relative;
 flex-shrink: 0;
 `, [te("icon-slot", `
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [Eu({
  top: "50%",
  originalTransform: "translateY(-50%)"
})]), n2()]), F("content", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 min-width: 0;
 `, [V("~", [F("icon", {
  margin: "var(--n-icon-margin)",
  marginRight: 0
})])]), fe("block", `
 display: flex;
 width: 100%;
 `), fe("dashed", [F("border, state-border", {
  borderStyle: "dashed !important"
})]), fe("disabled", {
  cursor: "not-allowed",
  opacity: "var(--n-opacity-disabled)"
})]), V("@keyframes button-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0 var(--n-ripple-color)"
  },
  to: {
    // don't use exact 5px since chrome will display the animation with glitches
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)"
  }
}), V("@keyframes button-wave-opacity", {
  from: {
    opacity: "var(--n-wave-opacity)"
  },
  to: {
    opacity: 0
  }
})]), {
  fontSize: a2,
  fontFamily: l2,
  lineHeight: s2
} = Mi, _1 = V("body", `
 margin: 0;
 font-size: ${a2};
 font-family: ${l2};
 line-height: ${s2};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [V("input", `
 font-family: inherit;
 font-size: inherit;
 `)]), Do = "n-config-provider";
function u2() {
  this.__data__ = [], this.size = 0;
}
function fs(e, t) {
  return e === t || e !== e && t !== t;
}
function Hc(e, t) {
  for (var r = e.length; r--; )
    if (fs(e[r][0], t))
      return r;
  return -1;
}
var c2 = Array.prototype, d2 = c2.splice;
function f2(e) {
  var t = this.__data__, r = Hc(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : d2.call(t, r, 1), --this.size, !0;
}
function p2(e) {
  var t = this.__data__, r = Hc(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function h2(e) {
  return Hc(this.__data__, e) > -1;
}
function g2(e, t) {
  var r = this.__data__, n = Hc(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function to(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
to.prototype.clear = u2;
to.prototype.delete = f2;
to.prototype.get = p2;
to.prototype.has = h2;
to.prototype.set = g2;
function m2() {
  this.__data__ = new to(), this.size = 0;
}
function v2(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function b2(e) {
  return this.__data__.get(e);
}
function M2(e) {
  return this.__data__.has(e);
}
var y2 = typeof global == "object" && global && global.Object === Object && global;
const P1 = y2;
var x2 = typeof self == "object" && self && self.Object === Object && self, w2 = P1 || x2 || Function("return this")();
const xn = w2;
var T2 = xn.Symbol;
const So = T2;
var B1 = Object.prototype, N2 = B1.hasOwnProperty, S2 = B1.toString, Qa = So ? So.toStringTag : void 0;
function C2(e) {
  var t = N2.call(e, Qa), r = e[Qa];
  try {
    e[Qa] = void 0;
    var n = !0;
  } catch {
  }
  var o = S2.call(e);
  return n && (t ? e[Qa] = r : delete e[Qa]), o;
}
var I2 = Object.prototype, A2 = I2.toString;
function D2(e) {
  return A2.call(e);
}
var k2 = "[object Null]", E2 = "[object Undefined]", sv = So ? So.toStringTag : void 0;
function yi(e) {
  return e == null ? e === void 0 ? E2 : k2 : sv && sv in Object(e) ? C2(e) : D2(e);
}
function vn(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var L2 = "[object AsyncFunction]", $2 = "[object Function]", z2 = "[object GeneratorFunction]", O2 = "[object Proxy]";
function rm(e) {
  if (!vn(e))
    return !1;
  var t = yi(e);
  return t == $2 || t == z2 || t == L2 || t == O2;
}
var j2 = xn["__core-js_shared__"];
const Nd = j2;
var uv = function() {
  var e = /[^.]+$/.exec(Nd && Nd.keys && Nd.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function R2(e) {
  return !!uv && uv in e;
}
var _2 = Function.prototype, P2 = _2.toString;
function xi(e) {
  if (e != null) {
    try {
      return P2.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var B2 = /[\\^$.*+?()[\]{}|]/g, F2 = /^\[object .+?Constructor\]$/, U2 = Function.prototype, H2 = Object.prototype, Y2 = U2.toString, W2 = H2.hasOwnProperty, Q2 = RegExp(
  "^" + Y2.call(W2).replace(B2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function V2(e) {
  if (!vn(e) || R2(e))
    return !1;
  var t = rm(e) ? Q2 : F2;
  return t.test(xi(e));
}
function Z2(e, t) {
  return e == null ? void 0 : e[t];
}
function wi(e, t) {
  var r = Z2(e, t);
  return V2(r) ? r : void 0;
}
var G2 = wi(xn, "Map");
const Pl = G2;
var K2 = wi(Object, "create");
const Bl = K2;
function q2() {
  this.__data__ = Bl ? Bl(null) : {}, this.size = 0;
}
function J2(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var X2 = "__lodash_hash_undefined__", ek = Object.prototype, tk = ek.hasOwnProperty;
function rk(e) {
  var t = this.__data__;
  if (Bl) {
    var r = t[e];
    return r === X2 ? void 0 : r;
  }
  return tk.call(t, e) ? t[e] : void 0;
}
var nk = Object.prototype, ok = nk.hasOwnProperty;
function ik(e) {
  var t = this.__data__;
  return Bl ? t[e] !== void 0 : ok.call(t, e);
}
var ak = "__lodash_hash_undefined__";
function lk(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Bl && t === void 0 ? ak : t, this;
}
function di(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
di.prototype.clear = q2;
di.prototype.delete = J2;
di.prototype.get = rk;
di.prototype.has = ik;
di.prototype.set = lk;
function sk() {
  this.size = 0, this.__data__ = {
    hash: new di(),
    map: new (Pl || to)(),
    string: new di()
  };
}
function uk(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Yc(e, t) {
  var r = e.__data__;
  return uk(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function ck(e) {
  var t = Yc(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function dk(e) {
  return Yc(this, e).get(e);
}
function fk(e) {
  return Yc(this, e).has(e);
}
function pk(e, t) {
  var r = Yc(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function ro(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ro.prototype.clear = sk;
ro.prototype.delete = ck;
ro.prototype.get = dk;
ro.prototype.has = fk;
ro.prototype.set = pk;
var hk = 200;
function gk(e, t) {
  var r = this.__data__;
  if (r instanceof to) {
    var n = r.__data__;
    if (!Pl || n.length < hk - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new ro(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Ln(e) {
  var t = this.__data__ = new to(e);
  this.size = t.size;
}
Ln.prototype.clear = m2;
Ln.prototype.delete = v2;
Ln.prototype.get = b2;
Ln.prototype.has = M2;
Ln.prototype.set = gk;
var mk = function() {
  try {
    var e = wi(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Lu = mk;
function nm(e, t, r) {
  t == "__proto__" && Lu ? Lu(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function _f(e, t, r) {
  (r !== void 0 && !fs(e[t], r) || r === void 0 && !(t in e)) && nm(e, t, r);
}
function vk(e) {
  return function(t, r, n) {
    for (var o = -1, i = Object(t), a = n(t), l = a.length; l--; ) {
      var s = a[e ? l : ++o];
      if (r(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var bk = vk();
const F1 = bk;
var U1 = typeof exports == "object" && exports && !exports.nodeType && exports, cv = U1 && typeof module == "object" && module && !module.nodeType && module, Mk = cv && cv.exports === U1, dv = Mk ? xn.Buffer : void 0, fv = dv ? dv.allocUnsafe : void 0;
function yk(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = fv ? fv(r) : new e.constructor(r);
  return e.copy(n), n;
}
var xk = xn.Uint8Array;
const $u = xk;
function wk(e) {
  var t = new e.constructor(e.byteLength);
  return new $u(t).set(new $u(e)), t;
}
function Tk(e, t) {
  var r = t ? wk(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
function Nk(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var pv = Object.create, Sk = function() {
  function e() {
  }
  return function(t) {
    if (!vn(t))
      return {};
    if (pv)
      return pv(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const Ck = Sk;
function H1(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Ik = H1(Object.getPrototypeOf, Object);
const Y1 = Ik;
var Ak = Object.prototype;
function om(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Ak;
  return e === r;
}
function Dk(e) {
  return typeof e.constructor == "function" && !om(e) ? Ck(Y1(e)) : {};
}
function Co(e) {
  return e != null && typeof e == "object";
}
var kk = "[object Arguments]";
function hv(e) {
  return Co(e) && yi(e) == kk;
}
var W1 = Object.prototype, Ek = W1.hasOwnProperty, Lk = W1.propertyIsEnumerable, $k = hv(function() {
  return arguments;
}()) ? hv : function(e) {
  return Co(e) && Ek.call(e, "callee") && !Lk.call(e, "callee");
};
const zu = $k;
var zk = Array.isArray;
const an = zk;
var Ok = 9007199254740991;
function im(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ok;
}
function Ca(e) {
  return e != null && im(e.length) && !rm(e);
}
function jk(e) {
  return Co(e) && Ca(e);
}
function Rk() {
  return !1;
}
var Q1 = typeof exports == "object" && exports && !exports.nodeType && exports, gv = Q1 && typeof module == "object" && module && !module.nodeType && module, _k = gv && gv.exports === Q1, mv = _k ? xn.Buffer : void 0, Pk = mv ? mv.isBuffer : void 0, Bk = Pk || Rk;
const Ou = Bk;
var Fk = "[object Object]", Uk = Function.prototype, Hk = Object.prototype, V1 = Uk.toString, Yk = Hk.hasOwnProperty, Wk = V1.call(Object);
function Qk(e) {
  if (!Co(e) || yi(e) != Fk)
    return !1;
  var t = Y1(e);
  if (t === null)
    return !0;
  var r = Yk.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && V1.call(r) == Wk;
}
var Vk = "[object Arguments]", Zk = "[object Array]", Gk = "[object Boolean]", Kk = "[object Date]", qk = "[object Error]", Jk = "[object Function]", Xk = "[object Map]", eE = "[object Number]", tE = "[object Object]", rE = "[object RegExp]", nE = "[object Set]", oE = "[object String]", iE = "[object WeakMap]", aE = "[object ArrayBuffer]", lE = "[object DataView]", sE = "[object Float32Array]", uE = "[object Float64Array]", cE = "[object Int8Array]", dE = "[object Int16Array]", fE = "[object Int32Array]", pE = "[object Uint8Array]", hE = "[object Uint8ClampedArray]", gE = "[object Uint16Array]", mE = "[object Uint32Array]", xt = {};
xt[sE] = xt[uE] = xt[cE] = xt[dE] = xt[fE] = xt[pE] = xt[hE] = xt[gE] = xt[mE] = !0;
xt[Vk] = xt[Zk] = xt[aE] = xt[Gk] = xt[lE] = xt[Kk] = xt[qk] = xt[Jk] = xt[Xk] = xt[eE] = xt[tE] = xt[rE] = xt[nE] = xt[oE] = xt[iE] = !1;
function vE(e) {
  return Co(e) && im(e.length) && !!xt[yi(e)];
}
function bE(e) {
  return function(t) {
    return e(t);
  };
}
var Z1 = typeof exports == "object" && exports && !exports.nodeType && exports, al = Z1 && typeof module == "object" && module && !module.nodeType && module, ME = al && al.exports === Z1, Sd = ME && P1.process, yE = function() {
  try {
    var e = al && al.require && al.require("util").types;
    return e || Sd && Sd.binding && Sd.binding("util");
  } catch {
  }
}();
const vv = yE;
var bv = vv && vv.isTypedArray, xE = bv ? bE(bv) : vE;
const am = xE;
function Pf(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var wE = Object.prototype, TE = wE.hasOwnProperty;
function NE(e, t, r) {
  var n = e[t];
  (!(TE.call(e, t) && fs(n, r)) || r === void 0 && !(t in e)) && nm(e, t, r);
}
function SE(e, t, r, n) {
  var o = !r;
  r || (r = {});
  for (var i = -1, a = t.length; ++i < a; ) {
    var l = t[i], s = n ? n(r[l], e[l], l, r, e) : void 0;
    s === void 0 && (s = e[l]), o ? nm(r, l, s) : NE(r, l, s);
  }
  return r;
}
function CE(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var IE = 9007199254740991, AE = /^(?:0|[1-9]\d*)$/;
function lm(e, t) {
  var r = typeof e;
  return t = t ?? IE, !!t && (r == "number" || r != "symbol" && AE.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var DE = Object.prototype, kE = DE.hasOwnProperty;
function G1(e, t) {
  var r = an(e), n = !r && zu(e), o = !r && !n && Ou(e), i = !r && !n && !o && am(e), a = r || n || o || i, l = a ? CE(e.length, String) : [], s = l.length;
  for (var c in e)
    (t || kE.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    lm(c, s))) && l.push(c);
  return l;
}
function EE(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var LE = Object.prototype, $E = LE.hasOwnProperty;
function zE(e) {
  if (!vn(e))
    return EE(e);
  var t = om(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !$E.call(e, n)) || r.push(n);
  return r;
}
function K1(e) {
  return Ca(e) ? G1(e, !0) : zE(e);
}
function OE(e) {
  return SE(e, K1(e));
}
function jE(e, t, r, n, o, i, a) {
  var l = Pf(e, r), s = Pf(t, r), c = a.get(s);
  if (c) {
    _f(e, r, c);
    return;
  }
  var u = i ? i(l, s, r + "", e, t, a) : void 0, d = u === void 0;
  if (d) {
    var f = an(s), p = !f && Ou(s), h = !f && !p && am(s);
    u = s, f || p || h ? an(l) ? u = l : jk(l) ? u = Nk(l) : p ? (d = !1, u = yk(s, !0)) : h ? (d = !1, u = Tk(s, !0)) : u = [] : Qk(s) || zu(s) ? (u = l, zu(l) ? u = OE(l) : (!vn(l) || rm(l)) && (u = Dk(s))) : d = !1;
  }
  d && (a.set(s, u), o(u, s, n, i, a), a.delete(s)), _f(e, r, u);
}
function q1(e, t, r, n, o) {
  e !== t && F1(t, function(i, a) {
    if (o || (o = new Ln()), vn(i))
      jE(e, t, a, r, q1, n, o);
    else {
      var l = n ? n(Pf(e, a), i, a + "", e, t, o) : void 0;
      l === void 0 && (l = i), _f(e, a, l);
    }
  }, K1);
}
function sm(e) {
  return e;
}
function RE(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Mv = Math.max;
function _E(e, t, r) {
  return t = Mv(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, o = -1, i = Mv(n.length - t, 0), a = Array(i); ++o < i; )
      a[o] = n[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = n[o];
    return l[t] = r(a), RE(e, this, l);
  };
}
function PE(e) {
  return function() {
    return e;
  };
}
var BE = Lu ? function(e, t) {
  return Lu(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: PE(t),
    writable: !0
  });
} : sm;
const FE = BE;
var UE = 800, HE = 16, YE = Date.now;
function WE(e) {
  var t = 0, r = 0;
  return function() {
    var n = YE(), o = HE - (n - r);
    if (r = n, o > 0) {
      if (++t >= UE)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var QE = WE(FE);
const VE = QE;
function ZE(e, t) {
  return VE(_E(e, t, sm), e + "");
}
function GE(e, t, r) {
  if (!vn(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? Ca(r) && lm(t, r.length) : n == "string" && t in r) ? fs(r[t], e) : !1;
}
function KE(e) {
  return ZE(function(t, r) {
    var n = -1, o = r.length, i = o > 1 ? r[o - 1] : void 0, a = o > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (o--, i) : void 0, a && GE(r[0], r[1], a) && (i = o < 3 ? void 0 : i, o = 1), t = Object(t); ++n < o; ) {
      var l = r[n];
      l && e(t, l, n, i);
    }
    return t;
  });
}
var qE = KE(function(e, t, r) {
  q1(e, t, r);
});
const Os = qE;
function Ve(e, t, r, n, o, i) {
  const a = bi(), l = De(Do, null);
  if (r) {
    const s = () => {
      const c = i == null ? void 0 : i.value;
      r.mount({
        id: c === void 0 ? t : c + t,
        head: !0,
        props: {
          bPrefix: c ? `.${c}-` : void 0
        },
        anchorMetaName: Rl,
        ssr: a
      }), l != null && l.preflightStyleDisabled || _1.mount({
        id: "n-global",
        head: !0,
        anchorMetaName: Rl,
        ssr: a
      });
    };
    a ? s() : ya(s);
  }
  return W(() => {
    var s;
    const {
      theme: {
        common: c,
        self: u,
        peers: d = {}
      } = {},
      themeOverrides: f = {},
      builtinThemeOverrides: p = {}
    } = o, {
      common: h,
      peers: g
    } = f, {
      common: m = void 0,
      [e]: {
        common: v = void 0,
        self: M = void 0,
        peers: x = {}
      } = {}
    } = (l == null ? void 0 : l.mergedThemeRef.value) || {}, {
      common: b = void 0,
      [e]: T = {}
    } = (l == null ? void 0 : l.mergedThemeOverridesRef.value) || {}, {
      common: w,
      peers: y = {}
    } = T, I = Os({}, c || v || m || n.common, b, w, h), D = Os(
      // {}, executed every time, no need for empty obj
      (s = u || M || n.self) === null || s === void 0 ? void 0 : s(I),
      p,
      T,
      f
    );
    return {
      common: I,
      self: D,
      peers: Os({}, n.peers, x, d),
      peerOverrides: Os({}, p.peers, y, g)
    };
  });
}
Ve.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
const yv = /* @__PURE__ */ new Set();
function sr(e, t) {
  const r = `[naive/${e}]: ${t}`;
  yv.has(r) || (yv.add(r), console.error(r));
}
function la(e, t) {
  console.error(`[naive/${e}]: ${t}`);
}
function J1(e, t) {
  throw new Error(`[naive/${e}]: ${t}`);
}
function _t(e) {
  const t = W(e), r = L(t.value);
  return at(t, (n) => {
    r.value = n;
  }), typeof e == "function" ? r : {
    __v_isRef: !0,
    get value() {
      return r.value;
    },
    set value(n) {
      e.set(n);
    }
  };
}
const Bf = "n-form-item";
function Ia(e, {
  defaultSize: t = "medium",
  mergedSize: r,
  mergedDisabled: n
} = {}) {
  const o = De(Bf, null);
  Et(Bf, null);
  const i = W(r ? () => r(o) : () => {
    const {
      size: s
    } = e;
    if (s)
      return s;
    if (o) {
      const {
        mergedSize: c
      } = o;
      if (c.value !== void 0)
        return c.value;
    }
    return t;
  }), a = W(n ? () => n(o) : () => {
    const {
      disabled: s
    } = e;
    return s !== void 0 ? s : o ? o.disabled.value : !1;
  }), l = W(() => {
    const {
      status: s
    } = e;
    return s || (o == null ? void 0 : o.mergedValidationStatus.value);
  });
  return vt(() => {
    o && o.restoreValidation();
  }), {
    mergedSizeRef: i,
    mergedDisabledRef: a,
    mergedStatusRef: l,
    nTriggerFormBlur() {
      o && o.handleContentBlur();
    },
    nTriggerFormChange() {
      o && o.handleContentChange();
    },
    nTriggerFormFocus() {
      o && o.handleContentFocus();
    },
    nTriggerFormInput() {
      o && o.handleContentInput();
    }
  };
}
const X1 = "n";
function Bt(e = {}, t = {
  defaultBordered: !0
}) {
  const r = De(Do, null);
  return {
    // NConfigProvider,
    inlineThemeDisabled: r == null ? void 0 : r.inlineThemeDisabled,
    mergedRtlRef: r == null ? void 0 : r.mergedRtlRef,
    mergedComponentPropsRef: r == null ? void 0 : r.mergedComponentPropsRef,
    mergedBreakpointsRef: r == null ? void 0 : r.mergedBreakpointsRef,
    mergedBorderedRef: W(() => {
      var n, o;
      const {
        bordered: i
      } = e;
      return i !== void 0 ? i : (o = (n = r == null ? void 0 : r.mergedBorderedRef.value) !== null && n !== void 0 ? n : t.defaultBordered) !== null && o !== void 0 ? o : !0;
    }),
    mergedClsPrefixRef: r ? r.mergedClsPrefixRef : T1(X1),
    namespaceRef: W(() => r == null ? void 0 : r.mergedNamespaceRef.value)
  };
}
function ex() {
  const e = De(Do, null);
  return e ? e.mergedClsPrefixRef : T1(X1);
}
const JE = {
  paddingTiny: "0 6px",
  paddingSmall: "0 10px",
  paddingMedium: "0 14px",
  paddingLarge: "0 18px",
  paddingRoundTiny: "0 10px",
  paddingRoundSmall: "0 14px",
  paddingRoundMedium: "0 18px",
  paddingRoundLarge: "0 22px",
  iconMarginTiny: "6px",
  iconMarginSmall: "6px",
  iconMarginMedium: "6px",
  iconMarginLarge: "6px",
  iconSizeTiny: "14px",
  iconSizeSmall: "18px",
  iconSizeMedium: "18px",
  iconSizeLarge: "20px",
  rippleDuration: ".6s"
}, je = {
  neutralBase: "#FFF",
  neutralInvertBase: "#000",
  neutralTextBase: "#000",
  neutralPopover: "#fff",
  neutralCard: "#fff",
  neutralModal: "#fff",
  neutralBody: "#fff",
  alpha1: "0.82",
  alpha2: "0.72",
  alpha3: "0.38",
  alpha4: "0.24",
  // disabled text, placeholder, icon
  alpha5: "0.18",
  // disabled placeholder
  alphaClose: "0.6",
  alphaDisabled: "0.5",
  alphaDisabledInput: "0.02",
  alphaPending: "0.05",
  alphaTablePending: "0.02",
  alphaPressed: "0.07",
  alphaAvatar: "0.2",
  alphaRail: "0.14",
  alphaProgressRail: ".08",
  alphaBorder: "0.12",
  alphaDivider: "0.06",
  alphaInput: "0",
  alphaAction: "0.02",
  alphaTab: "0.04",
  alphaScrollbar: "0.25",
  alphaScrollbarHover: "0.4",
  alphaCode: "0.05",
  alphaTag: "0.02",
  // primary
  primaryHover: "#36ad6a",
  primaryDefault: "#18a058",
  primaryActive: "#0c7a43",
  primarySuppl: "#36ad6a",
  // info
  infoHover: "#4098fc",
  infoDefault: "#2080f0",
  infoActive: "#1060c9",
  infoSuppl: "#4098fc",
  // error
  errorHover: "#de576d",
  errorDefault: "#d03050",
  errorActive: "#ab1f3f",
  errorSuppl: "#de576d",
  // warning
  warningHover: "#fcb040",
  warningDefault: "#f0a020",
  warningActive: "#c97c10",
  warningSuppl: "#fcb040",
  // success
  successHover: "#36ad6a",
  successDefault: "#18a058",
  successActive: "#0c7a43",
  successSuppl: "#36ad6a"
}, XE = No(je.neutralBase), tx = No(je.neutralInvertBase), eL = "rgba(" + tx.slice(0, 3).join(", ") + ", ";
function xv(e) {
  return eL + String(e) + ")";
}
function ar(e) {
  const t = Array.from(tx);
  return t[3] = Number(e), ei(XE, t);
}
const tL = Object.assign(Object.assign({
  name: "common"
}, Mi), {
  baseColor: je.neutralBase,
  // primary color
  primaryColor: je.primaryDefault,
  primaryColorHover: je.primaryHover,
  primaryColorPressed: je.primaryActive,
  primaryColorSuppl: je.primarySuppl,
  // info color
  infoColor: je.infoDefault,
  infoColorHover: je.infoHover,
  infoColorPressed: je.infoActive,
  infoColorSuppl: je.infoSuppl,
  // success color
  successColor: je.successDefault,
  successColorHover: je.successHover,
  successColorPressed: je.successActive,
  successColorSuppl: je.successSuppl,
  // warning color
  warningColor: je.warningDefault,
  warningColorHover: je.warningHover,
  warningColorPressed: je.warningActive,
  warningColorSuppl: je.warningSuppl,
  // error color
  errorColor: je.errorDefault,
  errorColorHover: je.errorHover,
  errorColorPressed: je.errorActive,
  errorColorSuppl: je.errorSuppl,
  // text color
  textColorBase: je.neutralTextBase,
  textColor1: "rgb(31, 34, 37)",
  textColor2: "rgb(51, 54, 57)",
  textColor3: "rgb(118, 124, 130)",
  // textColor4: neutral(base.alpha4), // disabled, placeholder, icon
  // textColor5: neutral(base.alpha5),
  textColorDisabled: ar(je.alpha4),
  placeholderColor: ar(je.alpha4),
  placeholderColorDisabled: ar(je.alpha5),
  iconColor: ar(je.alpha4),
  iconColorHover: Es(ar(je.alpha4), {
    lightness: 0.75
  }),
  iconColorPressed: Es(ar(je.alpha4), {
    lightness: 0.9
  }),
  iconColorDisabled: ar(je.alpha5),
  opacity1: je.alpha1,
  opacity2: je.alpha2,
  opacity3: je.alpha3,
  opacity4: je.alpha4,
  opacity5: je.alpha5,
  dividerColor: "rgb(239, 239, 245)",
  borderColor: "rgb(224, 224, 230)",
  // close
  closeIconColor: ar(Number(je.alphaClose)),
  closeIconColorHover: ar(Number(je.alphaClose)),
  closeIconColorPressed: ar(Number(je.alphaClose)),
  closeColorHover: "rgba(0, 0, 0, .09)",
  closeColorPressed: "rgba(0, 0, 0, .13)",
  // clear
  clearColor: ar(je.alpha4),
  clearColorHover: Es(ar(je.alpha4), {
    lightness: 0.75
  }),
  clearColorPressed: Es(ar(je.alpha4), {
    lightness: 0.9
  }),
  scrollbarColor: xv(je.alphaScrollbar),
  scrollbarColorHover: xv(je.alphaScrollbarHover),
  scrollbarWidth: "5px",
  scrollbarHeight: "5px",
  scrollbarBorderRadius: "5px",
  progressRailColor: ar(je.alphaProgressRail),
  railColor: "rgb(219, 219, 223)",
  popoverColor: je.neutralPopover,
  tableColor: je.neutralCard,
  cardColor: je.neutralCard,
  modalColor: je.neutralModal,
  bodyColor: je.neutralBody,
  tagColor: "#eee",
  avatarColor: ar(je.alphaAvatar),
  invertedColor: "rgb(0, 20, 40)",
  inputColor: ar(je.alphaInput),
  codeColor: "rgb(244, 244, 248)",
  tabColor: "rgb(247, 247, 250)",
  actionColor: "rgb(250, 250, 252)",
  tableHeaderColor: "rgb(250, 250, 252)",
  hoverColor: "rgb(243, 243, 245)",
  // use color with alpha since it can be nested with header filter & sorter effect
  tableColorHover: "rgba(0, 0, 100, 0.03)",
  tableColorStriped: "rgba(0, 0, 100, 0.02)",
  pressedColor: "rgb(237, 237, 239)",
  opacityDisabled: je.alphaDisabled,
  inputColorDisabled: "rgb(250, 250, 252)",
  // secondary button color
  // can also be used in tertiary button & quaternary button
  buttonColor2: "rgba(46, 51, 56, .05)",
  buttonColor2Hover: "rgba(46, 51, 56, .09)",
  buttonColor2Pressed: "rgba(46, 51, 56, .13)",
  boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
}), Jt = tL, rL = (e) => {
  const {
    heightTiny: t,
    heightSmall: r,
    heightMedium: n,
    heightLarge: o,
    borderRadius: i,
    fontSizeTiny: a,
    fontSizeSmall: l,
    fontSizeMedium: s,
    fontSizeLarge: c,
    opacityDisabled: u,
    textColor2: d,
    textColor3: f,
    primaryColorHover: p,
    primaryColorPressed: h,
    borderColor: g,
    primaryColor: m,
    baseColor: v,
    infoColor: M,
    infoColorHover: x,
    infoColorPressed: b,
    successColor: T,
    successColorHover: w,
    successColorPressed: y,
    warningColor: I,
    warningColorHover: D,
    warningColorPressed: O,
    errorColor: $,
    errorColorHover: z,
    errorColorPressed: Y,
    fontWeight: j,
    buttonColor2: q,
    buttonColor2Hover: ee,
    buttonColor2Pressed: re,
    fontWeightStrong: le
  } = e;
  return Object.assign(Object.assign({}, JE), {
    heightTiny: t,
    heightSmall: r,
    heightMedium: n,
    heightLarge: o,
    borderRadiusTiny: i,
    borderRadiusSmall: i,
    borderRadiusMedium: i,
    borderRadiusLarge: i,
    fontSizeTiny: a,
    fontSizeSmall: l,
    fontSizeMedium: s,
    fontSizeLarge: c,
    opacityDisabled: u,
    // secondary
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: q,
    colorSecondaryHover: ee,
    colorSecondaryPressed: re,
    // tertiary
    colorTertiary: q,
    colorTertiaryHover: ee,
    colorTertiaryPressed: re,
    // quaternary
    colorQuaternary: "#0000",
    colorQuaternaryHover: ee,
    colorQuaternaryPressed: re,
    // default type
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: d,
    textColorTertiary: f,
    textColorHover: p,
    textColorPressed: h,
    textColorFocus: p,
    textColorDisabled: d,
    textColorText: d,
    textColorTextHover: p,
    textColorTextPressed: h,
    textColorTextFocus: p,
    textColorTextDisabled: d,
    textColorGhost: d,
    textColorGhostHover: p,
    textColorGhostPressed: h,
    textColorGhostFocus: p,
    textColorGhostDisabled: d,
    border: `1px solid ${g}`,
    borderHover: `1px solid ${p}`,
    borderPressed: `1px solid ${h}`,
    borderFocus: `1px solid ${p}`,
    borderDisabled: `1px solid ${g}`,
    rippleColor: m,
    // primary
    colorPrimary: m,
    colorHoverPrimary: p,
    colorPressedPrimary: h,
    colorFocusPrimary: p,
    colorDisabledPrimary: m,
    textColorPrimary: v,
    textColorHoverPrimary: v,
    textColorPressedPrimary: v,
    textColorFocusPrimary: v,
    textColorDisabledPrimary: v,
    textColorTextPrimary: m,
    textColorTextHoverPrimary: p,
    textColorTextPressedPrimary: h,
    textColorTextFocusPrimary: p,
    textColorTextDisabledPrimary: d,
    textColorGhostPrimary: m,
    textColorGhostHoverPrimary: p,
    textColorGhostPressedPrimary: h,
    textColorGhostFocusPrimary: p,
    textColorGhostDisabledPrimary: m,
    borderPrimary: `1px solid ${m}`,
    borderHoverPrimary: `1px solid ${p}`,
    borderPressedPrimary: `1px solid ${h}`,
    borderFocusPrimary: `1px solid ${p}`,
    borderDisabledPrimary: `1px solid ${m}`,
    rippleColorPrimary: m,
    // info
    colorInfo: M,
    colorHoverInfo: x,
    colorPressedInfo: b,
    colorFocusInfo: x,
    colorDisabledInfo: M,
    textColorInfo: v,
    textColorHoverInfo: v,
    textColorPressedInfo: v,
    textColorFocusInfo: v,
    textColorDisabledInfo: v,
    textColorTextInfo: M,
    textColorTextHoverInfo: x,
    textColorTextPressedInfo: b,
    textColorTextFocusInfo: x,
    textColorTextDisabledInfo: d,
    textColorGhostInfo: M,
    textColorGhostHoverInfo: x,
    textColorGhostPressedInfo: b,
    textColorGhostFocusInfo: x,
    textColorGhostDisabledInfo: M,
    borderInfo: `1px solid ${M}`,
    borderHoverInfo: `1px solid ${x}`,
    borderPressedInfo: `1px solid ${b}`,
    borderFocusInfo: `1px solid ${x}`,
    borderDisabledInfo: `1px solid ${M}`,
    rippleColorInfo: M,
    // success
    colorSuccess: T,
    colorHoverSuccess: w,
    colorPressedSuccess: y,
    colorFocusSuccess: w,
    colorDisabledSuccess: T,
    textColorSuccess: v,
    textColorHoverSuccess: v,
    textColorPressedSuccess: v,
    textColorFocusSuccess: v,
    textColorDisabledSuccess: v,
    textColorTextSuccess: T,
    textColorTextHoverSuccess: w,
    textColorTextPressedSuccess: y,
    textColorTextFocusSuccess: w,
    textColorTextDisabledSuccess: d,
    textColorGhostSuccess: T,
    textColorGhostHoverSuccess: w,
    textColorGhostPressedSuccess: y,
    textColorGhostFocusSuccess: w,
    textColorGhostDisabledSuccess: T,
    borderSuccess: `1px solid ${T}`,
    borderHoverSuccess: `1px solid ${w}`,
    borderPressedSuccess: `1px solid ${y}`,
    borderFocusSuccess: `1px solid ${w}`,
    borderDisabledSuccess: `1px solid ${T}`,
    rippleColorSuccess: T,
    // warning
    colorWarning: I,
    colorHoverWarning: D,
    colorPressedWarning: O,
    colorFocusWarning: D,
    colorDisabledWarning: I,
    textColorWarning: v,
    textColorHoverWarning: v,
    textColorPressedWarning: v,
    textColorFocusWarning: v,
    textColorDisabledWarning: v,
    textColorTextWarning: I,
    textColorTextHoverWarning: D,
    textColorTextPressedWarning: O,
    textColorTextFocusWarning: D,
    textColorTextDisabledWarning: d,
    textColorGhostWarning: I,
    textColorGhostHoverWarning: D,
    textColorGhostPressedWarning: O,
    textColorGhostFocusWarning: D,
    textColorGhostDisabledWarning: I,
    borderWarning: `1px solid ${I}`,
    borderHoverWarning: `1px solid ${D}`,
    borderPressedWarning: `1px solid ${O}`,
    borderFocusWarning: `1px solid ${D}`,
    borderDisabledWarning: `1px solid ${I}`,
    rippleColorWarning: I,
    // error
    colorError: $,
    colorHoverError: z,
    colorPressedError: Y,
    colorFocusError: z,
    colorDisabledError: $,
    textColorError: v,
    textColorHoverError: v,
    textColorPressedError: v,
    textColorFocusError: v,
    textColorDisabledError: v,
    textColorTextError: $,
    textColorTextHoverError: z,
    textColorTextPressedError: Y,
    textColorTextFocusError: z,
    textColorTextDisabledError: d,
    textColorGhostError: $,
    textColorGhostHoverError: z,
    textColorGhostPressedError: Y,
    textColorGhostFocusError: z,
    textColorGhostDisabledError: $,
    borderError: `1px solid ${$}`,
    borderHoverError: `1px solid ${z}`,
    borderPressedError: `1px solid ${Y}`,
    borderFocusError: `1px solid ${z}`,
    borderDisabledError: `1px solid ${$}`,
    rippleColorError: $,
    waveOpacity: "0.6",
    fontWeight: j,
    fontWeightStrong: le
  });
}, nL = {
  name: "Button",
  common: Jt,
  self: rL
}, um = nL;
function dr(e, t, r, n) {
  var o;
  r || J1("useThemeClass", "cssVarsRef is not passed");
  const i = (o = De(Do, null)) === null || o === void 0 ? void 0 : o.mergedThemeHashRef, a = L(""), l = bi();
  let s;
  const c = `__${e}`, u = () => {
    let d = c;
    const f = t ? t.value : void 0, p = i == null ? void 0 : i.value;
    p && (d += "-" + p), f && (d += "-" + f);
    const {
      themeOverrides: h,
      builtinThemeOverrides: g
    } = n;
    h && (d += "-" + Rf(JSON.stringify(h))), g && (d += "-" + Rf(JSON.stringify(g))), a.value = d, s = () => {
      const m = r.value;
      let v = "";
      for (const M in m)
        v += `${M}: ${m[M]};`;
      V(`.${d}`, v).mount({
        id: d,
        ssr: l
      }), s = void 0;
    };
  };
  return rr(() => {
    u();
  }), {
    themeClass: a,
    onRender: () => {
      s == null || s();
    }
  };
}
function Fl(e) {
  return e.replace(/#|\(|\)|,|\s|\./g, "_");
}
function ps(e) {
  return e.some((t) => h4(t) ? !(t.type === qg || t.type === qt && !ps(t.children)) : !0) ? e : null;
}
function hn(e, t) {
  return e && ps(e()) || t();
}
function oL(e, t, r) {
  return e && ps(e(t)) || r(t);
}
function mt(e, t) {
  const r = e && ps(e());
  return t(r || null);
}
function Ff(e) {
  return !(e && ps(e()));
}
const iL = Z({
  name: "FadeInExpandTransition",
  props: {
    appear: Boolean,
    group: Boolean,
    mode: String,
    onLeave: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    width: Boolean,
    // reverse mode is only used in tree
    // it make it from expanded to collapsed after mounted
    reverse: Boolean
  },
  setup(e, {
    slots: t
  }) {
    function r(l) {
      e.width ? l.style.maxWidth = `${l.offsetWidth}px` : l.style.maxHeight = `${l.offsetHeight}px`, l.offsetWidth;
    }
    function n(l) {
      e.width ? l.style.maxWidth = "0" : l.style.maxHeight = "0", l.offsetWidth;
      const {
        onLeave: s
      } = e;
      s && s();
    }
    function o(l) {
      e.width ? l.style.maxWidth = "" : l.style.maxHeight = "";
      const {
        onAfterLeave: s
      } = e;
      s && s();
    }
    function i(l) {
      if (l.style.transition = "none", e.width) {
        const s = l.offsetWidth;
        l.style.maxWidth = "0", l.offsetWidth, l.style.transition = "", l.style.maxWidth = `${s}px`;
      } else if (e.reverse)
        l.style.maxHeight = `${l.offsetHeight}px`, l.offsetHeight, l.style.transition = "", l.style.maxHeight = "0";
      else {
        const s = l.offsetHeight;
        l.style.maxHeight = "0", l.offsetWidth, l.style.transition = "", l.style.maxHeight = `${s}px`;
      }
      l.offsetWidth;
    }
    function a(l) {
      var s;
      e.width ? l.style.maxWidth = "" : e.reverse || (l.style.maxHeight = ""), (s = e.onAfterEnter) === null || s === void 0 || s.call(e);
    }
    return () => {
      const {
        group: l,
        width: s,
        appear: c,
        mode: u
      } = e, d = l ? g4 : zn, f = {
        name: s ? "fade-in-width-expand-transition" : "fade-in-height-expand-transition",
        appear: c,
        onEnter: i,
        onAfterEnter: a,
        onBeforeLeave: r,
        onLeave: n,
        onAfterLeave: o
      };
      return l || (f.mode = u), S(d, f, t);
    };
  }
});
function hs() {
  const e = L(!1);
  return et(() => {
    e.value = !0;
  }), ui(e);
}
const cm = Z({
  name: "BaseIconSwitchTransition",
  setup(e, {
    slots: t
  }) {
    const r = hs();
    return () => S(zn, {
      name: "icon-switch-transition",
      appear: r.value
    }, t);
  }
}), aL = V([V("@keyframes rotator", `
 0% {
 -webkit-transform: rotate(0deg);
 transform: rotate(0deg);
 }
 100% {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }`), te("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [F("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [Eu()]), F("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [Eu({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), F("container", `
 animation: rotator 3s linear infinite both;
 `, [F("icon", `
 height: 1em;
 width: 1em;
 `)])])]);
function ko(e, t, r) {
  if (!t) {
    process.env.NODE_ENV !== "production" && J1("use-style", "No style is specified.");
    return;
  }
  const n = bi(), o = De(Do, null), i = () => {
    const a = r.value;
    t.mount({
      id: a === void 0 ? e : a + e,
      head: !0,
      anchorMetaName: Rl,
      props: {
        bPrefix: a ? `.${a}-` : void 0
      },
      ssr: n
    }), o != null && o.preflightStyleDisabled || _1.mount({
      id: "n-global",
      head: !0,
      anchorMetaName: Rl,
      ssr: n
    });
  };
  n ? i() : ya(i);
}
const Cd = "1.6s", lL = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
}, dm = Z({
  name: "BaseLoading",
  props: Object.assign({
    clsPrefix: {
      type: String,
      required: !0
    },
    show: {
      type: Boolean,
      default: !0
    },
    scale: {
      type: Number,
      default: 1
    },
    radius: {
      type: Number,
      default: 100
    }
  }, lL),
  setup(e) {
    ko("-base-loading", aL, We(e, "clsPrefix"));
  },
  render() {
    const {
      clsPrefix: e,
      radius: t,
      strokeWidth: r,
      stroke: n,
      scale: o
    } = this, i = t / o;
    return S("div", {
      class: `${e}-base-loading`,
      role: "img",
      "aria-label": "loading"
    }, S(cm, null, {
      default: () => this.show ? S("div", {
        key: "icon",
        class: `${e}-base-loading__transition-wrapper`
      }, S("div", {
        class: `${e}-base-loading__container`
      }, S("svg", {
        class: `${e}-base-loading__icon`,
        viewBox: `0 0 ${2 * i} ${2 * i}`,
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          color: n
        }
      }, S("g", null, S("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${i} ${i};270 ${i} ${i}`,
        begin: "0s",
        dur: Cd,
        fill: "freeze",
        repeatCount: "indefinite"
      }), S("circle", {
        class: `${e}-base-loading__icon`,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": r,
        "stroke-linecap": "round",
        cx: i,
        cy: i,
        r: t - r / 2,
        "stroke-dasharray": 5.67 * t,
        "stroke-dashoffset": 18.48 * t
      }, S("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${i} ${i};135 ${i} ${i};450 ${i} ${i}`,
        begin: "0s",
        dur: Cd,
        fill: "freeze",
        repeatCount: "indefinite"
      }), S("animate", {
        attributeName: "stroke-dashoffset",
        values: `${5.67 * t};${1.42 * t};${5.67 * t}`,
        begin: "0s",
        dur: Cd,
        fill: "freeze",
        repeatCount: "indefinite"
      })))))) : S("div", {
        key: "placeholder",
        class: `${e}-base-loading__placeholder`
      }, this.$slots)
    }));
  }
}), sL = te("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`), uL = Z({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    ko("-base-wave", sL, We(e, "clsPrefix"));
    const t = L(null), r = L(!1);
    let n = null;
    return vt(() => {
      n !== null && window.clearTimeout(n);
    }), {
      active: r,
      selfRef: t,
      play() {
        n !== null && (window.clearTimeout(n), r.value = !1, n = null), mn(() => {
          var o;
          (o = t.value) === null || o === void 0 || o.offsetHeight, r.value = !0, n = window.setTimeout(() => {
            r.value = !1, n = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return S("div", {
      ref: "selfRef",
      "aria-hidden": !0,
      class: [`${e}-base-wave`, this.active && `${e}-base-wave--active`]
    });
  }
});
function Be(e, ...t) {
  if (Array.isArray(e))
    e.forEach((r) => Be(r, ...t));
  else
    return e(...t);
}
const cL = Object.assign(Object.assign({}, Ve.props), {
  color: String,
  textColor: String,
  text: Boolean,
  block: Boolean,
  loading: Boolean,
  disabled: Boolean,
  circle: Boolean,
  size: String,
  ghost: Boolean,
  round: Boolean,
  secondary: Boolean,
  tertiary: Boolean,
  quaternary: Boolean,
  strong: Boolean,
  focusable: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  dashed: Boolean,
  renderIcon: Function,
  iconPlacement: {
    type: String,
    default: "left"
  },
  attrType: {
    type: String,
    default: "button"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  onClick: [Function, Array],
  nativeFocusBehavior: {
    type: Boolean,
    default: !A1
  }
}), rx = Z({
  name: "Button",
  props: cL,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      const {
        dashed: b,
        ghost: T,
        text: w,
        secondary: y,
        tertiary: I,
        quaternary: D
      } = e;
      (b || T || w) && (y || I || D) && sr("button", "`dashed`, `ghost` and `text` props can't be used along with `secondary`, `tertiary` and `quaternary` props.");
    });
    const t = L(null), r = L(null), n = L(!1), o = _t(() => !e.quaternary && !e.tertiary && !e.secondary && !e.text && (!e.color || e.ghost || e.dashed) && e.bordered), i = De(E4, {}), {
      mergedSizeRef: a
    } = Ia({}, {
      defaultSize: "medium",
      mergedSize: (b) => {
        const {
          size: T
        } = e;
        if (T)
          return T;
        const {
          size: w
        } = i;
        if (w)
          return w;
        const {
          mergedSize: y
        } = b || {};
        return y ? y.value : "medium";
      }
    }), l = W(() => e.focusable && !e.disabled), s = (b) => {
      var T;
      l.value || b.preventDefault(), !e.nativeFocusBehavior && (b.preventDefault(), !e.disabled && l.value && ((T = t.value) === null || T === void 0 || T.focus({
        preventScroll: !0
      })));
    }, c = (b) => {
      var T;
      if (!e.disabled && !e.loading) {
        const {
          onClick: w
        } = e;
        w && Be(w, b), e.text || (T = r.value) === null || T === void 0 || T.play();
      }
    }, u = (b) => {
      switch (b.key) {
        case "Enter":
          if (!e.keyboard)
            return;
          n.value = !1;
      }
    }, d = (b) => {
      switch (b.key) {
        case "Enter":
          if (!e.keyboard || e.loading) {
            b.preventDefault();
            return;
          }
          n.value = !0;
      }
    }, f = () => {
      n.value = !1;
    }, {
      inlineThemeDisabled: p,
      mergedClsPrefixRef: h,
      mergedRtlRef: g
    } = Bt(e), m = Ve("Button", "-button", i2, um, e, h), v = yn("Button", g, h), M = W(() => {
      const b = m.value, {
        common: {
          cubicBezierEaseInOut: T,
          cubicBezierEaseOut: w
        },
        self: y
      } = b, {
        rippleDuration: I,
        opacityDisabled: D,
        fontWeight: O,
        fontWeightStrong: $
      } = y, z = a.value, {
        dashed: Y,
        type: j,
        ghost: q,
        text: ee,
        color: re,
        round: le,
        circle: ye,
        textColor: Me,
        secondary: Ee,
        tertiary: ne,
        quaternary: ue,
        strong: Ce
      } = e, ze = {
        "font-weight": Ce ? $ : O
      };
      let ke = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const tt = j === "tertiary", Ge = j === "default", Ne = tt ? "default" : j;
      if (ee) {
        const H = Me || re;
        ke = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": H || y[ve("textColorText", Ne)],
          "--n-text-color-hover": H ? Bo(H) : y[ve("textColorTextHover", Ne)],
          "--n-text-color-pressed": H ? Ls(H) : y[ve("textColorTextPressed", Ne)],
          "--n-text-color-focus": H ? Bo(H) : y[ve("textColorTextHover", Ne)],
          "--n-text-color-disabled": H || y[ve("textColorTextDisabled", Ne)]
        };
      } else if (q || Y) {
        const H = Me || re;
        ke = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": re || y[ve("rippleColor", Ne)],
          "--n-text-color": H || y[ve("textColorGhost", Ne)],
          "--n-text-color-hover": H ? Bo(H) : y[ve("textColorGhostHover", Ne)],
          "--n-text-color-pressed": H ? Ls(H) : y[ve("textColorGhostPressed", Ne)],
          "--n-text-color-focus": H ? Bo(H) : y[ve("textColorGhostHover", Ne)],
          "--n-text-color-disabled": H || y[ve("textColorGhostDisabled", Ne)]
        };
      } else if (Ee) {
        const H = Ge ? y.textColor : tt ? y.textColorTertiary : y[ve("color", Ne)], X = re || H, me = j !== "default" && j !== "tertiary";
        ke = {
          "--n-color": me ? qe(X, {
            alpha: Number(y.colorOpacitySecondary)
          }) : y.colorSecondary,
          "--n-color-hover": me ? qe(X, {
            alpha: Number(y.colorOpacitySecondaryHover)
          }) : y.colorSecondaryHover,
          "--n-color-pressed": me ? qe(X, {
            alpha: Number(y.colorOpacitySecondaryPressed)
          }) : y.colorSecondaryPressed,
          "--n-color-focus": me ? qe(X, {
            alpha: Number(y.colorOpacitySecondaryHover)
          }) : y.colorSecondaryHover,
          "--n-color-disabled": y.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": X,
          "--n-text-color-hover": X,
          "--n-text-color-pressed": X,
          "--n-text-color-focus": X,
          "--n-text-color-disabled": X
        };
      } else if (ne || ue) {
        const H = Ge ? y.textColor : tt ? y.textColorTertiary : y[ve("color", Ne)], X = re || H;
        ne ? (ke["--n-color"] = y.colorTertiary, ke["--n-color-hover"] = y.colorTertiaryHover, ke["--n-color-pressed"] = y.colorTertiaryPressed, ke["--n-color-focus"] = y.colorSecondaryHover, ke["--n-color-disabled"] = y.colorTertiary) : (ke["--n-color"] = y.colorQuaternary, ke["--n-color-hover"] = y.colorQuaternaryHover, ke["--n-color-pressed"] = y.colorQuaternaryPressed, ke["--n-color-focus"] = y.colorQuaternaryHover, ke["--n-color-disabled"] = y.colorQuaternary), ke["--n-ripple-color"] = "#0000", ke["--n-text-color"] = X, ke["--n-text-color-hover"] = X, ke["--n-text-color-pressed"] = X, ke["--n-text-color-focus"] = X, ke["--n-text-color-disabled"] = X;
      } else
        ke = {
          "--n-color": re || y[ve("color", Ne)],
          "--n-color-hover": re ? Bo(re) : y[ve("colorHover", Ne)],
          "--n-color-pressed": re ? Ls(re) : y[ve("colorPressed", Ne)],
          "--n-color-focus": re ? Bo(re) : y[ve("colorFocus", Ne)],
          "--n-color-disabled": re || y[ve("colorDisabled", Ne)],
          "--n-ripple-color": re || y[ve("rippleColor", Ne)],
          "--n-text-color": Me || (re ? y.textColorPrimary : tt ? y.textColorTertiary : y[ve("textColor", Ne)]),
          "--n-text-color-hover": Me || (re ? y.textColorHoverPrimary : y[ve("textColorHover", Ne)]),
          "--n-text-color-pressed": Me || (re ? y.textColorPressedPrimary : y[ve("textColorPressed", Ne)]),
          "--n-text-color-focus": Me || (re ? y.textColorFocusPrimary : y[ve("textColorFocus", Ne)]),
          "--n-text-color-disabled": Me || (re ? y.textColorDisabledPrimary : y[ve("textColorDisabled", Ne)])
        };
      let Ye = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      ee ? Ye = {
        "--n-border": "none",
        "--n-border-hover": "none",
        "--n-border-pressed": "none",
        "--n-border-focus": "none",
        "--n-border-disabled": "none"
      } : Ye = {
        "--n-border": y[ve("border", Ne)],
        "--n-border-hover": y[ve("borderHover", Ne)],
        "--n-border-pressed": y[ve("borderPressed", Ne)],
        "--n-border-focus": y[ve("borderFocus", Ne)],
        "--n-border-disabled": y[ve("borderDisabled", Ne)]
      };
      const {
        [ve("height", z)]: Se,
        [ve("fontSize", z)]: _e,
        [ve("padding", z)]: Fe,
        [ve("paddingRound", z)]: ot,
        [ve("iconSize", z)]: Nt,
        [ve("borderRadius", z)]: A,
        [ve("iconMargin", z)]: C,
        waveOpacity: E
      } = y, J = {
        "--n-width": ye && !ee ? Se : "initial",
        "--n-height": ee ? "initial" : Se,
        "--n-font-size": _e,
        "--n-padding": ye || ee ? "initial" : le ? ot : Fe,
        "--n-icon-size": Nt,
        "--n-icon-margin": C,
        "--n-border-radius": ee ? "initial" : ye || le ? Se : A
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({
        "--n-bezier": T,
        "--n-bezier-ease-out": w,
        "--n-ripple-duration": I,
        "--n-opacity-disabled": D,
        "--n-wave-opacity": E
      }, ze), ke), Ye), J);
    }), x = p ? dr("button", W(() => {
      let b = "";
      const {
        dashed: T,
        type: w,
        ghost: y,
        text: I,
        color: D,
        round: O,
        circle: $,
        textColor: z,
        secondary: Y,
        tertiary: j,
        quaternary: q,
        strong: ee
      } = e;
      T && (b += "a"), y && (b += "b"), I && (b += "c"), O && (b += "d"), $ && (b += "e"), Y && (b += "f"), j && (b += "g"), q && (b += "h"), ee && (b += "i"), D && (b += "j" + Fl(D)), z && (b += "k" + Fl(z));
      const {
        value: re
      } = a;
      return b += "l" + re[0], b += "m" + w[0], b;
    }), M, e) : void 0;
    return {
      selfElRef: t,
      waveElRef: r,
      mergedClsPrefix: h,
      mergedFocusable: l,
      mergedSize: a,
      showBorder: o,
      enterPressed: n,
      rtlEnabled: v,
      handleMousedown: s,
      handleKeydown: d,
      handleBlur: f,
      handleKeyup: u,
      handleClick: c,
      customColorCssVars: W(() => {
        const {
          color: b
        } = e;
        if (!b)
          return null;
        const T = Bo(b);
        return {
          "--n-border-color": b,
          "--n-border-color-hover": T,
          "--n-border-color-pressed": Ls(b),
          "--n-border-color-focus": T,
          "--n-border-color-disabled": b
        };
      }),
      cssVars: p ? void 0 : M,
      themeClass: x == null ? void 0 : x.themeClass,
      onRender: x == null ? void 0 : x.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e,
      tag: t,
      onRender: r
    } = this;
    r == null || r();
    const n = mt(this.$slots.default, (o) => o && S("span", {
      class: `${e}-button__content`
    }, o));
    return S(t, {
      ref: "selfElRef",
      class: [
        this.themeClass,
        `${e}-button`,
        `${e}-button--${this.type}-type`,
        `${e}-button--${this.mergedSize}-type`,
        this.rtlEnabled && `${e}-button--rtl`,
        this.disabled && `${e}-button--disabled`,
        this.block && `${e}-button--block`,
        this.enterPressed && `${e}-button--pressed`,
        !this.text && this.dashed && `${e}-button--dashed`,
        this.color && `${e}-button--color`,
        this.secondary && `${e}-button--secondary`,
        this.loading && `${e}-button--loading`,
        this.ghost && `${e}-button--ghost`
        // required for button group border collapse
      ],
      tabindex: this.mergedFocusable ? 0 : -1,
      type: this.attrType,
      style: this.cssVars,
      disabled: this.disabled,
      onClick: this.handleClick,
      onBlur: this.handleBlur,
      onMousedown: this.handleMousedown,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, this.iconPlacement === "right" && n, S(iL, {
      width: !0
    }, {
      default: () => mt(this.$slots.icon, (o) => (this.loading || this.renderIcon || o) && S("span", {
        class: `${e}-button__icon`,
        style: {
          margin: Ff(this.$slots.default) ? "0" : ""
        }
      }, S(cm, null, {
        default: () => this.loading ? S(dm, {
          clsPrefix: e,
          key: "loading",
          class: `${e}-icon-slot`,
          strokeWidth: 20
        }) : S("div", {
          key: "icon",
          class: `${e}-icon-slot`,
          role: "none"
        }, this.renderIcon ? this.renderIcon() : o)
      })))
    }), this.iconPlacement === "left" && n, this.text ? null : S(uL, {
      ref: "waveElRef",
      clsPrefix: e
    }), this.showBorder ? S("div", {
      "aria-hidden": !0,
      class: `${e}-button__border`,
      style: this.customColorCssVars
    }) : null, this.showBorder ? S("div", {
      "aria-hidden": !0,
      class: `${e}-button__state-border`,
      style: this.customColorCssVars
    }) : null);
  }
}), Uf = rx, wv = rx, dL = Z({
  name: "UIButton"
}), fL = Z({
  ...dL,
  props: {
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "medium"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    ghost: {
      type: Boolean,
      default: !1
    },
    quaternary: {
      type: Boolean,
      default: !1
    },
    circle: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: void 0
    },
    linkGray: {
      type: Boolean
    }
  },
  emits: ["click"],
  setup(e) {
    const t = wr();
    return (r, n) => (_(), se(N(Uf), Ut({
      id: e.id,
      text: e.text,
      class: [
        e.quaternary ? "quaternary" : null,
        e.circle || e.text ? "icon-only" : null,
        e.active ? "hl-active-btn" : null,
        e.text ? "hl-text-btn" : null,
        e.linkGray ? "hl-linkgray-btn" : null
      ],
      type: e.type,
      size: e.size
    }, r.$attrs, {
      disabled: e.disabled,
      loading: e.loading,
      onClick: n[0] || (n[0] = (o) => r.$emit("click", o)),
      quaternary: e.quaternary,
      circle: e.circle,
      linkGray: e.linkGray
    }), {
      default: Q(() => [
        Re(r.$slots, "default"),
        N(t).icon ? Re(r.$slots, "icon", { key: 0 }) : Oe("", !0)
      ]),
      _: 3
    }, 16, ["id", "text", "class", "type", "size", "disabled", "loading", "quaternary", "circle", "linkGray"]));
  }
}), Lr = fL;
var pL = H1(Object.keys, Object);
const hL = pL;
var gL = Object.prototype, mL = gL.hasOwnProperty;
function vL(e) {
  if (!om(e))
    return hL(e);
  var t = [];
  for (var r in Object(e))
    mL.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function fm(e) {
  return Ca(e) ? G1(e) : vL(e);
}
function bL(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (i[o++] = a);
  }
  return i;
}
function ML() {
  return [];
}
var yL = Object.prototype, xL = yL.propertyIsEnumerable, Tv = Object.getOwnPropertySymbols, wL = Tv ? function(e) {
  return e == null ? [] : (e = Object(e), bL(Tv(e), function(t) {
    return xL.call(e, t);
  }));
} : ML;
const TL = wL;
function NL(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n; )
    e[o + r] = t[r];
  return e;
}
function SL(e, t, r) {
  var n = t(e);
  return an(e) ? n : NL(n, r(e));
}
function Nv(e) {
  return SL(e, fm, TL);
}
var CL = wi(xn, "DataView");
const Hf = CL;
var IL = wi(xn, "Promise");
const Yf = IL;
var AL = wi(xn, "Set");
const Gi = AL;
var DL = wi(xn, "WeakMap");
const Wf = DL;
var Sv = "[object Map]", kL = "[object Object]", Cv = "[object Promise]", Iv = "[object Set]", Av = "[object WeakMap]", Dv = "[object DataView]", EL = xi(Hf), LL = xi(Pl), $L = xi(Yf), zL = xi(Gi), OL = xi(Wf), Uo = yi;
(Hf && Uo(new Hf(new ArrayBuffer(1))) != Dv || Pl && Uo(new Pl()) != Sv || Yf && Uo(Yf.resolve()) != Cv || Gi && Uo(new Gi()) != Iv || Wf && Uo(new Wf()) != Av) && (Uo = function(e) {
  var t = yi(e), r = t == kL ? e.constructor : void 0, n = r ? xi(r) : "";
  if (n)
    switch (n) {
      case EL:
        return Dv;
      case LL:
        return Sv;
      case $L:
        return Cv;
      case zL:
        return Iv;
      case OL:
        return Av;
    }
  return t;
});
const kv = Uo, jL = {
  color: Object,
  type: {
    type: String,
    default: "default"
  },
  round: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  closable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  }
}, RL = te("tag", `
 --n-close-margin: var(--n-close-margin-top) var(--n-close-margin-right) var(--n-close-margin-bottom) var(--n-close-margin-left);
 white-space: nowrap;
 position: relative;
 box-sizing: border-box;
 cursor: default;
 display: inline-flex;
 align-items: center;
 flex-wrap: nowrap;
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 line-height: 1;
 height: var(--n-height);
 font-size: var(--n-font-size);
`, [fe("strong", `
 font-weight: var(--n-font-weight-strong);
 `), F("border", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-border);
 transition: border-color .3s var(--n-bezier);
 `), F("icon", `
 display: flex;
 margin: 0 4px 0 0;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 font-size: var(--n-avatar-size-override);
 `), F("avatar", `
 display: flex;
 margin: 0 6px 0 0;
 `), F("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), fe("round", `
 padding: 0 calc(var(--n-height) / 3);
 border-radius: calc(var(--n-height) / 2);
 `, [F("icon", `
 margin: 0 4px 0 calc((var(--n-height) - 8px) / -2);
 `), F("avatar", `
 margin: 0 6px 0 calc((var(--n-height) - 8px) / -2);
 `), fe("closable", `
 padding: 0 calc(var(--n-height) / 4) 0 calc(var(--n-height) / 3);
 `)]), fe("icon, avatar", [fe("round", `
 padding: 0 calc(var(--n-height) / 3) 0 calc(var(--n-height) / 2);
 `)]), fe("disabled", `
 cursor: not-allowed !important;
 opacity: var(--n-opacity-disabled);
 `), fe("checkable", `
 cursor: pointer;
 box-shadow: none;
 color: var(--n-text-color-checkable);
 background-color: var(--n-color-checkable);
 `, [$t("disabled", [V("&:hover", "background-color: var(--n-color-hover-checkable);", [$t("checked", "color: var(--n-text-color-hover-checkable);")]), V("&:active", "background-color: var(--n-color-pressed-checkable);", [$t("checked", "color: var(--n-text-color-pressed-checkable);")])]), fe("checked", `
 color: var(--n-text-color-checked);
 background-color: var(--n-color-checked);
 `, [$t("disabled", [V("&:hover", "background-color: var(--n-color-checked-hover);"), V("&:active", "background-color: var(--n-color-checked-pressed);")])])])]);
function _L(e) {
  return typeof e == "string" ? e.endsWith("px") ? Number(e.slice(0, e.length - 2)) : Number(e) : e;
}
function Kn(e, t) {
  const r = e.trim().split(/\s+/g), n = {
    top: r[0]
  };
  switch (r.length) {
    case 1:
      n.right = r[0], n.bottom = r[0], n.left = r[0];
      break;
    case 2:
      n.right = r[1], n.left = r[1], n.bottom = r[0];
      break;
    case 3:
      n.right = r[1], n.bottom = r[2], n.left = r[1];
      break;
    case 4:
      n.right = r[1], n.bottom = r[2], n.left = r[3];
      break;
    default:
      throw new Error("[seemly/getMargin]:" + e + " is not a valid value.");
  }
  return t === void 0 ? n : n[t];
}
const PL = te("base-close", `
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 background-color: transparent;
 color: var(--n-close-icon-color);
 border-radius: var(--n-close-border-radius);
 height: var(--n-close-size);
 width: var(--n-close-size);
 font-size: var(--n-close-icon-size);
 outline: none;
 border: none;
 position: relative;
 padding: 0;
`, [fe("absolute", `
 height: var(--n-close-icon-size);
 width: var(--n-close-icon-size);
 `), V("&::before", `
 content: "";
 position: absolute;
 width: var(--n-close-size);
 height: var(--n-close-size);
 left: 50%;
 top: 50%;
 transform: translateY(-50%) translateX(-50%);
 transition: inherit;
 border-radius: inherit;
 `), $t("disabled", [V("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), V("&:hover::before", `
 background-color: var(--n-close-color-hover);
 `), V("&:focus::before", `
 background-color: var(--n-close-color-hover);
 `), V("&:active", `
 color: var(--n-close-icon-color-pressed);
 `), V("&:active::before", `
 background-color: var(--n-close-color-pressed);
 `)]), fe("disabled", `
 cursor: not-allowed;
 color: var(--n-close-icon-color-disabled);
 background-color: transparent;
 `), fe("round", [V("&::before", `
 border-radius: 50%;
 `)])]), BL = te("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [V("svg", `
 height: 1em;
 width: 1em;
 `)]), On = Z({
  name: "BaseIcon",
  props: {
    role: String,
    ariaLabel: String,
    ariaDisabled: {
      type: Boolean,
      default: void 0
    },
    ariaHidden: {
      type: Boolean,
      default: void 0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    onClick: Function,
    onMousedown: Function,
    onMouseup: Function
  },
  setup(e) {
    ko("-base-icon", BL, We(e, "clsPrefix"));
  },
  render() {
    return S("i", {
      class: `${this.clsPrefix}-base-icon`,
      onClick: this.onClick,
      onMousedown: this.onMousedown,
      onMouseup: this.onMouseup,
      role: this.role,
      "aria-label": this.ariaLabel,
      "aria-hidden": this.ariaHidden,
      "aria-disabled": this.ariaDisabled
    }, this.$slots);
  }
});
function FL(e, t, r) {
  var n = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(o); ++n < o; )
    i[n] = e[n + t];
  return i;
}
function UL(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : FL(e, t, r);
}
var HL = "\\ud800-\\udfff", YL = "\\u0300-\\u036f", WL = "\\ufe20-\\ufe2f", QL = "\\u20d0-\\u20ff", VL = YL + WL + QL, ZL = "\\ufe0e\\ufe0f", GL = "\\u200d", KL = RegExp("[" + GL + HL + VL + ZL + "]");
function nx(e) {
  return KL.test(e);
}
function qL(e) {
  return e.split("");
}
var ox = "\\ud800-\\udfff", JL = "\\u0300-\\u036f", XL = "\\ufe20-\\ufe2f", e$ = "\\u20d0-\\u20ff", t$ = JL + XL + e$, r$ = "\\ufe0e\\ufe0f", n$ = "[" + ox + "]", Qf = "[" + t$ + "]", Vf = "\\ud83c[\\udffb-\\udfff]", o$ = "(?:" + Qf + "|" + Vf + ")", ix = "[^" + ox + "]", ax = "(?:\\ud83c[\\udde6-\\uddff]){2}", lx = "[\\ud800-\\udbff][\\udc00-\\udfff]", i$ = "\\u200d", sx = o$ + "?", ux = "[" + r$ + "]?", a$ = "(?:" + i$ + "(?:" + [ix, ax, lx].join("|") + ")" + ux + sx + ")*", l$ = ux + sx + a$, s$ = "(?:" + [ix + Qf + "?", Qf, ax, lx, n$].join("|") + ")", u$ = RegExp(Vf + "(?=" + Vf + ")|" + s$ + l$, "g");
function c$(e) {
  return e.match(u$) || [];
}
function d$(e) {
  return nx(e) ? c$(e) : qL(e);
}
function cx(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
    o[r] = t(e[r], r, e);
  return o;
}
var f$ = "[object Symbol]";
function Wc(e) {
  return typeof e == "symbol" || Co(e) && yi(e) == f$;
}
var p$ = 1 / 0, Ev = So ? So.prototype : void 0, Lv = Ev ? Ev.toString : void 0;
function dx(e) {
  if (typeof e == "string")
    return e;
  if (an(e))
    return cx(e, dx) + "";
  if (Wc(e))
    return Lv ? Lv.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -p$ ? "-0" : t;
}
function fx(e) {
  return e == null ? "" : dx(e);
}
function h$(e) {
  return function(t) {
    t = fx(t);
    var r = nx(t) ? d$(t) : void 0, n = r ? r[0] : t.charAt(0), o = r ? UL(r, 1).join("") : t.slice(1);
    return n[e]() + o;
  };
}
var g$ = h$("toUpperCase");
const m$ = g$;
function Aa(e, t) {
  return Z({
    name: m$(e),
    setup() {
      var r;
      const n = (r = De(Do, null)) === null || r === void 0 ? void 0 : r.mergedIconsRef;
      return () => {
        var o;
        const i = (o = n == null ? void 0 : n.value) === null || o === void 0 ? void 0 : o[e];
        return i ? i() : t;
      };
    }
  });
}
const v$ = Aa("close", S("svg", {
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": !0
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, S("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, S("path", {
  d: "M2.08859116,2.2156945 L2.14644661,2.14644661 C2.32001296,1.97288026 2.58943736,1.95359511 2.7843055,2.08859116 L2.85355339,2.14644661 L6,5.293 L9.14644661,2.14644661 C9.34170876,1.95118446 9.65829124,1.95118446 9.85355339,2.14644661 C10.0488155,2.34170876 10.0488155,2.65829124 9.85355339,2.85355339 L6.707,6 L9.85355339,9.14644661 C10.0271197,9.32001296 10.0464049,9.58943736 9.91140884,9.7843055 L9.85355339,9.85355339 C9.67998704,10.0271197 9.41056264,10.0464049 9.2156945,9.91140884 L9.14644661,9.85355339 L6,6.707 L2.85355339,9.85355339 C2.65829124,10.0488155 2.34170876,10.0488155 2.14644661,9.85355339 C1.95118446,9.65829124 1.95118446,9.34170876 2.14644661,9.14644661 L5.293,6 L2.14644661,2.85355339 C1.97288026,2.67998704 1.95359511,2.41056264 2.08859116,2.2156945 L2.14644661,2.14644661 L2.08859116,2.2156945 Z"
}))))), pm = Z({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: !0
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(e) {
    return ko("-base-close", PL, We(e, "clsPrefix")), () => {
      const {
        clsPrefix: t,
        disabled: r,
        absolute: n,
        round: o,
        isButtonTag: i
      } = e;
      return S(i ? "button" : "div", {
        type: i ? "button" : void 0,
        tabindex: r || !e.focusable ? -1 : 0,
        "aria-disabled": r,
        "aria-label": "close",
        role: i ? void 0 : "button",
        disabled: r,
        class: [`${t}-base-close`, n && `${t}-base-close--absolute`, r && `${t}-base-close--disabled`, o && `${t}-base-close--round`],
        onMousedown: (a) => {
          e.focusable || a.preventDefault();
        },
        onClick: e.onClick
      }, S(On, {
        clsPrefix: t
      }, {
        default: () => S(v$, null)
      }));
    };
  }
}), b$ = {
  closeIconSizeTiny: "12px",
  closeIconSizeSmall: "12px",
  closeIconSizeMedium: "14px",
  closeIconSizeLarge: "14px",
  closeSizeTiny: "16px",
  closeSizeSmall: "16px",
  closeSizeMedium: "18px",
  closeSizeLarge: "18px",
  padding: "0 7px",
  closeMargin: "0 0 0 4px"
}, M$ = (e) => {
  const {
    textColor2: t,
    primaryColorHover: r,
    primaryColorPressed: n,
    primaryColor: o,
    infoColor: i,
    successColor: a,
    warningColor: l,
    errorColor: s,
    baseColor: c,
    borderColor: u,
    opacityDisabled: d,
    tagColor: f,
    closeIconColor: p,
    closeIconColorHover: h,
    closeIconColorPressed: g,
    borderRadiusSmall: m,
    fontSizeMini: v,
    fontSizeTiny: M,
    fontSizeSmall: x,
    fontSizeMedium: b,
    heightMini: T,
    heightTiny: w,
    heightSmall: y,
    heightMedium: I,
    closeColorHover: D,
    closeColorPressed: O,
    buttonColor2Hover: $,
    buttonColor2Pressed: z,
    fontWeightStrong: Y
  } = e;
  return Object.assign(Object.assign({}, b$), {
    closeBorderRadius: m,
    heightTiny: T,
    heightSmall: w,
    heightMedium: y,
    heightLarge: I,
    borderRadius: m,
    opacityDisabled: d,
    fontSizeTiny: v,
    fontSizeSmall: M,
    fontSizeMedium: x,
    fontSizeLarge: b,
    fontWeightStrong: Y,
    // checked
    textColorCheckable: t,
    textColorHoverCheckable: t,
    textColorPressedCheckable: t,
    textColorChecked: c,
    colorCheckable: "#0000",
    colorHoverCheckable: $,
    colorPressedCheckable: z,
    colorChecked: o,
    colorCheckedHover: r,
    colorCheckedPressed: n,
    // default
    border: `1px solid ${u}`,
    textColor: t,
    color: f,
    colorBordered: "rgb(250, 250, 252)",
    closeIconColor: p,
    closeIconColorHover: h,
    closeIconColorPressed: g,
    closeColorHover: D,
    closeColorPressed: O,
    borderPrimary: `1px solid ${qe(o, {
      alpha: 0.3
    })}`,
    textColorPrimary: o,
    colorPrimary: qe(o, {
      alpha: 0.12
    }),
    colorBorderedPrimary: qe(o, {
      alpha: 0.1
    }),
    closeIconColorPrimary: o,
    closeIconColorHoverPrimary: o,
    closeIconColorPressedPrimary: o,
    closeColorHoverPrimary: qe(o, {
      alpha: 0.12
    }),
    closeColorPressedPrimary: qe(o, {
      alpha: 0.18
    }),
    borderInfo: `1px solid ${qe(i, {
      alpha: 0.3
    })}`,
    textColorInfo: i,
    colorInfo: qe(i, {
      alpha: 0.12
    }),
    colorBorderedInfo: qe(i, {
      alpha: 0.1
    }),
    closeIconColorInfo: i,
    closeIconColorHoverInfo: i,
    closeIconColorPressedInfo: i,
    closeColorHoverInfo: qe(i, {
      alpha: 0.12
    }),
    closeColorPressedInfo: qe(i, {
      alpha: 0.18
    }),
    borderSuccess: `1px solid ${qe(a, {
      alpha: 0.3
    })}`,
    textColorSuccess: a,
    colorSuccess: qe(a, {
      alpha: 0.12
    }),
    colorBorderedSuccess: qe(a, {
      alpha: 0.1
    }),
    closeIconColorSuccess: a,
    closeIconColorHoverSuccess: a,
    closeIconColorPressedSuccess: a,
    closeColorHoverSuccess: qe(a, {
      alpha: 0.12
    }),
    closeColorPressedSuccess: qe(a, {
      alpha: 0.18
    }),
    borderWarning: `1px solid ${qe(l, {
      alpha: 0.35
    })}`,
    textColorWarning: l,
    colorWarning: qe(l, {
      alpha: 0.15
    }),
    colorBorderedWarning: qe(l, {
      alpha: 0.12
    }),
    closeIconColorWarning: l,
    closeIconColorHoverWarning: l,
    closeIconColorPressedWarning: l,
    closeColorHoverWarning: qe(l, {
      alpha: 0.12
    }),
    closeColorPressedWarning: qe(l, {
      alpha: 0.18
    }),
    borderError: `1px solid ${qe(s, {
      alpha: 0.23
    })}`,
    textColorError: s,
    colorError: qe(s, {
      alpha: 0.1
    }),
    colorBorderedError: qe(s, {
      alpha: 0.08
    }),
    closeIconColorError: s,
    closeIconColorHoverError: s,
    closeIconColorPressedError: s,
    closeColorHoverError: qe(s, {
      alpha: 0.12
    }),
    closeColorPressedError: qe(s, {
      alpha: 0.18
    })
  });
}, y$ = {
  name: "Tag",
  common: Jt,
  self: M$
}, x$ = y$, w$ = Object.assign(Object.assign(Object.assign({}, Ve.props), jL), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  // private
  internalCloseFocusable: {
    type: Boolean,
    default: !0
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onCheckedChange: Function
}), px = "n-tag", ll = Z({
  name: "Tag",
  props: w$,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      e.onCheckedChange !== void 0 && sr("tag", "`on-checked-change` is deprecated, please use `on-update:checked` instead");
    });
    const t = L(null), {
      mergedBorderedRef: r,
      mergedClsPrefixRef: n,
      inlineThemeDisabled: o,
      mergedRtlRef: i
    } = Bt(e), a = Ve("Tag", "-tag", RL, x$, e, n);
    Et(px, {
      roundRef: We(e, "round")
    });
    function l(p) {
      if (!e.disabled && e.checkable) {
        const {
          checked: h,
          onCheckedChange: g,
          onUpdateChecked: m,
          "onUpdate:checked": v
        } = e;
        m && m(!h), v && v(!h), g && g(!h);
      }
    }
    function s(p) {
      if (e.triggerClickOnClose || p.stopPropagation(), !e.disabled) {
        const {
          onClose: h
        } = e;
        h && Be(h, p);
      }
    }
    const c = {
      setTextContent(p) {
        const {
          value: h
        } = t;
        h && (h.textContent = p);
      }
    }, u = yn("Tag", i, n), d = W(() => {
      const {
        type: p,
        size: h,
        color: {
          color: g,
          textColor: m
        } = {}
      } = e, {
        common: {
          cubicBezierEaseInOut: v
        },
        self: {
          padding: M,
          closeMargin: x,
          borderRadius: b,
          opacityDisabled: T,
          textColorCheckable: w,
          textColorHoverCheckable: y,
          textColorPressedCheckable: I,
          textColorChecked: D,
          colorCheckable: O,
          colorHoverCheckable: $,
          colorPressedCheckable: z,
          colorChecked: Y,
          colorCheckedHover: j,
          colorCheckedPressed: q,
          closeBorderRadius: ee,
          fontWeightStrong: re,
          [ve("colorBordered", p)]: le,
          [ve("closeSize", h)]: ye,
          [ve("closeIconSize", h)]: Me,
          [ve("fontSize", h)]: Ee,
          [ve("height", h)]: ne,
          [ve("color", p)]: ue,
          [ve("textColor", p)]: Ce,
          [ve("border", p)]: ze,
          [ve("closeIconColor", p)]: ke,
          [ve("closeIconColorHover", p)]: tt,
          [ve("closeIconColorPressed", p)]: Ge,
          [ve("closeColorHover", p)]: Ne,
          [ve("closeColorPressed", p)]: Ye
        }
      } = a.value, Se = Kn(x);
      return {
        "--n-font-weight-strong": re,
        "--n-avatar-size-override": `calc(${ne} - 8px)`,
        "--n-bezier": v,
        "--n-border-radius": b,
        "--n-border": ze,
        "--n-close-icon-size": Me,
        "--n-close-color-pressed": Ye,
        "--n-close-color-hover": Ne,
        "--n-close-border-radius": ee,
        "--n-close-icon-color": ke,
        "--n-close-icon-color-hover": tt,
        "--n-close-icon-color-pressed": Ge,
        "--n-close-icon-color-disabled": ke,
        "--n-close-margin-top": Se.top,
        "--n-close-margin-right": Se.right,
        "--n-close-margin-bottom": Se.bottom,
        "--n-close-margin-left": Se.left,
        "--n-close-size": ye,
        "--n-color": g || (r.value ? le : ue),
        "--n-color-checkable": O,
        "--n-color-checked": Y,
        "--n-color-checked-hover": j,
        "--n-color-checked-pressed": q,
        "--n-color-hover-checkable": $,
        "--n-color-pressed-checkable": z,
        "--n-font-size": Ee,
        "--n-height": ne,
        "--n-opacity-disabled": T,
        "--n-padding": M,
        "--n-text-color": m || Ce,
        "--n-text-color-checkable": w,
        "--n-text-color-checked": D,
        "--n-text-color-hover-checkable": y,
        "--n-text-color-pressed-checkable": I
      };
    }), f = o ? dr("tag", W(() => {
      let p = "";
      const {
        type: h,
        size: g,
        color: {
          color: m,
          textColor: v
        } = {}
      } = e;
      return p += h[0], p += g[0], m && (p += `a${Fl(m)}`), v && (p += `b${Fl(v)}`), r.value && (p += "c"), p;
    }), d, e) : void 0;
    return Object.assign(Object.assign({}, c), {
      rtlEnabled: u,
      mergedClsPrefix: n,
      contentRef: t,
      mergedBordered: r,
      handleClick: l,
      handleCloseClick: s,
      cssVars: o ? void 0 : d,
      themeClass: f == null ? void 0 : f.themeClass,
      onRender: f == null ? void 0 : f.onRender
    });
  },
  render() {
    var e, t;
    const {
      mergedClsPrefix: r,
      rtlEnabled: n,
      closable: o,
      color: {
        borderColor: i
      } = {},
      round: a,
      onRender: l,
      $slots: s
    } = this;
    l == null || l();
    const c = mt(s.avatar, (d) => d && S("div", {
      class: `${r}-tag__avatar`
    }, d)), u = mt(s.icon, (d) => d && S("div", {
      class: `${r}-tag__icon`
    }, d));
    return S("div", {
      class: [`${r}-tag`, this.themeClass, {
        [`${r}-tag--rtl`]: n,
        [`${r}-tag--strong`]: this.strong,
        [`${r}-tag--disabled`]: this.disabled,
        [`${r}-tag--checkable`]: this.checkable,
        [`${r}-tag--checked`]: this.checkable && this.checked,
        [`${r}-tag--round`]: a,
        [`${r}-tag--avatar`]: c,
        [`${r}-tag--icon`]: u,
        [`${r}-tag--closable`]: o
      }],
      style: this.cssVars,
      onClick: this.handleClick,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, u || c, S("span", {
      class: `${r}-tag__content`,
      ref: "contentRef"
    }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e)), !this.checkable && o ? S(pm, {
      clsPrefix: r,
      class: `${r}-tag__close`,
      disabled: this.disabled,
      onClick: this.handleCloseClick,
      focusable: this.internalCloseFocusable,
      round: a,
      isButtonTag: this.internalCloseIsButtonTag,
      absolute: !0
    }) : null, !this.checkable && this.mergedBordered ? S("div", {
      class: `${r}-tag__border`,
      style: {
        borderColor: i
      }
    }) : null);
  }
}), T$ = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  padding: "8px 0",
  width: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  flexDirection: "column"
}, $v = {
  margin: 0,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  width: "100%"
}, N$ = (e) => S(
  "div",
  {
    style: T$
  },
  [
    S(
      "p",
      {
        style: $v
      },
      { default: () => e == null ? void 0 : e.label }
    ),
    S(
      "span",
      {
        style: {
          color: e.disabled ? "var(--gray-300)" : "var(--gray-500)",
          ...$v
        }
      },
      {
        default: () => e != null && e.description ? e == null ? void 0 : e.description : void 0
      }
    )
  ]
), S$ = ({ option: e }) => e.label, C$ = ({
  option: e,
  handleClose: t
}) => S(
  ll,
  {
    closable: !0,
    onClose: (r) => {
      r.stopPropagation(), t();
    }
  },
  {
    default: () => e.label
  }
), zv = [
  "#FEEE95",
  "#F9DBAF",
  "#FFD6AE",
  "#FECDD6",
  "#FCE7F6",
  "#F6D0FE",
  "#D9D6FE",
  "#DDD6FE",
  "#C7D7FE",
  "#B2CCFF",
  "#B2DDFF",
  "#B9E6FE",
  "#A5F0FC",
  "#99F6E0",
  "#D0F8AB"
], I$ = (e) => {
  if (e == null)
    return "#f2f4f7";
  let t = 0;
  if (e = e.trim().toLowerCase(), e.length === 0)
    return "#f2f4f7";
  for (let r = 0; r < e.length; r++)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  return zv[Math.abs(t) % zv.length];
}, A$ = (e = "") => {
  if (e === null || !e.trim())
    return e;
  const t = (e ?? "").toLocaleUpperCase().split(" ").filter((r) => r.trim());
  return t.length > 1 ? t.splice(0, 2).reduce((r, n) => r + n[0], "") : t[0].slice(0, 2);
}, D$ = Sa && "loading" in document.createElement("img"), k$ = (e = {}) => {
  var t;
  const {
    root: r = null
  } = e;
  return {
    hash: `${e.rootMargin || "0px 0px 0px 0px"}-${Array.isArray(e.threshold) ? e.threshold.join(",") : (t = e.threshold) !== null && t !== void 0 ? t : "0"}`,
    options: Object.assign(Object.assign({}, e), {
      root: (typeof r == "string" ? document.querySelector(r) : r) || document.documentElement
    })
  };
}, Id = /* @__PURE__ */ new WeakMap(), Ad = /* @__PURE__ */ new WeakMap(), Dd = /* @__PURE__ */ new WeakMap(), E$ = (e, t, r) => {
  if (!e)
    return () => {
    };
  const n = k$(t), {
    root: o
  } = n.options;
  let i;
  const a = Id.get(o);
  a ? i = a : (i = /* @__PURE__ */ new Map(), Id.set(o, i));
  let l, s;
  i.has(n.hash) ? (s = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  i.get(n.hash), s[1].has(e) || (l = s[0], s[1].add(e), l.observe(e))) : (l = new IntersectionObserver((d) => {
    d.forEach((f) => {
      if (f.isIntersecting) {
        const p = Ad.get(f.target), h = Dd.get(f.target);
        p && p(), h && (h.value = !0);
      }
    });
  }, n.options), l.observe(e), s = [l, /* @__PURE__ */ new Set([e])], i.set(n.hash, s));
  let c = !1;
  const u = () => {
    c || (Ad.delete(e), Dd.delete(e), c = !0, s[1].has(e) && (s[0].unobserve(e), s[1].delete(e)), s[1].size <= 0 && i.delete(n.hash), i.size || Id.delete(o));
  };
  return Ad.set(e, u), Dd.set(e, r), u;
}, L$ = "n-avatar-group", $$ = te("avatar", `
 width: var(--n-merged-size);
 height: var(--n-merged-size);
 color: #FFF;
 font-size: var(--n-font-size);
 display: inline-flex;
 position: relative;
 overflow: hidden;
 text-align: center;
 border: var(--n-border);
 border-radius: var(--n-border-radius);
 --n-merged-color: var(--n-color);
 background-color: var(--n-merged-color);
 transition:
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
`, [tm(V("&", "--n-merged-color: var(--n-color-modal);")), j1(V("&", "--n-merged-color: var(--n-color-popover);")), V("img", `
 width: 100%;
 height: 100%;
 `), F("text", `
 white-space: nowrap;
 display: inline-block;
 position: absolute;
 left: 50%;
 top: 50%;
 `), te("icon", `
 vertical-align: bottom;
 font-size: calc(var(--n-merged-size) - 6px);
 `), F("text", "line-height: 1.25")]), z$ = (e) => {
  const {
    borderRadius: t,
    avatarColor: r,
    cardColor: n,
    fontSize: o,
    heightTiny: i,
    heightSmall: a,
    heightMedium: l,
    heightLarge: s,
    heightHuge: c,
    modalColor: u,
    popoverColor: d
  } = e;
  return {
    borderRadius: t,
    fontSize: o,
    border: `2px solid ${n}`,
    heightTiny: i,
    heightSmall: a,
    heightMedium: l,
    heightLarge: s,
    heightHuge: c,
    color: ei(n, r),
    colorModal: ei(u, r),
    colorPopover: ei(d, r)
  };
}, O$ = {
  name: "Avatar",
  common: Jt,
  self: z$
}, j$ = O$;
var ti = [], R$ = function() {
  return ti.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, _$ = function() {
  return ti.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, Ov = "ResizeObserver loop completed with undelivered notifications.", P$ = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: Ov
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = Ov), window.dispatchEvent(e);
}, Ul;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Ul || (Ul = {}));
var ri = function(e) {
  return Object.freeze(e);
}, B$ = function() {
  function e(t, r) {
    this.inlineSize = t, this.blockSize = r, ri(this);
  }
  return e;
}(), hx = function() {
  function e(t, r, n, o) {
    return this.x = t, this.y = r, this.width = n, this.height = o, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, ri(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, r = t.x, n = t.y, o = t.top, i = t.right, a = t.bottom, l = t.left, s = t.width, c = t.height;
    return { x: r, y: n, top: o, right: i, bottom: a, left: l, width: s, height: c };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), hm = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, gx = function(e) {
  if (hm(e)) {
    var t = e.getBBox(), r = t.width, n = t.height;
    return !r && !n;
  }
  var o = e, i = o.offsetWidth, a = o.offsetHeight;
  return !(i || a || e.getClientRects().length);
}, jv = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var r = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(r && e instanceof r.Element);
}, F$ = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, sl = typeof window < "u" ? window : {}, js = /* @__PURE__ */ new WeakMap(), Rv = /auto|scroll/, U$ = /^tb|vertical/, H$ = /msie|trident/i.test(sl.navigator && sl.navigator.userAgent), Cn = function(e) {
  return parseFloat(e || "0");
}, Ki = function(e, t, r) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), r === void 0 && (r = !1), new B$((r ? t : e) || 0, (r ? e : t) || 0);
}, _v = ri({
  devicePixelContentBoxSize: Ki(),
  borderBoxSize: Ki(),
  contentBoxSize: Ki(),
  contentRect: new hx(0, 0, 0, 0)
}), mx = function(e, t) {
  if (t === void 0 && (t = !1), js.has(e) && !t)
    return js.get(e);
  if (gx(e))
    return js.set(e, _v), _v;
  var r = getComputedStyle(e), n = hm(e) && e.ownerSVGElement && e.getBBox(), o = !H$ && r.boxSizing === "border-box", i = U$.test(r.writingMode || ""), a = !n && Rv.test(r.overflowY || ""), l = !n && Rv.test(r.overflowX || ""), s = n ? 0 : Cn(r.paddingTop), c = n ? 0 : Cn(r.paddingRight), u = n ? 0 : Cn(r.paddingBottom), d = n ? 0 : Cn(r.paddingLeft), f = n ? 0 : Cn(r.borderTopWidth), p = n ? 0 : Cn(r.borderRightWidth), h = n ? 0 : Cn(r.borderBottomWidth), g = n ? 0 : Cn(r.borderLeftWidth), m = d + c, v = s + u, M = g + p, x = f + h, b = l ? e.offsetHeight - x - e.clientHeight : 0, T = a ? e.offsetWidth - M - e.clientWidth : 0, w = o ? m + M : 0, y = o ? v + x : 0, I = n ? n.width : Cn(r.width) - w - T, D = n ? n.height : Cn(r.height) - y - b, O = I + m + T + M, $ = D + v + b + x, z = ri({
    devicePixelContentBoxSize: Ki(Math.round(I * devicePixelRatio), Math.round(D * devicePixelRatio), i),
    borderBoxSize: Ki(O, $, i),
    contentBoxSize: Ki(I, D, i),
    contentRect: new hx(d, s, I, D)
  });
  return js.set(e, z), z;
}, vx = function(e, t, r) {
  var n = mx(e, r), o = n.borderBoxSize, i = n.contentBoxSize, a = n.devicePixelContentBoxSize;
  switch (t) {
    case Ul.DEVICE_PIXEL_CONTENT_BOX:
      return a;
    case Ul.BORDER_BOX:
      return o;
    default:
      return i;
  }
}, Y$ = function() {
  function e(t) {
    var r = mx(t);
    this.target = t, this.contentRect = r.contentRect, this.borderBoxSize = ri([r.borderBoxSize]), this.contentBoxSize = ri([r.contentBoxSize]), this.devicePixelContentBoxSize = ri([r.devicePixelContentBoxSize]);
  }
  return e;
}(), bx = function(e) {
  if (gx(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
}, W$ = function() {
  var e = 1 / 0, t = [];
  ti.forEach(function(i) {
    if (i.activeTargets.length !== 0) {
      var a = [];
      i.activeTargets.forEach(function(l) {
        var s = new Y$(l.target), c = bx(l.target);
        a.push(s), l.lastReportedSize = vx(l.target, l.observedBox), c < e && (e = c);
      }), t.push(function() {
        i.callback.call(i.observer, a, i.observer);
      }), i.activeTargets.splice(0, i.activeTargets.length);
    }
  });
  for (var r = 0, n = t; r < n.length; r++) {
    var o = n[r];
    o();
  }
  return e;
}, Pv = function(e) {
  ti.forEach(function(t) {
    t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function(r) {
      r.isActive() && (bx(r.target) > e ? t.activeTargets.push(r) : t.skippedTargets.push(r));
    });
  });
}, Q$ = function() {
  var e = 0;
  for (Pv(e); R$(); )
    e = W$(), Pv(e);
  return _$() && P$(), e > 0;
}, kd, Mx = [], V$ = function() {
  return Mx.splice(0).forEach(function(e) {
    return e();
  });
}, Z$ = function(e) {
  if (!kd) {
    var t = 0, r = document.createTextNode(""), n = { characterData: !0 };
    new MutationObserver(function() {
      return V$();
    }).observe(r, n), kd = function() {
      r.textContent = "".concat(t ? t-- : t++);
    };
  }
  Mx.push(e), kd();
}, G$ = function(e) {
  Z$(function() {
    requestAnimationFrame(e);
  });
}, mu = 0, K$ = function() {
  return !!mu;
}, q$ = 250, J$ = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Bv = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Fv = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, Ed = !1, X$ = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var r = this;
    if (t === void 0 && (t = q$), !Ed) {
      Ed = !0;
      var n = Fv(t);
      G$(function() {
        var o = !1;
        try {
          o = Q$();
        } finally {
          if (Ed = !1, t = n - Fv(), !K$())
            return;
          o ? r.run(1e3) : t > 0 ? r.run(t) : r.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, r = function() {
      return t.observer && t.observer.observe(document.body, J$);
    };
    document.body ? r() : sl.addEventListener("DOMContentLoaded", r);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Bv.forEach(function(r) {
      return sl.addEventListener(r, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), Bv.forEach(function(r) {
      return sl.removeEventListener(r, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), Zf = new X$(), Uv = function(e) {
  !mu && e > 0 && Zf.start(), mu += e, !mu && Zf.stop();
}, ez = function(e) {
  return !hm(e) && !F$(e) && getComputedStyle(e).display === "inline";
}, tz = function() {
  function e(t, r) {
    this.target = t, this.observedBox = r || Ul.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = vx(this.target, this.observedBox, !0);
    return ez(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), rz = function() {
  function e(t, r) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = r;
  }
  return e;
}(), Rs = /* @__PURE__ */ new WeakMap(), Hv = function(e, t) {
  for (var r = 0; r < e.length; r += 1)
    if (e[r].target === t)
      return r;
  return -1;
}, _s = function() {
  function e() {
  }
  return e.connect = function(t, r) {
    var n = new rz(t, r);
    Rs.set(t, n);
  }, e.observe = function(t, r, n) {
    var o = Rs.get(t), i = o.observationTargets.length === 0;
    Hv(o.observationTargets, r) < 0 && (i && ti.push(o), o.observationTargets.push(new tz(r, n && n.box)), Uv(1), Zf.schedule());
  }, e.unobserve = function(t, r) {
    var n = Rs.get(t), o = Hv(n.observationTargets, r), i = n.observationTargets.length === 1;
    o >= 0 && (i && ti.splice(ti.indexOf(n), 1), n.observationTargets.splice(o, 1), Uv(-1));
  }, e.disconnect = function(t) {
    var r = this, n = Rs.get(t);
    n.observationTargets.slice().forEach(function(o) {
      return r.unobserve(t, o.target);
    }), n.activeTargets.splice(0, n.activeTargets.length);
  }, e;
}(), nz = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    _s.connect(this, t);
  }
  return e.prototype.observe = function(t, r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!jv(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    _s.observe(this, t, r);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!jv(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    _s.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    _s.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
let oz = class {
  constructor() {
    this.handleResize = this.handleResize.bind(this), this.observer = new (typeof window < "u" && window.ResizeObserver || nz)(this.handleResize), this.elHandlersMap = /* @__PURE__ */ new Map();
  }
  handleResize(t) {
    for (const r of t) {
      const n = this.elHandlersMap.get(r.target);
      n !== void 0 && n(r);
    }
  }
  registerHandler(t, r) {
    this.elHandlersMap.set(t, r), this.observer.observe(t);
  }
  unregisterHandler(t) {
    this.elHandlersMap.has(t) && (this.elHandlersMap.delete(t), this.observer.unobserve(t));
  }
};
const ju = new oz();
function Yv(e, t) {
  console.error(`[vueuc/${e}]: ${t}`);
}
const sa = Z({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(e) {
    let t = !1;
    const r = xa().proxy;
    function n(o) {
      const { onResize: i } = e;
      i !== void 0 && i(o);
    }
    et(() => {
      const o = r.$el;
      if (o === void 0) {
        Yv("resize-observer", "$el does not exist.");
        return;
      }
      if (o.nextElementSibling !== o.nextSibling && o.nodeType === 3 && o.nodeValue !== "") {
        Yv("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      o.nextElementSibling !== null && (ju.registerHandler(o.nextElementSibling, n), t = !0);
    }), vt(() => {
      t && ju.unregisterHandler(r.$el.nextElementSibling);
    });
  },
  render() {
    return Re(this.$slots, "default");
  }
}), iz = Object.assign(Object.assign({}, Ve.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  /** @deprecated */
  color: String
}), Wv = Z({
  name: "Avatar",
  props: iz,
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      inlineThemeDisabled: r
    } = Bt(e), n = L(!1);
    let o = null;
    const i = L(null), a = L(null), l = () => {
      const {
        value: M
      } = i;
      if (M && (o === null || o !== M.innerHTML)) {
        o = M.innerHTML;
        const {
          value: x
        } = a;
        if (x) {
          const {
            offsetWidth: b,
            offsetHeight: T
          } = x, {
            offsetWidth: w,
            offsetHeight: y
          } = M, I = 0.9, D = Math.min(b / w * I, T / y * I, 1);
          M.style.transform = `translateX(-50%) translateY(-50%) scale(${D})`;
        }
      }
    }, s = De(L$, null), c = W(() => {
      const {
        size: M
      } = e;
      if (M)
        return M;
      const {
        size: x
      } = s || {};
      return x || "medium";
    }), u = Ve("Avatar", "-avatar", $$, j$, e, t), d = De(px, null), f = W(() => {
      if (s)
        return !0;
      const {
        round: M,
        circle: x
      } = e;
      return M !== void 0 || x !== void 0 ? M || x : d ? d.roundRef.value : !1;
    }), p = W(() => s ? !0 : e.bordered || !1), h = W(() => {
      const M = c.value, x = f.value, b = p.value, {
        color: T
      } = e, {
        self: {
          borderRadius: w,
          fontSize: y,
          color: I,
          border: D,
          colorModal: O,
          colorPopover: $
        },
        common: {
          cubicBezierEaseInOut: z
        }
      } = u.value;
      let Y;
      return typeof M == "number" ? Y = `${M}px` : Y = u.value.self[ve("height", M)], {
        "--n-font-size": y,
        "--n-border": b ? D : "none",
        "--n-border-radius": x ? "50%" : w,
        "--n-color": T || I,
        "--n-color-modal": T || O,
        "--n-color-popover": T || $,
        "--n-bezier": z,
        "--n-merged-size": `var(--n-avatar-size-override, ${Y})`
      };
    }), g = r ? dr("avatar", W(() => {
      const M = c.value, x = f.value, b = p.value, {
        color: T
      } = e;
      let w = "";
      return M && (typeof M == "number" ? w += `a${M}` : w += M[0]), x && (w += "b"), b && (w += "c"), T && (w += Fl(T)), w;
    }), h, e) : void 0, m = L(!e.lazy);
    et(() => {
      if (e.lazy && e.intersectionObserverOptions) {
        let M;
        const x = rr(() => {
          M == null || M(), M = void 0, e.lazy && (M = E$(a.value, e.intersectionObserverOptions, m));
        });
        vt(() => {
          x(), M == null || M();
        });
      }
    }), at(() => {
      var M;
      return e.src || ((M = e.imgProps) === null || M === void 0 ? void 0 : M.src);
    }, () => {
      n.value = !1;
    });
    const v = L(!e.lazy);
    return {
      textRef: i,
      selfRef: a,
      mergedRoundRef: f,
      mergedClsPrefix: t,
      fitTextTransform: l,
      cssVars: r ? void 0 : h,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender,
      hasLoadError: n,
      shouldStartLoading: m,
      loaded: v,
      mergedOnError: (M) => {
        if (!m.value)
          return;
        n.value = !0;
        const {
          onError: x,
          imgProps: {
            onError: b
          } = {}
        } = e;
        x == null || x(M), b == null || b(M);
      },
      mergedOnLoad: (M) => {
        const {
          onLoad: x,
          imgProps: {
            onLoad: b
          } = {}
        } = e;
        x == null || x(M), b == null || b(M), v.value = !0;
      }
    };
  },
  render() {
    var e, t;
    const {
      $slots: r,
      src: n,
      mergedClsPrefix: o,
      lazy: i,
      onRender: a,
      loaded: l,
      hasLoadError: s,
      imgProps: c = {}
    } = this;
    a == null || a();
    let u;
    const d = !l && !s && (this.renderPlaceholder ? this.renderPlaceholder() : (t = (e = this.$slots).placeholder) === null || t === void 0 ? void 0 : t.call(e));
    return this.hasLoadError ? u = this.renderFallback ? this.renderFallback() : hn(r.fallback, () => [S("img", {
      src: this.fallbackSrc,
      style: {
        objectFit: this.objectFit
      }
    })]) : u = mt(r.default, (f) => {
      if (f)
        return S(sa, {
          onResize: this.fitTextTransform
        }, {
          default: () => S("span", {
            ref: "textRef",
            class: `${o}-avatar__text`
          }, f)
        });
      if (n || c.src) {
        const p = this.src || c.src;
        return S("img", Object.assign(Object.assign({}, c), {
          loading: (
            // If interseciton observer options is set, do not use native lazy
            D$ && !this.intersectionObserverOptions && i ? "lazy" : "eager"
          ),
          src: i && this.intersectionObserverOptions ? this.shouldStartLoading ? p : void 0 : p,
          "data-image-src": p,
          onLoad: this.mergedOnLoad,
          onError: this.mergedOnError,
          style: [c.style || "", {
            objectFit: this.objectFit
          }, d ? {
            height: "0",
            width: "0",
            visibility: "hidden",
            position: "absolute"
          } : ""]
        }));
      }
    }), S("span", {
      ref: "selfRef",
      class: [`${o}-avatar`, this.themeClass],
      style: this.cssVars
    }, u, i && d);
  }
}), Qv = (e = {}) => ({
  round: !0,
  size: 24,
  style: e
}), gm = (e) => e.imageUrl ? S(Wv, {
  src: e.imageUrl,
  ...Qv({
    flex: "none",
    ...e.avatarClass
  })
}) : S(
  Wv,
  Qv({
    backgroundColor: I$(e.label),
    fontSize: "10px",
    flex: "none",
    ...e.avatarClass
  }),
  {
    default: () => A$(e.label)
  }
), az = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px",
  padding: "4px 0px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, lz = (e) => S(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center"
    }
  },
  [
    gm(e),
    S(
      "div",
      {
        style: az
      },
      [
        S(
          "p",
          {
            style: {
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          [e.label]
        ),
        S(
          "span",
          {
            style: {
              color: e.disabled ? "var(--gray-300)" : "var(--gray-500)"
            }
          },
          {
            default: () => e == null ? void 0 : e.description
          }
        )
      ]
    )
  ]
), sz = (e) => S("div", {}, [S("span", {}, [e.label])]), yx = te("ellipsis", {
  overflow: "hidden"
}, [$t("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), fe("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), fe("cursor-pointer", `
 cursor: pointer;
 `)]), uz = {
  padding: "8px 14px"
}, cz = {
  space: "6px",
  spaceArrow: "10px",
  arrowOffset: "10px",
  arrowOffsetVertical: "10px",
  arrowHeight: "6px",
  padding: "8px 14px"
}, dz = (e) => {
  const {
    boxShadow2: t,
    popoverColor: r,
    textColor2: n,
    borderRadius: o,
    fontSize: i,
    dividerColor: a
  } = e;
  return Object.assign(Object.assign({}, cz), {
    fontSize: i,
    borderRadius: o,
    color: r,
    dividerColor: a,
    textColor: n,
    boxShadow: t
  });
}, fz = {
  name: "Popover",
  common: Jt,
  self: dz
}, mm = fz, pz = (e) => {
  const {
    borderRadius: t,
    boxShadow2: r,
    baseColor: n
  } = e;
  return Object.assign(Object.assign({}, uz), {
    borderRadius: t,
    boxShadow: r,
    color: ei(n, "rgba(0, 0, 0, .85)"),
    textColor: n
  });
}, hz = {
  name: "Tooltip",
  common: Jt,
  peers: {
    Popover: mm
  },
  self: pz
}, xx = hz, gz = {
  name: "Ellipsis",
  common: Jt,
  peers: {
    Tooltip: xx
  }
}, mz = gz, vm = "n-drawer-body", bm = "n-modal-body", vz = "n-modal-provider", wx = "n-modal", Mm = "n-popover-body";
var bz = "__lodash_hash_undefined__";
function Mz(e) {
  return this.__data__.set(e, bz), this;
}
function yz(e) {
  return this.__data__.has(e);
}
function Hl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new ro(); ++t < r; )
    this.add(e[t]);
}
Hl.prototype.add = Hl.prototype.push = Mz;
Hl.prototype.has = yz;
function xz(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function Tx(e, t) {
  return e.has(t);
}
var wz = 1, Tz = 2;
function Nx(e, t, r, n, o, i) {
  var a = r & wz, l = e.length, s = t.length;
  if (l != s && !(a && s > l))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, p = r & Tz ? new Hl() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < l; ) {
    var h = e[d], g = t[d];
    if (n)
      var m = a ? n(g, h, d, t, e, i) : n(h, g, d, e, t, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!xz(t, function(v, M) {
        if (!Tx(p, M) && (h === v || o(h, v, r, n, i)))
          return p.push(M);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === g || o(h, g, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
function Nz(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, o) {
    r[++t] = [o, n];
  }), r;
}
function ym(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Sz = 1, Cz = 2, Iz = "[object Boolean]", Az = "[object Date]", Dz = "[object Error]", kz = "[object Map]", Ez = "[object Number]", Lz = "[object RegExp]", $z = "[object Set]", zz = "[object String]", Oz = "[object Symbol]", jz = "[object ArrayBuffer]", Rz = "[object DataView]", Vv = So ? So.prototype : void 0, Ld = Vv ? Vv.valueOf : void 0;
function _z(e, t, r, n, o, i, a) {
  switch (r) {
    case Rz:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case jz:
      return !(e.byteLength != t.byteLength || !i(new $u(e), new $u(t)));
    case Iz:
    case Az:
    case Ez:
      return fs(+e, +t);
    case Dz:
      return e.name == t.name && e.message == t.message;
    case Lz:
    case zz:
      return e == t + "";
    case kz:
      var l = Nz;
    case $z:
      var s = n & Sz;
      if (l || (l = ym), e.size != t.size && !s)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      n |= Cz, a.set(e, t);
      var u = Nx(l(e), l(t), n, o, i, a);
      return a.delete(e), u;
    case Oz:
      if (Ld)
        return Ld.call(e) == Ld.call(t);
  }
  return !1;
}
var Pz = 1, Bz = Object.prototype, Fz = Bz.hasOwnProperty;
function Uz(e, t, r, n, o, i) {
  var a = r & Pz, l = Nv(e), s = l.length, c = Nv(t), u = c.length;
  if (s != u && !a)
    return !1;
  for (var d = s; d--; ) {
    var f = l[d];
    if (!(a ? f in t : Fz.call(t, f)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var m = a; ++d < s; ) {
    f = l[d];
    var v = e[f], M = t[f];
    if (n)
      var x = a ? n(M, v, f, t, e, i) : n(v, M, f, e, t, i);
    if (!(x === void 0 ? v === M || o(v, M, r, n, i) : x)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var b = e.constructor, T = t.constructor;
    b != T && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof T == "function" && T instanceof T) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var Hz = 1, Zv = "[object Arguments]", Gv = "[object Array]", Ps = "[object Object]", Yz = Object.prototype, Kv = Yz.hasOwnProperty;
function Wz(e, t, r, n, o, i) {
  var a = an(e), l = an(t), s = a ? Gv : kv(e), c = l ? Gv : kv(t);
  s = s == Zv ? Ps : s, c = c == Zv ? Ps : c;
  var u = s == Ps, d = c == Ps, f = s == c;
  if (f && Ou(e)) {
    if (!Ou(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new Ln()), a || am(e) ? Nx(e, t, r, n, o, i) : _z(e, t, s, r, n, o, i);
  if (!(r & Hz)) {
    var p = u && Kv.call(e, "__wrapped__"), h = d && Kv.call(t, "__wrapped__");
    if (p || h) {
      var g = p ? e.value() : e, m = h ? t.value() : t;
      return i || (i = new Ln()), o(g, m, r, n, i);
    }
  }
  return f ? (i || (i = new Ln()), Uz(e, t, r, n, o, i)) : !1;
}
function xm(e, t, r, n, o) {
  return e === t ? !0 : e == null || t == null || !Co(e) && !Co(t) ? e !== e && t !== t : Wz(e, t, r, n, xm, o);
}
var Qz = 1, Vz = 2;
function Zz(e, t, r, n) {
  var o = r.length, i = o, a = !n;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var l = r[o];
    if (a && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    l = r[o];
    var s = l[0], c = e[s], u = l[1];
    if (a && l[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var d = new Ln();
      if (n)
        var f = n(c, u, s, e, t, d);
      if (!(f === void 0 ? xm(u, c, Qz | Vz, n, d) : f))
        return !1;
    }
  }
  return !0;
}
function Sx(e) {
  return e === e && !vn(e);
}
function Gz(e) {
  for (var t = fm(e), r = t.length; r--; ) {
    var n = t[r], o = e[n];
    t[r] = [n, o, Sx(o)];
  }
  return t;
}
function Cx(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Kz(e) {
  var t = Gz(e);
  return t.length == 1 && t[0][2] ? Cx(t[0][0], t[0][1]) : function(r) {
    return r === e || Zz(r, e, t);
  };
}
var qz = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Jz = /^\w*$/;
function wm(e, t) {
  if (an(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Wc(e) ? !0 : Jz.test(e) || !qz.test(e) || t != null && e in Object(t);
}
var Xz = "Expected a function";
function Tm(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Xz);
  var r = function() {
    var n = arguments, o = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, n);
    return r.cache = i.set(o, a) || i, a;
  };
  return r.cache = new (Tm.Cache || ro)(), r;
}
Tm.Cache = ro;
var eO = 500;
function tO(e) {
  var t = Tm(e, function(n) {
    return r.size === eO && r.clear(), n;
  }), r = t.cache;
  return t;
}
var rO = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, nO = /\\(\\)?/g, oO = tO(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(rO, function(r, n, o, i) {
    t.push(o ? i.replace(nO, "$1") : n || r);
  }), t;
});
const iO = oO;
function Ix(e, t) {
  return an(e) ? e : wm(e, t) ? [e] : iO(fx(e));
}
var aO = 1 / 0;
function Qc(e) {
  if (typeof e == "string" || Wc(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -aO ? "-0" : t;
}
function Ax(e, t) {
  t = Ix(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Qc(t[r++])];
  return r && r == n ? e : void 0;
}
function Nm(e, t, r) {
  var n = e == null ? void 0 : Ax(e, t);
  return n === void 0 ? r : n;
}
function lO(e, t) {
  return e != null && t in Object(e);
}
function sO(e, t, r) {
  t = Ix(t, e);
  for (var n = -1, o = t.length, i = !1; ++n < o; ) {
    var a = Qc(t[n]);
    if (!(i = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return i || ++n != o ? i : (o = e == null ? 0 : e.length, !!o && im(o) && lm(a, o) && (an(e) || zu(e)));
}
function uO(e, t) {
  return e != null && sO(e, t, lO);
}
var cO = 1, dO = 2;
function fO(e, t) {
  return wm(e) && Sx(t) ? Cx(Qc(e), t) : function(r) {
    var n = Nm(r, e);
    return n === void 0 && n === t ? uO(r, e) : xm(t, n, cO | dO);
  };
}
function pO(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function hO(e) {
  return function(t) {
    return Ax(t, e);
  };
}
function gO(e) {
  return wm(e) ? pO(Qc(e)) : hO(e);
}
function Dx(e) {
  return typeof e == "function" ? e : e == null ? sm : typeof e == "object" ? an(e) ? fO(e[0], e[1]) : Kz(e) : gO(e);
}
function mO(e, t) {
  return e && F1(e, t, fm);
}
function vO(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Ca(r))
      return e(r, n);
    for (var o = r.length, i = t ? o : -1, a = Object(r); (t ? i-- : ++i < o) && n(a[i], i, a) !== !1; )
      ;
    return r;
  };
}
var bO = vO(mO);
const MO = bO;
function yO(e, t) {
  var r = -1, n = Ca(e) ? Array(e.length) : [];
  return MO(e, function(o, i, a) {
    n[++r] = t(o, i, a);
  }), n;
}
function xO(e, t) {
  var r = an(e) ? cx : yO;
  return r(e, Dx(t));
}
const $d = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Yt = "var(--n-arrow-height) * 1.414", wO = V([te("popover", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 position: relative;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 box-shadow: var(--n-box-shadow);
 word-break: break-word;
 `, [V(">", [te("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), $t("raw", `
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 `, [$t("scrollable", [$t("show-header-or-footer", "padding: var(--n-padding);")])]), F("header", `
 padding: var(--n-padding);
 border-bottom: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), F("footer", `
 padding: var(--n-padding);
 border-top: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), fe("scrollable, show-header-or-footer", [F("content", `
 padding: var(--n-padding);
 `)])]), te("popover-shared", `
 transform-origin: inherit;
 `, [
  te("popover-arrow-wrapper", `
 position: absolute;
 overflow: hidden;
 pointer-events: none;
 `, [te("popover-arrow", `
 transition: background-color .3s var(--n-bezier);
 position: absolute;
 display: block;
 width: calc(${Yt});
 height: calc(${Yt});
 box-shadow: 0 0 8px 0 rgba(0, 0, 0, .12);
 transform: rotate(45deg);
 background-color: var(--n-color);
 pointer-events: all;
 `)]),
  // body transition
  V("&.popover-transition-enter-from, &.popover-transition-leave-to", `
 opacity: 0;
 transform: scale(.85);
 `),
  V("&.popover-transition-enter-to, &.popover-transition-leave-from", `
 transform: scale(1);
 opacity: 1;
 `),
  V("&.popover-transition-enter-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-out),
 transform .15s var(--n-bezier-ease-out);
 `),
  V("&.popover-transition-leave-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-in),
 transform .15s var(--n-bezier-ease-in);
 `)
]), Vr("top-start", `
 top: calc(${Yt} / -2);
 left: calc(${Hn("top-start")} - var(--v-offset-left));
 `), Vr("top", `
 top: calc(${Yt} / -2);
 transform: translateX(calc(${Yt} / -2)) rotate(45deg);
 left: 50%;
 `), Vr("top-end", `
 top: calc(${Yt} / -2);
 right: calc(${Hn("top-end")} + var(--v-offset-left));
 `), Vr("bottom-start", `
 bottom: calc(${Yt} / -2);
 left: calc(${Hn("bottom-start")} - var(--v-offset-left));
 `), Vr("bottom", `
 bottom: calc(${Yt} / -2);
 transform: translateX(calc(${Yt} / -2)) rotate(45deg);
 left: 50%;
 `), Vr("bottom-end", `
 bottom: calc(${Yt} / -2);
 right: calc(${Hn("bottom-end")} + var(--v-offset-left));
 `), Vr("left-start", `
 left: calc(${Yt} / -2);
 top: calc(${Hn("left-start")} - var(--v-offset-top));
 `), Vr("left", `
 left: calc(${Yt} / -2);
 transform: translateY(calc(${Yt} / -2)) rotate(45deg);
 top: 50%;
 `), Vr("left-end", `
 left: calc(${Yt} / -2);
 bottom: calc(${Hn("left-end")} + var(--v-offset-top));
 `), Vr("right-start", `
 right: calc(${Yt} / -2);
 top: calc(${Hn("right-start")} - var(--v-offset-top));
 `), Vr("right", `
 right: calc(${Yt} / -2);
 transform: translateY(calc(${Yt} / -2)) rotate(45deg);
 top: 50%;
 `), Vr("right-end", `
 right: calc(${Yt} / -2);
 bottom: calc(${Hn("right-end")} + var(--v-offset-top));
 `), ...xO({
  top: ["right-start", "left-start"],
  right: ["top-end", "bottom-end"],
  bottom: ["right-end", "left-end"],
  left: ["top-start", "bottom-start"]
}, (e, t) => {
  const r = ["right", "left"].includes(t), n = r ? "width" : "height";
  return e.map((o) => {
    const i = o.split("-")[1] === "end", a = `calc((${`var(--v-target-${n}, 0px)`} - ${Yt}) / 2)`, l = Hn(o);
    return V(`[v-placement="${o}"] >`, [te("popover-shared", [fe("center-arrow", [te("popover-arrow", `${t}: calc(max(${a}, ${l}) ${i ? "+" : "-"} var(--v-offset-${r ? "left" : "top"}));`)])])]);
  });
})]);
function Hn(e) {
  return ["top", "bottom"].includes(e.split("-")[0]) ? "var(--n-arrow-offset)" : "var(--n-arrow-offset-vertical)";
}
function Vr(e, t) {
  const r = e.split("-")[0], n = ["top", "bottom"].includes(r) ? "height: var(--n-space-arrow);" : "width: var(--n-space-arrow);";
  return V(`[v-placement="${e}"] >`, [te("popover-shared", `
 margin-${$d[r]}: var(--n-space);
 `, [fe("show-arrow", `
 margin-${$d[r]}: var(--n-space-arrow);
 `), fe("overlap", `
 margin: 0;
 `), r2("popover-arrow-wrapper", `
 right: 0;
 left: 0;
 top: 0;
 bottom: 0;
 ${r}: 100%;
 ${$d[r]}: auto;
 ${n}
 `, [te("popover-arrow", t)])])]);
}
let zd;
function TO() {
  return zd === void 0 && (zd = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), zd;
}
function vu(e) {
  return e.composedPath()[0];
}
const NO = {
  mousemoveoutside: /* @__PURE__ */ new WeakMap(),
  clickoutside: /* @__PURE__ */ new WeakMap()
};
function SO(e, t, r) {
  if (e === "mousemoveoutside") {
    const n = (o) => {
      t.contains(vu(o)) || r(o);
    };
    return {
      mousemove: n,
      touchstart: n
    };
  } else if (e === "clickoutside") {
    let n = !1;
    const o = (a) => {
      n = !t.contains(vu(a));
    }, i = (a) => {
      n && (t.contains(vu(a)) || r(a));
    };
    return {
      mousedown: o,
      mouseup: i,
      touchstart: o,
      touchend: i
    };
  }
  return console.error(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `[evtd/create-trap-handler]: name \`${e}\` is invalid. This could be a bug of evtd.`
  ), {};
}
function kx(e, t, r) {
  const n = NO[e];
  let o = n.get(t);
  o === void 0 && n.set(t, o = /* @__PURE__ */ new WeakMap());
  let i = o.get(r);
  return i === void 0 && o.set(r, i = SO(e, t, r)), i;
}
function CO(e, t, r, n) {
  if (e === "mousemoveoutside" || e === "clickoutside") {
    const o = kx(e, t, r);
    return Object.keys(o).forEach((i) => {
      zt(i, document, o[i], n);
    }), !0;
  }
  return !1;
}
function IO(e, t, r, n) {
  if (e === "mousemoveoutside" || e === "clickoutside") {
    const o = kx(e, t, r);
    return Object.keys(o).forEach((i) => {
      It(i, document, o[i], n);
    }), !0;
  }
  return !1;
}
function AO() {
  if (typeof window > "u")
    return {
      on: () => {
      },
      off: () => {
      }
    };
  const e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  function r() {
    e.set(this, !0);
  }
  function n() {
    e.set(this, !0), t.set(this, !0);
  }
  function o(y, I, D) {
    const O = y[I];
    return y[I] = function() {
      return D.apply(y, arguments), O.apply(y, arguments);
    }, y;
  }
  function i(y, I) {
    y[I] = Event.prototype[I];
  }
  const a = /* @__PURE__ */ new WeakMap(), l = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");
  function s() {
    var y;
    return (y = a.get(this)) !== null && y !== void 0 ? y : null;
  }
  function c(y, I) {
    l !== void 0 && Object.defineProperty(y, "currentTarget", {
      configurable: !0,
      enumerable: !0,
      get: I ?? l.get
    });
  }
  const u = {
    bubble: {},
    capture: {}
  }, d = {};
  function f() {
    const y = function(I) {
      const { type: D, eventPhase: O, bubbles: $ } = I, z = vu(I);
      if (O === 2)
        return;
      const Y = O === 1 ? "capture" : "bubble";
      let j = z;
      const q = [];
      for (; j === null && (j = window), q.push(j), j !== window; )
        j = j.parentNode || null;
      const ee = u.capture[D], re = u.bubble[D];
      if (o(I, "stopPropagation", r), o(I, "stopImmediatePropagation", n), c(I, s), Y === "capture") {
        if (ee === void 0)
          return;
        for (let le = q.length - 1; le >= 0 && !e.has(I); --le) {
          const ye = q[le], Me = ee.get(ye);
          if (Me !== void 0) {
            a.set(I, ye);
            for (const Ee of Me) {
              if (t.has(I))
                break;
              Ee(I);
            }
          }
          if (le === 0 && !$ && re !== void 0) {
            const Ee = re.get(ye);
            if (Ee !== void 0)
              for (const ne of Ee) {
                if (t.has(I))
                  break;
                ne(I);
              }
          }
        }
      } else if (Y === "bubble") {
        if (re === void 0)
          return;
        for (let le = 0; le < q.length && !e.has(I); ++le) {
          const ye = q[le], Me = re.get(ye);
          if (Me !== void 0) {
            a.set(I, ye);
            for (const Ee of Me) {
              if (t.has(I))
                break;
              Ee(I);
            }
          }
        }
      }
      i(I, "stopPropagation"), i(I, "stopImmediatePropagation"), c(I);
    };
    return y.displayName = "evtdUnifiedHandler", y;
  }
  function p() {
    const y = function(I) {
      const { type: D, eventPhase: O } = I;
      if (O !== 2)
        return;
      const $ = d[D];
      $ !== void 0 && $.forEach((z) => z(I));
    };
    return y.displayName = "evtdUnifiedWindowEventHandler", y;
  }
  const h = f(), g = p();
  function m(y, I) {
    const D = u[y];
    return D[I] === void 0 && (D[I] = /* @__PURE__ */ new Map(), window.addEventListener(I, h, y === "capture")), D[I];
  }
  function v(y) {
    return d[y] === void 0 && (d[y] = /* @__PURE__ */ new Set(), window.addEventListener(y, g)), d[y];
  }
  function M(y, I) {
    let D = y.get(I);
    return D === void 0 && y.set(I, D = /* @__PURE__ */ new Set()), D;
  }
  function x(y, I, D, O) {
    const $ = u[I][D];
    if ($ !== void 0) {
      const z = $.get(y);
      if (z !== void 0 && z.has(O))
        return !0;
    }
    return !1;
  }
  function b(y, I) {
    const D = d[y];
    return !!(D !== void 0 && D.has(I));
  }
  function T(y, I, D, O) {
    let $;
    if (typeof O == "object" && O.once === !0 ? $ = (q) => {
      w(y, I, $, O), D(q);
    } : $ = D, CO(y, I, $, O))
      return;
    const z = O === !0 || typeof O == "object" && O.capture === !0 ? "capture" : "bubble", Y = m(z, y), j = M(Y, I);
    if (j.has($) || j.add($), I === window) {
      const q = v(y);
      q.has($) || q.add($);
    }
  }
  function w(y, I, D, O) {
    if (IO(y, I, D, O))
      return;
    const $ = O === !0 || typeof O == "object" && O.capture === !0, z = $ ? "capture" : "bubble", Y = m(z, y), j = M(Y, I);
    if (I === window && !x(I, $ ? "bubble" : "capture", y, D) && b(y, D)) {
      const q = d[y];
      q.delete(D), q.size === 0 && (window.removeEventListener(y, g), d[y] = void 0);
    }
    j.has(D) && j.delete(D), j.size === 0 && Y.delete(I), Y.size === 0 && (window.removeEventListener(y, h, z === "capture"), u[z][y] = void 0);
  }
  return {
    on: T,
    off: w
  };
}
const { on: zt, off: It } = AO(), zi = "@@coContext", DO = {
  mounted(e, { value: t, modifiers: r }) {
    e[zi] = {
      handler: void 0
    }, typeof t == "function" && (e[zi].handler = t, zt("clickoutside", e, t, {
      capture: r.capture
    }));
  },
  updated(e, { value: t, modifiers: r }) {
    const n = e[zi];
    typeof t == "function" ? n.handler ? n.handler !== t && (It("clickoutside", e, n.handler, {
      capture: r.capture
    }), n.handler = t, zt("clickoutside", e, t, {
      capture: r.capture
    })) : (e[zi].handler = t, zt("clickoutside", e, t, {
      capture: r.capture
    })) : n.handler && (It("clickoutside", e, n.handler, {
      capture: r.capture
    }), n.handler = void 0);
  },
  unmounted(e, { modifiers: t }) {
    const { handler: r } = e[zi];
    r && It("clickoutside", e, r, {
      capture: t.capture
    }), e[zi].handler = void 0;
  }
}, Yl = DO, Oi = "@@mmoContext", kO = {
  mounted(e, { value: t }) {
    e[Oi] = {
      handler: void 0
    }, typeof t == "function" && (e[Oi].handler = t, zt("mousemoveoutside", e, t));
  },
  updated(e, { value: t }) {
    const r = e[Oi];
    typeof t == "function" ? r.handler ? r.handler !== t && (It("mousemoveoutside", e, r.handler), r.handler = t, zt("mousemoveoutside", e, t)) : (e[Oi].handler = t, zt("mousemoveoutside", e, t)) : r.handler && (It("mousemoveoutside", e, r.handler), r.handler = void 0);
  },
  unmounted(e) {
    const { handler: t } = e[Oi];
    t && It("mousemoveoutside", e, t), e[Oi].handler = void 0;
  }
}, EO = kO, LO = /^(\d|\.)+$/, qv = /(\d|\.)+/;
function qi(e, {
  c: t = 1,
  offset: r = 0,
  attachPx: n = !0
} = {}) {
  if (typeof e == "number") {
    const o = (e + r) * t;
    return o === 0 ? "0" : `${o}px`;
  } else if (typeof e == "string")
    if (LO.test(e)) {
      const o = (Number(e) + r) * t;
      return n ? o === 0 ? "0" : `${o}px` : `${o}`;
    } else {
      const o = qv.exec(e);
      return o ? e.replace(qv, String((Number(o[0]) + r) * t)) : e;
    }
  return e;
}
function Wl(e) {
  return e.composedPath()[0] || null;
}
const Sm = "n-internal-select-menu", Ex = "n-internal-select-menu-body", Lx = "__disabled__";
function Xn(e) {
  const t = De(bm, null), r = De(vm, null), n = De(Mm, null), o = De(Ex, null), i = L();
  if (typeof document < "u") {
    i.value = document.fullscreenElement;
    const a = () => {
      i.value = document.fullscreenElement;
    };
    et(() => {
      zt("fullscreenchange", document, a);
    }), vt(() => {
      It("fullscreenchange", document, a);
    });
  }
  return _t(() => {
    var a;
    const {
      to: l
    } = e;
    return l !== void 0 ? l === !1 ? Lx : l === !0 ? i.value || "body" : l : t != null && t.value ? (a = t.value.$el) !== null && a !== void 0 ? a : t.value : r != null && r.value ? r.value : n != null && n.value ? n.value : o != null && o.value ? o.value : l ?? (i.value || "body");
  });
}
Xn.tdkey = Lx;
Xn.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
function Gf(e, t, r = "default") {
  const n = t[r];
  if (n === void 0)
    throw new Error(`[vueuc/${e}]: slot[${r}] is empty.`);
  return n();
}
function Kf(e, t = !0, r = []) {
  return e.forEach((n) => {
    if (n !== null) {
      if (typeof n != "object") {
        (typeof n == "string" || typeof n == "number") && r.push(Qt(String(n)));
        return;
      }
      if (Array.isArray(n)) {
        Kf(n, t, r);
        return;
      }
      if (n.type === qt) {
        if (n.children === null)
          return;
        Array.isArray(n.children) && Kf(n.children, t, r);
      } else
        n.type !== qg && r.push(n);
    }
  }), r;
}
function Jv(e, t, r = "default") {
  const n = t[r];
  if (n === void 0)
    throw new Error(`[vueuc/${e}]: slot[${r}] is empty.`);
  const o = Kf(n());
  if (o.length === 1)
    return o[0];
  throw new Error(`[vueuc/${e}]: slot[${r}] should have exactly one child.`);
}
function $O(e) {
  const t = L(!!e.value);
  if (t.value)
    return ui(t);
  const r = at(e, (n) => {
    n && (t.value = !0, r());
  });
  return ui(t);
}
const $x = Z({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    return {
      showTeleport: $O(We(e, "show")),
      mergedTo: W(() => {
        const { to: t } = e;
        return t ?? "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? Gf("lazy-teleport", this.$slots) : S(N1, {
      disabled: this.disabled,
      to: this.mergedTo
    }, Gf("lazy-teleport", this.$slots)) : null;
  }
}), Bs = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Xv = {
  start: "end",
  center: "center",
  end: "start"
}, Od = {
  top: "height",
  bottom: "height",
  left: "width",
  right: "width"
}, zO = {
  "bottom-start": "top left",
  bottom: "top center",
  "bottom-end": "top right",
  "top-start": "bottom left",
  top: "bottom center",
  "top-end": "bottom right",
  "right-start": "top left",
  right: "center left",
  "right-end": "bottom left",
  "left-start": "top right",
  left: "center right",
  "left-end": "bottom right"
}, OO = {
  "bottom-start": "bottom left",
  bottom: "bottom center",
  "bottom-end": "bottom right",
  "top-start": "top left",
  top: "top center",
  "top-end": "top right",
  "right-start": "top right",
  right: "center right",
  "right-end": "bottom right",
  "left-start": "top left",
  left: "center left",
  "left-end": "bottom left"
}, jO = {
  "bottom-start": "right",
  "bottom-end": "left",
  "top-start": "right",
  "top-end": "left",
  "right-start": "bottom",
  "right-end": "top",
  "left-start": "bottom",
  "left-end": "top"
}, eb = {
  top: !0,
  bottom: !1,
  left: !0,
  right: !1
  // left--
}, tb = {
  top: "end",
  bottom: "start",
  left: "end",
  right: "start"
};
function RO(e, t, r, n, o, i) {
  if (!o || i)
    return { placement: e, top: 0, left: 0 };
  const [a, l] = e.split("-");
  let s = l ?? "center", c = {
    top: 0,
    left: 0
  };
  const u = (p, h, g) => {
    let m = 0, v = 0;
    const M = r[p] - t[h] - t[p];
    return M > 0 && n && (g ? v = eb[h] ? M : -M : m = eb[h] ? M : -M), {
      left: m,
      top: v
    };
  }, d = a === "left" || a === "right";
  if (s !== "center") {
    const p = jO[e], h = Bs[p], g = Od[p];
    if (r[g] > t[g]) {
      if (
        // current space is not enough
        // ----------[ target ]---------|
        // -------[     follower        ]
        t[p] + t[g] < r[g]
      ) {
        const m = (r[g] - t[g]) / 2;
        t[p] < m || t[h] < m ? t[p] < t[h] ? (s = Xv[l], c = u(g, h, d)) : c = u(g, p, d) : s = "center";
      }
    } else
      r[g] < t[g] && t[h] < 0 && // opposite align has larger space
      // ------------[   target   ]
      // ----------------[follower]
      t[p] > t[h] && (s = Xv[l]);
  } else {
    const p = a === "bottom" || a === "top" ? "left" : "top", h = Bs[p], g = Od[p], m = (r[g] - t[g]) / 2;
    (t[p] < m || t[h] < m) && (t[p] > t[h] ? (s = tb[p], c = u(g, p, d)) : (s = tb[h], c = u(g, h, d)));
  }
  let f = a;
  return (
    // space is not enough
    t[a] < r[Od[a]] && // opposite position's space is larger
    t[a] < t[Bs[a]] && (f = Bs[a]), {
      placement: s !== "center" ? `${f}-${s}` : f,
      left: c.left,
      top: c.top
    }
  );
}
function _O(e, t) {
  return t ? OO[e] : zO[e];
}
function PO(e, t, r, n, o, i) {
  if (i)
    switch (e) {
      case "bottom-start":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-100%)"
        };
      case "bottom-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "top-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: ""
        };
      case "top-end":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "left-start":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: ""
        };
      case "left-end":
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-100%)"
        };
      case "top":
        return {
          top: `${Math.round(r.top - t.top)}px`,
          left: `${Math.round(r.left - t.left + r.width / 2)}px`,
          transform: "translateX(-50%)"
        };
      case "right":
        return {
          top: `${Math.round(r.top - t.top + r.height / 2)}px`,
          left: `${Math.round(r.left - t.left + r.width)}px`,
          transform: "translateX(-100%) translateY(-50%)"
        };
      case "left":
        return {
          top: `${Math.round(r.top - t.top + r.height / 2)}px`,
          left: `${Math.round(r.left - t.left)}px`,
          transform: "translateY(-50%)"
        };
      case "bottom":
      default:
        return {
          top: `${Math.round(r.top - t.top + r.height)}px`,
          left: `${Math.round(r.left - t.left + r.width / 2)}px`,
          transform: "translateX(-50%) translateY(-100%)"
        };
    }
  switch (e) {
    case "bottom-start":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + o)}px`,
        transform: ""
      };
    case "bottom-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + o)}px`,
        transform: "translateX(-100%)"
      };
    case "top-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + o)}px`,
        transform: "translateY(-100%)"
      };
    case "top-end":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + o)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "right-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + o)}px`,
        transform: ""
      };
    case "right-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + o)}px`,
        transform: "translateY(-100%)"
      };
    case "left-start":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + o)}px`,
        transform: "translateX(-100%)"
      };
    case "left-end":
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + o)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "top":
      return {
        top: `${Math.round(r.top - t.top + n)}px`,
        left: `${Math.round(r.left - t.left + r.width / 2 + o)}px`,
        transform: "translateY(-100%) translateX(-50%)"
      };
    case "right":
      return {
        top: `${Math.round(r.top - t.top + r.height / 2 + n)}px`,
        left: `${Math.round(r.left - t.left + r.width + o)}px`,
        transform: "translateY(-50%)"
      };
    case "left":
      return {
        top: `${Math.round(r.top - t.top + r.height / 2 + n)}px`,
        left: `${Math.round(r.left - t.left + o)}px`,
        transform: "translateY(-50%) translateX(-100%)"
      };
    case "bottom":
    default:
      return {
        top: `${Math.round(r.top - t.top + r.height + n)}px`,
        left: `${Math.round(r.left - t.left + r.width / 2 + o)}px`,
        transform: "translateX(-50%)"
      };
  }
}
let co = null;
function zx() {
  if (co === null && (co = document.getElementById("v-binder-view-measurer"), co === null)) {
    co = document.createElement("div"), co.id = "v-binder-view-measurer";
    const { style: e } = co;
    e.position = "fixed", e.left = "0", e.right = "0", e.top = "0", e.bottom = "0", e.pointerEvents = "none", e.visibility = "hidden", document.body.appendChild(co);
  }
  return co.getBoundingClientRect();
}
function BO(e, t) {
  const r = zx();
  return {
    top: t,
    left: e,
    height: 0,
    width: 0,
    right: r.width - e,
    bottom: r.height - t
  };
}
function jd(e) {
  const t = e.getBoundingClientRect(), r = zx();
  return {
    left: t.left - r.left,
    top: t.top - r.top,
    bottom: r.height + r.top - t.bottom,
    right: r.width + r.left - t.right,
    width: t.width,
    height: t.height
  };
}
function FO(e) {
  return e.nodeType === 9 ? null : e.parentNode;
}
function Ox(e) {
  if (e === null)
    return null;
  const t = FO(e);
  if (t === null)
    return null;
  if (t.nodeType === 9)
    return document;
  if (t.nodeType === 1) {
    const { overflow: r, overflowX: n, overflowY: o } = getComputedStyle(t);
    if (/(auto|scroll|overlay)/.test(r + o + n))
      return t;
  }
  return Ox(t);
}
const { c: bo } = $1(), Cm = "vueuc-style";
function jx() {
  return xa() !== null;
}
const Im = typeof window < "u";
let ul, cl;
const UO = () => {
  var e, t;
  ul = Im ? (t = (e = document) === null || e === void 0 ? void 0 : e.fonts) === null || t === void 0 ? void 0 : t.ready : void 0, cl = !1, ul !== void 0 ? ul.then(() => {
    cl = !0;
  }) : cl = !0;
};
UO();
function HO(e) {
  if (cl)
    return;
  let t = !1;
  et(() => {
    cl || ul == null || ul.then(() => {
      t || e();
    });
  }), vt(() => {
    t = !0;
  });
}
function YO(e, t) {
  console.error(`[vdirs/${e}]: ${t}`);
}
let WO = class {
  constructor() {
    this.elementZIndex = /* @__PURE__ */ new Map(), this.nextZIndex = 2e3;
  }
  get elementCount() {
    return this.elementZIndex.size;
  }
  ensureZIndex(t, r) {
    const { elementZIndex: n } = this;
    if (r !== void 0) {
      t.style.zIndex = `${r}`, n.delete(t);
      return;
    }
    const { nextZIndex: o } = this;
    n.has(t) && n.get(t) + 1 === this.nextZIndex || (t.style.zIndex = `${o}`, n.set(t, o), this.nextZIndex = o + 1, this.squashState());
  }
  unregister(t, r) {
    const { elementZIndex: n } = this;
    n.has(t) ? n.delete(t) : r === void 0 && YO("z-index-manager/unregister-element", "Element not found when unregistering."), this.squashState();
  }
  squashState() {
    const { elementCount: t } = this;
    t || (this.nextZIndex = 2e3), this.nextZIndex - t > 2500 && this.rearrange();
  }
  rearrange() {
    const t = Array.from(this.elementZIndex.entries());
    t.sort((r, n) => r[1] - n[1]), this.nextZIndex = 2e3, t.forEach((r) => {
      const n = r[0], o = this.nextZIndex++;
      `${o}` !== n.style.zIndex && (n.style.zIndex = `${o}`);
    });
  }
};
const Rd = new WO(), ji = "@@ziContext", QO = {
  mounted(e, t) {
    const { value: r = {} } = t, { zIndex: n, enabled: o } = r;
    e[ji] = {
      enabled: !!o,
      initialized: !1
    }, o && (Rd.ensureZIndex(e, n), e[ji].initialized = !0);
  },
  updated(e, t) {
    const { value: r = {} } = t, { zIndex: n, enabled: o } = r, i = e[ji].enabled;
    o && !i && (Rd.ensureZIndex(e, n), e[ji].initialized = !0), e[ji].enabled = !!o;
  },
  unmounted(e, t) {
    if (!e[ji].initialized)
      return;
    const { value: r = {} } = t, { zIndex: n } = r;
    Rd.unregister(e, n);
  }
}, Am = QO, VO = bo([
  bo(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  bo(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    bo("> *", {
      pointerEvents: "all"
    })
  ])
]), Rx = Z({
  name: "Follower",
  inheritAttrs: !1,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: !0
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: !0
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(e) {
    const t = De("VBinder"), r = _t(() => e.enabled !== void 0 ? e.enabled : e.show), n = L(null), o = L(null), i = () => {
      const { syncTrigger: f } = e;
      f.includes("scroll") && t.addScrollListener(s), f.includes("resize") && t.addResizeListener(s);
    }, a = () => {
      t.removeScrollListener(s), t.removeResizeListener(s);
    };
    et(() => {
      r.value && (s(), i());
    });
    const l = bi();
    VO.mount({
      id: "vueuc/binder",
      head: !0,
      anchorMetaName: Cm,
      ssr: l
    }), vt(() => {
      a();
    }), HO(() => {
      r.value && s();
    });
    const s = () => {
      if (!r.value)
        return;
      const f = n.value;
      if (f === null)
        return;
      const p = t.targetRef, { x: h, y: g, overlap: m } = e, v = h !== void 0 && g !== void 0 ? BO(h, g) : jd(p);
      f.style.setProperty("--v-target-width", `${Math.round(v.width)}px`), f.style.setProperty("--v-target-height", `${Math.round(v.height)}px`);
      const { width: M, minWidth: x, placement: b, internalShift: T, flip: w } = e;
      f.setAttribute("v-placement", b), m ? f.setAttribute("v-overlap", "") : f.removeAttribute("v-overlap");
      const { style: y } = f;
      M === "target" ? y.width = `${v.width}px` : M !== void 0 ? y.width = M : y.width = "", x === "target" ? y.minWidth = `${v.width}px` : x !== void 0 ? y.minWidth = x : y.minWidth = "";
      const I = jd(f), D = jd(o.value), { left: O, top: $, placement: z } = RO(b, v, I, T, w, m), Y = _O(z, m), { left: j, top: q, transform: ee } = PO(z, D, v, $, O, m);
      f.setAttribute("v-placement", z), f.style.setProperty("--v-offset-left", `${Math.round(O)}px`), f.style.setProperty("--v-offset-top", `${Math.round($)}px`), f.style.transform = `translateX(${j}) translateY(${q}) ${ee}`, f.style.setProperty("--v-transform-origin", Y), f.style.transformOrigin = Y;
    };
    at(r, (f) => {
      f ? (i(), c()) : a();
    });
    const c = () => {
      mn().then(s).catch((f) => console.error(f));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((f) => {
      at(We(e, f), s);
    }), ["teleportDisabled"].forEach((f) => {
      at(We(e, f), c);
    }), at(We(e, "syncTrigger"), (f) => {
      f.includes("resize") ? t.addResizeListener(s) : t.removeResizeListener(s), f.includes("scroll") ? t.addScrollListener(s) : t.removeScrollListener(s);
    });
    const u = hs(), d = _t(() => {
      const { to: f } = e;
      if (f !== void 0)
        return f;
      u.value;
    });
    return {
      VBinder: t,
      mergedEnabled: r,
      offsetContainerRef: o,
      followerRef: n,
      mergedTo: d,
      syncPosition: s
    };
  },
  render() {
    return S($x, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var e, t;
        const r = S("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          S("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e))
        ]);
        return this.zindexable ? on(r, [
          [
            Am,
            {
              enabled: this.mergedEnabled,
              zIndex: this.zIndex
            }
          ]
        ]) : r;
      }
    });
  }
});
function _x(e) {
  return e instanceof HTMLElement;
}
function Px(e) {
  for (let t = 0; t < e.childNodes.length; t++) {
    const r = e.childNodes[t];
    if (_x(r) && (Fx(r) || Px(r)))
      return !0;
  }
  return !1;
}
function Bx(e) {
  for (let t = e.childNodes.length - 1; t >= 0; t--) {
    const r = e.childNodes[t];
    if (_x(r) && (Fx(r) || Bx(r)))
      return !0;
  }
  return !1;
}
function Fx(e) {
  if (!ZO(e))
    return !1;
  try {
    e.focus({ preventScroll: !0 });
  } catch {
  }
  return document.activeElement === e;
}
function ZO(e) {
  if (e.tabIndex > 0 || e.tabIndex === 0 && e.getAttribute("tabIndex") !== null)
    return !0;
  if (e.getAttribute("disabled"))
    return !1;
  switch (e.nodeName) {
    case "A":
      return !!e.href && e.rel !== "ignore";
    case "INPUT":
      return e.type !== "hidden" && e.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}
function GO(e = 8) {
  return Math.random().toString(16).slice(2, 2 + e);
}
function rb(e) {
  return typeof e == "string" ? document.querySelector(e) : e();
}
function KO(e) {
  return e.composedPath()[0] || null;
}
let Va = [];
const Ux = Z({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: !0
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = GO(), r = L(null), n = L(null);
    let o = !1, i = !1;
    const a = typeof document > "u" ? null : document.activeElement;
    function l() {
      return Va[Va.length - 1] === t;
    }
    function s(m) {
      var v;
      m.code === "Escape" && l() && ((v = e.onEsc) === null || v === void 0 || v.call(e, m));
    }
    et(() => {
      at(() => e.active, (m) => {
        m ? (d(), zt("keydown", document, s)) : (It("keydown", document, s), o && f());
      }, {
        immediate: !0
      });
    }), vt(() => {
      It("keydown", document, s), o && f();
    });
    function c(m) {
      if (!i && l()) {
        const v = u();
        if (v === null || v.contains(KO(m)))
          return;
        p("first");
      }
    }
    function u() {
      const m = r.value;
      if (m === null)
        return null;
      let v = m;
      for (; v = v.nextSibling, !(v === null || v instanceof Element && v.tagName === "DIV"); )
        ;
      return v;
    }
    function d() {
      var m;
      if (!e.disabled) {
        if (Va.push(t), e.autoFocus) {
          const { initialFocusTo: v } = e;
          v === void 0 ? p("first") : (m = rb(v)) === null || m === void 0 || m.focus({ preventScroll: !0 });
        }
        o = !0, document.addEventListener("focus", c, !0);
      }
    }
    function f() {
      var m;
      if (e.disabled || (document.removeEventListener("focus", c, !0), Va = Va.filter((M) => M !== t), l()))
        return;
      const { finalFocusTo: v } = e;
      v !== void 0 ? (m = rb(v)) === null || m === void 0 || m.focus({ preventScroll: !0 }) : e.returnFocusOnDeactivated && a instanceof HTMLElement && (i = !0, a.focus({ preventScroll: !0 }), i = !1);
    }
    function p(m) {
      if (l() && e.active) {
        const v = r.value, M = n.value;
        if (v !== null && M !== null) {
          const x = u();
          if (x == null || x === M) {
            i = !0, v.focus({ preventScroll: !0 }), i = !1;
            return;
          }
          i = !0;
          const b = m === "first" ? Px(x) : Bx(x);
          i = !1, b || (i = !0, v.focus({ preventScroll: !0 }), i = !1);
        }
      }
    }
    function h(m) {
      if (i)
        return;
      const v = u();
      v !== null && (m.relatedTarget !== null && v.contains(m.relatedTarget) ? p("last") : p("first"));
    }
    function g(m) {
      i || (m.relatedTarget !== null && m.relatedTarget === r.value ? p("last") : p("first"));
    }
    return {
      focusableStartRef: r,
      focusableEndRef: n,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus: h,
      handleEndFocus: g
    };
  },
  render() {
    const { default: e } = this.$slots;
    if (e === void 0)
      return null;
    if (this.disabled)
      return e();
    const { active: t, focusableStyle: r } = this;
    return S(qt, null, [
      S("div", {
        "aria-hidden": "true",
        tabindex: t ? "0" : "-1",
        ref: "focusableStartRef",
        style: r,
        onFocus: this.handleStartFocus
      }),
      e(),
      S("div", {
        "aria-hidden": "true",
        style: r,
        ref: "focusableEndRef",
        tabindex: t ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
}), {
  cubicBezierEaseInOut: nb
} = Mi;
function Hx({
  name: e = "fade-in",
  enterDuration: t = "0.2s",
  leaveDuration: r = "0.2s",
  enterCubicBezier: n = nb,
  leaveCubicBezier: o = nb
} = {}) {
  return [V(`&.${e}-transition-enter-active`, {
    transition: `all ${t} ${n}!important`
  }), V(`&.${e}-transition-leave-active`, {
    transition: `all ${r} ${o}!important`
  }), V(`&.${e}-transition-enter-from, &.${e}-transition-leave-to`, {
    opacity: 0
  }), V(`&.${e}-transition-leave-from, &.${e}-transition-enter-to`, {
    opacity: 1
  })];
}
const qO = te("scrollbar", `
 overflow: hidden;
 position: relative;
 z-index: auto;
 height: 100%;
 width: 100%;
`, [V(">", [te("scrollbar-container", `
 width: 100%;
 overflow: scroll;
 height: 100%;
 min-height: inherit;
 max-height: inherit;
 scrollbar-width: none;
 `, [V("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), V(">", [te("scrollbar-content", `
 box-sizing: border-box;
 min-width: 100%;
 `)])])]), V(">, +", [te("scrollbar-rail", `
 position: absolute;
 pointer-events: none;
 user-select: none;
 -webkit-user-select: none;
 `, [fe("horizontal", `
 left: 2px;
 right: 2px;
 bottom: 4px;
 height: var(--n-scrollbar-height);
 `, [V(">", [F("scrollbar", `
 height: var(--n-scrollbar-height);
 border-radius: var(--n-scrollbar-border-radius);
 right: 0;
 `)])]), fe("vertical", `
 right: 4px;
 top: 2px;
 bottom: 2px;
 width: var(--n-scrollbar-width);
 `, [V(">", [F("scrollbar", `
 width: var(--n-scrollbar-width);
 border-radius: var(--n-scrollbar-border-radius);
 bottom: 0;
 `)])]), fe("disabled", [V(">", [F("scrollbar", "pointer-events: none;")])]), V(">", [F("scrollbar", `
 z-index: 1;
 position: absolute;
 cursor: pointer;
 pointer-events: all;
 background-color: var(--n-scrollbar-color);
 transition: background-color .2s var(--n-scrollbar-bezier);
 `, [Hx(), V("&:hover", "background-color: var(--n-scrollbar-color-hover);")])])])])]), JO = (typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
!window.MSStream;
function XO() {
  return JO;
}
function e3(e) {
  const t = {
    isDeactivated: !1
  };
  let r = !1;
  return S1(() => {
    if (t.isDeactivated = !1, !r) {
      r = !0;
      return;
    }
    e();
  }), Jg(() => {
    t.isDeactivated = !0, r || (r = !0);
  }), t;
}
const t3 = (e) => {
  const {
    scrollbarColor: t,
    scrollbarColorHover: r
  } = e;
  return {
    color: t,
    colorHover: r
  };
}, r3 = {
  name: "Scrollbar",
  common: Jt,
  self: t3
}, Dm = r3, qf = Z({
  render() {
    var e, t;
    return (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e);
  }
}), n3 = Object.assign(Object.assign({}, Ve.props), {
  size: {
    type: Number,
    default: 5
  },
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: !0
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  // If container is set, resize observer won't not attached
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: [String, Array],
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean
}), Yx = Z({
  name: "Scrollbar",
  props: n3,
  inheritAttrs: !1,
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      inlineThemeDisabled: r,
      mergedRtlRef: n
    } = Bt(e), o = yn("Scrollbar", n, t), i = L(null), a = L(null), l = L(null), s = L(null), c = L(null), u = L(null), d = L(null), f = L(null), p = L(null), h = L(null), g = L(null), m = L(0), v = L(0), M = L(!1), x = L(!1);
    let b = !1, T = !1, w, y, I = 0, D = 0, O = 0, $ = 0;
    const z = XO(), Y = W(() => {
      const {
        value: P
      } = f, {
        value: k
      } = u, {
        value: U
      } = h;
      return P === null || k === null || U === null ? 0 : Math.min(P, U * P / k + e.size * 1.5);
    }), j = W(() => `${Y.value}px`), q = W(() => {
      const {
        value: P
      } = p, {
        value: k
      } = d, {
        value: U
      } = g;
      return P === null || k === null || U === null ? 0 : U * P / k + e.size * 1.5;
    }), ee = W(() => `${q.value}px`), re = W(() => {
      const {
        value: P
      } = f, {
        value: k
      } = m, {
        value: U
      } = u, {
        value: ie
      } = h;
      if (P === null || U === null || ie === null)
        return 0;
      {
        const xe = U - P;
        return xe ? k / xe * (ie - Y.value) : 0;
      }
    }), le = W(() => `${re.value}px`), ye = W(() => {
      const {
        value: P
      } = p, {
        value: k
      } = v, {
        value: U
      } = d, {
        value: ie
      } = g;
      if (P === null || U === null || ie === null)
        return 0;
      {
        const xe = U - P;
        return xe ? k / xe * (ie - q.value) : 0;
      }
    }), Me = W(() => `${ye.value}px`), Ee = W(() => {
      const {
        value: P
      } = f, {
        value: k
      } = u;
      return P !== null && k !== null && k > P;
    }), ne = W(() => {
      const {
        value: P
      } = p, {
        value: k
      } = d;
      return P !== null && k !== null && k > P;
    }), ue = W(() => {
      const {
        trigger: P
      } = e;
      return P === "none" || M.value;
    }), Ce = W(() => {
      const {
        trigger: P
      } = e;
      return P === "none" || x.value;
    }), ze = W(() => {
      const {
        container: P
      } = e;
      return P ? P() : a.value;
    }), ke = W(() => {
      const {
        content: P
      } = e;
      return P ? P() : l.value;
    }), tt = e3(() => {
      e.container || Ye({
        top: m.value,
        left: v.value
      });
    }), Ge = () => {
      tt.isDeactivated || G();
    }, Ne = (P) => {
      if (tt.isDeactivated)
        return;
      const {
        onResize: k
      } = e;
      k && k(P), G();
    }, Ye = (P, k) => {
      if (!e.scrollable)
        return;
      if (typeof P == "number") {
        _e(P, k ?? 0, 0, !1, "auto");
        return;
      }
      const {
        left: U,
        top: ie,
        index: xe,
        elSize: Ie,
        position: Ae,
        behavior: Le,
        el: rt,
        debounce: At = !0
      } = P;
      (U !== void 0 || ie !== void 0) && _e(U ?? 0, ie ?? 0, 0, !1, Le), rt !== void 0 ? _e(0, rt.offsetTop, rt.offsetHeight, At, Le) : xe !== void 0 && Ie !== void 0 ? _e(0, xe * Ie, Ie, At, Le) : Ae === "bottom" ? _e(0, Number.MAX_SAFE_INTEGER, 0, !1, Le) : Ae === "top" && _e(0, 0, 0, !1, Le);
    }, Se = (P, k) => {
      if (!e.scrollable)
        return;
      const {
        value: U
      } = ze;
      U && (typeof P == "object" ? U.scrollBy(P) : U.scrollBy(P, k || 0));
    };
    function _e(P, k, U, ie, xe) {
      const {
        value: Ie
      } = ze;
      if (Ie) {
        if (ie) {
          const {
            scrollTop: Ae,
            offsetHeight: Le
          } = Ie;
          if (k > Ae) {
            k + U <= Ae + Le || Ie.scrollTo({
              left: P,
              top: k + U - Le,
              behavior: xe
            });
            return;
          }
        }
        Ie.scrollTo({
          left: P,
          top: k,
          behavior: xe
        });
      }
    }
    function Fe() {
      E(), J(), G();
    }
    function ot() {
      Nt();
    }
    function Nt() {
      A(), C();
    }
    function A() {
      y !== void 0 && window.clearTimeout(y), y = window.setTimeout(() => {
        x.value = !1;
      }, e.duration);
    }
    function C() {
      w !== void 0 && window.clearTimeout(w), w = window.setTimeout(() => {
        M.value = !1;
      }, e.duration);
    }
    function E() {
      w !== void 0 && window.clearTimeout(w), M.value = !0;
    }
    function J() {
      y !== void 0 && window.clearTimeout(y), x.value = !0;
    }
    function H(P) {
      const {
        onScroll: k
      } = e;
      k && k(P), X();
    }
    function X() {
      const {
        value: P
      } = ze;
      P && (m.value = P.scrollTop, v.value = P.scrollLeft * (o != null && o.value ? -1 : 1));
    }
    function me() {
      const {
        value: P
      } = ke;
      P && (u.value = P.offsetHeight, d.value = P.offsetWidth);
      const {
        value: k
      } = ze;
      k && (f.value = k.offsetHeight, p.value = k.offsetWidth);
      const {
        value: U
      } = c, {
        value: ie
      } = s;
      U && (g.value = U.offsetWidth), ie && (h.value = ie.offsetHeight);
    }
    function Te() {
      const {
        value: P
      } = ze;
      P && (m.value = P.scrollTop, v.value = P.scrollLeft * (o != null && o.value ? -1 : 1), f.value = P.offsetHeight, p.value = P.offsetWidth, u.value = P.scrollHeight, d.value = P.scrollWidth);
      const {
        value: k
      } = c, {
        value: U
      } = s;
      k && (g.value = k.offsetWidth), U && (h.value = U.offsetHeight);
    }
    function G() {
      e.scrollable && (e.useUnifiedContainer ? Te() : (me(), X()));
    }
    function ae(P) {
      var k;
      return !(!((k = i.value) === null || k === void 0) && k.contains(Wl(P)));
    }
    function Xe(P) {
      P.preventDefault(), P.stopPropagation(), T = !0, zt("mousemove", window, gt, !0), zt("mouseup", window, yt, !0), D = v.value, O = o != null && o.value ? window.innerWidth - P.clientX : P.clientX;
    }
    function gt(P) {
      if (!T)
        return;
      w !== void 0 && window.clearTimeout(w), y !== void 0 && window.clearTimeout(y);
      const {
        value: k
      } = p, {
        value: U
      } = d, {
        value: ie
      } = q;
      if (k === null || U === null)
        return;
      const xe = (o != null && o.value ? window.innerWidth - P.clientX - O : P.clientX - O) * (U - k) / (k - ie), Ie = U - k;
      let Ae = D + xe;
      Ae = Math.min(Ie, Ae), Ae = Math.max(Ae, 0);
      const {
        value: Le
      } = ze;
      if (Le) {
        Le.scrollLeft = Ae * (o != null && o.value ? -1 : 1);
        const {
          internalOnUpdateScrollLeft: rt
        } = e;
        rt && rt(Ae);
      }
    }
    function yt(P) {
      P.preventDefault(), P.stopPropagation(), It("mousemove", window, gt, !0), It("mouseup", window, yt, !0), T = !1, G(), ae(P) && Nt();
    }
    function or(P) {
      P.preventDefault(), P.stopPropagation(), b = !0, zt("mousemove", window, Xt, !0), zt("mouseup", window, jt, !0), I = m.value, $ = P.clientY;
    }
    function Xt(P) {
      if (!b)
        return;
      w !== void 0 && window.clearTimeout(w), y !== void 0 && window.clearTimeout(y);
      const {
        value: k
      } = f, {
        value: U
      } = u, {
        value: ie
      } = Y;
      if (k === null || U === null)
        return;
      const xe = (P.clientY - $) * (U - k) / (k - ie), Ie = U - k;
      let Ae = I + xe;
      Ae = Math.min(Ie, Ae), Ae = Math.max(Ae, 0);
      const {
        value: Le
      } = ze;
      Le && (Le.scrollTop = Ae);
    }
    function jt(P) {
      P.preventDefault(), P.stopPropagation(), It("mousemove", window, Xt, !0), It("mouseup", window, jt, !0), b = !1, G(), ae(P) && Nt();
    }
    rr(() => {
      const {
        value: P
      } = ne, {
        value: k
      } = Ee, {
        value: U
      } = t, {
        value: ie
      } = c, {
        value: xe
      } = s;
      ie && (P ? ie.classList.remove(`${U}-scrollbar-rail--disabled`) : ie.classList.add(`${U}-scrollbar-rail--disabled`)), xe && (k ? xe.classList.remove(`${U}-scrollbar-rail--disabled`) : xe.classList.add(`${U}-scrollbar-rail--disabled`));
    }), et(() => {
      e.container || G();
    }), vt(() => {
      w !== void 0 && window.clearTimeout(w), y !== void 0 && window.clearTimeout(y), It("mousemove", window, Xt, !0), It("mouseup", window, jt, !0);
    });
    const ir = Ve("Scrollbar", "-scrollbar", qO, Dm, e, t), gr = W(() => {
      const {
        common: {
          cubicBezierEaseInOut: P,
          scrollbarBorderRadius: k,
          scrollbarHeight: U,
          scrollbarWidth: ie
        },
        self: {
          color: xe,
          colorHover: Ie
        }
      } = ir.value;
      return {
        "--n-scrollbar-bezier": P,
        "--n-scrollbar-color": xe,
        "--n-scrollbar-color-hover": Ie,
        "--n-scrollbar-border-radius": k,
        "--n-scrollbar-width": ie,
        "--n-scrollbar-height": U
      };
    }), K = r ? dr("scrollbar", void 0, gr, e) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: Ye,
      scrollBy: Se,
      sync: G,
      syncUnifiedContainer: Te,
      handleMouseEnterWrapper: Fe,
      handleMouseLeaveWrapper: ot
    }), {
      mergedClsPrefix: t,
      rtlEnabled: o,
      containerScrollTop: m,
      wrapperRef: i,
      containerRef: a,
      contentRef: l,
      yRailRef: s,
      xRailRef: c,
      needYBar: Ee,
      needXBar: ne,
      yBarSizePx: j,
      xBarSizePx: ee,
      yBarTopPx: le,
      xBarLeftPx: Me,
      isShowXBar: ue,
      isShowYBar: Ce,
      isIos: z,
      handleScroll: H,
      handleContentResize: Ge,
      handleContainerResize: Ne,
      handleYScrollMouseDown: or,
      handleXScrollMouseDown: Xe,
      cssVars: r ? void 0 : gr,
      themeClass: K == null ? void 0 : K.themeClass,
      onRender: K == null ? void 0 : K.onRender
    });
  },
  render() {
    var e;
    const {
      $slots: t,
      mergedClsPrefix: r,
      triggerDisplayManually: n,
      rtlEnabled: o,
      internalHoistYRail: i
    } = this;
    if (!this.scrollable)
      return (e = t.default) === null || e === void 0 ? void 0 : e.call(t);
    const a = this.trigger === "none", l = (u, d) => S("div", {
      ref: "yRailRef",
      class: [`${r}-scrollbar-rail`, `${r}-scrollbar-rail--vertical`, u],
      "data-scrollbar-rail": !0,
      style: [d || "", this.verticalRailStyle],
      "aria-hidden": !0
    }, S(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      a ? qf : zn,
      a ? null : {
        name: "fade-in-transition"
      },
      {
        default: () => this.needYBar && this.isShowYBar && !this.isIos ? S("div", {
          class: `${r}-scrollbar-rail__scrollbar`,
          style: {
            height: this.yBarSizePx,
            top: this.yBarTopPx
          },
          onMousedown: this.handleYScrollMouseDown
        }) : null
      }
    )), s = () => {
      var u, d;
      return (u = this.onRender) === null || u === void 0 || u.call(this), S("div", Ut(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [`${r}-scrollbar`, this.themeClass, o && `${r}-scrollbar--rtl`],
        style: this.cssVars,
        onMouseenter: n ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: n ? void 0 : this.handleMouseLeaveWrapper
      }), [this.container ? (d = t.default) === null || d === void 0 ? void 0 : d.call(t) : S("div", {
        role: "none",
        ref: "containerRef",
        class: [`${r}-scrollbar-container`, this.containerClass],
        style: this.containerStyle,
        onScroll: this.handleScroll,
        onWheel: this.onWheel
      }, S(sa, {
        onResize: this.handleContentResize
      }, {
        default: () => S("div", {
          ref: "contentRef",
          role: "none",
          style: [{
            width: this.xScrollable ? "fit-content" : null
          }, this.contentStyle],
          class: [`${r}-scrollbar-content`, this.contentClass]
        }, t)
      })), i ? null : l(void 0, void 0), this.xScrollable && S("div", {
        ref: "xRailRef",
        class: [`${r}-scrollbar-rail`, `${r}-scrollbar-rail--horizontal`],
        style: this.horizontalRailStyle,
        "data-scrollbar-rail": !0,
        "aria-hidden": !0
      }, S(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        a ? qf : zn,
        a ? null : {
          name: "fade-in-transition"
        },
        {
          default: () => this.needXBar && this.isShowXBar && !this.isIos ? S("div", {
            class: `${r}-scrollbar-rail__scrollbar`,
            style: {
              width: this.xBarSizePx,
              right: o ? this.xBarLeftPx : void 0,
              left: o ? void 0 : this.xBarLeftPx
            },
            onMousedown: this.handleXScrollMouseDown
          }) : null
        }
      ))]);
    }, c = this.container ? s() : S(sa, {
      onResize: this.handleContainerResize
    }, {
      default: s
    });
    return i ? S(qt, null, c, l(this.themeClass, this.cssVars)) : c;
  }
}), km = Yx, o3 = Yx, Wx = Object.assign(Object.assign({}, Ve.props), {
  to: Xn.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // private
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  // deprecated
  minWidth: Number,
  maxWidth: Number
}), i3 = ({
  arrowClass: e,
  arrowStyle: t,
  arrowWrapperClass: r,
  arrowWrapperStyle: n,
  clsPrefix: o
}) => S("div", {
  key: "__popover-arrow__",
  style: n,
  class: [`${o}-popover-arrow-wrapper`, r]
}, S("div", {
  class: [`${o}-popover-arrow`, e],
  style: t
})), a3 = Z({
  name: "PopoverBody",
  inheritAttrs: !1,
  props: Wx,
  setup(e, {
    slots: t,
    attrs: r
  }) {
    const {
      namespaceRef: n,
      mergedClsPrefixRef: o,
      inlineThemeDisabled: i
    } = Bt(e), a = Ve("Popover", "-popover", wO, mm, e, o), l = L(null), s = De("NPopover"), c = L(null), u = L(e.show), d = L(!1);
    rr(() => {
      const {
        show: y
      } = e;
      y && !TO() && !e.internalDeactivateImmediately && (d.value = !0);
    });
    const f = W(() => {
      const {
        trigger: y,
        onClickoutside: I
      } = e, D = [], {
        positionManuallyRef: {
          value: O
        }
      } = s;
      return O || (y === "click" && !I && D.push([Yl, b, void 0, {
        capture: !0
      }]), y === "hover" && D.push([EO, x])), I && D.push([Yl, b, void 0, {
        capture: !0
      }]), (e.displayDirective === "show" || e.animated && d.value) && D.push([ci, e.show]), D;
    }), p = W(() => {
      const y = e.width === "trigger" ? void 0 : qi(e.width), I = [];
      y && I.push({
        width: y
      });
      const {
        maxWidth: D,
        minWidth: O
      } = e;
      return D && I.push({
        maxWidth: qi(D)
      }), O && I.push({
        maxWidth: qi(O)
      }), i || I.push(h.value), I;
    }), h = W(() => {
      const {
        common: {
          cubicBezierEaseInOut: y,
          cubicBezierEaseIn: I,
          cubicBezierEaseOut: D
        },
        self: {
          space: O,
          spaceArrow: $,
          padding: z,
          fontSize: Y,
          textColor: j,
          dividerColor: q,
          color: ee,
          boxShadow: re,
          borderRadius: le,
          arrowHeight: ye,
          arrowOffset: Me,
          arrowOffsetVertical: Ee
        }
      } = a.value;
      return {
        "--n-box-shadow": re,
        "--n-bezier": y,
        "--n-bezier-ease-in": I,
        "--n-bezier-ease-out": D,
        "--n-font-size": Y,
        "--n-text-color": j,
        "--n-color": ee,
        "--n-divider-color": q,
        "--n-border-radius": le,
        "--n-arrow-height": ye,
        "--n-arrow-offset": Me,
        "--n-arrow-offset-vertical": Ee,
        "--n-padding": z,
        "--n-space": O,
        "--n-space-arrow": $
      };
    }), g = i ? dr("popover", void 0, h, e) : void 0;
    s.setBodyInstance({
      syncPosition: m
    }), vt(() => {
      s.setBodyInstance(null);
    }), at(We(e, "show"), (y) => {
      e.animated || (y ? u.value = !0 : u.value = !1);
    });
    function m() {
      var y;
      (y = l.value) === null || y === void 0 || y.syncPosition();
    }
    function v(y) {
      e.trigger === "hover" && e.keepAliveOnHover && e.show && s.handleMouseEnter(y);
    }
    function M(y) {
      e.trigger === "hover" && e.keepAliveOnHover && s.handleMouseLeave(y);
    }
    function x(y) {
      e.trigger === "hover" && !T().contains(Wl(y)) && s.handleMouseMoveOutside(y);
    }
    function b(y) {
      (e.trigger === "click" && !T().contains(Wl(y)) || e.onClickoutside) && s.handleClickOutside(y);
    }
    function T() {
      return s.getTriggerElement();
    }
    Et(Mm, c), Et(vm, null), Et(bm, null);
    function w() {
      if (g == null || g.onRender(), !(e.displayDirective === "show" || e.show || e.animated && d.value))
        return null;
      let y;
      const I = s.internalRenderBodyRef.value, {
        value: D
      } = o;
      if (I)
        y = I(
          // The popover class and overlap class must exists, they will be used
          // to place the body & transition animation.
          // Shadow class exists for reuse box-shadow.
          [`${D}-popover-shared`, g == null ? void 0 : g.themeClass.value, e.overlap && `${D}-popover-shared--overlap`, e.showArrow && `${D}-popover-shared--show-arrow`, e.arrowPointToCenter && `${D}-popover-shared--center-arrow`],
          c,
          p.value,
          v,
          M
        );
      else {
        const {
          value: O
        } = s.extraClassRef, {
          internalTrapFocus: $
        } = e, z = !Ff(t.header) || !Ff(t.footer), Y = () => {
          var j, q;
          const ee = z ? S(qt, null, mt(t.header, (ye) => ye ? S("div", {
            class: [`${D}-popover__header`, e.headerClass],
            style: e.headerStyle
          }, ye) : null), mt(t.default, (ye) => ye ? S("div", {
            class: [`${D}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, t) : null), mt(t.footer, (ye) => ye ? S("div", {
            class: [`${D}-popover__footer`, e.footerClass],
            style: e.footerStyle
          }, ye) : null)) : e.scrollable ? (j = t.default) === null || j === void 0 ? void 0 : j.call(t) : S("div", {
            class: [`${D}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, t), re = e.scrollable ? S(o3, {
            contentClass: z ? void 0 : `${D}-popover__content ${(q = e.contentClass) !== null && q !== void 0 ? q : ""}`,
            contentStyle: z ? void 0 : e.contentStyle
          }, {
            default: () => ee
          }) : ee, le = e.showArrow ? i3({
            arrowClass: e.arrowClass,
            arrowStyle: e.arrowStyle,
            arrowWrapperClass: e.arrowWrapperClass,
            arrowWrapperStyle: e.arrowWrapperStyle,
            clsPrefix: D
          }) : null;
          return [re, le];
        };
        y = S("div", Ut({
          class: [`${D}-popover`, `${D}-popover-shared`, g == null ? void 0 : g.themeClass.value, O.map((j) => `${D}-${j}`), {
            [`${D}-popover--scrollable`]: e.scrollable,
            [`${D}-popover--show-header-or-footer`]: z,
            [`${D}-popover--raw`]: e.raw,
            [`${D}-popover-shared--overlap`]: e.overlap,
            [`${D}-popover-shared--show-arrow`]: e.showArrow,
            [`${D}-popover-shared--center-arrow`]: e.arrowPointToCenter
          }],
          ref: c,
          style: p.value,
          onKeydown: s.handleKeydown,
          onMouseenter: v,
          onMouseleave: M
        }, r), $ ? S(Ux, {
          active: e.show,
          autoFocus: !0
        }, {
          default: Y
        }) : Y());
      }
      return on(y, f.value);
    }
    return {
      displayed: d,
      namespace: n,
      isMounted: s.isMountedRef,
      zIndex: s.zIndexRef,
      followerRef: l,
      adjustedTo: Xn(e),
      followerEnabled: u,
      renderContentNode: w
    };
  },
  render() {
    return S(Rx, {
      ref: "followerRef",
      zIndex: this.zIndex,
      show: this.show,
      enabled: this.followerEnabled,
      to: this.adjustedTo,
      x: this.x,
      y: this.y,
      flip: this.flip,
      placement: this.placement,
      containerClass: this.namespace,
      overlap: this.overlap,
      width: this.width === "trigger" ? "target" : void 0,
      teleportDisabled: this.adjustedTo === Xn.tdkey
    }, {
      default: () => this.animated ? S(zn, {
        name: "popover-transition",
        appear: this.isMounted,
        // Don't use watch to enable follower, since the transition may
        // make position sync timing very subtle and buggy.
        onEnter: () => {
          this.followerEnabled = !0;
        },
        onAfterLeave: () => {
          var e;
          (e = this.internalOnAfterLeave) === null || e === void 0 || e.call(this), this.followerEnabled = !1, this.displayed = !1;
        }
      }, {
        default: this.renderContentNode
      }) : this.renderContentNode()
    });
  }
});
function fi(e, t) {
  return at(e, (r) => {
    r !== void 0 && (t.value = r);
  }), W(() => e.value === void 0 ? t.value : e.value);
}
function Qx(e, t) {
  return W(() => {
    for (const r of t)
      if (e[r] !== void 0)
        return e[r];
    return e[t[t.length - 1]];
  });
}
function Ru(e, t = !0, r = []) {
  return e.forEach((n) => {
    if (n !== null) {
      if (typeof n != "object") {
        (typeof n == "string" || typeof n == "number") && r.push(Qt(String(n)));
        return;
      }
      if (Array.isArray(n)) {
        Ru(n, t, r);
        return;
      }
      if (n.type === qt) {
        if (n.children === null)
          return;
        Array.isArray(n.children) && Ru(n.children, t, r);
      } else {
        if (n.type === qg && t)
          return;
        r.push(n);
      }
    }
  }), r;
}
function Jf(e, t = "default", r = void 0) {
  const n = e[t];
  if (!n)
    return la("getFirstSlotVNode", `slot[${t}] is empty`), null;
  const o = Ru(n(r));
  return o.length === 1 ? o[0] : (la("getFirstSlotVNode", `slot[${t}] should have exactly one child`), null);
}
let _u = [];
const Vx = /* @__PURE__ */ new WeakMap();
function l3() {
  _u.forEach((e) => e(...Vx.get(e))), _u = [];
}
function Zx(e, ...t) {
  Vx.set(e, t), !_u.includes(e) && _u.push(e) === 1 && requestAnimationFrame(l3);
}
const s3 = Z({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    var t;
    Et("VBinder", (t = xa()) === null || t === void 0 ? void 0 : t.proxy);
    const r = De("VBinder", null), n = L(null), o = (v) => {
      n.value = v, r && e.syncTargetWithParent && r.setTargetRef(v);
    };
    let i = [];
    const a = () => {
      let v = n.value;
      for (; v = Ox(v), v !== null; )
        i.push(v);
      for (const M of i)
        zt("scroll", M, d, !0);
    }, l = () => {
      for (const v of i)
        It("scroll", v, d, !0);
      i = [];
    }, s = /* @__PURE__ */ new Set(), c = (v) => {
      s.size === 0 && a(), s.has(v) || s.add(v);
    }, u = (v) => {
      s.has(v) && s.delete(v), s.size === 0 && l();
    }, d = () => {
      Zx(f);
    }, f = () => {
      s.forEach((v) => v());
    }, p = /* @__PURE__ */ new Set(), h = (v) => {
      p.size === 0 && zt("resize", window, m), p.has(v) || p.add(v);
    }, g = (v) => {
      p.has(v) && p.delete(v), p.size === 0 && It("resize", window, m);
    }, m = () => {
      p.forEach((v) => v());
    };
    return vt(() => {
      It("resize", window, m), l();
    }), {
      targetRef: n,
      setTargetRef: o,
      addScrollListener: c,
      removeScrollListener: u,
      addResizeListener: h,
      removeResizeListener: g
    };
  },
  render() {
    return Gf("binder", this.$slots);
  }
}), Gx = s3, Kx = Z({
  name: "Target",
  setup() {
    const { setTargetRef: e, syncTarget: t } = De("VBinder");
    return {
      syncTarget: t,
      setTargetDirective: {
        mounted: e,
        updated: e
      }
    };
  },
  render() {
    const { syncTarget: e, setTargetDirective: t } = this;
    return e ? on(Jv("follower", this.$slots), [
      [t]
    ]) : Jv("follower", this.$slots);
  }
});
function Pu(e, t = [], r) {
  const n = {};
  return t.forEach((o) => {
    n[o] = e[o];
  }), Object.assign(n, r);
}
const u3 = Object.keys(Wx), c3 = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function d3(e, t, r) {
  c3[t].forEach((n) => {
    e.props ? e.props = Object.assign({}, e.props) : e.props = {};
    const o = e.props[n], i = r[n];
    o ? e.props[n] = (...a) => {
      o(...a), i(...a);
    } : e.props[n] = i;
  });
}
const qx = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  flip: {
    type: Boolean,
    default: !0
  },
  animated: {
    type: Boolean,
    default: !0
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  to: Xn.propTo,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // events
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  // internal
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  // deprecated
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
}, f3 = Object.assign(Object.assign(Object.assign({}, Ve.props), qx), {
  internalOnAfterLeave: Function,
  internalRenderBody: Function
}), Vc = Z({
  name: "Popover",
  inheritAttrs: !1,
  props: f3,
  __popover__: !0,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      e.maxWidth !== void 0 && sr("popover", "`max-width` is deprecated, please use `style` instead."), e.minWidth !== void 0 && sr("popover", "`min-width` is deprecated, please use `style` instead."), e.arrow !== void 0 && sr("popover", "`arrow` is deprecated, please use `showArrow` instead."), e.onHide !== void 0 && sr("popover", "`on-hide` is deprecated, please use `on-update:show` instead."), e.onShow !== void 0 && sr("popover", "`on-show` is deprecated, please use `on-update:show` instead.");
    });
    const t = hs(), r = L(null), n = W(() => e.show), o = L(e.defaultShow), i = fi(n, o), a = _t(() => e.disabled ? !1 : i.value), l = () => {
      if (e.disabled)
        return !0;
      const {
        getDisabled: j
      } = e;
      return !!(j != null && j());
    }, s = () => l() ? !1 : i.value, c = Qx(e, ["arrow", "showArrow"]), u = W(() => e.overlap ? !1 : c.value);
    let d = null;
    const f = L(null), p = L(null), h = _t(() => e.x !== void 0 && e.y !== void 0);
    function g(j) {
      const {
        "onUpdate:show": q,
        onUpdateShow: ee,
        onShow: re,
        onHide: le
      } = e;
      o.value = j, q && Be(q, j), ee && Be(ee, j), j && re && Be(re, !0), j && le && Be(le, !1);
    }
    function m() {
      d && d.syncPosition();
    }
    function v() {
      const {
        value: j
      } = f;
      j && (window.clearTimeout(j), f.value = null);
    }
    function M() {
      const {
        value: j
      } = p;
      j && (window.clearTimeout(j), p.value = null);
    }
    function x() {
      const j = l();
      if (e.trigger === "focus" && !j) {
        if (s())
          return;
        g(!0);
      }
    }
    function b() {
      const j = l();
      if (e.trigger === "focus" && !j) {
        if (!s())
          return;
        g(!1);
      }
    }
    function T() {
      const j = l();
      if (e.trigger === "hover" && !j) {
        if (M(), f.value !== null || s())
          return;
        const q = () => {
          g(!0), f.value = null;
        }, {
          delay: ee
        } = e;
        ee === 0 ? q() : f.value = window.setTimeout(q, ee);
      }
    }
    function w() {
      const j = l();
      if (e.trigger === "hover" && !j) {
        if (v(), p.value !== null || !s())
          return;
        const q = () => {
          g(!1), p.value = null;
        }, {
          duration: ee
        } = e;
        ee === 0 ? q() : p.value = window.setTimeout(q, ee);
      }
    }
    function y() {
      w();
    }
    function I(j) {
      var q;
      s() && (e.trigger === "click" && (v(), M(), g(!1)), (q = e.onClickoutside) === null || q === void 0 || q.call(e, j));
    }
    function D() {
      if (e.trigger === "click" && !l()) {
        v(), M();
        const j = !s();
        g(j);
      }
    }
    function O(j) {
      e.internalTrapFocus && j.key === "Escape" && (v(), M(), g(!1));
    }
    function $(j) {
      o.value = j;
    }
    function z() {
      var j;
      return (j = r.value) === null || j === void 0 ? void 0 : j.targetRef;
    }
    function Y(j) {
      d = j;
    }
    return Et("NPopover", {
      getTriggerElement: z,
      handleKeydown: O,
      handleMouseEnter: T,
      handleMouseLeave: w,
      handleClickOutside: I,
      handleMouseMoveOutside: y,
      setBodyInstance: Y,
      positionManuallyRef: h,
      isMountedRef: t,
      zIndexRef: We(e, "zIndex"),
      extraClassRef: We(e, "internalExtraClass"),
      internalRenderBodyRef: We(e, "internalRenderBody")
    }), rr(() => {
      i.value && l() && g(!1);
    }), {
      binderInstRef: r,
      positionManually: h,
      mergedShowConsideringDisabledProp: a,
      // if to show popover body
      uncontrolledShow: o,
      mergedShowArrow: u,
      getMergedShow: s,
      setShow: $,
      handleClick: D,
      handleMouseEnter: T,
      handleMouseLeave: w,
      handleFocus: x,
      handleBlur: b,
      syncPosition: m
    };
  },
  render() {
    var e;
    const {
      positionManually: t,
      $slots: r
    } = this;
    let n, o = !1;
    if (!t && (r.activator ? n = Jf(r, "activator") : n = Jf(r, "trigger"), n)) {
      n = C1(n), n = n.type === m4 ? S("span", [n]) : n;
      const i = {
        onClick: this.handleClick,
        onMouseenter: this.handleMouseEnter,
        onMouseleave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };
      if (!((e = n.type) === null || e === void 0) && e.__popover__)
        o = !0, n.props || (n.props = {
          internalSyncTargetWithParent: !0,
          internalInheritedEventHandlers: []
        }), n.props.internalSyncTargetWithParent = !0, n.props.internalInheritedEventHandlers ? n.props.internalInheritedEventHandlers = [i, ...n.props.internalInheritedEventHandlers] : n.props.internalInheritedEventHandlers = [i];
      else {
        const {
          internalInheritedEventHandlers: a
        } = this, l = [i, ...a], s = {
          onBlur: (c) => {
            l.forEach((u) => {
              u.onBlur(c);
            });
          },
          onFocus: (c) => {
            l.forEach((u) => {
              u.onFocus(c);
            });
          },
          onClick: (c) => {
            l.forEach((u) => {
              u.onClick(c);
            });
          },
          onMouseenter: (c) => {
            l.forEach((u) => {
              u.onMouseenter(c);
            });
          },
          onMouseleave: (c) => {
            l.forEach((u) => {
              u.onMouseleave(c);
            });
          }
        };
        d3(n, a ? "nested" : t ? "manual" : this.trigger, s);
      }
    }
    return S(Gx, {
      ref: "binderInstRef",
      syncTarget: !o,
      syncTargetWithParent: this.internalSyncTargetWithParent
    }, {
      default: () => {
        this.mergedShowConsideringDisabledProp;
        const i = this.getMergedShow();
        return [this.internalTrapFocus && i ? on(S("div", {
          style: {
            position: "fixed",
            inset: 0
          }
        }), [[Am, {
          enabled: i,
          zIndex: this.zIndex
        }]]) : null, t ? null : S(Kx, null, {
          default: () => n
        }), S(a3, Pu(this.$props, u3, Object.assign(Object.assign({}, this.$attrs), {
          showArrow: this.mergedShowArrow,
          show: i
        })), {
          default: () => {
            var a, l;
            return (l = (a = this.$slots).default) === null || l === void 0 ? void 0 : l.call(a);
          },
          header: () => {
            var a, l;
            return (l = (a = this.$slots).header) === null || l === void 0 ? void 0 : l.call(a);
          },
          footer: () => {
            var a, l;
            return (l = (a = this.$slots).footer) === null || l === void 0 ? void 0 : l.call(a);
          }
        })];
      }
    });
  }
}), p3 = Object.assign(Object.assign({}, qx), Ve.props), Jx = Z({
  name: "Tooltip",
  props: p3,
  __popover__: !0,
  setup(e) {
    const {
      mergedClsPrefixRef: t
    } = Bt(e), r = Ve("Tooltip", "-tooltip", void 0, xx, e, t), n = L(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        n.value.syncPosition();
      },
      setShow(o) {
        n.value.setShow(o);
      }
    }), {
      popoverRef: n,
      mergedTheme: r,
      popoverThemeOverrides: W(() => r.value.self)
    });
  },
  render() {
    const {
      mergedTheme: e,
      internalExtraClass: t
    } = this;
    return S(Vc, Object.assign(Object.assign({}, this.$props), {
      theme: e.peers.Popover,
      themeOverrides: e.peerOverrides.Popover,
      builtinThemeOverrides: this.popoverThemeOverrides,
      internalExtraClass: t.concat("tooltip"),
      ref: "popoverRef"
    }), this.$slots);
  }
});
function Xf(e) {
  return `${e}-ellipsis--line-clamp`;
}
function ep(e, t) {
  return `${e}-ellipsis--cursor-${t}`;
}
const Xx = Object.assign(Object.assign({}, Ve.props), {
  expandTrigger: String,
  lineClamp: [Number, String],
  tooltip: {
    type: [Boolean, Object],
    default: !0
  }
}), Bu = Z({
  name: "Ellipsis",
  inheritAttrs: !1,
  props: Xx,
  setup(e, {
    slots: t,
    attrs: r
  }) {
    const n = ex(), o = Ve("Ellipsis", "-ellipsis", yx, mz, e, n), i = L(null), a = L(null), l = L(null), s = L(!1), c = W(() => {
      const {
        lineClamp: m
      } = e, {
        value: v
      } = s;
      return m !== void 0 ? {
        textOverflow: "",
        "-webkit-line-clamp": v ? "" : m
      } : {
        textOverflow: v ? "" : "ellipsis",
        "-webkit-line-clamp": ""
      };
    });
    function u() {
      let m = !1;
      const {
        value: v
      } = s;
      if (v)
        return !0;
      const {
        value: M
      } = i;
      if (M) {
        const {
          lineClamp: x
        } = e;
        if (p(M), x !== void 0)
          m = M.scrollHeight <= M.offsetHeight;
        else {
          const {
            value: b
          } = a;
          b && (m = b.getBoundingClientRect().width <= M.getBoundingClientRect().width);
        }
        h(M, m);
      }
      return m;
    }
    const d = W(() => e.expandTrigger === "click" ? () => {
      var m;
      const {
        value: v
      } = s;
      v && ((m = l.value) === null || m === void 0 || m.setShow(!1)), s.value = !v;
    } : void 0);
    Jg(() => {
      var m;
      e.tooltip && ((m = l.value) === null || m === void 0 || m.setShow(!1));
    });
    const f = () => S("span", Object.assign({}, Ut(r, {
      class: [`${n.value}-ellipsis`, e.lineClamp !== void 0 ? Xf(n.value) : void 0, e.expandTrigger === "click" ? ep(n.value, "pointer") : void 0],
      style: c.value
    }), {
      ref: "triggerRef",
      onClick: d.value,
      onMouseenter: (
        // get tooltip disabled will derive cursor style
        e.expandTrigger === "click" ? u : void 0
      )
    }), e.lineClamp ? t : S("span", {
      ref: "triggerInnerRef"
    }, t));
    function p(m) {
      if (!m)
        return;
      const v = c.value, M = Xf(n.value);
      e.lineClamp !== void 0 ? g(m, M, "add") : g(m, M, "remove");
      for (const x in v)
        m.style[x] !== v[x] && (m.style[x] = v[x]);
    }
    function h(m, v) {
      const M = ep(n.value, "pointer");
      e.expandTrigger === "click" && !v ? g(m, M, "add") : g(m, M, "remove");
    }
    function g(m, v, M) {
      M === "add" ? m.classList.contains(v) || m.classList.add(v) : m.classList.contains(v) && m.classList.remove(v);
    }
    return {
      mergedTheme: o,
      triggerRef: i,
      triggerInnerRef: a,
      tooltipRef: l,
      handleClick: d,
      renderTrigger: f,
      getTooltipDisabled: u
    };
  },
  render() {
    var e;
    const {
      tooltip: t,
      renderTrigger: r,
      $slots: n
    } = this;
    if (t) {
      const {
        mergedTheme: o
      } = this;
      return S(Jx, Object.assign({
        ref: "tooltipRef",
        placement: "top"
      }, t, {
        getDisabled: this.getTooltipDisabled,
        theme: o.peers.Tooltip,
        themeOverrides: o.peerOverrides.Tooltip
      }), {
        trigger: r,
        default: (e = n.tooltip) !== null && e !== void 0 ? e : n.default
      });
    } else
      return r();
  }
}), h3 = Z({
  name: "PerformantEllipsis",
  props: Xx,
  inheritAttrs: !1,
  setup(e, {
    attrs: t,
    slots: r
  }) {
    const n = L(!1), o = ex();
    return ko("-ellipsis", yx, o), {
      mouseEntered: n,
      renderTrigger: () => {
        const {
          lineClamp: i
        } = e, a = o.value;
        return S("span", Object.assign({}, Ut(t, {
          class: [`${a}-ellipsis`, i !== void 0 ? Xf(a) : void 0, e.expandTrigger === "click" ? ep(a, "pointer") : void 0],
          style: i === void 0 ? {
            textOverflow: "ellipsis"
          } : {
            "-webkit-line-clamp": i
          }
        }), {
          onMouseenter: () => {
            n.value = !0;
          }
        }), i ? r : S("span", null, r));
      }
    };
  },
  render() {
    return this.mouseEntered ? S(Bu, Ut({}, this.$attrs, this.$props), this.$slots) : this.renderTrigger();
  }
}), g3 = (e) => S(h3, {}, [e.label]), m3 = { class: "flex items-center space-x-1" }, v3 = {
  key: 0,
  class: "flex items-center"
}, b3 = { style: { width: "100%" } }, M3 = Z({
  name: "UITag",
  inheritAttrs: !1
}), y3 = Z({
  ...M3,
  props: {
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "medium"
    },
    round: {
      type: Boolean,
      default: !0
    },
    bordered: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = wr();
    return (r, n) => (_(), se(N(ll), Ut({
      class: [`hl-${e.type}`, e.bordered ? null : "hl-border-hidden"]
    }, r.$attrs, {
      type: e.type,
      closable: e.closable,
      size: e.size,
      round: e.round
    }), {
      default: Q(() => [
        de("div", m3, [
          N(t).icon ? (_(), be("div", v3, [
            Re(r.$slots, "icon")
          ])) : Oe("", !0),
          de("div", b3, [
            Re(r.$slots, "default")
          ])
        ])
      ]),
      _: 3
    }, 16, ["class", "type", "closable", "size", "round"]));
  }
}), x3 = y3, ew = {
  display: "flex",
  alignItems: "center",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, w3 = ({ option: e }) => S(
  "div",
  {
    style: ew
  },
  [
    gm(e),
    S(
      "p",
      {
        style: {
          margin: 0,
          marginLeft: "8px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      },
      { default: () => e.label }
    )
  ]
), T3 = ({
  option: e,
  handleClose: t
}) => S(
  x3,
  {
    style: {
      padding: "0 6px 0 4px"
    },
    round: !0,
    closable: !0,
    onClose: (r) => {
      r.stopPropagation(), t();
    }
  },
  {
    default: () => S(
      "div",
      {
        style: ew
      },
      [
        gm(e),
        S(
          "p",
          {
            style: {
              margin: 0,
              marginLeft: "8px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          { default: () => e.label }
        )
      ]
    )
  }
);
function Fu(e) {
  return e.type === "group";
}
function tw(e) {
  return e.type === "ignored";
}
function _d(e, t) {
  try {
    return !!(1 + t.toString().toLowerCase().indexOf(e.trim().toLowerCase()));
  } catch {
    return !1;
  }
}
function N3(e, t) {
  return {
    getIsGroup: Fu,
    getIgnored: tw,
    getKey(r) {
      return Fu(r) ? r.name || r.key || "key-required" : r[e];
    },
    getChildren(r) {
      return r[t];
    }
  };
}
function S3(e, t, r, n) {
  if (!t)
    return e;
  function o(i) {
    if (!Array.isArray(i))
      return [];
    const a = [];
    for (const l of i)
      if (Fu(l)) {
        const s = o(l[n]);
        s.length && a.push(Object.assign({}, l, {
          [n]: s
        }));
      } else {
        if (tw(l))
          continue;
        t(r, l) && a.push(l);
      }
    return a;
  }
  return o(e);
}
function C3(e, t, r) {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((o) => {
    Fu(o) ? o[r].forEach((i) => {
      n.set(i[t], i);
    }) : n.set(o[t], o);
  }), n;
}
const {
  cubicBezierEaseIn: ob,
  cubicBezierEaseOut: ib
} = Mi;
function Em({
  transformOrigin: e = "inherit",
  duration: t = ".2s",
  enterScale: r = ".9",
  originalTransform: n = "",
  originalTransition: o = ""
} = {}) {
  return [V("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin: e,
    transition: `opacity ${t} ${ob}, transform ${t} ${ob} ${o && "," + o}`
  }), V("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin: e,
    transition: `opacity ${t} ${ib}, transform ${t} ${ib} ${o && "," + o}`
  }), V("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${n} scale(${r})`
  }), V("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${n} scale(1)`
  })];
}
const I3 = V([te("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), te("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [Em({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
function ab(e) {
  return Array.isArray(e) ? e : [e];
}
const tp = {
  STOP: "STOP"
};
function rw(e, t) {
  const r = t(e);
  e.children !== void 0 && r !== tp.STOP && e.children.forEach((n) => rw(n, t));
}
function A3(e, t = {}) {
  const { preserveGroup: r = !1 } = t, n = [], o = r ? (a) => {
    a.isLeaf || (n.push(a.key), i(a.children));
  } : (a) => {
    a.isLeaf || (a.isGroup || n.push(a.key), i(a.children));
  };
  function i(a) {
    a.forEach(o);
  }
  return i(e), n;
}
function D3(e, t) {
  const { isLeaf: r } = e;
  return r !== void 0 ? r : !t(e);
}
function k3(e) {
  return e.children;
}
function E3(e) {
  return e.key;
}
function L3() {
  return !1;
}
function $3(e, t) {
  const { isLeaf: r } = e;
  return !(r === !1 && !Array.isArray(t(e)));
}
function z3(e) {
  return e.disabled === !0;
}
function O3(e, t) {
  return e.isLeaf === !1 && !Array.isArray(t(e));
}
function j3(e, t) {
  if (e.isLeaf === !0) {
    const r = t(e);
    if (Array.isArray(r) && r.length > 0)
      return !0;
  }
  return !1;
}
function Pd(e) {
  var t;
  return e == null ? [] : Array.isArray(e) ? e : (t = e.checkedKeys) !== null && t !== void 0 ? t : [];
}
function Bd(e) {
  var t;
  return e == null || Array.isArray(e) ? [] : (t = e.indeterminateKeys) !== null && t !== void 0 ? t : [];
}
function R3(e, t) {
  const r = new Set(e);
  return t.forEach((n) => {
    r.has(n) || r.add(n);
  }), Array.from(r);
}
function _3(e, t) {
  const r = new Set(e);
  return t.forEach((n) => {
    r.has(n) && r.delete(n);
  }), Array.from(r);
}
function P3(e) {
  return (e == null ? void 0 : e.type) === "group";
}
function B3(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((r, n) => {
    t.set(r.key, n);
  }), (r) => {
    var n;
    return (n = t.get(r)) !== null && n !== void 0 ? n : null;
  };
}
let F3 = class extends Error {
  constructor() {
    super(), this.message = "SubtreeNotLoadedError: checking a subtree whose required nodes are not fully loaded.";
  }
};
function U3(e, t, r, n) {
  return Uu(t.concat(e), r, n, !1);
}
function H3(e, t) {
  const r = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    const o = t.treeNodeMap.get(n);
    if (o !== void 0) {
      let i = o.parent;
      for (; i !== null && !(i.disabled || r.has(i.key)); )
        r.add(i.key), i = i.parent;
    }
  }), r;
}
function Y3(e, t, r, n) {
  const o = Uu(t, r, n, !1), i = Uu(e, r, n, !0), a = H3(e, r), l = [];
  return o.forEach((s) => {
    (i.has(s) || a.has(s)) && l.push(s);
  }), l.forEach((s) => o.delete(s)), o;
}
function Fd(e, t) {
  const { checkedKeys: r, keysToCheck: n, keysToUncheck: o, indeterminateKeys: i, cascade: a, leafOnly: l, checkStrategy: s, allowNotLoaded: c } = e;
  if (!a)
    return n !== void 0 ? {
      checkedKeys: R3(r, n),
      indeterminateKeys: Array.from(i)
    } : o !== void 0 ? {
      checkedKeys: _3(r, o),
      indeterminateKeys: Array.from(i)
    } : {
      checkedKeys: Array.from(r),
      indeterminateKeys: Array.from(i)
    };
  const { levelTreeNodeMap: u } = t;
  let d;
  o !== void 0 ? d = Y3(o, r, t, c) : n !== void 0 ? d = U3(n, r, t, c) : d = Uu(r, t, c, !1);
  const f = s === "parent", p = s === "child" || l, h = d, g = /* @__PURE__ */ new Set(), m = Math.max.apply(null, Array.from(u.keys()));
  for (let v = m; v >= 0; v -= 1) {
    const M = v === 0, x = u.get(v);
    for (const b of x) {
      if (b.isLeaf)
        continue;
      const { key: T, shallowLoaded: w } = b;
      if (p && w && b.children.forEach((O) => {
        !O.disabled && !O.isLeaf && O.shallowLoaded && h.has(O.key) && h.delete(O.key);
      }), b.disabled || !w)
        continue;
      let y = !0, I = !1, D = !0;
      for (const O of b.children) {
        const $ = O.key;
        if (!O.disabled) {
          if (D && (D = !1), h.has($))
            I = !0;
          else if (g.has($)) {
            I = !0, y = !1;
            break;
          } else if (y = !1, I)
            break;
        }
      }
      y && !D ? (f && b.children.forEach((O) => {
        !O.disabled && h.has(O.key) && h.delete(O.key);
      }), h.add(T)) : I && g.add(T), M && p && h.has(T) && h.delete(T);
    }
  }
  return {
    checkedKeys: Array.from(h),
    indeterminateKeys: Array.from(g)
  };
}
function Uu(e, t, r, n) {
  const { treeNodeMap: o, getChildren: i } = t, a = /* @__PURE__ */ new Set(), l = new Set(e);
  return e.forEach((s) => {
    const c = o.get(s);
    c !== void 0 && rw(c, (u) => {
      if (u.disabled)
        return tp.STOP;
      const { key: d } = u;
      if (!a.has(d) && (a.add(d), l.add(d), O3(u.rawNode, i))) {
        if (n)
          return tp.STOP;
        if (!r)
          throw new F3();
      }
    });
  }), l;
}
function W3(e, { includeGroup: t = !1, includeSelf: r = !0 }, n) {
  var o;
  const i = n.treeNodeMap;
  let a = e == null ? null : (o = i.get(e)) !== null && o !== void 0 ? o : null;
  const l = {
    keyPath: [],
    treeNodePath: [],
    treeNode: a
  };
  if (a != null && a.ignored)
    return l.treeNode = null, l;
  for (; a; )
    !a.ignored && (t || !a.isGroup) && l.treeNodePath.push(a), a = a.parent;
  return l.treeNodePath.reverse(), r || l.treeNodePath.pop(), l.keyPath = l.treeNodePath.map((s) => s.key), l;
}
function Q3(e) {
  if (e.length === 0)
    return null;
  const t = e[0];
  return t.isGroup || t.ignored || t.disabled ? t.getNext() : t;
}
function V3(e, t) {
  const r = e.siblings, n = r.length, { index: o } = e;
  return t ? r[(o + 1) % n] : o === r.length - 1 ? null : r[o + 1];
}
function lb(e, t, { loop: r = !1, includeDisabled: n = !1 } = {}) {
  const o = t === "prev" ? Z3 : V3, i = {
    reverse: t === "prev"
  };
  let a = !1, l = null;
  function s(c) {
    if (c !== null) {
      if (c === e) {
        if (!a)
          a = !0;
        else if (!e.disabled && !e.isGroup) {
          l = e;
          return;
        }
      } else if ((!c.disabled || n) && !c.ignored && !c.isGroup) {
        l = c;
        return;
      }
      if (c.isGroup) {
        const u = Lm(c, i);
        u !== null ? l = u : s(o(c, r));
      } else {
        const u = o(c, !1);
        if (u !== null)
          s(u);
        else {
          const d = G3(c);
          d != null && d.isGroup ? s(o(d, r)) : r && s(o(c, !0));
        }
      }
    }
  }
  return s(e), l;
}
function Z3(e, t) {
  const r = e.siblings, n = r.length, { index: o } = e;
  return t ? r[(o - 1 + n) % n] : o === 0 ? null : r[o - 1];
}
function G3(e) {
  return e.parent;
}
function Lm(e, t = {}) {
  const { reverse: r = !1 } = t, { children: n } = e;
  if (n) {
    const { length: o } = n, i = r ? o - 1 : 0, a = r ? -1 : o, l = r ? -1 : 1;
    for (let s = i; s !== a; s += l) {
      const c = n[s];
      if (!c.disabled && !c.ignored)
        if (c.isGroup) {
          const u = Lm(c, t);
          if (u !== null)
            return u;
        } else
          return c;
    }
  }
  return null;
}
const K3 = {
  getChild() {
    return this.ignored ? null : Lm(this);
  },
  getParent() {
    const { parent: e } = this;
    return e != null && e.isGroup ? e.getParent() : e;
  },
  getNext(e = {}) {
    return lb(this, "next", e);
  },
  getPrev(e = {}) {
    return lb(this, "prev", e);
  }
};
function q3(e, t) {
  const r = t ? new Set(t) : void 0, n = [];
  function o(i) {
    i.forEach((a) => {
      n.push(a), !(a.isLeaf || !a.children || a.ignored) && (a.isGroup || // normal non-leaf node
      r === void 0 || r.has(a.key)) && o(a.children);
    });
  }
  return o(e), n;
}
function J3(e, t) {
  const r = e.key;
  for (; t; ) {
    if (t.key === r)
      return !0;
    t = t.parent;
  }
  return !1;
}
function nw(e, t, r, n, o, i = null, a = 0) {
  const l = [];
  return e.forEach((s, c) => {
    var u;
    process.env.NODE_ENV !== "production" && j3(s, o) && console.error("[treemate]: node", s, "is invalid");
    const d = Object.create(n);
    if (d.rawNode = s, d.siblings = l, d.level = a, d.index = c, d.isFirstChild = c === 0, d.isLastChild = c + 1 === e.length, d.parent = i, !d.ignored) {
      const f = o(s);
      Array.isArray(f) && (d.children = nw(f, t, r, n, o, d, a + 1));
    }
    l.push(d), t.set(d.key, d), r.has(a) || r.set(a, []), (u = r.get(a)) === null || u === void 0 || u.push(d);
  }), l;
}
function X3(e, t = {}) {
  var r;
  const n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), { getDisabled: i = z3, getIgnored: a = L3, getIsGroup: l = P3, getKey: s = E3 } = t, c = (r = t.getChildren) !== null && r !== void 0 ? r : k3, u = t.ignoreEmptyChildren ? (b) => {
    const T = c(b);
    return Array.isArray(T) ? T.length ? T : null : T;
  } : c, d = Object.assign({
    get key() {
      return s(this.rawNode);
    },
    get disabled() {
      return i(this.rawNode);
    },
    get isGroup() {
      return l(this.rawNode);
    },
    get isLeaf() {
      return D3(this.rawNode, u);
    },
    get shallowLoaded() {
      return $3(this.rawNode, u);
    },
    get ignored() {
      return a(this.rawNode);
    },
    contains(b) {
      return J3(this, b);
    }
  }, K3), f = nw(e, n, o, d, u);
  function p(b) {
    if (b == null)
      return null;
    const T = n.get(b);
    return T && !T.isGroup && !T.ignored ? T : null;
  }
  function h(b) {
    if (b == null)
      return null;
    const T = n.get(b);
    return T && !T.ignored ? T : null;
  }
  function g(b, T) {
    const w = h(b);
    return w ? w.getPrev(T) : null;
  }
  function m(b, T) {
    const w = h(b);
    return w ? w.getNext(T) : null;
  }
  function v(b) {
    const T = h(b);
    return T ? T.getParent() : null;
  }
  function M(b) {
    const T = h(b);
    return T ? T.getChild() : null;
  }
  const x = {
    treeNodes: f,
    treeNodeMap: n,
    levelTreeNodeMap: o,
    maxLevel: Math.max(...o.keys()),
    getChildren: u,
    getFlattenedNodes(b) {
      return q3(f, b);
    },
    getNode: p,
    getPrev: g,
    getNext: m,
    getParent: v,
    getChild: M,
    getFirstAvailableNode() {
      return Q3(f);
    },
    getPath(b, T = {}) {
      return W3(b, T, x);
    },
    getCheckedKeys(b, T = {}) {
      const { cascade: w = !0, leafOnly: y = !1, checkStrategy: I = "all", allowNotLoaded: D = !1 } = T;
      return Fd({
        checkedKeys: Pd(b),
        indeterminateKeys: Bd(b),
        cascade: w,
        leafOnly: y,
        checkStrategy: I,
        allowNotLoaded: D
      }, x);
    },
    check(b, T, w = {}) {
      const { cascade: y = !0, leafOnly: I = !1, checkStrategy: D = "all", allowNotLoaded: O = !1 } = w;
      return Fd({
        checkedKeys: Pd(T),
        indeterminateKeys: Bd(T),
        keysToCheck: b == null ? [] : ab(b),
        cascade: y,
        leafOnly: I,
        checkStrategy: D,
        allowNotLoaded: O
      }, x);
    },
    uncheck(b, T, w = {}) {
      const { cascade: y = !0, leafOnly: I = !1, checkStrategy: D = "all", allowNotLoaded: O = !1 } = w;
      return Fd({
        checkedKeys: Pd(T),
        indeterminateKeys: Bd(T),
        keysToUncheck: b == null ? [] : ab(b),
        cascade: y,
        leafOnly: I,
        checkStrategy: D,
        allowNotLoaded: O
      }, x);
    },
    getNonLeafKeys(b = {}) {
      return A3(f, b);
    }
  };
  return x;
}
const ej = {
  name: "en-US",
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: (e) => `Please load all ${e}'s descendants before checking it.`
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    weekFormat: "yyyy-w",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    weekPlaceholder: "Select Week",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear",
    total: (e) => `Total ${e} items`,
    selected: (e) => `${e} items selected`
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now",
    clear: "Clear"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (←)",
    tipNext: "Next picture (→)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipDownload: "Download",
    tipClose: "Close (Esc)",
    // TODO: translation
    tipOriginalSize: "Zoom to original size"
  }
}, tj = ej;
var rj = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, nj = function(e, t, r) {
  var n, o = rj[e];
  return typeof o == "string" ? n = o : t === 1 ? n = o.one : n = o.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
const oj = nj;
function Ud(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var ij = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, aj = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, lj = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, sj = {
  date: Ud({
    formats: ij,
    defaultWidth: "full"
  }),
  time: Ud({
    formats: aj,
    defaultWidth: "full"
  }),
  dateTime: Ud({
    formats: lj,
    defaultWidth: "full"
  })
};
const uj = sj;
var cj = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dj = function(e, t, r, n) {
  return cj[e];
};
const fj = dj;
function Za(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", o;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, a = r != null && r.width ? String(r.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      var l = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      o = e.values[s] || e.values[l];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[c];
  };
}
var pj = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, hj = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, gj = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, mj = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, vj = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, bj = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Mj = function(e, t) {
  var r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, yj = {
  ordinalNumber: Mj,
  era: Za({
    values: pj,
    defaultWidth: "wide"
  }),
  quarter: Za({
    values: hj,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Za({
    values: gj,
    defaultWidth: "wide"
  }),
  day: Za({
    values: mj,
    defaultWidth: "wide"
  }),
  dayPeriod: Za({
    values: vj,
    defaultWidth: "wide",
    formattingValues: bj,
    defaultFormattingWidth: "wide"
  })
};
const xj = yj;
function Ga(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    var a = i[0], l = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(l) ? Tj(l, function(d) {
      return d.test(a);
    }) : wj(l, function(d) {
      return d.test(a);
    }), c;
    c = e.valueCallback ? e.valueCallback(s) : s, c = r.valueCallback ? r.valueCallback(c) : c;
    var u = t.slice(a.length);
    return {
      value: c,
      rest: u
    };
  };
}
function wj(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function Tj(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Nj(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var o = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = r.valueCallback ? r.valueCallback(a) : a;
    var l = t.slice(o.length);
    return {
      value: a,
      rest: l
    };
  };
}
var Sj = /^(\d+)(th|st|nd|rd)?/i, Cj = /\d+/i, Ij = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Aj = {
  any: [/^b/i, /^(a|c)/i]
}, Dj = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kj = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ej = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Lj = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, $j = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, zj = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Oj = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jj = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Rj = {
  ordinalNumber: Nj({
    matchPattern: Sj,
    parsePattern: Cj,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ga({
    matchPatterns: Ij,
    defaultMatchWidth: "wide",
    parsePatterns: Aj,
    defaultParseWidth: "any"
  }),
  quarter: Ga({
    matchPatterns: Dj,
    defaultMatchWidth: "wide",
    parsePatterns: kj,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Ga({
    matchPatterns: Ej,
    defaultMatchWidth: "wide",
    parsePatterns: Lj,
    defaultParseWidth: "any"
  }),
  day: Ga({
    matchPatterns: $j,
    defaultMatchWidth: "wide",
    parsePatterns: zj,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ga({
    matchPatterns: Oj,
    defaultMatchWidth: "any",
    parsePatterns: jj,
    defaultParseWidth: "any"
  })
};
const _j = Rj;
var Pj = {
  code: "en-US",
  formatDistance: oj,
  formatLong: uj,
  formatRelative: fj,
  localize: xj,
  match: _j,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Bj = Pj, Fj = {
  name: "en-US",
  locale: Bj
}, Uj = Fj;
function Zc(e) {
  const {
    mergedLocaleRef: t,
    mergedDateLocaleRef: r
  } = De(Do, null) || {}, n = W(() => {
    var o, i;
    return (i = (o = t == null ? void 0 : t.value) === null || o === void 0 ? void 0 : o[e]) !== null && i !== void 0 ? i : tj[e];
  });
  return {
    dateLocaleRef: W(() => {
      var o;
      return (o = r == null ? void 0 : r.value) !== null && o !== void 0 ? o : Uj;
    }),
    localeRef: n
  };
}
const Hj = V([te("base-selection", `
 --n-padding-single: var(--n-padding-single-top) var(--n-padding-single-right) var(--n-padding-single-bottom) var(--n-padding-single-left);
 --n-padding-multiple: var(--n-padding-multiple-top) var(--n-padding-multiple-right) var(--n-padding-multiple-bottom) var(--n-padding-multiple-left);
 position: relative;
 z-index: auto;
 box-shadow: none;
 width: 100%;
 max-width: 100%;
 display: inline-block;
 vertical-align: bottom;
 border-radius: var(--n-border-radius);
 min-height: var(--n-height);
 line-height: 1.5;
 font-size: var(--n-font-size);
 `, [te("base-loading", `
 color: var(--n-loading-color);
 `), te("base-selection-tags", "min-height: var(--n-height);"), F("border, state-border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border: var(--n-border);
 border-radius: inherit;
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `), F("state-border", `
 z-index: 1;
 border-color: #0000;
 `), te("base-suffix", `
 cursor: pointer;
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
 right: 10px;
 `, [F("arrow", `
 font-size: var(--n-arrow-size);
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 `)]), te("base-selection-overlay", `
 display: flex;
 align-items: center;
 white-space: nowrap;
 pointer-events: none;
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 padding: var(--n-padding-single);
 transition: color .3s var(--n-bezier);
 `, [F("wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), te("base-selection-placeholder", `
 color: var(--n-placeholder-color);
 `, [F("inner", `
 max-width: 100%;
 overflow: hidden;
 `)]), te("base-selection-tags", `
 cursor: pointer;
 outline: none;
 box-sizing: border-box;
 position: relative;
 z-index: auto;
 display: flex;
 padding: var(--n-padding-multiple);
 flex-wrap: wrap;
 align-items: center;
 width: 100%;
 vertical-align: bottom;
 background-color: var(--n-color);
 border-radius: inherit;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), te("base-selection-label", `
 height: var(--n-height);
 display: inline-flex;
 width: 100%;
 vertical-align: bottom;
 cursor: pointer;
 outline: none;
 z-index: auto;
 box-sizing: border-box;
 position: relative;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: inherit;
 background-color: var(--n-color);
 align-items: center;
 `, [te("base-selection-input", `
 font-size: inherit;
 line-height: inherit;
 outline: none;
 cursor: pointer;
 box-sizing: border-box;
 border:none;
 width: 100%;
 padding: var(--n-padding-single);
 background-color: #0000;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 caret-color: var(--n-caret-color);
 `, [F("content", `
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap; 
 `)]), F("render-label", `
 color: var(--n-text-color);
 `)]), $t("disabled", [V("&:hover", [F("state-border", `
 box-shadow: var(--n-box-shadow-hover);
 border: var(--n-border-hover);
 `)]), fe("focus", [F("state-border", `
 box-shadow: var(--n-box-shadow-focus);
 border: var(--n-border-focus);
 `)]), fe("active", [F("state-border", `
 box-shadow: var(--n-box-shadow-active);
 border: var(--n-border-active);
 `), te("base-selection-label", "background-color: var(--n-color-active);"), te("base-selection-tags", "background-color: var(--n-color-active);")])]), fe("disabled", "cursor: not-allowed;", [F("arrow", `
 color: var(--n-arrow-color-disabled);
 `), te("base-selection-label", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [te("base-selection-input", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 `), F("render-label", `
 color: var(--n-text-color-disabled);
 `)]), te("base-selection-tags", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `), te("base-selection-placeholder", `
 cursor: not-allowed;
 color: var(--n-placeholder-color-disabled);
 `)]), te("base-selection-input-tag", `
 height: calc(var(--n-height) - 6px);
 line-height: calc(var(--n-height) - 6px);
 outline: none;
 display: none;
 position: relative;
 margin-bottom: 3px;
 max-width: 100%;
 vertical-align: bottom;
 `, [F("input", `
 font-size: inherit;
 font-family: inherit;
 min-width: 1px;
 padding: 0;
 background-color: #0000;
 outline: none;
 border: none;
 max-width: 100%;
 overflow: hidden;
 width: 1em;
 line-height: inherit;
 cursor: pointer;
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 `), F("mirror", `
 position: absolute;
 left: 0;
 top: 0;
 white-space: pre;
 visibility: hidden;
 user-select: none;
 -webkit-user-select: none;
 opacity: 0;
 `)]), ["warning", "error"].map((e) => fe(`${e}-status`, [F("state-border", `border: var(--n-border-${e});`), $t("disabled", [V("&:hover", [F("state-border", `
 box-shadow: var(--n-box-shadow-hover-${e});
 border: var(--n-border-hover-${e});
 `)]), fe("active", [F("state-border", `
 box-shadow: var(--n-box-shadow-active-${e});
 border: var(--n-border-active-${e});
 `), te("base-selection-label", `background-color: var(--n-color-active-${e});`), te("base-selection-tags", `background-color: var(--n-color-active-${e});`)]), fe("focus", [F("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)])])]))]), te("base-selection-popover", `
 margin-bottom: -3px;
 display: flex;
 flex-wrap: wrap;
 margin-right: -8px;
 `), te("base-selection-tag-wrapper", `
 max-width: 100%;
 display: inline-flex;
 padding: 0 7px 3px 0;
 `, [V("&:last-child", "padding-right: 0;"), te("tag", `
 font-size: 14px;
 max-width: 100%;
 `, [F("content", `
 line-height: 1.25;
 text-overflow: ellipsis;
 overflow: hidden;
 `)])])]), Yj = {
  paddingSingle: "0 26px 0 12px",
  paddingMultiple: "3px 26px 0 12px",
  clearSize: "16px",
  arrowSize: "16px"
}, Wj = (e) => {
  const {
    borderRadius: t,
    textColor2: r,
    textColorDisabled: n,
    inputColor: o,
    inputColorDisabled: i,
    primaryColor: a,
    primaryColorHover: l,
    warningColor: s,
    warningColorHover: c,
    errorColor: u,
    errorColorHover: d,
    borderColor: f,
    iconColor: p,
    iconColorDisabled: h,
    clearColor: g,
    clearColorHover: m,
    clearColorPressed: v,
    placeholderColor: M,
    placeholderColorDisabled: x,
    fontSizeTiny: b,
    fontSizeSmall: T,
    fontSizeMedium: w,
    fontSizeLarge: y,
    heightTiny: I,
    heightSmall: D,
    heightMedium: O,
    heightLarge: $
  } = e;
  return Object.assign(Object.assign({}, Yj), {
    fontSizeTiny: b,
    fontSizeSmall: T,
    fontSizeMedium: w,
    fontSizeLarge: y,
    heightTiny: I,
    heightSmall: D,
    heightMedium: O,
    heightLarge: $,
    borderRadius: t,
    // default
    textColor: r,
    textColorDisabled: n,
    placeholderColor: M,
    placeholderColorDisabled: x,
    color: o,
    colorDisabled: i,
    colorActive: o,
    border: `1px solid ${f}`,
    borderHover: `1px solid ${l}`,
    borderActive: `1px solid ${a}`,
    borderFocus: `1px solid ${l}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${qe(a, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${qe(a, {
      alpha: 0.2
    })}`,
    caretColor: a,
    arrowColor: p,
    arrowColorDisabled: h,
    loadingColor: a,
    // warning
    borderWarning: `1px solid ${s}`,
    borderHoverWarning: `1px solid ${c}`,
    borderActiveWarning: `1px solid ${s}`,
    borderFocusWarning: `1px solid ${c}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${qe(s, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${qe(s, {
      alpha: 0.2
    })}`,
    colorActiveWarning: o,
    caretColorWarning: s,
    // error
    borderError: `1px solid ${u}`,
    borderHoverError: `1px solid ${d}`,
    borderActiveError: `1px solid ${u}`,
    borderFocusError: `1px solid ${d}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${qe(u, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${qe(u, {
      alpha: 0.2
    })}`,
    colorActiveError: o,
    caretColorError: u,
    clearColor: g,
    clearColorHover: m,
    clearColorPressed: v
  });
}, Qj = {
  name: "InternalSelection",
  common: Jt,
  peers: {
    Popover: mm
  },
  self: Wj
}, ow = Qj, Xr = (e, ...t) => typeof e == "function" ? e(...t) : typeof e == "string" ? Qt(e) : typeof e == "number" ? Qt(String(e)) : null, Vj = te("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [V(">", [F("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [V("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), V("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), F("placeholder", `
 display: flex;
 `), F("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [Eu({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]), Zj = Aa("clear", S("svg", {
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, S("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, S("path", {
  d: "M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M6.5343055,5.83859116 C6.33943736,5.70359511 6.07001296,5.72288026 5.89644661,5.89644661 L5.89644661,5.89644661 L5.83859116,5.9656945 C5.70359511,6.16056264 5.72288026,6.42998704 5.89644661,6.60355339 L5.89644661,6.60355339 L7.293,8 L5.89644661,9.39644661 L5.83859116,9.4656945 C5.70359511,9.66056264 5.72288026,9.92998704 5.89644661,10.1035534 L5.89644661,10.1035534 L5.9656945,10.1614088 C6.16056264,10.2964049 6.42998704,10.2771197 6.60355339,10.1035534 L6.60355339,10.1035534 L8,8.707 L9.39644661,10.1035534 L9.4656945,10.1614088 C9.66056264,10.2964049 9.92998704,10.2771197 10.1035534,10.1035534 L10.1035534,10.1035534 L10.1614088,10.0343055 C10.2964049,9.83943736 10.2771197,9.57001296 10.1035534,9.39644661 L10.1035534,9.39644661 L8.707,8 L10.1035534,6.60355339 L10.1614088,6.5343055 C10.2964049,6.33943736 10.2771197,6.07001296 10.1035534,5.89644661 L10.1035534,5.89644661 L10.0343055,5.83859116 C9.83943736,5.70359511 9.57001296,5.72288026 9.39644661,5.89644661 L9.39644661,5.89644661 L8,7.293 L6.60355339,5.89644661 Z"
}))))), rp = Z({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    show: Boolean,
    onClear: Function
  },
  setup(e) {
    return ko("-base-clear", Vj, We(e, "clsPrefix")), {
      handleMouseDown(t) {
        t.preventDefault();
      }
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return S("div", {
      class: `${e}-base-clear`
    }, S(cm, null, {
      default: () => {
        var t, r;
        return this.show ? S("div", {
          key: "dismiss",
          class: `${e}-base-clear__clear`,
          onClick: this.onClear,
          onMousedown: this.handleMouseDown,
          "data-clear": !0
        }, hn(this.$slots.icon, () => [S(On, {
          clsPrefix: e
        }, {
          default: () => S(Zj, null)
        })])) : S("div", {
          key: "icon",
          class: `${e}-base-clear__placeholder`
        }, (r = (t = this.$slots).placeholder) === null || r === void 0 ? void 0 : r.call(t));
      }
    }));
  }
}), Gj = Z({
  name: "ChevronDown",
  render() {
    return S("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, S("path", {
      d: "M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z",
      fill: "currentColor"
    }));
  }
}), iw = Z({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    onClear: Function
  },
  setup(e, {
    slots: t
  }) {
    return () => {
      const {
        clsPrefix: r
      } = e;
      return S(dm, {
        clsPrefix: r,
        class: `${r}-base-suffix`,
        strokeWidth: 24,
        scale: 0.85,
        show: e.loading
      }, {
        default: () => e.showArrow ? S(rp, {
          clsPrefix: r,
          show: e.showClear,
          onClear: e.onClear
        }, {
          placeholder: () => S(On, {
            clsPrefix: r,
            class: `${r}-base-suffix__arrow`
          }, {
            default: () => hn(t.default, () => [S(Gj, null)])
          })
        }) : null
      });
    };
  }
}), Yn = "v-hidden", Kj = bo("[v-hidden]", {
  display: "none!important"
}), sb = Z({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateCount: Function,
    onUpdateOverflow: Function
  },
  setup(e, { slots: t }) {
    const r = L(null), n = L(null);
    function o(a) {
      const { value: l } = r, { getCounter: s, getTail: c } = e;
      let u;
      if (s !== void 0 ? u = s() : u = n.value, !l || !u)
        return;
      u.hasAttribute(Yn) && u.removeAttribute(Yn);
      const { children: d } = l;
      if (a.showAllItemsBeforeCalculate)
        for (const x of d)
          x.hasAttribute(Yn) && x.removeAttribute(Yn);
      const f = l.offsetWidth, p = [], h = t.tail ? c == null ? void 0 : c() : null;
      let g = h ? h.offsetWidth : 0, m = !1;
      const v = l.children.length - (t.tail ? 1 : 0);
      for (let x = 0; x < v - 1; ++x) {
        if (x < 0)
          continue;
        const b = d[x];
        if (m) {
          b.hasAttribute(Yn) || b.setAttribute(Yn, "");
          continue;
        } else
          b.hasAttribute(Yn) && b.removeAttribute(Yn);
        const T = b.offsetWidth;
        if (g += T, p[x] = T, g > f) {
          const { updateCounter: w } = e;
          for (let y = x; y >= 0; --y) {
            const I = v - 1 - y;
            w !== void 0 ? w(I) : u.textContent = `${I}`;
            const D = u.offsetWidth;
            if (g -= p[y], g + D <= f || y === 0) {
              m = !0, x = y - 1, h && (x === -1 ? (h.style.maxWidth = `${f - D}px`, h.style.boxSizing = "border-box") : h.style.maxWidth = "");
              const { onUpdateCount: O } = e;
              O && O(I);
              break;
            }
          }
        }
      }
      const { onUpdateOverflow: M } = e;
      m ? M !== void 0 && M(!0) : (M !== void 0 && M(!1), u.setAttribute(Yn, ""));
    }
    const i = bi();
    return Kj.mount({
      id: "vueuc/overflow",
      head: !0,
      anchorMetaName: Cm,
      ssr: i
    }), et(() => o({
      showAllItemsBeforeCalculate: !1
    })), {
      selfRef: r,
      counterRef: n,
      sync: o
    };
  },
  render() {
    const { $slots: e } = this;
    return mn(() => this.sync({
      showAllItemsBeforeCalculate: !1
    })), S("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      Re(e, "default"),
      // $slots.counter should only has 1 element
      e.counter ? e.counter() : S("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      // $slots.tail should only has 1 element
      e.tail ? e.tail() : null
    ]);
  }
});
function ub(e) {
  switch (typeof e) {
    case "string":
      return e || void 0;
    case "number":
      return String(e);
    default:
      return;
  }
}
function aw(e, t) {
  t && (et(() => {
    const {
      value: r
    } = e;
    r && ju.registerHandler(r, t);
  }), vt(() => {
    const {
      value: r
    } = e;
    r && ju.unregisterHandler(r);
  }));
}
const qj = Z({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, Ve.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    active: Boolean,
    pattern: {
      type: String,
      default: ""
    },
    placeholder: String,
    selectedOption: {
      type: Object,
      default: null
    },
    selectedOptions: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    multiple: Boolean,
    filterable: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    loading: Boolean,
    autofocus: Boolean,
    showArrow: {
      type: Boolean,
      default: !0
    },
    inputProps: Object,
    focused: Boolean,
    renderTag: Function,
    onKeydown: Function,
    onClick: Function,
    onBlur: Function,
    onFocus: Function,
    onDeleteOption: Function,
    maxTagCount: [String, Number],
    ellipsisTagPopoverProps: Object,
    onClear: Function,
    onPatternInput: Function,
    onPatternFocus: Function,
    onPatternBlur: Function,
    renderLabel: Function,
    status: String,
    inlineThemeDisabled: Boolean,
    ignoreComposition: {
      type: Boolean,
      default: !0
    },
    onResize: Function
  }),
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      mergedRtlRef: r
    } = Bt(e), n = yn("InternalSelection", r, t), o = L(null), i = L(null), a = L(null), l = L(null), s = L(null), c = L(null), u = L(null), d = L(null), f = L(null), p = L(null), h = L(!1), g = L(!1), m = L(!1), v = Ve("InternalSelection", "-internal-selection", Hj, ow, e, We(e, "clsPrefix")), M = W(() => e.clearable && !e.disabled && (m.value || e.active)), x = W(() => e.selectedOption ? e.renderTag ? e.renderTag({
      option: e.selectedOption,
      handleClose: () => {
      }
    }) : e.renderLabel ? e.renderLabel(e.selectedOption, !0) : Xr(e.selectedOption[e.labelField], e.selectedOption, !0) : e.placeholder), b = W(() => {
      const G = e.selectedOption;
      if (G)
        return G[e.labelField];
    }), T = W(() => e.multiple ? !!(Array.isArray(e.selectedOptions) && e.selectedOptions.length) : e.selectedOption !== null);
    function w() {
      var G;
      const {
        value: ae
      } = o;
      if (ae) {
        const {
          value: Xe
        } = i;
        Xe && (Xe.style.width = `${ae.offsetWidth}px`, e.maxTagCount !== "responsive" && ((G = f.value) === null || G === void 0 || G.sync({
          showAllItemsBeforeCalculate: !1
        })));
      }
    }
    function y() {
      const {
        value: G
      } = p;
      G && (G.style.display = "none");
    }
    function I() {
      const {
        value: G
      } = p;
      G && (G.style.display = "inline-block");
    }
    at(We(e, "active"), (G) => {
      G || y();
    }), at(We(e, "pattern"), () => {
      e.multiple && mn(w);
    });
    function D(G) {
      const {
        onFocus: ae
      } = e;
      ae && ae(G);
    }
    function O(G) {
      const {
        onBlur: ae
      } = e;
      ae && ae(G);
    }
    function $(G) {
      const {
        onDeleteOption: ae
      } = e;
      ae && ae(G);
    }
    function z(G) {
      const {
        onClear: ae
      } = e;
      ae && ae(G);
    }
    function Y(G) {
      const {
        onPatternInput: ae
      } = e;
      ae && ae(G);
    }
    function j(G) {
      var ae;
      (!G.relatedTarget || !(!((ae = a.value) === null || ae === void 0) && ae.contains(G.relatedTarget))) && D(G);
    }
    function q(G) {
      var ae;
      !((ae = a.value) === null || ae === void 0) && ae.contains(G.relatedTarget) || O(G);
    }
    function ee(G) {
      z(G);
    }
    function re() {
      m.value = !0;
    }
    function le() {
      m.value = !1;
    }
    function ye(G) {
      !e.active || !e.filterable || G.target !== i.value && G.preventDefault();
    }
    function Me(G) {
      $(G);
    }
    function Ee(G) {
      if (G.key === "Backspace" && !ne.value && !e.pattern.length) {
        const {
          selectedOptions: ae
        } = e;
        ae != null && ae.length && Me(ae[ae.length - 1]);
      }
    }
    const ne = L(!1);
    let ue = null;
    function Ce(G) {
      const {
        value: ae
      } = o;
      if (ae) {
        const Xe = G.target.value;
        ae.textContent = Xe, w();
      }
      e.ignoreComposition && ne.value ? ue = G : Y(G);
    }
    function ze() {
      ne.value = !0;
    }
    function ke() {
      ne.value = !1, e.ignoreComposition && Y(ue), ue = null;
    }
    function tt(G) {
      var ae;
      g.value = !0, (ae = e.onPatternFocus) === null || ae === void 0 || ae.call(e, G);
    }
    function Ge(G) {
      var ae;
      g.value = !1, (ae = e.onPatternBlur) === null || ae === void 0 || ae.call(e, G);
    }
    function Ne() {
      var G, ae;
      if (e.filterable)
        g.value = !1, (G = c.value) === null || G === void 0 || G.blur(), (ae = i.value) === null || ae === void 0 || ae.blur();
      else if (e.multiple) {
        const {
          value: Xe
        } = l;
        Xe == null || Xe.blur();
      } else {
        const {
          value: Xe
        } = s;
        Xe == null || Xe.blur();
      }
    }
    function Ye() {
      var G, ae, Xe;
      e.filterable ? (g.value = !1, (G = c.value) === null || G === void 0 || G.focus()) : e.multiple ? (ae = l.value) === null || ae === void 0 || ae.focus() : (Xe = s.value) === null || Xe === void 0 || Xe.focus();
    }
    function Se() {
      const {
        value: G
      } = i;
      G && (I(), G.focus());
    }
    function _e() {
      const {
        value: G
      } = i;
      G && G.blur();
    }
    function Fe(G) {
      const {
        value: ae
      } = u;
      ae && ae.setTextContent(`+${G}`);
    }
    function ot() {
      const {
        value: G
      } = d;
      return G;
    }
    function Nt() {
      return i.value;
    }
    let A = null;
    function C() {
      A !== null && window.clearTimeout(A);
    }
    function E() {
      e.active || (C(), A = window.setTimeout(() => {
        T.value && (h.value = !0);
      }, 100));
    }
    function J() {
      C();
    }
    function H(G) {
      G || (C(), h.value = !1);
    }
    at(T, (G) => {
      G || (h.value = !1);
    }), et(() => {
      rr(() => {
        const G = c.value;
        G && (e.disabled ? G.removeAttribute("tabindex") : G.tabIndex = g.value ? -1 : 0);
      });
    }), aw(a, e.onResize);
    const {
      inlineThemeDisabled: X
    } = e, me = W(() => {
      const {
        size: G
      } = e, {
        common: {
          cubicBezierEaseInOut: ae
        },
        self: {
          borderRadius: Xe,
          color: gt,
          placeholderColor: yt,
          textColor: or,
          paddingSingle: Xt,
          paddingMultiple: jt,
          caretColor: ir,
          colorDisabled: gr,
          textColorDisabled: K,
          placeholderColorDisabled: P,
          colorActive: k,
          boxShadowFocus: U,
          boxShadowActive: ie,
          boxShadowHover: xe,
          border: Ie,
          borderFocus: Ae,
          borderHover: Le,
          borderActive: rt,
          arrowColor: At,
          arrowColorDisabled: Wr,
          loadingColor: $r,
          // form warning
          colorActiveWarning: jo,
          boxShadowFocusWarning: un,
          boxShadowActiveWarning: Qr,
          boxShadowHoverWarning: Ei,
          borderWarning: Ha,
          borderFocusWarning: Li,
          borderHoverWarning: ao,
          borderActiveWarning: R,
          // form error
          colorActiveError: oe,
          boxShadowFocusError: $e,
          boxShadowActiveError: ut,
          boxShadowHoverError: bt,
          borderError: st,
          borderFocusError: cn,
          borderHoverError: dn,
          borderActiveError: fn,
          // clear
          clearColor: Fn,
          clearColorHover: Un,
          clearColorPressed: lo,
          clearSize: Nn,
          // arrow
          arrowSize: ce,
          [ve("height", G)]: Ya,
          [ve("fontSize", G)]: Wa
        }
      } = v.value, so = Kn(Xt), it = Kn(jt);
      return {
        "--n-bezier": ae,
        "--n-border": Ie,
        "--n-border-active": rt,
        "--n-border-focus": Ae,
        "--n-border-hover": Le,
        "--n-border-radius": Xe,
        "--n-box-shadow-active": ie,
        "--n-box-shadow-focus": U,
        "--n-box-shadow-hover": xe,
        "--n-caret-color": ir,
        "--n-color": gt,
        "--n-color-active": k,
        "--n-color-disabled": gr,
        "--n-font-size": Wa,
        "--n-height": Ya,
        "--n-padding-single-top": so.top,
        "--n-padding-multiple-top": it.top,
        "--n-padding-single-right": so.right,
        "--n-padding-multiple-right": it.right,
        "--n-padding-single-left": so.left,
        "--n-padding-multiple-left": it.left,
        "--n-padding-single-bottom": so.bottom,
        "--n-padding-multiple-bottom": it.bottom,
        "--n-placeholder-color": yt,
        "--n-placeholder-color-disabled": P,
        "--n-text-color": or,
        "--n-text-color-disabled": K,
        "--n-arrow-color": At,
        "--n-arrow-color-disabled": Wr,
        "--n-loading-color": $r,
        // form warning
        "--n-color-active-warning": jo,
        "--n-box-shadow-focus-warning": un,
        "--n-box-shadow-active-warning": Qr,
        "--n-box-shadow-hover-warning": Ei,
        "--n-border-warning": Ha,
        "--n-border-focus-warning": Li,
        "--n-border-hover-warning": ao,
        "--n-border-active-warning": R,
        // form error
        "--n-color-active-error": oe,
        "--n-box-shadow-focus-error": $e,
        "--n-box-shadow-active-error": ut,
        "--n-box-shadow-hover-error": bt,
        "--n-border-error": st,
        "--n-border-focus-error": cn,
        "--n-border-hover-error": dn,
        "--n-border-active-error": fn,
        // clear
        "--n-clear-size": Nn,
        "--n-clear-color": Fn,
        "--n-clear-color-hover": Un,
        "--n-clear-color-pressed": lo,
        // arrow-size
        "--n-arrow-size": ce
      };
    }), Te = X ? dr("internal-selection", W(() => e.size[0]), me, e) : void 0;
    return {
      mergedTheme: v,
      mergedClearable: M,
      mergedClsPrefix: t,
      rtlEnabled: n,
      patternInputFocused: g,
      filterablePlaceholder: x,
      label: b,
      selected: T,
      showTagsPanel: h,
      isComposing: ne,
      // dom ref
      counterRef: u,
      counterWrapperRef: d,
      patternInputMirrorRef: o,
      patternInputRef: i,
      selfRef: a,
      multipleElRef: l,
      singleElRef: s,
      patternInputWrapperRef: c,
      overflowRef: f,
      inputTagElRef: p,
      handleMouseDown: ye,
      handleFocusin: j,
      handleClear: ee,
      handleMouseEnter: re,
      handleMouseLeave: le,
      handleDeleteOption: Me,
      handlePatternKeyDown: Ee,
      handlePatternInputInput: Ce,
      handlePatternInputBlur: Ge,
      handlePatternInputFocus: tt,
      handleMouseEnterCounter: E,
      handleMouseLeaveCounter: J,
      handleFocusout: q,
      handleCompositionEnd: ke,
      handleCompositionStart: ze,
      onPopoverUpdateShow: H,
      focus: Ye,
      focusInput: Se,
      blur: Ne,
      blurInput: _e,
      updateCounter: Fe,
      getCounter: ot,
      getTail: Nt,
      renderLabel: e.renderLabel,
      cssVars: X ? void 0 : me,
      themeClass: Te == null ? void 0 : Te.themeClass,
      onRender: Te == null ? void 0 : Te.onRender
    };
  },
  render() {
    const {
      status: e,
      multiple: t,
      size: r,
      disabled: n,
      filterable: o,
      maxTagCount: i,
      bordered: a,
      clsPrefix: l,
      ellipsisTagPopoverProps: s,
      onRender: c,
      renderTag: u,
      renderLabel: d
    } = this;
    c == null || c();
    const f = i === "responsive", p = typeof i == "number", h = f || p, g = S(qf, null, {
      default: () => S(iw, {
        clsPrefix: l,
        loading: this.loading,
        showArrow: this.showArrow,
        showClear: this.mergedClearable && this.selected,
        onClear: this.handleClear
      }, {
        default: () => {
          var v, M;
          return (M = (v = this.$slots).arrow) === null || M === void 0 ? void 0 : M.call(v);
        }
      })
    });
    let m;
    if (t) {
      const {
        labelField: v
      } = this, M = (z) => S("div", {
        class: `${l}-base-selection-tag-wrapper`,
        key: z.value
      }, u ? u({
        option: z,
        handleClose: () => {
          this.handleDeleteOption(z);
        }
      }) : S(ll, {
        size: r,
        closable: !z.disabled,
        disabled: n,
        onClose: () => {
          this.handleDeleteOption(z);
        },
        internalCloseIsButtonTag: !1,
        internalCloseFocusable: !1
      }, {
        default: () => d ? d(z, !0) : Xr(z[v], z, !0)
      })), x = () => (p ? this.selectedOptions.slice(0, i) : this.selectedOptions).map(M), b = o ? S("div", {
        class: `${l}-base-selection-input-tag`,
        ref: "inputTagElRef",
        key: "__input-tag__"
      }, S("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        tabindex: -1,
        disabled: n,
        value: this.pattern,
        autofocus: this.autofocus,
        class: `${l}-base-selection-input-tag__input`,
        onBlur: this.handlePatternInputBlur,
        onFocus: this.handlePatternInputFocus,
        onKeydown: this.handlePatternKeyDown,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), S("span", {
        ref: "patternInputMirrorRef",
        class: `${l}-base-selection-input-tag__mirror`
      }, this.pattern)) : null, T = f ? () => S("div", {
        class: `${l}-base-selection-tag-wrapper`,
        ref: "counterWrapperRef"
      }, S(ll, {
        size: r,
        ref: "counterRef",
        onMouseenter: this.handleMouseEnterCounter,
        onMouseleave: this.handleMouseLeaveCounter,
        disabled: n
      })) : void 0;
      let w;
      if (p) {
        const z = this.selectedOptions.length - i;
        z > 0 && (w = S("div", {
          class: `${l}-base-selection-tag-wrapper`,
          key: "__counter__"
        }, S(ll, {
          size: r,
          ref: "counterRef",
          onMouseenter: this.handleMouseEnterCounter,
          disabled: n
        }, {
          default: () => `+${z}`
        })));
      }
      const y = f ? o ? S(sb, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        getTail: this.getTail,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: x,
        counter: T,
        tail: () => b
      }) : S(sb, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: x,
        counter: T
      }) : p && w ? x().concat(w) : x(), I = h ? () => S("div", {
        class: `${l}-base-selection-popover`
      }, f ? x() : this.selectedOptions.map(M)) : void 0, D = h ? Object.assign({
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: !0,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      }, s) : null, O = !this.selected && (!this.active || !this.pattern && !this.isComposing) ? S("div", {
        class: `${l}-base-selection-placeholder ${l}-base-selection-overlay`
      }, S("div", {
        class: `${l}-base-selection-placeholder__inner`
      }, this.placeholder)) : null, $ = o ? S("div", {
        ref: "patternInputWrapperRef",
        class: `${l}-base-selection-tags`
      }, y, f ? null : b, g) : S("div", {
        ref: "multipleElRef",
        class: `${l}-base-selection-tags`,
        tabindex: n ? void 0 : 0
      }, y, g);
      m = S(qt, null, h ? S(Vc, Object.assign({}, D, {
        scrollable: !0,
        style: "max-height: calc(var(--v-target-height) * 6.6);"
      }), {
        trigger: () => $,
        default: I
      }) : $, O);
    } else if (o) {
      const v = this.pattern || this.isComposing, M = this.active ? !v : !this.selected, x = this.active ? !1 : this.selected;
      m = S("div", {
        ref: "patternInputWrapperRef",
        class: `${l}-base-selection-label`,
        title: this.patternInputFocused ? void 0 : ub(this.label)
      }, S("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        class: `${l}-base-selection-input`,
        value: this.active ? this.pattern : "",
        placeholder: "",
        readonly: n,
        disabled: n,
        tabindex: -1,
        autofocus: this.autofocus,
        onFocus: this.handlePatternInputFocus,
        onBlur: this.handlePatternInputBlur,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), x ? S("div", {
        class: `${l}-base-selection-label__render-label ${l}-base-selection-overlay`,
        key: "input"
      }, S("div", {
        class: `${l}-base-selection-overlay__wrapper`
      }, u ? u({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : d ? d(this.selectedOption, !0) : Xr(this.label, this.selectedOption, !0))) : null, M ? S("div", {
        class: `${l}-base-selection-placeholder ${l}-base-selection-overlay`,
        key: "placeholder"
      }, S("div", {
        class: `${l}-base-selection-overlay__wrapper`
      }, this.filterablePlaceholder)) : null, g);
    } else
      m = S("div", {
        ref: "singleElRef",
        class: `${l}-base-selection-label`,
        tabindex: this.disabled ? void 0 : 0
      }, this.label !== void 0 ? S("div", {
        class: `${l}-base-selection-input`,
        title: ub(this.label),
        key: "input"
      }, S("div", {
        class: `${l}-base-selection-input__content`
      }, u ? u({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : d ? d(this.selectedOption, !0) : Xr(this.label, this.selectedOption, !0))) : S("div", {
        class: `${l}-base-selection-placeholder ${l}-base-selection-overlay`,
        key: "placeholder"
      }, S("div", {
        class: `${l}-base-selection-placeholder__inner`
      }, this.placeholder)), g);
    return S("div", {
      ref: "selfRef",
      class: [`${l}-base-selection`, this.rtlEnabled && `${l}-base-selection--rtl`, this.themeClass, e && `${l}-base-selection--${e}-status`, {
        [`${l}-base-selection--active`]: this.active,
        [`${l}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${l}-base-selection--disabled`]: this.disabled,
        [`${l}-base-selection--multiple`]: this.multiple,
        // focus is not controlled by selection itself since it always need
        // to be managed together with menu. provide :focus style will cause
        // many redundant codes.
        [`${l}-base-selection--focus`]: this.focused
      }],
      style: this.cssVars,
      onClick: this.onClick,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onKeydown: this.onKeydown,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onMousedown: this.handleMouseDown
    }, m, a ? S("div", {
      class: `${l}-base-selection__border`
    }) : null, a ? S("div", {
      class: `${l}-base-selection__state-border`
    }) : null);
  }
}), Jj = Z({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(e) {
    return () => S("div", {
      style: "width: 0; height: 0",
      tabindex: 0,
      onFocus: e.onFocus,
      onBlur: e.onBlur
    });
  }
});
function Hd(e) {
  const t = e.filter((r) => r !== void 0);
  if (t.length !== 0)
    return t.length === 1 ? t[0] : (r) => {
      e.forEach((n) => {
        n && n(r);
      });
    };
}
const Xj = Z({
  name: "Checkmark",
  render() {
    return S("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, S("g", {
      fill: "none"
    }, S("path", {
      d: "M14.046 3.486a.75.75 0 0 1-.032 1.06l-7.93 7.474a.85.85 0 0 1-1.188-.022l-2.68-2.72a.75.75 0 1 1 1.068-1.053l2.234 2.267l7.468-7.038a.75.75 0 0 1 1.06.032z",
      fill: "currentColor"
    })));
  }
});
function e5(e, t) {
  return S(zn, {
    name: "fade-in-scale-up-transition"
  }, {
    default: () => e ? S(On, {
      clsPrefix: t,
      class: `${t}-base-select-option__check`
    }, {
      default: () => S(Xj)
    }) : null
  });
}
const cb = Z({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const {
      valueRef: t,
      pendingTmNodeRef: r,
      multipleRef: n,
      valueSetRef: o,
      renderLabelRef: i,
      renderOptionRef: a,
      labelFieldRef: l,
      valueFieldRef: s,
      showCheckmarkRef: c,
      nodePropsRef: u,
      handleOptionClick: d,
      handleOptionMouseEnter: f
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = De(Sm), p = _t(() => {
      const {
        value: v
      } = r;
      return v ? e.tmNode.key === v.key : !1;
    });
    function h(v) {
      const {
        tmNode: M
      } = e;
      M.disabled || d(v, M);
    }
    function g(v) {
      const {
        tmNode: M
      } = e;
      M.disabled || f(v, M);
    }
    function m(v) {
      const {
        tmNode: M
      } = e, {
        value: x
      } = p;
      M.disabled || x || f(v, M);
    }
    return {
      multiple: n,
      isGrouped: _t(() => {
        const {
          tmNode: v
        } = e, {
          parent: M
        } = v;
        return M && M.rawNode.type === "group";
      }),
      showCheckmark: c,
      nodeProps: u,
      isPending: p,
      isSelected: _t(() => {
        const {
          value: v
        } = t, {
          value: M
        } = n;
        if (v === null)
          return !1;
        const x = e.tmNode.rawNode[s.value];
        if (M) {
          const {
            value: b
          } = o;
          return b.has(x);
        } else
          return v === x;
      }),
      labelField: l,
      renderLabel: i,
      renderOption: a,
      handleMouseMove: m,
      handleMouseEnter: g,
      handleClick: h
    };
  },
  render() {
    const {
      clsPrefix: e,
      tmNode: {
        rawNode: t
      },
      isSelected: r,
      isPending: n,
      isGrouped: o,
      showCheckmark: i,
      nodeProps: a,
      renderOption: l,
      renderLabel: s,
      handleClick: c,
      handleMouseEnter: u,
      handleMouseMove: d
    } = this, f = e5(r, e), p = s ? [s(t, r), i && f] : [Xr(t[this.labelField], t, r), i && f], h = a == null ? void 0 : a(t), g = S("div", Object.assign({}, h, {
      class: [`${e}-base-select-option`, t.class, h == null ? void 0 : h.class, {
        [`${e}-base-select-option--disabled`]: t.disabled,
        [`${e}-base-select-option--selected`]: r,
        [`${e}-base-select-option--grouped`]: o,
        [`${e}-base-select-option--pending`]: n,
        [`${e}-base-select-option--show-checkmark`]: i
      }],
      style: [(h == null ? void 0 : h.style) || "", t.style || ""],
      onClick: Hd([c, h == null ? void 0 : h.onClick]),
      onMouseenter: Hd([u, h == null ? void 0 : h.onMouseenter]),
      onMousemove: Hd([d, h == null ? void 0 : h.onMousemove])
    }), S("div", {
      class: `${e}-base-select-option__content`
    }, p));
    return t.render ? t.render({
      node: g,
      option: t,
      selected: r
    }) : l ? l({
      node: g,
      option: t,
      selected: r
    }) : g;
  }
}), db = Z({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      renderLabelRef: e,
      renderOptionRef: t,
      labelFieldRef: r,
      nodePropsRef: n
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = De(Sm);
    return {
      labelField: r,
      nodeProps: n,
      renderLabel: e,
      renderOption: t
    };
  },
  render() {
    const {
      clsPrefix: e,
      renderLabel: t,
      renderOption: r,
      nodeProps: n,
      tmNode: {
        rawNode: o
      }
    } = this, i = n == null ? void 0 : n(o), a = t ? t(o, !1) : Xr(o[this.labelField], o, !1), l = S("div", Object.assign({}, i, {
      class: [`${e}-base-select-group-header`, i == null ? void 0 : i.class]
    }), a);
    return o.render ? o.render({
      node: l,
      option: o
    }) : r ? r({
      node: l,
      option: o,
      selected: !1
    }) : l;
  }
}), t5 = te("base-select-menu", `
 line-height: 1.5;
 outline: none;
 z-index: 0;
 position: relative;
 border-radius: var(--n-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-color);
`, [te("scrollbar", `
 max-height: var(--n-height);
 `), te("virtual-list", `
 max-height: var(--n-height);
 `), te("base-select-option", `
 min-height: var(--n-option-height);
 font-size: var(--n-option-font-size);
 display: flex;
 align-items: center;
 `, [F("content", `
 z-index: 1;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 `)]), te("base-select-group-header", `
 min-height: var(--n-option-height);
 font-size: .93em;
 display: flex;
 align-items: center;
 `), te("base-select-menu-option-wrapper", `
 position: relative;
 width: 100%;
 `), F("loading, empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), F("loading", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 `), F("header", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), F("action", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), te("base-select-group-header", `
 position: relative;
 cursor: default;
 padding: var(--n-option-padding);
 color: var(--n-group-header-text-color);
 `), te("base-select-option", `
 cursor: pointer;
 position: relative;
 padding: var(--n-option-padding);
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 box-sizing: border-box;
 color: var(--n-option-text-color);
 opacity: 1;
 `, [fe("show-checkmark", `
 padding-right: calc(var(--n-option-padding-right) + 20px);
 `), V("&::before", `
 content: "";
 position: absolute;
 left: 4px;
 right: 4px;
 top: 0;
 bottom: 0;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), V("&:active", `
 color: var(--n-option-text-color-pressed);
 `), fe("grouped", `
 padding-left: calc(var(--n-option-padding-left) * 1.5);
 `), fe("pending", [V("&::before", `
 background-color: var(--n-option-color-pending);
 `)]), fe("selected", `
 color: var(--n-option-text-color-active);
 `, [V("&::before", `
 background-color: var(--n-option-color-active);
 `), fe("pending", [V("&::before", `
 background-color: var(--n-option-color-active-pending);
 `)])]), fe("disabled", `
 cursor: not-allowed;
 `, [$t("selected", `
 color: var(--n-option-text-color-disabled);
 `), fe("selected", `
 opacity: var(--n-option-opacity-disabled);
 `)]), F("check", `
 font-size: 16px;
 position: absolute;
 right: calc(var(--n-option-padding-right) - 4px);
 top: calc(50% - 7px);
 color: var(--n-option-check-color);
 transition: color .3s var(--n-bezier);
 `, [Em({
  enterScale: "0.5"
})])])]), r5 = {
  height: "calc(var(--n-option-height) * 7.6)",
  paddingSmall: "4px 0",
  paddingMedium: "4px 0",
  paddingLarge: "4px 0",
  paddingHuge: "4px 0",
  optionPaddingSmall: "0 12px",
  optionPaddingMedium: "0 12px",
  optionPaddingLarge: "0 12px",
  optionPaddingHuge: "0 12px",
  loadingSize: "18px"
}, n5 = {
  iconSizeSmall: "34px",
  iconSizeMedium: "40px",
  iconSizeLarge: "46px",
  iconSizeHuge: "52px"
}, o5 = (e) => {
  const {
    textColorDisabled: t,
    iconColor: r,
    textColor2: n,
    fontSizeSmall: o,
    fontSizeMedium: i,
    fontSizeLarge: a,
    fontSizeHuge: l
  } = e;
  return Object.assign(Object.assign({}, n5), {
    fontSizeSmall: o,
    fontSizeMedium: i,
    fontSizeLarge: a,
    fontSizeHuge: l,
    textColor: t,
    iconColor: r,
    extraTextColor: n
  });
}, i5 = {
  name: "Empty",
  common: Jt,
  self: o5
}, lw = i5, a5 = (e) => {
  const {
    borderRadius: t,
    popoverColor: r,
    textColor3: n,
    dividerColor: o,
    textColor2: i,
    primaryColorPressed: a,
    textColorDisabled: l,
    primaryColor: s,
    opacityDisabled: c,
    hoverColor: u,
    fontSizeSmall: d,
    fontSizeMedium: f,
    fontSizeLarge: p,
    fontSizeHuge: h,
    heightSmall: g,
    heightMedium: m,
    heightLarge: v,
    heightHuge: M
  } = e;
  return Object.assign(Object.assign({}, r5), {
    optionFontSizeSmall: d,
    optionFontSizeMedium: f,
    optionFontSizeLarge: p,
    optionFontSizeHuge: h,
    optionHeightSmall: g,
    optionHeightMedium: m,
    optionHeightLarge: v,
    optionHeightHuge: M,
    borderRadius: t,
    color: r,
    groupHeaderTextColor: n,
    actionDividerColor: o,
    optionTextColor: i,
    optionTextColorPressed: a,
    optionTextColorDisabled: l,
    optionTextColorActive: s,
    optionOpacityDisabled: c,
    optionCheckColor: s,
    optionColorPending: u,
    optionColorActive: "rgba(0, 0, 0, 0)",
    optionColorActivePending: u,
    actionTextColor: i,
    loadingColor: s
  });
}, l5 = {
  name: "InternalSelectMenu",
  common: Jt,
  peers: {
    Scrollbar: Dm,
    Empty: lw
  },
  self: a5
}, sw = l5;
let Fs;
function s5() {
  return typeof document > "u" ? !1 : (Fs === void 0 && ("matchMedia" in window ? Fs = window.matchMedia("(pointer:coarse)").matches : Fs = !1), Fs);
}
let Yd;
function fb() {
  return typeof document > "u" ? 1 : (Yd === void 0 && (Yd = "chrome" in window ? window.devicePixelRatio : 1), Yd);
}
function pb(e) {
  return e & -e;
}
let u5 = class {
  /**
   * @param l length of the array
   * @param min min value of the array
   */
  constructor(t, r) {
    this.l = t, this.min = r;
    const n = new Array(t + 1);
    for (let o = 0; o < t + 1; ++o)
      n[o] = 0;
    this.ft = n;
  }
  /**
   * Add arr[i] by n, start from 0
   * @param i the index of the element to be added
   * @param n the value to be added
   */
  add(t, r) {
    if (r === 0)
      return;
    const { l: n, ft: o } = this;
    for (t += 1; t <= n; )
      o[t] += r, t += pb(t);
  }
  /**
   * Get the value of index i
   * @param i index
   * @returns value of the index
   */
  get(t) {
    return this.sum(t + 1) - this.sum(t);
  }
  /**
   * Get the sum of first i elements
   * @param i count of head elements to be added
   * @returns the sum of first i elements
   */
  sum(t) {
    if (t === void 0 && (t = this.l), t <= 0)
      return 0;
    const { ft: r, min: n, l: o } = this;
    if (t > o)
      throw new Error("[FinweckTree.sum]: `i` is larger than length.");
    let i = t * n;
    for (; t > 0; )
      i += r[t], t -= pb(t);
    return i;
  }
  /**
   * Get the largest count of head elements whose sum are <= threshold
   * @param threshold
   * @returns the largest count of head elements whose sum are <= threshold
   */
  getBound(t) {
    let r = 0, n = this.l;
    for (; n > r; ) {
      const o = Math.floor((r + n) / 2), i = this.sum(o);
      if (i > t) {
        n = o;
        continue;
      } else if (i < t) {
        if (r === o)
          return this.sum(r + 1) <= t ? r + 1 : o;
        r = o;
      } else
        return o;
    }
    return r;
  }
};
function hb(e) {
  return typeof e == "string" ? e.endsWith("px") ? Number(e.slice(0, e.length - 2)) : Number(e) : e;
}
function Us(e) {
  if (e != null)
    return typeof e == "number" ? `${e}px` : e.endsWith("px") ? e : `${e}px`;
}
const c5 = bo(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
  // a zero width container won't be scrollable
}, [
  bo("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    bo("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]), d5 = Z({
  name: "VirtualList",
  inheritAttrs: !1,
  props: {
    showScrollbar: {
      type: Boolean,
      default: !0
    },
    items: {
      type: Array,
      default: () => []
    },
    // it is suppose to be the min height
    itemSize: {
      type: Number,
      required: !0
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    // Whether it is a good API?
    // ResizeObserver + footer & header is not enough.
    // Too complex for simple case
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(e) {
    const t = bi();
    c5.mount({
      id: "vueuc/virtual-list",
      head: !0,
      anchorMetaName: Cm,
      ssr: t
    }), et(() => {
      const { defaultScrollIndex: $, defaultScrollKey: z } = e;
      $ != null ? h({ index: $ }) : z != null && h({ key: z });
    });
    let r = !1, n = !1;
    S1(() => {
      if (r = !1, !n) {
        n = !0;
        return;
      }
      h({ top: d.value, left: u });
    }), Jg(() => {
      r = !0, n || (n = !0);
    });
    const o = W(() => {
      const $ = /* @__PURE__ */ new Map(), { keyField: z } = e;
      return e.items.forEach((Y, j) => {
        $.set(Y[z], j);
      }), $;
    }), i = L(null), a = L(void 0), l = /* @__PURE__ */ new Map(), s = W(() => {
      const { items: $, itemSize: z, keyField: Y } = e, j = new u5($.length, z);
      return $.forEach((q, ee) => {
        const re = q[Y], le = l.get(re);
        le !== void 0 && j.add(ee, le);
      }), j;
    }), c = L(0);
    let u = 0;
    const d = L(0), f = _t(() => Math.max(s.value.getBound(d.value - hb(e.paddingTop)) - 1, 0)), p = W(() => {
      const { value: $ } = a;
      if ($ === void 0)
        return [];
      const { items: z, itemSize: Y } = e, j = f.value, q = Math.min(j + Math.ceil($ / Y + 1), z.length - 1), ee = [];
      for (let re = j; re <= q; ++re)
        ee.push(z[re]);
      return ee;
    }), h = ($, z) => {
      if (typeof $ == "number") {
        M($, z, "auto");
        return;
      }
      const { left: Y, top: j, index: q, key: ee, position: re, behavior: le, debounce: ye = !0 } = $;
      if (Y !== void 0 || j !== void 0)
        M(Y, j, le);
      else if (q !== void 0)
        v(q, le, ye);
      else if (ee !== void 0) {
        const Me = o.value.get(ee);
        Me !== void 0 && v(Me, le, ye);
      } else
        re === "bottom" ? M(0, Number.MAX_SAFE_INTEGER, le) : re === "top" && M(0, 0, le);
    };
    let g, m = null;
    function v($, z, Y) {
      const { value: j } = s, q = j.sum($) + hb(e.paddingTop);
      if (!Y)
        i.value.scrollTo({
          left: 0,
          top: q,
          behavior: z
        });
      else {
        g = $, m !== null && window.clearTimeout(m), m = window.setTimeout(() => {
          g = void 0, m = null;
        }, 16);
        const { scrollTop: ee, offsetHeight: re } = i.value;
        if (q > ee) {
          const le = j.get($);
          q + le <= ee + re || i.value.scrollTo({
            left: 0,
            top: q + le - re,
            behavior: z
          });
        } else
          i.value.scrollTo({
            left: 0,
            top: q,
            behavior: z
          });
      }
    }
    function M($, z, Y) {
      i.value.scrollTo({
        left: $,
        top: z,
        behavior: Y
      });
    }
    function x($, z) {
      var Y, j, q;
      if (r || e.ignoreItemResize || O(z.target))
        return;
      const { value: ee } = s, re = o.value.get($), le = ee.get(re), ye = (q = (j = (Y = z.borderBoxSize) === null || Y === void 0 ? void 0 : Y[0]) === null || j === void 0 ? void 0 : j.blockSize) !== null && q !== void 0 ? q : z.contentRect.height;
      if (ye === le)
        return;
      ye - e.itemSize === 0 ? l.delete($) : l.set($, ye - e.itemSize);
      const Me = ye - le;
      if (Me === 0)
        return;
      ee.add(re, Me);
      const Ee = i.value;
      if (Ee != null) {
        if (g === void 0) {
          const ne = ee.sum(re);
          Ee.scrollTop > ne && Ee.scrollBy(0, Me);
        } else if (re < g)
          Ee.scrollBy(0, Me);
        else if (re === g) {
          const ne = ee.sum(re);
          ye + ne > // Note, listEl shouldn't have border, nor offsetHeight won't be
          // correct
          Ee.scrollTop + Ee.offsetHeight && Ee.scrollBy(0, Me);
        }
        D();
      }
      c.value++;
    }
    const b = !s5();
    let T = !1;
    function w($) {
      var z;
      (z = e.onScroll) === null || z === void 0 || z.call(e, $), (!b || !T) && D();
    }
    function y($) {
      var z;
      if ((z = e.onWheel) === null || z === void 0 || z.call(e, $), b) {
        const Y = i.value;
        if (Y != null) {
          if ($.deltaX === 0 && (Y.scrollTop === 0 && $.deltaY <= 0 || Y.scrollTop + Y.offsetHeight >= Y.scrollHeight && $.deltaY >= 0))
            return;
          $.preventDefault(), Y.scrollTop += $.deltaY / fb(), Y.scrollLeft += $.deltaX / fb(), D(), T = !0, Zx(() => {
            T = !1;
          });
        }
      }
    }
    function I($) {
      if (r || O($.target) || $.contentRect.height === a.value)
        return;
      a.value = $.contentRect.height;
      const { onResize: z } = e;
      z !== void 0 && z($);
    }
    function D() {
      const { value: $ } = i;
      $ != null && (d.value = $.scrollTop, u = $.scrollLeft);
    }
    function O($) {
      let z = $;
      for (; z !== null; ) {
        if (z.style.display === "none")
          return !0;
        z = z.parentElement;
      }
      return !1;
    }
    return {
      listHeight: a,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: o,
      itemsStyle: W(() => {
        const { itemResizable: $ } = e, z = Us(s.value.sum());
        return c.value, [
          e.itemsStyle,
          {
            boxSizing: "content-box",
            height: $ ? "" : z,
            minHeight: $ ? z : "",
            paddingTop: Us(e.paddingTop),
            paddingBottom: Us(e.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: W(() => (c.value, {
        transform: `translateY(${Us(s.value.sum(f.value))})`
      })),
      viewportItems: p,
      listElRef: i,
      itemsElRef: L(null),
      scrollTo: h,
      handleListResize: I,
      handleListScroll: w,
      handleListWheel: y,
      handleItemResize: x
    };
  },
  render() {
    const { itemResizable: e, keyField: t, keyToIndex: r, visibleItemsTag: n } = this;
    return S(sa, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var o, i;
        return S("div", Ut(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? S("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            S(n, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => this.viewportItems.map((a) => {
                const l = a[t], s = r.get(l), c = this.$slots.default({
                  item: a,
                  index: s
                })[0];
                return e ? S(sa, {
                  key: l,
                  onResize: (u) => this.handleItemResize(l, u)
                }, {
                  default: () => c
                }) : (c.key = l, c);
              })
            })
          ]) : (i = (o = this.$slots).empty) === null || i === void 0 ? void 0 : i.call(o)
        ]);
      }
    });
  }
});
function Hu(e, t) {
  let { target: r } = e;
  for (; r; ) {
    if (r.dataset && r.dataset[t] !== void 0)
      return !0;
    r = r.parentElement;
  }
  return !1;
}
const f5 = te("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [F("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [V("+", [F("description", `
 margin-top: 8px;
 `)])]), F("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), F("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]), p5 = Z({
  name: "Empty",
  render() {
    return S("svg", {
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, S("path", {
      d: "M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z",
      fill: "currentColor"
    }), S("path", {
      d: "M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z",
      fill: "currentColor"
    }));
  }
}), h5 = Object.assign(Object.assign({}, Ve.props), {
  description: String,
  showDescription: {
    type: Boolean,
    default: !0
  },
  showIcon: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  renderIcon: Function
}), g5 = Z({
  name: "Empty",
  props: h5,
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      inlineThemeDisabled: r
    } = Bt(e), n = Ve("Empty", "-empty", f5, lw, e, t), {
      localeRef: o
    } = Zc("Empty"), i = De(Do, null), a = W(() => {
      var u, d, f;
      return (u = e.description) !== null && u !== void 0 ? u : (f = (d = i == null ? void 0 : i.mergedComponentPropsRef.value) === null || d === void 0 ? void 0 : d.Empty) === null || f === void 0 ? void 0 : f.description;
    }), l = W(() => {
      var u, d;
      return ((d = (u = i == null ? void 0 : i.mergedComponentPropsRef.value) === null || u === void 0 ? void 0 : u.Empty) === null || d === void 0 ? void 0 : d.renderIcon) || (() => S(p5, null));
    }), s = W(() => {
      const {
        size: u
      } = e, {
        common: {
          cubicBezierEaseInOut: d
        },
        self: {
          [ve("iconSize", u)]: f,
          [ve("fontSize", u)]: p,
          textColor: h,
          iconColor: g,
          extraTextColor: m
        }
      } = n.value;
      return {
        "--n-icon-size": f,
        "--n-font-size": p,
        "--n-bezier": d,
        "--n-text-color": h,
        "--n-icon-color": g,
        "--n-extra-text-color": m
      };
    }), c = r ? dr("empty", W(() => {
      let u = "";
      const {
        size: d
      } = e;
      return u += d[0], u;
    }), s, e) : void 0;
    return {
      mergedClsPrefix: t,
      mergedRenderIcon: l,
      localizedDescription: W(() => a.value || o.value.description),
      cssVars: r ? void 0 : s,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender
    };
  },
  render() {
    const {
      $slots: e,
      mergedClsPrefix: t,
      onRender: r
    } = this;
    return r == null || r(), S("div", {
      class: [`${t}-empty`, this.themeClass],
      style: this.cssVars
    }, this.showIcon ? S("div", {
      class: `${t}-empty__icon`
    }, e.icon ? e.icon() : S(On, {
      clsPrefix: t
    }, {
      default: this.mergedRenderIcon
    })) : null, this.showDescription ? S("div", {
      class: `${t}-empty__description`
    }, e.default ? e.default() : this.localizedDescription) : null, e.extra ? S("div", {
      class: `${t}-empty__extra`
    }, e.extra()) : null);
  }
}), m5 = Z({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, Ve.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    scrollable: {
      type: Boolean,
      default: !0
    },
    treeMate: {
      type: Object,
      required: !0
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: !0
    },
    // show is used to toggle pending state initialization
    show: {
      type: Boolean,
      default: !0
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: {
      type: Boolean,
      default: !0
    },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    inlineThemeDisabled: Boolean,
    // deprecated
    onToggle: Function
  }),
  setup(e) {
    const {
      mergedClsPrefixRef: t,
      mergedRtlRef: r
    } = Bt(e), n = yn("InternalSelectMenu", r, t), o = Ve("InternalSelectMenu", "-internal-select-menu", t5, sw, e, We(e, "clsPrefix")), i = L(null), a = L(null), l = L(null), s = W(() => e.treeMate.getFlattenedNodes()), c = W(() => B3(s.value)), u = L(null);
    function d() {
      const {
        treeMate: ne
      } = e;
      let ue = null;
      const {
        value: Ce
      } = e;
      Ce === null ? ue = ne.getFirstAvailableNode() : (e.multiple ? ue = ne.getNode((Ce || [])[(Ce || []).length - 1]) : ue = ne.getNode(Ce), (!ue || ue.disabled) && (ue = ne.getFirstAvailableNode())), j(ue || null);
    }
    function f() {
      const {
        value: ne
      } = u;
      ne && !e.treeMate.getNode(ne.key) && (u.value = null);
    }
    let p;
    at(() => e.show, (ne) => {
      ne ? p = at(() => e.treeMate, () => {
        e.resetMenuOnOptionsChange ? (e.autoPending ? d() : f(), mn(q)) : f();
      }, {
        immediate: !0
      }) : p == null || p();
    }, {
      immediate: !0
    }), vt(() => {
      p == null || p();
    });
    const h = W(() => _L(o.value.self[ve("optionHeight", e.size)])), g = W(() => Kn(o.value.self[ve("padding", e.size)])), m = W(() => e.multiple && Array.isArray(e.value) ? new Set(e.value) : /* @__PURE__ */ new Set()), v = W(() => {
      const ne = s.value;
      return ne && ne.length === 0;
    });
    function M(ne) {
      const {
        onToggle: ue
      } = e;
      ue && ue(ne);
    }
    function x(ne) {
      const {
        onScroll: ue
      } = e;
      ue && ue(ne);
    }
    function b(ne) {
      var ue;
      (ue = l.value) === null || ue === void 0 || ue.sync(), x(ne);
    }
    function T() {
      var ne;
      (ne = l.value) === null || ne === void 0 || ne.sync();
    }
    function w() {
      const {
        value: ne
      } = u;
      return ne || null;
    }
    function y(ne, ue) {
      ue.disabled || j(ue, !1);
    }
    function I(ne, ue) {
      ue.disabled || M(ue);
    }
    function D(ne) {
      var ue;
      Hu(ne, "action") || (ue = e.onKeyup) === null || ue === void 0 || ue.call(e, ne);
    }
    function O(ne) {
      var ue;
      Hu(ne, "action") || (ue = e.onKeydown) === null || ue === void 0 || ue.call(e, ne);
    }
    function $(ne) {
      var ue;
      (ue = e.onMousedown) === null || ue === void 0 || ue.call(e, ne), !e.focusable && ne.preventDefault();
    }
    function z() {
      const {
        value: ne
      } = u;
      ne && j(ne.getNext({
        loop: !0
      }), !0);
    }
    function Y() {
      const {
        value: ne
      } = u;
      ne && j(ne.getPrev({
        loop: !0
      }), !0);
    }
    function j(ne, ue = !1) {
      u.value = ne, ue && q();
    }
    function q() {
      var ne, ue;
      const Ce = u.value;
      if (!Ce)
        return;
      const ze = c.value(Ce.key);
      ze !== null && (e.virtualScroll ? (ne = a.value) === null || ne === void 0 || ne.scrollTo({
        index: ze
      }) : (ue = l.value) === null || ue === void 0 || ue.scrollTo({
        index: ze,
        elSize: h.value
      }));
    }
    function ee(ne) {
      var ue, Ce;
      !((ue = i.value) === null || ue === void 0) && ue.contains(ne.target) && ((Ce = e.onFocus) === null || Ce === void 0 || Ce.call(e, ne));
    }
    function re(ne) {
      var ue, Ce;
      !((ue = i.value) === null || ue === void 0) && ue.contains(ne.relatedTarget) || (Ce = e.onBlur) === null || Ce === void 0 || Ce.call(e, ne);
    }
    Et(Sm, {
      handleOptionMouseEnter: y,
      handleOptionClick: I,
      valueSetRef: m,
      pendingTmNodeRef: u,
      nodePropsRef: We(e, "nodeProps"),
      showCheckmarkRef: We(e, "showCheckmark"),
      multipleRef: We(e, "multiple"),
      valueRef: We(e, "value"),
      renderLabelRef: We(e, "renderLabel"),
      renderOptionRef: We(e, "renderOption"),
      labelFieldRef: We(e, "labelField"),
      valueFieldRef: We(e, "valueField")
    }), Et(Ex, i), et(() => {
      const {
        value: ne
      } = l;
      ne && ne.sync();
    });
    const le = W(() => {
      const {
        size: ne
      } = e, {
        common: {
          cubicBezierEaseInOut: ue
        },
        self: {
          height: Ce,
          borderRadius: ze,
          color: ke,
          groupHeaderTextColor: tt,
          actionDividerColor: Ge,
          optionTextColorPressed: Ne,
          optionTextColor: Ye,
          optionTextColorDisabled: Se,
          optionTextColorActive: _e,
          optionOpacityDisabled: Fe,
          optionCheckColor: ot,
          actionTextColor: Nt,
          optionColorPending: A,
          optionColorActive: C,
          loadingColor: E,
          loadingSize: J,
          optionColorActivePending: H,
          [ve("optionFontSize", ne)]: X,
          [ve("optionHeight", ne)]: me,
          [ve("optionPadding", ne)]: Te
        }
      } = o.value;
      return {
        "--n-height": Ce,
        "--n-action-divider-color": Ge,
        "--n-action-text-color": Nt,
        "--n-bezier": ue,
        "--n-border-radius": ze,
        "--n-color": ke,
        "--n-option-font-size": X,
        "--n-group-header-text-color": tt,
        "--n-option-check-color": ot,
        "--n-option-color-pending": A,
        "--n-option-color-active": C,
        "--n-option-color-active-pending": H,
        "--n-option-height": me,
        "--n-option-opacity-disabled": Fe,
        "--n-option-text-color": Ye,
        "--n-option-text-color-active": _e,
        "--n-option-text-color-disabled": Se,
        "--n-option-text-color-pressed": Ne,
        "--n-option-padding": Te,
        "--n-option-padding-left": Kn(Te, "left"),
        "--n-option-padding-right": Kn(Te, "right"),
        "--n-loading-color": E,
        "--n-loading-size": J
      };
    }), {
      inlineThemeDisabled: ye
    } = e, Me = ye ? dr("internal-select-menu", W(() => e.size[0]), le, e) : void 0, Ee = {
      selfRef: i,
      next: z,
      prev: Y,
      getPendingTmNode: w
    };
    return aw(i, e.onResize), Object.assign({
      mergedTheme: o,
      mergedClsPrefix: t,
      rtlEnabled: n,
      virtualListRef: a,
      scrollbarRef: l,
      itemSize: h,
      padding: g,
      flattenedNodes: s,
      empty: v,
      virtualListContainer() {
        const {
          value: ne
        } = a;
        return ne == null ? void 0 : ne.listElRef;
      },
      virtualListContent() {
        const {
          value: ne
        } = a;
        return ne == null ? void 0 : ne.itemsElRef;
      },
      doScroll: x,
      handleFocusin: ee,
      handleFocusout: re,
      handleKeyUp: D,
      handleKeyDown: O,
      handleMouseDown: $,
      handleVirtualListResize: T,
      handleVirtualListScroll: b,
      cssVars: ye ? void 0 : le,
      themeClass: Me == null ? void 0 : Me.themeClass,
      onRender: Me == null ? void 0 : Me.onRender
    }, Ee);
  },
  render() {
    const {
      $slots: e,
      virtualScroll: t,
      clsPrefix: r,
      mergedTheme: n,
      themeClass: o,
      onRender: i
    } = this;
    return i == null || i(), S("div", {
      ref: "selfRef",
      tabindex: this.focusable ? 0 : -1,
      class: [`${r}-base-select-menu`, this.rtlEnabled && `${r}-base-select-menu--rtl`, o, this.multiple && `${r}-base-select-menu--multiple`],
      style: this.cssVars,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onKeyup: this.handleKeyUp,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, mt(e.header, (a) => a && S("div", {
      class: `${r}-base-select-menu__header`,
      "data-header": !0,
      key: "header"
    }, a)), this.loading ? S("div", {
      class: `${r}-base-select-menu__loading`
    }, S(dm, {
      clsPrefix: r,
      strokeWidth: 20
    })) : this.empty ? S("div", {
      class: `${r}-base-select-menu__empty`,
      "data-empty": !0
    }, hn(e.empty, () => [S(g5, {
      theme: n.peers.Empty,
      themeOverrides: n.peerOverrides.Empty
    })])) : S(km, {
      ref: "scrollbarRef",
      theme: n.peers.Scrollbar,
      themeOverrides: n.peerOverrides.Scrollbar,
      scrollable: this.scrollable,
      container: t ? this.virtualListContainer : void 0,
      content: t ? this.virtualListContent : void 0,
      onScroll: t ? void 0 : this.doScroll
    }, {
      default: () => t ? S(d5, {
        ref: "virtualListRef",
        class: `${r}-virtual-list`,
        items: this.flattenedNodes,
        itemSize: this.itemSize,
        showScrollbar: !1,
        paddingTop: this.padding.top,
        paddingBottom: this.padding.bottom,
        onResize: this.handleVirtualListResize,
        onScroll: this.handleVirtualListScroll,
        itemResizable: !0
      }, {
        default: ({
          item: a
        }) => a.isGroup ? S(db, {
          key: a.key,
          clsPrefix: r,
          tmNode: a
        }) : a.ignored ? null : S(cb, {
          clsPrefix: r,
          key: a.key,
          tmNode: a
        })
      }) : S("div", {
        class: `${r}-base-select-menu-option-wrapper`,
        style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        }
      }, this.flattenedNodes.map((a) => a.isGroup ? S(db, {
        key: a.key,
        clsPrefix: r,
        tmNode: a
      }) : S(cb, {
        clsPrefix: r,
        key: a.key,
        tmNode: a
      })))
    }), mt(e.action, (a) => a && [S("div", {
      class: `${r}-base-select-menu__action`,
      "data-action": !0,
      key: "action"
    }, a), S(Jj, {
      onFocus: this.onTabOut,
      key: "focus-detector"
    })]));
  }
});
function v5(e) {
  const {
    boxShadow2: t
  } = e;
  return {
    menuBoxShadow: t
  };
}
const b5 = {
  name: "Select",
  common: Jt,
  peers: {
    InternalSelection: ow,
    InternalSelectMenu: sw
  },
  self: v5
}, M5 = b5, uw = /* @__PURE__ */ new WeakSet();
function y5(e) {
  uw.add(e);
}
function x5(e) {
  return !uw.has(e);
}
const w5 = Object.assign(Object.assign({}, Ve.props), {
  to: Xn.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: !0
  },
  options: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  value: [String, Number, Array],
  placeholder: String,
  menuProps: Object,
  multiple: Boolean,
  size: String,
  filterable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  remote: Boolean,
  loading: Boolean,
  filter: Function,
  placement: {
    type: String,
    default: "bottom-start"
  },
  widthMode: {
    type: String,
    default: "trigger"
  },
  tag: Boolean,
  onCreate: Function,
  fallbackOption: {
    type: [Function, Boolean],
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  maxTagCount: [Number, String],
  ellipsisTagPopoverProps: Object,
  consistentMenuWidth: {
    type: Boolean,
    default: !0
  },
  virtualScroll: {
    type: Boolean,
    default: !0
  },
  labelField: {
    type: String,
    default: "label"
  },
  valueField: {
    type: String,
    default: "value"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  renderLabel: Function,
  renderOption: Function,
  renderTag: Function,
  "onUpdate:value": [Function, Array],
  inputProps: Object,
  nodeProps: Function,
  ignoreComposition: {
    type: Boolean,
    default: !0
  },
  showOnFocus: Boolean,
  // for jsx
  onUpdateValue: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onFocus: [Function, Array],
  onScroll: [Function, Array],
  onSearch: [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:show": [Function, Array],
  displayDirective: {
    type: String,
    default: "show"
  },
  resetMenuOnOptionsChange: {
    type: Boolean,
    default: !0
  },
  status: String,
  showCheckmark: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  onChange: [Function, Array],
  items: Array
}), T5 = Z({
  name: "Select",
  props: w5,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      e.items !== void 0 && sr("select", "`items` is deprecated, please use `options` instead."), e.onChange !== void 0 && sr("select", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: t,
      mergedBorderedRef: r,
      namespaceRef: n,
      inlineThemeDisabled: o
    } = Bt(e), i = Ve("Select", "-select", I3, M5, e, t), a = L(e.defaultValue), l = We(e, "value"), s = fi(l, a), c = L(!1), u = L(""), d = W(() => {
      const {
        valueField: k,
        childrenField: U
      } = e, ie = N3(k, U);
      return X3(z.value, ie);
    }), f = W(() => C3(O.value, e.valueField, e.childrenField)), p = L(!1), h = fi(We(e, "show"), p), g = L(null), m = L(null), v = L(null), {
      localeRef: M
    } = Zc("Select"), x = W(() => {
      var k;
      return (k = e.placeholder) !== null && k !== void 0 ? k : M.value.placeholder;
    }), b = Qx(e, ["items", "options"]), T = [], w = L([]), y = L([]), I = L(/* @__PURE__ */ new Map()), D = W(() => {
      const {
        fallbackOption: k
      } = e;
      if (k === void 0) {
        const {
          labelField: U,
          valueField: ie
        } = e;
        return (xe) => ({
          [U]: String(xe),
          [ie]: xe
        });
      }
      return k === !1 ? !1 : (U) => Object.assign(k(U), {
        value: U
      });
    }), O = W(() => y.value.concat(w.value).concat(b.value)), $ = W(() => {
      const {
        filter: k
      } = e;
      if (k)
        return k;
      const {
        labelField: U,
        valueField: ie
      } = e;
      return (xe, Ie) => {
        if (!Ie)
          return !1;
        const Ae = Ie[U];
        if (typeof Ae == "string")
          return _d(xe, Ae);
        const Le = Ie[ie];
        return typeof Le == "string" ? _d(xe, Le) : typeof Le == "number" ? _d(xe, String(Le)) : !1;
      };
    }), z = W(() => {
      if (e.remote)
        return b.value;
      {
        const {
          value: k
        } = O, {
          value: U
        } = u;
        return !U.length || !e.filterable ? k : S3(k, $.value, U, e.childrenField);
      }
    });
    function Y(k) {
      const U = e.remote, {
        value: ie
      } = I, {
        value: xe
      } = f, {
        value: Ie
      } = D, Ae = [];
      return k.forEach((Le) => {
        if (xe.has(Le))
          Ae.push(xe.get(Le));
        else if (U && ie.has(Le))
          Ae.push(ie.get(Le));
        else if (Ie) {
          const rt = Ie(Le);
          rt && Ae.push(rt);
        }
      }), Ae;
    }
    const j = W(() => {
      if (e.multiple) {
        const {
          value: k
        } = s;
        return Array.isArray(k) ? Y(k) : [];
      }
      return null;
    }), q = W(() => {
      const {
        value: k
      } = s;
      return !e.multiple && !Array.isArray(k) ? k === null ? null : Y([k])[0] || null : null;
    }), ee = Ia(e), {
      mergedSizeRef: re,
      mergedDisabledRef: le,
      mergedStatusRef: ye
    } = ee;
    function Me(k, U) {
      const {
        onChange: ie,
        "onUpdate:value": xe,
        onUpdateValue: Ie
      } = e, {
        nTriggerFormChange: Ae,
        nTriggerFormInput: Le
      } = ee;
      ie && Be(ie, k, U), Ie && Be(Ie, k, U), xe && Be(xe, k, U), a.value = k, Ae(), Le();
    }
    function Ee(k) {
      const {
        onBlur: U
      } = e, {
        nTriggerFormBlur: ie
      } = ee;
      U && Be(U, k), ie();
    }
    function ne() {
      const {
        onClear: k
      } = e;
      k && Be(k);
    }
    function ue(k) {
      const {
        onFocus: U,
        showOnFocus: ie
      } = e, {
        nTriggerFormFocus: xe
      } = ee;
      U && Be(U, k), xe(), ie && Ge();
    }
    function Ce(k) {
      const {
        onSearch: U
      } = e;
      U && Be(U, k);
    }
    function ze(k) {
      const {
        onScroll: U
      } = e;
      U && Be(U, k);
    }
    function ke() {
      var k;
      const {
        remote: U,
        multiple: ie
      } = e;
      if (U) {
        const {
          value: xe
        } = I;
        if (ie) {
          const {
            valueField: Ie
          } = e;
          (k = j.value) === null || k === void 0 || k.forEach((Ae) => {
            xe.set(Ae[Ie], Ae);
          });
        } else {
          const Ie = q.value;
          Ie && xe.set(Ie[e.valueField], Ie);
        }
      }
    }
    function tt(k) {
      const {
        onUpdateShow: U,
        "onUpdate:show": ie
      } = e;
      U && Be(U, k), ie && Be(ie, k), p.value = k;
    }
    function Ge() {
      le.value || (tt(!0), p.value = !0, e.filterable && jt());
    }
    function Ne() {
      tt(!1);
    }
    function Ye() {
      u.value = "", y.value = T;
    }
    const Se = L(!1);
    function _e() {
      e.filterable && (Se.value = !0);
    }
    function Fe() {
      e.filterable && (Se.value = !1, h.value || Ye());
    }
    function ot() {
      le.value || (h.value ? e.filterable ? jt() : Ne() : Ge());
    }
    function Nt(k) {
      var U, ie;
      !((ie = (U = v.value) === null || U === void 0 ? void 0 : U.selfRef) === null || ie === void 0) && ie.contains(k.relatedTarget) || (c.value = !1, Ee(k), Ne());
    }
    function A(k) {
      ue(k), c.value = !0;
    }
    function C(k) {
      c.value = !0;
    }
    function E(k) {
      var U;
      !((U = g.value) === null || U === void 0) && U.$el.contains(k.relatedTarget) || (c.value = !1, Ee(k), Ne());
    }
    function J() {
      var k;
      (k = g.value) === null || k === void 0 || k.focus(), Ne();
    }
    function H(k) {
      var U;
      h.value && (!((U = g.value) === null || U === void 0) && U.$el.contains(Wl(k)) || Ne());
    }
    function X(k) {
      if (!Array.isArray(k))
        return [];
      if (D.value)
        return Array.from(k);
      {
        const {
          remote: U
        } = e, {
          value: ie
        } = f;
        if (U) {
          const {
            value: xe
          } = I;
          return k.filter((Ie) => ie.has(Ie) || xe.has(Ie));
        } else
          return k.filter((xe) => ie.has(xe));
      }
    }
    function me(k) {
      Te(k.rawNode);
    }
    function Te(k) {
      if (le.value)
        return;
      const {
        tag: U,
        remote: ie,
        clearFilterAfterSelect: xe,
        valueField: Ie
      } = e;
      if (U && !ie) {
        const {
          value: Ae
        } = y, Le = Ae[0] || null;
        if (Le) {
          const rt = w.value;
          rt.length ? rt.push(Le) : w.value = [Le], y.value = T;
        }
      }
      if (ie && I.value.set(k[Ie], k), e.multiple) {
        const Ae = X(s.value), Le = Ae.findIndex((rt) => rt === k[Ie]);
        if (~Le) {
          if (Ae.splice(Le, 1), U && !ie) {
            const rt = G(k[Ie]);
            ~rt && (w.value.splice(rt, 1), xe && (u.value = ""));
          }
        } else
          Ae.push(k[Ie]), xe && (u.value = "");
        Me(Ae, Y(Ae));
      } else {
        if (U && !ie) {
          const Ae = G(k[Ie]);
          ~Ae ? w.value = [w.value[Ae]] : w.value = T;
        }
        Xt(), Ne(), Me(k[Ie], k);
      }
    }
    function G(k) {
      return w.value.findIndex((U) => U[e.valueField] === k);
    }
    function ae(k) {
      h.value || Ge();
      const {
        value: U
      } = k.target;
      u.value = U;
      const {
        tag: ie,
        remote: xe
      } = e;
      if (Ce(U), ie && !xe) {
        if (!U) {
          y.value = T;
          return;
        }
        const {
          onCreate: Ie
        } = e, Ae = Ie ? Ie(U) : {
          [e.labelField]: U,
          [e.valueField]: U
        }, {
          valueField: Le,
          labelField: rt
        } = e;
        b.value.some((At) => At[Le] === Ae[Le] || At[rt] === Ae[rt]) || w.value.some((At) => At[Le] === Ae[Le] || At[rt] === Ae[rt]) ? y.value = T : y.value = [Ae];
      }
    }
    function Xe(k) {
      k.stopPropagation();
      const {
        multiple: U
      } = e;
      !U && e.filterable && Ne(), ne(), U ? Me([], []) : Me(null, null);
    }
    function gt(k) {
      !Hu(k, "action") && !Hu(k, "empty") && k.preventDefault();
    }
    function yt(k) {
      ze(k);
    }
    function or(k) {
      var U, ie, xe, Ie, Ae;
      if (!e.keyboard) {
        k.preventDefault();
        return;
      }
      switch (k.key) {
        case " ":
          if (e.filterable)
            break;
          k.preventDefault();
        case "Enter":
          if (!(!((U = g.value) === null || U === void 0) && U.isComposing)) {
            if (h.value) {
              const Le = (ie = v.value) === null || ie === void 0 ? void 0 : ie.getPendingTmNode();
              Le ? me(Le) : e.filterable || (Ne(), Xt());
            } else if (Ge(), e.tag && Se.value) {
              const Le = y.value[0];
              if (Le) {
                const rt = Le[e.valueField], {
                  value: At
                } = s;
                e.multiple && Array.isArray(At) && At.some((Wr) => Wr === rt) || Te(Le);
              }
            }
          }
          k.preventDefault();
          break;
        case "ArrowUp":
          if (k.preventDefault(), e.loading)
            return;
          h.value && ((xe = v.value) === null || xe === void 0 || xe.prev());
          break;
        case "ArrowDown":
          if (k.preventDefault(), e.loading)
            return;
          h.value ? (Ie = v.value) === null || Ie === void 0 || Ie.next() : Ge();
          break;
        case "Escape":
          h.value && (y5(k), Ne()), (Ae = g.value) === null || Ae === void 0 || Ae.focus();
          break;
      }
    }
    function Xt() {
      var k;
      (k = g.value) === null || k === void 0 || k.focus();
    }
    function jt() {
      var k;
      (k = g.value) === null || k === void 0 || k.focusInput();
    }
    function ir() {
      var k;
      h.value && ((k = m.value) === null || k === void 0 || k.syncPosition());
    }
    ke(), at(We(e, "options"), ke);
    const gr = {
      focus: () => {
        var k;
        (k = g.value) === null || k === void 0 || k.focus();
      },
      focusInput: () => {
        var k;
        (k = g.value) === null || k === void 0 || k.focusInput();
      },
      blur: () => {
        var k;
        (k = g.value) === null || k === void 0 || k.blur();
      },
      blurInput: () => {
        var k;
        (k = g.value) === null || k === void 0 || k.blurInput();
      }
    }, K = W(() => {
      const {
        self: {
          menuBoxShadow: k
        }
      } = i.value;
      return {
        "--n-menu-box-shadow": k
      };
    }), P = o ? dr("select", void 0, K, e) : void 0;
    return Object.assign(Object.assign({}, gr), {
      mergedStatus: ye,
      mergedClsPrefix: t,
      mergedBordered: r,
      namespace: n,
      treeMate: d,
      isMounted: hs(),
      triggerRef: g,
      menuRef: v,
      pattern: u,
      uncontrolledShow: p,
      mergedShow: h,
      adjustedTo: Xn(e),
      uncontrolledValue: a,
      mergedValue: s,
      followerRef: m,
      localizedPlaceholder: x,
      selectedOption: q,
      selectedOptions: j,
      mergedSize: re,
      mergedDisabled: le,
      focused: c,
      activeWithoutMenuOpen: Se,
      inlineThemeDisabled: o,
      onTriggerInputFocus: _e,
      onTriggerInputBlur: Fe,
      handleTriggerOrMenuResize: ir,
      handleMenuFocus: C,
      handleMenuBlur: E,
      handleMenuTabOut: J,
      handleTriggerClick: ot,
      handleToggle: me,
      handleDeleteOption: Te,
      handlePatternInput: ae,
      handleClear: Xe,
      handleTriggerBlur: Nt,
      handleTriggerFocus: A,
      handleKeydown: or,
      handleMenuAfterLeave: Ye,
      handleMenuClickOutside: H,
      handleMenuScroll: yt,
      handleMenuKeydown: or,
      handleMenuMousedown: gt,
      mergedTheme: i,
      cssVars: o ? void 0 : K,
      themeClass: P == null ? void 0 : P.themeClass,
      onRender: P == null ? void 0 : P.onRender
    });
  },
  render() {
    return S("div", {
      class: `${this.mergedClsPrefix}-select`
    }, S(Gx, null, {
      default: () => [S(Kx, null, {
        default: () => S(qj, {
          ref: "triggerRef",
          inlineThemeDisabled: this.inlineThemeDisabled,
          status: this.mergedStatus,
          inputProps: this.inputProps,
          clsPrefix: this.mergedClsPrefix,
          showArrow: this.showArrow,
          maxTagCount: this.maxTagCount,
          ellipsisTagPopoverProps: this.ellipsisTagPopoverProps,
          bordered: this.mergedBordered,
          active: this.activeWithoutMenuOpen || this.mergedShow,
          pattern: this.pattern,
          placeholder: this.localizedPlaceholder,
          selectedOption: this.selectedOption,
          selectedOptions: this.selectedOptions,
          multiple: this.multiple,
          renderTag: this.renderTag,
          renderLabel: this.renderLabel,
          filterable: this.filterable,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          size: this.mergedSize,
          theme: this.mergedTheme.peers.InternalSelection,
          labelField: this.labelField,
          valueField: this.valueField,
          themeOverrides: this.mergedTheme.peerOverrides.InternalSelection,
          loading: this.loading,
          focused: this.focused,
          onClick: this.handleTriggerClick,
          onDeleteOption: this.handleDeleteOption,
          onPatternInput: this.handlePatternInput,
          onClear: this.handleClear,
          onBlur: this.handleTriggerBlur,
          onFocus: this.handleTriggerFocus,
          onKeydown: this.handleKeydown,
          onPatternBlur: this.onTriggerInputBlur,
          onPatternFocus: this.onTriggerInputFocus,
          onResize: this.handleTriggerOrMenuResize,
          ignoreComposition: this.ignoreComposition
        }, {
          arrow: () => {
            var e, t;
            return [(t = (e = this.$slots).arrow) === null || t === void 0 ? void 0 : t.call(e)];
          }
        })
      }), S(Rx, {
        ref: "followerRef",
        show: this.mergedShow,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === Xn.tdkey,
        containerClass: this.namespace,
        width: this.consistentMenuWidth ? "target" : void 0,
        minWidth: "target",
        placement: this.placement
      }, {
        default: () => S(zn, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted,
          onAfterLeave: this.handleMenuAfterLeave
        }, {
          default: () => {
            var e, t, r;
            return this.mergedShow || this.displayDirective === "show" ? ((e = this.onRender) === null || e === void 0 || e.call(this), on(S(m5, Object.assign({}, this.menuProps, {
              ref: "menuRef",
              onResize: this.handleTriggerOrMenuResize,
              inlineThemeDisabled: this.inlineThemeDisabled,
              virtualScroll: this.consistentMenuWidth && this.virtualScroll,
              class: [`${this.mergedClsPrefix}-select-menu`, this.themeClass, (t = this.menuProps) === null || t === void 0 ? void 0 : t.class],
              clsPrefix: this.mergedClsPrefix,
              focusable: !0,
              labelField: this.labelField,
              valueField: this.valueField,
              autoPending: !0,
              nodeProps: this.nodeProps,
              theme: this.mergedTheme.peers.InternalSelectMenu,
              themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
              treeMate: this.treeMate,
              multiple: this.multiple,
              size: "medium",
              renderOption: this.renderOption,
              renderLabel: this.renderLabel,
              value: this.mergedValue,
              style: [(r = this.menuProps) === null || r === void 0 ? void 0 : r.style, this.cssVars],
              onToggle: this.handleToggle,
              onScroll: this.handleMenuScroll,
              onFocus: this.handleMenuFocus,
              onBlur: this.handleMenuBlur,
              onKeydown: this.handleMenuKeydown,
              onTabOut: this.handleMenuTabOut,
              onMousedown: this.handleMenuMousedown,
              show: this.mergedShow,
              showCheckmark: this.showCheckmark,
              resetMenuOnOptionsChange: this.resetMenuOnOptionsChange
            }), {
              empty: () => {
                var n, o;
                return [(o = (n = this.$slots).empty) === null || o === void 0 ? void 0 : o.call(n)];
              },
              header: () => {
                var n, o;
                return [(o = (n = this.$slots).header) === null || o === void 0 ? void 0 : o.call(n)];
              },
              action: () => {
                var n, o;
                return [(o = (n = this.$slots).action) === null || o === void 0 ? void 0 : o.call(n)];
              }
            }), this.displayDirective === "show" ? [[ci, this.mergedShow], [Yl, this.handleMenuClickOutside, void 0, {
              capture: !0
            }]] : [[Yl, this.handleMenuClickOutside, void 0, {
              capture: !0
            }]])) : null;
          }
        })
      })]
    }));
  }
}), N5 = Z({
  name: "UISelect",
  inheritAttrs: !1
}), S5 = Z({
  ...N5,
  props: {
    id: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderTag: {
      type: Function,
      default: void 0
    },
    showTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["search", "update:value", "scroll"],
  setup(e) {
    const t = e, r = (i, a) => {
      switch (i.type ?? t.type) {
        case "avatar":
        default:
          return lz(i);
        case "group":
          return sz(i);
      }
    }, n = W(() => t.multiple ? T3 : w3), o = W(() => t.multiple ? C$ : S$);
    return (i, a) => (_(), se(N(T5), Ut({
      "reset-menu-on-options-change": e.resetMenuOnOptionsChange,
      "render-label": e.renderLabel ? e.renderLabel : e.type === "avatar" ? r : e.showTooltip ? N(g3) : N(N$),
      "render-tag": e.renderTag ? e.renderTag : e.type === "avatar" ? n.value : o.value,
      id: e.id
    }, i.$attrs, {
      placeholder: e.placeholder,
      options: e.options,
      disabled: e.disabled,
      value: e.value,
      class: "hl-select",
      filterable: e.filterable,
      show: e.show,
      multiple: e.multiple,
      loading: e.loading,
      clearable: e.clearable,
      remote: e.remote,
      tag: e.tag,
      size: e.size,
      "max-tag-count": e.maxTagCount,
      onScroll: a[0] || (a[0] = (l) => i.$emit("scroll", l)),
      onSearch: a[1] || (a[1] = (l) => i.$emit("search", l)),
      "onUpdate:value": a[2] || (a[2] = (l, s) => i.$emit("update:value", l, s))
    }), {
      header: Q(() => [
        Re(i.$slots, "header")
      ]),
      action: Q(() => [
        Re(i.$slots, "action")
      ]),
      arrow: Q(() => [
        Re(i.$slots, "arrow")
      ]),
      empty: Q(() => [
        Re(i.$slots, "empty")
      ]),
      _: 3
    }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "size", "max-tag-count"]));
  }
}), Da = S5;
function gb(e = 8) {
  return Math.random().toString(16).slice(2, 2 + e);
}
const cw = "n-input";
function C5(e) {
  let t = 0;
  for (const r of e)
    t++;
  return t;
}
function Hs(e) {
  return e === "" || e == null;
}
function I5(e) {
  const t = L(null);
  function r() {
    const {
      value: i
    } = e;
    if (!(i != null && i.focus)) {
      o();
      return;
    }
    const {
      selectionStart: a,
      selectionEnd: l,
      value: s
    } = i;
    if (a == null || l == null) {
      o();
      return;
    }
    t.value = {
      start: a,
      end: l,
      beforeText: s.slice(0, a),
      afterText: s.slice(l)
    };
  }
  function n() {
    var i;
    const {
      value: a
    } = t, {
      value: l
    } = e;
    if (!a || !l)
      return;
    const {
      value: s
    } = l, {
      start: c,
      beforeText: u,
      afterText: d
    } = a;
    let f = s.length;
    if (s.endsWith(d))
      f = s.length - d.length;
    else if (s.startsWith(u))
      f = u.length;
    else {
      const p = u[c - 1], h = s.indexOf(p, c - 1);
      h !== -1 && (f = h + 1);
    }
    (i = l.setSelectionRange) === null || i === void 0 || i.call(l, f, f);
  }
  function o() {
    t.value = null;
  }
  return at(e, o), {
    recordCursor: r,
    restoreCursor: n
  };
}
const mb = Z({
  name: "InputWordCount",
  setup(e, {
    slots: t
  }) {
    const {
      mergedValueRef: r,
      maxlengthRef: n,
      mergedClsPrefixRef: o,
      countGraphemesRef: i
    } = (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      De(cw)
    ), a = W(() => {
      const {
        value: l
      } = r;
      return l === null || Array.isArray(l) ? 0 : (i.value || C5)(l);
    });
    return () => {
      const {
        value: l
      } = n, {
        value: s
      } = r;
      return S("span", {
        class: `${o.value}-input-word-count`
      }, oL(t.default, {
        value: s === null || Array.isArray(s) ? "" : s
      }, () => [l === void 0 ? a.value : `${a.value} / ${l}`]));
    };
  }
}), A5 = te("input", `
 max-width: 100%;
 cursor: text;
 line-height: 1.5;
 z-index: auto;
 outline: none;
 box-sizing: border-box;
 position: relative;
 display: inline-flex;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color .3s var(--n-bezier);
 font-size: var(--n-font-size);
 --n-padding-vertical: calc((var(--n-height) - 1.5 * var(--n-font-size)) / 2);
`, [
  // common
  F("input, textarea", `
 overflow: hidden;
 flex-grow: 1;
 position: relative;
 `),
  F("input-el, textarea-el, input-mirror, textarea-mirror, separator, placeholder", `
 box-sizing: border-box;
 font-size: inherit;
 line-height: 1.5;
 font-family: inherit;
 border: none;
 outline: none;
 background-color: #0000;
 text-align: inherit;
 transition:
 -webkit-text-fill-color .3s var(--n-bezier),
 caret-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 `),
  F("input-el, textarea-el", `
 -webkit-appearance: none;
 scrollbar-width: none;
 width: 100%;
 min-width: 0;
 text-decoration-color: var(--n-text-decoration-color);
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 background-color: transparent;
 `, [V("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), V("&::placeholder", `
 color: #0000;
 -webkit-text-fill-color: transparent !important;
 `), V("&:-webkit-autofill ~", [F("placeholder", "display: none;")])]),
  fe("round", [$t("textarea", "border-radius: calc(var(--n-height) / 2);")]),
  F("placeholder", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: hidden;
 color: var(--n-placeholder-color);
 `, [V("span", `
 width: 100%;
 display: inline-block;
 `)]),
  fe("textarea", [F("placeholder", "overflow: visible;")]),
  $t("autosize", "width: 100%;"),
  fe("autosize", [F("textarea-el, input-el", `
 position: absolute;
 top: 0;
 left: 0;
 height: 100%;
 `)]),
  // input
  te("input-wrapper", `
 overflow: hidden;
 display: inline-flex;
 flex-grow: 1;
 position: relative;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 `),
  F("input-mirror", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre;
 pointer-events: none;
 `),
  F("input-el", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [V("&[type=password]::-ms-reveal", "display: none;"), V("+", [F("placeholder", `
 display: flex;
 align-items: center; 
 `)])]),
  $t("textarea", [F("placeholder", "white-space: nowrap;")]),
  F("eye", `
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `),
  // textarea
  fe("textarea", "width: 100%;", [te("input-word-count", `
 position: absolute;
 right: var(--n-padding-right);
 bottom: var(--n-padding-vertical);
 `), fe("resizable", [te("input-wrapper", `
 resize: vertical;
 min-height: var(--n-height);
 `)]), F("textarea-el, textarea-mirror, placeholder", `
 height: 100%;
 padding-left: 0;
 padding-right: 0;
 padding-top: var(--n-padding-vertical);
 padding-bottom: var(--n-padding-vertical);
 word-break: break-word;
 display: inline-block;
 vertical-align: bottom;
 box-sizing: border-box;
 line-height: var(--n-line-height-textarea);
 margin: 0;
 resize: none;
 white-space: pre-wrap;
 scroll-padding-block-end: var(--n-padding-vertical);
 `), F("textarea-mirror", `
 width: 100%;
 pointer-events: none;
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre-wrap;
 overflow-wrap: break-word;
 `)]),
  // pair
  fe("pair", [F("input-el, placeholder", "text-align: center;"), F("separator", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 white-space: nowrap;
 `, [te("icon", `
 color: var(--n-icon-color);
 `), te("base-icon", `
 color: var(--n-icon-color);
 `)])]),
  fe("disabled", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [F("border", "border: var(--n-border-disabled);"), F("input-el, textarea-el", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 text-decoration-color: var(--n-text-color-disabled);
 `), F("placeholder", "color: var(--n-placeholder-color-disabled);"), F("separator", "color: var(--n-text-color-disabled);", [te("icon", `
 color: var(--n-icon-color-disabled);
 `), te("base-icon", `
 color: var(--n-icon-color-disabled);
 `)]), te("input-word-count", `
 color: var(--n-count-text-color-disabled);
 `), F("suffix, prefix", "color: var(--n-text-color-disabled);", [te("icon", `
 color: var(--n-icon-color-disabled);
 `), te("internal-icon", `
 color: var(--n-icon-color-disabled);
 `)])]),
  $t("disabled", [F("eye", `
 color: var(--n-icon-color);
 cursor: pointer;
 `, [V("&:hover", `
 color: var(--n-icon-color-hover);
 `), V("&:active", `
 color: var(--n-icon-color-pressed);
 `)]), V("&:hover", [F("state-border", "border: var(--n-border-hover);")]), fe("focus", "background-color: var(--n-color-focus);", [F("state-border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]),
  F("border, state-border", `
 box-sizing: border-box;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: inherit;
 border: var(--n-border);
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `),
  F("state-border", `
 border-color: #0000;
 z-index: 1;
 `),
  F("prefix", "margin-right: 4px;"),
  F("suffix", `
 margin-left: 4px;
 `),
  F("suffix, prefix", `
 transition: color .3s var(--n-bezier);
 flex-wrap: nowrap;
 flex-shrink: 0;
 line-height: var(--n-height);
 white-space: nowrap;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 color: var(--n-suffix-text-color);
 `, [te("base-loading", `
 font-size: var(--n-icon-size);
 margin: 0 2px;
 color: var(--n-loading-color);
 `), te("base-clear", `
 font-size: var(--n-icon-size);
 `, [F("placeholder", [te("base-icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)])]), V(">", [te("icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)]), te("base-icon", `
 font-size: var(--n-icon-size);
 `)]),
  te("input-word-count", `
 pointer-events: none;
 line-height: 1.5;
 font-size: .85em;
 color: var(--n-count-text-color);
 transition: color .3s var(--n-bezier);
 margin-left: 4px;
 font-variant: tabular-nums;
 `),
  ["warning", "error"].map((e) => fe(`${e}-status`, [$t("disabled", [te("base-loading", `
 color: var(--n-loading-color-${e})
 `), F("input-el, textarea-el", `
 caret-color: var(--n-caret-color-${e});
 `), F("state-border", `
 border: var(--n-border-${e});
 `), V("&:hover", [F("state-border", `
 border: var(--n-border-hover-${e});
 `)]), V("&:focus", `
 background-color: var(--n-color-focus-${e});
 `, [F("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)]), fe("focus", `
 background-color: var(--n-color-focus-${e});
 `, [F("state-border", `
 box-shadow: var(--n-box-shadow-focus-${e});
 border: var(--n-border-focus-${e});
 `)])])]))
]), D5 = te("input", [fe("disabled", [F("input-el, textarea-el", `
 -webkit-text-fill-color: var(--n-text-color-disabled);
 `)])]), k5 = {
  paddingTiny: "0 8px",
  paddingSmall: "0 10px",
  paddingMedium: "0 12px",
  paddingLarge: "0 14px",
  clearSize: "16px"
}, E5 = (e) => {
  const {
    textColor2: t,
    textColor3: r,
    textColorDisabled: n,
    primaryColor: o,
    primaryColorHover: i,
    inputColor: a,
    inputColorDisabled: l,
    borderColor: s,
    warningColor: c,
    warningColorHover: u,
    errorColor: d,
    errorColorHover: f,
    borderRadius: p,
    lineHeight: h,
    fontSizeTiny: g,
    fontSizeSmall: m,
    fontSizeMedium: v,
    fontSizeLarge: M,
    heightTiny: x,
    heightSmall: b,
    heightMedium: T,
    heightLarge: w,
    actionColor: y,
    clearColor: I,
    clearColorHover: D,
    clearColorPressed: O,
    placeholderColor: $,
    placeholderColorDisabled: z,
    iconColor: Y,
    iconColorDisabled: j,
    iconColorHover: q,
    iconColorPressed: ee
  } = e;
  return Object.assign(Object.assign({}, k5), {
    countTextColorDisabled: n,
    countTextColor: r,
    heightTiny: x,
    heightSmall: b,
    heightMedium: T,
    heightLarge: w,
    fontSizeTiny: g,
    fontSizeSmall: m,
    fontSizeMedium: v,
    fontSizeLarge: M,
    lineHeight: h,
    lineHeightTextarea: h,
    borderRadius: p,
    iconSize: "16px",
    groupLabelColor: y,
    groupLabelTextColor: t,
    textColor: t,
    textColorDisabled: n,
    textDecorationColor: t,
    caretColor: o,
    placeholderColor: $,
    placeholderColorDisabled: z,
    color: a,
    colorDisabled: l,
    colorFocus: a,
    groupLabelBorder: `1px solid ${s}`,
    border: `1px solid ${s}`,
    borderHover: `1px solid ${i}`,
    borderDisabled: `1px solid ${s}`,
    borderFocus: `1px solid ${i}`,
    boxShadowFocus: `0 0 0 2px ${qe(o, {
      alpha: 0.2
    })}`,
    loadingColor: o,
    // warning
    loadingColorWarning: c,
    borderWarning: `1px solid ${c}`,
    borderHoverWarning: `1px solid ${u}`,
    colorFocusWarning: a,
    borderFocusWarning: `1px solid ${u}`,
    boxShadowFocusWarning: `0 0 0 2px ${qe(c, {
      alpha: 0.2
    })}`,
    caretColorWarning: c,
    // error
    loadingColorError: d,
    borderError: `1px solid ${d}`,
    borderHoverError: `1px solid ${f}`,
    colorFocusError: a,
    borderFocusError: `1px solid ${f}`,
    boxShadowFocusError: `0 0 0 2px ${qe(d, {
      alpha: 0.2
    })}`,
    caretColorError: d,
    clearColor: I,
    clearColorHover: D,
    clearColorPressed: O,
    iconColor: Y,
    iconColorDisabled: j,
    iconColorHover: q,
    iconColorPressed: ee,
    suffixTextColor: t
  });
}, L5 = {
  name: "Input",
  common: Jt,
  self: E5
}, dw = L5, $5 = Z({
  name: "Eye",
  render() {
    return S("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, S("path", {
      d: "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32"
    }), S("circle", {
      cx: "256",
      cy: "256",
      r: "80",
      fill: "none",
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "32"
    }));
  }
}), z5 = Z({
  name: "EyeOff",
  render() {
    return S("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, S("path", {
      d: "M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448z",
      fill: "currentColor"
    }), S("path", {
      d: "M255.66 384c-41.49 0-81.5-12.28-118.92-36.5c-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58a2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1a204.8 204.8 0 0 1-51.16 6.47z",
      fill: "currentColor"
    }), S("path", {
      d: "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83a2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1a192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37c34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16a310.72 310.72 0 0 1-64.12 72.73a2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13a343.49 343.49 0 0 0 68.64-78.48a32.2 32.2 0 0 0-.1-34.78z",
      fill: "currentColor"
    }), S("path", {
      d: "M256 160a95.88 95.88 0 0 0-21.37 2.4a2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160z",
      fill: "currentColor"
    }), S("path", {
      d: "M165.78 233.66a2 2 0 0 0-3.38 1a96 96 0 0 0 115 115a2 2 0 0 0 1-3.38z",
      fill: "currentColor"
    }));
  }
}), O5 = Object.assign(Object.assign({}, Ve.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: !1
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: !1
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: !0
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: !0
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: [Function, Array],
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  /** private */
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: {
    type: Boolean,
    default: !0
  },
  /** deprecated */
  showPasswordToggle: Boolean
}), Gc = Z({
  name: "Input",
  props: O5,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      e.showPasswordToggle && sr("input", '`show-password-toggle` is deprecated, please use `showPasswordOn="click"` instead');
    });
    const {
      mergedClsPrefixRef: t,
      mergedBorderedRef: r,
      inlineThemeDisabled: n,
      mergedRtlRef: o
    } = Bt(e), i = Ve("Input", "-input", A5, dw, e, t);
    A1 && ko("-input-safari", D5, t);
    const a = L(null), l = L(null), s = L(null), c = L(null), u = L(null), d = L(null), f = L(null), p = I5(f), h = L(null), {
      localeRef: g
    } = Zc("Input"), m = L(e.defaultValue), v = We(e, "value"), M = fi(v, m), x = Ia(e), {
      mergedSizeRef: b,
      mergedDisabledRef: T,
      mergedStatusRef: w
    } = x, y = L(!1), I = L(!1), D = L(!1), O = L(!1);
    let $ = null;
    const z = W(() => {
      const {
        placeholder: R,
        pair: oe
      } = e;
      return oe ? Array.isArray(R) ? R : R === void 0 ? ["", ""] : [R, R] : R === void 0 ? [g.value.placeholder] : [R];
    }), Y = W(() => {
      const {
        value: R
      } = D, {
        value: oe
      } = M, {
        value: $e
      } = z;
      return !R && (Hs(oe) || Array.isArray(oe) && Hs(oe[0])) && $e[0];
    }), j = W(() => {
      const {
        value: R
      } = D, {
        value: oe
      } = M, {
        value: $e
      } = z;
      return !R && $e[1] && (Hs(oe) || Array.isArray(oe) && Hs(oe[1]));
    }), q = _t(() => e.internalForceFocus || y.value), ee = _t(() => {
      if (T.value || e.readonly || !e.clearable || !q.value && !I.value)
        return !1;
      const {
        value: R
      } = M, {
        value: oe
      } = q;
      return e.pair ? !!(Array.isArray(R) && (R[0] || R[1])) && (I.value || oe) : !!R && (I.value || oe);
    }), re = W(() => {
      const {
        showPasswordOn: R
      } = e;
      if (R)
        return R;
      if (e.showPasswordToggle)
        return "click";
    }), le = L(!1), ye = W(() => {
      const {
        textDecoration: R
      } = e;
      return R ? Array.isArray(R) ? R.map((oe) => ({
        textDecoration: oe
      })) : [{
        textDecoration: R
      }] : ["", ""];
    }), Me = L(void 0), Ee = () => {
      var R, oe;
      if (e.type === "textarea") {
        const {
          autosize: $e
        } = e;
        if ($e && (Me.value = (oe = (R = h.value) === null || R === void 0 ? void 0 : R.$el) === null || oe === void 0 ? void 0 : oe.offsetWidth), !l.value || typeof $e == "boolean")
          return;
        const {
          paddingTop: ut,
          paddingBottom: bt,
          lineHeight: st
        } = window.getComputedStyle(l.value), cn = Number(ut.slice(0, -2)), dn = Number(bt.slice(0, -2)), fn = Number(st.slice(0, -2)), {
          value: Fn
        } = s;
        if (!Fn)
          return;
        if ($e.minRows) {
          const Un = Math.max($e.minRows, 1), lo = `${cn + dn + fn * Un}px`;
          Fn.style.minHeight = lo;
        }
        if ($e.maxRows) {
          const Un = `${cn + dn + fn * $e.maxRows}px`;
          Fn.style.maxHeight = Un;
        }
      }
    }, ne = W(() => {
      const {
        maxlength: R
      } = e;
      return R === void 0 ? void 0 : Number(R);
    });
    et(() => {
      const {
        value: R
      } = M;
      Array.isArray(R) || At(R);
    });
    const ue = xa().proxy;
    function Ce(R, oe) {
      const {
        onUpdateValue: $e,
        "onUpdate:value": ut,
        onInput: bt
      } = e, {
        nTriggerFormInput: st
      } = x;
      $e && Be($e, R, oe), ut && Be(ut, R, oe), bt && Be(bt, R, oe), m.value = R, st();
    }
    function ze(R, oe) {
      const {
        onChange: $e
      } = e, {
        nTriggerFormChange: ut
      } = x;
      $e && Be($e, R, oe), m.value = R, ut();
    }
    function ke(R) {
      const {
        onBlur: oe
      } = e, {
        nTriggerFormBlur: $e
      } = x;
      oe && Be(oe, R), $e();
    }
    function tt(R) {
      const {
        onFocus: oe
      } = e, {
        nTriggerFormFocus: $e
      } = x;
      oe && Be(oe, R), $e();
    }
    function Ge(R) {
      const {
        onClear: oe
      } = e;
      oe && Be(oe, R);
    }
    function Ne(R) {
      const {
        onInputBlur: oe
      } = e;
      oe && Be(oe, R);
    }
    function Ye(R) {
      const {
        onInputFocus: oe
      } = e;
      oe && Be(oe, R);
    }
    function Se() {
      const {
        onDeactivate: R
      } = e;
      R && Be(R);
    }
    function _e() {
      const {
        onActivate: R
      } = e;
      R && Be(R);
    }
    function Fe(R) {
      const {
        onClick: oe
      } = e;
      oe && Be(oe, R);
    }
    function ot(R) {
      const {
        onWrapperFocus: oe
      } = e;
      oe && Be(oe, R);
    }
    function Nt(R) {
      const {
        onWrapperBlur: oe
      } = e;
      oe && Be(oe, R);
    }
    function A() {
      D.value = !0;
    }
    function C(R) {
      D.value = !1, R.target === d.value ? E(R, 1) : E(R, 0);
    }
    function E(R, oe = 0, $e = "input") {
      const ut = R.target.value;
      if (At(ut), R instanceof InputEvent && !R.isComposing && (D.value = !1), e.type === "textarea") {
        const {
          value: st
        } = h;
        st && st.syncUnifiedContainer();
      }
      if ($ = ut, D.value)
        return;
      p.recordCursor();
      const bt = J(ut);
      if (bt)
        if (!e.pair)
          $e === "input" ? Ce(ut, {
            source: oe
          }) : ze(ut, {
            source: oe
          });
        else {
          let {
            value: st
          } = M;
          Array.isArray(st) ? st = [st[0], st[1]] : st = ["", ""], st[oe] = ut, $e === "input" ? Ce(st, {
            source: oe
          }) : ze(st, {
            source: oe
          });
        }
      ue.$forceUpdate(), bt || mn(p.restoreCursor);
    }
    function J(R) {
      const {
        countGraphemes: oe,
        maxlength: $e,
        minlength: ut
      } = e;
      if (oe) {
        let st;
        if ($e !== void 0 && (st === void 0 && (st = oe(R)), st > Number($e)) || ut !== void 0 && (st === void 0 && (st = oe(R)), st < Number($e)))
          return !1;
      }
      const {
        allowInput: bt
      } = e;
      return typeof bt == "function" ? bt(R) : !0;
    }
    function H(R) {
      Ne(R), R.relatedTarget === a.value && Se(), R.relatedTarget !== null && (R.relatedTarget === u.value || R.relatedTarget === d.value || R.relatedTarget === l.value) || (O.value = !1), G(R, "blur"), f.value = null;
    }
    function X(R, oe) {
      Ye(R), y.value = !0, O.value = !0, _e(), G(R, "focus"), oe === 0 ? f.value = u.value : oe === 1 ? f.value = d.value : oe === 2 && (f.value = l.value);
    }
    function me(R) {
      e.passivelyActivated && (Nt(R), G(R, "blur"));
    }
    function Te(R) {
      e.passivelyActivated && (y.value = !0, ot(R), G(R, "focus"));
    }
    function G(R, oe) {
      R.relatedTarget !== null && (R.relatedTarget === u.value || R.relatedTarget === d.value || R.relatedTarget === l.value || R.relatedTarget === a.value) || (oe === "focus" ? (tt(R), y.value = !0) : oe === "blur" && (ke(R), y.value = !1));
    }
    function ae(R, oe) {
      E(R, oe, "change");
    }
    function Xe(R) {
      Fe(R);
    }
    function gt(R) {
      Ge(R), yt();
    }
    function yt() {
      e.pair ? (Ce(["", ""], {
        source: "clear"
      }), ze(["", ""], {
        source: "clear"
      })) : (Ce("", {
        source: "clear"
      }), ze("", {
        source: "clear"
      }));
    }
    function or(R) {
      const {
        onMousedown: oe
      } = e;
      oe && oe(R);
      const {
        tagName: $e
      } = R.target;
      if ($e !== "INPUT" && $e !== "TEXTAREA") {
        if (e.resizable) {
          const {
            value: ut
          } = a;
          if (ut) {
            const {
              left: bt,
              top: st,
              width: cn,
              height: dn
            } = ut.getBoundingClientRect(), fn = 14;
            if (bt + cn - fn < R.clientX && R.clientX < bt + cn && st + dn - fn < R.clientY && R.clientY < st + dn)
              return;
          }
        }
        R.preventDefault(), y.value || ie();
      }
    }
    function Xt() {
      var R;
      I.value = !0, e.type === "textarea" && ((R = h.value) === null || R === void 0 || R.handleMouseEnterWrapper());
    }
    function jt() {
      var R;
      I.value = !1, e.type === "textarea" && ((R = h.value) === null || R === void 0 || R.handleMouseLeaveWrapper());
    }
    function ir() {
      T.value || re.value === "click" && (le.value = !le.value);
    }
    function gr(R) {
      if (T.value)
        return;
      R.preventDefault();
      const oe = (ut) => {
        ut.preventDefault(), It("mouseup", document, oe);
      };
      if (zt("mouseup", document, oe), re.value !== "mousedown")
        return;
      le.value = !0;
      const $e = () => {
        le.value = !1, It("mouseup", document, $e);
      };
      zt("mouseup", document, $e);
    }
    function K(R) {
      e.onKeyup && Be(e.onKeyup, R);
    }
    function P(R) {
      switch (e.onKeydown && Be(e.onKeydown, R), R.key) {
        case "Escape":
          U();
          break;
        case "Enter":
          k(R);
          break;
      }
    }
    function k(R) {
      var oe, $e;
      if (e.passivelyActivated) {
        const {
          value: ut
        } = O;
        if (ut) {
          e.internalDeactivateOnEnter && U();
          return;
        }
        R.preventDefault(), e.type === "textarea" ? (oe = l.value) === null || oe === void 0 || oe.focus() : ($e = u.value) === null || $e === void 0 || $e.focus();
      }
    }
    function U() {
      e.passivelyActivated && (O.value = !1, mn(() => {
        var R;
        (R = a.value) === null || R === void 0 || R.focus();
      }));
    }
    function ie() {
      var R, oe, $e;
      T.value || (e.passivelyActivated ? (R = a.value) === null || R === void 0 || R.focus() : ((oe = l.value) === null || oe === void 0 || oe.focus(), ($e = u.value) === null || $e === void 0 || $e.focus()));
    }
    function xe() {
      var R;
      !((R = a.value) === null || R === void 0) && R.contains(document.activeElement) && document.activeElement.blur();
    }
    function Ie() {
      var R, oe;
      (R = l.value) === null || R === void 0 || R.select(), (oe = u.value) === null || oe === void 0 || oe.select();
    }
    function Ae() {
      T.value || (l.value ? l.value.focus() : u.value && u.value.focus());
    }
    function Le() {
      const {
        value: R
      } = a;
      R != null && R.contains(document.activeElement) && R !== document.activeElement && U();
    }
    function rt(R) {
      if (e.type === "textarea") {
        const {
          value: oe
        } = l;
        oe == null || oe.scrollTo(R);
      } else {
        const {
          value: oe
        } = u;
        oe == null || oe.scrollTo(R);
      }
    }
    function At(R) {
      const {
        type: oe,
        pair: $e,
        autosize: ut
      } = e;
      if (!$e && ut)
        if (oe === "textarea") {
          const {
            value: bt
          } = s;
          bt && (bt.textContent = (R ?? "") + `\r
`);
        } else {
          const {
            value: bt
          } = c;
          bt && (R ? bt.textContent = R : bt.innerHTML = "&nbsp;");
        }
    }
    function Wr() {
      Ee();
    }
    const $r = L({
      top: "0"
    });
    function jo(R) {
      var oe;
      const {
        scrollTop: $e
      } = R.target;
      $r.value.top = `${-$e}px`, (oe = h.value) === null || oe === void 0 || oe.syncUnifiedContainer();
    }
    let un = null;
    rr(() => {
      const {
        autosize: R,
        type: oe
      } = e;
      R && oe === "textarea" ? un = at(M, ($e) => {
        !Array.isArray($e) && $e !== $ && At($e);
      }) : un == null || un();
    });
    let Qr = null;
    rr(() => {
      e.type === "textarea" ? Qr = at(M, (R) => {
        var oe;
        !Array.isArray(R) && R !== $ && ((oe = h.value) === null || oe === void 0 || oe.syncUnifiedContainer());
      }) : Qr == null || Qr();
    }), Et(cw, {
      mergedValueRef: M,
      maxlengthRef: ne,
      mergedClsPrefixRef: t,
      countGraphemesRef: We(e, "countGraphemes")
    });
    const Ei = {
      wrapperElRef: a,
      inputElRef: u,
      textareaElRef: l,
      isCompositing: D,
      clear: yt,
      focus: ie,
      blur: xe,
      select: Ie,
      deactivate: Le,
      activate: Ae,
      scrollTo: rt
    }, Ha = yn("Input", o, t), Li = W(() => {
      const {
        value: R
      } = b, {
        common: {
          cubicBezierEaseInOut: oe
        },
        self: {
          color: $e,
          borderRadius: ut,
          textColor: bt,
          caretColor: st,
          caretColorError: cn,
          caretColorWarning: dn,
          textDecorationColor: fn,
          border: Fn,
          borderDisabled: Un,
          borderHover: lo,
          borderFocus: Nn,
          placeholderColor: ce,
          placeholderColorDisabled: Ya,
          lineHeightTextarea: Wa,
          colorDisabled: so,
          colorFocus: it,
          textColorDisabled: Sn,
          boxShadowFocus: Sr,
          iconSize: wd,
          colorFocusWarning: Ro,
          boxShadowFocusWarning: $i,
          borderWarning: PD,
          borderFocusWarning: BD,
          borderHoverWarning: FD,
          colorFocusError: UD,
          boxShadowFocusError: HD,
          borderError: YD,
          borderFocusError: WD,
          borderHoverError: QD,
          clearSize: VD,
          clearColor: ZD,
          clearColorHover: GD,
          clearColorPressed: KD,
          iconColor: qD,
          iconColorDisabled: JD,
          suffixTextColor: XD,
          countTextColor: e4,
          countTextColorDisabled: t4,
          iconColorHover: r4,
          iconColorPressed: n4,
          loadingColor: o4,
          loadingColorError: i4,
          loadingColorWarning: a4,
          [ve("padding", R)]: l4,
          [ve("fontSize", R)]: s4,
          [ve("height", R)]: u4
        }
      } = i.value, {
        left: c4,
        right: d4
      } = Kn(l4);
      return {
        "--n-bezier": oe,
        "--n-count-text-color": e4,
        "--n-count-text-color-disabled": t4,
        "--n-color": $e,
        "--n-font-size": s4,
        "--n-border-radius": ut,
        "--n-height": u4,
        "--n-padding-left": c4,
        "--n-padding-right": d4,
        "--n-text-color": bt,
        "--n-caret-color": st,
        "--n-text-decoration-color": fn,
        "--n-border": Fn,
        "--n-border-disabled": Un,
        "--n-border-hover": lo,
        "--n-border-focus": Nn,
        "--n-placeholder-color": ce,
        "--n-placeholder-color-disabled": Ya,
        "--n-icon-size": wd,
        "--n-line-height-textarea": Wa,
        "--n-color-disabled": so,
        "--n-color-focus": it,
        "--n-text-color-disabled": Sn,
        "--n-box-shadow-focus": Sr,
        "--n-loading-color": o4,
        // form warning
        "--n-caret-color-warning": dn,
        "--n-color-focus-warning": Ro,
        "--n-box-shadow-focus-warning": $i,
        "--n-border-warning": PD,
        "--n-border-focus-warning": BD,
        "--n-border-hover-warning": FD,
        "--n-loading-color-warning": a4,
        // form error
        "--n-caret-color-error": cn,
        "--n-color-focus-error": UD,
        "--n-box-shadow-focus-error": HD,
        "--n-border-error": YD,
        "--n-border-focus-error": WD,
        "--n-border-hover-error": QD,
        "--n-loading-color-error": i4,
        // clear-button
        "--n-clear-color": ZD,
        "--n-clear-size": VD,
        "--n-clear-color-hover": GD,
        "--n-clear-color-pressed": KD,
        "--n-icon-color": qD,
        "--n-icon-color-hover": r4,
        "--n-icon-color-pressed": n4,
        "--n-icon-color-disabled": JD,
        "--n-suffix-text-color": XD
      };
    }), ao = n ? dr("input", W(() => {
      const {
        value: R
      } = b;
      return R[0];
    }), Li, e) : void 0;
    return Object.assign(Object.assign({}, Ei), {
      // DOM ref
      wrapperElRef: a,
      inputElRef: u,
      inputMirrorElRef: c,
      inputEl2Ref: d,
      textareaElRef: l,
      textareaMirrorElRef: s,
      textareaScrollbarInstRef: h,
      // value
      rtlEnabled: Ha,
      uncontrolledValue: m,
      mergedValue: M,
      passwordVisible: le,
      mergedPlaceholder: z,
      showPlaceholder1: Y,
      showPlaceholder2: j,
      mergedFocus: q,
      isComposing: D,
      activated: O,
      showClearButton: ee,
      mergedSize: b,
      mergedDisabled: T,
      textDecorationStyle: ye,
      mergedClsPrefix: t,
      mergedBordered: r,
      mergedShowPasswordOn: re,
      placeholderStyle: $r,
      mergedStatus: w,
      textAreaScrollContainerWidth: Me,
      // methods
      handleTextAreaScroll: jo,
      handleCompositionStart: A,
      handleCompositionEnd: C,
      handleInput: E,
      handleInputBlur: H,
      handleInputFocus: X,
      handleWrapperBlur: me,
      handleWrapperFocus: Te,
      handleMouseEnter: Xt,
      handleMouseLeave: jt,
      handleMouseDown: or,
      handleChange: ae,
      handleClick: Xe,
      handleClear: gt,
      handlePasswordToggleClick: ir,
      handlePasswordToggleMousedown: gr,
      handleWrapperKeydown: P,
      handleWrapperKeyup: K,
      handleTextAreaMirrorResize: Wr,
      getTextareaScrollContainer: () => l.value,
      mergedTheme: i,
      cssVars: n ? void 0 : Li,
      themeClass: ao == null ? void 0 : ao.themeClass,
      onRender: ao == null ? void 0 : ao.onRender
    });
  },
  render() {
    var e, t;
    const {
      mergedClsPrefix: r,
      mergedStatus: n,
      themeClass: o,
      type: i,
      countGraphemes: a,
      onRender: l
    } = this, s = this.$slots;
    return l == null || l(), S("div", {
      ref: "wrapperElRef",
      class: [`${r}-input`, o, n && `${r}-input--${n}-status`, {
        [`${r}-input--rtl`]: this.rtlEnabled,
        [`${r}-input--disabled`]: this.mergedDisabled,
        [`${r}-input--textarea`]: i === "textarea",
        [`${r}-input--resizable`]: this.resizable && !this.autosize,
        [`${r}-input--autosize`]: this.autosize,
        [`${r}-input--round`]: this.round && i !== "textarea",
        [`${r}-input--pair`]: this.pair,
        [`${r}-input--focus`]: this.mergedFocus,
        [`${r}-input--stateful`]: this.stateful
      }],
      style: this.cssVars,
      tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0,
      onFocus: this.handleWrapperFocus,
      onBlur: this.handleWrapperBlur,
      onClick: this.handleClick,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onCompositionstart: this.handleCompositionStart,
      onCompositionend: this.handleCompositionEnd,
      onKeyup: this.handleWrapperKeyup,
      onKeydown: this.handleWrapperKeydown
    }, S("div", {
      class: `${r}-input-wrapper`
    }, mt(s.prefix, (c) => c && S("div", {
      class: `${r}-input__prefix`
    }, c)), i === "textarea" ? S(km, {
      ref: "textareaScrollbarInstRef",
      class: `${r}-input__textarea`,
      container: this.getTextareaScrollContainer,
      triggerDisplayManually: !0,
      useUnifiedContainer: !0,
      internalHoistYRail: !0
    }, {
      default: () => {
        var c, u;
        const {
          textAreaScrollContainerWidth: d
        } = this, f = {
          width: this.autosize && d && `${d}px`
        };
        return S(qt, null, S("textarea", Object.assign({}, this.inputProps, {
          ref: "textareaElRef",
          class: [`${r}-input__textarea-el`, (c = this.inputProps) === null || c === void 0 ? void 0 : c.class],
          autofocus: this.autofocus,
          rows: Number(this.rows),
          placeholder: this.placeholder,
          value: this.mergedValue,
          disabled: this.mergedDisabled,
          maxlength: a ? void 0 : this.maxlength,
          minlength: a ? void 0 : this.minlength,
          readonly: this.readonly,
          tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
          style: [this.textDecorationStyle[0], (u = this.inputProps) === null || u === void 0 ? void 0 : u.style, f],
          onBlur: this.handleInputBlur,
          onFocus: (p) => {
            this.handleInputFocus(p, 2);
          },
          onInput: this.handleInput,
          onChange: this.handleChange,
          onScroll: this.handleTextAreaScroll
        })), this.showPlaceholder1 ? S("div", {
          class: `${r}-input__placeholder`,
          style: [this.placeholderStyle, f],
          key: "placeholder"
        }, this.mergedPlaceholder[0]) : null, this.autosize ? S(sa, {
          onResize: this.handleTextAreaMirrorResize
        }, {
          default: () => S("div", {
            ref: "textareaMirrorElRef",
            class: `${r}-input__textarea-mirror`,
            key: "mirror"
          })
        }) : null);
      }
    }) : S("div", {
      class: `${r}-input__input`
    }, S("input", Object.assign({
      type: i === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : i
    }, this.inputProps, {
      ref: "inputElRef",
      class: [`${r}-input__input-el`, (e = this.inputProps) === null || e === void 0 ? void 0 : e.class],
      style: [this.textDecorationStyle[0], (t = this.inputProps) === null || t === void 0 ? void 0 : t.style],
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[0],
      disabled: this.mergedDisabled,
      maxlength: a ? void 0 : this.maxlength,
      minlength: a ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue,
      readonly: this.readonly,
      autofocus: this.autofocus,
      size: this.attrSize,
      onBlur: this.handleInputBlur,
      onFocus: (c) => {
        this.handleInputFocus(c, 0);
      },
      onInput: (c) => {
        this.handleInput(c, 0);
      },
      onChange: (c) => {
        this.handleChange(c, 0);
      }
    })), this.showPlaceholder1 ? S("div", {
      class: `${r}-input__placeholder`
    }, S("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? S("div", {
      class: `${r}-input__input-mirror`,
      key: "mirror",
      ref: "inputMirrorElRef"
    }, " ") : null), !this.pair && mt(s.suffix, (c) => c || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? S("div", {
      class: `${r}-input__suffix`
    }, [mt(s["clear-icon-placeholder"], (u) => (this.clearable || u) && S(rp, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      placeholder: () => u,
      icon: () => {
        var d, f;
        return (f = (d = this.$slots)["clear-icon"]) === null || f === void 0 ? void 0 : f.call(d);
      }
    })), this.internalLoadingBeforeSuffix ? null : c, this.loading !== void 0 ? S(iw, {
      clsPrefix: r,
      loading: this.loading,
      showArrow: !1,
      showClear: !1,
      style: this.cssVars
    }) : null, this.internalLoadingBeforeSuffix ? c : null, this.showCount && this.type !== "textarea" ? S(mb, null, {
      default: (u) => {
        var d;
        return (d = s.count) === null || d === void 0 ? void 0 : d.call(s, u);
      }
    }) : null, this.mergedShowPasswordOn && this.type === "password" ? S("div", {
      class: `${r}-input__eye`,
      onMousedown: this.handlePasswordToggleMousedown,
      onClick: this.handlePasswordToggleClick
    }, this.passwordVisible ? hn(s["password-visible-icon"], () => [S(On, {
      clsPrefix: r
    }, {
      default: () => S($5, null)
    })]) : hn(s["password-invisible-icon"], () => [S(On, {
      clsPrefix: r
    }, {
      default: () => S(z5, null)
    })])) : null]) : null)), this.pair ? S("span", {
      class: `${r}-input__separator`
    }, hn(s.separator, () => [this.separator])) : null, this.pair ? S("div", {
      class: `${r}-input-wrapper`
    }, S("div", {
      class: `${r}-input__input`
    }, S("input", {
      ref: "inputEl2Ref",
      type: this.type,
      class: `${r}-input__input-el`,
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[1],
      disabled: this.mergedDisabled,
      maxlength: a ? void 0 : this.maxlength,
      minlength: a ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0,
      readonly: this.readonly,
      style: this.textDecorationStyle[1],
      onBlur: this.handleInputBlur,
      onFocus: (c) => {
        this.handleInputFocus(c, 1);
      },
      onInput: (c) => {
        this.handleInput(c, 1);
      },
      onChange: (c) => {
        this.handleChange(c, 1);
      }
    }), this.showPlaceholder2 ? S("div", {
      class: `${r}-input__placeholder`
    }, S("span", null, this.mergedPlaceholder[1])) : null), mt(s.suffix, (c) => (this.clearable || c) && S("div", {
      class: `${r}-input__suffix`
    }, [this.clearable && S(rp, {
      clsPrefix: r,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      icon: () => {
        var u;
        return (u = s["clear-icon"]) === null || u === void 0 ? void 0 : u.call(s);
      },
      placeholder: () => {
        var u;
        return (u = s["clear-icon-placeholder"]) === null || u === void 0 ? void 0 : u.call(s);
      }
    }), c]))) : null, this.mergedBordered ? S("div", {
      class: `${r}-input__border`
    }) : null, this.mergedBordered ? S("div", {
      class: `${r}-input__state-border`
    }) : null, this.showCount && i === "textarea" ? S(mb, null, {
      default: (c) => {
        var u;
        const {
          renderCount: d
        } = this;
        return d ? d(c) : (u = s.count) === null || u === void 0 ? void 0 : u.call(s, c);
      }
    }) : null);
  }
}), j5 = Z({
  name: "UIInput"
}), R5 = Z({
  ...j5,
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: { type: String, default: void 0 },
    readonly: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: Number,
    minlength: Number,
    loading: {
      type: Boolean
    },
    autosize: {
      type: [Boolean, Object]
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    },
    showCount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    inputProps: {
      /** It can be any HTML `TextareaHTMLAttributes` and  `InputHTMLAttributes` */
      type: Object
    },
    showPasswordOn: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange"],
  setup(e, { emit: t }) {
    const r = ["text", "textarea", "password"], n = e, o = t, i = W(() => r.includes(n.type) ? n.type : "text"), a = W(() => {
      if (!r.includes(n.type))
        return {
          type: n.type,
          ...n.inputProps
        };
      if (n.inputProps)
        return n.inputProps;
    });
    function l(s) {
      o("update:modelValue", s);
    }
    return (s, c) => (_(), se(N(Gc), Ut(s.$attrs, {
      id: e.id,
      clearable: e.clearable,
      disabled: e.disabled,
      loading: e.loading,
      maxlength: e.maxlength,
      minlength: e.minlength,
      placeholder: e.placeholder,
      readonly: e.readonly,
      rows: e.rows,
      "show-count": e.showCount,
      size: e.size,
      type: i.value,
      "input-props": a.value,
      value: e.modelValue,
      autosize: e.autosize,
      "show-password-on": e.showPasswordOn,
      "onUpdate:value": l,
      onOnBlur: c[0] || (c[0] = (u) => s.$emit("onBlur", u)),
      onOnChange: c[1] || (c[1] = (u) => s.$emit("onChange", u)),
      class: "hl-input-text font-sans"
    }), {
      prefix: Q(() => [
        Re(s.$slots, "prefix")
      ]),
      suffix: Q(() => [
        Re(s.$slots, "suffix")
      ]),
      "password-visible-icon": Q(() => [
        Re(s.$slots, "password-visible-icon")
      ]),
      "password-invisible-icon": Q(() => [
        Re(s.$slots, "password-invisible-icon")
      ]),
      _: 3
    }, 16, ["id", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "size", "type", "input-props", "value", "autosize", "show-password-on"]));
  }
}), ni = R5, _5 = te("input-group", `
 display: inline-flex;
 width: 100%;
 flex-wrap: nowrap;
 vertical-align: bottom;
`, [V(">", [te("input", [V("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), V("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 margin-left: -1px!important;
 `)]), te("button", [V("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [F("state-border, border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)]), V("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [F("state-border, border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])]), V("*", [V("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [V(">", [te("input", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), te("base-selection", [te("base-selection-label", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), te("base-selection-tags", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), F("box-shadow, border, state-border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)])])]), V("&:not(:first-child)", `
 margin-left: -1px!important;
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [V(">", [te("input", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), te("base-selection", [te("base-selection-label", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), te("base-selection-tags", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), F("box-shadow, border, state-border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])])])])])]), P5 = {}, B5 = Z({
  name: "InputGroup",
  props: P5,
  setup(e) {
    const {
      mergedClsPrefixRef: t
    } = Bt(e);
    return ko("-input-group", _5, t), {
      mergedClsPrefix: t
    };
  },
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return S("div", {
      class: `${e}-input-group`
    }, this.$slots);
  }
}), F5 = Z({
  name: "UIInputGroup",
  inheritAttrs: !1
}), U5 = Z({
  ...F5,
  setup(e) {
    return (t, r) => (_(), se(N(B5), null, {
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), fw = U5;
function Ql(e) {
  return Object.keys(e);
}
const H5 = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  // deprecated
  checkedValue: {
    type: Boolean,
    default: void 0
  }
}, pw = "n-radio-group";
function Y5(e) {
  process.env.NODE_ENV !== "production" && rr(() => {
    e.checkedValue !== void 0 && sr("radio", "`checked-value` is deprecated, please use `checked` instead.");
  });
  const t = Ia(e, {
    mergedSize(M) {
      const {
        size: x
      } = e;
      if (x !== void 0)
        return x;
      if (a) {
        const {
          mergedSizeRef: {
            value: b
          }
        } = a;
        if (b !== void 0)
          return b;
      }
      return M ? M.mergedSize.value : "medium";
    },
    mergedDisabled(M) {
      return !!(e.disabled || a != null && a.disabledRef.value || M != null && M.disabled.value);
    }
  }), {
    mergedSizeRef: r,
    mergedDisabledRef: n
  } = t, o = L(null), i = L(null), a = De(pw, null), l = L(e.defaultChecked), s = We(e, "checked"), c = fi(s, l), u = _t(() => a ? a.valueRef.value === e.value : c.value), d = _t(() => {
    const {
      name: M
    } = e;
    if (M !== void 0)
      return M;
    if (a)
      return a.nameRef.value;
  }), f = L(!1);
  function p() {
    if (a) {
      const {
        doUpdateValue: M
      } = a, {
        value: x
      } = e;
      Be(M, x);
    } else {
      const {
        onUpdateChecked: M,
        "onUpdate:checked": x
      } = e, {
        nTriggerFormInput: b,
        nTriggerFormChange: T
      } = t;
      M && Be(M, !0), x && Be(x, !0), b(), T(), l.value = !0;
    }
  }
  function h() {
    n.value || u.value || p();
  }
  function g() {
    h(), o.value && (o.value.checked = u.value);
  }
  function m() {
    f.value = !1;
  }
  function v() {
    f.value = !0;
  }
  return {
    mergedClsPrefix: a ? a.mergedClsPrefixRef : Bt(e).mergedClsPrefixRef,
    inputRef: o,
    labelRef: i,
    mergedName: d,
    mergedDisabled: n,
    renderSafeChecked: u,
    focus: f,
    mergedSize: r,
    handleRadioInputChange: g,
    handleRadioInputBlur: m,
    handleRadioInputFocus: v
  };
}
const W5 = te("radio-group", `
 display: inline-block;
 font-size: var(--n-font-size);
`, [F("splitor", `
 display: inline-block;
 vertical-align: bottom;
 width: 1px;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 background: var(--n-button-border-color);
 `, [fe("checked", {
  backgroundColor: "var(--n-button-border-color-active)"
}), fe("disabled", {
  opacity: "var(--n-opacity-disabled)"
})]), fe("button-group", `
 white-space: nowrap;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [te("radio-button", {
  height: "var(--n-height)",
  lineHeight: "var(--n-height)"
}), F("splitor", {
  height: "var(--n-height)"
})]), te("radio-button", `
 vertical-align: bottom;
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-block;
 box-sizing: border-box;
 padding-left: 14px;
 padding-right: 14px;
 white-space: nowrap;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background: var(--n-button-color);
 color: var(--n-button-text-color);
 border-top: 1px solid var(--n-button-border-color);
 border-bottom: 1px solid var(--n-button-border-color);
 `, [te("radio-input", `
 pointer-events: none;
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 `), F("state-border", `
 z-index: 1;
 pointer-events: none;
 position: absolute;
 box-shadow: var(--n-button-box-shadow);
 transition: box-shadow .3s var(--n-bezier);
 left: -1px;
 bottom: -1px;
 right: -1px;
 top: -1px;
 `), V("&:first-child", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 border-left: 1px solid var(--n-button-border-color);
 `, [F("state-border", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 `)]), V("&:last-child", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 border-right: 1px solid var(--n-button-border-color);
 `, [F("state-border", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 `)]), $t("disabled", `
 cursor: pointer;
 `, [V("&:hover", [F("state-border", `
 transition: box-shadow .3s var(--n-bezier);
 box-shadow: var(--n-button-box-shadow-hover);
 `), $t("checked", {
  color: "var(--n-button-text-color-hover)"
})]), fe("focus", [V("&:not(:active)", [F("state-border", {
  boxShadow: "var(--n-button-box-shadow-focus)"
})])])]), fe("checked", `
 background: var(--n-button-color-active);
 color: var(--n-button-text-color-active);
 border-color: var(--n-button-border-color-active);
 `), fe("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `)])]);
function Q5(e, t = "default", r = []) {
  const n = e.$slots[t];
  return n === void 0 ? r : n();
}
const V5 = {
  radioSizeSmall: "14px",
  radioSizeMedium: "16px",
  radioSizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
}, Z5 = (e) => {
  const {
    borderColor: t,
    primaryColor: r,
    baseColor: n,
    textColorDisabled: o,
    inputColorDisabled: i,
    textColor2: a,
    opacityDisabled: l,
    borderRadius: s,
    fontSizeSmall: c,
    fontSizeMedium: u,
    fontSizeLarge: d,
    heightSmall: f,
    heightMedium: p,
    heightLarge: h,
    lineHeight: g
  } = e;
  return Object.assign(Object.assign({}, V5), {
    labelLineHeight: g,
    buttonHeightSmall: f,
    buttonHeightMedium: p,
    buttonHeightLarge: h,
    fontSizeSmall: c,
    fontSizeMedium: u,
    fontSizeLarge: d,
    boxShadow: `inset 0 0 0 1px ${t}`,
    boxShadowActive: `inset 0 0 0 1px ${r}`,
    boxShadowFocus: `inset 0 0 0 1px ${r}, 0 0 0 2px ${qe(r, {
      alpha: 0.2
    })}`,
    boxShadowHover: `inset 0 0 0 1px ${r}`,
    boxShadowDisabled: `inset 0 0 0 1px ${t}`,
    color: n,
    colorDisabled: i,
    colorActive: "#0000",
    textColor: a,
    textColorDisabled: o,
    dotColorActive: r,
    dotColorDisabled: t,
    buttonBorderColor: t,
    buttonBorderColorActive: r,
    buttonBorderColorHover: t,
    buttonColor: n,
    buttonColorActive: n,
    buttonTextColor: a,
    buttonTextColorActive: r,
    buttonTextColorHover: r,
    opacityDisabled: l,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${r}, 0 0 0 2px ${qe(r, {
      alpha: 0.3
    })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: s
  });
}, G5 = {
  name: "Radio",
  common: Jt,
  self: Z5
}, hw = G5;
function K5(e, t, r) {
  var n;
  const o = [];
  let i = !1;
  for (let a = 0; a < e.length; ++a) {
    const l = e[a], s = (n = l.type) === null || n === void 0 ? void 0 : n.name;
    if (s === "RadioButton" && (i = !0), process.env.NODE_ENV !== "production" && i && s !== "RadioButton") {
      la("radio-group", "`n-radio-group` in button mode only takes `n-radio-button` as children.");
      continue;
    }
    const c = l.props;
    if (s !== "RadioButton") {
      o.push(l);
      continue;
    }
    if (a === 0)
      o.push(l);
    else {
      const u = o[o.length - 1].props, d = t === u.value, f = u.disabled, p = t === c.value, h = c.disabled, g = (d ? 2 : 0) + (f ? 0 : 1), m = (p ? 2 : 0) + (h ? 0 : 1), v = {
        [`${r}-radio-group__splitor--disabled`]: f,
        [`${r}-radio-group__splitor--checked`]: d
      }, M = {
        [`${r}-radio-group__splitor--disabled`]: h,
        [`${r}-radio-group__splitor--checked`]: p
      }, x = g < m ? M : v;
      o.push(S("div", {
        class: [`${r}-radio-group__splitor`, x]
      }), l);
    }
  }
  return {
    children: o,
    isButtonGroup: i
  };
}
const q5 = Object.assign(Object.assign({}, Ve.props), {
  name: String,
  value: [String, Number, Boolean],
  defaultValue: {
    type: [String, Number, Boolean],
    default: null
  },
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), J5 = Z({
  name: "RadioGroup",
  props: q5,
  setup(e) {
    const t = L(null), {
      mergedSizeRef: r,
      mergedDisabledRef: n,
      nTriggerFormChange: o,
      nTriggerFormInput: i,
      nTriggerFormBlur: a,
      nTriggerFormFocus: l
    } = Ia(e), {
      mergedClsPrefixRef: s,
      inlineThemeDisabled: c,
      mergedRtlRef: u
    } = Bt(e), d = Ve("Radio", "-radio-group", W5, hw, e, s), f = L(e.defaultValue), p = We(e, "value"), h = fi(p, f);
    function g(T) {
      const {
        onUpdateValue: w,
        "onUpdate:value": y
      } = e;
      w && Be(w, T), y && Be(y, T), f.value = T, o(), i();
    }
    function m(T) {
      const {
        value: w
      } = t;
      w && (w.contains(T.relatedTarget) || l());
    }
    function v(T) {
      const {
        value: w
      } = t;
      w && (w.contains(T.relatedTarget) || a());
    }
    Et(pw, {
      mergedClsPrefixRef: s,
      nameRef: We(e, "name"),
      valueRef: h,
      disabledRef: n,
      mergedSizeRef: r,
      doUpdateValue: g
    });
    const M = yn("Radio", u, s), x = W(() => {
      const {
        value: T
      } = r, {
        common: {
          cubicBezierEaseInOut: w
        },
        self: {
          buttonBorderColor: y,
          buttonBorderColorActive: I,
          buttonBorderRadius: D,
          buttonBoxShadow: O,
          buttonBoxShadowFocus: $,
          buttonBoxShadowHover: z,
          buttonColor: Y,
          buttonColorActive: j,
          buttonTextColor: q,
          buttonTextColorActive: ee,
          buttonTextColorHover: re,
          opacityDisabled: le,
          [ve("buttonHeight", T)]: ye,
          [ve("fontSize", T)]: Me
        }
      } = d.value;
      return {
        "--n-font-size": Me,
        "--n-bezier": w,
        "--n-button-border-color": y,
        "--n-button-border-color-active": I,
        "--n-button-border-radius": D,
        "--n-button-box-shadow": O,
        "--n-button-box-shadow-focus": $,
        "--n-button-box-shadow-hover": z,
        "--n-button-color": Y,
        "--n-button-color-active": j,
        "--n-button-text-color": q,
        "--n-button-text-color-hover": re,
        "--n-button-text-color-active": ee,
        "--n-height": ye,
        "--n-opacity-disabled": le
      };
    }), b = c ? dr("radio-group", W(() => r.value[0]), x, e) : void 0;
    return {
      selfElRef: t,
      rtlEnabled: M,
      mergedClsPrefix: s,
      mergedValue: h,
      handleFocusout: v,
      handleFocusin: m,
      cssVars: c ? void 0 : x,
      themeClass: b == null ? void 0 : b.themeClass,
      onRender: b == null ? void 0 : b.onRender
    };
  },
  render() {
    var e;
    const {
      mergedValue: t,
      mergedClsPrefix: r,
      handleFocusin: n,
      handleFocusout: o
    } = this, {
      children: i,
      isButtonGroup: a
    } = K5(Ru(Q5(this)), t, r);
    return (e = this.onRender) === null || e === void 0 || e.call(this), S("div", {
      onFocusin: n,
      onFocusout: o,
      ref: "selfElRef",
      class: [`${r}-radio-group`, this.rtlEnabled && `${r}-radio-group--rtl`, this.themeClass, a && `${r}-radio-group--button-group`],
      style: this.cssVars
    }, i);
  }
}), X5 = te("radio", `
 line-height: var(--n-label-line-height);
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 align-items: flex-start;
 flex-wrap: nowrap;
 font-size: var(--n-font-size);
 word-break: break-word;
`, [fe("checked", [F("dot", `
 background-color: var(--n-color-active);
 `)]), F("dot-wrapper", `
 position: relative;
 flex-shrink: 0;
 flex-grow: 0;
 width: var(--n-radio-size);
 `), te("radio-input", `
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 cursor: pointer;
 `), F("dot", `
 position: absolute;
 top: 50%;
 left: 0;
 transform: translateY(-50%);
 height: var(--n-radio-size);
 width: var(--n-radio-size);
 background: var(--n-color);
 box-shadow: var(--n-box-shadow);
 border-radius: 50%;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [V("&::before", `
 content: "";
 opacity: 0;
 position: absolute;
 left: 4px;
 top: 4px;
 height: calc(100% - 8px);
 width: calc(100% - 8px);
 border-radius: 50%;
 transform: scale(.8);
 background: var(--n-dot-color-active);
 transition: 
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .3s var(--n-bezier);
 `), fe("checked", {
  boxShadow: "var(--n-box-shadow-active)"
}, [V("&::before", `
 opacity: 1;
 transform: scale(1);
 `)])]), F("label", `
 color: var(--n-text-color);
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 display: inline-block;
 transition: color .3s var(--n-bezier);
 `), $t("disabled", `
 cursor: pointer;
 `, [V("&:hover", [F("dot", {
  boxShadow: "var(--n-box-shadow-hover)"
})]), fe("focus", [V("&:not(:active)", [F("dot", {
  boxShadow: "var(--n-box-shadow-focus)"
})])])]), fe("disabled", `
 cursor: not-allowed;
 `, [F("dot", {
  boxShadow: "var(--n-box-shadow-disabled)",
  backgroundColor: "var(--n-color-disabled)"
}, [V("&::before", {
  backgroundColor: "var(--n-dot-color-disabled)"
}), fe("checked", `
 opacity: 1;
 `)]), F("label", {
  color: "var(--n-text-color-disabled)"
}), te("radio-input", `
 cursor: not-allowed;
 `)])]), eR = Object.assign(Object.assign({}, Ve.props), H5), tR = Z({
  name: "Radio",
  props: eR,
  setup(e) {
    const t = Y5(e), r = Ve("Radio", "-radio", X5, hw, e, t.mergedClsPrefix), n = W(() => {
      const {
        mergedSize: {
          value: c
        }
      } = t, {
        common: {
          cubicBezierEaseInOut: u
        },
        self: {
          boxShadow: d,
          boxShadowActive: f,
          boxShadowDisabled: p,
          boxShadowFocus: h,
          boxShadowHover: g,
          color: m,
          colorDisabled: v,
          colorActive: M,
          textColor: x,
          textColorDisabled: b,
          dotColorActive: T,
          dotColorDisabled: w,
          labelPadding: y,
          labelLineHeight: I,
          labelFontWeight: D,
          [ve("fontSize", c)]: O,
          [ve("radioSize", c)]: $
        }
      } = r.value;
      return {
        "--n-bezier": u,
        "--n-label-line-height": I,
        "--n-label-font-weight": D,
        "--n-box-shadow": d,
        "--n-box-shadow-active": f,
        "--n-box-shadow-disabled": p,
        "--n-box-shadow-focus": h,
        "--n-box-shadow-hover": g,
        "--n-color": m,
        "--n-color-active": M,
        "--n-color-disabled": v,
        "--n-dot-color-active": T,
        "--n-dot-color-disabled": w,
        "--n-font-size": O,
        "--n-radio-size": $,
        "--n-text-color": x,
        "--n-text-color-disabled": b,
        "--n-label-padding": y
      };
    }), {
      inlineThemeDisabled: o,
      mergedClsPrefixRef: i,
      mergedRtlRef: a
    } = Bt(e), l = yn("Radio", a, i), s = o ? dr("radio", W(() => t.mergedSize.value[0]), n, e) : void 0;
    return Object.assign(t, {
      rtlEnabled: l,
      cssVars: o ? void 0 : n,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    });
  },
  render() {
    const {
      $slots: e,
      mergedClsPrefix: t,
      onRender: r,
      label: n
    } = this;
    return r == null || r(), S("label", {
      class: [`${t}-radio`, this.themeClass, this.rtlEnabled && `${t}-radio--rtl`, this.mergedDisabled && `${t}-radio--disabled`, this.renderSafeChecked && `${t}-radio--checked`, this.focus && `${t}-radio--focus`],
      style: this.cssVars
    }, S("input", {
      ref: "inputRef",
      type: "radio",
      class: `${t}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    }), S("div", {
      class: `${t}-radio__dot-wrapper`
    }, " ", S("div", {
      class: [`${t}-radio__dot`, this.renderSafeChecked && `${t}-radio__dot--checked`]
    })), mt(e.default, (o) => !o && !n ? null : S("div", {
      ref: "labelRef",
      class: `${t}-radio__label`
    }, o || n)));
  }
}), rR = Z({
  name: "UITooltip",
  inheritAttrs: !1
}), nR = Z({
  ...rR,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e) {
    return (t, r) => (_(), se(N(Jx), Ut(t.$attrs, {
      trigger: e.trigger,
      show: e.show,
      placement: e.placement,
      "onUpdate:show": r[0] || (r[0] = (n) => t.$emit("show", n))
    }), {
      trigger: Q(() => [
        Re(t.$slots, "trigger")
      ]),
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["trigger", "show", "placement"]));
  }
}), gs = nR;
let Ri = 0, vb = "", bb = "", Mb = "", yb = "";
const xb = L("0px");
function oR(e) {
  if (typeof document > "u")
    return;
  const t = document.documentElement;
  let r, n = !1;
  const o = () => {
    t.style.marginRight = vb, t.style.overflow = bb, t.style.overflowX = Mb, t.style.overflowY = yb, xb.value = "0px";
  };
  et(() => {
    r = at(e, (i) => {
      if (i) {
        if (!Ri) {
          const a = window.innerWidth - t.offsetWidth;
          a > 0 && (vb = t.style.marginRight, t.style.marginRight = `${a}px`, xb.value = `${a}px`), bb = t.style.overflow, Mb = t.style.overflowX, yb = t.style.overflowY, t.style.overflow = "hidden", t.style.overflowX = "hidden", t.style.overflowY = "hidden";
        }
        n = !0, Ri++;
      } else
        Ri--, Ri || o(), n = !1;
    }, {
      immediate: !0
    });
  }), vt(() => {
    r == null || r(), n && (Ri--, Ri || o(), n = !1);
  });
}
const $m = L(!1), wb = () => {
  $m.value = !0;
}, Tb = () => {
  $m.value = !1;
};
let Ka = 0;
const iR = () => (Sa && (ya(() => {
  Ka || (window.addEventListener("compositionstart", wb), window.addEventListener("compositionend", Tb)), Ka++;
}), vt(() => {
  Ka <= 1 ? (window.removeEventListener("compositionstart", wb), window.removeEventListener("compositionend", Tb), Ka = 0) : Ka--;
})), $m), zm = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, aR = te("form", [fe("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [te("form-item", {
  width: "auto",
  marginRight: "18px"
}, [V("&:last-child", {
  marginRight: 0
})])])]), ms = "n-form", gw = "n-form-item-insts", lR = {
  feedbackPadding: "4px 0 0 2px",
  feedbackHeightSmall: "24px",
  feedbackHeightMedium: "24px",
  feedbackHeightLarge: "26px",
  feedbackFontSizeSmall: "13px",
  feedbackFontSizeMedium: "14px",
  feedbackFontSizeLarge: "14px",
  labelFontSizeLeftSmall: "14px",
  labelFontSizeLeftMedium: "14px",
  labelFontSizeLeftLarge: "15px",
  labelFontSizeTopSmall: "13px",
  labelFontSizeTopMedium: "14px",
  labelFontSizeTopLarge: "14px",
  labelHeightSmall: "24px",
  labelHeightMedium: "26px",
  labelHeightLarge: "28px",
  labelPaddingVertical: "0 0 6px 2px",
  labelPaddingHorizontal: "0 12px 0 0",
  labelTextAlignVertical: "left",
  labelTextAlignHorizontal: "right",
  labelFontWeight: "400"
}, sR = (e) => {
  const {
    heightSmall: t,
    heightMedium: r,
    heightLarge: n,
    textColor1: o,
    errorColor: i,
    warningColor: a,
    lineHeight: l,
    textColor3: s
  } = e;
  return Object.assign(Object.assign({}, lR), {
    blankHeightSmall: t,
    blankHeightMedium: r,
    blankHeightLarge: n,
    lineHeight: l,
    labelTextColor: o,
    asteriskColor: i,
    feedbackTextColorError: i,
    feedbackTextColorWarning: a,
    feedbackTextColor: s
  });
}, uR = {
  name: "Form",
  common: Jt,
  self: sR
}, mw = uR;
var cR = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function l(u) {
      try {
        c(n.next(u));
      } catch (d) {
        a(d);
      }
    }
    function s(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : o(u.value).then(l, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
const dR = Object.assign(Object.assign({}, Ve.props), {
  inline: Boolean,
  labelWidth: [Number, String],
  labelAlign: String,
  labelPlacement: {
    type: String,
    default: "top"
  },
  model: {
    type: Object,
    default: () => {
    }
  },
  rules: Object,
  disabled: Boolean,
  size: String,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: !0
  },
  onSubmit: {
    type: Function,
    default: (e) => {
      e.preventDefault();
    }
  },
  showLabel: {
    type: Boolean,
    default: void 0
  },
  validateMessages: Object
}), fR = Z({
  name: "Form",
  props: dR,
  setup(e) {
    const {
      mergedClsPrefixRef: t
    } = Bt(e);
    Ve("Form", "-form", aR, mw, e, t);
    const r = {}, n = L(void 0), o = (l) => {
      const s = n.value;
      (s === void 0 || l >= s) && (n.value = l);
    };
    function i(l, s = () => !0) {
      return cR(this, void 0, void 0, function* () {
        return yield new Promise((c, u) => {
          const d = [];
          for (const f of Ql(r)) {
            const p = r[f];
            for (const h of p)
              h.path && d.push(h.internalValidate(null, s));
          }
          Promise.all(d).then((f) => {
            const p = f.some((m) => !m.valid), h = [], g = [];
            f.forEach((m) => {
              var v, M;
              !((v = m.errors) === null || v === void 0) && v.length && h.push(m.errors), !((M = m.warnings) === null || M === void 0) && M.length && g.push(m.warnings);
            }), l && l(h.length ? h : void 0, {
              warnings: g.length ? g : void 0
            }), p ? u(h.length ? h : void 0) : c({
              warnings: g.length ? g : void 0
            });
          });
        });
      });
    }
    function a() {
      for (const l of Ql(r)) {
        const s = r[l];
        for (const c of s)
          c.restoreValidation();
      }
    }
    return Et(ms, {
      props: e,
      maxChildLabelWidthRef: n,
      deriveMaxChildLabelWidth: o
    }), Et(gw, {
      formItems: r
    }), Object.assign({
      validate: i,
      restoreValidation: a
    }, {
      mergedClsPrefix: t
    });
  },
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return S("form", {
      class: [`${e}-form`, this.inline && `${e}-form--inline`],
      onSubmit: this.onSubmit
    }, this.$slots);
  }
}), pR = Z({
  name: "UIForm"
}), hR = Z({
  ...pR,
  props: {
    rules: {
      type: Object
    },
    inline: {
      type: Boolean,
      default: !1
    },
    model: {
      type: [String, Object]
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e, { expose: t }) {
    const r = L();
    function n() {
      return r.value;
    }
    return t({ getForm: n }), (o, i) => (_(), se(N(fR), Ut({ id: e.id }, o.$attrs, {
      rules: e.rules,
      model: e.model,
      inline: e.inline,
      ref_key: "formRef",
      ref: r
    }), {
      default: Q(() => [
        Re(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "rules", "model", "inline"]));
  }
}), Om = hR;
function gR(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
const mR = Z({
  name: "UIFormLabelTooltip",
  inheritAttrs: !1
}), vR = Z({
  ...mR,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: gR
    },
    iconClass: String
  },
  setup(e) {
    return (t, r) => (_(), se(N(gs), {
      placement: e.placement,
      trigger: e.trigger
    }, {
      trigger: Q(() => [
        (_(), se(Jn(e.icon), {
          class: br(e.iconClass ? e.iconClass : "w-4 h-4 text-gray-500")
        }, null, 8, ["class"]))
      ]),
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger"]));
  }
}), bR = vR;
function qo() {
  return qo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qo.apply(this, arguments);
}
function MR(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Vl(e, t);
}
function np(e) {
  return np = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, np(e);
}
function Vl(e, t) {
  return Vl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Vl(e, t);
}
function yR() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function bu(e, t, r) {
  return yR() ? bu = Reflect.construct.bind() : bu = function(n, o, i) {
    var a = [null];
    a.push.apply(a, o);
    var l = Function.bind.apply(n, a), s = new l();
    return i && Vl(s, i.prototype), s;
  }, bu.apply(null, arguments);
}
function xR(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function op(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return op = function(r) {
    if (r === null || !xR(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, n);
    }
    function n() {
      return bu(r, arguments, np(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Vl(n, r);
  }, op(e);
}
var wR = /%[sdj%]/g, vw = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (vw = function(e, t) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && t.every(function(r) {
    return typeof r == "string";
  }) && console.warn(e, t);
});
function ip(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function Br(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var o = 0, i = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var a = e.replace(wR, function(l) {
      if (l === "%%")
        return "%";
      if (o >= i)
        return l;
      switch (l) {
        case "%s":
          return String(r[o++]);
        case "%d":
          return Number(r[o++]);
        case "%j":
          try {
            return JSON.stringify(r[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return l;
      }
    });
    return a;
  }
  return e;
}
function TR(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Vt(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || TR(t) && typeof e == "string" && !e);
}
function NR(e, t, r) {
  var n = [], o = 0, i = e.length;
  function a(l) {
    n.push.apply(n, l || []), o++, o === i && r(n);
  }
  e.forEach(function(l) {
    t(l, a);
  });
}
function Nb(e, t, r) {
  var n = 0, o = e.length;
  function i(a) {
    if (a && a.length) {
      r(a);
      return;
    }
    var l = n;
    n = n + 1, l < o ? t(e[l], i) : r([]);
  }
  i([]);
}
function SR(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, e[r] || []);
  }), t;
}
var Sb = /* @__PURE__ */ function(e) {
  MR(t, e);
  function t(r, n) {
    var o;
    return o = e.call(this, "Async Validation Error") || this, o.errors = r, o.fields = n, o;
  }
  return t;
}(/* @__PURE__ */ op(Error));
function CR(e, t, r, n, o) {
  if (t.first) {
    var i = new Promise(function(f, p) {
      var h = function(m) {
        return n(m), m.length ? p(new Sb(m, ip(m))) : f(o);
      }, g = SR(e);
      Nb(g, r, h);
    });
    return i.catch(function(f) {
      return f;
    }), i;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], l = Object.keys(e), s = l.length, c = 0, u = [], d = new Promise(function(f, p) {
    var h = function(g) {
      if (u.push.apply(u, g), c++, c === s)
        return n(u), u.length ? p(new Sb(u, ip(u))) : f(o);
    };
    l.length || (n(u), f(o)), l.forEach(function(g) {
      var m = e[g];
      a.indexOf(g) !== -1 ? Nb(m, r, h) : NR(m, r, h);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function IR(e) {
  return !!(e && e.message !== void 0);
}
function AR(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function Cb(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = AR(t, e.fullFields) : n = t[r.field || e.fullField], IR(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function Ib(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        typeof n == "object" && typeof e[r] == "object" ? e[r] = qo({}, e[r], n) : e[r] = n;
      }
  }
  return e;
}
var bw = function(e, t, r, n, o, i) {
  e.required && (!r.hasOwnProperty(e.field) || Vt(t, i || e.type)) && n.push(Br(o.messages.required, e.fullField));
}, DR = function(e, t, r, n, o) {
  (/^\s+$/.test(t) || t === "") && n.push(Br(o.messages.whitespace, e.fullField));
}, Ys, kR = function() {
  if (Ys)
    return Ys;
  var e = "[a-fA-F\\d:]", t = function(x) {
    return x && x.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", o = (`
(?:
(?:` + n + ":){7}(?:" + n + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + n + ":){6}(?:" + r + "|:" + n + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + n + ":){5}(?::" + r + "|(?::" + n + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + n + ":){4}(?:(?::" + n + "){0,1}:" + r + "|(?::" + n + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + n + ":){3}(?:(?::" + n + "){0,2}:" + r + "|(?::" + n + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + n + ":){2}(?:(?::" + n + "){0,3}:" + r + "|(?::" + n + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + n + ":){1}(?:(?::" + n + "){0,4}:" + r + "|(?::" + n + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + n + "){0,5}:" + r + "|(?::" + n + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), i = new RegExp("(?:^" + r + "$)|(?:^" + o + "$)"), a = new RegExp("^" + r + "$"), l = new RegExp("^" + o + "$"), s = function(x) {
    return x && x.exact ? i : new RegExp("(?:" + t(x) + r + t(x) + ")|(?:" + t(x) + o + t(x) + ")", "g");
  };
  s.v4 = function(x) {
    return x && x.exact ? a : new RegExp("" + t(x) + r + t(x), "g");
  }, s.v6 = function(x) {
    return x && x.exact ? l : new RegExp("" + t(x) + o + t(x), "g");
  };
  var c = "(?:(?:[a-z]+:)?//)", u = "(?:\\S+(?::\\S*)?@)?", d = s.v4().source, f = s.v6().source, p = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", h = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", g = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", v = '(?:[/?#][^\\s"]*)?', M = "(?:" + c + "|www\\.)" + u + "(?:localhost|" + d + "|" + f + "|" + p + h + g + ")" + m + v;
  return Ys = new RegExp("(?:^" + M + "$)", "i"), Ys;
}, Ab = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, el = {
  integer: function(e) {
    return el.number(e) && parseInt(e, 10) === e;
  },
  float: function(e) {
    return el.number(e) && !el.integer(e);
  },
  array: function(e) {
    return Array.isArray(e);
  },
  regexp: function(e) {
    if (e instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(e);
    } catch {
      return !1;
    }
  },
  date: function(e) {
    return typeof e.getTime == "function" && typeof e.getMonth == "function" && typeof e.getYear == "function" && !isNaN(e.getTime());
  },
  number: function(e) {
    return isNaN(e) ? !1 : typeof e == "number";
  },
  object: function(e) {
    return typeof e == "object" && !el.array(e);
  },
  method: function(e) {
    return typeof e == "function";
  },
  email: function(e) {
    return typeof e == "string" && e.length <= 320 && !!e.match(Ab.email);
  },
  url: function(e) {
    return typeof e == "string" && e.length <= 2048 && !!e.match(kR());
  },
  hex: function(e) {
    return typeof e == "string" && !!e.match(Ab.hex);
  }
}, ER = function(e, t, r, n, o) {
  if (e.required && t === void 0) {
    bw(e, t, r, n, o);
    return;
  }
  var i = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], a = e.type;
  i.indexOf(a) > -1 ? el[a](t) || n.push(Br(o.messages.types[a], e.fullField, e.type)) : a && typeof t !== e.type && n.push(Br(o.messages.types[a], e.fullField, e.type));
}, LR = function(e, t, r, n, o) {
  var i = typeof e.len == "number", a = typeof e.min == "number", l = typeof e.max == "number", s = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, c = t, u = null, d = typeof t == "number", f = typeof t == "string", p = Array.isArray(t);
  if (d ? u = "number" : f ? u = "string" : p && (u = "array"), !u)
    return !1;
  p && (c = t.length), f && (c = t.replace(s, "_").length), i ? c !== e.len && n.push(Br(o.messages[u].len, e.fullField, e.len)) : a && !l && c < e.min ? n.push(Br(o.messages[u].min, e.fullField, e.min)) : l && !a && c > e.max ? n.push(Br(o.messages[u].max, e.fullField, e.max)) : a && l && (c < e.min || c > e.max) && n.push(Br(o.messages[u].range, e.fullField, e.min, e.max));
}, _i = "enum", $R = function(e, t, r, n, o) {
  e[_i] = Array.isArray(e[_i]) ? e[_i] : [], e[_i].indexOf(t) === -1 && n.push(Br(o.messages[_i], e.fullField, e[_i].join(", ")));
}, zR = function(e, t, r, n, o) {
  if (e.pattern) {
    if (e.pattern instanceof RegExp)
      e.pattern.lastIndex = 0, e.pattern.test(t) || n.push(Br(o.messages.pattern.mismatch, e.fullField, t, e.pattern));
    else if (typeof e.pattern == "string") {
      var i = new RegExp(e.pattern);
      i.test(t) || n.push(Br(o.messages.pattern.mismatch, e.fullField, t, e.pattern));
    }
  }
}, nt = {
  required: bw,
  whitespace: DR,
  type: ER,
  range: LR,
  enum: $R,
  pattern: zR
}, OR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t, "string") && !e.required)
      return r();
    nt.required(e, t, n, i, o, "string"), Vt(t, "string") || (nt.type(e, t, n, i, o), nt.range(e, t, n, i, o), nt.pattern(e, t, n, i, o), e.whitespace === !0 && nt.whitespace(e, t, n, i, o));
  }
  r(i);
}, jR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && nt.type(e, t, n, i, o);
  }
  r(i);
}, RR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (t === "" && (t = void 0), Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && (nt.type(e, t, n, i, o), nt.range(e, t, n, i, o));
  }
  r(i);
}, _R = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && nt.type(e, t, n, i, o);
  }
  r(i);
}, PR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), Vt(t) || nt.type(e, t, n, i, o);
  }
  r(i);
}, BR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && (nt.type(e, t, n, i, o), nt.range(e, t, n, i, o));
  }
  r(i);
}, FR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && (nt.type(e, t, n, i, o), nt.range(e, t, n, i, o));
  }
  r(i);
}, UR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (t == null && !e.required)
      return r();
    nt.required(e, t, n, i, o, "array"), t != null && (nt.type(e, t, n, i, o), nt.range(e, t, n, i, o));
  }
  r(i);
}, HR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && nt.type(e, t, n, i, o);
  }
  r(i);
}, YR = "enum", WR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o), t !== void 0 && nt[YR](e, t, n, i, o);
  }
  r(i);
}, QR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t, "string") && !e.required)
      return r();
    nt.required(e, t, n, i, o), Vt(t, "string") || nt.pattern(e, t, n, i, o);
  }
  r(i);
}, VR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t, "date") && !e.required)
      return r();
    if (nt.required(e, t, n, i, o), !Vt(t, "date")) {
      var l;
      t instanceof Date ? l = t : l = new Date(t), nt.type(e, l, n, i, o), l && nt.range(e, l.getTime(), n, i, o);
    }
  }
  r(i);
}, ZR = function(e, t, r, n, o) {
  var i = [], a = Array.isArray(t) ? "array" : typeof t;
  nt.required(e, t, n, i, o, a), r(i);
}, Wd = function(e, t, r, n, o) {
  var i = e.type, a = [], l = e.required || !e.required && n.hasOwnProperty(e.field);
  if (l) {
    if (Vt(t, i) && !e.required)
      return r();
    nt.required(e, t, n, a, o, i), Vt(t, i) || nt.type(e, t, n, a, o);
  }
  r(a);
}, GR = function(e, t, r, n, o) {
  var i = [], a = e.required || !e.required && n.hasOwnProperty(e.field);
  if (a) {
    if (Vt(t) && !e.required)
      return r();
    nt.required(e, t, n, i, o);
  }
  r(i);
}, dl = {
  string: OR,
  method: jR,
  number: RR,
  boolean: _R,
  regexp: PR,
  integer: BR,
  float: FR,
  array: UR,
  object: HR,
  enum: WR,
  pattern: QR,
  date: VR,
  url: Wd,
  hex: Wd,
  email: Wd,
  required: ZR,
  any: GR
};
function ap() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var e = JSON.parse(JSON.stringify(this));
      return e.clone = this.clone, e;
    }
  };
}
var lp = ap(), ua = /* @__PURE__ */ function() {
  function e(r) {
    this.rules = null, this._messages = lp, this.define(r);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var n = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(o) {
      var i = r[o];
      n.rules[o] = Array.isArray(i) ? i : [i];
    });
  }, t.messages = function(r) {
    return r && (this._messages = Ib(ap(), r)), this._messages;
  }, t.validate = function(r, n, o) {
    var i = this;
    n === void 0 && (n = {}), o === void 0 && (o = function() {
    });
    var a = r, l = n, s = o;
    if (typeof l == "function" && (s = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return s && s(null, a), Promise.resolve(a);
    function c(h) {
      var g = [], m = {};
      function v(x) {
        if (Array.isArray(x)) {
          var b;
          g = (b = g).concat.apply(b, x);
        } else
          g.push(x);
      }
      for (var M = 0; M < h.length; M++)
        v(h[M]);
      g.length ? (m = ip(g), s(g, m)) : s(null, a);
    }
    if (l.messages) {
      var u = this.messages();
      u === lp && (u = ap()), Ib(u, l.messages), l.messages = u;
    } else
      l.messages = this.messages();
    var d = {}, f = l.keys || Object.keys(this.rules);
    f.forEach(function(h) {
      var g = i.rules[h], m = a[h];
      g.forEach(function(v) {
        var M = v;
        typeof M.transform == "function" && (a === r && (a = qo({}, a)), m = a[h] = M.transform(m)), typeof M == "function" ? M = {
          validator: M
        } : M = qo({}, M), M.validator = i.getValidationMethod(M), M.validator && (M.field = h, M.fullField = M.fullField || h, M.type = i.getType(M), d[h] = d[h] || [], d[h].push({
          rule: M,
          value: m,
          source: a,
          field: h
        }));
      });
    });
    var p = {};
    return CR(d, l, function(h, g) {
      var m = h.rule, v = (m.type === "object" || m.type === "array") && (typeof m.fields == "object" || typeof m.defaultField == "object");
      v = v && (m.required || !m.required && h.value), m.field = h.field;
      function M(T, w) {
        return qo({}, w, {
          fullField: m.fullField + "." + T,
          fullFields: m.fullFields ? [].concat(m.fullFields, [T]) : [T]
        });
      }
      function x(T) {
        T === void 0 && (T = []);
        var w = Array.isArray(T) ? T : [T];
        !l.suppressWarning && w.length && e.warning("async-validator:", w), w.length && m.message !== void 0 && (w = [].concat(m.message));
        var y = w.map(Cb(m, a));
        if (l.first && y.length)
          return p[m.field] = 1, g(y);
        if (!v)
          g(y);
        else {
          if (m.required && !h.value)
            return m.message !== void 0 ? y = [].concat(m.message).map(Cb(m, a)) : l.error && (y = [l.error(m, Br(l.messages.required, m.field))]), g(y);
          var I = {};
          m.defaultField && Object.keys(h.value).map(function($) {
            I[$] = m.defaultField;
          }), I = qo({}, I, h.rule.fields);
          var D = {};
          Object.keys(I).forEach(function($) {
            var z = I[$], Y = Array.isArray(z) ? z : [z];
            D[$] = Y.map(M.bind(null, $));
          });
          var O = new e(D);
          O.messages(l.messages), h.rule.options && (h.rule.options.messages = l.messages, h.rule.options.error = l.error), O.validate(h.value, h.rule.options || l, function($) {
            var z = [];
            y && y.length && z.push.apply(z, y), $ && $.length && z.push.apply(z, $), g(z.length ? z : null);
          });
        }
      }
      var b;
      if (m.asyncValidator)
        b = m.asyncValidator(m, h.value, x, h.source, l);
      else if (m.validator) {
        try {
          b = m.validator(m, h.value, x, h.source, l);
        } catch (T) {
          console.error == null || console.error(T), l.suppressValidatorError || setTimeout(function() {
            throw T;
          }, 0), x(T.message);
        }
        b === !0 ? x() : b === !1 ? x(typeof m.message == "function" ? m.message(m.fullField || m.field) : m.message || (m.fullField || m.field) + " fails") : b instanceof Array ? x(b) : b instanceof Error && x(b.message);
      }
      b && b.then && b.then(function() {
        return x();
      }, function(T) {
        return x(T);
      });
    }, function(h) {
      c(h);
    }, a);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !dl.hasOwnProperty(r.type))
      throw new Error(Br("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var n = Object.keys(r), o = n.indexOf("message");
    return o !== -1 && n.splice(o, 1), n.length === 1 && n[0] === "required" ? dl.required : dl[this.getType(r)] || void 0;
  }, e;
}();
ua.register = function(e, t) {
  if (typeof t != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  dl[e] = t;
};
ua.warning = vw;
ua.messages = lp;
ua.validators = dl;
function KR(e) {
  const t = De(ms, null);
  return {
    mergedSize: W(() => e.size !== void 0 ? e.size : (t == null ? void 0 : t.props.size) !== void 0 ? t.props.size : "medium")
  };
}
function qR(e) {
  const t = De(ms, null), r = W(() => {
    const {
      labelPlacement: h
    } = e;
    return h !== void 0 ? h : t != null && t.props.labelPlacement ? t.props.labelPlacement : "top";
  }), n = W(() => r.value === "left" && (e.labelWidth === "auto" || (t == null ? void 0 : t.props.labelWidth) === "auto")), o = W(() => {
    if (r.value === "top")
      return;
    const {
      labelWidth: h
    } = e;
    if (h !== void 0 && h !== "auto")
      return qi(h);
    if (n.value) {
      const g = t == null ? void 0 : t.maxChildLabelWidthRef.value;
      return g !== void 0 ? qi(g) : void 0;
    }
    if ((t == null ? void 0 : t.props.labelWidth) !== void 0)
      return qi(t.props.labelWidth);
  }), i = W(() => {
    const {
      labelAlign: h
    } = e;
    if (h)
      return h;
    if (t != null && t.props.labelAlign)
      return t.props.labelAlign;
  }), a = W(() => {
    var h;
    return [(h = e.labelProps) === null || h === void 0 ? void 0 : h.style, e.labelStyle, {
      width: o.value
    }];
  }), l = W(() => {
    const {
      showRequireMark: h
    } = e;
    return h !== void 0 ? h : t == null ? void 0 : t.props.showRequireMark;
  }), s = W(() => {
    const {
      requireMarkPlacement: h
    } = e;
    return h !== void 0 ? h : (t == null ? void 0 : t.props.requireMarkPlacement) || "right";
  }), c = L(!1), u = L(!1), d = W(() => {
    const {
      validationStatus: h
    } = e;
    if (h !== void 0)
      return h;
    if (c.value)
      return "error";
    if (u.value)
      return "warning";
  }), f = W(() => {
    const {
      showFeedback: h
    } = e;
    return h !== void 0 ? h : (t == null ? void 0 : t.props.showFeedback) !== void 0 ? t.props.showFeedback : !0;
  }), p = W(() => {
    const {
      showLabel: h
    } = e;
    return h !== void 0 ? h : (t == null ? void 0 : t.props.showLabel) !== void 0 ? t.props.showLabel : !0;
  });
  return {
    validationErrored: c,
    validationWarned: u,
    mergedLabelStyle: a,
    mergedLabelPlacement: r,
    mergedLabelAlign: i,
    mergedShowRequireMark: l,
    mergedRequireMarkPlacement: s,
    mergedValidationStatus: d,
    mergedShowFeedback: f,
    mergedShowLabel: p,
    isAutoLabelWidth: n
  };
}
function JR(e) {
  const t = De(ms, null), r = W(() => {
    const {
      rulePath: a
    } = e;
    if (a !== void 0)
      return a;
    const {
      path: l
    } = e;
    if (l !== void 0)
      return l;
  }), n = W(() => {
    const a = [], {
      rule: l
    } = e;
    if (l !== void 0 && (Array.isArray(l) ? a.push(...l) : a.push(l)), t) {
      const {
        rules: s
      } = t.props, {
        value: c
      } = r;
      if (s !== void 0 && c !== void 0) {
        const u = Nm(s, c);
        u !== void 0 && (Array.isArray(u) ? a.push(...u) : a.push(u));
      }
    }
    return a;
  }), o = W(() => n.value.some((a) => a.required)), i = W(() => o.value || e.required);
  return {
    mergedRules: n,
    mergedRequired: i
  };
}
const {
  cubicBezierEaseInOut: Db
} = Mi;
function XR({
  name: e = "fade-down",
  fromOffset: t = "-4px",
  enterDuration: r = ".3s",
  leaveDuration: n = ".3s",
  enterCubicBezier: o = Db,
  leaveCubicBezier: i = Db
} = {}) {
  return [V(`&.${e}-transition-enter-from, &.${e}-transition-leave-to`, {
    opacity: 0,
    transform: `translateY(${t})`
  }), V(`&.${e}-transition-enter-to, &.${e}-transition-leave-from`, {
    opacity: 1,
    transform: "translateY(0)"
  }), V(`&.${e}-transition-leave-active`, {
    transition: `opacity ${n} ${i}, transform ${n} ${i}`
  }), V(`&.${e}-transition-enter-active`, {
    transition: `opacity ${r} ${o}, transform ${r} ${o}`
  })];
}
const e_ = te("form-item", `
 display: grid;
 line-height: var(--n-line-height);
`, [te("form-item-label", `
 grid-area: label;
 align-items: center;
 line-height: 1.25;
 text-align: var(--n-label-text-align);
 font-size: var(--n-label-font-size);
 min-height: var(--n-label-height);
 padding: var(--n-label-padding);
 color: var(--n-label-text-color);
 transition: color .3s var(--n-bezier);
 box-sizing: border-box;
 font-weight: var(--n-label-font-weight);
 `, [F("asterisk", `
 white-space: nowrap;
 user-select: none;
 -webkit-user-select: none;
 color: var(--n-asterisk-color);
 transition: color .3s var(--n-bezier);
 `), F("asterisk-placeholder", `
 grid-area: mark;
 user-select: none;
 -webkit-user-select: none;
 visibility: hidden; 
 `)]), te("form-item-blank", `
 grid-area: blank;
 min-height: var(--n-blank-height);
 `), fe("auto-label-width", [te("form-item-label", "white-space: nowrap;")]), fe("left-labelled", `
 grid-template-areas:
 "label blank"
 "label feedback";
 grid-template-columns: auto minmax(0, 1fr);
 grid-template-rows: auto 1fr;
 align-items: flex-start;
 `, [te("form-item-label", `
 display: grid;
 grid-template-columns: 1fr auto;
 min-height: var(--n-blank-height);
 height: auto;
 box-sizing: border-box;
 flex-shrink: 0;
 flex-grow: 0;
 `, [fe("reverse-columns-space", `
 grid-template-columns: auto 1fr;
 `), fe("left-mark", `
 grid-template-areas:
 "mark text"
 ". text";
 `), fe("right-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), fe("right-hanging-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), F("text", `
 grid-area: text; 
 `), F("asterisk", `
 grid-area: mark; 
 align-self: end;
 `)])]), fe("top-labelled", `
 grid-template-areas:
 "label"
 "blank"
 "feedback";
 grid-template-rows: minmax(var(--n-label-height), auto) 1fr;
 grid-template-columns: minmax(0, 100%);
 `, [fe("no-label", `
 grid-template-areas:
 "blank"
 "feedback";
 grid-template-rows: 1fr;
 `), te("form-item-label", `
 display: flex;
 align-items: flex-start;
 justify-content: var(--n-label-text-align);
 `)]), te("form-item-blank", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 position: relative;
 `), te("form-item-feedback-wrapper", `
 grid-area: feedback;
 box-sizing: border-box;
 min-height: var(--n-feedback-height);
 font-size: var(--n-feedback-font-size);
 line-height: 1.25;
 transform-origin: top left;
 `, [V("&:not(:empty)", `
 padding: var(--n-feedback-padding);
 `), te("form-item-feedback", {
  transition: "color .3s var(--n-bezier)",
  color: "var(--n-feedback-text-color)"
}, [fe("warning", {
  color: "var(--n-feedback-text-color-warning)"
}), fe("error", {
  color: "var(--n-feedback-text-color-error)"
}), XR({
  fromOffset: "-3px",
  enterDuration: ".3s",
  leaveDuration: ".2s"
})])])]);
function t_(e, t, r) {
  var n;
  const o = De(e, null);
  if (o === null)
    return;
  const i = (n = xa()) === null || n === void 0 ? void 0 : n.proxy;
  at(r, a), a(r.value), vt(() => {
    a(void 0, r.value);
  });
  function a(c, u) {
    if (!o)
      return;
    const d = o[t];
    u !== void 0 && l(d, u), c !== void 0 && s(d, c);
  }
  function l(c, u) {
    c[u] || (c[u] = []), c[u].splice(c[u].findIndex((d) => d === i), 1);
  }
  function s(c, u) {
    c[u] || (c[u] = []), ~c[u].findIndex((d) => d === i) || c[u].push(i);
  }
}
var kb = globalThis && globalThis.__awaiter || function(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function l(u) {
      try {
        c(n.next(u));
      } catch (d) {
        a(d);
      }
    }
    function s(u) {
      try {
        c(n.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : o(u.value).then(l, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
const r_ = Object.assign(Object.assign({}, Ve.props), {
  label: String,
  labelWidth: [Number, String],
  labelStyle: [String, Object],
  labelAlign: String,
  labelPlacement: String,
  path: String,
  first: Boolean,
  rulePath: String,
  required: Boolean,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: void 0
  },
  rule: [Object, Array],
  size: String,
  ignorePathChange: Boolean,
  validationStatus: String,
  feedback: String,
  showLabel: {
    type: Boolean,
    default: void 0
  },
  labelProps: Object
});
function Eb(e, t) {
  return (...r) => {
    try {
      const n = e(...r);
      return !t && (typeof n == "boolean" || n instanceof Error || Array.isArray(n)) || // Error[]
      n != null && n.then ? n : (n === void 0 || la("form-item/validate", `You return a ${typeof n} typed value in the validator method, which is not recommended. Please use ` + (t ? "`Promise`" : "`boolean`, `Error` or `Promise`") + " typed value instead."), !0);
    } catch (n) {
      la("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(n);
      return;
    }
  };
}
const n_ = Z({
  name: "FormItem",
  props: r_,
  setup(e) {
    t_(gw, "formItems", We(e, "path"));
    const {
      mergedClsPrefixRef: t,
      inlineThemeDisabled: r
    } = Bt(e), n = De(ms, null), o = KR(e), i = qR(e), {
      validationErrored: a,
      validationWarned: l
    } = i, {
      mergedRequired: s,
      mergedRules: c
    } = JR(e), {
      mergedSize: u
    } = o, {
      mergedLabelPlacement: d,
      mergedLabelAlign: f,
      mergedRequireMarkPlacement: p
    } = i, h = L([]), g = L(gb()), m = n ? We(n.props, "disabled") : L(!1), v = Ve("Form", "-form-item", e_, mw, e, t);
    at(We(e, "path"), () => {
      e.ignorePathChange || M();
    });
    function M() {
      h.value = [], a.value = !1, l.value = !1, e.feedback && (g.value = gb());
    }
    function x() {
      I("blur");
    }
    function b() {
      I("change");
    }
    function T() {
      I("focus");
    }
    function w() {
      I("input");
    }
    function y(j, q) {
      return kb(this, void 0, void 0, function* () {
        let ee, re, le, ye;
        return typeof j == "string" ? (ee = j, re = q) : j !== null && typeof j == "object" && (ee = j.trigger, re = j.callback, le = j.shouldRuleBeApplied, ye = j.options), yield new Promise((Me, Ee) => {
          I(ee, le, ye).then(({
            valid: ne,
            errors: ue,
            warnings: Ce
          }) => {
            ne ? (re && re(void 0, {
              warnings: Ce
            }), Me({
              warnings: Ce
            })) : (re && re(ue, {
              warnings: Ce
            }), Ee(ue));
          });
        });
      });
    }
    const I = (j = null, q = () => !0, ee = {
      suppressWarning: !0
    }) => kb(this, void 0, void 0, function* () {
      const {
        path: re
      } = e;
      ee ? ee.first || (ee.first = e.first) : ee = {};
      const {
        value: le
      } = c, ye = n ? Nm(n.props.model, re || "") : void 0, Me = {}, Ee = {}, ne = (j ? le.filter((Se) => Array.isArray(Se.trigger) ? Se.trigger.includes(j) : Se.trigger === j) : le).filter(q).map((Se, _e) => {
        const Fe = Object.assign({}, Se);
        if (Fe.validator && (Fe.validator = Eb(Fe.validator, !1)), Fe.asyncValidator && (Fe.asyncValidator = Eb(Fe.asyncValidator, !0)), Fe.renderMessage) {
          const ot = `__renderMessage__${_e}`;
          Ee[ot] = Fe.message, Fe.message = ot, Me[ot] = Fe.renderMessage;
        }
        return Fe;
      }), ue = ne.filter((Se) => Se.level !== "warning"), Ce = ne.filter((Se) => Se.level === "warning"), ze = re ?? "__n_no_path__", ke = new ua({
        [ze]: ue
      }), tt = new ua({
        [ze]: Ce
      }), {
        validateMessages: Ge
      } = (n == null ? void 0 : n.props) || {};
      Ge && (ke.messages(Ge), tt.messages(Ge));
      const Ne = (Se) => {
        h.value = Se.map((_e) => {
          const Fe = (_e == null ? void 0 : _e.message) || "";
          return {
            key: Fe,
            render: () => Fe.startsWith("__renderMessage__") ? Me[Fe]() : Fe
          };
        }), Se.forEach((_e) => {
          var Fe;
          !((Fe = _e.message) === null || Fe === void 0) && Fe.startsWith("__renderMessage__") && (_e.message = Ee[_e.message]);
        });
      }, Ye = {
        valid: !0,
        errors: void 0,
        warnings: void 0
      };
      if (ue.length) {
        const Se = yield new Promise((_e) => {
          ke.validate({
            [ze]: ye
          }, ee, _e);
        });
        Se != null && Se.length && (a.value = !0, Ye.valid = !1, Ye.errors = Se, Ne(Se));
      }
      if (Ce.length && !Ye.errors) {
        const Se = yield new Promise((_e) => {
          tt.validate({
            [ze]: ye
          }, ee, _e);
        });
        Se != null && Se.length && (Ne(Se), l.value = !0, Ye.warnings = Se);
      }
      return ue.length + Ce.length > 0 && !Ye.errors && !Ye.warnings && M(), Ye;
    });
    Et(Bf, {
      path: We(e, "path"),
      disabled: m,
      mergedSize: o.mergedSize,
      mergedValidationStatus: i.mergedValidationStatus,
      restoreValidation: M,
      handleContentBlur: x,
      handleContentChange: b,
      handleContentFocus: T,
      handleContentInput: w
    });
    const D = {
      validate: y,
      restoreValidation: M,
      internalValidate: I
    }, O = L(null);
    et(() => {
      if (!i.isAutoLabelWidth.value)
        return;
      const j = O.value;
      if (j !== null) {
        const q = j.style.whiteSpace;
        j.style.whiteSpace = "nowrap", j.style.width = "", n == null || n.deriveMaxChildLabelWidth(Number(getComputedStyle(j).width.slice(0, -2))), j.style.whiteSpace = q;
      }
    });
    const $ = W(() => {
      var j;
      const {
        value: q
      } = u, {
        value: ee
      } = d, re = ee === "top" ? "vertical" : "horizontal", {
        common: {
          cubicBezierEaseInOut: le
        },
        self: {
          labelTextColor: ye,
          asteriskColor: Me,
          lineHeight: Ee,
          feedbackTextColor: ne,
          feedbackTextColorWarning: ue,
          feedbackTextColorError: Ce,
          feedbackPadding: ze,
          labelFontWeight: ke,
          [ve("labelHeight", q)]: tt,
          [ve("blankHeight", q)]: Ge,
          [ve("feedbackFontSize", q)]: Ne,
          [ve("feedbackHeight", q)]: Ye,
          [ve("labelPadding", re)]: Se,
          [ve("labelTextAlign", re)]: _e,
          [ve(ve("labelFontSize", ee), q)]: Fe
        }
      } = v.value;
      let ot = (j = f.value) !== null && j !== void 0 ? j : _e;
      return ee === "top" && (ot = ot === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": le,
        "--n-line-height": Ee,
        "--n-blank-height": Ge,
        "--n-label-font-size": Fe,
        "--n-label-text-align": ot,
        "--n-label-height": tt,
        "--n-label-padding": Se,
        "--n-label-font-weight": ke,
        "--n-asterisk-color": Me,
        "--n-label-text-color": ye,
        "--n-feedback-padding": ze,
        "--n-feedback-font-size": Ne,
        "--n-feedback-height": Ye,
        "--n-feedback-text-color": ne,
        "--n-feedback-text-color-warning": ue,
        "--n-feedback-text-color-error": Ce
      };
    }), z = r ? dr("form-item", W(() => {
      var j;
      return `${u.value[0]}${d.value[0]}${((j = f.value) === null || j === void 0 ? void 0 : j[0]) || ""}`;
    }), $, e) : void 0, Y = W(() => d.value === "left" && p.value === "left" && f.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({
      labelElementRef: O,
      mergedClsPrefix: t,
      mergedRequired: s,
      feedbackId: g,
      renderExplains: h,
      reverseColSpace: Y
    }, i), o), D), {
      cssVars: r ? void 0 : $,
      themeClass: z == null ? void 0 : z.themeClass,
      onRender: z == null ? void 0 : z.onRender
    });
  },
  render() {
    const {
      $slots: e,
      mergedClsPrefix: t,
      mergedShowLabel: r,
      mergedShowRequireMark: n,
      mergedRequireMarkPlacement: o,
      onRender: i
    } = this, a = n !== void 0 ? n : this.mergedRequired;
    i == null || i();
    const l = () => {
      const s = this.$slots.label ? this.$slots.label() : this.label;
      if (!s)
        return null;
      const c = S("span", {
        class: `${t}-form-item-label__text`
      }, s), u = a ? S("span", {
        class: `${t}-form-item-label__asterisk`
      }, o !== "left" ? " *" : "* ") : o === "right-hanging" && S("span", {
        class: `${t}-form-item-label__asterisk-placeholder`
      }, " *"), {
        labelProps: d
      } = this;
      return S("label", Object.assign({}, d, {
        class: [d == null ? void 0 : d.class, `${t}-form-item-label`, `${t}-form-item-label--${o}-mark`, this.reverseColSpace && `${t}-form-item-label--reverse-columns-space`],
        style: this.mergedLabelStyle,
        ref: "labelElementRef"
      }), o === "left" ? [u, c] : [c, u]);
    };
    return S("div", {
      class: [`${t}-form-item`, this.themeClass, `${t}-form-item--${this.mergedSize}-size`, `${t}-form-item--${this.mergedLabelPlacement}-labelled`, this.isAutoLabelWidth && `${t}-form-item--auto-label-width`, !r && `${t}-form-item--no-label`],
      style: this.cssVars
    }, r && l(), S("div", {
      class: [`${t}-form-item-blank`, this.mergedValidationStatus && `${t}-form-item-blank--${this.mergedValidationStatus}`]
    }, e), this.mergedShowFeedback ? S("div", {
      key: this.feedbackId,
      class: `${t}-form-item-feedback-wrapper`
    }, S(zn, {
      name: "fade-down-transition",
      mode: "out-in"
    }, {
      default: () => {
        const {
          mergedValidationStatus: s
        } = this;
        return mt(e.feedback, (c) => {
          var u;
          const {
            feedback: d
          } = this, f = c || d ? S("div", {
            key: "__feedback__",
            class: `${t}-form-item-feedback__line`
          }, c || d) : this.renderExplains.length ? (u = this.renderExplains) === null || u === void 0 ? void 0 : u.map(({
            key: p,
            render: h
          }) => S("div", {
            key: p,
            class: `${t}-form-item-feedback__line`
          }, h())) : null;
          return f ? s === "warning" ? S("div", {
            key: "controlled-warning",
            class: `${t}-form-item-feedback ${t}-form-item-feedback--warning`
          }, f) : s === "error" ? S("div", {
            key: "controlled-error",
            class: `${t}-form-item-feedback ${t}-form-item-feedback--error`
          }, f) : s === "success" ? S("div", {
            key: "controlled-success",
            class: `${t}-form-item-feedback ${t}-form-item-feedback--success`
          }, f) : S("div", {
            key: "controlled-default",
            class: `${t}-form-item-feedback`
          }, f) : null;
        });
      }
    })) : null);
  }
}), o_ = { class: "n-form-custom-label" }, i_ = {
  key: 0,
  class: "asterisk"
}, a_ = { key: 0 }, l_ = Z({
  name: "UIFormItem",
  inheritAttrs: !1
}), s_ = Z({
  ...l_,
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: !0
    },
    showFeedback: {
      type: Boolean,
      default: !0
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean
  },
  setup(e) {
    return (t, r) => (_(), se(N(n_), Ut(t.$attrs, {
      rule: e.rule,
      label: e.label,
      path: e.path,
      "show-label": e.showLabel,
      "show-feedback": e.showFeedback,
      class: { "n-form-has-custom-label": e.tooltip },
      required: e.required
    }), Xg({
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 2
    }, [
      e.tooltip ? {
        name: "label",
        fn: Q(() => {
          var n, o, i, a;
          return [
            de("div", o_, [
              de("span", null, [
                de("span", null, kt(e.label), 1),
                e.required ? (_(), be("span", i_, " *")) : Oe("", !0)
              ]),
              B(bR, {
                placement: (n = e.tooltip) == null ? void 0 : n.placement,
                trigger: (o = e.tooltip) == null ? void 0 : o.trigger,
                icon: (i = e.tooltip) == null ? void 0 : i.icon,
                iconClass: (a = e.tooltip) == null ? void 0 : a.iconClass
              }, {
                default: Q(() => [
                  typeof e.tooltip.text == "string" ? (_(), be("span", a_, kt(e.tooltip.text), 1)) : (_(), se(Jn(e.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])
            ])
          ];
        }),
        key: "0"
      } : void 0
    ]), 1040, ["rule", "label", "path", "show-label", "show-feedback", "class", "required"]));
  }
}), Rr = s_, u_ = "n-dialog-provider", jm = {
  icon: Function,
  type: {
    type: String,
    default: "default"
  },
  title: [String, Function],
  closable: {
    type: Boolean,
    default: !0
  },
  negativeText: String,
  positiveText: String,
  positiveButtonProps: Object,
  negativeButtonProps: Object,
  content: [String, Function],
  action: Function,
  showIcon: {
    type: Boolean,
    default: !0
  },
  loading: Boolean,
  bordered: Boolean,
  iconPlacement: String,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onClose: Function
}, c_ = Ql(jm), d_ = V([te("card", `
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 display: flex;
 flex-direction: column;
 width: 100%;
 box-sizing: border-box;
 position: relative;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 color: var(--n-text-color);
 word-break: break-word;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [R1({
  background: "var(--n-color-modal)"
}), fe("hoverable", [V("&:hover", "box-shadow: var(--n-box-shadow);")]), fe("content-segmented", [V(">", [F("content", {
  paddingTop: "var(--n-padding-bottom)"
})])]), fe("content-soft-segmented", [V(">", [F("content", `
 margin: 0 var(--n-padding-left);
 padding: var(--n-padding-bottom) 0;
 `)])]), fe("footer-segmented", [V(">", [F("footer", {
  paddingTop: "var(--n-padding-bottom)"
})])]), fe("footer-soft-segmented", [V(">", [F("footer", `
 padding: var(--n-padding-bottom) 0;
 margin: 0 var(--n-padding-left);
 `)])]), V(">", [te("card-header", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 padding:
 var(--n-padding-top)
 var(--n-padding-left)
 var(--n-padding-bottom)
 var(--n-padding-left);
 `, [F("main", `
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 min-width: 0;
 color: var(--n-title-text-color);
 `), F("extra", `
 display: flex;
 align-items: center;
 font-size: var(--n-font-size);
 font-weight: 400;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), F("close", `
 margin: 0 0 0 8px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), F("action", `
 box-sizing: border-box;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 background-clip: padding-box;
 background-color: var(--n-action-color);
 `), F("content", "flex: 1; min-width: 0;"), F("content, footer", `
 box-sizing: border-box;
 padding: 0 var(--n-padding-left) var(--n-padding-bottom) var(--n-padding-left);
 font-size: var(--n-font-size);
 `, [V("&:first-child", {
  paddingTop: "var(--n-padding-bottom)"
})]), F("action", `
 background-color: var(--n-action-color);
 padding: var(--n-padding-bottom) var(--n-padding-left);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `)]), te("card-cover", `
 overflow: hidden;
 width: 100%;
 border-radius: var(--n-border-radius) var(--n-border-radius) 0 0;
 `, [V("img", `
 display: block;
 width: 100%;
 `)]), fe("bordered", `
 border: 1px solid var(--n-border-color);
 `, [V("&:target", "border-color: var(--n-color-target);")]), fe("action-segmented", [V(">", [F("action", [V("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), fe("content-segmented, content-soft-segmented", [V(">", [F("content", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [V("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), fe("footer-segmented, footer-soft-segmented", [V(">", [F("footer", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [V("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), fe("embedded", `
 background-color: var(--n-color-embedded);
 `)]), tm(te("card", `
 background: var(--n-color-modal);
 `, [fe("embedded", `
 background-color: var(--n-color-embedded-modal);
 `)])), j1(te("card", `
 background: var(--n-color-popover);
 `, [fe("embedded", `
 background-color: var(--n-color-embedded-popover);
 `)]))]), f_ = {
  paddingSmall: "12px 16px 12px",
  paddingMedium: "19px 24px 20px",
  paddingLarge: "23px 32px 24px",
  paddingHuge: "27px 40px 28px",
  titleFontSizeSmall: "16px",
  titleFontSizeMedium: "18px",
  titleFontSizeLarge: "18px",
  titleFontSizeHuge: "18px",
  closeIconSize: "18px",
  closeSize: "22px"
}, p_ = (e) => {
  const {
    primaryColor: t,
    borderRadius: r,
    lineHeight: n,
    fontSize: o,
    cardColor: i,
    textColor2: a,
    textColor1: l,
    dividerColor: s,
    fontWeightStrong: c,
    closeIconColor: u,
    closeIconColorHover: d,
    closeIconColorPressed: f,
    closeColorHover: p,
    closeColorPressed: h,
    modalColor: g,
    boxShadow1: m,
    popoverColor: v,
    actionColor: M
  } = e;
  return Object.assign(Object.assign({}, f_), {
    lineHeight: n,
    color: i,
    colorModal: g,
    colorPopover: v,
    colorTarget: t,
    colorEmbedded: M,
    colorEmbeddedModal: M,
    colorEmbeddedPopover: M,
    textColor: a,
    titleTextColor: l,
    borderColor: s,
    actionColor: M,
    titleFontWeight: c,
    closeColorHover: p,
    closeColorPressed: h,
    closeBorderRadius: r,
    closeIconColor: u,
    closeIconColorHover: d,
    closeIconColorPressed: f,
    fontSizeSmall: o,
    fontSizeMedium: o,
    fontSizeLarge: o,
    fontSizeHuge: o,
    boxShadow: m,
    borderRadius: r
  });
}, h_ = {
  name: "Card",
  common: Jt,
  self: p_
}, Mw = h_, Rm = {
  title: String,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  headerExtraClass: String,
  headerExtraStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: !1
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  }
}, g_ = Ql(Rm), m_ = Object.assign(Object.assign({}, Ve.props), Rm), yw = Z({
  name: "Card",
  props: m_,
  setup(e) {
    const t = () => {
      const {
        onClose: c
      } = e;
      c && Be(c);
    }, {
      inlineThemeDisabled: r,
      mergedClsPrefixRef: n,
      mergedRtlRef: o
    } = Bt(e), i = Ve("Card", "-card", d_, Mw, e, n), a = yn("Card", o, n), l = W(() => {
      const {
        size: c
      } = e, {
        self: {
          color: u,
          colorModal: d,
          colorTarget: f,
          textColor: p,
          titleTextColor: h,
          titleFontWeight: g,
          borderColor: m,
          actionColor: v,
          borderRadius: M,
          lineHeight: x,
          closeIconColor: b,
          closeIconColorHover: T,
          closeIconColorPressed: w,
          closeColorHover: y,
          closeColorPressed: I,
          closeBorderRadius: D,
          closeIconSize: O,
          closeSize: $,
          boxShadow: z,
          colorPopover: Y,
          colorEmbedded: j,
          colorEmbeddedModal: q,
          colorEmbeddedPopover: ee,
          [ve("padding", c)]: re,
          [ve("fontSize", c)]: le,
          [ve("titleFontSize", c)]: ye
        },
        common: {
          cubicBezierEaseInOut: Me
        }
      } = i.value, {
        top: Ee,
        left: ne,
        bottom: ue
      } = Kn(re);
      return {
        "--n-bezier": Me,
        "--n-border-radius": M,
        "--n-color": u,
        "--n-color-modal": d,
        "--n-color-popover": Y,
        "--n-color-embedded": j,
        "--n-color-embedded-modal": q,
        "--n-color-embedded-popover": ee,
        "--n-color-target": f,
        "--n-text-color": p,
        "--n-line-height": x,
        "--n-action-color": v,
        "--n-title-text-color": h,
        "--n-title-font-weight": g,
        "--n-close-icon-color": b,
        "--n-close-icon-color-hover": T,
        "--n-close-icon-color-pressed": w,
        "--n-close-color-hover": y,
        "--n-close-color-pressed": I,
        "--n-border-color": m,
        "--n-box-shadow": z,
        // size
        "--n-padding-top": Ee,
        "--n-padding-bottom": ue,
        "--n-padding-left": ne,
        "--n-font-size": le,
        "--n-title-font-size": ye,
        "--n-close-size": $,
        "--n-close-icon-size": O,
        "--n-close-border-radius": D
      };
    }), s = r ? dr("card", W(() => e.size[0]), l, e) : void 0;
    return {
      rtlEnabled: a,
      mergedClsPrefix: n,
      mergedTheme: i,
      handleCloseClick: t,
      cssVars: r ? void 0 : l,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const {
      segmented: e,
      bordered: t,
      hoverable: r,
      mergedClsPrefix: n,
      rtlEnabled: o,
      onRender: i,
      embedded: a,
      tag: l,
      $slots: s
    } = this;
    return i == null || i(), S(l, {
      class: [`${n}-card`, this.themeClass, a && `${n}-card--embedded`, {
        [`${n}-card--rtl`]: o,
        [`${n}-card--content${typeof e != "boolean" && e.content === "soft" ? "-soft" : ""}-segmented`]: e === !0 || e !== !1 && e.content,
        [`${n}-card--footer${typeof e != "boolean" && e.footer === "soft" ? "-soft" : ""}-segmented`]: e === !0 || e !== !1 && e.footer,
        [`${n}-card--action-segmented`]: e === !0 || e !== !1 && e.action,
        [`${n}-card--bordered`]: t,
        [`${n}-card--hoverable`]: r
      }],
      style: this.cssVars,
      role: this.role
    }, mt(s.cover, (c) => c && S("div", {
      class: `${n}-card-cover`,
      role: "none"
    }, c)), mt(s.header, (c) => c || this.title || this.closable ? S("div", {
      class: [`${n}-card-header`, this.headerClass],
      style: this.headerStyle
    }, S("div", {
      class: `${n}-card-header__main`,
      role: "heading"
    }, c || this.title), mt(s["header-extra"], (u) => u && S("div", {
      class: [`${n}-card-header__extra`, this.headerExtraClass],
      style: this.headerExtraStyle
    }, u)), this.closable ? S(pm, {
      clsPrefix: n,
      class: `${n}-card-header__close`,
      onClick: this.handleCloseClick,
      absolute: !0
    }) : null) : null), mt(s.default, (c) => c && S("div", {
      class: [`${n}-card__content`, this.contentClass],
      style: this.contentStyle,
      role: "none"
    }, c)), mt(s.footer, (c) => c && [S("div", {
      class: [`${n}-card__footer`, this.footerClass],
      style: this.footerStyle,
      role: "none"
    }, c)]), mt(s.action, (c) => c && S("div", {
      class: `${n}-card__action`,
      role: "none"
    }, c)));
  }
}), _m = Object.assign(Object.assign({}, Rm), jm), v_ = Ql(_m), b_ = V([te("dialog", `
 --n-icon-margin: var(--n-icon-margin-top) var(--n-icon-margin-right) var(--n-icon-margin-bottom) var(--n-icon-margin-left);
 word-break: break-word;
 line-height: var(--n-line-height);
 position: relative;
 background: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 margin: auto;
 border-radius: var(--n-border-radius);
 padding: var(--n-padding);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [F("icon", {
  color: "var(--n-icon-color)"
}), fe("bordered", {
  border: "var(--n-border)"
}), fe("icon-top", [F("close", {
  margin: "var(--n-close-margin)"
}), F("icon", {
  margin: "var(--n-icon-margin)"
}), F("content", {
  textAlign: "center"
}), F("title", {
  justifyContent: "center"
}), F("action", {
  justifyContent: "center"
})]), fe("icon-left", [F("icon", {
  margin: "var(--n-icon-margin)"
}), fe("closable", [F("title", `
 padding-right: calc(var(--n-close-size) + 6px);
 `)])]), F("close", `
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 z-index: 1;
 `), F("content", `
 font-size: var(--n-font-size);
 margin: var(--n-content-margin);
 position: relative;
 word-break: break-word;
 `, [fe("last", "margin-bottom: 0;")]), F("action", `
 display: flex;
 justify-content: flex-end;
 `, [V("> *:not(:last-child)", `
 margin-right: var(--n-action-space);
 `)]), F("icon", `
 font-size: var(--n-icon-size);
 transition: color .3s var(--n-bezier);
 `), F("title", `
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 font-weight: var(--n-title-font-weight);
 color: var(--n-title-text-color);
 `), te("dialog-icon-container", `
 display: flex;
 justify-content: center;
 `)]), tm(te("dialog", `
 width: 446px;
 max-width: calc(100vw - 32px);
 `)), te("dialog", [R1(`
 width: 446px;
 max-width: calc(100vw - 32px);
 `)])]), M_ = {
  titleFontSize: "18px",
  padding: "16px 28px 20px 28px",
  iconSize: "28px",
  actionSpace: "12px",
  contentMargin: "8px 0 16px 0",
  iconMargin: "0 4px 0 0",
  iconMarginIconTop: "4px 0 8px 0",
  closeSize: "22px",
  closeIconSize: "18px",
  closeMargin: "20px 26px 0 0",
  closeMarginIconTop: "10px 16px 0 0"
}, y_ = (e) => {
  const {
    textColor1: t,
    textColor2: r,
    modalColor: n,
    closeIconColor: o,
    closeIconColorHover: i,
    closeIconColorPressed: a,
    closeColorHover: l,
    closeColorPressed: s,
    infoColor: c,
    successColor: u,
    warningColor: d,
    errorColor: f,
    primaryColor: p,
    dividerColor: h,
    borderRadius: g,
    fontWeightStrong: m,
    lineHeight: v,
    fontSize: M
  } = e;
  return Object.assign(Object.assign({}, M_), {
    fontSize: M,
    lineHeight: v,
    border: `1px solid ${h}`,
    titleTextColor: t,
    textColor: r,
    color: n,
    closeColorHover: l,
    closeColorPressed: s,
    closeIconColor: o,
    closeIconColorHover: i,
    closeIconColorPressed: a,
    closeBorderRadius: g,
    iconColor: p,
    iconColorInfo: c,
    iconColorSuccess: u,
    iconColorWarning: d,
    iconColorError: f,
    borderRadius: g,
    titleFontWeight: m
  });
}, x_ = {
  name: "Dialog",
  common: Jt,
  peers: {
    Button: um
  },
  self: y_
}, xw = x_, Lb = Aa("info", S("svg", {
  viewBox: "0 0 28 28",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, S("g", {
  "fill-rule": "nonzero"
}, S("path", {
  d: "M14,2 C20.6274,2 26,7.37258 26,14 C26,20.6274 20.6274,26 14,26 C7.37258,26 2,20.6274 2,14 C2,7.37258 7.37258,2 14,2 Z M14,11 C13.4477,11 13,11.4477 13,12 L13,12 L13,20 C13,20.5523 13.4477,21 14,21 C14.5523,21 15,20.5523 15,20 L15,20 L15,12 C15,11.4477 14.5523,11 14,11 Z M14,6.75 C13.3096,6.75 12.75,7.30964 12.75,8 C12.75,8.69036 13.3096,9.25 14,9.25 C14.6904,9.25 15.25,8.69036 15.25,8 C15.25,7.30964 14.6904,6.75 14,6.75 Z"
}))))), w_ = Aa("success", S("svg", {
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, S("g", {
  "fill-rule": "nonzero"
}, S("path", {
  d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.6338835,17.6161165 C32.1782718,17.1605048 31.4584514,17.1301307 30.9676119,17.5249942 L30.8661165,17.6161165 L20.75,27.732233 L17.1338835,24.1161165 C16.6457281,23.6279612 15.8542719,23.6279612 15.3661165,24.1161165 C14.9105048,24.5717282 14.8801307,25.2915486 15.2749942,25.7823881 L15.3661165,25.8838835 L19.8661165,30.3838835 C20.3217282,30.8394952 21.0415486,30.8698693 21.5323881,30.4750058 L21.6338835,30.3838835 L32.6338835,19.3838835 C33.1220388,18.8957281 33.1220388,18.1042719 32.6338835,17.6161165 Z"
}))))), T_ = Aa("warning", S("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, S("g", {
  "fill-rule": "nonzero"
}, S("path", {
  d: "M12,2 C17.523,2 22,6.478 22,12 C22,17.522 17.523,22 12,22 C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12.0018002,15.0037242 C11.450254,15.0037242 11.0031376,15.4508407 11.0031376,16.0023869 C11.0031376,16.553933 11.450254,17.0010495 12.0018002,17.0010495 C12.5533463,17.0010495 13.0004628,16.553933 13.0004628,16.0023869 C13.0004628,15.4508407 12.5533463,15.0037242 12.0018002,15.0037242 Z M11.99964,7 C11.4868042,7.00018474 11.0642719,7.38637706 11.0066858,7.8837365 L11,8.00036004 L11.0018003,13.0012393 L11.00857,13.117858 C11.0665141,13.6151758 11.4893244,14.0010638 12.0021602,14.0008793 C12.514996,14.0006946 12.9375283,13.6145023 12.9951144,13.1171428 L13.0018002,13.0005193 L13,7.99964009 L12.9932303,7.8830214 C12.9352861,7.38570354 12.5124758,6.99981552 11.99964,7 Z"
}))))), N_ = Aa("error", S("svg", {
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, S("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, S("g", {
  "fill-rule": "nonzero"
}, S("path", {
  d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M17.8838835,16.1161165 L17.7823881,16.0249942 C17.3266086,15.6583353 16.6733914,15.6583353 16.2176119,16.0249942 L16.1161165,16.1161165 L16.0249942,16.2176119 C15.6583353,16.6733914 15.6583353,17.3266086 16.0249942,17.7823881 L16.1161165,17.8838835 L22.233,24 L16.1161165,30.1161165 L16.0249942,30.2176119 C15.6583353,30.6733914 15.6583353,31.3266086 16.0249942,31.7823881 L16.1161165,31.8838835 L16.2176119,31.9750058 C16.6733914,32.3416647 17.3266086,32.3416647 17.7823881,31.9750058 L17.8838835,31.8838835 L24,25.767 L30.1161165,31.8838835 L30.2176119,31.9750058 C30.6733914,32.3416647 31.3266086,32.3416647 31.7823881,31.9750058 L31.8838835,31.8838835 L31.9750058,31.7823881 C32.3416647,31.3266086 32.3416647,30.6733914 31.9750058,30.2176119 L31.8838835,30.1161165 L25.767,24 L31.8838835,17.8838835 L31.9750058,17.7823881 C32.3416647,17.3266086 32.3416647,16.6733914 31.9750058,16.2176119 L31.8838835,16.1161165 L31.7823881,16.0249942 C31.3266086,15.6583353 30.6733914,15.6583353 30.2176119,16.0249942 L30.1161165,16.1161165 L24,22.233 L17.8838835,16.1161165 L17.7823881,16.0249942 L17.8838835,16.1161165 Z"
}))))), S_ = {
  default: () => S(Lb, null),
  info: () => S(Lb, null),
  success: () => S(w_, null),
  warning: () => S(T_, null),
  error: () => S(N_, null)
}, C_ = Z({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    // deprecated
    "Confirm"
    // deprecated
  ],
  props: Object.assign(Object.assign({}, Ve.props), jm),
  setup(e) {
    const {
      mergedComponentPropsRef: t,
      mergedClsPrefixRef: r,
      inlineThemeDisabled: n,
      mergedRtlRef: o
    } = Bt(e), i = yn("Dialog", o, r), a = W(() => {
      var p, h;
      const {
        iconPlacement: g
      } = e;
      return g || ((h = (p = t == null ? void 0 : t.value) === null || p === void 0 ? void 0 : p.Dialog) === null || h === void 0 ? void 0 : h.iconPlacement) || "left";
    });
    function l(p) {
      const {
        onPositiveClick: h
      } = e;
      h && h(p);
    }
    function s(p) {
      const {
        onNegativeClick: h
      } = e;
      h && h(p);
    }
    function c() {
      const {
        onClose: p
      } = e;
      p && p();
    }
    const u = Ve("Dialog", "-dialog", b_, xw, e, r), d = W(() => {
      const {
        type: p
      } = e, h = a.value, {
        common: {
          cubicBezierEaseInOut: g
        },
        self: {
          fontSize: m,
          lineHeight: v,
          border: M,
          titleTextColor: x,
          textColor: b,
          color: T,
          closeBorderRadius: w,
          closeColorHover: y,
          closeColorPressed: I,
          closeIconColor: D,
          closeIconColorHover: O,
          closeIconColorPressed: $,
          closeIconSize: z,
          borderRadius: Y,
          titleFontWeight: j,
          titleFontSize: q,
          padding: ee,
          iconSize: re,
          actionSpace: le,
          contentMargin: ye,
          closeSize: Me,
          [h === "top" ? "iconMarginIconTop" : "iconMargin"]: Ee,
          [h === "top" ? "closeMarginIconTop" : "closeMargin"]: ne,
          [ve("iconColor", p)]: ue
        }
      } = u.value, Ce = Kn(Ee);
      return {
        "--n-font-size": m,
        "--n-icon-color": ue,
        "--n-bezier": g,
        "--n-close-margin": ne,
        "--n-icon-margin-top": Ce.top,
        "--n-icon-margin-right": Ce.right,
        "--n-icon-margin-bottom": Ce.bottom,
        "--n-icon-margin-left": Ce.left,
        "--n-icon-size": re,
        "--n-close-size": Me,
        "--n-close-icon-size": z,
        "--n-close-border-radius": w,
        "--n-close-color-hover": y,
        "--n-close-color-pressed": I,
        "--n-close-icon-color": D,
        "--n-close-icon-color-hover": O,
        "--n-close-icon-color-pressed": $,
        "--n-color": T,
        "--n-text-color": b,
        "--n-border-radius": Y,
        "--n-padding": ee,
        "--n-line-height": v,
        "--n-border": M,
        "--n-content-margin": ye,
        "--n-title-font-size": q,
        "--n-title-font-weight": j,
        "--n-title-text-color": x,
        "--n-action-space": le
      };
    }), f = n ? dr("dialog", W(() => `${e.type[0]}${a.value[0]}`), d, e) : void 0;
    return {
      mergedClsPrefix: r,
      rtlEnabled: i,
      mergedIconPlacement: a,
      mergedTheme: u,
      handlePositiveClick: l,
      handleNegativeClick: s,
      handleCloseClick: c,
      cssVars: n ? void 0 : d,
      themeClass: f == null ? void 0 : f.themeClass,
      onRender: f == null ? void 0 : f.onRender
    };
  },
  render() {
    var e;
    const {
      bordered: t,
      mergedIconPlacement: r,
      cssVars: n,
      closable: o,
      showIcon: i,
      title: a,
      content: l,
      action: s,
      negativeText: c,
      positiveText: u,
      positiveButtonProps: d,
      negativeButtonProps: f,
      handlePositiveClick: p,
      handleNegativeClick: h,
      mergedTheme: g,
      loading: m,
      type: v,
      mergedClsPrefix: M
    } = this;
    (e = this.onRender) === null || e === void 0 || e.call(this);
    const x = i ? S(On, {
      clsPrefix: M,
      class: `${M}-dialog__icon`
    }, {
      default: () => mt(this.$slots.icon, (T) => T || (this.icon ? Xr(this.icon) : S_[this.type]()))
    }) : null, b = mt(this.$slots.action, (T) => T || u || c || s ? S("div", {
      class: `${M}-dialog__action`
    }, T || (s ? [Xr(s)] : [this.negativeText && S(Uf, Object.assign({
      theme: g.peers.Button,
      themeOverrides: g.peerOverrides.Button,
      ghost: !0,
      size: "small",
      onClick: h
    }, f), {
      default: () => Xr(this.negativeText)
    }), this.positiveText && S(Uf, Object.assign({
      theme: g.peers.Button,
      themeOverrides: g.peerOverrides.Button,
      size: "small",
      type: v === "default" ? "primary" : v,
      disabled: m,
      loading: m,
      onClick: p
    }, d), {
      default: () => Xr(this.positiveText)
    })])) : null);
    return S("div", {
      class: [`${M}-dialog`, this.themeClass, this.closable && `${M}-dialog--closable`, `${M}-dialog--icon-${r}`, t && `${M}-dialog--bordered`, this.rtlEnabled && `${M}-dialog--rtl`],
      style: n,
      role: "dialog"
    }, o ? mt(this.$slots.close, (T) => {
      const w = [`${M}-dialog__close`, this.rtlEnabled && `${M}-dialog--rtl`];
      return T ? S("div", {
        class: w
      }, T) : S(pm, {
        clsPrefix: M,
        class: w,
        onClick: this.handleCloseClick
      });
    }) : null, i && r === "top" ? S("div", {
      class: `${M}-dialog-icon-container`
    }, x) : null, S("div", {
      class: `${M}-dialog__title`
    }, i && r === "left" ? x : null, hn(this.$slots.header, () => [Xr(a)])), S("div", {
      class: [`${M}-dialog__content`, b ? "" : `${M}-dialog__content--last`]
    }, hn(this.$slots.default, () => [Xr(l)])), b);
  }
}), I_ = Z({
  name: "ModalBody",
  inheritAttrs: !1,
  props: Object.assign(Object.assign({
    show: {
      type: Boolean,
      required: !0
    },
    preset: String,
    displayDirective: {
      type: String,
      required: !0
    },
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    blockScroll: Boolean
  }, _m), {
    renderMask: Function,
    // events
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: !0
    },
    onAfterLeave: {
      type: Function,
      required: !0
    },
    onPositiveClick: {
      type: Function,
      required: !0
    },
    onNegativeClick: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      required: !0
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(e) {
    const t = L(null), r = L(null), n = L(e.show), o = L(null), i = L(null);
    at(We(e, "show"), (m) => {
      m && (n.value = !0);
    }), oR(W(() => e.blockScroll && n.value));
    const a = De(wx);
    function l() {
      if (a.transformOriginRef.value === "center")
        return "";
      const {
        value: m
      } = o, {
        value: v
      } = i;
      if (m === null || v === null)
        return "";
      if (r.value) {
        const M = r.value.containerScrollTop;
        return `${m}px ${v + M}px`;
      }
      return "";
    }
    function s(m) {
      if (a.transformOriginRef.value === "center")
        return;
      const v = a.getMousePosition();
      if (!v || !r.value)
        return;
      const M = r.value.containerScrollTop, {
        offsetLeft: x,
        offsetTop: b
      } = m;
      if (v) {
        const T = v.y, w = v.x;
        o.value = -(x - w), i.value = -(b - T - M);
      }
      m.style.transformOrigin = l();
    }
    function c(m) {
      mn(() => {
        s(m);
      });
    }
    function u(m) {
      m.style.transformOrigin = l(), e.onBeforeLeave();
    }
    function d() {
      n.value = !1, o.value = null, i.value = null, e.onAfterLeave();
    }
    function f() {
      const {
        onClose: m
      } = e;
      m && m();
    }
    function p() {
      e.onNegativeClick();
    }
    function h() {
      e.onPositiveClick();
    }
    const g = L(null);
    return at(g, (m) => {
      m && mn(() => {
        const v = m.el;
        v && t.value !== v && (t.value = v);
      });
    }), Et(bm, t), Et(vm, null), Et(Mm, null), {
      mergedTheme: a.mergedThemeRef,
      appear: a.appearRef,
      isMounted: a.isMountedRef,
      mergedClsPrefix: a.mergedClsPrefixRef,
      bodyRef: t,
      scrollbarRef: r,
      displayed: n,
      childNodeRef: g,
      handlePositiveClick: h,
      handleNegativeClick: p,
      handleCloseClick: f,
      handleAfterLeave: d,
      handleBeforeLeave: u,
      handleEnter: c
    };
  },
  render() {
    const {
      $slots: e,
      $attrs: t,
      handleEnter: r,
      handleAfterLeave: n,
      handleBeforeLeave: o,
      preset: i,
      mergedClsPrefix: a
    } = this;
    let l = null;
    if (!i) {
      if (l = Jf(e), !l) {
        la("modal", "default slot is empty");
        return;
      }
      l = C1(l), l.props = Ut({
        class: `${a}-modal`
      }, t, l.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? on(S("div", {
      role: "none",
      class: `${a}-modal-body-wrapper`
    }, S(km, {
      ref: "scrollbarRef",
      theme: this.mergedTheme.peers.Scrollbar,
      themeOverrides: this.mergedTheme.peerOverrides.Scrollbar,
      contentClass: `${a}-modal-scroll-content`
    }, {
      default: () => {
        var s;
        return [(s = this.renderMask) === null || s === void 0 ? void 0 : s.call(this), S(Ux, {
          disabled: !this.trapFocus,
          active: this.show,
          onEsc: this.onEsc,
          autoFocus: this.autoFocus
        }, {
          default: () => {
            var c;
            return S(zn, {
              name: "fade-in-scale-up-transition",
              appear: (c = this.appear) !== null && c !== void 0 ? c : this.isMounted,
              onEnter: r,
              onAfterEnter: this.onAfterEnter,
              onAfterLeave: n,
              onBeforeLeave: o
            }, {
              default: () => {
                const u = [[ci, this.show]], {
                  onClickoutside: d
                } = this;
                return d && u.push([Yl, this.onClickoutside, void 0, {
                  capture: !0
                }]), on(this.preset === "confirm" || this.preset === "dialog" ? S(C_, Object.assign({}, this.$attrs, {
                  class: [`${a}-modal`, this.$attrs.class],
                  ref: "bodyRef",
                  theme: this.mergedTheme.peers.Dialog,
                  themeOverrides: this.mergedTheme.peerOverrides.Dialog
                }, Pu(this.$props, c_), {
                  "aria-modal": "true"
                }), e) : this.preset === "card" ? S(yw, Object.assign({}, this.$attrs, {
                  ref: "bodyRef",
                  class: [`${a}-modal`, this.$attrs.class],
                  theme: this.mergedTheme.peers.Card,
                  themeOverrides: this.mergedTheme.peerOverrides.Card
                }, Pu(this.$props, g_), {
                  "aria-modal": "true",
                  role: "dialog"
                }), e) : this.childNodeRef = l, u);
              }
            });
          }
        })];
      }
    })), [[ci, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
}), A_ = V([te("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), te("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [Hx({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), te("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [te("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), te("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [Em({
  duration: ".25s",
  enterScale: ".5"
})])]), D_ = L(void 0);
let Ws = 0;
function $b() {
  D_.value = Date.now();
}
let zb = !0;
function k_(e) {
  if (!Im)
    return ui(L(!1));
  const t = L(!1);
  let r = null;
  function n() {
    r !== null && window.clearTimeout(r);
  }
  function o() {
    n(), t.value = !0, r = window.setTimeout(() => {
      t.value = !1;
    }, e);
  }
  Ws === 0 && zt("click", window, $b, !0);
  const i = () => {
    Ws += 1, zt("click", window, o, !0);
  };
  return zb && (zb = jx()) ? (ya(i), vt(() => {
    Ws -= 1, Ws === 0 && It("click", window, $b, !0), It("click", window, o, !0), n();
  })) : i(), ui(t);
}
const tl = L(null);
function Ob(e) {
  if (e.clientX > 0 || e.clientY > 0)
    tl.value = {
      x: e.clientX,
      y: e.clientY
    };
  else {
    const { target: t } = e;
    if (t instanceof Element) {
      const { left: r, top: n, width: o, height: i } = t.getBoundingClientRect();
      r > 0 || n > 0 ? tl.value = {
        x: r + o / 2,
        y: n + i / 2
      } : tl.value = { x: 0, y: 0 };
    } else
      tl.value = null;
  }
}
let Qs = 0, jb = !0;
function E_() {
  if (!Im)
    return ui(L(null));
  Qs === 0 && zt("click", document, Ob, !0);
  const e = () => {
    Qs += 1;
  };
  return jb && (jb = jx()) ? (ya(e), vt(() => {
    Qs -= 1, Qs === 0 && It("click", document, Ob, !0);
  })) : e(), ui(tl);
}
const L_ = (e) => {
  const {
    modalColor: t,
    textColor2: r,
    boxShadow3: n
  } = e;
  return {
    color: t,
    textColor: r,
    boxShadow: n
  };
}, $_ = {
  name: "Modal",
  common: Jt,
  peers: {
    Scrollbar: Dm,
    Dialog: xw,
    Card: Mw
  },
  self: L_
}, z_ = $_, O_ = Object.assign(Object.assign(Object.assign(Object.assign({}, Ve.props), {
  show: Boolean,
  unstableShowMask: {
    type: Boolean,
    default: !0
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  preset: String,
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  transformOrigin: {
    type: String,
    default: "mouse"
  },
  zIndex: Number,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  trapFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  }
}), _m), {
  // events
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  // private
  internalDialog: Boolean,
  internalModal: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
}), j_ = Z({
  name: "Modal",
  inheritAttrs: !1,
  props: O_,
  setup(e) {
    process.env.NODE_ENV !== "production" && (e.onHide && sr("modal", "`on-hide` is deprecated."), e.onAfterHide && sr("modal", "`on-after-hide` is deprecated, please use `on-after-leave` instead."), e.onBeforeHide && sr("modal", "`on-before-hide` is deprecated, please use `on-before-leave` instead."), e.overlayStyle && sr("modal", "`overlay-style` is deprecated, please use `style` instead."));
    const t = L(null), {
      mergedClsPrefixRef: r,
      namespaceRef: n,
      inlineThemeDisabled: o
    } = Bt(e), i = Ve("Modal", "-modal", A_, z_, e, r), a = k_(64), l = E_(), s = hs(), c = e.internalDialog ? De(u_, null) : null, u = e.internalModal ? De(vz, null) : null, d = iR();
    function f(w) {
      const {
        onUpdateShow: y,
        "onUpdate:show": I,
        onHide: D
      } = e;
      y && Be(y, w), I && Be(I, w), D && !w && D(w);
    }
    function p() {
      const {
        onClose: w
      } = e;
      w ? Promise.resolve(w()).then((y) => {
        y !== !1 && f(!1);
      }) : f(!1);
    }
    function h() {
      const {
        onPositiveClick: w
      } = e;
      w ? Promise.resolve(w()).then((y) => {
        y !== !1 && f(!1);
      }) : f(!1);
    }
    function g() {
      const {
        onNegativeClick: w
      } = e;
      w ? Promise.resolve(w()).then((y) => {
        y !== !1 && f(!1);
      }) : f(!1);
    }
    function m() {
      const {
        onBeforeLeave: w,
        onBeforeHide: y
      } = e;
      w && Be(w), y && y();
    }
    function v() {
      const {
        onAfterLeave: w,
        onAfterHide: y
      } = e;
      w && Be(w), y && y();
    }
    function M(w) {
      var y;
      const {
        onMaskClick: I
      } = e;
      I && I(w), e.maskClosable && !((y = t.value) === null || y === void 0) && y.contains(Wl(w)) && f(!1);
    }
    function x(w) {
      var y;
      (y = e.onEsc) === null || y === void 0 || y.call(e), e.show && e.closeOnEsc && x5(w) && !d.value && f(!1);
    }
    Et(wx, {
      getMousePosition: () => {
        const w = c || u;
        if (w) {
          const {
            clickedRef: y,
            clickedPositionRef: I
          } = w;
          if (y.value && I.value)
            return I.value;
        }
        return a.value ? l.value : null;
      },
      mergedClsPrefixRef: r,
      mergedThemeRef: i,
      isMountedRef: s,
      appearRef: We(e, "internalAppear"),
      transformOriginRef: We(e, "transformOrigin")
    });
    const b = W(() => {
      const {
        common: {
          cubicBezierEaseOut: w
        },
        self: {
          boxShadow: y,
          color: I,
          textColor: D
        }
      } = i.value;
      return {
        "--n-bezier-ease-out": w,
        "--n-box-shadow": y,
        "--n-color": I,
        "--n-text-color": D
      };
    }), T = o ? dr("theme-class", void 0, b, e) : void 0;
    return {
      mergedClsPrefix: r,
      namespace: n,
      isMounted: s,
      containerRef: t,
      presetProps: W(() => Pu(e, v_)),
      handleEsc: x,
      handleAfterLeave: v,
      handleClickoutside: M,
      handleBeforeLeave: m,
      doUpdateShow: f,
      handleNegativeClick: g,
      handlePositiveClick: h,
      handleCloseClick: p,
      cssVars: o ? void 0 : b,
      themeClass: T == null ? void 0 : T.themeClass,
      onRender: T == null ? void 0 : T.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e
    } = this;
    return S($x, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var t;
        (t = this.onRender) === null || t === void 0 || t.call(this);
        const {
          unstableShowMask: r
        } = this;
        return on(S("div", {
          role: "none",
          ref: "containerRef",
          class: [`${e}-modal-container`, this.themeClass, this.namespace],
          style: this.cssVars
        }, S(I_, Object.assign({
          style: this.overlayStyle
        }, this.$attrs, {
          ref: "bodyWrapper",
          displayDirective: this.displayDirective,
          show: this.show,
          preset: this.preset,
          autoFocus: this.autoFocus,
          trapFocus: this.trapFocus,
          blockScroll: this.blockScroll
        }, this.presetProps, {
          onEsc: this.handleEsc,
          onClose: this.handleCloseClick,
          onNegativeClick: this.handleNegativeClick,
          onPositiveClick: this.handlePositiveClick,
          onBeforeLeave: this.handleBeforeLeave,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave,
          onClickoutside: r ? void 0 : this.handleClickoutside,
          renderMask: r ? () => {
            var n;
            return S(zn, {
              name: "fade-in-transition",
              key: "mask",
              appear: (n = this.internalAppear) !== null && n !== void 0 ? n : this.isMounted
            }, {
              default: () => this.show ? S("div", {
                "aria-hidden": !0,
                ref: "containerRef",
                class: `${e}-modal-mask`,
                onClick: this.handleClickoutside
              }) : null
            });
          } : void 0
        }), this.$slots)), [[Am, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
}), R_ = Z({
  name: "UIModal",
  inheritAttrs: !1
}), __ = Z({
  ...R_,
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: [String, HTMLElement],
      default: void 0
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    className: {
      type: String,
      default: ""
    },
    maskClosable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  setup(e) {
    return (t, r) => (_(), se(N(j_), {
      show: e.show,
      "onUpdate:show": r[0] || (r[0] = (n) => t.$emit("update:show", n)),
      "z-index": e.zIndex,
      "auto-focus": e.autoFocus,
      to: e.to,
      "mask-closable": e.maskClosable
    }, {
      default: Q(() => [
        B(N(yw), {
          style: Fc({ width: `${e.width}px` }),
          bordered: !1,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          class: br(["hl-modal", e.className])
        }, {
          header: Q(() => [
            Re(t.$slots, "header")
          ]),
          footer: Q(() => [
            Re(t.$slots, "footer")
          ]),
          default: Q(() => [
            Re(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["style", "class"])
      ]),
      _: 3
    }, 8, ["show", "z-index", "auto-focus", "to", "mask-closable"]));
  }
}), Kc = __, P_ = { class: "hl-modal-content" };
Z({
  name: "UIModalContent"
});
const B_ = Z({
  __name: "ModalContent",
  setup(e) {
    return (t, r) => (_(), be("div", P_, [
      Re(t.$slots, "default")
    ]));
  }
}), Pm = B_, F_ = { class: "hl-modal-footer-actions" }, U_ = { class: "action-left" }, H_ = { class: "action-right" };
Z({
  name: "UIModalFooter"
});
const Y_ = Z({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: !0
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e) {
    const t = wr(), r = W(() => !!t.actionRight);
    return (n, o) => (_(), be("div", F_, [
      de("div", U_, [
        Re(n.$slots, "actionLeft")
      ]),
      de("div", H_, [
        Re(n.$slots, "actionRight"),
        r.value ? Oe("", !0) : (_(), be(qt, { key: 0 }, [
          e.negativeText ? (_(), se(N(Lr), {
            key: 0,
            onClick: o[0] || (o[0] = (i) => n.$emit("negativeClick")),
            id: `${e.id}-btn-negative-action`
          }, {
            default: Q(() => [
              Qt(kt(e.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : Oe("", !0),
          e.positiveText ? (_(), se(N(Lr), {
            key: 1,
            loading: e.loading,
            disabled: e.disabled,
            type: e.type,
            id: `${e.id}-btn-positive-action`,
            onClick: o[1] || (o[1] = (i) => n.$emit("positiveClick"))
          }, {
            default: Q(() => [
              Qt(kt(e.positiveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "type", "id"])) : Oe("", !0)
        ], 64))
      ])
    ]));
  }
}), qc = Y_;
function Rb(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 7L7 17M7 7l10 10"
    })
  ]);
}
const W_ = { class: "hl-modal-heading" }, Q_ = { key: 0 }, V_ = { key: 1 }, Z_ = {
  key: 0,
  class: "hl-icon-container"
}, G_ = { class: "action" }, K_ = { class: "title" }, q_ = {
  key: 0,
  class: "action"
}, J_ = { key: 1 }, X_ = {
  key: 2,
  class: "description"
}, eP = Z({
  __name: "ModalHeader",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      custom: "icon-custom",
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, r = wr();
    return (n, o) => (_(), be("div", W_, [
      N(r).customHeader ? (_(), be("div", Q_, [
        Re(n.$slots, "customHeader")
      ])) : (_(), be("div", V_, [
        e.icon ? (_(), be("div", Z_, [
          de("div", {
            class: br(["icon", t[e.type]])
          }, [
            (_(), se(Jn(e.icon)))
          ], 2),
          de("div", G_, [
            B(N(Lr), {
              circle: "",
              quaternary: "",
              onClick: o[0] || (o[0] = (i) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: Q(() => [
                B(N(Rb), { class: "w-5 h-5" })
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])) : Oe("", !0),
        de("div", K_, [
          Qt(kt(e.title) + " ", 1),
          e.icon ? Oe("", !0) : (_(), be("div", q_, [
            B(N(Lr), {
              circle: "",
              quaternary: "",
              onClick: o[1] || (o[1] = (i) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: Q(() => [
                B(N(Rb), { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["id"])
          ]))
        ]),
        N(r).customDescription ? (_(), be("div", J_, [
          Re(n.$slots, "customDescription")
        ])) : e.description ? (_(), be("div", X_, kt(e.description), 1)) : Oe("", !0)
      ]))
    ]));
  }
}), Jc = eP, tP = Z({
  name: "UIRadio",
  inheritAttrs: !1
}), rP = Z({
  ...tP,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["change", "checked", "value"],
  setup(e) {
    return (t, r) => (_(), se(N(tR), Ut({
      id: e.id,
      disabled: e.disabled,
      label: e.label,
      value: e.value,
      name: e.name
    }, t.$attrs, {
      checked: e.checked,
      onChange: r[0] || (r[0] = (n) => t.$emit("change", n)),
      onChecked: r[1] || (r[1] = (n) => t.$emit("checked", n)),
      "onUpdate:value": r[2] || (r[2] = (n) => t.$emit("value", n)),
      size: "large"
    }), {
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "label", "value", "name", "checked"]));
  }
}), nP = rP, oP = Z({
  name: "UIRadioGroup",
  inheritAttrs: !1
}), iP = Z({
  ...oP,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    defaultValue: {
      type: [String, Number, Boolean, null]
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, r) => (_(), se(N(J5), Ut({
      disabled: e.disabled,
      "default-value": e.defaultValue,
      value: e.value,
      name: e.name
    }, t.$attrs, {
      size: e.size,
      "onUpdate:value": r[0] || (r[0] = (n) => t.$emit("update:value", n))
    }), {
      default: Q(() => [
        Re(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["disabled", "default-value", "value", "name", "size"]));
  }
}), aP = iP, lP = Z({
  name: "Add",
  render() {
    return S("svg", {
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, S("path", {
      d: "M256 112V400M400 256H112",
      stroke: "currentColor",
      "stroke-width": "32",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  }
});
var sP = function() {
  return xn.Date.now();
};
const Qd = sP;
var uP = /\s/;
function cP(e) {
  for (var t = e.length; t-- && uP.test(e.charAt(t)); )
    ;
  return t;
}
var dP = /^\s+/;
function fP(e) {
  return e && e.slice(0, cP(e) + 1).replace(dP, "");
}
var _b = 0 / 0, pP = /^[-+]0x[0-9a-f]+$/i, hP = /^0b[01]+$/i, gP = /^0o[0-7]+$/i, mP = parseInt;
function Pb(e) {
  if (typeof e == "number")
    return e;
  if (Wc(e))
    return _b;
  if (vn(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = vn(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = fP(e);
  var r = hP.test(e);
  return r || gP.test(e) ? mP(e.slice(2), r ? 2 : 8) : pP.test(e) ? _b : +e;
}
var vP = "Expected a function", bP = Math.max, MP = Math.min;
function yP(e, t, r) {
  var n, o, i, a, l, s, c = 0, u = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(vP);
  t = Pb(t) || 0, vn(r) && (u = !!r.leading, d = "maxWait" in r, i = d ? bP(Pb(r.maxWait) || 0, t) : i, f = "trailing" in r ? !!r.trailing : f);
  function p(w) {
    var y = n, I = o;
    return n = o = void 0, c = w, a = e.apply(I, y), a;
  }
  function h(w) {
    return c = w, l = setTimeout(v, t), u ? p(w) : a;
  }
  function g(w) {
    var y = w - s, I = w - c, D = t - y;
    return d ? MP(D, i - I) : D;
  }
  function m(w) {
    var y = w - s, I = w - c;
    return s === void 0 || y >= t || y < 0 || d && I >= i;
  }
  function v() {
    var w = Qd();
    if (m(w))
      return M(w);
    l = setTimeout(v, g(w));
  }
  function M(w) {
    return l = void 0, f && n ? p(w) : (n = o = void 0, a);
  }
  function x() {
    l !== void 0 && clearTimeout(l), c = 0, n = s = o = l = void 0;
  }
  function b() {
    return l === void 0 ? a : M(Qd());
  }
  function T() {
    var w = Qd(), y = m(w);
    if (n = arguments, o = this, s = w, y) {
      if (l === void 0)
        return h(s);
      if (d)
        return clearTimeout(l), l = setTimeout(v, t), p(s);
    }
    return l === void 0 && (l = setTimeout(v, t)), a;
  }
  return T.cancel = x, T.flush = b, T;
}
function xP(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    })
  ]);
}
function wP(e, t, r, n) {
  for (var o = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function TP(e) {
  return e !== e;
}
function NP(e, t, r) {
  for (var n = r - 1, o = e.length; ++n < o; )
    if (e[n] === t)
      return n;
  return -1;
}
function SP(e, t, r) {
  return t === t ? NP(e, t, r) : wP(e, TP, r);
}
function CP(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && SP(e, t, 0) > -1;
}
function IP(e, t, r) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
function AP() {
}
var DP = 1 / 0, kP = Gi && 1 / ym(new Gi([, -0]))[1] == DP ? function(e) {
  return new Gi(e);
} : AP;
const EP = kP;
var LP = 200;
function $P(e, t, r) {
  var n = -1, o = CP, i = e.length, a = !0, l = [], s = l;
  if (r)
    a = !1, o = IP;
  else if (i >= LP) {
    var c = t ? null : EP(e);
    if (c)
      return ym(c);
    a = !1, o = Tx, s = new Hl();
  } else
    s = t ? [] : l;
  e:
    for (; ++n < i; ) {
      var u = e[n], d = t ? t(u) : u;
      if (u = r || u !== 0 ? u : 0, a && d === d) {
        for (var f = s.length; f--; )
          if (s[f] === d)
            continue e;
        t && s.push(d), l.push(u);
      } else
        o(s, d, r) || (s !== l && s.push(d), l.push(u));
    }
  return l;
}
function ww(e, t) {
  return e && e.length ? $P(e, Dx(t)) : [];
}
const Bb = ({
  path: e,
  options: t,
  pathSeparator: r = "/"
}) => {
  const n = e.split(r).filter(Boolean);
  let o = t;
  for (const i of n) {
    const a = o.find((l) => l.value === i);
    if (!a)
      return null;
    o = a.children || [];
  }
  return ww(o, "value");
}, Pi = (e, t) => {
  console.log(e, t);
}, Fb = (e) => {
  const t = [], r = (n, o = "/") => {
    const { label: i, value: a, children: l, ...s } = n, c = { label: i, value: a, _pathFromRoot: o, ...s };
    l ? (t.push({ ...c, type: "parent" }), l.forEach((u) => r(u, `${o}${i}/`))) : t.push(c);
  };
  return e.forEach((n) => r(n)), ww(t, "value");
}, zP = Z({
  name: "UIPopover",
  inheritAttrs: !1
}), OP = Z({
  ...zP,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: !0
    },
    positionX: {
      type: Number,
      default: void 0
    },
    positionY: {
      type: Number,
      default: void 0
    },
    onClickoutside: {
      type: Function,
      default: void 0
    },
    onUpdateShow: {
      type: Function,
      default: void 0
    },
    animated: {
      type: Boolean,
      default: !0
    },
    arrowPointToCenter: {
      type: Boolean,
      default: !1
    },
    arrowClass: {
      type: String,
      default: void 0
    },
    arrowStyle: {
      type: String || Object,
      default: void 0
    },
    arrowWrapperClass: {
      type: String,
      default: void 0
    },
    arrowWrapperStyle: {
      type: String || Object,
      default: void 0
    },
    contentClass: {
      type: String,
      default: void 0
    },
    contentStyle: {
      type: String || Object,
      default: void 0
    },
    footerClass: {
      type: String,
      default: void 0
    },
    footerStyle: {
      type: String || Object,
      default: void 0
    },
    headerClass: {
      type: String,
      default: void 0
    },
    headerStyle: {
      type: String || Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: Boolean,
      default: !0
    },
    keepAliveOnHover: {
      type: Boolean,
      default: !0
    },
    overlap: {
      type: Boolean,
      default: !1
    },
    raw: {
      type: Boolean,
      default: !1
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    },
    width: {
      type: [Number, String],
      default: void 0
    },
    zIndex: {
      type: Number,
      default: void 0
    }
  },
  setup(e) {
    const t = wr();
    return (r, n) => (_(), se(N(Vc), Ut(r.$attrs, {
      "show-arrow": e.showArrow,
      show: e.show,
      placement: e.placement,
      trigger: e.trigger,
      delay: e.delay,
      duration: e.duration,
      x: e.positionX,
      y: e.positionY,
      "on-clickoutside": e.onClickoutside,
      animated: e.animated,
      "arrow-point-to-center": e.arrowPointToCenter,
      "arrow-class": e.arrowClass,
      "arrow-style": e.arrowStyle,
      "arrow-wrapper-class": e.arrowWrapperClass,
      "arrow-wrapper-style": e.arrowWrapperStyle,
      "content-class": e.contentClass,
      "content-style": e.contentStyle,
      disabled: e.disabled,
      flip: e.flip,
      "footer-class": e.footerClass,
      "footer-style": e.footerStyle,
      "header-class": e.headerClass,
      "header-style": e.headerStyle,
      "keep-alive-on-hover": e.keepAliveOnHover,
      overlap: e.overlap,
      raw: e.raw,
      scrollable: e.scrollable,
      title: e.title,
      to: e.to,
      width: e.width,
      "z-index": e.zIndex,
      "on-update:show": e.onUpdateShow
    }), Xg({
      default: Q(() => [
        Re(r.$slots, "default")
      ]),
      _: 2
    }, [
      N(t).trigger ? {
        name: "trigger",
        fn: Q(() => [
          Re(r.$slots, "trigger")
        ]),
        key: "0"
      } : void 0,
      N(t).header ? {
        name: "header",
        fn: Q(() => [
          Re(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      N(t).footer ? {
        name: "footer",
        fn: Q(() => [
          Re(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["show-arrow", "show", "placement", "trigger", "delay", "duration", "x", "y", "on-clickoutside", "animated", "arrow-point-to-center", "arrow-class", "arrow-style", "arrow-wrapper-class", "arrow-wrapper-style", "content-class", "content-style", "disabled", "flip", "footer-class", "footer-style", "header-class", "header-style", "keep-alive-on-hover", "overlap", "raw", "scrollable", "title", "to", "width", "z-index", "on-update:show"]));
  }
}), jP = OP;
function RP(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 9l6 6 6-6"
    })
  ]);
}
function _P(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 12H5m0 0l7 7m-7-7l7-7"
    })
  ]);
}
const PP = {
  key: 0,
  class: "dropdown-tree__breadcrumb"
}, BP = { class: "dropdown-tree__breadcrumb-content" }, FP = { class: "dropdown-tree__breadcrumb-title" }, UP = Z({
  __name: "BreadCrumb",
  props: {
    disabled: Boolean,
    title: String,
    show: Boolean,
    icon: Function,
    iconClass: String
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const r = t;
    return (n, o) => e.show ? (_(), be("div", PP, [
      B(N(Lr), {
        id: "dropdown-backward-traversal",
        text: "",
        onClick: o[0] || (o[0] = (i) => r("onClick")),
        disabled: e.disabled
      }, {
        default: Q(() => [
          de("div", BP, [
            B(N(_P), { class: "w-5 h-5" }),
            de("span", FP, [
              (_(), se(Jn(e.icon), {
                class: br(e.iconClass)
              }, null, 8, ["class"])),
              B(N(Bu), {
                style: { "max-width": "250px" },
                tooltip: !1
              }, {
                default: Q(() => [
                  Qt(kt(e.title), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : Oe("", !0);
  }
}), Tw = /* @__PURE__ */ zm(UP, [["__scopeId", "data-v-4aa44406"]]);
function HP(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18l6-6-6-6"
    })
  ]);
}
const YP = ["onClick"], WP = { class: "flex gap-1" }, QP = { class: "dropdown-tree__item--path" }, VP = { class: "dropdown-tree__item--label" }, ZP = {
  key: 0,
  class: "dropdown-tree__item--icon"
}, GP = Z({
  __name: "DropdownItem",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showPath: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(e, { emit: t }) {
    const r = t, n = (i) => {
      var a;
      !i.disabled && (a = i.children) != null && a.length ? r("onForwardTraverse", i) : r("onSelect", i.value);
    }, o = (i) => i ? i == null ? void 0 : i.split("/").filter(Boolean).at(-1) : null;
    return (i, a) => (_(!0), be(qt, null, jl(e.options, (l) => {
      var s;
      return _(), be("a", {
        key: l.label.toString(),
        class: br(["dropdown-tree__item", [l == null ? void 0 : l.className, l.disabled ? "disabled" : ""]]),
        onClick: () => n(l)
      }, [
        de("span", WP, [
          e.showPath && l._pathFromRoot !== "/" ? (_(), se(N(gs), {
            key: 0,
            disabled: !e.showPath && l._pathFromRoot
          }, {
            trigger: Q(() => [
              de("span", QP, [
                B(N(Bu), {
                  class: "dropdown-tree__item--path-label",
                  tooltip: !1
                }, {
                  default: Q(() => [
                    Qt(kt(o(l._pathFromRoot)), 1)
                  ]),
                  _: 2
                }, 1024),
                Qt(" " + kt("/"))
              ])
            ]),
            default: Q(() => [
              Qt(" " + kt(l == null ? void 0 : l._pathFromRoot), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : Oe("", !0),
          de("span", VP, [
            (_(), se(Jn(l.icon), {
              class: br(l.iconClass)
            }, null, 8, ["class"])),
            B(N(Bu), {
              class: br(e.showPath ? "showPath" : ""),
              tooltip: !1
            }, {
              default: Q(() => [
                Qt(kt(l.label), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        (s = l.children) != null && s.length ? (_(), be("span", ZP, [
          l.customArrow ? (_(), se(Jn(l == null ? void 0 : l.customArrow), {
            key: 0,
            class: br(l == null ? void 0 : l.arrowClass)
          }, null, 8, ["class"])) : (_(), se(N(HP), {
            key: 1,
            class: "chevron"
          }))
        ])) : Oe("", !0)
      ], 10, YP);
    }), 128));
  }
}), Nw = /* @__PURE__ */ zm(GP, [["__scopeId", "data-v-91330f12"]]), KP = { class: "dropdown-tree__container" }, qP = { class: "dropdown-tree__search" }, JP = { key: 0 }, XP = {
  key: 1,
  class: "no-data"
}, e9 = { key: 1 }, t9 = {
  key: 1,
  class: "empty-search"
}, r9 = Z({
  name: "UIDropdownTree",
  inheritAttrs: !1,
  components: { UIInput: ni, UIButton: Lr, BreadCrumb: Tw, DropdownItem: Nw, NInput: Gc }
}), n9 = Z({
  ...r9,
  props: {
    id: String,
    options: {
      type: Array,
      default: () => []
    },
    pathSeparator: {
      type: String,
      default: "/"
    },
    disabled: Boolean,
    triggerLabel: String,
    debug: Boolean,
    placement: String,
    loading: Boolean,
    remote: Boolean,
    searchPlaceholder: {
      type: String,
      required: !1,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    x: Number,
    y: Number,
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    }
  },
  emits: ["onSelect", "onSearch", "onClickOutside"],
  setup(e, { emit: t }) {
    const r = e, n = W(() => {
      const b = Fb(r.options).filter(
        (T) => T.type !== "parent"
      );
      return r.debug && Pi("flattenedOptions", b), b;
    }), o = W(() => {
      const b = Fb(r.options).filter(
        (T) => T.type === "parent"
      );
      return r.debug && Pi("flattenedParents", b), b;
    }), i = L(r.options);
    at(
      () => r.options,
      (b) => {
        i.value = b;
      }
    );
    const a = L(""), l = L(r.pathSeparator), s = L(null), c = wr(), u = t, d = L(!1), f = (b) => {
      var T;
      (T = a.value) != null && T.includes(b) || (a.value ? a.value += `${b}${l.value}` : a.value += `${b}${l.value}`, i.value = Bb({ options: r.options, path: a.value }) ?? [], r.debug && Pi(
        `handleForwardTraversal(${b})`,
        `${JSON.stringify(i.value)}   ${a.value}`
      ));
    }, p = (b) => {
      const T = b.split(l.value).filter(Boolean), w = T.slice(0, T.length - 1).join(l.value);
      a.value = w ? `${w}${l.value}` : "", i.value = Bb({ options: r.options, path: w }) ?? [], r.debug && Pi(`handleBackwardTraversal(${b})`, i.value);
    }, h = W(() => {
      const b = a.value.split(l.value).filter(Boolean).at(-1), T = o.value.find(
        (w) => w.value === b
      );
      return r.debug && Pi(`[Computed] currentViewTitle for ${b} is`, T), T;
    }), g = (b) => {
      if (a.value = "", d.value = !0, r.remote)
        u("onSearch", b);
      else if (b) {
        const T = n.value.filter(
          (w) => w.label.toLowerCase().includes(b.toLowerCase())
        );
        i.value = T;
      } else
        i.value = r.options, d.value = !1;
      r.debug && Pi(
        `handleSearch with remote ${r.remote} and search string is ${b}`,
        i.value
      );
    };
    at(
      () => s,
      yP((b) => {
        g(b.value);
      }, 300),
      { deep: !0 }
    );
    const m = () => {
      setTimeout(() => {
        i.value = r.options, s.value = null, a.value = "";
      }, 300), u("onClickOutside");
    }, v = L(), M = (b) => {
      u("onSelect", b), x();
    }, x = () => {
      v.value.handleClick();
    };
    return (b, T) => (_(), se(N(Vc), {
      raw: "",
      id: e.id,
      class: "dropdown-tree",
      disabled: e.disabled,
      "show-arrow": !1,
      trigger: e.trigger,
      onClickoutside: m,
      placement: e.placement,
      ref_key: "popoverRef",
      ref: v,
      show: e.show,
      x: e.x,
      y: e.y,
      to: e.to
    }, {
      trigger: Q(() => [
        N(c).trigger ? Re(b.$slots, "trigger", {
          key: 0,
          disabled: e.disabled
        }, void 0, !0) : (_(), se(N(Lr), {
          key: 1,
          id: "dropdown-tree__trigger",
          class: "dropdown-tree__trigger",
          disabled: e.disabled,
          loading: e.loading
        }, {
          default: Q(() => [
            de("span", null, [
              Qt(kt(e.triggerLabel) + " ", 1),
              (_(), se(Jn(N(RP)), { class: "chevron" }))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      ]),
      default: Q(() => {
        var w, y, I;
        return [
          de("div", KP, [
            de("div", qP, [
              B(N(Gc), {
                id: "dropdown-tree-search",
                placeholder: e.searchPlaceholder,
                value: s.value,
                "onUpdate:value": T[0] || (T[0] = (D) => s.value = D),
                loading: e.loading,
                size: "small"
              }, {
                prefix: Q(() => [
                  N(c).searchIcon ? Re(b.$slots, "searchIcon", { key: 0 }, void 0, !0) : (_(), se(N(xP), {
                    key: 1,
                    class: "icon"
                  }))
                ]),
                _: 3
              }, 8, ["placeholder", "value", "loading"])
            ]),
            B(Tw, {
              show: !!a.value.length,
              title: (w = h.value) == null ? void 0 : w.label,
              disabled: !a.value,
              onOnClick: T[1] || (T[1] = (D) => p(a.value)),
              icon: (y = h.value) == null ? void 0 : y.icon,
              "icon-class": (I = h.value) == null ? void 0 : I.iconClass
            }, null, 8, ["show", "title", "disabled", "icon", "icon-class"]),
            B(Nw, {
              showPath: d.value,
              options: i.value,
              onOnForwardTraverse: T[2] || (T[2] = (D) => f(D.value)),
              onOnSelect: T[3] || (T[3] = (D) => M(D))
            }, null, 8, ["showPath", "options"]),
            !d.value && !e.options.length ? (_(), be("div", JP, [
              N(c).empty ? Re(b.$slots, "empty", { key: 0 }, void 0, !0) : (_(), be("p", XP, "No data"))
            ])) : Oe("", !0),
            d.value && !i.value.length ? (_(), be("div", e9, [
              N(c).emptySearch ? Re(b.$slots, "emptySearch", { key: 0 }, void 0, !0) : (_(), be("p", t9, "No matching results found"))
            ])) : Oe("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["id", "disabled", "trigger", "placement", "show", "x", "y", "to"]));
  }
}), Sw = /* @__PURE__ */ zm(n9, [["__scopeId", "data-v-772aa478"]]);
function o9(e) {
  return e == null || typeof e == "string" && e.trim() === "" ? null : Number(e);
}
function i9(e) {
  return e.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(e) || /^\.\d+$/.test(e));
}
function Vd(e) {
  return e == null ? !0 : !Number.isNaN(e);
}
function Ub(e, t) {
  return e == null ? "" : t === void 0 ? String(e) : e.toFixed(t);
}
function Zd(e) {
  if (e === null)
    return null;
  if (typeof e == "number")
    return e;
  {
    const t = Number(e);
    return Number.isNaN(t) ? null : t;
  }
}
const a9 = V([te("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), te("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]), l9 = (e) => {
  const {
    textColorDisabled: t
  } = e;
  return {
    iconColorDisabled: t
  };
}, s9 = {
  name: "InputNumber",
  common: Jt,
  peers: {
    Button: um,
    Input: dw
  },
  self: l9
}, u9 = s9, c9 = Z({
  name: "Remove",
  render() {
    return S("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, S("line", {
      x1: "400",
      y1: "256",
      x2: "112",
      y2: "256",
      style: `
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 32px;
      `
    }));
  }
}), Hb = 800, Yb = 100, d9 = Object.assign(Object.assign({}, Ve.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: !0
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  inputProps: Object,
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: !0
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}), f9 = Z({
  name: "InputNumber",
  props: d9,
  setup(e) {
    process.env.NODE_ENV !== "production" && rr(() => {
      e.onChange !== void 0 && sr("input-number", "`on-change` is deprecated, please use `on-update:value` instead");
    });
    const {
      mergedBorderedRef: t,
      mergedClsPrefixRef: r,
      mergedRtlRef: n
    } = Bt(e), o = Ve("InputNumber", "-input-number", a9, u9, e, r), {
      localeRef: i
    } = Zc("InputNumber"), a = Ia(e), {
      mergedSizeRef: l,
      mergedDisabledRef: s,
      mergedStatusRef: c
    } = a, u = L(null), d = L(null), f = L(null), p = L(e.defaultValue), h = We(e, "value"), g = fi(h, p), m = L(""), v = (C) => {
      const E = String(C).split(".")[1];
      return E ? E.length : 0;
    }, M = (C) => {
      const E = [e.min, e.max, e.step, C].map((J) => J === void 0 ? 0 : v(J));
      return Math.max(...E);
    }, x = _t(() => {
      const {
        placeholder: C
      } = e;
      return C !== void 0 ? C : i.value.placeholder;
    }), b = _t(() => {
      const C = Zd(e.step);
      return C !== null ? C === 0 ? 1 : Math.abs(C) : 1;
    }), T = _t(() => {
      const C = Zd(e.min);
      return C !== null ? C : null;
    }), w = _t(() => {
      const C = Zd(e.max);
      return C !== null ? C : null;
    }), y = (C) => {
      const {
        value: E
      } = g;
      if (C === E) {
        D();
        return;
      }
      const {
        "onUpdate:value": J,
        onUpdateValue: H,
        onChange: X
      } = e, {
        nTriggerFormInput: me,
        nTriggerFormChange: Te
      } = a;
      X && Be(X, C), H && Be(H, C), J && Be(J, C), p.value = C, me(), Te();
    }, I = ({
      offset: C,
      doUpdateIfValid: E,
      fixPrecision: J,
      isInputing: H
    }) => {
      const {
        value: X
      } = m;
      if (H && i9(X))
        return !1;
      const me = (e.parse || o9)(X);
      if (me === null)
        return E && y(null), null;
      if (Vd(me)) {
        const Te = v(me), {
          precision: G
        } = e;
        if (G !== void 0 && G < Te && !J)
          return !1;
        let ae = parseFloat((me + C).toFixed(G ?? M(me)));
        if (Vd(ae)) {
          const {
            value: Xe
          } = w, {
            value: gt
          } = T;
          if (Xe !== null && ae > Xe) {
            if (!E || H)
              return !1;
            ae = Xe;
          }
          if (gt !== null && ae < gt) {
            if (!E || H)
              return !1;
            ae = gt;
          }
          return e.validator && !e.validator(ae) ? !1 : (E && y(ae), ae);
        }
      }
      return !1;
    }, D = () => {
      const {
        value: C
      } = g;
      if (Vd(C)) {
        const {
          format: E,
          precision: J
        } = e;
        E ? m.value = E(C) : C === null || J === void 0 || // precision overflow
        v(C) > J ? m.value = Ub(C, void 0) : m.value = Ub(C, J);
      } else
        m.value = String(C);
    };
    D();
    const O = _t(() => I({
      offset: 0,
      doUpdateIfValid: !1,
      isInputing: !1,
      fixPrecision: !1
    }) === !1), $ = _t(() => {
      const {
        value: C
      } = g;
      if (e.validator && C === null)
        return !1;
      const {
        value: E
      } = b;
      return I({
        offset: -E,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    }), z = _t(() => {
      const {
        value: C
      } = g;
      if (e.validator && C === null)
        return !1;
      const {
        value: E
      } = b;
      return I({
        offset: +E,
        doUpdateIfValid: !1,
        isInputing: !1,
        fixPrecision: !1
      }) !== !1;
    });
    function Y(C) {
      const {
        onFocus: E
      } = e, {
        nTriggerFormFocus: J
      } = a;
      E && Be(E, C), J();
    }
    function j(C) {
      var E, J;
      if (C.target === ((E = u.value) === null || E === void 0 ? void 0 : E.wrapperElRef))
        return;
      const H = I({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !1,
        fixPrecision: !0
      });
      if (H !== !1) {
        const Te = (J = u.value) === null || J === void 0 ? void 0 : J.inputElRef;
        Te && (Te.value = String(H || "")), g.value === H && D();
      } else
        D();
      const {
        onBlur: X
      } = e, {
        nTriggerFormBlur: me
      } = a;
      X && Be(X, C), me(), mn(() => {
        D();
      });
    }
    function q(C) {
      const {
        onClear: E
      } = e;
      E && Be(E, C);
    }
    function ee() {
      const {
        value: C
      } = z;
      if (!C) {
        tt();
        return;
      }
      const {
        value: E
      } = g;
      if (E === null)
        e.validator || y(Me());
      else {
        const {
          value: J
        } = b;
        I({
          offset: J,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    function re() {
      const {
        value: C
      } = $;
      if (!C) {
        ke();
        return;
      }
      const {
        value: E
      } = g;
      if (E === null)
        e.validator || y(Me());
      else {
        const {
          value: J
        } = b;
        I({
          offset: -J,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        });
      }
    }
    const le = Y, ye = j;
    function Me() {
      if (e.validator)
        return null;
      const {
        value: C
      } = T, {
        value: E
      } = w;
      return C !== null ? Math.max(0, C) : E !== null ? Math.min(0, E) : 0;
    }
    function Ee(C) {
      q(C), y(null);
    }
    function ne(C) {
      var E, J, H;
      !((E = f.value) === null || E === void 0) && E.$el.contains(C.target) && C.preventDefault(), !((J = d.value) === null || J === void 0) && J.$el.contains(C.target) && C.preventDefault(), (H = u.value) === null || H === void 0 || H.activate();
    }
    let ue = null, Ce = null, ze = null;
    function ke() {
      ze && (window.clearTimeout(ze), ze = null), ue && (window.clearInterval(ue), ue = null);
    }
    function tt() {
      Ne && (window.clearTimeout(Ne), Ne = null), Ce && (window.clearInterval(Ce), Ce = null);
    }
    function Ge() {
      ke(), ze = window.setTimeout(() => {
        ue = window.setInterval(() => {
          re();
        }, Yb);
      }, Hb), zt("mouseup", document, ke, {
        once: !0
      });
    }
    let Ne = null;
    function Ye() {
      tt(), Ne = window.setTimeout(() => {
        Ce = window.setInterval(() => {
          ee();
        }, Yb);
      }, Hb), zt("mouseup", document, tt, {
        once: !0
      });
    }
    const Se = () => {
      Ce || ee();
    }, _e = () => {
      ue || re();
    };
    function Fe(C) {
      var E, J;
      if (C.key === "Enter") {
        if (C.target === ((E = u.value) === null || E === void 0 ? void 0 : E.wrapperElRef))
          return;
        I({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && ((J = u.value) === null || J === void 0 || J.deactivate());
      } else if (C.key === "ArrowUp") {
        if (!z.value || e.keyboard.ArrowUp === !1)
          return;
        C.preventDefault(), I({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && ee();
      } else if (C.key === "ArrowDown") {
        if (!$.value || e.keyboard.ArrowDown === !1)
          return;
        C.preventDefault(), I({
          offset: 0,
          doUpdateIfValid: !0,
          isInputing: !1,
          fixPrecision: !0
        }) !== !1 && re();
      }
    }
    function ot(C) {
      m.value = C, e.updateValueOnInput && !e.format && !e.parse && e.precision === void 0 && I({
        offset: 0,
        doUpdateIfValid: !0,
        isInputing: !0,
        fixPrecision: !1
      });
    }
    at(g, () => {
      D();
    });
    const Nt = {
      focus: () => {
        var C;
        return (C = u.value) === null || C === void 0 ? void 0 : C.focus();
      },
      blur: () => {
        var C;
        return (C = u.value) === null || C === void 0 ? void 0 : C.blur();
      },
      select: () => {
        var C;
        return (C = u.value) === null || C === void 0 ? void 0 : C.select();
      }
    }, A = yn("InputNumber", n, r);
    return Object.assign(Object.assign({}, Nt), {
      rtlEnabled: A,
      inputInstRef: u,
      minusButtonInstRef: d,
      addButtonInstRef: f,
      mergedClsPrefix: r,
      mergedBordered: t,
      uncontrolledValue: p,
      mergedValue: g,
      mergedPlaceholder: x,
      displayedValueInvalid: O,
      mergedSize: l,
      mergedDisabled: s,
      displayedValue: m,
      addable: z,
      minusable: $,
      mergedStatus: c,
      handleFocus: le,
      handleBlur: ye,
      handleClear: Ee,
      handleMouseDown: ne,
      handleAddClick: Se,
      handleMinusClick: _e,
      handleAddMousedown: Ye,
      handleMinusMousedown: Ge,
      handleKeyDown: Fe,
      handleUpdateDisplayedValue: ot,
      // theme
      mergedTheme: o,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: W(() => {
        const {
          self: {
            iconColorDisabled: C
          }
        } = o.value, [E, J, H, X] = No(C);
        return {
          textColorTextDisabled: `rgb(${E}, ${J}, ${H})`,
          opacityDisabled: `${X}`
        };
      })
    });
  },
  render() {
    const {
      mergedClsPrefix: e,
      $slots: t
    } = this, r = () => S(wv, {
      text: !0,
      disabled: !this.minusable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleMinusClick,
      onMousedown: this.handleMinusMousedown,
      ref: "minusButtonInstRef"
    }, {
      icon: () => hn(t["minus-icon"], () => [S(On, {
        clsPrefix: e
      }, {
        default: () => S(c9, null)
      })])
    }), n = () => S(wv, {
      text: !0,
      disabled: !this.addable || this.mergedDisabled || this.readonly,
      focusable: !1,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleAddClick,
      onMousedown: this.handleAddMousedown,
      ref: "addButtonInstRef"
    }, {
      icon: () => hn(t["add-icon"], () => [S(On, {
        clsPrefix: e
      }, {
        default: () => S(lP, null)
      })])
    });
    return S("div", {
      class: [`${e}-input-number`, this.rtlEnabled && `${e}-input-number--rtl`]
    }, S(Gc, {
      ref: "inputInstRef",
      autofocus: this.autofocus,
      status: this.mergedStatus,
      bordered: this.mergedBordered,
      loading: this.loading,
      value: this.displayedValue,
      onUpdateValue: this.handleUpdateDisplayedValue,
      theme: this.mergedTheme.peers.Input,
      themeOverrides: this.mergedTheme.peerOverrides.Input,
      builtinThemeOverrides: this.inputThemeOverrides,
      size: this.mergedSize,
      placeholder: this.mergedPlaceholder,
      disabled: this.mergedDisabled,
      readonly: this.readonly,
      textDecoration: this.displayedValueInvalid ? "line-through" : void 0,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onClear: this.handleClear,
      clearable: this.clearable,
      inputProps: this.inputProps,
      internalLoadingBeforeSuffix: !0
    }, {
      prefix: () => {
        var o;
        return this.showButton && this.buttonPlacement === "both" ? [r(), mt(t.prefix, (i) => i ? S("span", {
          class: `${e}-input-number-prefix`
        }, i) : null)] : (o = t.prefix) === null || o === void 0 ? void 0 : o.call(t);
      },
      suffix: () => {
        var o;
        return this.showButton ? [mt(t.suffix, (i) => i ? S("span", {
          class: `${e}-input-number-suffix`
        }, i) : null), this.buttonPlacement === "right" ? r() : null, n()] : (o = t.suffix) === null || o === void 0 ? void 0 : o.call(t);
      }
    }));
  }
}), p9 = Z({
  name: "UIInput"
}), h9 = Z({
  ...p9,
  props: {
    modelValue: {
      type: Number
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    precision: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonPlacement: {
      type: String,
      default: void 0
    },
    showButton: {
      type: Boolean,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: t }) {
    const r = t;
    function n(o) {
      r("update:modelValue", o);
    }
    return (o, i) => (_(), se(N(f9), Ut({
      id: e.id,
      max: e.max,
      min: e.min,
      "button-placement": e.buttonPlacement,
      "show-button": e.showButton,
      precision: e.precision,
      disabled: e.disabled,
      size: e.size,
      readonly: e.readonly,
      value: e.modelValue,
      "onUpdate:value": n,
      placeholder: e.placeholder,
      clearable: e.clearable,
      loading: e.loading
    }, o.$attrs, {
      class: [e.loading ? "" : "hide-loader", "hl-input-number font-sans"],
      onFocus: i[0] || (i[0] = (a) => o.$emit("focus", a)),
      onBlur: i[1] || (i[1] = (a) => o.$emit("blur", a))
    }), {
      prefix: Q(() => [
        Re(o.$slots, "prefix")
      ]),
      suffix: Q(() => [
        Re(o.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["id", "max", "min", "button-placement", "show-button", "precision", "disabled", "size", "readonly", "value", "placeholder", "clearable", "loading", "class"]));
  }
}), Yu = h9, g9 = ["id", "disabled"], m9 = {
  name: "RTEControl",
  inheritAttrs: !1
}, v9 = /* @__PURE__ */ Z({
  ...m9,
  props: {
    id: {
      type: String,
      required: !0
    },
    tooltipLabel: {
      type: String,
      required: !0
    },
    tooltipPosition: {
      type: String
    },
    active: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    callbackData: {
      type: Object,
      required: !1,
      default: null
    }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const r = t;
    return (n, o) => (_(), se(N(gs), { placement: e.tooltipPosition }, {
      trigger: Q(() => [
        de("button", {
          id: e.id,
          class: br(["toolbar_button", { "active ": e.active }]),
          disabled: e.disabled,
          onClick: o[0] || (o[0] = () => r("onClick", e.callbackData)),
          type: "button"
        }, [
          Re(n.$slots, "default", {}, void 0, !0)
        ], 10, g9)
      ]),
      default: Q(() => [
        de("span", null, kt(e.tooltipLabel), 1)
      ]),
      _: 3
    }, 8, ["placement"]));
  }
});
const Yr = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Je = /* @__PURE__ */ Yr(v9, [["__scopeId", "data-v-9033ca31"]]);
Je.install = (e) => {
  e.component(Je.name, Je);
};
const b9 = "data:image/svg+xml;base64,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", ft = "toolbar_button", Vs = "toolbar_select", Zr = "floating_menu", Ue = {
  toolbarButtonBold: `${ft}--bold`,
  toolbarButtonItalic: `${ft}--italic`,
  toolbarButtonUnderline: `${ft}--underline`,
  toolbarButtonStrike: `${ft}--strike`,
  toolbarSelectFontFamily: `${Vs}--font_family`,
  toolbarSelectFontSize: `${Vs}--font_size`,
  toolbarSelectTextBlock: `${Vs}--text_block`,
  toolbarSelectLineHeight: `${Vs}--line_height`,
  toolbarButtonTextAlignLeft: `${ft}--text_align_left`,
  toolbarButtonTextAlignRight: `${ft}--text_align_right`,
  toolbarButtonTextAlignCenter: `${ft}--text_align_center`,
  toolbarButtonTextAlignJustify: `${ft}--text_align_justify`,
  toolbarButtonShowLinkEmbed: `${ft}--show_link_embed`,
  floatingMenuImageAlignLeft: `${Zr}--image_picker_menu--align_left`,
  floatingMenuImageAlignRight: `${Zr}--image_picker_menu--align_right`,
  floatingMenuImageAlignCenter: `${Zr}--image_picker_menu--align_center`,
  floatingMenuImageJustifyLeft: `${Zr}--image_picker_menu--justify_left`,
  floatingMenuImageJustifyRight: `${Zr}--image_picker_menu--justify_right`,
  floatingMenuImageShowPicker: `${Zr}--image_picker_menu--show_picker`,
  floatingMenuVideoAlignLeft: `${Zr}--Video_picker_menu--align_left`,
  floatingMenuVideoAlignRight: `${Zr}--Video_picker_menu--align_right`,
  floatingMenuVideoAlignCenter: `${Zr}--Video_picker_menu--align_center`,
  floatingMenuVideoJustifyLeft: `${Zr}--Video_picker_menu--justify_left`,
  floatingMenuVideoJustifyRight: `${Zr}--Video_picker_menu--justify_right`,
  floatingMenuVideoShowPicker: `${Zr}--Video_picker_menu--show_picker`,
  toolbarButtonFormatStyles: `${ft}--format_styles`,
  toolbarButtonOrderedList: `${ft}--ordered_list`,
  toolbarButtonUnOrderedList: `${ft}--unordered_list`,
  toolbarButtonTaskList: `${ft}--task_list`,
  toolbarButtonUndo: `${ft}--history--undo`,
  toolbarButtonRedo: `${ft}--history--redo`,
  toolbarButtonInlineCode: `${ft}--inline_code`,
  toolbarButtonCodeBlock: `${ft}--code_block`,
  toolbarButtonSuper: `${ft}--super`,
  toolbarButtonSub: `${ft}--sub`,
  toolbarButtonCircleList: `${ft}--circle_list`,
  toolbarButtonSquareList: `${ft}--square_list`,
  toolbarButtonLowerAlphaList: `${ft}--lower_alpha_list`,
  toolbarButtonLowerGreekList: `${ft}--lower_greek_list`,
  toolbarButtonLowerRomanList: `${ft}--lower_roman_list`,
  toolbarButtonUpperAlphaList: `${ft}--upper_alpha_list`,
  toolbarButtonUpperRomanList: `${ft}--upper_roman_list`,
  toolbarButtonQuote: `${ft}--quote`,
  toolbarButtonColorPicker: `${ft}--color-picker`,
  toolbarButtonDots: `${ft}--dots`
}, Cw = {
  cancel: "Afbestille",
  save: "Gem",
  left: "Venstre",
  right: "Højre",
  center: "Center",
  justify: "Retfærdiggøre",
  bold: "Bold",
  italic: "Kursiv",
  strike: "strejke",
  underline: "Understrege",
  remove: "Fjern",
  update: "Opdatering",
  action: "Handling",
  blockquote: "citatboks",
  code: "Kode",
  fileUpload: "Fil upload",
  invalidURL: "Ugyldig URL",
  url: "Uniform Resource Locator",
  valueMissing: "Værdi mangler",
  targetNeeded: "Der er brug for et mål",
  customControl: "Brugerdefineret kontrol",
  externalEmbed: "Extern indlejring",
  invalidOption: "Ugyldig valgmulighed angivet",
  "Paste formatting options": "Indsæt formateringsindstillinger",
  pasteMessage: "Vælg at beholde eller fjerne formateringen i det indsatte indhold",
  keepFormatting: "Fortsæt med at formatere",
  removeFormatting: "Fjern formatering"
}, Iw = {
  fontFamily: "Skrifttypefamilie",
  fontSize: "Skriftstørrelse",
  lineHeight: "Linjehøjde"
}, Aw = {
  tooltip: "Tilføj link",
  title: "Indlejr link",
  urlFieldLabel: "Tilføj URL",
  actionFieldLabel: "Vælg handling",
  validations: {
    href: "Gyldig URL er nødvendig",
    target: "Mål er nødvendigt"
  }
}, Dw = {
  tooltip: "Tilføj billede",
  alignmentTooltip: "Justér billede til {align}",
  wrapTooltip: "Pak billede ind til {align}",
  editTitle: "Rediger billede",
  embedTitle: "Indlejr billede",
  validations: {
    url: "Gyldig billede-URL er påkrævet",
    width: "Ugyldig bredde angivet",
    height: "Ugyldig højde angivet",
    alt: "Angiv venligst alternativ tekst",
    imageLink: "Gyldig URL er nødvendig",
    target: "Ugyldigt mål er angivet"
  },
  labels: {
    url: "Billed-URL",
    width: "Indstil bredde",
    height: "Indstil højde",
    alt: "Alternativ tekst",
    imageLink: "Billedhandlingslink",
    target: "Åbn link i",
    target_self: "I det samme vindue",
    target_blank: "I det nye vindue"
  },
  placeholders: {
    url: "Venligst tilføj en gyldig billed-URL"
  },
  lockAspect: "Lås forholdet mellem længde og bredde",
  unlockAspect: "Lås sideforhold"
}, kw = {
  width: "bil",
  height: "bil",
  alt: "Angiv en alternativ tekst",
  imageLink: "Indsæt et link til at åbne ved at klikke på billedet",
  target: "ignorer",
  tooltip: "Tilføj video",
  alignmentTooltip: "Juster video til {align}",
  wrapTooltip: "Ombryd video til {align}",
  editTitle: "Rediger video",
  embedTitle: "Indlejr video",
  convertLinkTitle: "Konverter til et link",
  validations: {
    src: "Gyldig video-URL er påkrævet",
    width: "Ugyldig bredde angivet",
    height: "Ugyldig højde angivet",
    fileType: "Ugyldig filtype"
  },
  labels: {
    linkSource: "Video kilde",
    width: "Bredde (px)",
    height: "Højde (px)",
    src: "Video-URL",
    source_native: "Indsæt fra et link",
    source_youtube: "Tilføj Youtube-URL"
  },
  placeholders: {
    src: "ignorer",
    width: "Standardbredde",
    height: "Standardhøjde",
    alt: "Angiv en alternativ tekst",
    imageLink: "Indsæt et link til at åbne ved at klikke på billedet",
    target: "ignorere"
  },
  updateVideo: "Opdater video"
}, Ew = {
  tooltip: "Tilføj linjehøjde"
}, Lw = {
  bulletListTooltip: "Tilføj punktopstilling",
  orderedListTooltip: "Tilføj nummereret liste",
  taskListTooltip: "Tilføj opgaveliste",
  list: "Liste",
  circleList: "Cirkelliste",
  discList: "Diskliste",
  squareList: "Firkantet liste",
  upperAlphaList: "Øvre alfabetiske liste",
  upperRomanList: "Øvre romerske liste",
  decimalList: "Decimalliste",
  lowerAlphaList: "Lavere alfabetisk liste",
  lowerGreekList: "Lavgræsk liste",
  lowerRomanList: "Nedre romersk liste"
}, $w = {
  formatAllTooltip: "Formater alle dokumenter",
  formatSelectedTooltip: "Formatet er valgt"
}, zw = {
  undo: "Fortryd",
  redo: "Gør igen"
}, Ow = {
  alignTooltip: "Juster tekst til {align}",
  subScript: "Underskrevet skrift",
  superScript: "Super Skript"
}, jw = {
  self: "Selv",
  newWindow: "Nyt vindue",
  linkTitle: "Link overskrift",
  textNeeded: "Link tekst er nødvendig",
  invalidCustomLink: "Ugyldigt brugerdefineret integreringslink"
}, Rw = {
  textColor: "Tekstfarve",
  textHighlight: "Tekst fremhævning"
}, _w = {
  paragraph: "Afsnit",
  heading1: "Overskrift 1",
  heading2: "Overskrift 2",
  heading3: "Rubrik 3",
  heading4: "Overskrift 4",
  heading5: "Overskrift 5"
}, Pw = {
  insertTable: "Indsæt tabel",
  deleteTable: "Slet tabel",
  deleteColumn: "Slet kolonne",
  deleteRow: "Slet række",
  addColumnBefore: "Tilføj kolonne før",
  addColumnAfter: "Tilføj kolonne efter",
  addRowBefore: "Tilføj række før",
  addRowAfter: "Tilføj række efter",
  mergeCell: "Flet celler",
  splitCell: "Opdel celle"
}, M9 = {
  common: Cw,
  placeholders: Iw,
  linkEmbed: Aw,
  imageEmbed: Dw,
  videoEmbed: kw,
  lineHeight: Ew,
  list: Lw,
  resetStyles: $w,
  history: zw,
  textAlign: Ow,
  link: jw,
  color: Rw,
  paragraph: _w,
  table: Pw
}, y9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: Rw,
  common: Cw,
  default: M9,
  history: zw,
  imageEmbed: Dw,
  lineHeight: Ew,
  link: jw,
  linkEmbed: Aw,
  list: Lw,
  paragraph: _w,
  placeholders: Iw,
  resetStyles: $w,
  table: Pw,
  textAlign: Ow,
  videoEmbed: kw
}, Symbol.toStringTag, { value: "Module" })), Bw = {
  cancel: "Abbrechen",
  save: "Speichern",
  left: "Links",
  right: "Richtig",
  center: "Einmitten",
  justify: "Rechtfertigen",
  bold: "Fett",
  italic: "Kursiv",
  strike: "Durchstreichen",
  underline: "Unterstreichen",
  remove: "Entfernen",
  update: "Aktualisieren",
  action: "Aktion",
  blockquote: "Blockzitat",
  code: "Code",
  fileUpload: "Datei hochladen",
  invalidURL: "Ungültige URL",
  url: "Uniformer Ressourcen-Zeiger",
  valueMissing: "Wert fehlt",
  targetNeeded: "Ziel wird benötigt",
  customControl: "Benutzerdefinierte Steuerung",
  externalEmbed: "Externer Einbettungscode",
  invalidOption: "Ungültige Option angegeben",
  "Paste formatting options": "Formatierungsoptionen einfügen",
  pasteMessage: "Wählen Sie, ob Sie die Formatierung im eingefügten Inhalt beibehalten oder entfernen möchten",
  keepFormatting: "Formatieren Sie weiter",
  removeFormatting: "Formatierung entfernen"
}, Fw = {
  fontFamily: "Schriftart",
  fontSize: "Schriftgröße",
  lineHeight: "Zeilenhöhe"
}, Uw = {
  tooltip: "Fügen Sie einen Link hinzu",
  title: "Link einbetten",
  urlFieldLabel: "URL hinzufügen",
  actionFieldLabel: "Aktion auswählen",
  validations: {
    href: "Eine gültige URL ist erforderlich",
    target: "Ziel ist erforderlich"
  }
}, Hw = {
  tooltip: "Bild hinzufügen",
  alignmentTooltip: "Bild an {align} ausrichten",
  wrapTooltip: "Bild umbrechen auf {align}",
  editTitle: "Bild bearbeiten",
  embedTitle: "Bild einbetten",
  validations: {
    url: "Eine gültige Bild-URL ist erforderlich",
    width: "Ungültige Breite angegeben",
    height: "Ungültige Höhe angegeben",
    alt: "Bitte geben Sie einen alternativen Text an",
    imageLink: "Eine gültige URL ist erforderlich",
    target: "Ungültiges Ziel angegeben"
  },
  labels: {
    url: "Bild-URL",
    width: "Breite festlegen",
    height: "Höhe einstellen",
    alt: "Alt-Text",
    imageLink: "Bild Aktionslink",
    target: "Öffne den Link",
    target_self: "Im selben Fenster",
    target_blank: "In dem neuen Fenster"
  },
  placeholders: {
    url: "Bitte fügen Sie eine gültige Bild-URL hinzu"
  },
  lockAspect: "Aspektverhältnis sperren",
  unlockAspect: "Aspektverhältnis entsperren"
}, Yw = {
  width: "Auto",
  height: "Auto",
  alt: "Geben Sie einen alternativen Text an",
  imageLink: "Fügen Sie einen Link ein, um das Bild beim Klicken zu öffnen",
  target: "ignorieren",
  tooltip: "Video hinzufügen",
  alignmentTooltip: "Video an {align} ausrichten",
  wrapTooltip: "Video an {align} anpassen",
  editTitle: "Video bearbeiten",
  embedTitle: "Video einbetten",
  convertLinkTitle: "In einen Link umwandeln",
  validations: {
    src: "Eine gültige Video-URL ist erforderlich",
    width: "Ungültige Breite angegeben",
    height: "Ungültige Höhe angegeben",
    fileType: "Ungültiger Dateityp"
  },
  labels: {
    linkSource: "Videoquelle",
    width: "Breite (px)",
    height: "Höhe (px)",
    src: "Video-URL",
    source_native: "Einfügen von einem Link",
    source_youtube: "Fügen Sie die YouTube-URL hinzu"
  },
  placeholders: {
    src: "ignore",
    width: "Standardbreite",
    height: "Standardhöhe",
    alt: "Geben Sie einen alternativen Text an",
    imageLink: "Fügen Sie einen Link ein, um das Bild beim Klicken zu öffnen",
    target: "ignore"
  },
  updateVideo: "Aktualisierungsvideo"
}, Ww = {
  tooltip: "Zeilenhöhe hinzufügen"
}, Qw = {
  bulletListTooltip: "Liste mit Aufzählungszeichen hinzufügen",
  orderedListTooltip: "Fügen Sie eine nummerierte Liste hinzu",
  taskListTooltip: "Fügen Sie eine To-Do-Liste hinzu",
  list: "Liste",
  circleList: "Kreisliste",
  discList: "Disc-Liste",
  squareList: "Listenplatz",
  upperAlphaList: "Obere Alpha-Liste",
  upperRomanList: "Obere Römische Liste",
  decimalList: "Dezimalliste",
  lowerAlphaList: "Untere Alphabetische Liste",
  lowerGreekList: "Untere griechische Liste",
  lowerRomanList: "Untere römische Liste"
}, Vw = {
  formatAllTooltip: "Alle Dokumente formatieren",
  formatSelectedTooltip: "Ausgewähltes Format"
}, Zw = {
  undo: "Rückgängig machen",
  redo: "Mach es noch einmal"
}, Gw = {
  alignTooltip: "Text an {align} ausrichten",
  subScript: "Unter-Skript",
  superScript: "Super Skript"
}, Kw = {
  self: "Selbst",
  newWindow: "Neues Fenster",
  linkTitle: "Linktitel",
  textNeeded: "Linktext wird benötigt",
  invalidCustomLink: "Ungültiger benutzerdefinierter Einbettungslink"
}, qw = {
  textColor: "Textfarbe",
  textHighlight: "Text-Hervorhebung"
}, Jw = {
  paragraph: "Absatz",
  heading1: "Überschrift 1",
  heading2: "Überschrift 2",
  heading3: "Überschrift 3",
  heading4: "Überschrift 4",
  heading5: "Überschrift 5"
}, Xw = {
  insertTable: "Tabelle einfügen",
  deleteTable: "Tabelle löschen",
  deleteColumn: "Spalte löschen",
  deleteRow: "Zeile löschen",
  addColumnBefore: "Spalte davor hinzufügen",
  addColumnAfter: "Spalte danach hinzufügen",
  addRowBefore: "Zeile davor hinzufügen",
  addRowAfter: "Zeile danach hinzufügen",
  mergeCell: "Zellen zusammenführen",
  splitCell: "Zelle aufteilen"
}, x9 = {
  common: Bw,
  placeholders: Fw,
  linkEmbed: Uw,
  imageEmbed: Hw,
  videoEmbed: Yw,
  lineHeight: Ww,
  list: Qw,
  resetStyles: Vw,
  history: Zw,
  textAlign: Gw,
  link: Kw,
  color: qw,
  paragraph: Jw,
  table: Xw
}, w9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: qw,
  common: Bw,
  default: x9,
  history: Zw,
  imageEmbed: Hw,
  lineHeight: Ww,
  link: Kw,
  linkEmbed: Uw,
  list: Qw,
  paragraph: Jw,
  placeholders: Fw,
  resetStyles: Vw,
  table: Xw,
  textAlign: Gw,
  videoEmbed: Yw
}, Symbol.toStringTag, { value: "Module" })), eT = {
  cancel: "Cancel",
  save: "Save",
  left: "Left",
  right: "Right",
  center: "Center",
  justify: "Justify",
  bold: "Bold",
  italic: "Italic",
  strike: "Strike",
  underline: "Underline",
  remove: "Remove",
  update: "Update",
  action: "Action",
  blockquote: "Blockquote",
  code: "Code",
  fileUpload: "File Upload",
  invalidURL: "Invalid URL",
  url: "URL",
  valueMissing: "Value is missing",
  targetNeeded: "Target is needed",
  customControl: "Custom control",
  externalEmbed: "External Embed",
  invalidOption: "Invalid option provided",
  pasteFormattingOptions: "Paste formatting options",
  pasteMessage: "Choose to keep or remove the formatting in the pasted content",
  keepFormatting: "Keep Formatting",
  removeFormatting: "Remove Formatting"
}, tT = {
  fontFamily: "Font family",
  fontSize: "Font size",
  lineHeight: "Line Height"
}, rT = {
  tooltip: "Add Link",
  title: "Embed Link",
  urlFieldLabel: "Add URL",
  actionFieldLabel: "Select Action",
  validations: {
    href: "Valid URL is needed",
    target: "Target is needed"
  }
}, nT = {
  tooltip: "Add Image",
  alignmentTooltip: "Align image to {align}",
  wrapTooltip: "Wrap image to {align}",
  editTitle: "Edit Image",
  embedTitle: "Embed Image",
  validations: {
    url: "Valid image URL is needed",
    width: "Invalid width provided",
    height: "Invalid height provided",
    alt: "Please specify alternate text",
    imageLink: "Valid URL is needed",
    target: "Invalid target provided"
  },
  labels: {
    url: "Image URL",
    width: "Set Width",
    height: "Set Height",
    alt: "Alt Text",
    imageLink: "Image Action Link",
    target: "Open Link In",
    target_self: "In the same window",
    target_blank: "In the new window"
  },
  placeholders: {
    url: "Please add a valid image url"
  },
  lockAspect: "Lock aspect ratio",
  unlockAspect: "Un-lock aspect ratio"
}, oT = {
  width: "Auto",
  height: "Auto",
  alt: "Specify an alternate text",
  imageLink: "Paste a link to open on clicking on image",
  target: "ignore",
  tooltip: "Add Video",
  alignmentTooltip: "Align video to {align}",
  wrapTooltip: "Wrap video to {align}",
  editTitle: "Edit Video",
  embedTitle: "Embed Video",
  convertLinkTitle: "Convert to a link",
  validations: {
    src: "Valid video URL is needed",
    width: "Invalid width provided",
    height: "Invalid height provided",
    fileType: "Invalid File type"
  },
  labels: {
    linkSource: "Video Source",
    width: "Width (px)",
    height: "Height (px)",
    src: "Video URL",
    source_native: "Insert from a link",
    source_youtube: "Add Youtube URL"
  },
  placeholders: {
    src: "ignore",
    width: "Default width",
    height: "Default height",
    alt: "Specify an alternate text",
    imageLink: "Paste a link to open on clicking on image",
    target: "ignore"
  },
  updateVideo: "Update Video"
}, iT = {
  tooltip: "Add Line Height"
}, aT = {
  bulletListTooltip: "Add Bulleted List",
  orderedListTooltip: "Add Numbered List",
  taskListTooltip: "Add Todo List",
  list: "List",
  circleList: "Circle List",
  discList: "Disc List",
  squareList: "Square List",
  upperAlphaList: "Upper Alpha List",
  upperRomanList: "Upper Roman List",
  decimalList: "Decimal List",
  lowerAlphaList: "Lower Alpha List",
  lowerGreekList: "Lower Greek List",
  lowerRomanList: "Lower Roman List"
}, lT = {
  formatAllTooltip: "Format all document",
  formatSelectedTooltip: "Format selected"
}, sT = {
  undo: "Undo",
  redo: "Redo"
}, uT = {
  alignTooltip: "Align text to {align}",
  subScript: "Sub Script",
  superScript: "Super Script"
}, cT = {
  self: "Self",
  newWindow: "New window",
  linkTitle: "Link Title",
  textNeeded: "Link text is needed",
  invalidCustomLink: "Invalid custom embed link"
}, dT = {
  textColor: "Text Color",
  textHighlight: "Text Highlight"
}, fT = {
  paragraph: "Paragraph",
  heading1: "Heading 1",
  heading2: "Heading 2",
  heading3: "Heading 3",
  heading4: "Heading 4",
  heading5: "Heading 5"
}, pT = {
  insertTable: "Insert Table",
  deleteTable: "Delete Table",
  deleteColumn: "Delete Column",
  deleteRow: "Delete Row",
  addColumnBefore: "Add Column Before",
  addColumnAfter: "Add Column After",
  addRowBefore: "Add Row Before",
  addRowAfter: "Add Row After",
  mergeCell: "Merge Cells",
  splitCell: "Split Cell"
}, T9 = {
  common: eT,
  placeholders: tT,
  linkEmbed: rT,
  imageEmbed: nT,
  videoEmbed: oT,
  lineHeight: iT,
  list: aT,
  resetStyles: lT,
  history: sT,
  textAlign: uT,
  link: cT,
  color: dT,
  paragraph: fT,
  table: pT
}, N9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: dT,
  common: eT,
  default: T9,
  history: sT,
  imageEmbed: nT,
  lineHeight: iT,
  link: cT,
  linkEmbed: rT,
  list: aT,
  paragraph: fT,
  placeholders: tT,
  resetStyles: lT,
  table: pT,
  textAlign: uT,
  videoEmbed: oT
}, Symbol.toStringTag, { value: "Module" })), hT = {
  cancel: "Guardar",
  save: "Izquierda",
  left: "¡Correcto!",
  right: "Centro",
  center: "Justificar",
  justify: "Audaz",
  bold: "Itálico",
  italic: "Huelga",
  strike: "Subrayar",
  underline: "Quitar",
  remove: "Actualizar",
  update: "Familia de fuentes",
  action: "Acción",
  blockquote: "Cita en bloque",
  code: "Código",
  fileUpload: "Carga de archivos",
  invalidURL: "URL inválida",
  url: "Localizador Uniforme de Recursos",
  valueMissing: "Valor faltante",
  targetNeeded: "Se necesita un objetivo",
  customControl: "control personalizado",
  externalEmbed: "Incrustación externa",
  invalidOption: "Opción inválida proporcionada",
  pasteFormattingOptions: "Paste formatting options",
  pasteMessage: "Choose to keep or remove the formatting in the pasted content",
  keepFormatting: "Keep Formatting",
  removeFormatting: "Remove Formatting"
}, gT = {
  fontFamily: "Tamaño de fuente",
  fontSize: "Altura de línea",
  lineHeight: "Agregar enlace"
}, mT = {
  tooltip: "Incrustar enlace",
  title: "Agregar URL",
  urlFieldLabel: "Seleccionar Acción",
  actionFieldLabel: "Se necesita una URL válida",
  validations: {
    href: "Se necesita un objetivo",
    target: "Añadir imagen"
  }
}, vT = {
  tooltip: "Agregar imagen",
  alignmentTooltip: "Alinear imagen a {align}",
  wrapTooltip: "Envolver imagen para {align}",
  editTitle: "Editar imagen",
  embedTitle: "Incrustar imagen",
  validations: {
    url: "Se necesita una URL de imagen válida",
    width: "Ancho inválido proporcionado",
    height: "Altura inválida proporcionada",
    alt: "Por favor especifique un texto alternativo",
    imageLink: "Se necesita una URL válida",
    target: "Destino no válido proporcionado"
  },
  labels: {
    url: "URL de imagen",
    width: "Establecer ancho",
    height: "Establecer altura",
    alt: "Texto alternativo",
    imageLink: "Enlace de acción de imagen",
    target: "Abrir enlace en",
    target_self: "En la misma ventana",
    target_blank: "En la nueva ventana"
  },
  placeholders: {
    url: "Por favor, agregue una URL de imagen válida"
  },
  lockAspect: "Bloquear relación de aspecto",
  unlockAspect: "Desbloquear relación de aspecto"
}, bT = {
  width: "Auto",
  height: "Auto",
  alt: "Especificar un texto alternativo",
  imageLink: "Pegar un enlace para abrir al hacer clic en la imagen",
  target: "ignore",
  tooltip: "Agregar video",
  alignmentTooltip: "Alinear video a {align}",
  wrapTooltip: "Envolver video a {align}",
  editTitle: "Editar video",
  embedTitle: "Incrustar video",
  convertLinkTitle: "Convertir en un enlace",
  validations: {
    src: "Se necesita una URL de video válida",
    width: "Ancho inválido proporcionado",
    height: "Altura inválida proporcionada",
    fileType: "Tipo de archivo no válido"
  },
  labels: {
    linkSource: "Fuente de video",
    width: "Ancho (px)",
    height: "Altura (px)",
    src: "URL del vídeo",
    source_native: "Inserte desde un enlace",
    source_youtube: "Agregar URL de Youtube"
  },
  placeholders: {
    src: "ignore",
    width: "Ancho predeterminado",
    height: "Altura predeterminada",
    alt: "Especificar un texto alternativo",
    imageLink: "Pegar un enlace para abrir al hacer clic en la imagen",
    target: "ignore"
  },
  updateVideo: "Actualizar video"
}, MT = {
  tooltip: "Agregar altura de línea"
}, yT = {
  bulletListTooltip: "Agregar lista con viñetas",
  orderedListTooltip: "Agregar lista numerada",
  taskListTooltip: "Agregar lista de tareas",
  list: "Lista",
  circleList: "Lista de círculo",
  discList: "Lista de discos",
  squareList: "Lista Cuadrada",
  upperAlphaList: "Lista alfabética superior",
  upperRomanList: "Lista romana superior",
  decimalList: "Lista decimal",
  lowerAlphaList: "Lista alfa inferior",
  lowerGreekList: "Lista griega inferior",
  lowerRomanList: "Lista romana inferior"
}, xT = {
  formatAllTooltip: "Formatear todos los documentos",
  formatSelectedTooltip: "Formato seleccionado"
}, wT = {
  undo: "Deshacer",
  redo: "Volver a hacer"
}, TT = {
  alignTooltip: "Alinear el texto a {align}",
  subScript: "Subíndice",
  superScript: "Superíndice"
}, NT = {
  self: "Uno mismo",
  newWindow: "Nueva ventana",
  linkTitle: "Título del enlace",
  textNeeded: "Se necesita un texto de enlace",
  invalidCustomLink: "Enlace personalizado de incrustación no válido"
}, ST = {
  textColor: "Color del texto",
  textHighlight: "Resaltado de texto"
}, CT = {
  paragraph: "Párrafo",
  heading1: "Título 1",
  heading2: "Título 2",
  heading3: "Encabezado 3",
  heading4: "Título 4",
  heading5: "Encabezado 5"
}, IT = {
  insertTable: "Insertar tabla",
  deleteTable: "Eliminar tabla",
  deleteColumn: "Eliminar columna",
  deleteRow: "Eliminar fila",
  addColumnBefore: "Agregar columna antes",
  addColumnAfter: "Agregar columna después",
  addRowBefore: "Agregar fila antes",
  addRowAfter: "Agregar fila después",
  mergeCell: "Combinar celdas",
  splitCell: "Dividir celda"
}, S9 = {
  common: hT,
  placeholders: gT,
  linkEmbed: mT,
  imageEmbed: vT,
  videoEmbed: bT,
  lineHeight: MT,
  list: yT,
  resetStyles: xT,
  history: wT,
  textAlign: TT,
  link: NT,
  color: ST,
  paragraph: CT,
  table: IT
}, C9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: ST,
  common: hT,
  default: S9,
  history: wT,
  imageEmbed: vT,
  lineHeight: MT,
  link: NT,
  linkEmbed: mT,
  list: yT,
  paragraph: CT,
  placeholders: gT,
  resetStyles: xT,
  table: IT,
  textAlign: TT,
  videoEmbed: bT
}, Symbol.toStringTag, { value: "Module" })), AT = {
  cancel: "Peruuta",
  save: "Tallentaa",
  left: "vasen",
  right: "Oikea",
  center: "keskus",
  justify: "perustella",
  bold: "Rohkea",
  italic: "kursiivi",
  strike: "Lakko",
  underline: "Alleviivata",
  remove: "Poista",
  update: "Päivitys",
  action: "Toiminta",
  blockquote: "Lainaus",
  code: "Koodi",
  fileUpload: "Tiedoston lähetys",
  invalidURL: "Virheellinen URL",
  url: "Uniform Resource Locators",
  valueMissing: "Arvo puuttuu",
  targetNeeded: "Kohde tarvitaan",
  customControl: "Räätälöity ohjaus",
  externalEmbed: "Ulkoista upotusta",
  invalidOption: "Virheellinen valinta annettu",
  "Paste formatting options": "Liitä muotoiluasetukset",
  pasteMessage: "Valitse, haluatko säilyttää liitetyn sisällön muotoilun tai poistaa sen",
  keepFormatting: "Jatka muotoilua",
  removeFormatting: "Poista muotoilu"
}, DT = {
  fontFamily: "Fonttiperhe",
  fontSize: "Fonttikoko",
  lineHeight: "Riviväli"
}, kT = {
  tooltip: "Lisää linkki",
  title: "Upota linkki",
  urlFieldLabel: "Lisää URL-osoite",
  actionFieldLabel: "Valitse toiminto",
  validations: {
    href: "Tarvitaan voimassa oleva URL-osoite",
    target: "Kohde tarvitaan"
  }
}, ET = {
  tooltip: "Lisää kuva",
  alignmentTooltip: "Kohdista kuva {align} suuntaan",
  wrapTooltip: "Kääri kuva {align}iin",
  editTitle: "Muokkaa kuvaa",
  embedTitle: "Upota kuva",
  validations: {
    url: "Kelvollinen kuvan URL-osoite tarvitaan",
    width: "Virheellinen leveys annettu",
    height: "Virheellinen pituus annettu",
    alt: "Ole hyvä ja määrittele vaihtoehtoinen teksti",
    imageLink: "Tarvitaan kelvollinen URL-osoite",
    target: "Virheellinen kohde annettu"
  },
  labels: {
    url: "Kuvan URL-osoite",
    width: "Aseta leveys",
    height: "Aseta korkeus",
    alt: "Vaihtoehtoinen teksti",
    imageLink: "Kuvan toimintolinkki",
    target: "Avaa linkki",
    target_self: "Samassa ikkunassa",
    target_blank: "Uudessa ikkunassa"
  },
  placeholders: {
    url: "Ole hyvä ja lisää pätevä kuvake URL"
  },
  lockAspect: "Lukitse kuvasuhteen oikea kääntö",
  unlockAspect: "Avaa kuvasuhteen lukitus"
}, LT = {
  width: "auto",
  height: "auto",
  alt: "Määritä vaihtoehtoinen teksti",
  imageLink: "Liitä linkki avattavaksi napsauttamalla kuvaa",
  target: "unohtaa",
  tooltip: "Lisää video",
  alignmentTooltip: "Kohdista video {align}-asentoon",
  wrapTooltip: "Pakkaa video {align} mukaiseksi",
  editTitle: "Muokkaa videota",
  embedTitle: "Upota video",
  convertLinkTitle: "Muunna linkiksi",
  validations: {
    src: "Tarvitaan voimassa oleva videon URL-osoite",
    width: "Epäkelpo leveys annettu",
    height: "Virheellinen korkeus annettu",
    fileType: "Virheellinen tiedostotyyppi"
  },
  labels: {
    linkSource: "Videon lähde",
    width: "Leveys (px)",
    height: "Korkeus (px)",
    src: "Videon URL-osoite",
    source_native: "Lisää linkistä",
    source_youtube: "Lisää Youtube URL-osoite"
  },
  placeholders: {
    src: "ohittaa",
    width: "Oletusleveys",
    height: "Oletuskorkeus",
    alt: "Määritä vaihtoehtoinen teksti",
    imageLink: "Liitä linkki avautumaan kuvaa napsauttamalla",
    target: "unohtaa"
  },
  updateVideo: "Päivitä video"
}, $T = {
  tooltip: "Lisää riviväli"
}, zT = {
  bulletListTooltip: "Lisää luettelomerkit",
  orderedListTooltip: "Lisää numerointiluettelo",
  taskListTooltip: "Lisää tehtävälista",
  list: "Listan",
  circleList: "Ympyrälista",
  discList: "Levylista",
  squareList: "Neliöluettelo",
  upperAlphaList: "Ylätunnuslista",
  upperRomanList: "Yläroomalainen luettelo",
  decimalList: "Desimaalilista",
  lowerAlphaList: "Aakkosjärjestetty alarajainen lista",
  lowerGreekList: "Alempi kreikkalainen lista",
  lowerRomanList: "Alemmainen roomalainen luettelo"
}, OT = {
  formatAllTooltip: "Muotoile koko asiakirja",
  formatSelectedTooltip: "Tiedostomuoto valittu"
}, jT = {
  undo: "Kumoa",
  redo: "Teke uudelleen"
}, RT = {
  alignTooltip: "Kohdista teksti {align}-asentoon",
  subScript: "Subskriptio",
  superScript: "Ylöskirjoitus"
}, _T = {
  self: "Itse",
  newWindow: "Uusi ikkuna",
  linkTitle: "Linkin otsikko",
  textNeeded: "Linkkitekstiä tarvitaan",
  invalidCustomLink: "Virheellinen mukautettu upotuslinkki"
}, PT = {
  textColor: "Tekstin väri",
  textHighlight: "Tekstin korostus"
}, BT = {
  paragraph: "Kappale",
  heading1: "Otsikko 1",
  heading2: "Otsikko 2",
  heading3: "Otsikko 3",
  heading4: "Otsikko 4",
  heading5: "Ylätunniste 5"
}, FT = {
  insertTable: "Lisää taulukko",
  deleteTable: "Poista taulukko",
  deleteColumn: "Poista sarake",
  deleteRow: "Poista rivi",
  addColumnBefore: "Lisää sarake ennen",
  addColumnAfter: "Lisää sarake jälkeen",
  addRowBefore: "Lisää rivi ennen",
  addRowAfter: "Lisää rivi jälkeen",
  mergeCell: "Yhdistä solut",
  splitCell: "Jaa solu"
}, I9 = {
  common: AT,
  placeholders: DT,
  linkEmbed: kT,
  imageEmbed: ET,
  videoEmbed: LT,
  lineHeight: $T,
  list: zT,
  resetStyles: OT,
  history: jT,
  textAlign: RT,
  link: _T,
  color: PT,
  paragraph: BT,
  table: FT
}, A9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: PT,
  common: AT,
  default: I9,
  history: jT,
  imageEmbed: ET,
  lineHeight: $T,
  link: _T,
  linkEmbed: kT,
  list: zT,
  paragraph: BT,
  placeholders: DT,
  resetStyles: OT,
  table: FT,
  textAlign: RT,
  videoEmbed: LT
}, Symbol.toStringTag, { value: "Module" })), UT = {
  cancel: "Annuler",
  save: "Sauvegarder",
  left: "Gauche",
  right: "Droit",
  center: "Centre",
  justify: "Justifier",
  bold: "Gras",
  italic: "Italique",
  strike: "Grève",
  underline: "Souligner",
  remove: "Supprimer",
  update: "Mise à jour",
  action: "Action",
  blockquote: "Extrait de texte",
  code: "Code",
  fileUpload: "Transfert de fichier",
  invalidURL: "URL invalide",
  url: "adresse URL",
  valueMissing: "Valeur manquante",
  targetNeeded: "La cible est nécessaire",
  customControl: "Contrôle personnalisé",
  externalEmbed: "Incorporation externe",
  invalidOption: "Option invalide fournie",
  "Paste formatting options": "Coller les options de formatage",
  pasteMessage: "Choisissez de conserver ou de supprimer la mise en forme dans le contenu collé",
  keepFormatting: "Conserver le formatage",
  removeFormatting: "Supprimer le formatage"
}, HT = {
  fontFamily: "Famille de polices",
  fontSize: "Taille de police",
  lineHeight: "Hauteur de ligne"
}, YT = {
  tooltip: "Ajouter un lien",
  title: "Lien intégré",
  urlFieldLabel: "Ajouter l'URL",
  actionFieldLabel: "Sélectionner une action",
  validations: {
    href: "Une URL valide est nécessaire",
    target: "Une cible est nécessaire"
  }
}, WT = {
  tooltip: "Ajouter une image",
  alignmentTooltip: "Aligner l'image à {align}",
  wrapTooltip: "Aligner l'image à {align}",
  editTitle: "Modifier l'image",
  embedTitle: "Image intégrée",
  validations: {
    url: "Une URL d'image valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    alt: "Veuillez préciser un texte alternatif",
    imageLink: "Une URL valide est nécessaire",
    target: "Cible invalide fournie"
  },
  labels: {
    url: "URL de l'image",
    width: "Largeur de l'ensemble",
    height: "Hauteur définie",
    alt: "Texte alternatif",
    imageLink: "Lien d'action d'image",
    target: "Ouvrir le lien dans",
    target_self: "Dans la même fenêtre",
    target_blank: "Dans la nouvelle fenêtre"
  },
  placeholders: {
    url: "Veuillez ajouter une URL d'image valide"
  },
  lockAspect: "Verrouiller le ratio d'aspect",
  unlockAspect: "Déverrouiller le rapport d'aspect"
}, QT = {
  width: "voiture",
  height: "voiture",
  alt: "Spécifiez un texte alternatif",
  imageLink: "Coller un lien pour ouvrir en cliquant sur l'image",
  target: "ignore",
  tooltip: "Ajouter une vidéo",
  alignmentTooltip: "Aligner la vidéo à {align}",
  wrapTooltip: "Aligner la vidéo à {align}",
  editTitle: "Modifier la vidéo",
  embedTitle: "Intégrer une vidéo",
  convertLinkTitle: "Convertir en lien",
  validations: {
    src: "Une URL vidéo valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    fileType: "Type de fichier invalide"
  },
  labels: {
    linkSource: "Source vidéo",
    width: "Largeur (px)",
    height: "Hauteur (px)",
    src: "URL de la vidéo",
    source_native: "Insérer à partir d'un lien",
    source_youtube: "Ajouter l'URL de Youtube"
  },
  placeholders: {
    src: "#ERROR!",
    width: "Largeur par défaut",
    height: "Hauteur par défaut",
    alt: "Spécifiez un texte alternatif",
    imageLink: "Coller un lien pour ouvrir en cliquant sur l'image",
    target: "#ERROR!"
  },
  updateVideo: "Mise à jour vidéo"
}, VT = {
  tooltip: "Ajouter la hauteur de ligne"
}, ZT = {
  bulletListTooltip: "Ajouter une liste à puces",
  orderedListTooltip: "Ajouter une liste numérotée",
  taskListTooltip: "Ajouter une liste de tâches à faire",
  list: "Liste",
  circleList: "Liste de cercle",
  discList: "Liste de disques",
  squareList: "Liste Carrée",
  upperAlphaList: "Liste alpha supérieure",
  upperRomanList: "Liste romaine supérieure",
  decimalList: "Liste décimale",
  lowerAlphaList: "Liste alphabétique inférieure",
  lowerGreekList: "Liste grecque inférieure",
  lowerRomanList: "Liste en chiffres romains minuscules"
}, GT = {
  formatAllTooltip: "Formatez tous les documents",
  formatSelectedTooltip: "Format sélectionné"
}, KT = {
  undo: "Annuler",
  redo: "Refaire"
}, qT = {
  alignTooltip: "Aligner le texte à {align}",
  subScript: "Sous-Script",
  superScript: "Super minutieux"
}, JT = {
  self: "Soi",
  newWindow: "Nouvelle fenêtre",
  linkTitle: "Titre du lien",
  textNeeded: "Un lien texte est nécessaire",
  invalidCustomLink: "Lien d'intégration personnalisée invalide"
}, XT = {
  textColor: "Couleur de texte",
  textHighlight: "Surlignage de texte"
}, eN = {
  paragraph: "Paragraphe",
  heading1: "Titre 1",
  heading2: "Titre 2",
  heading3: "Titre 3",
  heading4: "Titre 4",
  heading5: "Titre 5"
}, tN = {
  insertTable: "Insérer un tableau",
  deleteTable: "Supprimer le tableau",
  deleteColumn: "Supprimer la colonne",
  deleteRow: "Supprimer la ligne",
  addColumnBefore: "Ajouter une colonne avant",
  addColumnAfter: "Ajouter une colonne après",
  addRowBefore: "Ajouter une ligne avant",
  addRowAfter: "Ajouter une ligne après",
  mergeCell: "Fusionner les cellules",
  splitCell: "Diviser la cellule"
}, D9 = {
  common: UT,
  placeholders: HT,
  linkEmbed: YT,
  imageEmbed: WT,
  videoEmbed: QT,
  lineHeight: VT,
  list: ZT,
  resetStyles: GT,
  history: KT,
  textAlign: qT,
  link: JT,
  color: XT,
  paragraph: eN,
  table: tN
}, k9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: XT,
  common: UT,
  default: D9,
  history: KT,
  imageEmbed: WT,
  lineHeight: VT,
  link: JT,
  linkEmbed: YT,
  list: ZT,
  paragraph: eN,
  placeholders: HT,
  resetStyles: GT,
  table: tN,
  textAlign: qT,
  videoEmbed: QT
}, Symbol.toStringTag, { value: "Module" })), rN = {
  cancel: "Annuler",
  save: "Sauvegarder",
  left: "Gauche",
  right: "Droit",
  center: "Centre",
  justify: "Justifier",
  bold: "Gras",
  italic: "Italic",
  strike: "Grève",
  underline: "Souligner",
  remove: "Supprimer",
  update: "Mise à jour",
  action: "l'action",
  blockquote: "Bloc de citation",
  code: "le code",
  fileUpload: "Téléchargement de fichier",
  invalidURL: "URL invalide",
  url: "Identifiant de ressource uniforme",
  valueMissing: "La valeur est manquante",
  targetNeeded: "La cible est nécessaire",
  customControl: "Contrôle douanier",
  externalEmbed: "Incorporation externe",
  invalidOption: "Option incorrecte fournie",
  "Paste formatting options": "Coller les options de formatage",
  pasteMessage: "Choisissez de conserver ou de supprimer la mise en forme dans le contenu collé",
  keepFormatting: "Conserver le formatage",
  removeFormatting: "Supprimer le formatage"
}, nN = {
  fontFamily: "Famille de polices",
  fontSize: "Taille de police",
  lineHeight: "Hauteur de ligne"
}, oN = {
  tooltip: "Ajouter un lien",
  title: "Lien intégré",
  urlFieldLabel: "Ajouter une URL",
  actionFieldLabel: "Sélectionner une action",
  validations: {
    href: "Une URL valide est nécessaire",
    target: "Une cible est nécessaire"
  }
}, iN = {
  tooltip: "Ajouter une image",
  alignmentTooltip: "Aligner l'image à {align}",
  wrapTooltip: "Aligner l'image à {align}",
  editTitle: "Modifier l'image",
  embedTitle: "Incorporer l'image",
  validations: {
    url: "Une URL d'image valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    alt: "Veuillez préciser un texte alternatif",
    imageLink: "Une URL valide est nécessaire",
    target: "Cible invalide fournie"
  },
  labels: {
    url: "URL de l'image",
    width: "Largeur de l'ensemble",
    height: "Hauteur définie",
    alt: "Texte alternatif",
    imageLink: "Lien d'action d'image",
    target: "Ouvrir le lien dans",
    target_self: "Dans la même fenêtre",
    target_blank: "Dans la nouvelle fenêtre"
  },
  placeholders: {
    url: "Veuillez ajouter une URL d'image valide"
  },
  lockAspect: "Verrouiller le rapport d'aspect",
  unlockAspect: "Déverrouiller le ratio d'aspect"
}, aN = {
  width: "auto",
  height: "auto",
  alt: "Spécifiez un texte alternatif",
  imageLink: "Collez un lien pour ouvrir en cliquant sur l'image",
  target: "#ERROR!",
  tooltip: "Ajouter une vidéo",
  alignmentTooltip: "Aligner la vidéo sur {align}",
  wrapTooltip: "Aligner la vidéo sur {align}",
  editTitle: "Modifier la vidéo",
  embedTitle: "Incorporer la vidéo",
  convertLinkTitle: "Convertir en lien",
  validations: {
    src: "Une URL vidéo valide est nécessaire",
    width: "Largeur invalide fournie",
    height: "Hauteur invalide fournie",
    fileType: "Type de fichier invalide"
  },
  labels: {
    linkSource: "Source vidéo",
    width: "Largeur (px)",
    height: "Hauteur (px)",
    src: "URL de la vidéo",
    source_native: "Insérer à partir d'un lien",
    source_youtube: "Ajouter l'URL de Youtube"
  },
  placeholders: {
    src: "#ERROR!",
    width: "Largeur par défaut",
    height: "Hauteur par défaut",
    alt: "Spécifiez un texte alternatif",
    imageLink: "Collez un lien pour ouvrir en cliquant sur l'image",
    target: "#ERROR!"
  },
  updateVideo: "Mise à jour vidéo"
}, lN = {
  tooltip: "Ajouter la hauteur de ligne"
}, sN = {
  bulletListTooltip: "Ajouter une liste à puces",
  orderedListTooltip: "Ajouter une liste numérotée",
  taskListTooltip: "Ajouter une liste de tâches à faire",
  list: "La liste",
  circleList: "Liste circulaire",
  discList: "Liste des disques",
  squareList: "Liste carrée",
  upperAlphaList: "Liste Alpha Supérieure",
  upperRomanList: "Liste romaine supérieure",
  decimalList: "Liste décimale",
  lowerAlphaList: "Liste alphabétique inférieure",
  lowerGreekList: "Liste grecque inférieure",
  lowerRomanList: "Liste romaine inférieure"
}, uN = {
  formatAllTooltip: "Formater tout le document",
  formatSelectedTooltip: "Format sélectionné"
}, cN = {
  undo: "Annuler",
  redo: "Refaire"
}, dN = {
  alignTooltip: "Aligner le texte à {align}",
  subScript: "Sous-titre",
  superScript: "Super Script"
}, fN = {
  self: "soi",
  newWindow: "Nouvelle fenêtre",
  linkTitle: "Titre du lien",
  textNeeded: "Lien texte est nécessaire",
  invalidCustomLink: "Lien intégré personnalisé invalide"
}, pN = {
  textColor: "Couleur du texte",
  textHighlight: "Texte surligné"
}, hN = {
  paragraph: "paragraphe",
  heading1: "Titre 1",
  heading2: "Rubrique 2",
  heading3: "Titre 3",
  heading4: "En-tête 4",
  heading5: "Titre 5"
}, gN = {
  insertTable: "Insérer un tableau",
  deleteTable: "Supprimer le tableau",
  deleteColumn: "Supprimer la colonne",
  deleteRow: "Supprimer la ligne",
  addColumnBefore: "Ajouter une colonne avant",
  addColumnAfter: "Ajouter une colonne après",
  addRowBefore: "Ajouter une ligne avant",
  addRowAfter: "Ajouter une ligne après",
  mergeCell: "Fusionner les cellules",
  splitCell: "Diviser la cellule"
}, E9 = {
  common: rN,
  placeholders: nN,
  linkEmbed: oN,
  imageEmbed: iN,
  videoEmbed: aN,
  lineHeight: lN,
  list: sN,
  resetStyles: uN,
  history: cN,
  textAlign: dN,
  link: fN,
  color: pN,
  paragraph: hN,
  table: gN
}, L9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: pN,
  common: rN,
  default: E9,
  history: cN,
  imageEmbed: iN,
  lineHeight: lN,
  link: fN,
  linkEmbed: oN,
  list: sN,
  paragraph: hN,
  placeholders: nN,
  resetStyles: uN,
  table: gN,
  textAlign: dN,
  videoEmbed: aN
}, Symbol.toStringTag, { value: "Module" })), mN = {
  cancel: "Annulla",
  save: "Salvare",
  left: "Sinistra",
  right: "Destra",
  center: "Centro",
  justify: "giustificare",
  bold: "Audace",
  italic: "italico",
  strike: "Sciopero",
  underline: "Sottolinea",
  remove: "rimuovi",
  update: "Aggiornamento",
  action: "Action",
  blockquote: "Blockquote",
  code: "Code",
  fileUpload: "File Upload",
  invalidURL: "Invalid URL",
  url: "URL",
  valueMissing: "Value is missing",
  targetNeeded: "Target is needed",
  customControl: "Custom control",
  externalEmbed: "External Embed",
  invalidOption: "Invalid option provided",
  "Paste formatting options": "Incolla le opzioni di formattazione",
  pasteMessage: "Scegli di mantenere o rimuovere la formattazione nel contenuto incollato",
  keepFormatting: "Continua a formattare",
  removeFormatting: "Rimuovi formattazione"
}, vN = {
  fontFamily: "Famiglia di font",
  fontSize: "Dimensione carattere",
  lineHeight: "Altezza riga"
}, bN = {
  tooltip: "Aggiungi collegamento",
  title: "Incorpora link",
  urlFieldLabel: "Aggiungi URL",
  actionFieldLabel: "Selezionare azione",
  validations: {
    href: "È necessario un URL valido",
    target: "È necessario un obiettivo"
  }
}, MN = {
  tooltip: "Aggiungi immagine",
  alignmentTooltip: "Allineare immagine a {align}",
  wrapTooltip: "Inserisci immagine allineata a {align}",
  editTitle: "Modifica immagine",
  embedTitle: "Incorpora immagine",
  validations: {
    url: "È necessario un URL di immagine valido",
    width: "Larghezza non valida fornita",
    height: "Altezza fornita non valida",
    alt: "Per favore, specifica il testo alternativo",
    imageLink: "È necessario un URL valido",
    target: "Obiettivo non valido fornito"
  },
  labels: {
    url: "URL dell'immagine",
    width: "Imposta larghezza",
    height: "Altezza impostata",
    alt: "Testo alternativo",
    imageLink: "Immagine collegamento azione",
    target: "Apri link in",
    target_self: "Nella stessa finestra",
    target_blank: "Nella nuova finestra"
  },
  placeholders: {
    url: "Per favore inserisci un URL di immagine valido"
  },
  lockAspect: "Lock aspect ratio",
  unlockAspect: "Un-lock aspect ratio"
}, yN = {
  width: "automobile",
  height: "auto",
  alt: "Specifica un testo alternativo",
  imageLink: "Incolla un link da aprire cliccando sull'immagine",
  target: "ignorare",
  tooltip: "Aggiungi video",
  alignmentTooltip: "Allinea il video a {align}",
  wrapTooltip: "Includi il video in {align}",
  editTitle: "Modifica video",
  embedTitle: "Incorpora video",
  convertLinkTitle: "Converti in un collegamento",
  validations: {
    src: "È necessario un URL valido del video",
    width: "Larghezza non valida fornita",
    height: "Altezza non valida fornita",
    fileType: "Tipo di file non valido"
  },
  labels: {
    linkSource: "Sorgente del video",
    width: "Larghezza (px)",
    height: "altezza (px)",
    src: "URL del video",
    source_native: "Inserisci da un link",
    source_youtube: "Aggiungi URL di Youtube"
  },
  placeholders: {
    src: "ignorare",
    width: "Larghezza di default",
    height: "Altezza predefinita",
    alt: "Specificare un testo alternativo",
    imageLink: "Incolla un link per aprire cliccando sull'immagine",
    target: "ignorare"
  },
  updateVideo: "Update Video"
}, xN = {
  tooltip: "Aggiungi altezza riga"
}, wN = {
  bulletListTooltip: "Aggiungi elenco puntato",
  orderedListTooltip: "Aggiungi lista numerata",
  taskListTooltip: "Aggiungi lista di cose da fare",
  list: "List",
  circleList: "Circle List",
  discList: "Disc List",
  squareList: "Square List",
  upperAlphaList: "Upper Alpha List",
  upperRomanList: "Upper Roman List",
  decimalList: "Decimal List",
  lowerAlphaList: "Lower Alpha List",
  lowerGreekList: "Lower Greek List",
  lowerRomanList: "Lower Roman List"
}, TN = {
  formatAllTooltip: "Formatta tutto il documento",
  formatSelectedTooltip: "Formato selezionato"
}, NN = {
  undo: "Annulla",
  redo: "Rifare"
}, SN = {
  alignTooltip: "Allineare il testo a {align}",
  subScript: "Sub Script",
  superScript: "Super Script"
}, CN = {
  self: "Self",
  newWindow: "New window",
  linkTitle: "Link Title",
  textNeeded: "Link text is needed",
  invalidCustomLink: "Invalid custom embed link"
}, IN = {
  textColor: "Text Color",
  textHighlight: "Text Highlight"
}, AN = {
  paragraph: "Paragraph",
  heading1: "Heading 1",
  heading2: "Heading 2",
  heading3: "Heading 3",
  heading4: "Heading 4",
  heading5: "Heading 5"
}, DN = {
  insertTable: "Inserisci tabella",
  deleteTable: "Elimina tabella",
  deleteColumn: "Elimina colonna",
  deleteRow: "Elimina riga",
  addColumnBefore: "Aggiungi colonna prima",
  addColumnAfter: "Aggiungi colonna dopo",
  addRowBefore: "Aggiungi riga prima",
  addRowAfter: "Aggiungi riga dopo",
  mergeCell: "Unisci celle",
  splitCell: "Dividi cella"
}, $9 = {
  common: mN,
  placeholders: vN,
  linkEmbed: bN,
  imageEmbed: MN,
  videoEmbed: yN,
  lineHeight: xN,
  list: wN,
  resetStyles: TN,
  history: NN,
  textAlign: SN,
  link: CN,
  color: IN,
  paragraph: AN,
  table: DN
}, z9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: IN,
  common: mN,
  default: $9,
  history: NN,
  imageEmbed: MN,
  lineHeight: xN,
  link: CN,
  linkEmbed: bN,
  list: wN,
  paragraph: AN,
  placeholders: vN,
  resetStyles: TN,
  table: DN,
  textAlign: SN,
  videoEmbed: yN
}, Symbol.toStringTag, { value: "Module" })), kN = {
  cancel: "Annuleren",
  save: "Opslaan",
  left: "Links",
  right: "Juist",
  center: "Centrum",
  justify: "rechtvaardigen",
  bold: "Vetgedrukt",
  italic: "Schuingedrukt",
  strike: "Staking",
  underline: "Onderstrepen",
  remove: "Verwijderen",
  update: "Update",
  action: "Actie",
  blockquote: "Citaatblok",
  code: "Code",
  fileUpload: "Bestand uploaden",
  invalidURL: "Ongeldige URL",
  url: "URL - Uniform Resource Locator",
  valueMissing: "Waarde ontbreekt",
  targetNeeded: "Doelwit is nodig",
  customControl: "Aangepaste besturing",
  externalEmbed: "Externe Insluiting",
  invalidOption: "Ongeldige optie opgegeven",
  "Paste formatting options": "Opmaakopties plakken",
  pasteMessage: "Kies ervoor om de opmaak in de geplakte inhoud te behouden of te verwijderen",
  keepFormatting: "Blijf formatteren",
  removeFormatting: "Opmaak verwijderen"
}, EN = {
  fontFamily: "Lettertypefamilie",
  fontSize: "Lettergrootte",
  lineHeight: "Regelhoogte"
}, LN = {
  tooltip: "Voeg link toe",
  title: "Insluiten Link",
  urlFieldLabel: "Voeg URL toe",
  actionFieldLabel: "Selecteer actie",
  validations: {
    href: "Een geldige URL is vereist",
    target: "Er is een doelwit nodig"
  }
}, $N = {
  tooltip: "Voeg afbeelding toe",
  alignmentTooltip: "Uitlijnen afbeelding naar {align}",
  wrapTooltip: "Omhul afbeelding met {align}",
  editTitle: "Bewerk afbeelding",
  embedTitle: "Insluiten afbeelding",
  validations: {
    url: "Een geldige afbeeldings-URL is vereist",
    width: "Ongeldige breedte opgegeven",
    height: "Ongeldige hoogte opgegeven",
    alt: "Gelieve alternatieve tekst op te geven",
    imageLink: "Een geldige URL is vereist",
    target: "Ongeldige doelwit opgegeven"
  },
  labels: {
    url: "Beeld-URL",
    width: "Breedte instellen",
    height: "Stel hoogte in",
    alt: "Alternatieve tekst",
    imageLink: "Afbeelding Actie Link",
    target: "Open link in",
    target_self: "In hetzelfde venster",
    target_blank: "In het nieuwe venster"
  },
  placeholders: {
    url: "Voeg alstublieft een geldige afbeeldings-URL toe"
  },
  lockAspect: "Verhouding vergrendelen",
  unlockAspect: "Ontgrendel aspectverhouding"
}, zN = {
  width: "auto",
  height: "auto",
  alt: "Geef een alternatieve tekst op",
  imageLink: "Plak een link om te openen bij het klikken op de afbeelding",
  target: "ignore",
  tooltip: "Voeg video toe",
  alignmentTooltip: "Video uitlijnen op {align}",
  wrapTooltip: "Plaats video in {align}",
  editTitle: "Bewerk video",
  embedTitle: "Insluiten video",
  convertLinkTitle: "Converteren naar een link",
  validations: {
    src: "Een geldige video-URL is vereist",
    width: "Ongeldige breedte opgegeven",
    height: "Ongeldige hoogte opgegeven",
    fileType: "Ongeldig bestandstype"
  },
  labels: {
    linkSource: "Videobron",
    width: "Breedte (px)",
    height: "Hoogte (px)",
    src: "Videolink",
    source_native: "Invoegen vanuit een link",
    source_youtube: "Voeg Youtube URL toe"
  },
  placeholders: {
    src: "ignore",
    width: "Standaard breedte",
    height: "Standaardhoogte",
    alt: "Geef een alternatieve tekst op",
    imageLink: "Plak een link om te openen bij het klikken op de afbeelding",
    target: "ignore"
  },
  updateVideo: "Bijwerken video"
}, ON = {
  tooltip: "Voeg regelhoogte toe"
}, jN = {
  bulletListTooltip: "Voeg opsommingstekens toe",
  orderedListTooltip: "Voeg genummerde lijst toe",
  taskListTooltip: "Voeg takenlijst toe",
  list: "Lijst",
  circleList: "Cirkellijst",
  discList: "Schijflijst",
  squareList: "Vierkante lijst",
  upperAlphaList: "Bovenaan Alpha Lijst",
  upperRomanList: "Bovenaan Romeinse lijst",
  decimalList: "Decimale lijst",
  lowerAlphaList: "Lagere alfabetische lijst",
  lowerGreekList: "Lager Griekse Lijst",
  lowerRomanList: "Lagere Romeinse lijst"
}, RN = {
  formatAllTooltip: "Formatteer het hele document",
  formatSelectedTooltip: "Geselecteerd formaat"
}, _N = {
  undo: "Ongedaan maken",
  redo: "Opnieuw doen"
}, PN = {
  alignTooltip: "Tekst uitlijnen naar {align}",
  subScript: "Sub Script   Dutch translation: Onderstrepingsteken (or) Subscriptie",
  superScript: "Super Script"
}, BN = {
  self: "Zelf",
  newWindow: "Nieuw venster",
  linkTitle: "Link titel",
  textNeeded: "Linktekst is nodig",
  invalidCustomLink: "Ongeldige aangepaste embed-link"
}, FN = {
  textColor: "Tekstkleur",
  textHighlight: "Tekst markeren"
}, UN = {
  paragraph: "Paragraaf",
  heading1: "Kop 1",
  heading2: "Kop 2",
  heading3: "Koptekst 3",
  heading4: "Kop 4",
  heading5: "Kop 5"
}, HN = {
  insertTable: "Tabel invoegen",
  deleteTable: "Tabel verwijderen",
  deleteColumn: "Kolom verwijderen",
  deleteRow: "Rij verwijderen",
  addColumnBefore: "Kolom toevoegen voor",
  addColumnAfter: "Kolom toevoegen na",
  addRowBefore: "Rij toevoegen voor",
  addRowAfter: "Rij toevoegen na",
  mergeCell: "Cellen samenvoegen",
  splitCell: "Cel splitsen"
}, O9 = {
  common: kN,
  placeholders: EN,
  linkEmbed: LN,
  imageEmbed: $N,
  videoEmbed: zN,
  lineHeight: ON,
  list: jN,
  resetStyles: RN,
  history: _N,
  textAlign: PN,
  link: BN,
  color: FN,
  paragraph: UN,
  table: HN
}, j9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: FN,
  common: kN,
  default: O9,
  history: _N,
  imageEmbed: $N,
  lineHeight: ON,
  link: BN,
  linkEmbed: LN,
  list: jN,
  paragraph: UN,
  placeholders: EN,
  resetStyles: RN,
  table: HN,
  textAlign: PN,
  videoEmbed: zN
}, Symbol.toStringTag, { value: "Module" })), YN = {
  cancel: "Avbryte",
  save: "Lagre",
  left: "Venstre",
  right: "Riktig",
  center: "Senter",
  justify: "retteferdiggjøre",
  bold: "Modig",
  italic: "Kursiv",
  strike: "Streik",
  underline: "Understrek",
  remove: "Fjerne",
  update: "Oppdatering",
  action: "Handling",
  blockquote: "Blockquote",
  code: "Kode",
  fileUpload: "Filopplasting",
  invalidURL: "Ugyldig URL",
  url: "nettadresse",
  valueMissing: "Verdi mangler",
  targetNeeded: "Målet er nødvendig",
  customControl: "Tilpasset kontroll",
  externalEmbed: "Ekstern innbygging",
  invalidOption: "Ugyldig valg gitt",
  "Paste formatting options": "Lim inn formateringsalternativer",
  pasteMessage: "Velg å beholde eller fjerne formateringen i det limte innholdet",
  keepFormatting: "Fortsett å formatere",
  removeFormatting: "Fjern formatering"
}, WN = {
  fontFamily: "Skriftfamilie",
  fontSize: "Skriftstørrelse",
  lineHeight: "Linjehøyde"
}, QN = {
  tooltip: "Legg til lenke",
  title: "Innbettet lenke",
  urlFieldLabel: "Legg til URL",
  actionFieldLabel: "Velg handling",
  validations: {
    href: "Gyldig URL er nødvendig",
    target: "Mål er nødvendig"
  }
}, VN = {
  tooltip: "Legg til bilde",
  alignmentTooltip: "Juster bilde til {align}",
  wrapTooltip: "Omslutt bilde til {align}",
  editTitle: "Rediger bilde",
  embedTitle: "Innbettet bilde",
  validations: {
    url: "Gyldig bilde-URL er nødvendig",
    width: "Ugyldig bredde oppgitt",
    height: "Ugyldig høyde oppgitt",
    alt: "Vennligst spesifiser alternativ tekst",
    imageLink: "En gyldig URL er nødvendig",
    target: "Ugyldig mål gitt"
  },
  labels: {
    url: "Bilde-URL",
    width: "Sett bredde",
    height: "Sett høyde",
    alt: "Alternativ tekst",
    imageLink: "Bildehandlingslenke",
    target: "Åpne lenke i",
    target_self: "I samme vindu",
    target_blank: "I det nye vinduet"
  },
  placeholders: {
    url: "Vennligst legg til en gyldig bilde-URL"
  },
  lockAspect: "Lås sideforhold",
  unlockAspect: "Lås opp sideforhold"
}, ZN = {
  width: "bil",
  height: "bil",
  alt: "Angi en alternativ tekst",
  imageLink: "Lim inn en lenke for å åpne ved å klikke på bilde",
  target: "ignorere",
  tooltip: "Legg til video",
  alignmentTooltip: "Juster videoen til {align}",
  wrapTooltip: "Pakk inn video til {align}",
  editTitle: "Rediger video",
  embedTitle: "Bygg inn video",
  convertLinkTitle: "Konverter til en lenke",
  validations: {
    src: "Gyldig videolenke kreves",
    width: "Ugyldig bredde angitt",
    height: "Ugyldig høyde oppgitt",
    fileType: "Ugyldig filtype"
  },
  labels: {
    linkSource: "Video kilde",
    width: "Bredde (px)",
    height: "Høyde (px)",
    src: "Video-URL",
    source_native: "Sett inn fra en lenke",
    source_youtube: "Legg til YouTube-URL"
  },
  placeholders: {
    src: "ignorere",
    width: "Standardbredde",
    height: "Standard høyde",
    alt: "Angi en alternativ tekst",
    imageLink: "Lim inn en lenke for å åpne ved å klikke på bildet",
    target: "ignorere"
  },
  updateVideo: "Oppdater video"
}, GN = {
  tooltip: "Legg til linjehøyde"
}, KN = {
  bulletListTooltip: "Legg til punktliste",
  orderedListTooltip: "Legg til nummerert liste",
  taskListTooltip: "Legg til gjøremålsliste",
  list: "Liste",
  circleList: "Sirkelliste",
  discList: "Plateoversikt",
  squareList: "Kvadratisk liste",
  upperAlphaList: "Øvre alfabetliste",
  upperRomanList: "Øvre romersk liste",
  decimalList: "liste",
  lowerAlphaList: "Nedre alfabetiske liste",
  lowerGreekList: "Lavere greskliste",
  lowerRomanList: "Lavere romersk liste"
}, qN = {
  formatAllTooltip: "Formatere hele dokumentet",
  formatSelectedTooltip: "Format valgt"
}, JN = {
  undo: "Angre",
  redo: "Gjøre om"
}, XN = {
  alignTooltip: "Juster tekst til {align}",
  subScript: "Undertekst",
  superScript: "Overordnet skrift"
}, eS = {
  self: "Selv",
  newWindow: "Nytt vindu",
  linkTitle: "Link Tittel",
  textNeeded: "Det trengs en koblingstekst",
  invalidCustomLink: "Ugyldig tilpasset innebyggingslink"
}, tS = {
  textColor: "Tekstfarge",
  textHighlight: "Tekstmarkering"
}, rS = {
  paragraph: "Avsnitt",
  heading1: "Overskrift 1",
  heading2: "Overskrift 2",
  heading3: "Overskrift 3",
  heading4: "Overskrift 4",
  heading5: "Overskrift 5"
}, nS = {
  insertTable: "Sett inn tabell",
  deleteTable: "Slett tabell",
  deleteColumn: "Slett kolonne",
  deleteRow: "Slett rad",
  addColumnBefore: "Legg til kolonne før",
  addColumnAfter: "Legg til kolonne etter",
  addRowBefore: "Legg til rad før",
  addRowAfter: "Legg til rad etter",
  mergeCell: "Slå sammen celler",
  splitCell: "Del celle"
}, R9 = {
  common: YN,
  placeholders: WN,
  linkEmbed: QN,
  imageEmbed: VN,
  videoEmbed: ZN,
  lineHeight: GN,
  list: KN,
  resetStyles: qN,
  history: JN,
  textAlign: XN,
  link: eS,
  color: tS,
  paragraph: rS,
  table: nS
}, _9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: tS,
  common: YN,
  default: R9,
  history: JN,
  imageEmbed: VN,
  lineHeight: GN,
  link: eS,
  linkEmbed: QN,
  list: KN,
  paragraph: rS,
  placeholders: WN,
  resetStyles: qN,
  table: nS,
  textAlign: XN,
  videoEmbed: ZN
}, Symbol.toStringTag, { value: "Module" })), oS = {
  cancel: "Cancelar",
  save: "Salvar",
  left: "Esquerda",
  right: "Certo",
  center: "Centro",
  justify: "Justificar",
  bold: "Negrito",
  italic: "Texto em itálico",
  strike: "Greve",
  underline: "Sublinhar",
  remove: "Remover",
  update: "Atualização",
  action: "Ação",
  blockquote: "Citação de bloco",
  code: "Código",
  fileUpload: "Envio de Arquivo",
  invalidURL: "URL inválida",
  url: "URL",
  valueMissing: "Valor está faltando",
  targetNeeded: "Alvo é necessário",
  customControl: "Controle personalizado",
  externalEmbed: "Incorporação externa",
  invalidOption: "Opção inválida fornecida",
  "Paste formatting options": "Colar opções de formatação",
  pasteMessage: "Escolha manter ou remover a formatação do conteúdo colado",
  keepFormatting: "Continue formatando",
  removeFormatting: "Remover formatação"
}, iS = {
  fontFamily: "Família de fontes",
  fontSize: "Tamanho da fonte",
  lineHeight: "Altura da linha"
}, aS = {
  tooltip: "Adicionar link",
  title: "Link de incorporação",
  urlFieldLabel: "Adicionar URL",
  actionFieldLabel: "Selecionar Ação",
  validations: {
    href: "É necessário um URL válido",
    target: "É necessário um alvo"
  }
}, lS = {
  tooltip: "Adicionar imagem",
  alignmentTooltip: "Alinhar imagem para {align}",
  wrapTooltip: "Envolver imagem em {align}",
  editTitle: "Editar imagem",
  embedTitle: "Incorporar imagem",
  validations: {
    url: "É necessário um URL de imagem válido",
    width: "Largura inválida fornecida",
    height: "Altura fornecida inválida",
    alt: "Por favor, especifique um texto alternativo",
    imageLink: "É necessário um URL válido",
    target: "Alvo inválido fornecido"
  },
  labels: {
    url: "URL da imagem",
    width: "Largura definida",
    height: "Definir altura",
    alt: "Texto alternativo",
    imageLink: "Link de Ação da Imagem",
    target: "Abrir link em",
    target_self: "Na mesma janela",
    target_blank: "Na nova janela"
  },
  placeholders: {
    url: "Por favor, adicione uma URL de imagem válida"
  },
  lockAspect: "Bloquear proporção de aspecto",
  unlockAspect: "Desbloquear proporção de aspecto"
}, sS = {
  width: "auto",
  height: "auto",
  alt: "Especifique um texto alternativo",
  imageLink: "Cole um link para abrir ao clicar na imagem",
  target: "ignorar",
  tooltip: "Adicionar vídeo",
  alignmentTooltip: "Alinhar vídeo para {align}",
  wrapTooltip: "Encaixar vídeo em {align}",
  editTitle: "Editar vídeo",
  embedTitle: "Incorporar vídeo",
  convertLinkTitle: "Converter em um link",
  validations: {
    src: "É necessário um URL de vídeo válido",
    width: "Largura inválida fornecida",
    height: "Altura fornecida inválida",
    fileType: "Tipo de arquivo inválido"
  },
  labels: {
    linkSource: "Fonte do vídeo",
    width: "Largura (px)",
    height: "Altura (px)",
    src: "URL do vídeo",
    source_native: "Inserir a partir de um link",
    source_youtube: "Adicionar URL do Youtube"
  },
  placeholders: {
    src: "ignorar",
    width: "Largura padrão",
    height: "Altura padrão",
    alt: "Especifique um texto alternativo",
    imageLink: "Cole um link para abrir ao clicar na imagem",
    target: "ignorar"
  },
  updateVideo: "Atualizar vídeo"
}, uS = {
  tooltip: "Adicionar altura de linha"
}, cS = {
  bulletListTooltip: "Adicionar lista com marcadores",
  orderedListTooltip: "Adicionar Lista Numerada",
  taskListTooltip: "Adicionar Lista de Tarefas",
  list: "Lista",
  circleList: "Lista de Círculo",
  discList: "Lista de discos",
  squareList: "Lista Quadrada",
  upperAlphaList: "Lista Alfabética Superior",
  upperRomanList: "Lista Romana Superior",
  decimalList: "Lista Decimal",
  lowerAlphaList: "Lista Alfabética Inferior",
  lowerGreekList: "Lista em grego inferior",
  lowerRomanList: "Lista em Romano Minúsculo"
}, dS = {
  formatAllTooltip: "Formate todo o documento",
  formatSelectedTooltip: "Formato selecionado"
}, fS = {
  undo: "Desfazer",
  redo: "Refazer"
}, pS = {
  alignTooltip: "Alinhar texto para {align}",
  subScript: "Subscrito",
  superScript: "Super Script"
}, hS = {
  self: "Eu mesmo or Mulher",
  newWindow: "Nova janela",
  linkTitle: "Título do Link",
  textNeeded: "Link de texto é necessário",
  invalidCustomLink: "Link personalizado inválido"
}, gS = {
  textColor: "Cor da fonte",
  textHighlight: "Destaque de texto"
}, mS = {
  paragraph: "Parágrafo",
  heading1: "Título 1",
  heading2: "Título 2",
  heading3: "Título 3",
  heading4: "Título 4",
  heading5: "Titulo 5"
}, vS = {
  insertTable: "Inserir Tabela",
  deleteTable: "Excluir Tabela",
  deleteColumn: "Excluir Coluna",
  deleteRow: "Excluir Linha",
  addColumnBefore: "Adicionar Coluna Antes",
  addColumnAfter: "Adicionar Coluna Depois",
  addRowBefore: "Adicionar Linha Antes",
  addRowAfter: "Adicionar Linha Depois",
  mergeCell: "Mesclar Células",
  splitCell: "Dividir Célula"
}, P9 = {
  common: oS,
  placeholders: iS,
  linkEmbed: aS,
  imageEmbed: lS,
  videoEmbed: sS,
  lineHeight: uS,
  list: cS,
  resetStyles: dS,
  history: fS,
  textAlign: pS,
  link: hS,
  color: gS,
  paragraph: mS,
  table: vS
}, B9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: gS,
  common: oS,
  default: P9,
  history: fS,
  imageEmbed: lS,
  lineHeight: uS,
  link: hS,
  linkEmbed: aS,
  list: cS,
  paragraph: mS,
  placeholders: iS,
  resetStyles: dS,
  table: vS,
  textAlign: pS,
  videoEmbed: sS
}, Symbol.toStringTag, { value: "Module" })), bS = {
  cancel: "Cancelar",
  save: "Guardar",
  left: "Esquerda",
  right: "Certo",
  center: "Centro",
  justify: "Justificar",
  bold: "Negrito",
  italic: "Texto em itálico",
  strike: "Greve",
  underline: "Sublinhar",
  remove: "Remover",
  update: "Atualização",
  action: "Ação",
  blockquote: "Citação em bloco",
  code: "Código",
  fileUpload: "Transferência de ficheiro",
  invalidURL: "URL inválido",
  url: "endereço URL",
  valueMissing: "Falta valor",
  targetNeeded: "É necessário um alvo",
  customControl: "Controlo personalizado",
  externalEmbed: "Incorporação Externa",
  invalidOption: "Opção inválida fornecida",
  "Paste formatting options": "Colar opções de formatação",
  pasteMessage: "Escolha manter ou remover a formatação do conteúdo colado",
  keepFormatting: "Continue formatando",
  removeFormatting: "Remover formatação"
}, MS = {
  fontFamily: "Família de fontes",
  fontSize: "Tamanho da fonte",
  lineHeight: "Altura da linha"
}, yS = {
  tooltip: "Adicionar Link",
  title: "Incorporar Link",
  urlFieldLabel: "Adicionar URL",
  actionFieldLabel: "Selecionar Ação",
  validations: {
    href: "É necessário um URL válido",
    target: "É necessário um alvo"
  }
}, xS = {
  tooltip: "Adicionar imagem",
  alignmentTooltip: "Alinhar imagem para {align}",
  wrapTooltip: "Envolver imagem em {align}",
  editTitle: "Editar imagem",
  embedTitle: "Incorporar imagem",
  validations: {
    url: "É necessário um URL de imagem válido",
    width: "Largura inválida fornecida",
    height: "Altura inválida fornecida",
    alt: "Por favor, especifique um texto alternativo",
    imageLink: "É necessário um URL válido",
    target: "Alvo inválido fornecido"
  },
  labels: {
    url: "URL da imagem",
    width: "Largura definida",
    height: "Definir Altura",
    alt: "Texto alternativo",
    imageLink: "Ligação de Ação de Imagem",
    target: "Abrir ligação em",
    target_self: "Na mesma janela",
    target_blank: "Na nova janela"
  },
  placeholders: {
    url: "Por favor, adicione um URL de imagem válido"
  },
  lockAspect: "Bloquear proporção de aspecto",
  unlockAspect: "De-stravar relação de aspecto"
}, wS = {
  width: "auto",
  height: "auto",
  alt: "Especificar um texto alternativo",
  imageLink: "Cole um link para abrir ao clicar na imagem",
  target: "ignore",
  tooltip: "Adicionar vídeo",
  alignmentTooltip: "Alinhar vídeo para {align}",
  wrapTooltip: "Encaixar vídeo em {align}",
  editTitle: "Editar vídeo",
  embedTitle: "Incorporar vídeo",
  convertLinkTitle: "Converter em um link",
  validations: {
    src: "É necessário um URL de vídeo válido",
    width: "Largura inválida fornecida",
    height: "Altura inválida fornecida",
    fileType: "Tipo de ficheiro inválido"
  },
  labels: {
    linkSource: "Fonte de vídeo",
    width: "Largura (px)",
    height: "Altura (px)",
    src: "URL do vídeo",
    source_native: "Inserir a partir de um link",
    source_youtube: "Adicionar URL do Youtube"
  },
  placeholders: {
    src: "ignore",
    width: "Largura padrão",
    height: "Altura padrão",
    alt: "Especificar um texto alternativo",
    imageLink: "Cole um link para abrir ao clicar na imagem",
    target: "ignore"
  },
  updateVideo: "Atualizar Vídeo"
}, TS = {
  tooltip: "Adicionar altura de linha"
}, NS = {
  bulletListTooltip: "Adicionar lista com marcadores",
  orderedListTooltip: "Adicionar Lista Numerada",
  taskListTooltip: "Adicionar Lista de Tarefas",
  list: "Lista",
  circleList: "Lista de Círculo",
  discList: "Lista de discos",
  squareList: "Lista Quadrada",
  upperAlphaList: "Lista de Alfa Superior",
  upperRomanList: "Lista Romana Superior",
  decimalList: "Lista Decimal",
  lowerAlphaList: "Lista Alfabética Inferior",
  lowerGreekList: "Lista grega inferior",
  lowerRomanList: "Lista Romana Inferior"
}, SS = {
  formatAllTooltip: "Formatar todo o documento",
  formatSelectedTooltip: "Formato selecionado"
}, CS = {
  undo: "Desfazer",
  redo: "Refazer"
}, IS = {
  alignTooltip: "Alinhar texto para {align}",
  subScript: "Subscripto",
  superScript: "Super Roteiro"
}, AS = {
  self: "eu mesmo",
  newWindow: "Nova janela",
  linkTitle: "Título do Link",
  textNeeded: "É necessário um texto de ligação",
  invalidCustomLink: "Link personalizado inválido"
}, DS = {
  textColor: "Cor de Texto",
  textHighlight: "Destaque de texto"
}, kS = {
  paragraph: "Parágrafo",
  heading1: "Titulo 1",
  heading2: "Título 2",
  heading3: "Título 3",
  heading4: "Título 4",
  heading5: "Título de Nível 5"
}, ES = {
  insertTable: "Inserir Tabela",
  deleteTable: "Eliminar Tabela",
  deleteColumn: "Eliminar Coluna",
  deleteRow: "Eliminar Linha",
  addColumnBefore: "Adicionar Coluna Antes",
  addColumnAfter: "Adicionar Coluna Depois",
  addRowBefore: "Adicionar Linha Antes",
  addRowAfter: "Adicionar Linha Depois",
  mergeCell: "Unir Células",
  splitCell: "Dividir Célula"
}, F9 = {
  common: bS,
  placeholders: MS,
  linkEmbed: yS,
  imageEmbed: xS,
  videoEmbed: wS,
  lineHeight: TS,
  list: NS,
  resetStyles: SS,
  history: CS,
  textAlign: IS,
  link: AS,
  color: DS,
  paragraph: kS,
  table: ES
}, U9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: DS,
  common: bS,
  default: F9,
  history: CS,
  imageEmbed: xS,
  lineHeight: TS,
  link: AS,
  linkEmbed: yS,
  list: NS,
  paragraph: kS,
  placeholders: MS,
  resetStyles: SS,
  table: ES,
  textAlign: IS,
  videoEmbed: wS
}, Symbol.toStringTag, { value: "Module" })), LS = {
  cancel: "Avbryt",
  save: "Spara",
  left: "Vänster",
  right: "Rätt",
  center: "Centrum",
  justify: "motivera",
  bold: "Djärv",
  italic: "kursiv",
  strike: "Strejk",
  underline: "Understryk",
  remove: "Ta bort",
  update: "Uppdatering",
  action: "Handling",
  blockquote: "Blockcitat",
  code: "Kod",
  fileUpload: "Filöverföring",
  invalidURL: "Ogiltig URL",
  url: "Uniform Resource Locator",
  valueMissing: "Värdet saknas",
  targetNeeded: "Målet behövs",
  customControl: "Anpassad kontroll",
  externalEmbed: "Extern inbäddning",
  invalidOption: "Ogiltigt alternativ angetts",
  "Paste formatting options": "Klistra in formateringsalternativ",
  pasteMessage: "Välj att behålla eller ta bort formateringen i det inklistrade innehållet",
  keepFormatting: "Fortsätt formatera",
  removeFormatting: "Ta bort formatering"
}, $S = {
  fontFamily: "Typsnittsfamilj",
  fontSize: "Teckenstorlek",
  lineHeight: "Radavstånd"
}, zS = {
  tooltip: "Lägg till länk",
  title: "Bädda in länk",
  urlFieldLabel: "Lägg till URL",
  actionFieldLabel: "Välj Åtgärd",
  validations: {
    href: "En giltig URL behövs",
    target: "Målintresse behövs"
  }
}, OS = {
  tooltip: "Lägg till bild",
  alignmentTooltip: "Justera bild till {align}",
  wrapTooltip: "Omslut bild till {align}",
  editTitle: "Redigera bild",
  embedTitle: "Bädda in bild",
  validations: {
    url: "Giltig bild-URL krävs",
    width: "Ogiltig bredd angiven",
    height: "Ogiltig höjd angiven",
    alt: "Ange alternativ text, tack",
    imageLink: "En giltig URL krävs",
    target: "Ogiltigt mål angivet"
  },
  labels: {
    url: "Bild-URL",
    width: "Sätt bredd",
    height: "Sätt höjd",
    alt: "Alternativtext",
    imageLink: "Bildåtgärds länk",
    target: "Öppna länk i",
    target_self: "I samma fönster",
    target_blank: "I det nya fönstret"
  },
  placeholders: {
    url: "Var god lägg till en giltig bild-URL"
  },
  lockAspect: "Lås sidoförhållande",
  unlockAspect: "Lås upp aspektratio"
}, jS = {
  width: "bil",
  height: "bil",
  alt: "Specificera en alternativ text",
  imageLink: "Klistra in en länk för att öppna vid klick på bild",
  target: "ignorera",
  tooltip: "Lägg till video",
  alignmentTooltip: "Justera video till {align}",
  wrapTooltip: "Omslut video till {align}",
  editTitle: "Redigera video",
  embedTitle: "Bädda in video",
  convertLinkTitle: "Konvertera till en länk",
  validations: {
    src: "En giltig videolänk behövs",
    width: "Ogiltig bredd angiven",
    height: "Ogiltig höjd angiven",
    fileType: "Ogiltig filtyp"
  },
  labels: {
    linkSource: "Videokälla",
    width: "Bredd (px)",
    height: "Höjd (px)",
    src: "Videolänk",
    source_native: "Infoga från en länk",
    source_youtube: "Lägg till Youtube-URL"
  },
  placeholders: {
    src: "ignorera",
    width: "Standardbredd",
    height: "Standardhöjd",
    alt: "Ange en alternativ text",
    imageLink: "Klistra in en länk för att öppnas vid klick på bild",
    target: "ignorera"
  },
  updateVideo: "Uppdateringsvideo"
}, RS = {
  tooltip: "Lägg till radhöjd"
}, _S = {
  bulletListTooltip: "Lägg till punktlista",
  orderedListTooltip: "Lägg till numrerad lista",
  taskListTooltip: "Lägg till att göra-lista",
  list: "Lista",
  circleList: "Cirkellista",
  discList: "Skivlista",
  squareList: "Kvadratlista",
  upperAlphaList: "Övre alfabetlista",
  upperRomanList: "Övre romersk lista",
  decimalList: "Decimal lista",
  lowerAlphaList: "Nedre alfabetisk lista",
  lowerGreekList: "Lägre grekisk lista",
  lowerRomanList: "Lägre romersk lista"
}, PS = {
  formatAllTooltip: "Formatera hela dokumentet",
  formatSelectedTooltip: "Valt format"
}, BS = {
  undo: "Ångra",
  redo: "Klar"
}, FS = {
  alignTooltip: "Justera text till {align}",
  subScript: "Undertext",
  superScript: "höjdtecken"
}, US = {
  self: "Själv",
  newWindow: "Nytt fönster",
  linkTitle: "Länktitel",
  textNeeded: "Länktext krävs",
  invalidCustomLink: "Ogiltig anpassad inbäddningslänk"
}, HS = {
  textColor: "Textfärg",
  textHighlight: "Textmarkering"
}, YS = {
  paragraph: "Stycke",
  heading1: "Rubrik 1",
  heading2: "Rubrik 2",
  heading3: "Rubrik 3",
  heading4: "Rubrik 4",
  heading5: "Rubrik 5"
}, WS = {
  insertTable: "Infoga tabell",
  deleteTable: "Radera tabell",
  deleteColumn: "Radera kolumn",
  deleteRow: "Radera rad",
  addColumnBefore: "Lägg till kolumn före",
  addColumnAfter: "Lägg till kolumn efter",
  addRowBefore: "Lägg till rad före",
  addRowAfter: "Lägg till rad efter",
  mergeCell: "Sammanfoga celler",
  splitCell: "Dela cell"
}, H9 = {
  common: LS,
  placeholders: $S,
  linkEmbed: zS,
  imageEmbed: OS,
  videoEmbed: jS,
  lineHeight: RS,
  list: _S,
  resetStyles: PS,
  history: BS,
  textAlign: FS,
  link: US,
  color: HS,
  paragraph: YS,
  table: WS
}, Y9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color: HS,
  common: LS,
  default: H9,
  history: BS,
  imageEmbed: OS,
  lineHeight: RS,
  link: US,
  linkEmbed: zS,
  list: _S,
  paragraph: YS,
  placeholders: $S,
  resetStyles: PS,
  table: WS,
  textAlign: FS,
  videoEmbed: jS
}, Symbol.toStringTag, { value: "Module" }));
var pt = /* @__PURE__ */ ((e) => (e.English_US = "en-US", e.Danish = "da", e.German = "de", e.Spanish = "es", e.Finnish = "fi", e.French_CA = "fr-CA", e.French_FR = "fr-FR", e.Italian = "it", e.Dutch = "nl", e.Norwegian = "no", e.Portuguese_BR = "pt-BR", e.Portuguese_PT = "pt-PT", e.Swedish = "sv", e))(pt || {});
const ht = {
  "en-US": N9,
  da: y9,
  de: w9,
  es: C9,
  fi: A9,
  "fr-CA": k9,
  "fr-FR": L9,
  it: z9,
  nl: j9,
  no: _9,
  "pt-BR": B9,
  "pt-PT": U9,
  sv: Y9
};
function Wb(e) {
  Et("language", e), Et("locale", ht[e]);
}
var Zs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function QS(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sp = { exports: {} }, up = { exports: {} }, cp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(a) {
      return typeof a;
    } : r = function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, r(o);
  }
  function n(o) {
    var i = typeof o == "string" || o instanceof String;
    if (!i) {
      var a = r(o);
      throw o === null ? a = "null" : a === "object" && (a = o.constructor.name), new TypeError("Expected a string but received a ".concat(a));
    }
  }
  e.exports = t.default, e.exports.default = t.default;
})(cp, cp.exports);
var he = cp.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i), i = Date.parse(i), isNaN(i) ? null : new Date(i);
  }
  e.exports = t.default, e.exports.default = t.default;
})(up, up.exports);
var Bm = up.exports, dp = { exports: {} }, ka = {}, St = {};
Object.defineProperty(St, "__esModule", {
  value: !0
});
St.commaDecimal = St.dotDecimal = St.bengaliLocales = St.farsiLocales = St.arabicLocales = St.englishLocales = St.decimal = St.alphanumeric = St.alpha = void 0;
var yr = {
  "en-US": /^[A-Z]+$/i,
  "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  "fi-FI": /^[A-ZÅÄÖ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๐\s]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
  "si-LK": /^[\u0D80-\u0DFF]+$/
};
St.alpha = yr;
var xr = {
  "en-US": /^[0-9A-Z]+$/i,
  "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๙\s]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
  "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
St.alphanumeric = xr;
var ur = {
  "en-US": ".",
  ar: "٫"
};
St.decimal = ur;
var fp = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
St.englishLocales = fp;
for (var Gs, Gd = 0; Gd < fp.length; Gd++)
  Gs = "en-".concat(fp[Gd]), yr[Gs] = yr["en-US"], xr[Gs] = xr["en-US"], ur[Gs] = ur["en-US"];
var pp = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
St.arabicLocales = pp;
for (var Ks, Kd = 0; Kd < pp.length; Kd++)
  Ks = "ar-".concat(pp[Kd]), yr[Ks] = yr.ar, xr[Ks] = xr.ar, ur[Ks] = ur.ar;
var hp = ["IR", "AF"];
St.farsiLocales = hp;
for (var qd, Jd = 0; Jd < hp.length; Jd++)
  qd = "fa-".concat(hp[Jd]), xr[qd] = xr.fa, ur[qd] = ur.ar;
var gp = ["BD", "IN"];
St.bengaliLocales = gp;
for (var qs, Xd = 0; Xd < gp.length; Xd++)
  qs = "bn-".concat(gp[Xd]), yr[qs] = yr.bn, xr[qs] = xr.bn, ur[qs] = ur["en-US"];
var mp = ["ar-EG", "ar-LB", "ar-LY"];
St.dotDecimal = mp;
var vp = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"];
St.commaDecimal = vp;
for (var ef = 0; ef < mp.length; ef++)
  ur[mp[ef]] = ur["en-US"];
for (var tf = 0; tf < vp.length; tf++)
  ur[vp[tf]] = ",";
yr["fr-CA"] = yr["fr-FR"];
xr["fr-CA"] = xr["fr-FR"];
yr["pt-BR"] = yr["pt-PT"];
xr["pt-BR"] = xr["pt-PT"];
ur["pt-BR"] = ur["pt-PT"];
yr["pl-Pl"] = yr["pl-PL"];
xr["pl-Pl"] = xr["pl-PL"];
ur["pl-Pl"] = ur["pl-PL"];
yr["fa-AF"] = yr.fa;
Object.defineProperty(ka, "__esModule", {
  value: !0
});
ka.default = V9;
ka.locales = void 0;
var W9 = Q9(he), VS = St;
function Q9(e) {
  return e && e.__esModule ? e : { default: e };
}
function V9(e, t) {
  (0, W9.default)(e), t = t || {};
  var r = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(t.locale ? VS.decimal[t.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (e === "" || e === "." || e === "," || e === "-" || e === "+")
    return !1;
  var n = parseFloat(e.replace(",", "."));
  return r.test(e) && (!t.hasOwnProperty("min") || n >= t.min) && (!t.hasOwnProperty("max") || n <= t.max) && (!t.hasOwnProperty("lt") || n < t.lt) && (!t.hasOwnProperty("gt") || n > t.gt);
}
var Z9 = Object.keys(VS.decimal);
ka.locales = Z9;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(ka);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i) ? parseFloat(i) : NaN;
  }
  e.exports = t.default, e.exports.default = t.default;
})(dp, dp.exports);
var ZS = dp.exports, bp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    return (0, r.default)(i), parseInt(i, a || 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(bp, bp.exports);
var G9 = bp.exports, Mp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    return (0, r.default)(i), a ? i === "1" || /^true$/i.test(i) : i !== "0" && !/^false$/i.test(i) && i !== "";
  }
  e.exports = t.default, e.exports.default = t.default;
})(Mp, Mp.exports);
var K9 = Mp.exports, yp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    return (0, r.default)(i), i === a;
  }
  e.exports = t.default, e.exports.default = t.default;
})(yp, yp.exports);
var q9 = yp.exports, xp = { exports: {} }, wp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function r(o) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(a) {
      return typeof a;
    } : r = function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, r(o);
  }
  function n(o) {
    return r(o) === "object" && o !== null ? typeof o.toString == "function" ? o = o.toString() : o = "[object Object]" : (o === null || typeof o > "u" || isNaN(o) && !o.length) && (o = ""), String(o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(wp, wp.exports);
var GS = wp.exports, Tp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
    for (var i in o)
      typeof n[i] > "u" && (n[i] = o[i]);
    return n;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Tp, Tp.exports);
var Tr = Tp.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = i(he), n = i(GS), o = i(Tr);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var a = {
    ignoreCase: !1,
    minOccurrences: 1
  };
  function l(s, c, u) {
    return (0, r.default)(s), u = (0, o.default)(u, a), u.ignoreCase ? s.toLowerCase().split((0, n.default)(c).toLowerCase()).length > u.minOccurrences : s.split((0, n.default)(c)).length > u.minOccurrences;
  }
  e.exports = t.default, e.exports.default = t.default;
})(xp, xp.exports);
var J9 = xp.exports, Np = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a, l) {
    return (0, r.default)(i), Object.prototype.toString.call(a) !== "[object RegExp]" && (a = new RegExp(a, l)), !!i.match(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Np, Np.exports);
var X9 = Np.exports, Sp = { exports: {} }, Cp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(s) {
      return typeof s;
    } : o = function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, o(a);
  }
  function i(a, l) {
    (0, r.default)(a);
    var s, c;
    o(l) === "object" ? (s = l.min || 0, c = l.max) : (s = arguments[1], c = arguments[2]);
    var u = encodeURI(a).split(/%..|./).length - 1;
    return u >= s && (typeof c > "u" || u <= c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Cp, Cp.exports);
var KS = Cp.exports, Ip = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = o(Tr);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1,
    ignore_max_length: !1
  };
  function a(l, s) {
    (0, r.default)(l), s = (0, n.default)(s, i), s.allow_trailing_dot && l[l.length - 1] === "." && (l = l.substring(0, l.length - 1)), s.allow_wildcard === !0 && l.indexOf("*.") === 0 && (l = l.substring(2));
    var c = l.split("."), u = c[c.length - 1];
    return s.require_tld && (c.length < 2 || !s.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(u) || /\s/.test(u)) || !s.allow_numeric_tld && /^\d+$/.test(u) ? !1 : c.every(function(d) {
      return !(d.length > 63 && !s.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(d) || /[\uff01-\uff5e]/.test(d) || /^-|-$/.test(d) || !s.allow_underscores && /_/.test(d));
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ip, Ip.exports);
var Fm = Ip.exports, Ap = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(he);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", i = "(".concat(o, "[.]){3}").concat(o), a = new RegExp("^".concat(i, "$")), l = "(?:[0-9a-fA-F]{1,4})", s = new RegExp("^(" + "(?:".concat(l, ":){7}(?:").concat(l, "|:)|") + "(?:".concat(l, ":){6}(?:").concat(i, "|:").concat(l, "|:)|") + "(?:".concat(l, ":){5}(?::").concat(i, "|(:").concat(l, "){1,2}|:)|") + "(?:".concat(l, ":){4}(?:(:").concat(l, "){0,1}:").concat(i, "|(:").concat(l, "){1,3}|:)|") + "(?:".concat(l, ":){3}(?:(:").concat(l, "){0,2}:").concat(i, "|(:").concat(l, "){1,4}|:)|") + "(?:".concat(l, ":){2}(?:(:").concat(l, "){0,3}:").concat(i, "|(:").concat(l, "){1,5}|:)|") + "(?:".concat(l, ":){1}(?:(:").concat(l, "){0,4}:").concat(i, "|(:").concat(l, "){1,6}|:)|") + "(?::((?::".concat(l, "){0,5}:").concat(i, "|(?::").concat(l, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
  function c(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, r.default)(u), d = String(d), d ? d === "4" ? a.test(u) : d === "6" ? s.test(u) : !1 : c(u, 4) || c(u, 6);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ap, Ap.exports);
var Xc = Ap.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var r = l(he), n = l(KS), o = l(Fm), i = l(Xc), a = l(Tr);
  function l(M) {
    return M && M.__esModule ? M : { default: M };
  }
  var s = {
    allow_display_name: !1,
    allow_underscores: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0,
    blacklisted_chars: "",
    ignore_max_length: !1,
    host_blacklist: [],
    host_whitelist: []
  }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, u = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, d = /^[a-z\d]+$/, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, g = 254;
  function m(M) {
    var x = M.replace(/^"(.+)"$/, "$1");
    if (!x.trim())
      return !1;
    var b = /[\.";<>]/.test(x);
    if (b) {
      if (x === M)
        return !1;
      var T = x.split('"').length === x.split('\\"').length;
      if (!T)
        return !1;
    }
    return !0;
  }
  function v(M, x) {
    if ((0, r.default)(M), x = (0, a.default)(x, s), x.require_display_name || x.allow_display_name) {
      var b = M.match(c);
      if (b) {
        var T = b[1];
        if (M = M.replace(T, "").replace(/(^<|>$)/g, ""), T.endsWith(" ") && (T = T.slice(0, -1)), !m(T))
          return !1;
      } else if (x.require_display_name)
        return !1;
    }
    if (!x.ignore_max_length && M.length > g)
      return !1;
    var w = M.split("@"), y = w.pop(), I = y.toLowerCase();
    if (x.host_blacklist.includes(I) || x.host_whitelist.length > 0 && !x.host_whitelist.includes(I))
      return !1;
    var D = w.join("@");
    if (x.domain_specific_validation && (I === "gmail.com" || I === "googlemail.com")) {
      D = D.toLowerCase();
      var O = D.split("+")[0];
      if (!(0, n.default)(O.replace(/\./g, ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var $ = O.split("."), z = 0; z < $.length; z++)
        if (!d.test($[z]))
          return !1;
    }
    if (x.ignore_max_length === !1 && (!(0, n.default)(D, {
      max: 64
    }) || !(0, n.default)(y, {
      max: 254
    })))
      return !1;
    if (!(0, o.default)(y, {
      require_tld: x.require_tld,
      ignore_max_length: x.ignore_max_length,
      allow_underscores: x.allow_underscores
    })) {
      if (!x.allow_ip_domain)
        return !1;
      if (!(0, i.default)(y)) {
        if (!y.startsWith("[") || !y.endsWith("]"))
          return !1;
        var Y = y.slice(1, -1);
        if (Y.length === 0 || !(0, i.default)(Y))
          return !1;
      }
    }
    if (D[0] === '"')
      return D = D.slice(1, D.length - 1), x.allow_utf8_local_part ? h.test(D) : f.test(D);
    for (var j = x.allow_utf8_local_part ? p : u, q = D.split("."), ee = 0; ee < q.length; ee++)
      if (!j.test(q[ee]))
        return !1;
    return !(x.blacklisted_chars && D.search(new RegExp("[".concat(x.blacklisted_chars, "]+"), "g")) !== -1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Sp, Sp.exports);
var qS = Sp.exports, Dp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var r = a(he), n = a(Fm), o = a(Xc), i = a(Tr);
  function a(M) {
    return M && M.__esModule ? M : { default: M };
  }
  function l(M, x) {
    return f(M) || d(M, x) || c(M, x) || s();
  }
  function s() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(M, x) {
    if (M) {
      if (typeof M == "string")
        return u(M, x);
      var b = Object.prototype.toString.call(M).slice(8, -1);
      if (b === "Object" && M.constructor && (b = M.constructor.name), b === "Map" || b === "Set")
        return Array.from(M);
      if (b === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(b))
        return u(M, x);
    }
  }
  function u(M, x) {
    (x == null || x > M.length) && (x = M.length);
    for (var b = 0, T = new Array(x); b < x; b++)
      T[b] = M[b];
    return T;
  }
  function d(M, x) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(M)))) {
      var b = [], T = !0, w = !1, y = void 0;
      try {
        for (var I = M[Symbol.iterator](), D; !(T = (D = I.next()).done) && (b.push(D.value), !(x && b.length === x)); T = !0)
          ;
      } catch (O) {
        w = !0, y = O;
      } finally {
        try {
          !T && I.return != null && I.return();
        } finally {
          if (w)
            throw y;
        }
      }
      return b;
    }
  }
  function f(M) {
    if (Array.isArray(M))
      return M;
  }
  var p = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_port: !1,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1,
    allow_fragments: !0,
    allow_query_components: !0,
    validate_length: !0
  }, h = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function g(M) {
    return Object.prototype.toString.call(M) === "[object RegExp]";
  }
  function m(M, x) {
    for (var b = 0; b < x.length; b++) {
      var T = x[b];
      if (M === T || g(T) && T.test(M))
        return !0;
    }
    return !1;
  }
  function v(M, x) {
    if ((0, r.default)(M), !M || /[\s<>]/.test(M) || M.indexOf("mailto:") === 0 || (x = (0, i.default)(x, p), x.validate_length && M.length >= 2083) || !x.allow_fragments && M.includes("#") || !x.allow_query_components && (M.includes("?") || M.includes("&")))
      return !1;
    var b, T, w, y, I, D, O, $;
    if (O = M.split("#"), M = O.shift(), O = M.split("?"), M = O.shift(), O = M.split("://"), O.length > 1) {
      if (b = O.shift().toLowerCase(), x.require_valid_protocol && x.protocols.indexOf(b) === -1)
        return !1;
    } else {
      if (x.require_protocol)
        return !1;
      if (M.slice(0, 2) === "//") {
        if (!x.allow_protocol_relative_urls)
          return !1;
        O[0] = M.slice(2);
      }
    }
    if (M = O.join("://"), M === "")
      return !1;
    if (O = M.split("/"), M = O.shift(), M === "" && !x.require_host)
      return !0;
    if (O = M.split("@"), O.length > 1) {
      if (x.disallow_auth || O[0] === "" || (T = O.shift(), T.indexOf(":") >= 0 && T.split(":").length > 2))
        return !1;
      var z = T.split(":"), Y = l(z, 2), j = Y[0], q = Y[1];
      if (j === "" && q === "")
        return !1;
    }
    y = O.join("@"), D = null, $ = null;
    var ee = y.match(h);
    if (ee ? (w = "", $ = ee[1], D = ee[2] || null) : (O = y.split(":"), w = O.shift(), O.length && (D = O.join(":"))), D !== null && D.length > 0) {
      if (I = parseInt(D, 10), !/^[0-9]+$/.test(D) || I <= 0 || I > 65535)
        return !1;
    } else if (x.require_port)
      return !1;
    return x.host_whitelist ? m(w, x.host_whitelist) : w === "" && !x.require_host ? !0 : !(!(0, o.default)(w) && !(0, n.default)(w, x) && (!$ || !(0, o.default)($, 6)) || (w = w || $, x.host_blacklist && m(w, x.host_blacklist)));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Dp, Dp.exports);
var eB = Dp.exports, kp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = n(he);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var o = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, i = /^([0-9a-fA-F]){12}$/, a = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, l = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, s = /^([0-9a-fA-F]){16}$/, c = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
  function u(d, f) {
    return (0, r.default)(d), f != null && f.eui && (f.eui = String(f.eui)), f != null && f.no_colons || f != null && f.no_separators ? f.eui === "48" ? i.test(d) : f.eui === "64" ? s.test(d) : i.test(d) || s.test(d) : (f == null ? void 0 : f.eui) === "48" ? o.test(d) || a.test(d) : (f == null ? void 0 : f.eui) === "64" ? l.test(d) || c.test(d) : u(d, {
      eui: "48"
    }) || u(d, {
      eui: "64"
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(kp, kp.exports);
var tB = kp.exports, Ep = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = o(he), n = o(Xc);
  function o(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /^\d{1,3}$/, a = 32, l = 128;
  function s(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0, r.default)(c);
    var d = c.split("/");
    if (d.length !== 2 || !i.test(d[1]) || d[1].length > 1 && d[1].startsWith("0"))
      return !1;
    var f = (0, n.default)(d[0], u);
    if (!f)
      return !1;
    var p = null;
    switch (String(u)) {
      case "4":
        p = a;
        break;
      case "6":
        p = l;
        break;
      default:
        p = (0, n.default)(d[0], "6") ? l : a;
    }
    return d[1] <= p && d[1] >= 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ep, Ep.exports);
var rB = Ep.exports, Lp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = h;
  var r = n(Tr);
  function n(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function o(g, m) {
    return l(g) || a(g, m) || c(g, m) || i();
  }
  function i() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function a(g, m) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(g)))) {
      var v = [], M = !0, x = !1, b = void 0;
      try {
        for (var T = g[Symbol.iterator](), w; !(M = (w = T.next()).done) && (v.push(w.value), !(m && v.length === m)); M = !0)
          ;
      } catch (y) {
        x = !0, b = y;
      } finally {
        try {
          !M && T.return != null && T.return();
        } finally {
          if (x)
            throw b;
        }
      }
      return v;
    }
  }
  function l(g) {
    if (Array.isArray(g))
      return g;
  }
  function s(g, m) {
    var v;
    if (typeof Symbol > "u" || g[Symbol.iterator] == null) {
      if (Array.isArray(g) || (v = c(g)) || m && g && typeof g.length == "number") {
        v && (g = v);
        var M = 0, x = function() {
        };
        return { s: x, n: function() {
          return M >= g.length ? { done: !0 } : { done: !1, value: g[M++] };
        }, e: function(I) {
          throw I;
        }, f: x };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var b = !0, T = !1, w;
    return { s: function() {
      v = g[Symbol.iterator]();
    }, n: function() {
      var I = v.next();
      return b = I.done, I;
    }, e: function(I) {
      T = !0, w = I;
    }, f: function() {
      try {
        !b && v.return != null && v.return();
      } finally {
        if (T)
          throw w;
      }
    } };
  }
  function c(g, m) {
    if (g) {
      if (typeof g == "string")
        return u(g, m);
      var v = Object.prototype.toString.call(g).slice(8, -1);
      if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set")
        return Array.from(g);
      if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v))
        return u(g, m);
    }
  }
  function u(g, m) {
    (m == null || m > g.length) && (m = g.length);
    for (var v = 0, M = new Array(m); v < m; v++)
      M[v] = g[v];
    return M;
  }
  var d = {
    format: "YYYY/MM/DD",
    delimiters: ["/", "-"],
    strictMode: !1
  };
  function f(g) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(g);
  }
  function p(g, m) {
    for (var v = [], M = Math.min(g.length, m.length), x = 0; x < M; x++)
      v.push([g[x], m[x]]);
    return v;
  }
  function h(g, m) {
    if (typeof m == "string" ? m = (0, r.default)({
      format: m
    }, d) : m = (0, r.default)(m, d), typeof g == "string" && f(m.format)) {
      var v = m.delimiters.find(function(Y) {
        return m.format.indexOf(Y) !== -1;
      }), M = m.strictMode ? v : m.delimiters.find(function(Y) {
        return g.indexOf(Y) !== -1;
      }), x = p(g.split(M), m.format.toLowerCase().split(v)), b = {}, T = s(x), w;
      try {
        for (T.s(); !(w = T.n()).done; ) {
          var y = o(w.value, 2), I = y[0], D = y[1];
          if (I.length !== D.length)
            return !1;
          b[D.charAt(0)] = I;
        }
      } catch (Y) {
        T.e(Y);
      } finally {
        T.f();
      }
      var O = b.y;
      if (b.y.length === 2) {
        var $ = parseInt(b.y, 10);
        if (isNaN($))
          return !1;
        var z = (/* @__PURE__ */ new Date()).getFullYear() % 100;
        $ < z ? O = "20".concat(b.y) : O = "19".concat(b.y);
      }
      return new Date("".concat(O, "-").concat(b.m, "-").concat(b.d)).getDate() === +b.d;
    }
    return m.strictMode ? !1 : Object.prototype.toString.call(g) === "[object Date]" && isFinite(g);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Lp, Lp.exports);
var JS = Lp.exports, $p = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(Tr);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = {
    hourFormat: "hour24",
    mode: "default"
  }, i = {
    hour24: {
      default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
      default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
      withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
  };
  function a(l, s) {
    return s = (0, r.default)(s, o), typeof l != "string" ? !1 : i[s.hourFormat][s.mode].test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})($p, $p.exports);
var nB = $p.exports, zp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(he);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = {
    loose: !1
  }, i = ["true", "false", "1", "0"], a = [].concat(i, ["yes", "no"]);
  function l(s) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o;
    return (0, r.default)(s), c.loose ? a.includes(s.toLowerCase()) : i.includes(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(zp, zp.exports);
var oB = zp.exports, Op = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = M;
  var r = n(he);
  function n(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var o = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", i = "(([a-zA-Z]{2,3}(-".concat(o, ")?)|([a-zA-Z]{5,8}))"), a = "([A-Za-z]{4})", l = "([A-Za-z]{2}|\\d{3})", s = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", c = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", u = "(".concat(c, "(-[A-Za-z0-9]{2,8})+)"), d = "(x(-[A-Za-z0-9]{1,8})+)", f = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", p = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", h = "(".concat(f, "|").concat(p, ")"), g = "(-|_)", m = "".concat(i, "(").concat(g).concat(a, ")?(").concat(g).concat(l, ")?(").concat(g).concat(s, ")*(").concat(g).concat(u, ")*(").concat(g).concat(d, ")?"), v = new RegExp("(^".concat(d, "$)|(^").concat(h, "$)|(^").concat(m, "$)"));
  function M(x) {
    return (0, r.default)(x), v.test(x);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Op, Op.exports);
var iB = Op.exports, vs = {};
Object.defineProperty(vs, "__esModule", {
  value: !0
});
vs.default = sB;
vs.locales = void 0;
var aB = lB(he), jp = St;
function lB(e) {
  return e && e.__esModule ? e : { default: e };
}
function sB(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, aB.default)(e);
  var n = e, o = r.ignore;
  if (o)
    if (o instanceof RegExp)
      n = n.replace(o, "");
    else if (typeof o == "string")
      n = n.replace(new RegExp("[".concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in jp.alpha)
    return jp.alpha[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var uB = Object.keys(jp.alpha);
vs.locales = uB;
var bs = {};
Object.defineProperty(bs, "__esModule", {
  value: !0
});
bs.default = fB;
bs.locales = void 0;
var cB = dB(he), Rp = St;
function dB(e) {
  return e && e.__esModule ? e : { default: e };
}
function fB(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  (0, cB.default)(e);
  var n = e, o = r.ignore;
  if (o)
    if (o instanceof RegExp)
      n = n.replace(o, "");
    else if (typeof o == "string")
      n = n.replace(new RegExp("[".concat(o.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
    else
      throw new Error("ignore should be instance of a String or RegExp");
  if (t in Rp.alphanumeric)
    return Rp.alphanumeric[t].test(n);
  throw new Error("Invalid locale '".concat(t, "'"));
}
var pB = Object.keys(Rp.alphanumeric);
bs.locales = pB;
var _p = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = St;
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = /^[0-9]+$/;
  function a(l, s) {
    return (0, r.default)(l), s && s.no_symbols ? i.test(l) : new RegExp("^[+-]?([0-9]*[".concat((s || {}).locale ? n.decimal[s.locale] : ".", "])?[0-9]+$")).test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(_p, _p.exports);
var hB = _p.exports, Pp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{2,3}\d{7,8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/
    // UNITED STATES
  };
  function i(a, l) {
    (0, r.default)(a);
    var s = a.replace(/\s/g, "").toUpperCase();
    return l.toUpperCase() in o && o[l].test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Pp, Pp.exports);
var gB = Pp.exports, Bp = { exports: {} }, Fp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(he);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, i = /^[-+]?[0-9]+$/;
  function a(l, s) {
    (0, r.default)(l), s = s || {};
    var c = s.hasOwnProperty("allow_leading_zeroes") && !s.allow_leading_zeroes ? o : i, u = !s.hasOwnProperty("min") || l >= s.min, d = !s.hasOwnProperty("max") || l <= s.max, f = !s.hasOwnProperty("lt") || l < s.lt, p = !s.hasOwnProperty("gt") || l > s.gt;
    return c.test(l) && u && d && f && p;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Fp, Fp.exports);
var Um = Fp.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Um);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i, {
      min: 0,
      max: 65535
    });
  }
  e.exports = t.default, e.exports.default = t.default;
})(Bp, Bp.exports);
var mB = Bp.exports, Up = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i), i === i.toLowerCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(Up, Up.exports);
var vB = Up.exports, Hp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i), i === i.toUpperCase();
  }
  e.exports = t.default, e.exports.default = t.default;
})(Hp, Hp.exports);
var bB = Hp.exports, Yp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(he);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = /^[0-9]{15}$/, i = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
  function a(l, s) {
    (0, r.default)(l), s = s || {};
    var c = o;
    if (s.allow_hyphens && (c = i), !c.test(l))
      return !1;
    l = l.replace(/-/g, "");
    for (var u = 0, d = 2, f = 14, p = 0; p < f; p++) {
      var h = l.substring(f - p - 1, f - p), g = parseInt(h, 10) * d;
      g >= 10 ? u += g % 10 + 1 : u += g, d === 1 ? d += 1 : d -= 1;
    }
    var m = (10 - u % 10) % 10;
    return m === parseInt(l.substring(14, 15), 10);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Yp, Yp.exports);
var MB = Yp.exports, Wp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[\x00-\x7F]+$/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Wp, Wp.exports);
var yB = Wp.exports, Ea = {};
Object.defineProperty(Ea, "__esModule", {
  value: !0
});
Ea.default = TB;
Ea.fullWidth = void 0;
var xB = wB(he);
function wB(e) {
  return e && e.__esModule ? e : { default: e };
}
var XS = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
Ea.fullWidth = XS;
function TB(e) {
  return (0, xB.default)(e), XS.test(e);
}
var La = {};
Object.defineProperty(La, "__esModule", {
  value: !0
});
La.default = CB;
La.halfWidth = void 0;
var NB = SB(he);
function SB(e) {
  return e && e.__esModule ? e : { default: e };
}
var eC = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
La.halfWidth = eC;
function CB(e) {
  return (0, NB.default)(e), eC.test(e);
}
var Qp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = i(he), n = Ea, o = La;
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function a(l) {
    return (0, r.default)(l), n.fullWidth.test(l) && o.halfWidth.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Qp, Qp.exports);
var IB = Qp.exports, Vp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /[^\x00-\x7F]/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Vp, Vp.exports);
var AB = Vp.exports, Zp = { exports: {} }, Gp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n, o) {
    var i = n.join("");
    return new RegExp(i, o);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Gp, Gp.exports);
var DB = Gp.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = o(DB);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
  function a(l) {
    return (0, r.default)(l), i.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Zp, Zp.exports);
var kB = Zp.exports, Kp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Kp, Kp.exports);
var EB = Kp.exports, qp = { exports: {} }, Jp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = function(i, a) {
    return i.some(function(l) {
      return a === l;
    });
  }, n = r;
  t.default = n, e.exports = t.default, e.exports.default = t.default;
})(Jp, Jp.exports);
var LB = Jp.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = a(Tr), n = a(he), o = a(LB), i = St;
  function a(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function l(d) {
    var f = new RegExp("^[-+]?([0-9]+)?(\\".concat(i.decimal[d.locale], "[0-9]{").concat(d.decimal_digits, "})").concat(d.force_decimal ? "" : "?", "$"));
    return f;
  }
  var s = {
    force_decimal: !1,
    decimal_digits: "1,",
    locale: "en-US"
  }, c = ["", "-", "+"];
  function u(d, f) {
    if ((0, n.default)(d), f = (0, r.default)(f, s), f.locale in i.decimal)
      return !(0, o.default)(c, d.replace(/ /g, "")) && l(f).test(d);
    throw new Error("Invalid locale '".concat(f.locale, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(qp, qp.exports);
var $B = qp.exports, Xp = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^(0x|0h)?[0-9A-F]+$/i;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Xp, Xp.exports);
var tC = Xp.exports, eh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^(0o)?[0-7]+$/i;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(eh, eh.exports);
var zB = eh.exports, th = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(he), n = o(ZS);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a, l) {
    return (0, r.default)(a), (0, n.default)(a) % parseInt(l, 10) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(th, th.exports);
var OB = th.exports, rh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(rh, rh.exports);
var jB = rh.exports, nh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = n(he);
  function n(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var o = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, i = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, a = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, l = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
  function s(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return (0, r.default)(c), u ? o.test(c) || i.test(c) || a.test(c) || l.test(c) : o.test(c) || i.test(c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(nh, nh.exports);
var RB = nh.exports, oh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(he);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, i = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
  function a(l) {
    (0, r.default)(l);
    var s = l.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
    return s.indexOf(",") !== -1 ? o.test(s) : i.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(oh, oh.exports);
var _B = oh.exports, ih = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ih, ih.exports);
var PB = ih.exports, Ms = {};
Object.defineProperty(Ms, "__esModule", {
  value: !0
});
Ms.default = WB;
Ms.locales = void 0;
var BB = FB(he);
function FB(e) {
  return e && e.__esModule ? e : { default: e };
}
var Wu = {
  AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
  AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
  AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  AT: /^(AT[0-9]{2})\d{16}$/,
  AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  BA: /^(BA[0-9]{2})\d{16}$/,
  BE: /^(BE[0-9]{2})\d{12}$/,
  BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
  BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
  BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
  BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  CR: /^(CR[0-9]{2})\d{18}$/,
  CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
  CZ: /^(CZ[0-9]{2})\d{20}$/,
  DE: /^(DE[0-9]{2})\d{18}$/,
  DK: /^(DK[0-9]{2})\d{14}$/,
  DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
  EE: /^(EE[0-9]{2})\d{16}$/,
  EG: /^(EG[0-9]{2})\d{25}$/,
  ES: /^(ES[0-9]{2})\d{20}$/,
  FI: /^(FI[0-9]{2})\d{14}$/,
  FO: /^(FO[0-9]{2})\d{14}$/,
  FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
  GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
  GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
  GL: /^(GL[0-9]{2})\d{14}$/,
  GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
  GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
  HR: /^(HR[0-9]{2})\d{17}$/,
  HU: /^(HU[0-9]{2})\d{24}$/,
  IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
  IL: /^(IL[0-9]{2})\d{19}$/,
  IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
  IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
  IS: /^(IS[0-9]{2})\d{22}$/,
  IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
  KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
  KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
  LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
  LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
  LT: /^(LT[0-9]{2})\d{16}$/,
  LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
  LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
  MA: /^(MA[0-9]{26})$/,
  MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
  MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
  ME: /^(ME[0-9]{2})\d{18}$/,
  MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
  MR: /^(MR[0-9]{2})\d{23}$/,
  MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
  MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
  MZ: /^(MZ[0-9]{2})\d{21}$/,
  NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
  NO: /^(NO[0-9]{2})\d{11}$/,
  PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  PL: /^(PL[0-9]{2})\d{24}$/,
  PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
  PT: /^(PT[0-9]{2})\d{21}$/,
  QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
  RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
  RS: /^(RS[0-9]{2})\d{18}$/,
  SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
  SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
  SE: /^(SE[0-9]{2})\d{20}$/,
  SI: /^(SI[0-9]{2})\d{15}$/,
  SK: /^(SK[0-9]{2})\d{20}$/,
  SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
  SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
  TL: /^(TL[0-9]{2})\d{19}$/,
  TN: /^(TN[0-9]{2})\d{20}$/,
  TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
  UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
  VA: /^(VA[0-9]{2})\d{18}$/,
  VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
  XK: /^(XK[0-9]{2})\d{16}$/
};
function UB(e) {
  var t = e.filter(function(r) {
    return !(r in Wu);
  });
  return !(t.length > 0);
}
function HB(e, t) {
  var r = e.replace(/[\s\-]+/gi, "").toUpperCase(), n = r.slice(0, 2).toUpperCase(), o = n in Wu;
  if (t.whitelist) {
    if (!UB(t.whitelist))
      return !1;
    var i = t.whitelist.includes(n);
    if (!i)
      return !1;
  }
  if (t.blacklist) {
    var a = t.blacklist.includes(n);
    if (a)
      return !1;
  }
  return o && Wu[n].test(r);
}
function YB(e) {
  var t = e.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), r = t.slice(4) + t.slice(0, 4), n = r.replace(/[A-Z]/g, function(i) {
    return i.charCodeAt(0) - 55;
  }), o = n.match(/\d{1,7}/g).reduce(function(i, a) {
    return Number(i + a) % 97;
  }, "");
  return o === 1;
}
function WB(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (0, BB.default)(e), HB(e, t) && YB(e);
}
var QB = Object.keys(Wu);
Ms.locales = QB;
var ah = { exports: {} }, $a = {};
Object.defineProperty($a, "__esModule", {
  value: !0
});
$a.default = GB;
$a.CountryCodes = void 0;
var VB = ZB(he);
function ZB(e) {
  return e && e.__esModule ? e : { default: e };
}
var rC = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
function GB(e) {
  return (0, VB.default)(e), rC.has(e.toUpperCase());
}
var KB = rC;
$a.CountryCodes = KB;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = $a;
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
  function a(l) {
    (0, r.default)(l);
    var s = l.slice(4, 6).toUpperCase();
    return !n.CountryCodes.has(s) && s !== "XK" ? !1 : i.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ah, ah.exports);
var qB = ah.exports, lh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[a-f0-9]{32}$/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(lh, lh.exports);
var JB = lh.exports, sh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
  };
  function i(a, l) {
    (0, r.default)(a);
    var s = new RegExp("^[a-fA-F0-9]{".concat(o[l], "}$"));
    return s.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(sh, sh.exports);
var XB = sh.exports, uh = { exports: {} }, ch = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = o(he), n = o(Tr);
  function o(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /[^A-Z0-9+\/=]/i, a = /^[A-Z0-9_\-]*$/i, l = {
    urlSafe: !1
  };
  function s(c, u) {
    (0, r.default)(c), u = (0, n.default)(u, l);
    var d = c.length;
    if (u.urlSafe)
      return a.test(c);
    if (d % 4 !== 0 || i.test(c))
      return !1;
    var f = c.indexOf("=");
    return f === -1 || f === d - 1 || f === d - 2 && c[d - 1] === "=";
  }
  e.exports = t.default, e.exports.default = t.default;
})(ch, ch.exports);
var nC = ch.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(he), n = o(nC);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    (0, r.default)(a);
    var l = a.split("."), s = l.length;
    return s !== 3 ? !1 : l.reduce(function(c, u) {
      return c && (0, n.default)(u, {
        urlSafe: !0
      });
    }, !0);
  }
  e.exports = t.default, e.exports.default = t.default;
})(uh, uh.exports);
var e8 = uh.exports, dh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = o(he), n = o(Tr);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(u) {
      return typeof u;
    } : i = function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, i(s);
  }
  var a = {
    allow_primitives: !1
  };
  function l(s, c) {
    (0, r.default)(s);
    try {
      c = (0, n.default)(c, a);
      var u = [];
      c.allow_primitives && (u = [null, !1, !0]);
      var d = JSON.parse(s);
      return u.includes(d) || !!d && i(d) === "object";
    } catch {
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(dh, dh.exports);
var t8 = dh.exports, fh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = o(Tr);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {
    ignore_whitespace: !1
  };
  function a(l, s) {
    return (0, r.default)(l), s = (0, n.default)(s, i), (s.ignore_whitespace ? l.trim().length : l.length) === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(fh, fh.exports);
var r8 = fh.exports, ph = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(s) {
      return typeof s;
    } : o = function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, o(a);
  }
  function i(a, l) {
    (0, r.default)(a);
    var s, c;
    o(l) === "object" ? (s = l.min || 0, c = l.max) : (s = arguments[1] || 0, c = arguments[2]);
    var u = a.match(/(\uFE0F|\uFE0E)/g) || [], d = a.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], f = a.length - u.length - d.length;
    return f >= s && (typeof c > "u" || f <= c);
  }
  e.exports = t.default, e.exports.default = t.default;
})(ph, ph.exports);
var n8 = ph.exports, hh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };
  function i(a, l) {
    (0, r.default)(a);
    var s = o[[void 0, null].includes(l) ? "all" : l];
    return !!s && s.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(hh, hh.exports);
var o8 = hh.exports, gh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(he), n = o(tC);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    return (0, r.default)(a), (0, n.default)(a) && a.length === 24;
  }
  e.exports = t.default, e.exports.default = t.default;
})(gh, gh.exports);
var i8 = gh.exports, mh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(Bm);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    var l = (a == null ? void 0 : a.comparisonDate) || a || Date().toString(), s = (0, r.default)(l), c = (0, r.default)(i);
    return !!(c && s && c > s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(mh, mh.exports);
var a8 = mh.exports, vh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(he), n = o(Bm);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
    (0, r.default)(a);
    var s = (0, n.default)(l), c = (0, n.default)(a);
    return !!(c && s && c < s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(vh, vh.exports);
var l8 = vh.exports, bh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = o(GS);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function i(l) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(c) {
      return typeof c;
    } : i = function(c) {
      return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    }, i(l);
  }
  function a(l, s) {
    (0, r.default)(l);
    var c;
    if (Object.prototype.toString.call(s) === "[object Array]") {
      var u = [];
      for (c in s)
        ({}).hasOwnProperty.call(s, c) && (u[c] = (0, n.default)(s[c]));
      return u.indexOf(l) >= 0;
    } else {
      if (i(s) === "object")
        return s.hasOwnProperty(l);
      if (s && typeof s.indexOf == "function")
        return s.indexOf(l) >= 0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(bh, bh.exports);
var s8 = bh.exports, Mh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    (0, r.default)(i);
    for (var a = i.replace(/[- ]+/g, ""), l = 0, s, c, u, d = a.length - 1; d >= 0; d--)
      s = a.substring(d, d + 1), c = parseInt(s, 10), u ? (c *= 2, c >= 10 ? l += c % 10 + 1 : l += c) : l += c, u = !u;
    return !!(l % 10 === 0 && a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Mh, Mh.exports);
var oC = Mh.exports, yh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = o(he), n = o(oC);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var i = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
  }, a = function() {
    var s = [];
    for (var c in i)
      i.hasOwnProperty(c) && s.push(i[c]);
    return s;
  }();
  function l(s) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(s);
    var u = c.provider, d = s.replace(/[- ]+/g, "");
    if (u && u.toLowerCase() in i) {
      if (!i[u.toLowerCase()].test(d))
        return !1;
    } else {
      if (u && !(u.toLowerCase() in i))
        throw new Error("".concat(u, " is not a valid credit card provider."));
      if (!a.some(function(f) {
        return f.test(d);
      }))
        return !1;
    }
    return (0, n.default)(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(yh, yh.exports);
var u8 = yh.exports, xh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = o(he), n = o(Um);
  function o(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var i = {
    PL: function(s) {
      (0, r.default)(s);
      var c = {
        1: 1,
        2: 3,
        3: 7,
        4: 9,
        5: 1,
        6: 3,
        7: 7,
        8: 9,
        9: 1,
        10: 3,
        11: 0
      };
      if (s != null && s.length === 11 && (0, n.default)(s, {
        allow_leading_zeroes: !0
      })) {
        var u = s.split("").slice(0, -1), d = u.reduce(function(h, g, m) {
          return h + Number(g) * c[m + 1];
        }, 0), f = d % 10, p = Number(s.charAt(s.length - 1));
        if (f === 0 && p === 0 || p === 10 - f)
          return !0;
      }
      return !1;
    },
    ES: function(s) {
      (0, r.default)(s);
      var c = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, u = {
        X: 0,
        Y: 1,
        Z: 2
      }, d = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], f = s.trim().toUpperCase();
      if (!c.test(f))
        return !1;
      var p = f.slice(0, -1).replace(/[X,Y,Z]/g, function(h) {
        return u[h];
      });
      return f.endsWith(d[p % 23]);
    },
    FI: function(s) {
      if ((0, r.default)(s), s.length !== 11 || !s.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
        return !1;
      var c = "0123456789ABCDEFHJKLMNPRSTUVWXY", u = parseInt(s.slice(0, 6), 10) * 1e3 + parseInt(s.slice(7, 10), 10), d = u % 31, f = c[d];
      return f === s.slice(10, 11);
    },
    IN: function(s) {
      var c = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, u = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], f = s.trim();
      if (!c.test(f))
        return !1;
      var p = 0, h = f.replace(/\s/g, "").split("").map(Number).reverse();
      return h.forEach(function(g, m) {
        p = u[p][d[m % 8][g]];
      }), p === 0;
    },
    IR: function(s) {
      if (!s.match(/^\d{10}$/) || (s = "0000".concat(s).slice(s.length - 6), parseInt(s.slice(3, 9), 10) === 0))
        return !1;
      for (var c = parseInt(s.slice(9, 10), 10), u = 0, d = 0; d < 9; d++)
        u += parseInt(s.slice(d, d + 1), 10) * (10 - d);
      return u %= 11, u < 2 && c === u || u >= 2 && c === 11 - u;
    },
    IT: function(s) {
      return s.length !== 9 || s === "CA00000AA" ? !1 : s.search(/C[A-Z][0-9]{5}[A-Z]{2}/i) > -1;
    },
    NO: function(s) {
      var c = s.trim();
      if (isNaN(Number(c)) || c.length !== 11 || c === "00000000000")
        return !1;
      var u = c.split("").map(Number), d = (11 - (3 * u[0] + 7 * u[1] + 6 * u[2] + 1 * u[3] + 8 * u[4] + 9 * u[5] + 4 * u[6] + 5 * u[7] + 2 * u[8]) % 11) % 11, f = (11 - (5 * u[0] + 4 * u[1] + 3 * u[2] + 2 * u[3] + 7 * u[4] + 6 * u[5] + 5 * u[6] + 4 * u[7] + 3 * u[8] + 2 * d) % 11) % 11;
      return !(d !== u[9] || f !== u[10]);
    },
    TH: function(s) {
      if (!s.match(/^[1-8]\d{12}$/))
        return !1;
      for (var c = 0, u = 0; u < 12; u++)
        c += parseInt(s[u], 10) * (13 - u);
      return s[12] === ((11 - c % 11) % 10).toString();
    },
    LK: function(s) {
      var c = /^[1-9]\d{8}[vx]$/i, u = /^[1-9]\d{11}$/i;
      return s.length === 10 && c.test(s) ? !0 : !!(s.length === 12 && u.test(s));
    },
    "he-IL": function(s) {
      var c = /^\d{9}$/, u = s.trim();
      if (!c.test(u))
        return !1;
      for (var d = u, f = 0, p, h = 0; h < d.length; h++)
        p = Number(d[h]) * (h % 2 + 1), f += p > 9 ? p - 9 : p;
      return f % 10 === 0;
    },
    "ar-LY": function(s) {
      var c = /^(1|2)\d{11}$/, u = s.trim();
      return !!c.test(u);
    },
    "ar-TN": function(s) {
      var c = /^\d{8}$/, u = s.trim();
      return !!c.test(u);
    },
    "zh-CN": function(s) {
      var c = [
        "11",
        // 北京
        "12",
        // 天津
        "13",
        // 河北
        "14",
        // 山西
        "15",
        // 内蒙古
        "21",
        // 辽宁
        "22",
        // 吉林
        "23",
        // 黑龙江
        "31",
        // 上海
        "32",
        // 江苏
        "33",
        // 浙江
        "34",
        // 安徽
        "35",
        // 福建
        "36",
        // 江西
        "37",
        // 山东
        "41",
        // 河南
        "42",
        // 湖北
        "43",
        // 湖南
        "44",
        // 广东
        "45",
        // 广西
        "46",
        // 海南
        "50",
        // 重庆
        "51",
        // 四川
        "52",
        // 贵州
        "53",
        // 云南
        "54",
        // 西藏
        "61",
        // 陕西
        "62",
        // 甘肃
        "63",
        // 青海
        "64",
        // 宁夏
        "65",
        // 新疆
        "71",
        // 台湾
        "81",
        // 香港
        "82",
        // 澳门
        "91"
        // 国外
      ], u = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], d = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], f = function(b) {
        return c.includes(b);
      }, p = function(b) {
        var T = parseInt(b.substring(0, 4), 10), w = parseInt(b.substring(4, 6), 10), y = parseInt(b.substring(6), 10), I = new Date(T, w - 1, y);
        return I > /* @__PURE__ */ new Date() ? !1 : I.getFullYear() === T && I.getMonth() === w - 1 && I.getDate() === y;
      }, h = function(b) {
        for (var T = b.substring(0, 17), w = 0, y = 0; y < 17; y++)
          w += parseInt(T.charAt(y), 10) * parseInt(u[y], 10);
        var I = w % 11;
        return d[I];
      }, g = function(b) {
        return h(b) === b.charAt(17).toUpperCase();
      }, m = function(b) {
        var T = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(b);
        if (!T)
          return !1;
        var w = b.substring(0, 2);
        if (T = f(w), !T)
          return !1;
        var y = "19".concat(b.substring(6, 12));
        return T = p(y), !!T;
      }, v = function(b) {
        var T = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(b);
        if (!T)
          return !1;
        var w = b.substring(0, 2);
        if (T = f(w), !T)
          return !1;
        var y = b.substring(6, 14);
        return T = p(y), T ? g(b) : !1;
      }, M = function(b) {
        var T = /^\d{15}|(\d{17}(\d|x|X))$/.test(b);
        return T ? b.length === 15 ? m(b) : v(b) : !1;
      };
      return M(s);
    },
    "zh-HK": function(s) {
      s = s.trim();
      var c = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, u = /^[0-9]$/;
      if (s = s.toUpperCase(), !c.test(s))
        return !1;
      s = s.replace(/\[|\]|\(|\)/g, ""), s.length === 8 && (s = "3".concat(s));
      for (var d = 0, f = 0; f <= 7; f++) {
        var p = void 0;
        u.test(s[f]) ? p = s[f] : p = (s[f].charCodeAt(0) - 55) % 11, d += p * (9 - f);
      }
      d %= 11;
      var h;
      return d === 0 ? h = "0" : d === 1 ? h = "A" : h = String(11 - d), h === s[s.length - 1];
    },
    "zh-TW": function(s) {
      var c = {
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        G: 16,
        H: 17,
        I: 34,
        J: 18,
        K: 19,
        L: 20,
        M: 21,
        N: 22,
        O: 35,
        P: 23,
        Q: 24,
        R: 25,
        S: 26,
        T: 27,
        U: 28,
        V: 29,
        W: 32,
        X: 30,
        Y: 31,
        Z: 33
      }, u = s.trim().toUpperCase();
      return /^[A-Z][0-9]{9}$/.test(u) ? Array.from(u).reduce(function(d, f, p) {
        if (p === 0) {
          var h = c[f];
          return h % 10 * 9 + Math.floor(h / 10);
        }
        return p === 9 ? (10 - d % 10 - Number(f)) % 10 === 0 : d + Number(f) * (9 - p);
      }, 0) : !1;
    }
  };
  function a(l, s) {
    if ((0, r.default)(l), s in i)
      return i[s](l);
    if (s === "any") {
      for (var c in i)
        if (i.hasOwnProperty(c)) {
          var u = i[c];
          if (u(l))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(xh, xh.exports);
var c8 = xh.exports, wh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var r = n(he);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var o = 8, i = 14, a = /^(\d{8}|\d{13}|\d{14})$/;
  function l(u, d) {
    return u === o || u === i ? d % 2 === 0 ? 3 : 1 : d % 2 === 0 ? 1 : 3;
  }
  function s(u) {
    var d = u.slice(0, -1).split("").map(function(p, h) {
      return Number(p) * l(u.length, h);
    }).reduce(function(p, h) {
      return p + h;
    }, 0), f = 10 - d % 10;
    return f < 10 ? f : 0;
  }
  function c(u) {
    (0, r.default)(u);
    var d = Number(u.slice(-1));
    return a.test(u) && d === s(u);
  }
  e.exports = t.default, e.exports.default = t.default;
})(wh, wh.exports);
var d8 = wh.exports, Th = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
  function i(a) {
    if ((0, r.default)(a), !o.test(a))
      return !1;
    for (var l = !0, s = 0, c = a.length - 2; c >= 0; c--)
      if (a[c] >= "A" && a[c] <= "Z")
        for (var u = a[c].charCodeAt(0) - 55, d = u % 10, f = Math.trunc(u / 10), p = 0, h = [d, f]; p < h.length; p++) {
          var g = h[p];
          l ? g >= 5 ? s += 1 + (g - 5) * 2 : s += g * 2 : s += g, l = !l;
        }
      else {
        var m = a[c].charCodeAt(0) - "0".charCodeAt(0);
        l ? m >= 5 ? s += 1 + (m - 5) * 2 : s += m * 2 : s += m, l = !l;
      }
    var v = Math.trunc((s + 9) / 10) * 10 - s;
    return +a[a.length - 1] === v;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Th, Th.exports);
var f8 = Th.exports, Nh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(he);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^(?:[0-9]{9}X|[0-9]{10})$/, i = /^(?:[0-9]{13})$/, a = [1, 3];
  function l(s, c) {
    (0, r.default)(s);
    var u = String((c == null ? void 0 : c.version) || c);
    if (!(c != null && c.version || c))
      return l(s, {
        version: 10
      }) || l(s, {
        version: 13
      });
    var d = s.replace(/[\s-]+/g, ""), f = 0;
    if (u === "10") {
      if (!o.test(d))
        return !1;
      for (var p = 0; p < u - 1; p++)
        f += (p + 1) * d.charAt(p);
      if (d.charAt(9) === "X" ? f += 10 * 10 : f += 10 * d.charAt(9), f % 11 === 0)
        return !0;
    } else if (u === "13") {
      if (!i.test(d))
        return !1;
      for (var h = 0; h < 12; h++)
        f += a[h % 2] * d.charAt(h);
      if (d.charAt(12) - (10 - f % 10) % 10 === 0)
        return !0;
    }
    return !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Nh, Nh.exports);
var p8 = Nh.exports, Sh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = "^\\d{4}-?\\d{3}[\\dX]$";
  function i(a) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(a);
    var s = o;
    if (s = l.require_hyphen ? s.replace("?", "") : s, s = l.case_sensitive ? new RegExp(s) : new RegExp(s, "i"), !s.test(a))
      return !1;
    for (var c = a.replace("-", "").toUpperCase(), u = 0, d = 0; d < c.length; d++) {
      var f = c[d];
      u += (f === "X" ? 10 : +f) * (8 - d);
    }
    return u % 11 === 0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Sh, Sh.exports);
var h8 = Sh.exports, Ch = { exports: {} }, Ti = {};
Object.defineProperty(Ti, "__esModule", {
  value: !0
});
Ti.iso7064Check = g8;
Ti.luhnCheck = m8;
Ti.reverseMultiplyAndSum = v8;
Ti.verhoeffCheck = b8;
function g8(e) {
  for (var t = 10, r = 0; r < e.length - 1; r++)
    t = (parseInt(e[r], 10) + t) % 10 === 0 ? 10 * 2 % 11 : (parseInt(e[r], 10) + t) % 10 * 2 % 11;
  return t = t === 1 ? 0 : 11 - t, t === parseInt(e[10], 10);
}
function m8(e) {
  for (var t = 0, r = !1, n = e.length - 1; n >= 0; n--) {
    if (r) {
      var o = parseInt(e[n], 10) * 2;
      o > 9 ? t += o.toString().split("").map(function(i) {
        return parseInt(i, 10);
      }).reduce(function(i, a) {
        return i + a;
      }, 0) : t += o;
    } else
      t += parseInt(e[n], 10);
    r = !r;
  }
  return t % 10 === 0;
}
function v8(e, t) {
  for (var r = 0, n = 0; n < e.length; n++)
    r += e[n] * (t - n);
  return r;
}
function b8(e) {
  for (var t = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], r = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], n = e.split("").reverse().join(""), o = 0, i = 0; i < n.length; i++)
    o = t[o][r[i % 8][parseInt(n[i], 10)]];
  return o === 0;
}
(function(e, t) {
  function r(A) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(E) {
      return typeof E;
    } : r = function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, r(A);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = Nt;
  var n = s(he), o = l(Ti), i = s(JS);
  function a() {
    if (typeof WeakMap != "function")
      return null;
    var A = /* @__PURE__ */ new WeakMap();
    return a = function() {
      return A;
    }, A;
  }
  function l(A) {
    if (A && A.__esModule)
      return A;
    if (A === null || r(A) !== "object" && typeof A != "function")
      return { default: A };
    var C = a();
    if (C && C.has(A))
      return C.get(A);
    var E = {}, J = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var H in A)
      if (Object.prototype.hasOwnProperty.call(A, H)) {
        var X = J ? Object.getOwnPropertyDescriptor(A, H) : null;
        X && (X.get || X.set) ? Object.defineProperty(E, H, X) : E[H] = A[H];
      }
    return E.default = A, C && C.set(A, E), E;
  }
  function s(A) {
    return A && A.__esModule ? A : { default: A };
  }
  function c(A) {
    return p(A) || f(A) || d(A) || u();
  }
  function u() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function d(A, C) {
    if (A) {
      if (typeof A == "string")
        return h(A, C);
      var E = Object.prototype.toString.call(A).slice(8, -1);
      if (E === "Object" && A.constructor && (E = A.constructor.name), E === "Map" || E === "Set")
        return Array.from(A);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E))
        return h(A, C);
    }
  }
  function f(A) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(A))
      return Array.from(A);
  }
  function p(A) {
    if (Array.isArray(A))
      return h(A);
  }
  function h(A, C) {
    (C == null || C > A.length) && (C = A.length);
    for (var E = 0, J = new Array(C); E < C; E++)
      J[E] = A[E];
    return J;
  }
  function g(A) {
    var C = A.slice(0, 2), E = parseInt(A.slice(2, 4), 10);
    E > 40 ? (E -= 40, C = "20".concat(C)) : E > 20 ? (E -= 20, C = "18".concat(C)) : C = "19".concat(C), E < 10 && (E = "0".concat(E));
    var J = "".concat(C, "/").concat(E, "/").concat(A.slice(4, 6));
    if (!(0, i.default)(J, "YYYY/MM/DD"))
      return !1;
    for (var H = A.split("").map(function(G) {
      return parseInt(G, 10);
    }), X = [2, 4, 8, 5, 10, 9, 7, 3, 6], me = 0, Te = 0; Te < X.length; Te++)
      me += H[Te] * X[Te];
    return me = me % 11 === 10 ? 0 : me % 11, me === H[9];
  }
  function m(A) {
    var C = A.split(""), E = C.filter(function(H, X) {
      return X % 2;
    }).map(function(H) {
      return Number(H) * 2;
    }).join("").split(""), J = C.filter(function(H, X) {
      return !(X % 2);
    }).concat(E).map(function(H) {
      return Number(H);
    }).reduce(function(H, X) {
      return H + X;
    });
    return J % 10 === 0;
  }
  function v(A) {
    A = A.replace(/\W/, "");
    var C = parseInt(A.slice(0, 2), 10);
    if (A.length === 10)
      C < 54 ? C = "20".concat(C) : C = "19".concat(C);
    else {
      if (A.slice(6) === "000")
        return !1;
      if (C < 54)
        C = "19".concat(C);
      else
        return !1;
    }
    C.length === 3 && (C = [C.slice(0, 2), "0", C.slice(2)].join(""));
    var E = parseInt(A.slice(2, 4), 10);
    if (E > 50 && (E -= 50), E > 20) {
      if (parseInt(C, 10) < 2004)
        return !1;
      E -= 20;
    }
    E < 10 && (E = "0".concat(E));
    var J = "".concat(C, "/").concat(E, "/").concat(A.slice(4, 6));
    if (!(0, i.default)(J, "YYYY/MM/DD"))
      return !1;
    if (A.length === 10 && parseInt(A, 10) % 11 !== 0) {
      var H = parseInt(A.slice(0, 9), 10) % 11;
      if (parseInt(C, 10) < 1986 && H === 10) {
        if (parseInt(A.slice(9), 10) !== 0)
          return !1;
      } else
        return !1;
    }
    return !0;
  }
  function M(A) {
    return o.luhnCheck(A);
  }
  function x(A) {
    for (var C = A.split("").map(function(G) {
      return parseInt(G, 10);
    }), E = [], J = 0; J < C.length - 1; J++) {
      E.push("");
      for (var H = 0; H < C.length - 1; H++)
        C[J] === C[H] && (E[J] += H);
    }
    if (E = E.filter(function(G) {
      return G.length > 1;
    }), E.length !== 2 && E.length !== 3)
      return !1;
    if (E[0].length === 3) {
      for (var X = E[0].split("").map(function(G) {
        return parseInt(G, 10);
      }), me = 0, Te = 0; Te < X.length - 1; Te++)
        X[Te] + 1 === X[Te + 1] && (me += 1);
      if (me === 2)
        return !1;
    }
    return o.iso7064Check(A);
  }
  function b(A) {
    A = A.replace(/\W/, "");
    var C = parseInt(A.slice(4, 6), 10), E = A.slice(6, 7);
    switch (E) {
      case "0":
      case "1":
      case "2":
      case "3":
        C = "19".concat(C);
        break;
      case "4":
      case "9":
        C < 37 ? C = "20".concat(C) : C = "19".concat(C);
        break;
      default:
        if (C < 37)
          C = "20".concat(C);
        else if (C > 58)
          C = "18".concat(C);
        else
          return !1;
        break;
    }
    C.length === 3 && (C = [C.slice(0, 2), "0", C.slice(2)].join(""));
    var J = "".concat(C, "/").concat(A.slice(2, 4), "/").concat(A.slice(0, 2));
    if (!(0, i.default)(J, "YYYY/MM/DD"))
      return !1;
    for (var H = A.split("").map(function(G) {
      return parseInt(G, 10);
    }), X = 0, me = 4, Te = 0; Te < 9; Te++)
      X += H[Te] * me, me -= 1, me === 1 && (me = 7);
    return X %= 11, X === 1 ? !1 : X === 0 ? H[9] === 0 : H[9] === 11 - X;
  }
  function T(A) {
    for (var C = A.slice(0, 8).split("").map(function(X) {
      return parseInt(X, 10);
    }), E = 0, J = 1; J < C.length; J += 2)
      E += C[J];
    for (var H = 0; H < C.length; H += 2)
      C[H] < 2 ? E += 1 - C[H] : (E += 2 * (C[H] - 2) + 5, C[H] > 4 && (E += 2));
    return String.fromCharCode(E % 26 + 65) === A.charAt(8);
  }
  function w(A) {
    for (var C = A.split("").map(function(H) {
      return parseInt(H, 10);
    }), E = 0, J = 0; J < 8; J++)
      E += C[J] * Math.pow(2, 8 - J);
    return E % 11 % 10 === C[8];
  }
  function y(A) {
    var C = o.reverseMultiplyAndSum(A.split("").slice(0, 7).map(function(E) {
      return parseInt(E, 10);
    }), 8);
    return A.length === 9 && A[8] !== "W" && (C += (A[8].charCodeAt(0) - 64) * 9), C %= 23, C === 0 ? A[7].toUpperCase() === "W" : A[7].toUpperCase() === String.fromCharCode(64 + C);
  }
  var I = {
    andover: ["10", "12"],
    atlanta: ["60", "67"],
    austin: ["50", "53"],
    brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
    cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
    fresno: ["15", "24"],
    internet: ["20", "26", "27", "45", "46", "47"],
    kansas: ["40", "44"],
    memphis: ["94", "95"],
    ogden: ["80", "90"],
    philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
    sba: ["31"]
  };
  function D() {
    var A = [];
    for (var C in I)
      I.hasOwnProperty(C) && A.push.apply(A, c(I[C]));
    return A;
  }
  function O(A) {
    return D().indexOf(A.slice(0, 2)) !== -1;
  }
  function $(A) {
    var C = A.toUpperCase().split("");
    if (isNaN(parseInt(C[0], 10)) && C.length > 1) {
      var E = 0;
      switch (C[0]) {
        case "Y":
          E = 1;
          break;
        case "Z":
          E = 2;
          break;
      }
      C.splice(0, 1, E);
    } else
      for (; C.length < 9; )
        C.unshift(0);
    var J = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
    C = C.join("");
    var H = parseInt(C.slice(0, 8), 10) % 23;
    return C[8] === J[H];
  }
  function z(A) {
    var C = A.slice(1, 3), E = A.slice(0, 1);
    switch (E) {
      case "1":
      case "2":
        C = "18".concat(C);
        break;
      case "3":
      case "4":
        C = "19".concat(C);
        break;
      default:
        C = "20".concat(C);
        break;
    }
    var J = "".concat(C, "/").concat(A.slice(3, 5), "/").concat(A.slice(5, 7));
    if (!(0, i.default)(J, "YYYY/MM/DD"))
      return !1;
    for (var H = A.split("").map(function(ae) {
      return parseInt(ae, 10);
    }), X = 0, me = 1, Te = 0; Te < 10; Te++)
      X += H[Te] * me, me += 1, me === 10 && (me = 1);
    if (X % 11 === 10) {
      X = 0, me = 3;
      for (var G = 0; G < 10; G++)
        X += H[G] * me, me += 1, me === 10 && (me = 1);
      if (X % 11 === 10)
        return H[10] === 0;
    }
    return X % 11 === H[10];
  }
  function Y(A) {
    var C = A.slice(4, 6), E = A.slice(6, 7);
    switch (E) {
      case "+":
        C = "18".concat(C);
        break;
      case "-":
        C = "19".concat(C);
        break;
      default:
        C = "20".concat(C);
        break;
    }
    var J = "".concat(C, "/").concat(A.slice(2, 4), "/").concat(A.slice(0, 2));
    if (!(0, i.default)(J, "YYYY/MM/DD"))
      return !1;
    var H = parseInt(A.slice(0, 6) + A.slice(7, 10), 10) % 31;
    if (H < 10)
      return H === parseInt(A.slice(10), 10);
    H -= 10;
    var X = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
    return X[H] === A.slice(10);
  }
  function j(A) {
    if (A.slice(2, 4) !== "00" || A.slice(4, 6) !== "00") {
      var C = "".concat(A.slice(0, 2), "/").concat(A.slice(2, 4), "/").concat(A.slice(4, 6));
      if (!(0, i.default)(C, "YY/MM/DD"))
        return !1;
    }
    var E = 97 - parseInt(A.slice(0, 9), 10) % 97, J = parseInt(A.slice(9, 11), 10);
    return !(E !== J && (E = 97 - parseInt("2".concat(A.slice(0, 9)), 10) % 97, E !== J));
  }
  function q(A) {
    A = A.replace(/\s/g, "");
    var C = parseInt(A.slice(0, 10), 10) % 511, E = parseInt(A.slice(10, 13), 10);
    return C === E;
  }
  function ee(A) {
    var C = "".concat(A.slice(0, 4), "/").concat(A.slice(4, 6), "/").concat(A.slice(6, 8));
    return !(0, i.default)(C, "YYYY/MM/DD") || !o.luhnCheck(A.slice(0, 12)) ? !1 : o.verhoeffCheck("".concat(A.slice(0, 11)).concat(A[12]));
  }
  function re(A) {
    return o.iso7064Check(A);
  }
  function le(A) {
    for (var C = A.split("").map(function(H) {
      return parseInt(H, 10);
    }), E = 8, J = 1; J < 9; J++)
      E += C[J] * (J + 1);
    return E % 11 === C[9];
  }
  function ye(A) {
    for (var C = !1, E = !1, J = 0; J < 3; J++)
      if (!C && /[AEIOU]/.test(A[J]))
        C = !0;
      else if (!E && C && A[J] === "X")
        E = !0;
      else if (J > 0 && (C && !E && !/[AEIOU]/.test(A[J]) || E && !/X/.test(A[J])))
        return !1;
    return !0;
  }
  function Me(A) {
    var C = A.toUpperCase().split("");
    if (!ye(C.slice(0, 3)) || !ye(C.slice(3, 6)))
      return !1;
    for (var E = [6, 7, 9, 10, 12, 13, 14], J = {
      L: "0",
      M: "1",
      N: "2",
      P: "3",
      Q: "4",
      R: "5",
      S: "6",
      T: "7",
      U: "8",
      V: "9"
    }, H = 0, X = E; H < X.length; H++) {
      var me = X[H];
      C[me] in J && C.splice(me, 1, J[C[me]]);
    }
    var Te = {
      A: "01",
      B: "02",
      C: "03",
      D: "04",
      E: "05",
      H: "06",
      L: "07",
      M: "08",
      P: "09",
      R: "10",
      S: "11",
      T: "12"
    }, G = Te[C[8]], ae = parseInt(C[9] + C[10], 10);
    ae > 40 && (ae -= 40), ae < 10 && (ae = "0".concat(ae));
    var Xe = "".concat(C[6]).concat(C[7], "/").concat(G, "/").concat(ae);
    if (!(0, i.default)(Xe, "YY/MM/DD"))
      return !1;
    for (var gt = 0, yt = 1; yt < C.length - 1; yt += 2) {
      var or = parseInt(C[yt], 10);
      isNaN(or) && (or = C[yt].charCodeAt(0) - 65), gt += or;
    }
    for (var Xt = {
      // Maps of characters at odd places
      A: 1,
      B: 0,
      C: 5,
      D: 7,
      E: 9,
      F: 13,
      G: 15,
      H: 17,
      I: 19,
      J: 21,
      K: 2,
      L: 4,
      M: 18,
      N: 20,
      O: 11,
      P: 3,
      Q: 6,
      R: 8,
      S: 12,
      T: 14,
      U: 16,
      V: 10,
      W: 22,
      X: 25,
      Y: 24,
      Z: 23,
      0: 1,
      1: 0
    }, jt = 0; jt < C.length - 1; jt += 2) {
      var ir = 0;
      if (C[jt] in Xt)
        ir = Xt[C[jt]];
      else {
        var gr = parseInt(C[jt], 10);
        ir = 2 * gr + 1, gr > 4 && (ir += 2);
      }
      gt += ir;
    }
    return String.fromCharCode(65 + gt % 26) === C[15];
  }
  function Ee(A) {
    A = A.replace(/\W/, "");
    var C = A.slice(0, 2);
    if (C !== "32") {
      var E = A.slice(2, 4);
      if (E !== "00") {
        var J = A.slice(4, 6);
        switch (A[6]) {
          case "0":
            J = "18".concat(J);
            break;
          case "1":
            J = "19".concat(J);
            break;
          default:
            J = "20".concat(J);
            break;
        }
        var H = "".concat(J, "/").concat(A.slice(2, 4), "/").concat(C);
        if (!(0, i.default)(H, "YYYY/MM/DD"))
          return !1;
      }
      for (var X = 1101, me = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], Te = 0; Te < A.length - 1; Te++)
        X -= parseInt(A[Te], 10) * me[Te];
      return parseInt(A[10], 10) === X % 11;
    }
    return !0;
  }
  function ne(A) {
    if (A.length !== 9) {
      for (var C = A.toUpperCase().split(""); C.length < 8; )
        C.unshift(0);
      switch (A[7]) {
        case "A":
        case "P":
          if (parseInt(C[6], 10) === 0)
            return !1;
          break;
        default: {
          var E = parseInt(C.join("").slice(0, 5), 10);
          if (E > 32e3)
            return !1;
          var J = parseInt(C.join("").slice(5, 7), 10);
          if (E === J)
            return !1;
        }
      }
    }
    return !0;
  }
  function ue(A) {
    return o.reverseMultiplyAndSum(A.split("").slice(0, 8).map(function(C) {
      return parseInt(C, 10);
    }), 9) % 11 === parseInt(A[8], 10);
  }
  function Ce(A) {
    if (A.length === 10) {
      for (var C = [6, 5, 7, 2, 3, 4, 5, 6, 7], E = 0, J = 0; J < C.length; J++)
        E += parseInt(A[J], 10) * C[J];
      return E %= 11, E === 10 ? !1 : E === parseInt(A[9], 10);
    }
    var H = A.slice(0, 2), X = parseInt(A.slice(2, 4), 10);
    X > 80 ? (H = "18".concat(H), X -= 80) : X > 60 ? (H = "22".concat(H), X -= 60) : X > 40 ? (H = "21".concat(H), X -= 40) : X > 20 ? (H = "20".concat(H), X -= 20) : H = "19".concat(H), X < 10 && (X = "0".concat(X));
    var me = "".concat(H, "/").concat(X, "/").concat(A.slice(4, 6));
    if (!(0, i.default)(me, "YYYY/MM/DD"))
      return !1;
    for (var Te = 0, G = 1, ae = 0; ae < A.length - 1; ae++)
      Te += parseInt(A[ae], 10) * G % 10, G += 2, G > 10 ? G = 1 : G === 5 && (G += 2);
    return Te = 10 - Te % 10, Te === parseInt(A[10], 10);
  }
  function ze(A) {
    if (A.length === 11) {
      var C, E;
      if (C = 0, // Reject known invalid CPFs
      A === "11111111111" || A === "22222222222" || A === "33333333333" || A === "44444444444" || A === "55555555555" || A === "66666666666" || A === "77777777777" || A === "88888888888" || A === "99999999999" || A === "00000000000")
        return !1;
      for (var J = 1; J <= 9; J++)
        C += parseInt(A.substring(J - 1, J), 10) * (11 - J);
      if (E = C * 10 % 11, E === 10 && (E = 0), E !== parseInt(A.substring(9, 10), 10))
        return !1;
      C = 0;
      for (var H = 1; H <= 10; H++)
        C += parseInt(A.substring(H - 1, H), 10) * (12 - H);
      return E = C * 10 % 11, E === 10 && (E = 0), E === parseInt(A.substring(10, 11), 10);
    }
    if (
      // Reject know invalid CNPJs
      A === "00000000000000" || A === "11111111111111" || A === "22222222222222" || A === "33333333333333" || A === "44444444444444" || A === "55555555555555" || A === "66666666666666" || A === "77777777777777" || A === "88888888888888" || A === "99999999999999"
    )
      return !1;
    for (var X = A.length - 2, me = A.substring(0, X), Te = A.substring(X), G = 0, ae = X - 7, Xe = X; Xe >= 1; Xe--)
      G += me.charAt(X - Xe) * ae, ae -= 1, ae < 2 && (ae = 9);
    var gt = G % 11 < 2 ? 0 : 11 - G % 11;
    if (gt !== parseInt(Te.charAt(0), 10))
      return !1;
    X += 1, me = A.substring(0, X), G = 0, ae = X - 7;
    for (var yt = X; yt >= 1; yt--)
      G += me.charAt(X - yt) * ae, ae -= 1, ae < 2 && (ae = 9);
    return gt = G % 11 < 2 ? 0 : 11 - G % 11, gt === parseInt(Te.charAt(1), 10);
  }
  function ke(A) {
    var C = 11 - o.reverseMultiplyAndSum(A.split("").slice(0, 8).map(function(E) {
      return parseInt(E, 10);
    }), 9) % 11;
    return C > 9 ? parseInt(A[8], 10) === 0 : C === parseInt(A[8], 10);
  }
  function tt(A) {
    if (A.slice(0, 4) !== "9000") {
      var C = A.slice(1, 3);
      switch (A[0]) {
        case "1":
        case "2":
          C = "19".concat(C);
          break;
        case "3":
        case "4":
          C = "18".concat(C);
          break;
        case "5":
        case "6":
          C = "20".concat(C);
          break;
      }
      var E = "".concat(C, "/").concat(A.slice(3, 5), "/").concat(A.slice(5, 7));
      if (E.length === 8) {
        if (!(0, i.default)(E, "YY/MM/DD"))
          return !1;
      } else if (!(0, i.default)(E, "YYYY/MM/DD"))
        return !1;
      for (var J = A.split("").map(function(Te) {
        return parseInt(Te, 10);
      }), H = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], X = 0, me = 0; me < H.length; me++)
        X += J[me] * H[me];
      return X % 11 === 10 ? J[12] === 1 : J[12] === X % 11;
    }
    return !0;
  }
  function Ge(A) {
    if (A.length === 9) {
      if (A = A.replace(/\W/, ""), A.slice(6) === "000")
        return !1;
      var C = parseInt(A.slice(0, 2), 10);
      if (C > 53)
        return !1;
      C < 10 ? C = "190".concat(C) : C = "19".concat(C);
      var E = parseInt(A.slice(2, 4), 10);
      E > 50 && (E -= 50), E < 10 && (E = "0".concat(E));
      var J = "".concat(C, "/").concat(E, "/").concat(A.slice(4, 6));
      if (!(0, i.default)(J, "YYYY/MM/DD"))
        return !1;
    }
    return !0;
  }
  function Ne(A) {
    var C = 11 - o.reverseMultiplyAndSum(A.split("").slice(0, 7).map(function(E) {
      return parseInt(E, 10);
    }), 8) % 11;
    return C === 10 ? parseInt(A[7], 10) === 0 : C === parseInt(A[7], 10);
  }
  function Ye(A) {
    var C = A.slice(0);
    A.length > 11 && (C = C.slice(2));
    var E = "", J = C.slice(2, 4), H = parseInt(C.slice(4, 6), 10);
    if (A.length > 11)
      E = A.slice(0, 4);
    else if (E = A.slice(0, 2), A.length === 11 && H < 60) {
      var X = (/* @__PURE__ */ new Date()).getFullYear().toString(), me = parseInt(X.slice(0, 2), 10);
      if (X = parseInt(X, 10), A[6] === "-")
        parseInt("".concat(me).concat(E), 10) > X ? E = "".concat(me - 1).concat(E) : E = "".concat(me).concat(E);
      else if (E = "".concat(me - 1).concat(E), X - parseInt(E, 10) < 100)
        return !1;
    }
    H > 60 && (H -= 60), H < 10 && (H = "0".concat(H));
    var Te = "".concat(E, "/").concat(J, "/").concat(H);
    if (Te.length === 8) {
      if (!(0, i.default)(Te, "YY/MM/DD"))
        return !1;
    } else if (!(0, i.default)(Te, "YYYY/MM/DD"))
      return !1;
    return o.luhnCheck(A.replace(/\W/, ""));
  }
  var Se = {
    "bg-BG": /^\d{10}$/,
    "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
    "de-AT": /^\d{9}$/,
    "de-DE": /^[1-9]\d{10}$/,
    "dk-DK": /^\d{6}-{0,1}\d{4}$/,
    "el-CY": /^[09]\d{7}[A-Z]$/,
    "el-GR": /^([0-4]|[7-9])\d{8}$/,
    "en-CA": /^\d{9}$/,
    "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
    "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
    "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    "fr-BE": /^\d{11}$/,
    "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    "fr-LU": /^\d{13}$/,
    "hr-HR": /^\d{11}$/,
    "hu-HU": /^8\d{9}$/,
    "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    "lv-LV": /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    "nl-NL": /^\d{9}$/,
    "pl-PL": /^\d{10,11}$/,
    "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
    "pt-PT": /^\d{9}$/,
    "ro-RO": /^\d{13}$/,
    "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
    "sl-SI": /^[1-9]\d{7}$/,
    "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/
  };
  Se["lb-LU"] = Se["fr-LU"], Se["lt-LT"] = Se["et-EE"], Se["nl-BE"] = Se["fr-BE"], Se["fr-CA"] = Se["en-CA"];
  var _e = {
    "bg-BG": g,
    "cs-CZ": v,
    "de-AT": M,
    "de-DE": x,
    "dk-DK": b,
    "el-CY": T,
    "el-GR": w,
    "en-CA": m,
    "en-IE": y,
    "en-US": O,
    "es-ES": $,
    "et-EE": z,
    "fi-FI": Y,
    "fr-BE": j,
    "fr-FR": q,
    "fr-LU": ee,
    "hr-HR": re,
    "hu-HU": le,
    "it-IT": Me,
    "lv-LV": Ee,
    "mt-MT": ne,
    "nl-NL": ue,
    "pl-PL": Ce,
    "pt-BR": ze,
    "pt-PT": ke,
    "ro-RO": tt,
    "sk-SK": Ge,
    "sl-SI": Ne,
    "sv-SE": Ye
  };
  _e["lb-LU"] = _e["fr-LU"], _e["lt-LT"] = _e["et-EE"], _e["nl-BE"] = _e["fr-BE"], _e["fr-CA"] = _e["en-CA"];
  var Fe = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, ot = {
    "de-AT": Fe,
    "de-DE": /[\/\\]/g,
    "fr-BE": Fe
  };
  ot["nl-BE"] = ot["fr-BE"];
  function Nt(A) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    (0, n.default)(A);
    var E = A.slice(0);
    if (C in Se)
      return C in ot && (E = E.replace(ot[C], "")), Se[C].test(E) ? C in _e ? _e[C](E) : !0 : !1;
    throw new Error("Invalid locale '".concat(C, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ch, Ch.exports);
var M8 = Ch.exports, ys = {};
Object.defineProperty(ys, "__esModule", {
  value: !0
});
ys.default = w8;
ys.locales = void 0;
var y8 = x8(he);
function x8(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ct = {
  "am-AM": /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
  "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
  "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
  "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
  "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
  "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
  "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
  "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
  "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
  "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
  "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
  "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
  "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
  "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
  "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
  "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
  "ar-TN": /^(\+?216)?[2459]\d{7}$/,
  "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
  "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
  "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
  "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
  "ca-AD": /^(\+376)?[346]\d{5}$/,
  "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
  "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
  "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
  "de-LU": /^(\+352)?((6\d1)\d{6})$/,
  "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
  "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
  "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
  "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
  "en-AU": /^(\+?61|0)4\d{8}$/,
  "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
  "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
  "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
  "en-GB": /^(\+?44|0)7\d{9}$/,
  "en-GG": /^(\+?44|0)1481\d{6}$/,
  "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
  "en-GY": /^(\+592|0)6\d{6}$/,
  "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
  "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
  "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
  "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
  "en-JM": /^(\+?876)?\d{7}$/,
  "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
  "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
  "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
  "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
  "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
  "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
  "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
  "en-MU": /^(\+?230|0)?\d{8}$/,
  "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
  "en-NG": /^(\+?234|0)?[789]\d{9}$/,
  "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
  "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
  "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
  "en-PH": /^(09|\+639)\d{9}$/,
  "en-RW": /^(\+?250|0)?[7]\d{8}$/,
  "en-SG": /^(\+65)?[3689]\d{7}$/,
  "en-SL": /^(\+?232|0)\d{8}$/,
  "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
  "en-UG": /^(\+?256|0)?[7]\d{8}$/,
  "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  "en-ZA": /^(\+?27|0)\d{9}$/,
  "en-ZM": /^(\+?26)?09[567]\d{7}$/,
  "en-ZW": /^(\+263)[0-9]{9}$/,
  "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
  "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
  "es-BO": /^(\+?591)?(6|7)\d{7}$/,
  "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
  "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
  "es-CR": /^(\+506)?[2-8]\d{7}$/,
  "es-CU": /^(\+53|0053)?5\d{7}$/,
  "es-DO": /^(\+?1)?8[024]9\d{7}$/,
  "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
  "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
  "es-ES": /^(\+?34)?[6|7]\d{8}$/,
  "es-PE": /^(\+?51)?9\d{8}$/,
  "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
  "es-NI": /^(\+?505)\d{7,8}$/,
  "es-PA": /^(\+?507)\d{7,8}$/,
  "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
  "es-SV": /^(\+?503)?[67]\d{7}$/,
  "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
  "es-VE": /^(\+?58)?(2|4)\d{9}$/,
  "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
  "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
  "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "fr-BF": /^(\+226|0)[67]\d{7}$/,
  "fr-BJ": /^(\+229)\d{8}$/,
  "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
  "fr-CM": /^(\+?237)6[0-9]{8}$/,
  "fr-FR": /^(\+?33|0)[67]\d{8}$/,
  "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
  "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
  "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
  "fr-PF": /^(\+?689)?8[789]\d{6}$/,
  "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
  "fr-WF": /^(\+681)?\d{6}$/,
  "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
  "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  "ir-IR": /^(\+98|0)?9\d{9}$/,
  "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
  "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
  "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
  "kk-KZ": /^(\+?7|8)?7\d{9}$/,
  "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
  "lt-LT": /^(\+370|8)\d{8}$/,
  "lv-LV": /^(\+?371)2\d{7}$/,
  "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
  "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
  "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
  "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
  "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
  "nb-NO": /^(\+?47)?[49]\d{7}$/,
  "ne-NP": /^(\+?977)?9[78]\d{8}$/,
  "nl-BE": /^(\+?32|0)4\d{8}$/,
  "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
  "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
  "nn-NO": /^(\+?47)?[49]\d{7}$/,
  "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
  "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
  "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
  "pt-AO": /^(\+244)\d{9}$/,
  "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
  "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
  "ru-RU": /^(\+?7|8)?9\d{9}$/,
  "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
  "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
  "sq-AL": /^(\+355|0)6[789]\d{6}$/,
  "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
  "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
  "th-TH": /^(\+66|66|0)\d{9}$/,
  "tr-TR": /^(\+?90|0)?5\d{9}$/,
  "tk-TM": /^(\+993|993|8)\d{8}$/,
  "uk-UA": /^(\+?38|8)?0\d{9}$/,
  "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
  "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
  "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
  "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
  "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
  "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
  "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
  "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
Ct["en-CA"] = Ct["en-US"];
Ct["fr-CA"] = Ct["en-CA"];
Ct["fr-BE"] = Ct["nl-BE"];
Ct["zh-HK"] = Ct["en-HK"];
Ct["zh-MO"] = Ct["en-MO"];
Ct["ga-IE"] = Ct["en-IE"];
Ct["fr-CH"] = Ct["de-CH"];
Ct["it-CH"] = Ct["fr-CH"];
function w8(e, t, r) {
  if ((0, y8.default)(e), r && r.strictMode && !e.startsWith("+"))
    return !1;
  if (Array.isArray(t))
    return t.some(function(i) {
      if (Ct.hasOwnProperty(i)) {
        var a = Ct[i];
        if (a.test(e))
          return !0;
      }
      return !1;
    });
  if (t in Ct)
    return Ct[t].test(e);
  if (!t || t === "any") {
    for (var n in Ct)
      if (Ct.hasOwnProperty(n)) {
        var o = Ct[n];
        if (o.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var T8 = Object.keys(Ct);
ys.locales = T8;
var Ih = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^(0x)[0-9a-f]{40}$/i;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ih, Ih.exports);
var N8 = Ih.exports, Ah = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = o(Tr), n = o(he);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  function i(s) {
    var c = "\\d{".concat(s.digits_after_decimal[0], "}");
    s.digits_after_decimal.forEach(function(M, x) {
      x !== 0 && (c = "".concat(c, "|\\d{").concat(M, "}"));
    });
    var u = "(".concat(s.symbol.replace(/\W/, function(M) {
      return "\\".concat(M);
    }), ")").concat(s.require_symbol ? "" : "?"), d = "-?", f = "[1-9]\\d*", p = "[1-9]\\d{0,2}(\\".concat(s.thousands_separator, "\\d{3})*"), h = ["0", f, p], g = "(".concat(h.join("|"), ")?"), m = "(\\".concat(s.decimal_separator, "(").concat(c, "))").concat(s.require_decimal ? "" : "?"), v = g + (s.allow_decimal || s.require_decimal ? m : "");
    return s.allow_negatives && !s.parens_for_negatives && (s.negative_sign_after_digits ? v += d : s.negative_sign_before_digits && (v = d + v)), s.allow_negative_sign_placeholder ? v = "( (?!\\-))?".concat(v) : s.allow_space_after_symbol ? v = " ?".concat(v) : s.allow_space_after_digits && (v += "( (?!$))?"), s.symbol_after_digits ? v += u : v = u + v, s.allow_negatives && (s.parens_for_negatives ? v = "(\\(".concat(v, "\\)|").concat(v, ")") : s.negative_sign_before_digits || s.negative_sign_after_digits || (v = d + v)), new RegExp("^(?!-? )(?=.*\\d)".concat(v, "$"));
  }
  var a = {
    symbol: "$",
    require_symbol: !1,
    allow_space_after_symbol: !1,
    symbol_after_digits: !1,
    allow_negatives: !0,
    parens_for_negatives: !1,
    negative_sign_before_digits: !1,
    negative_sign_after_digits: !1,
    allow_negative_sign_placeholder: !1,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: !0,
    require_decimal: !1,
    digits_after_decimal: [2],
    allow_space_after_digits: !1
  };
  function l(s, c) {
    return (0, n.default)(s), c = (0, r.default)(c, a), i(c).test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ah, Ah.exports);
var S8 = Ah.exports, Dh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var r = n(he);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = /^(bc1)[a-z0-9]{25,39}$/, i = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
  function a(l) {
    return (0, r.default)(l), o.test(l) || i.test(l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Dh, Dh.exports);
var C8 = Dh.exports, xs = {};
Object.defineProperty(xs, "__esModule", {
  value: !0
});
xs.isISO6346 = iC;
xs.isFreightContainerID = void 0;
var I8 = A8(he);
function A8(e) {
  return e && e.__esModule ? e : { default: e };
}
var D8 = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, k8 = /^[0-9]$/;
function iC(e) {
  if ((0, I8.default)(e), e = e.toUpperCase(), !D8.test(e))
    return !1;
  if (e.length === 11) {
    for (var t = 0, r = 0; r < e.length - 1; r++)
      if (k8.test(e[r]))
        t += e[r] * Math.pow(2, r);
      else {
        var n = void 0, o = e.charCodeAt(r) - 55;
        o < 11 ? n = o : o >= 11 && o <= 20 ? n = 12 + o % 11 : o >= 21 && o <= 30 ? n = 23 + o % 21 : n = 34 + o % 31, t += n * Math.pow(2, r);
      }
    var i = t % 11;
    return Number(e[e.length - 1]) === i;
  }
  return !0;
}
var E8 = iC;
xs.isFreightContainerID = E8;
var kh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
  function i(a) {
    return (0, r.default)(a), o.has(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(kh, kh.exports);
var L8 = kh.exports, Eh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(he);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, i = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = function(c) {
    var u = c.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (u) {
      var d = Number(u[1]), f = Number(u[2]);
      return d % 4 === 0 && d % 100 !== 0 || d % 400 === 0 ? f <= 366 : f <= 365;
    }
    var p = c.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), h = p[1], g = p[2], m = p[3], v = g && "0".concat(g).slice(-2), M = m && "0".concat(m).slice(-2), x = new Date("".concat(h, "-").concat(v || "01", "-").concat(M || "01"));
    return g && m ? x.getUTCFullYear() === h && x.getUTCMonth() + 1 === g && x.getUTCDate() === m : !0;
  };
  function l(s) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, r.default)(s);
    var u = c.strictSeparator ? i.test(s) : o.test(s);
    return u && c.strict ? a(s) : u;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Eh, Eh.exports);
var $8 = Eh.exports, Lh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = v;
  var r = n(he);
  function n(M) {
    return M && M.__esModule ? M : { default: M };
  }
  var o = /[0-9]{4}/, i = /(0[1-9]|1[0-2])/, a = /([12]\d|0[1-9]|3[01])/, l = /([01][0-9]|2[0-3])/, s = /[0-5][0-9]/, c = /([0-5][0-9]|60)/, u = /(\.[0-9]+)?/, d = new RegExp("[-+]".concat(l.source, ":").concat(s.source)), f = new RegExp("([zZ]|".concat(d.source, ")")), p = new RegExp("".concat(l.source, ":").concat(s.source, ":").concat(c.source).concat(u.source)), h = new RegExp("".concat(o.source, "-").concat(i.source, "-").concat(a.source)), g = new RegExp("".concat(p.source).concat(f.source)), m = new RegExp("^".concat(h.source, "[ tT]").concat(g.source, "$"));
  function v(M) {
    return (0, r.default)(M), m.test(M);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Lh, Lh.exports);
var z8 = Lh.exports, $h = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
  function i(a) {
    return (0, r.default)(a), o.has(a.toUpperCase());
  }
  e.exports = t.default, e.exports.default = t.default;
})($h, $h.exports);
var O8 = $h.exports, ws = {};
Object.defineProperty(ws, "__esModule", {
  value: !0
});
ws.default = _8;
ws.CurrencyCodes = void 0;
var j8 = R8(he);
function R8(e) {
  return e && e.__esModule ? e : { default: e };
}
var aC = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
function _8(e) {
  return (0, j8.default)(e), aC.has(e.toUpperCase());
}
var P8 = aC;
ws.CurrencyCodes = P8;
var zh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = o(he), n = o(Tr);
  function o(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var i = /^[A-Z2-7]+=*$/, a = /^[A-HJKMNP-TV-Z0-9]+$/, l = {
    crockford: !1
  };
  function s(c, u) {
    if ((0, r.default)(c), u = (0, n.default)(u, l), u.crockford)
      return a.test(c);
    var d = c.length;
    return !!(d % 8 === 0 && i.test(c));
  }
  e.exports = t.default, e.exports.default = t.default;
})(zh, zh.exports);
var B8 = zh.exports, Oh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[A-HJ-NP-Za-km-z1-9]*$/;
  function i(a) {
    return (0, r.default)(a), !!o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Oh, Oh.exports);
var F8 = Oh.exports, jh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(he);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, i = /^[a-z\-]+=[a-z0-9\-]+$/i, a = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
  function l(s) {
    (0, r.default)(s);
    var c = s.split(",");
    if (c.length < 2)
      return !1;
    var u = c.shift().trim().split(";"), d = u.shift();
    if (d.slice(0, 5) !== "data:")
      return !1;
    var f = d.slice(5);
    if (f !== "" && !o.test(f))
      return !1;
    for (var p = 0; p < u.length; p++)
      if (!(p === u.length - 1 && u[p].toLowerCase() === "base64") && !i.test(u[p]))
        return !1;
    for (var h = 0; h < c.length; h++)
      if (!a.test(c[h]))
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(jh, jh.exports);
var U8 = jh.exports, Rh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
  function i(a) {
    return (0, r.default)(a), a.indexOf("magnet:?") !== 0 ? !1 : o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Rh, Rh.exports);
var H8 = Rh.exports, _h = { exports: {} }, Ph = { exports: {} }, Bh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    if ((0, r.default)(i), a) {
      var l = new RegExp("[".concat(a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
      return i.replace(l, "");
    }
    for (var s = i.length - 1; /\s/.test(i.charAt(s)); )
      s -= 1;
    return i.slice(0, s + 1);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Bh, Bh.exports);
var lC = Bh.exports, Fh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    (0, r.default)(i);
    var l = a ? new RegExp("^[".concat(a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
    return i.replace(l, "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Fh, Fh.exports);
var sC = Fh.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(lC), n = o(sC);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a, l) {
    return (0, r.default)((0, n.default)(a, l), l);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Ph, Ph.exports);
var uC = Ph.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = h;
  var r = i(uC), n = i(qS), o = i(he);
  function i(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function a(g, m) {
    return c(g) || s(g, m) || d(g, m) || l();
  }
  function l() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function s(g, m) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(g)))) {
      var v = [], M = !0, x = !1, b = void 0;
      try {
        for (var T = g[Symbol.iterator](), w; !(M = (w = T.next()).done) && (v.push(w.value), !(m && v.length === m)); M = !0)
          ;
      } catch (y) {
        x = !0, b = y;
      } finally {
        try {
          !M && T.return != null && T.return();
        } finally {
          if (x)
            throw b;
        }
      }
      return v;
    }
  }
  function c(g) {
    if (Array.isArray(g))
      return g;
  }
  function u(g, m) {
    var v;
    if (typeof Symbol > "u" || g[Symbol.iterator] == null) {
      if (Array.isArray(g) || (v = d(g)) || m && g && typeof g.length == "number") {
        v && (g = v);
        var M = 0, x = function() {
        };
        return { s: x, n: function() {
          return M >= g.length ? { done: !0 } : { done: !1, value: g[M++] };
        }, e: function(I) {
          throw I;
        }, f: x };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var b = !0, T = !1, w;
    return { s: function() {
      v = g[Symbol.iterator]();
    }, n: function() {
      var I = v.next();
      return b = I.done, I;
    }, e: function(I) {
      T = !0, w = I;
    }, f: function() {
      try {
        !b && v.return != null && v.return();
      } finally {
        if (T)
          throw w;
      }
    } };
  }
  function d(g, m) {
    if (g) {
      if (typeof g == "string")
        return f(g, m);
      var v = Object.prototype.toString.call(g).slice(8, -1);
      if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set")
        return Array.from(g);
      if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v))
        return f(g, m);
    }
  }
  function f(g, m) {
    (m == null || m > g.length) && (m = g.length);
    for (var v = 0, M = new Array(m); v < m; v++)
      M[v] = g[v];
    return M;
  }
  function p(g) {
    var m = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), v = {
      cc: "",
      bcc: ""
    }, M = !1, x = g.split("&");
    if (x.length > 4)
      return !1;
    var b = u(x), T;
    try {
      for (b.s(); !(T = b.n()).done; ) {
        var w = T.value, y = w.split("="), I = a(y, 2), D = I[0], O = I[1];
        if (D && !m.has(D)) {
          M = !0;
          break;
        }
        O && (D === "cc" || D === "bcc") && (v[D] = O), D && m.delete(D);
      }
    } catch ($) {
      b.e($);
    } finally {
      b.f();
    }
    return M ? !1 : v;
  }
  function h(g, m) {
    if ((0, o.default)(g), g.indexOf("mailto:") !== 0)
      return !1;
    var v = g.replace("mailto:", "").split("?"), M = a(v, 2), x = M[0], b = x === void 0 ? "" : x, T = M[1], w = T === void 0 ? "" : T;
    if (!b && !w)
      return !0;
    var y = p(w);
    return y ? "".concat(b, ",").concat(y.cc, ",").concat(y.bcc).split(",").every(function(I) {
      return I = (0, r.default)(I, " "), I ? (0, n.default)(I, m) : !0;
    }) : !1;
  }
  e.exports = t.default, e.exports.default = t.default;
})(_h, _h.exports);
var Y8 = _h.exports, Uh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = n(he);
  function n(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var o = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, i = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, a = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
  function l(s) {
    return (0, r.default)(s), o.test(s) || i.test(s) || a.test(s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Uh, Uh.exports);
var W8 = Uh.exports, Hh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = o(he), n = o(Tr);
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var i = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, a = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, l = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, s = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, c = {
    checkDMS: !1
  };
  function u(d, f) {
    if ((0, r.default)(d), f = (0, n.default)(f, c), !d.includes(","))
      return !1;
    var p = d.split(",");
    return p[0].startsWith("(") && !p[1].endsWith(")") || p[1].endsWith(")") && !p[0].startsWith("(") ? !1 : f.checkDMS ? l.test(p[0]) && s.test(p[1]) : i.test(p[0]) && a.test(p[1]);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Hh, Hh.exports);
var Q8 = Hh.exports, Ts = {};
Object.defineProperty(Ts, "__esModule", {
  value: !0
});
Ts.default = K8;
Ts.locales = void 0;
var V8 = Z8(he);
function Z8(e) {
  return e && e.__esModule ? e : { default: e };
}
var Qb = /^\d{3}$/, zr = /^\d{4}$/, mr = /^\d{5}$/, rf = /^\d{6}$/, Hi = {
  AD: /^AD\d{3}$/,
  AT: zr,
  AU: zr,
  AZ: /^AZ\d{4}$/,
  BA: /^([7-8]\d{4}$)/,
  BE: zr,
  BG: zr,
  BR: /^\d{5}-\d{3}$/,
  BY: /^2[1-4]\d{4}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: zr,
  CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: mr,
  DK: zr,
  DO: mr,
  DZ: mr,
  EE: mr,
  ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
  FI: mr,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HT: /^HT\d{4}$/,
  HU: zr,
  ID: mr,
  IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
  IL: /^(\d{5}|\d{7})$/,
  IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
  IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
  IS: Qb,
  IT: mr,
  JP: /^\d{3}\-\d{4}$/,
  KE: mr,
  KR: /^(\d{5}|\d{6})$/,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: zr,
  LV: /^LV\-\d{4}$/,
  LK: mr,
  MG: Qb,
  MX: mr,
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
  MY: mr,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: zr,
  NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
  NZ: zr,
  PL: /^\d{2}\-\d{3}$/,
  PR: /^00[679]\d{2}([ -]\d{4})?$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: rf,
  RU: rf,
  SA: mr,
  SE: /^[1-9]\d{2}\s?\d{2}$/,
  SG: rf,
  SI: zr,
  SK: /^\d{3}\s?\d{2}$/,
  TH: mr,
  TN: zr,
  TW: /^\d{3}(\d{2})?$/,
  UA: mr,
  US: /^\d{5}(-\d{4})?$/,
  ZA: zr,
  ZM: mr
}, G8 = Object.keys(Hi);
Ts.locales = G8;
function K8(e, t) {
  if ((0, V8.default)(e), t in Hi)
    return Hi[t].test(e);
  if (t === "any") {
    for (var r in Hi)
      if (Hi.hasOwnProperty(r)) {
        var n = Hi[r];
        if (n.test(e))
          return !0;
      }
    return !1;
  }
  throw new Error("Invalid locale '".concat(t, "'"));
}
var Yh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i), i.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Yh, Yh.exports);
var q8 = Yh.exports, Wh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i) {
    return (0, r.default)(i), i.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Wh, Wh.exports);
var J8 = Wh.exports, Qh = { exports: {} }, Vh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    return (0, r.default)(i), i.replace(new RegExp("[".concat(a, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Vh, Vh.exports);
var cC = Vh.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = o(he), n = o(cC);
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a, l) {
    (0, r.default)(a);
    var s = l ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
    return (0, n.default)(a, s);
  }
  e.exports = t.default, e.exports.default = t.default;
})(Qh, Qh.exports);
var X8 = Qh.exports, Zh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    return (0, r.default)(i), i.replace(new RegExp("[^".concat(a, "]+"), "g"), "");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Zh, Zh.exports);
var eF = Zh.exports, Gh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = n(he);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function o(i, a) {
    (0, r.default)(i);
    for (var l = i.length - 1; l >= 0; l--)
      if (a.indexOf(i[l]) === -1)
        return !1;
    return !0;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Gh, Gh.exports);
var tF = Gh.exports, Kh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = n(Tr);
  function n(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var o = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: !0,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: !0,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: !0,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: !0,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: !0,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: !0,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: !0,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: !0,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: !0,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: !0
  }, i = ["icloud.com", "me.com"], a = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], l = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], s = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
  function c(d) {
    return d.length > 1 ? d : "";
  }
  function u(d, f) {
    f = (0, r.default)(f, o);
    var p = d.split("@"), h = p.pop(), g = p.join("@"), m = [g, h];
    if (m[1] = m[1].toLowerCase(), m[1] === "gmail.com" || m[1] === "googlemail.com") {
      if (f.gmail_remove_subaddress && (m[0] = m[0].split("+")[0]), f.gmail_remove_dots && (m[0] = m[0].replace(/\.+/g, c)), !m[0].length)
        return !1;
      (f.all_lowercase || f.gmail_lowercase) && (m[0] = m[0].toLowerCase()), m[1] = f.gmail_convert_googlemaildotcom ? "gmail.com" : m[1];
    } else if (i.indexOf(m[1]) >= 0) {
      if (f.icloud_remove_subaddress && (m[0] = m[0].split("+")[0]), !m[0].length)
        return !1;
      (f.all_lowercase || f.icloud_lowercase) && (m[0] = m[0].toLowerCase());
    } else if (a.indexOf(m[1]) >= 0) {
      if (f.outlookdotcom_remove_subaddress && (m[0] = m[0].split("+")[0]), !m[0].length)
        return !1;
      (f.all_lowercase || f.outlookdotcom_lowercase) && (m[0] = m[0].toLowerCase());
    } else if (l.indexOf(m[1]) >= 0) {
      if (f.yahoo_remove_subaddress) {
        var v = m[0].split("-");
        m[0] = v.length > 1 ? v.slice(0, -1).join("-") : v[0];
      }
      if (!m[0].length)
        return !1;
      (f.all_lowercase || f.yahoo_lowercase) && (m[0] = m[0].toLowerCase());
    } else
      s.indexOf(m[1]) >= 0 ? ((f.all_lowercase || f.yandex_lowercase) && (m[0] = m[0].toLowerCase()), m[1] = "yandex.ru") : f.all_lowercase && (m[0] = m[0].toLowerCase());
    return m.join("@");
  }
  e.exports = t.default, e.exports.default = t.default;
})(Kh, Kh.exports);
var rF = Kh.exports, qh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
  function i(a) {
    return (0, r.default)(a), o.test(a);
  }
  e.exports = t.default, e.exports.default = t.default;
})(qh, qh.exports);
var nF = qh.exports, Jh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = n(he);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var o = {
    "cs-CZ": function(l) {
      return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(l);
    },
    "de-DE": function(l) {
      return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(l);
    },
    "de-LI": function(l) {
      return /^FL[- ]?\d{1,5}[UZ]?$/.test(l);
    },
    "en-IN": function(l) {
      return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(l);
    },
    "es-AR": function(l) {
      return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(l);
    },
    "fi-FI": function(l) {
      return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(l);
    },
    "hu-HU": function(l) {
      return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(l);
    },
    "pt-BR": function(l) {
      return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(l);
    },
    "pt-PT": function(l) {
      return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(l);
    },
    "sq-AL": function(l) {
      return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(l);
    },
    "sv-SE": function(l) {
      return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(l.trim());
    }
  };
  function i(a, l) {
    if ((0, r.default)(a), l in o)
      return o[l](a);
    if (l === "any") {
      for (var s in o) {
        var c = o[s];
        if (c(a))
          return !0;
      }
      return !1;
    }
    throw new Error("Invalid locale '".concat(l, "'"));
  }
  e.exports = t.default, e.exports.default = t.default;
})(Jh, Jh.exports);
var oF = Jh.exports, Xh = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var r = o(Tr), n = o(he);
  function o(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var i = /^[A-Z]$/, a = /^[a-z]$/, l = /^[0-9]$/, s = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/, c = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: !1,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  function u(h) {
    var g = {};
    return Array.from(h).forEach(function(m) {
      var v = g[m];
      v ? g[m] += 1 : g[m] = 1;
    }), g;
  }
  function d(h) {
    var g = u(h), m = {
      length: h.length,
      uniqueChars: Object.keys(g).length,
      uppercaseCount: 0,
      lowercaseCount: 0,
      numberCount: 0,
      symbolCount: 0
    };
    return Object.keys(g).forEach(function(v) {
      i.test(v) ? m.uppercaseCount += g[v] : a.test(v) ? m.lowercaseCount += g[v] : l.test(v) ? m.numberCount += g[v] : s.test(v) && (m.symbolCount += g[v]);
    }), m;
  }
  function f(h, g) {
    var m = 0;
    return m += h.uniqueChars * g.pointsPerUnique, m += (h.length - h.uniqueChars) * g.pointsPerRepeat, h.lowercaseCount > 0 && (m += g.pointsForContainingLower), h.uppercaseCount > 0 && (m += g.pointsForContainingUpper), h.numberCount > 0 && (m += g.pointsForContainingNumber), h.symbolCount > 0 && (m += g.pointsForContainingSymbol), m;
  }
  function p(h) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0, n.default)(h);
    var m = d(h);
    return g = (0, r.default)(g || {}, c), g.returnScore ? f(m, g) : m.length >= g.minLength && m.lowercaseCount >= g.minLowercase && m.uppercaseCount >= g.minUppercase && m.numberCount >= g.minNumbers && m.symbolCount >= g.minSymbols;
  }
  e.exports = t.default, e.exports.default = t.default;
})(Xh, Xh.exports);
var iF = Xh.exports, Ns = {};
function Mu(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mu = function(r) {
    return typeof r;
  } : Mu = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Mu(e);
}
Object.defineProperty(Ns, "__esModule", {
  value: !0
});
Ns.default = dF;
Ns.vatMatchers = void 0;
var Vb = sF(he), aF = lF(Ti);
function dC() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return dC = function() {
    return e;
  }, e;
}
function lF(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || Mu(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = dC();
  if (t && t.has(e))
    return t.get(e);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      var i = n ? Object.getOwnPropertyDescriptor(e, o) : null;
      i && (i.get || i.set) ? Object.defineProperty(r, o, i) : r[o] = e[o];
    }
  return r.default = e, t && t.set(e, r), r;
}
function sF(e) {
  return e && e.__esModule ? e : { default: e };
}
var uF = function(t) {
  var r = function(o) {
    var i = o.pop(), a = [5, 4, 3, 2, 7, 6, 5, 4], l = (11 - o.reduce(function(s, c, u) {
      return s + c * a[u];
    }, 0) % 11) % 11;
    return i === l;
  };
  return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(t) && r(t.match(/\d/g).map(function(n) {
    return +n;
  }));
}, cF = function(t) {
  var r = t.match(/^(PT)?(\d{9})$/);
  if (!r)
    return !1;
  var n = r[2], o = 11 - aF.reverseMultiplyAndSum(n.split("").slice(0, 8).map(function(i) {
    return parseInt(i, 10);
  }), 9) % 11;
  return o > 9 ? parseInt(n[8], 10) === 0 : o === parseInt(n[8], 10);
}, eg = {
  /**
   * European Union VAT identification numbers
   */
  AT: function(t) {
    return /^(AT)?U\d{8}$/.test(t);
  },
  BE: function(t) {
    return /^(BE)?\d{10}$/.test(t);
  },
  BG: function(t) {
    return /^(BG)?\d{9,10}$/.test(t);
  },
  HR: function(t) {
    return /^(HR)?\d{11}$/.test(t);
  },
  CY: function(t) {
    return /^(CY)?\w{9}$/.test(t);
  },
  CZ: function(t) {
    return /^(CZ)?\d{8,10}$/.test(t);
  },
  DK: function(t) {
    return /^(DK)?\d{8}$/.test(t);
  },
  EE: function(t) {
    return /^(EE)?\d{9}$/.test(t);
  },
  FI: function(t) {
    return /^(FI)?\d{8}$/.test(t);
  },
  FR: function(t) {
    return /^(FR)?\w{2}\d{9}$/.test(t);
  },
  DE: function(t) {
    return /^(DE)?\d{9}$/.test(t);
  },
  EL: function(t) {
    return /^(EL)?\d{9}$/.test(t);
  },
  HU: function(t) {
    return /^(HU)?\d{8}$/.test(t);
  },
  IE: function(t) {
    return /^(IE)?\d{7}\w{1}(W)?$/.test(t);
  },
  IT: function(t) {
    return /^(IT)?\d{11}$/.test(t);
  },
  LV: function(t) {
    return /^(LV)?\d{11}$/.test(t);
  },
  LT: function(t) {
    return /^(LT)?\d{9,12}$/.test(t);
  },
  LU: function(t) {
    return /^(LU)?\d{8}$/.test(t);
  },
  MT: function(t) {
    return /^(MT)?\d{8}$/.test(t);
  },
  NL: function(t) {
    return /^(NL)?\d{9}B\d{2}$/.test(t);
  },
  PL: function(t) {
    return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(t);
  },
  PT: cF,
  RO: function(t) {
    return /^(RO)?\d{2,10}$/.test(t);
  },
  SK: function(t) {
    return /^(SK)?\d{10}$/.test(t);
  },
  SI: function(t) {
    return /^(SI)?\d{8}$/.test(t);
  },
  ES: function(t) {
    return /^(ES)?\w\d{7}[A-Z]$/.test(t);
  },
  SE: function(t) {
    return /^(SE)?\d{12}$/.test(t);
  },
  /**
   * VAT numbers of non-EU countries
   */
  AL: function(t) {
    return /^(AL)?\w{9}[A-Z]$/.test(t);
  },
  MK: function(t) {
    return /^(MK)?\d{13}$/.test(t);
  },
  AU: function(t) {
    return /^(AU)?\d{11}$/.test(t);
  },
  BY: function(t) {
    return /^(УНП )?\d{9}$/.test(t);
  },
  CA: function(t) {
    return /^(CA)?\d{9}$/.test(t);
  },
  IS: function(t) {
    return /^(IS)?\d{5,6}$/.test(t);
  },
  IN: function(t) {
    return /^(IN)?\d{15}$/.test(t);
  },
  ID: function(t) {
    return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(t);
  },
  IL: function(t) {
    return /^(IL)?\d{9}$/.test(t);
  },
  KZ: function(t) {
    return /^(KZ)?\d{9}$/.test(t);
  },
  NZ: function(t) {
    return /^(NZ)?\d{9}$/.test(t);
  },
  NG: function(t) {
    return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(t);
  },
  NO: function(t) {
    return /^(NO)?\d{9}MVA$/.test(t);
  },
  PH: function(t) {
    return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(t);
  },
  RU: function(t) {
    return /^(RU)?(\d{10}|\d{12})$/.test(t);
  },
  SM: function(t) {
    return /^(SM)?\d{5}$/.test(t);
  },
  SA: function(t) {
    return /^(SA)?\d{15}$/.test(t);
  },
  RS: function(t) {
    return /^(RS)?\d{9}$/.test(t);
  },
  CH: uF,
  TR: function(t) {
    return /^(TR)?\d{10}$/.test(t);
  },
  UA: function(t) {
    return /^(UA)?\d{12}$/.test(t);
  },
  GB: function(t) {
    return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(t);
  },
  UZ: function(t) {
    return /^(UZ)?\d{9}$/.test(t);
  },
  /**
   * VAT numbers of Latin American countries
   */
  AR: function(t) {
    return /^(AR)?\d{11}$/.test(t);
  },
  BO: function(t) {
    return /^(BO)?\d{7}$/.test(t);
  },
  BR: function(t) {
    return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(t);
  },
  CL: function(t) {
    return /^(CL)?\d{8}-\d{1}$/.test(t);
  },
  CO: function(t) {
    return /^(CO)?\d{10}$/.test(t);
  },
  CR: function(t) {
    return /^(CR)?\d{9,12}$/.test(t);
  },
  EC: function(t) {
    return /^(EC)?\d{13}$/.test(t);
  },
  SV: function(t) {
    return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(t);
  },
  GT: function(t) {
    return /^(GT)?\d{7}-\d{1}$/.test(t);
  },
  HN: function(t) {
    return /^(HN)?$/.test(t);
  },
  MX: function(t) {
    return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(t);
  },
  NI: function(t) {
    return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(t);
  },
  PA: function(t) {
    return /^(PA)?$/.test(t);
  },
  PY: function(t) {
    return /^(PY)?\d{6,8}-\d{1}$/.test(t);
  },
  PE: function(t) {
    return /^(PE)?\d{11}$/.test(t);
  },
  DO: function(t) {
    return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(t);
  },
  UY: function(t) {
    return /^(UY)?\d{12}$/.test(t);
  },
  VE: function(t) {
    return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(t);
  }
};
Ns.vatMatchers = eg;
function dF(e, t) {
  if ((0, Vb.default)(e), (0, Vb.default)(t), t in eg)
    return eg[t](e);
  throw new Error("Invalid country code: '".concat(t, "'"));
}
(function(e, t) {
  function r(it) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(Sr) {
      return typeof Sr;
    } : r = function(Sr) {
      return Sr && typeof Symbol == "function" && Sr.constructor === Symbol && Sr !== Symbol.prototype ? "symbol" : typeof Sr;
    }, r(it);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = ce(Bm), o = ce(ZS), i = ce(G9), a = ce(K9), l = ce(q9), s = ce(J9), c = ce(X9), u = ce(qS), d = ce(eB), f = ce(tB), p = ce(Xc), h = ce(rB), g = ce(Fm), m = ce(JS), v = ce(nB), M = ce(oB), x = ce(iB), b = Nn(vs), T = Nn(bs), w = ce(hB), y = ce(gB), I = ce(mB), D = ce(vB), O = ce(bB), $ = ce(MB), z = ce(yB), Y = ce(Ea), j = ce(La), q = ce(IB), ee = ce(AB), re = ce(kB), le = ce(EB), ye = ce(Um), Me = Nn(ka), Ee = ce($B), ne = ce(tC), ue = ce(zB), Ce = ce(OB), ze = ce(jB), ke = ce(RB), tt = ce(_B), Ge = ce(PB), Ne = Nn(Ms), Ye = ce(qB), Se = ce(JB), _e = ce(XB), Fe = ce(e8), ot = ce(t8), Nt = ce(r8), A = ce(n8), C = ce(KS), E = ce(o8), J = ce(i8), H = ce(a8), X = ce(l8), me = ce(s8), Te = ce(oC), G = ce(u8), ae = ce(c8), Xe = ce(d8), gt = ce(f8), yt = ce(p8), or = ce(h8), Xt = ce(M8), jt = Nn(ys), ir = ce(N8), gr = ce(S8), K = ce(C8), P = xs, k = ce(L8), U = ce($8), ie = ce(z8), xe = ce($a), Ie = ce(O8), Ae = ce(ws), Le = ce(B8), rt = ce(F8), At = ce(nC), Wr = ce(U8), $r = ce(H8), jo = ce(Y8), un = ce(W8), Qr = ce(Q8), Ei = Nn(Ts), Ha = ce(sC), Li = ce(lC), ao = ce(uC), R = ce(q8), oe = ce(J8), $e = ce(X8), ut = ce(eF), bt = ce(cC), st = ce(tF), cn = ce(rF), dn = ce(nF), fn = ce(oF), Fn = ce(iF), Un = ce(Ns);
  function lo() {
    if (typeof WeakMap != "function")
      return null;
    var it = /* @__PURE__ */ new WeakMap();
    return lo = function() {
      return it;
    }, it;
  }
  function Nn(it) {
    if (it && it.__esModule)
      return it;
    if (it === null || r(it) !== "object" && typeof it != "function")
      return { default: it };
    var Sn = lo();
    if (Sn && Sn.has(it))
      return Sn.get(it);
    var Sr = {}, wd = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Ro in it)
      if (Object.prototype.hasOwnProperty.call(it, Ro)) {
        var $i = wd ? Object.getOwnPropertyDescriptor(it, Ro) : null;
        $i && ($i.get || $i.set) ? Object.defineProperty(Sr, Ro, $i) : Sr[Ro] = it[Ro];
      }
    return Sr.default = it, Sn && Sn.set(it, Sr), Sr;
  }
  function ce(it) {
    return it && it.__esModule ? it : { default: it };
  }
  var Ya = "13.11.0", Wa = {
    version: Ya,
    toDate: n.default,
    toFloat: o.default,
    toInt: i.default,
    toBoolean: a.default,
    equals: l.default,
    contains: s.default,
    matches: c.default,
    isEmail: u.default,
    isURL: d.default,
    isMACAddress: f.default,
    isIP: p.default,
    isIPRange: h.default,
    isFQDN: g.default,
    isBoolean: M.default,
    isIBAN: Ne.default,
    isBIC: Ye.default,
    isAlpha: b.default,
    isAlphaLocales: b.locales,
    isAlphanumeric: T.default,
    isAlphanumericLocales: T.locales,
    isNumeric: w.default,
    isPassportNumber: y.default,
    isPort: I.default,
    isLowercase: D.default,
    isUppercase: O.default,
    isAscii: z.default,
    isFullWidth: Y.default,
    isHalfWidth: j.default,
    isVariableWidth: q.default,
    isMultibyte: ee.default,
    isSemVer: re.default,
    isSurrogatePair: le.default,
    isInt: ye.default,
    isIMEI: $.default,
    isFloat: Me.default,
    isFloatLocales: Me.locales,
    isDecimal: Ee.default,
    isHexadecimal: ne.default,
    isOctal: ue.default,
    isDivisibleBy: Ce.default,
    isHexColor: ze.default,
    isRgbColor: ke.default,
    isHSL: tt.default,
    isISRC: Ge.default,
    isMD5: Se.default,
    isHash: _e.default,
    isJWT: Fe.default,
    isJSON: ot.default,
    isEmpty: Nt.default,
    isLength: A.default,
    isLocale: x.default,
    isByteLength: C.default,
    isUUID: E.default,
    isMongoId: J.default,
    isAfter: H.default,
    isBefore: X.default,
    isIn: me.default,
    isLuhnNumber: Te.default,
    isCreditCard: G.default,
    isIdentityCard: ae.default,
    isEAN: Xe.default,
    isISIN: gt.default,
    isISBN: yt.default,
    isISSN: or.default,
    isMobilePhone: jt.default,
    isMobilePhoneLocales: jt.locales,
    isPostalCode: Ei.default,
    isPostalCodeLocales: Ei.locales,
    isEthereumAddress: ir.default,
    isCurrency: gr.default,
    isBtcAddress: K.default,
    isISO6346: P.isISO6346,
    isFreightContainerID: P.isFreightContainerID,
    isISO6391: k.default,
    isISO8601: U.default,
    isRFC3339: ie.default,
    isISO31661Alpha2: xe.default,
    isISO31661Alpha3: Ie.default,
    isISO4217: Ae.default,
    isBase32: Le.default,
    isBase58: rt.default,
    isBase64: At.default,
    isDataURI: Wr.default,
    isMagnetURI: $r.default,
    isMailtoURI: jo.default,
    isMimeType: un.default,
    isLatLong: Qr.default,
    ltrim: Ha.default,
    rtrim: Li.default,
    trim: ao.default,
    escape: R.default,
    unescape: oe.default,
    stripLow: $e.default,
    whitelist: ut.default,
    blacklist: bt.default,
    isWhitelisted: st.default,
    normalizeEmail: cn.default,
    toString,
    isSlug: dn.default,
    isStrongPassword: Fn.default,
    isTaxID: Xt.default,
    isDate: m.default,
    isTime: v.default,
    isLicensePlate: fn.default,
    isVAT: Un.default,
    ibanLocales: Ne.locales
  }, so = Wa;
  t.default = so, e.exports = t.default, e.exports.default = t.default;
})(sp, sp.exports);
var Ji = sp.exports, fF = typeof global == "object" && global && global.Object === Object && global;
const fC = fF;
var pF = typeof self == "object" && self && self.Object === Object && self, hF = fC || pF || Function("return this")();
const Pn = hF;
var gF = Pn.Symbol;
const jn = gF;
var pC = Object.prototype, mF = pC.hasOwnProperty, vF = pC.toString, qa = jn ? jn.toStringTag : void 0;
function bF(e) {
  var t = mF.call(e, qa), r = e[qa];
  try {
    e[qa] = void 0;
    var n = !0;
  } catch {
  }
  var o = vF.call(e);
  return n && (t ? e[qa] = r : delete e[qa]), o;
}
var MF = Object.prototype, yF = MF.toString;
function xF(e) {
  return yF.call(e);
}
var wF = "[object Null]", TF = "[object Undefined]", Zb = jn ? jn.toStringTag : void 0;
function za(e) {
  return e == null ? e === void 0 ? TF : wF : Zb && Zb in Object(e) ? bF(e) : xF(e);
}
function ca(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var NF = "[object AsyncFunction]", SF = "[object Function]", CF = "[object GeneratorFunction]", IF = "[object Proxy]";
function hC(e) {
  if (!ca(e))
    return !1;
  var t = za(e);
  return t == SF || t == CF || t == NF || t == IF;
}
var AF = Pn["__core-js_shared__"];
const nf = AF;
var Gb = function() {
  var e = /[^.]+$/.exec(nf && nf.keys && nf.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function DF(e) {
  return !!Gb && Gb in e;
}
var kF = Function.prototype, EF = kF.toString;
function Ni(e) {
  if (e != null) {
    try {
      return EF.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var LF = /[\\^$.*+?()[\]{}|]/g, $F = /^\[object .+?Constructor\]$/, zF = Function.prototype, OF = Object.prototype, jF = zF.toString, RF = OF.hasOwnProperty, _F = RegExp(
  "^" + jF.call(RF).replace(LF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function PF(e) {
  if (!ca(e) || DF(e))
    return !1;
  var t = hC(e) ? _F : $F;
  return t.test(Ni(e));
}
function BF(e, t) {
  return e == null ? void 0 : e[t];
}
function Si(e, t) {
  var r = BF(e, t);
  return PF(r) ? r : void 0;
}
var FF = Si(Object, "create");
const Zl = FF;
function UF() {
  this.__data__ = Zl ? Zl(null) : {}, this.size = 0;
}
function HF(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var YF = "__lodash_hash_undefined__", WF = Object.prototype, QF = WF.hasOwnProperty;
function VF(e) {
  var t = this.__data__;
  if (Zl) {
    var r = t[e];
    return r === YF ? void 0 : r;
  }
  return QF.call(t, e) ? t[e] : void 0;
}
var ZF = Object.prototype, GF = ZF.hasOwnProperty;
function KF(e) {
  var t = this.__data__;
  return Zl ? t[e] !== void 0 : GF.call(t, e);
}
var qF = "__lodash_hash_undefined__";
function JF(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Zl && t === void 0 ? qF : t, this;
}
function pi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
pi.prototype.clear = UF;
pi.prototype.delete = HF;
pi.prototype.get = VF;
pi.prototype.has = KF;
pi.prototype.set = JF;
function XF() {
  this.__data__ = [], this.size = 0;
}
function gC(e, t) {
  return e === t || e !== e && t !== t;
}
function ed(e, t) {
  for (var r = e.length; r--; )
    if (gC(e[r][0], t))
      return r;
  return -1;
}
var e6 = Array.prototype, t6 = e6.splice;
function r6(e) {
  var t = this.__data__, r = ed(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : t6.call(t, r, 1), --this.size, !0;
}
function n6(e) {
  var t = this.__data__, r = ed(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function o6(e) {
  return ed(this.__data__, e) > -1;
}
function i6(e, t) {
  var r = this.__data__, n = ed(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function no(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
no.prototype.clear = XF;
no.prototype.delete = r6;
no.prototype.get = n6;
no.prototype.has = o6;
no.prototype.set = i6;
var a6 = Si(Pn, "Map");
const Gl = a6;
function l6() {
  this.size = 0, this.__data__ = {
    hash: new pi(),
    map: new (Gl || no)(),
    string: new pi()
  };
}
function s6(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function td(e, t) {
  var r = e.__data__;
  return s6(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function u6(e) {
  var t = td(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function c6(e) {
  return td(this, e).get(e);
}
function d6(e) {
  return td(this, e).has(e);
}
function f6(e, t) {
  var r = td(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function oo(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
oo.prototype.clear = l6;
oo.prototype.delete = u6;
oo.prototype.get = c6;
oo.prototype.has = d6;
oo.prototype.set = f6;
var p6 = "__lodash_hash_undefined__";
function h6(e) {
  return this.__data__.set(e, p6), this;
}
function g6(e) {
  return this.__data__.has(e);
}
function da(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new oo(); ++t < r; )
    this.add(e[t]);
}
da.prototype.add = da.prototype.push = h6;
da.prototype.has = g6;
function m6(e, t, r, n) {
  for (var o = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function v6(e) {
  return e !== e;
}
function b6(e, t, r) {
  for (var n = r - 1, o = e.length; ++n < o; )
    if (e[n] === t)
      return n;
  return -1;
}
function M6(e, t, r) {
  return t === t ? b6(e, t, r) : m6(e, v6, r);
}
function mC(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && M6(e, t, 0) > -1;
}
function vC(e, t, r) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
function bC(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
    o[r] = t(e[r], r, e);
  return o;
}
function MC(e) {
  return function(t) {
    return e(t);
  };
}
function Hm(e, t) {
  return e.has(t);
}
var y6 = 200;
function x6(e, t, r, n) {
  var o = -1, i = mC, a = !0, l = e.length, s = [], c = t.length;
  if (!l)
    return s;
  r && (t = bC(t, MC(r))), n ? (i = vC, a = !1) : t.length >= y6 && (i = Hm, a = !1, t = new da(t));
  e:
    for (; ++o < l; ) {
      var u = e[o], d = r == null ? u : r(u);
      if (u = n || u !== 0 ? u : 0, a && d === d) {
        for (var f = c; f--; )
          if (t[f] === d)
            continue e;
        s.push(u);
      } else
        i(t, d, n) || s.push(u);
    }
  return s;
}
function yC(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n; )
    e[o + r] = t[r];
  return e;
}
function hi(e) {
  return e != null && typeof e == "object";
}
var w6 = "[object Arguments]";
function Kb(e) {
  return hi(e) && za(e) == w6;
}
var xC = Object.prototype, T6 = xC.hasOwnProperty, N6 = xC.propertyIsEnumerable, S6 = Kb(function() {
  return arguments;
}()) ? Kb : function(e) {
  return hi(e) && T6.call(e, "callee") && !N6.call(e, "callee");
};
const rd = S6;
var C6 = Array.isArray;
const bn = C6;
var qb = jn ? jn.isConcatSpreadable : void 0;
function I6(e) {
  return bn(e) || rd(e) || !!(qb && e && e[qb]);
}
function Ym(e, t, r, n, o) {
  var i = -1, a = e.length;
  for (r || (r = I6), o || (o = []); ++i < a; ) {
    var l = e[i];
    t > 0 && r(l) ? t > 1 ? Ym(l, t - 1, r, n, o) : yC(o, l) : n || (o[o.length] = l);
  }
  return o;
}
function Wm(e) {
  return e;
}
function A6(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Jb = Math.max;
function D6(e, t, r) {
  return t = Jb(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, o = -1, i = Jb(n.length - t, 0), a = Array(i); ++o < i; )
      a[o] = n[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = n[o];
    return l[t] = r(a), A6(e, this, l);
  };
}
function k6(e) {
  return function() {
    return e;
  };
}
var E6 = function() {
  try {
    var e = Si(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Xb = E6;
var L6 = Xb ? function(e, t) {
  return Xb(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: k6(t),
    writable: !0
  });
} : Wm;
const $6 = L6;
var z6 = 800, O6 = 16, j6 = Date.now;
function R6(e) {
  var t = 0, r = 0;
  return function() {
    var n = j6(), o = O6 - (n - r);
    if (r = n, o > 0) {
      if (++t >= z6)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var _6 = R6($6);
const P6 = _6;
function wC(e, t) {
  return P6(D6(e, t, Wm), e + "");
}
var B6 = 9007199254740991;
function Qm(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= B6;
}
function Vm(e) {
  return e != null && Qm(e.length) && !hC(e);
}
function Qu(e) {
  return hi(e) && Vm(e);
}
var F6 = wC(function(e, t) {
  return Qu(e) ? x6(e, Ym(t, 1, Qu, !0)) : [];
});
const U6 = F6;
var H6 = "[object Symbol]";
function nd(e) {
  return typeof e == "symbol" || hi(e) && za(e) == H6;
}
var Y6 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, W6 = /^\w*$/;
function Zm(e, t) {
  if (bn(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || nd(e) ? !0 : W6.test(e) || !Y6.test(e) || t != null && e in Object(t);
}
var Q6 = "Expected a function";
function od(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Q6);
  var r = function() {
    var n = arguments, o = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, n);
    return r.cache = i.set(o, a) || i, a;
  };
  return r.cache = new (od.Cache || oo)(), r;
}
od.Cache = oo;
var V6 = 500;
function Z6(e) {
  var t = od(e, function(n) {
    return r.size === V6 && r.clear(), n;
  }), r = t.cache;
  return t;
}
var G6 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, K6 = /\\(\\)?/g, q6 = Z6(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(G6, function(r, n, o, i) {
    t.push(o ? i.replace(K6, "$1") : n || r);
  }), t;
});
const J6 = q6;
var X6 = 1 / 0, eM = jn ? jn.prototype : void 0, tM = eM ? eM.toString : void 0;
function TC(e) {
  if (typeof e == "string")
    return e;
  if (bn(e))
    return bC(e, TC) + "";
  if (nd(e))
    return tM ? tM.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -X6 ? "-0" : t;
}
function eU(e) {
  return e == null ? "" : TC(e);
}
function NC(e, t) {
  return bn(e) ? e : Zm(e, t) ? [e] : J6(eU(e));
}
var tU = 1 / 0;
function id(e) {
  if (typeof e == "string" || nd(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -tU ? "-0" : t;
}
function SC(e, t) {
  t = NC(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[id(t[r++])];
  return r && r == n ? e : void 0;
}
function Zi(e, t, r) {
  var n = e == null ? void 0 : SC(e, t);
  return n === void 0 ? r : n;
}
var rU = Object.prototype;
function CC(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || rU;
  return e === r;
}
function nU(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var oU = nU(Object.keys, Object);
const iU = oU;
var aU = Object.prototype, lU = aU.hasOwnProperty;
function IC(e) {
  if (!CC(e))
    return iU(e);
  var t = [];
  for (var r in Object(e))
    lU.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var sU = Si(Pn, "DataView");
const tg = sU;
var uU = Si(Pn, "Promise");
const rg = uU;
var cU = Si(Pn, "Set");
const Xi = cU;
var dU = Si(Pn, "WeakMap");
const ng = dU;
var rM = "[object Map]", fU = "[object Object]", nM = "[object Promise]", oM = "[object Set]", iM = "[object WeakMap]", aM = "[object DataView]", pU = Ni(tg), hU = Ni(Gl), gU = Ni(rg), mU = Ni(Xi), vU = Ni(ng), Ho = za;
(tg && Ho(new tg(new ArrayBuffer(1))) != aM || Gl && Ho(new Gl()) != rM || rg && Ho(rg.resolve()) != nM || Xi && Ho(new Xi()) != oM || ng && Ho(new ng()) != iM) && (Ho = function(e) {
  var t = za(e), r = t == fU ? e.constructor : void 0, n = r ? Ni(r) : "";
  if (n)
    switch (n) {
      case pU:
        return aM;
      case hU:
        return rM;
      case gU:
        return nM;
      case mU:
        return oM;
      case vU:
        return iM;
    }
  return t;
});
const og = Ho;
function bU() {
  return !1;
}
var AC = typeof exports == "object" && exports && !exports.nodeType && exports, lM = AC && typeof module == "object" && module && !module.nodeType && module, MU = lM && lM.exports === AC, sM = MU ? Pn.Buffer : void 0, yU = sM ? sM.isBuffer : void 0, xU = yU || bU;
const Vu = xU;
var wU = "[object Arguments]", TU = "[object Array]", NU = "[object Boolean]", SU = "[object Date]", CU = "[object Error]", IU = "[object Function]", AU = "[object Map]", DU = "[object Number]", kU = "[object Object]", EU = "[object RegExp]", LU = "[object Set]", $U = "[object String]", zU = "[object WeakMap]", OU = "[object ArrayBuffer]", jU = "[object DataView]", RU = "[object Float32Array]", _U = "[object Float64Array]", PU = "[object Int8Array]", BU = "[object Int16Array]", FU = "[object Int32Array]", UU = "[object Uint8Array]", HU = "[object Uint8ClampedArray]", YU = "[object Uint16Array]", WU = "[object Uint32Array]", wt = {};
wt[RU] = wt[_U] = wt[PU] = wt[BU] = wt[FU] = wt[UU] = wt[HU] = wt[YU] = wt[WU] = !0;
wt[wU] = wt[TU] = wt[OU] = wt[NU] = wt[jU] = wt[SU] = wt[CU] = wt[IU] = wt[AU] = wt[DU] = wt[kU] = wt[EU] = wt[LU] = wt[$U] = wt[zU] = !1;
function QU(e) {
  return hi(e) && Qm(e.length) && !!wt[za(e)];
}
var DC = typeof exports == "object" && exports && !exports.nodeType && exports, fl = DC && typeof module == "object" && module && !module.nodeType && module, VU = fl && fl.exports === DC, of = VU && fC.process, ZU = function() {
  try {
    var e = fl && fl.require && fl.require("util").types;
    return e || of && of.binding && of.binding("util");
  } catch {
  }
}();
const uM = ZU;
var cM = uM && uM.isTypedArray, GU = cM ? MC(cM) : QU;
const Gm = GU;
var KU = "[object Map]", qU = "[object Set]", JU = Object.prototype, XU = JU.hasOwnProperty;
function Mr(e) {
  if (e == null)
    return !0;
  if (Vm(e) && (bn(e) || typeof e == "string" || typeof e.splice == "function" || Vu(e) || Gm(e) || rd(e)))
    return !e.length;
  var t = og(e);
  if (t == KU || t == qU)
    return !e.size;
  if (CC(e))
    return !IC(e).length;
  for (var r in e)
    if (XU.call(e, r))
      return !1;
  return !0;
}
const e7 = `.toolbar-button__icon{width:16px;height:16px;color:#000}.toolbar-button__icon--medium{width:20px;height:20px}.toolbar-group__container{display:flex;align-items:center;gap:8px}.ProseMirror{font-family:Verdana,sans-serif;font-size:1rem;overflow:hidden;outline:none;height:100%;text-align:left}.ProseMirror ul{display:block;list-style-type:disc;margin-top:1em;margin-bottom:1 em;margin-left:0;margin-right:0;padding-left:40px}.ProseMirror ol{display:block;list-style-type:decimal;margin:1em 0;padding-left:40px}.ProseMirror h1{display:block;font-size:2em;margin:.67em 0;font-weight:700}.ProseMirror h2{display:block;font-size:1.5em;margin:.83em 0;font-weight:700}.ProseMirror h3{display:block;font-size:1.17em;margin:1em 0;font-weight:700}.ProseMirror h4{display:block;font-size:1em;margin:1.33em 0;font-weight:700}.ProseMirror h5{display:block;font-size:.83em;margin:1.67em 0;font-weight:700}.ProseMirror h6{display:block;font-size:.67em;margin:2.33em 0;font-weight:700}.ProseMirror p{display:block;margin:1em 0}.ProseMirror code{background-color:#6161611a;color:#616161}.ProseMirror pre code{color:inherit;padding:0;background:none;font-size:.8rem}.ProseMirror video{max-width:100%;height:auto}.ProseMirror audio{pointer-events:none}.ProseMirror img.ProseMirror-selectednode,.ProseMirror video.ProseMirror-selectednode,.ProseMirror div[data-audio-embed].ProseMirror-selectednode,.ProseMirror div[data-code-embed-container].ProseMirror-selectednode{border:2px solid #188bf6}.ProseMirror div.ProseMirror-selectednode iframe{border:2px solid #188bf6}.ProseMirror div[data-code-embed-container]{padding:2px}.ProseMirror blockquote{padding-left:1rem;border-left:2px solid rgba(13,13,13,.1)}.ProseMirror hr{border:none;border-top:2px solid rgba(13,13,13,.1);margin:2rem 0}.ProseMirror a{color:#335dff;text-decoration:underline}.ProseMirror input[type=checkbox]{border-radius:4px;width:1rem;height:1rem}.ProseMirror div[data-youtube-video] a{pointer-events:none}.ProseMirror iframe{pointer-events:none;max-width:100%}.ProseMirror mark{color:inherit}.ProseMirror.preview iframe{pointer-events:all}.ProseMirror.preview p{min-height:24px}.ProseMirror.preview h1{min-height:40px}.ProseMirror.preview h2{min-height:32px}.ProseMirror.preview h3{min-height:25px}.ProseMirror.preview h4{min-height:22px}.ProseMirror.preview h5{min-height:20px}.ProseMirror.preview audio{pointer-events:initial}.ProseMirror.preview div[data-code-embed-placeholder]{display:none}.ProseMirror ul[data-type=taskList]{list-style:none;padding:0;margin-top:0}.ProseMirror ul[data-type=taskList] p{margin:0}.ProseMirror ul[data-type=taskList] li{display:flex}.ProseMirror ul[data-type=taskList] li>label{flex:0 0 auto;margin-right:.5rem;-webkit-user-select:none;user-select:none}.ProseMirror ul[data-type=taskList] li>div{flex:1 1 auto}.ProseMirror table.rte-table{border-collapse:collapse;table-layout:fixed;width:100%;margin:0;overflow:hidden}.ProseMirror table.rte-table td,.ProseMirror table.rte-table th{min-width:1em;border:2px solid #ced4da;padding:3px 5px;vertical-align:top;box-sizing:border-box;position:relative}.ProseMirror table.rte-table td>*,.ProseMirror table.rte-table th>*{margin-bottom:0}.ProseMirror table.rte-table th{font-weight:700;text-align:left;background-color:#f1f3f5}.ProseMirror table.rte-table .selectedCell:after{z-index:2;position:absolute;content:"";left:0;right:0;top:0;bottom:0;background:rgba(200,200,255,.4);pointer-events:none}.ProseMirror table.rte-table .column-resize-handle{position:absolute;right:-2px;top:0;bottom:-2px;width:4px;background-color:#adf;pointer-events:none}.ProseMirror table.rte-table p{margin:0}.CodeMirror{font-family:monospace!important;color:#000;font-size:15px;width:100%;height:500px!important}.CodeMirror-linenumber{left:-18px!important}.CodeMirror-gutters{left:0!important}.CodeMirror pre{white-space:pre-wrap;word-break:break-all;word-wrap:break-word}.ProseMirror p.is-empty:before,.ProseMirror p.is-editor-empty:first-child:before{color:var(--text-color);content:attr(data-placeholder);float:left;height:0;pointer-events:none}.ProseMirror a>span{text-decoration:underline;color:inherit}.tableWrapper{padding:1rem 0;overflow-x:auto}.resize-cursor{cursor:ew-resize;cursor:col-resize}
`, dM = (e, t = !0) => t ? Math.round(e * Math.pow(10, -6)) : (e * Math.pow(10, -6)).toFixed(1), t7 = od((e) => new Promise((t, r) => {
  const n = new XMLHttpRequest();
  n.open("GET", e, !0), n.responseType = "blob", n.onload = function() {
    t({ resourceDetails: n.response });
  }, n.onerror = r, n.send();
})), Ht = ({
  name: e,
  deps: t = [],
  editor: r,
  condition: n = "all"
}) => {
  if (!r)
    throw new Error("Editor instance is missing");
  let o = !1, i = [];
  const a = (r == null ? void 0 : r.extensionManager.extensions.map((s) => s.name)) ?? [], l = [...t, "_requiredExtensions"];
  return n === "all" ? (i = U6(l, a), o = Mr(i)) : o = l.some((s) => a.includes(s)), !Zi(r, [
    "options",
    "editorProps",
    "attributes",
    "data-extension-warning"
  ]) && n === "all" && !o && console.warn(
    `Unable to load the ${e} extension, Please check if All the extension is passed to the editor. Needed extensions are - ${i}`
  ), o;
}, r7 = ({ r: e, g: t, b: r, a: n }) => `rgba(${e},${t},${r},${n})`, fM = /^{{.{1,}}}$/im, kC = new RegExp(
  ["http://", "https://", "tel:", "mailto:"].join("|"),
  "im"
), EC = (e = "") => {
  if (fM.test(e))
    return !0;
  const t = e.split(kC).reduce((n, o) => [...n, ...o.split("/")], []).map((n) => n.trim());
  let r = !1;
  for (let n = 0; n < t.length; n++)
    if (fM.test(t[n])) {
      r = !0;
      break;
    }
  return r;
}, n7 = (e = "") => {
  const t = e == null ? void 0 : e.trim();
  return t.startsWith("tel:") ? Ji.isMobilePhone(t == null ? void 0 : t.split("tel:")[1]) : t != null && t.startsWith("mailto:") ? Ji.isMailtoURI(t) : Ji.isURL(t);
}, o7 = (e) => {
  const r = "(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)" + "(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?";
  return new RegExp("^" + r + "$", "gi").test(e);
}, ig = (e = "") => !!(o7(e) || EC(e) || n7(e)), Sue = (e) => {
  const t = e.state.toJSON().doc.content;
  let r = "";
  return t.forEach((n, o) => {
    n != null && n.content ? r += n.content[0].text + (o === t.length - 1 ? "" : `
`) : r += `
`;
  }), r;
}, Cue = (e) => {
  let t = "";
  return e.length && e.split(`
`).forEach((r) => {
    r === "" ? t += "<p></p>" : t += `<p>${r}</p>`;
  }), t.length ? t : e;
}, LC = (e) => {
  const t = e == null ? void 0 : e.trim();
  return kC.test(t) || EC(t) || !t ? e : Ji.isURL(t, { required_protocols: !0 }) ? `http://${e}` : e;
}, i7 = (e, t) => {
  const r = [];
  return !(t != null && t.trim()) || !(e != null && e.length) ? e : (e.forEach((n) => {
    var o;
    if ((o = n.children) != null && o.length) {
      const i = n.children.filter(
        (a) => a.value.toLowerCase() === t.toLowerCase()
      );
      i.length > 0 && r.push(...i);
    } else
      n.value.toLowerCase() === t.toLowerCase() && r.push(n);
  }), r);
}, Iue = () => e7, a7 = (e) => {
  if (e) {
    if (e.includes("pt")) {
      const t = +e.split("pt")[0];
      return `${Math.round(t * (4 / 3))}px`;
    }
    return e;
  }
}, Aue = (e) => {
  let t = e;
  return t = t.replace(/<p(\s+[^>]*?)?><\/p>/g, "<br/>"), t = t.replace(/<li>(<br\/>)?<\/li>/g, ""), t;
}, Due = (e) => {
  let t = e;
  return t = t.replace(/<br\/>/gi, '<p style="margin: 0px;"></p>'), t;
}, l7 = (e) => e ? e.split(/[- ]+/).map((n) => n[0].toUpperCase() + n.substring(1)).join(" ") : void 0, $C = (e) => {
  const t = e.split(";").filter((o) => o !== "").map((o) => o.trim()), r = {};
  let n = "";
  t.forEach((o) => {
    if (o.length) {
      const [i, a] = o.split(":").map((l) => l.trim()).filter((l) => l !== "");
      i in r || (r[i] = a);
    }
  });
  for (const o in r)
    n += `${o}: ${r[o]};`;
  return n;
}, s7 = ["src"], u7 = {
  name: "RTEControlBlockQuote",
  inheritAttrs: !1
}, pl = /* @__PURE__ */ Z({
  ...u7,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = wr(), o = L(!0), i = () => {
      t.editor && (o.value = !Ht({
        editor: t.editor,
        name: "Quote",
        deps: ["blockquote"]
      }));
    };
    return et(() => {
      i();
    }), Zt(() => {
      i();
    }), (a, l) => {
      var s;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonQuote,
        active: (s = e.editor) == null ? void 0 : s.isActive("blockquote"),
        disabled: o.value,
        onOnClick: l[0] || (l[0] = (c) => {
          var u;
          return (u = e.editor) == null ? void 0 : u.chain().focus().toggleBlockquote().run();
        }),
        "tooltip-label": e.tooltipLabel ?? N(r).common.blockquote,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          N(n).icon ? Re(a.$slots, "icon", { key: 0 }) : (_(), be("img", {
            key: 1,
            src: N(b9),
            class: "toolbar-button__icon"
          }, null, 8, s7))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
pl.install = (e) => {
  e.component(pl.name, pl);
};
function c7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 19c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.86 3 8.361 3 7.364 3H6.83c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4.069 4.33 4.02 4.608 4 5m12.619-2h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874C20 4.52 20 5.08 20 6.2v11.6c0 1.12 0 1.68-.194 2.108-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.904 1.904 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C15.123 3 15.622 3 16.619 3zM4 9v6m-3-3h6"
    })
  ]);
}
function d7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C15.14 3 15.639 3 16.636 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908M7.381 3h-.534c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4 4.52 4 5.08 4 6.2v11.6c0 1.12 0 1.68.194 2.108.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.877 3 8.378 3 7.381 3zM20 9v6m-3-3h6"
    })
  ]);
}
function f7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 20.002c-.392-.022-.67-.07-.908-.177a1.905 1.905 0 01-.874-.777C3 18.668 3 18.17 3 17.174v-.533c0-.996 0-1.494.218-1.874.192-.335.498-.606.874-.777.428-.194.988-.194 2.108-.194h11.6c1.12 0 1.68 0 2.108.194.376.17.682.442.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.238.107-.516.155-.908.177M3 7.396v-.533c0-.996 0-1.494.218-1.874.192-.334.498-.606.874-.777.428-.193.988-.193 2.108-.193h11.6c1.12 0 1.68 0 2.108.193.376.17.682.443.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.428.194-.988.194-2.108.194H6.2c-1.12 0-1.68 0-2.108-.194a1.904 1.904 0 01-.874-.777C3 8.89 3 8.392 3 7.396zM12 17v6m-3-3h6"
    })
  ]);
}
function p7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 4.017c-.392.021-.67.07-.908.177-.376.17-.682.442-.874.777C3 5.35 3 5.849 3 6.844v.534c0 .995 0 1.493.218 1.874.192.334.498.606.874.776.428.194.988.194 2.108.194h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.776.218-.38.218-.879.218-1.874v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.238-.108-.516-.156-.908-.177M3 16.622v.534c0 .995 0 1.493.218 1.873.192.335.498.607.874.777C4.52 20 5.08 20 6.2 20h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.777.218-.38.218-.878.218-1.873v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.428-.194-.988-.194-2.108-.194H6.2c-1.12 0-1.68 0-2.108.194-.376.17-.682.442-.874.777C3 15.129 3 15.627 3 16.622zM12 1v6M9 4h6"
    })
  ]);
}
function h7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 10H6m15-4H3m18 8H3m15 4H6"
    })
  ]);
}
function g7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10H3m18 8H3M21 6H3m18 8H3"
    })
  ]);
}
function m7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16 10H3m17-4H3m17 8H3m13 4H3"
    })
  ]);
}
function v7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 10H8m13-4H4m17 8H4m17 4H8"
    })
  ]);
}
function b7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12h8a4 4 0 000-8H6v8zm0 0h9a4 4 0 010 8H6v-8z"
    })
  ]);
}
function M7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 17l5-5-5-5M7 7l-5 5 5 5m7-14l-4 18"
    })
  ]);
}
function y7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.5 15l3-3-3-3m-5 0l-3 3 3 3m-1.7 6h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C5.28 21 6.12 21 7.8 21z"
    })
  ]);
}
function x7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 19c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.107-.238-.155-.516-.177-.908M20 5c-.021-.392-.07-.67-.177-.908a1.905 1.905 0 00-.778-.874C18.665 3 18.166 3 17.17 3h-.534c-.997 0-1.495 0-1.876.218a1.905 1.905 0 00-.778.874c-.107.238-.155.516-.177.908M7.381 3h-.534c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C4 4.52 4 5.08 4 6.2v11.6c0 1.12 0 1.68.194 2.108.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C8.877 3 8.378 3 7.381 3z"
    }),
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 9l-6 6m0-6l6 6"
    })
  ]);
}
function w7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM19 13a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function zC(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 01-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 11-4 0 2 2 0 014 0z"
    })
  ]);
}
function T7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 4h-9m4 16H5M15 4L9 20"
    })
  ]);
}
function N7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 9h18M3 15h18M12 3v18M7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3z"
    })
  ]);
}
function OC(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 17H7A5 5 0 017 7h2m6 10h2a5 5 0 000-10h-2m-8 5h10"
    })
  ]);
}
function S7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 10V8A5 5 0 007 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 21 7.12 21 8.8 21z"
    })
  ]);
}
function C7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 10V8a5 5 0 019.584-2M12 14.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 21 7.12 21 8.8 21z"
    })
  ]);
}
function I7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.21 19c-.02.392-.068.67-.176.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874C3 19.48 3 18.92 3 17.8V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C4.35 3 4.85 3 5.847 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908m5.578 14c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874C21 19.48 21 18.92 21 17.8V6.2c0-1.12 0-1.68-.194-2.108a1.904 1.904 0 00-.778-.874C19.65 3 19.15 3 18.153 3h-.534c-.996 0-1.495 0-1.875.218a1.904 1.904 0 00-.778.874c-.108.238-.156.516-.177.908M10 12L7 9m3 3l-3 3m3-3H3m11 0l3-3m-3 3l3 3m-3-3h7"
    })
  ]);
}
function A7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 20.002c-.392-.022-.67-.07-.908-.177a1.905 1.905 0 01-.874-.777C3 18.668 3 18.17 3 17.174v-.533c0-.996 0-1.494.218-1.874.192-.335.498-.606.874-.777.238-.107.516-.155.908-.177m14 6.188c.392-.02.67-.069.908-.176.376-.17.682-.443.874-.777.218-.38.218-.878.218-1.874v-.533c0-.996 0-1.494-.218-1.874a1.904 1.904 0 00-.874-.777c-.238-.107-.516-.155-.908-.177M3 7.396v-.533c0-.996 0-1.494.218-1.874.192-.334.498-.606.874-.777.428-.193.988-.193 2.108-.193h11.6c1.12 0 1.68 0 2.108.193.376.17.682.443.874.777.218.38.218.878.218 1.874v.533c0 .996 0 1.494-.218 1.874a1.904 1.904 0 01-.874.777c-.428.194-.988.194-2.108.194H6.2c-1.12 0-1.68 0-2.108-.194a1.904 1.904 0 01-.874-.777C3 8.89 3 8.392 3 7.396z"
    }),
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 14l-6 6m0-6l6 6"
    })
  ]);
}
function D7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 19c.021.392.07.67.177.908.17.376.443.682.778.874.38.218.879.218 1.875.218h.534c.997 0 1.495 0 1.876-.218.335-.192.607-.498.778-.874.194-.428.194-.988.194-2.108V6.2c0-1.12 0-1.68-.194-2.108a1.905 1.905 0 00-.778-.874C7.86 3 7.361 3 6.364 3H5.83c-.996 0-1.495 0-1.875.218a1.905 1.905 0 00-.778.874C3.069 4.33 3.02 4.608 3 5m18 14c-.021.392-.07.67-.177.908-.17.376-.443.682-.778.874-.38.218-.879.218-1.875.218h-.534c-.997 0-1.495 0-1.876-.218a1.905 1.905 0 01-.778-.874c-.194-.428-.194-.988-.194-2.108V6.2c0-1.12 0-1.68.194-2.108.17-.376.443-.682.778-.874C16.14 3 16.639 3 17.636 3h.534c.996 0 1.495 0 1.875.218.335.192.607.498.778.874.108.238.156.516.177.908M2 12l3-3m-3 3l3 3m-3-3h7m13 0l-3-3m3 3l-3 3m3-3h-7"
    })
  ]);
}
function k7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 16a4 4 0 004 4h4a4 4 0 000-8m4-4a4 4 0 00-4-4h-4a4 4 0 00-4 4m-3 4h18"
    })
  ]);
}
function E7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C3 5.28 3 6.12 3 7.8V9m9-6h4.2c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8V9m-9-6v6m9 0v6m0-6h-9m9 6v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311M21 15h-2.5M3 15v1.2c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311M3 15V9m0 6h2.5M3 9h9m0 0v3.5m3 2.5l-3 3m0 0l-3 3m3-3l-3-3m3 3l3 3"
    })
  ]);
}
function L7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 8h.01M2 5.2v4.475c0 .489 0 .733.055.963.05.204.13.4.24.579.123.201.296.374.642.72l7.669 7.669c1.188 1.188 1.782 1.782 2.467 2.004a3 3 0 001.854 0c.685-.222 1.28-.816 2.467-2.004l2.212-2.212c1.188-1.188 1.782-1.782 2.004-2.467a3 3 0 000-1.854c-.222-.685-.816-1.28-2.004-2.467l-7.669-7.669c-.346-.346-.519-.519-.72-.642a2.001 2.001 0 00-.579-.24C10.409 2 10.165 2 9.676 2H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C2 3.52 2 4.08 2 5.2zM8.5 8a.5.5 0 11-1 0 .5.5 0 011 0z"
    })
  ]);
}
function $7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 20h8m-5.75-9.5V20m3.5-6v6M3 3l18 18M4 7V6c0-.541.215-1.032.564-1.392M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C20 5.602 20 6.068 20 7m-9.75-3v1m3.5-1v4"
    })
  ]);
}
function z7(e, t) {
  return _(), be("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    de("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 4v7a6 6 0 01-12 0V4M4 21h16"
    })
  ]);
}
const O7 = {
  name: "RTEControlBold",
  inheritAttrs: !1
}, hl = /* @__PURE__ */ Z({
  ...O7,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Bold",
        deps: ["bold"]
      }));
    };
    return et(() => {
      o();
    }), Zt(() => {
      o();
    }), (i, a) => {
      var l;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonBold,
        active: (l = e.editor) == null ? void 0 : l.isActive("bold"),
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (s) => {
          var c;
          return (c = e.editor) == null ? void 0 : c.chain().focus().toggleBold().run();
        }),
        "tooltip-label": e.tooltipLabel ?? N(r).common.bold,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          B(N(b7), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
hl.install = (e) => {
  e.component(hl.name, hl);
};
const j7 = {
  name: "RTEControlCode",
  inheritAttrs: !1
}, ea = /* @__PURE__ */ Z({
  ...j7,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    type: {
      type: String,
      default: "inline"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = wr(), r = e, n = De("locale") ?? ht[r.language], o = L(!0), i = () => {
      r.type === "block" ? o.value = !Ht({
        editor: r.editor,
        name: "Code Block",
        deps: ["codeBlock"]
      }) : o.value = !Ht({
        editor: r.editor,
        name: "Inline Code Block",
        deps: ["inlineCode"]
      });
    };
    et(() => {
      i();
    }), Zt(() => {
      i();
    });
    const a = W(() => r.type === "block" ? {
      id: Ue.toolbarButtonCodeBlock,
      name: "codeBlock",
      icon: y7
    } : {
      id: Ue.toolbarButtonInlineCode,
      name: "inlineCode",
      icon: M7
    }), l = () => {
      var s, c;
      return r.type === "block" ? (s = r == null ? void 0 : r.editor) == null ? void 0 : s.chain().focus().toggleCodeBlock().run() : (c = r == null ? void 0 : r.editor) == null ? void 0 : c.chain().focus().toggleInlineCode().run();
    };
    return (s, c) => {
      var u;
      return _(), se(Je, {
        id: a.value.id,
        active: (u = e.editor) == null ? void 0 : u.isActive(a.value.name),
        disabled: o.value,
        onOnClick: l,
        "tooltip-label": e.tooltipLabel ?? N(n).common.code,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          N(t).icon ? Re(s.$slots, "icon", { key: 0 }) : (_(), se(Jn(a.value.icon), {
            key: 1,
            class: "toolbar-button__icon"
          }))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
ea.install = (e) => {
  e.component(ea.name, ea);
};
function jC(e, t, r) {
  for (let n = 0; ; n++) {
    if (n == e.childCount || n == t.childCount)
      return e.childCount == t.childCount ? null : r;
    let o = e.child(n), i = t.child(n);
    if (o == i) {
      r += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return r;
    if (o.isText && o.text != i.text) {
      for (let a = 0; o.text[a] == i.text[a]; a++)
        r++;
      return r;
    }
    if (o.content.size || i.content.size) {
      let a = jC(o.content, i.content, r + 1);
      if (a != null)
        return a;
    }
    r += o.nodeSize;
  }
}
function RC(e, t, r, n) {
  for (let o = e.childCount, i = t.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: r, b: n };
    let a = e.child(--o), l = t.child(--i), s = a.nodeSize;
    if (a == l) {
      r -= s, n -= s;
      continue;
    }
    if (!a.sameMarkup(l))
      return { a: r, b: n };
    if (a.isText && a.text != l.text) {
      let c = 0, u = Math.min(a.text.length, l.text.length);
      for (; c < u && a.text[a.text.length - c - 1] == l.text[l.text.length - c - 1]; )
        c++, r--, n--;
      return { a: r, b: n };
    }
    if (a.content.size || l.content.size) {
      let c = RC(a.content, l.content, r - 1, n - 1);
      if (c)
        return c;
    }
    r -= s, n -= s;
  }
}
class pe {
  /**
  @internal
  */
  constructor(t, r) {
    if (this.content = t, this.size = r || 0, r == null)
      for (let n = 0; n < t.length; n++)
        this.size += t[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, r, n, o = 0, i) {
    for (let a = 0, l = 0; l < r; a++) {
      let s = this.content[a], c = l + s.nodeSize;
      if (c > t && n(s, o + l, i || null, a) !== !1 && s.content.size) {
        let u = l + 1;
        s.nodesBetween(Math.max(0, t - u), Math.min(s.content.size, r - u), n, o + u);
      }
      l = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, r, n, o) {
    let i = "", a = !0;
    return this.nodesBetween(t, r, (l, s) => {
      l.isText ? (i += l.text.slice(Math.max(t, s) - s, r - s), a = !n) : l.isLeaf ? (o ? i += typeof o == "function" ? o(l) : o : l.type.spec.leafText && (i += l.type.spec.leafText(l)), a = !n) : !a && l.isBlock && (i += n, a = !0);
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let r = this.lastChild, n = t.firstChild, o = this.content.slice(), i = 0;
    for (r.isText && r.sameMarkup(n) && (o[o.length - 1] = r.withText(r.text + n.text), i = 1); i < t.content.length; i++)
      o.push(t.content[i]);
    return new pe(o, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, r = this.size) {
    if (t == 0 && r == this.size)
      return this;
    let n = [], o = 0;
    if (r > t)
      for (let i = 0, a = 0; a < r; i++) {
        let l = this.content[i], s = a + l.nodeSize;
        s > t && ((a < t || s > r) && (l.isText ? l = l.cut(Math.max(0, t - a), Math.min(l.text.length, r - a)) : l = l.cut(Math.max(0, t - a - 1), Math.min(l.content.size, r - a - 1))), n.push(l), o += l.nodeSize), a = s;
      }
    return new pe(n, o);
  }
  /**
  @internal
  */
  cutByIndex(t, r) {
    return t == r ? pe.empty : t == 0 && r == this.content.length ? this : new pe(this.content.slice(t, r));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, r) {
    let n = this.content[t];
    if (n == r)
      return this;
    let o = this.content.slice(), i = this.size + r.nodeSize - n.nodeSize;
    return o[t] = r, new pe(o, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new pe([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new pe(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let r = 0; r < this.content.length; r++)
      if (!this.content[r].eq(t.content[r]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let r = this.content[t];
    if (!r)
      throw new RangeError("Index " + t + " out of range for " + this);
    return r;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let r = 0, n = 0; r < this.content.length; r++) {
      let o = this.content[r];
      t(o, n, r), n += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, r = 0) {
    return jC(this, t, r);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, r = this.size, n = t.size) {
    return RC(this, t, r, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(t, r = -1) {
    if (t == 0)
      return Js(0, t);
    if (t == this.size)
      return Js(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let n = 0, o = 0; ; n++) {
      let i = this.child(n), a = o + i.nodeSize;
      if (a >= t)
        return a == t || r > 0 ? Js(n + 1, a) : Js(n, o);
      o = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, r) {
    if (!r)
      return pe.empty;
    if (!Array.isArray(r))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new pe(r.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return pe.empty;
    let r, n = 0;
    for (let o = 0; o < t.length; o++) {
      let i = t[o];
      n += i.nodeSize, o && i.isText && t[o - 1].sameMarkup(i) ? (r || (r = t.slice(0, o)), r[r.length - 1] = i.withText(r[r.length - 1].text + i.text)) : r && r.push(i);
    }
    return new pe(r || t, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return pe.empty;
    if (t instanceof pe)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new pe([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
pe.empty = new pe([], 0);
const af = { index: 0, offset: 0 };
function Js(e, t) {
  return af.index = e, af.offset = t, af;
}
function ag(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let r = Array.isArray(e);
  if (Array.isArray(t) != r)
    return !1;
  if (r) {
    if (e.length != t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!ag(e[n], t[n]))
        return !1;
  } else {
    for (let n in e)
      if (!(n in t) || !ag(e[n], t[n]))
        return !1;
    for (let n in t)
      if (!(n in e))
        return !1;
  }
  return !0;
}
let jr = class lg {
  /**
  @internal
  */
  constructor(t, r) {
    this.type = t, this.attrs = r;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let r, n = !1;
    for (let o = 0; o < t.length; o++) {
      let i = t[o];
      if (this.eq(i))
        return t;
      if (this.type.excludes(i.type))
        r || (r = t.slice(0, o));
      else {
        if (i.type.excludes(this.type))
          return t;
        !n && i.type.rank > this.type.rank && (r || (r = t.slice(0, o)), r.push(this), n = !0), r && r.push(i);
      }
    }
    return r || (r = t.slice()), n || r.push(this), r;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let r = 0; r < t.length; r++)
      if (this.eq(t[r]))
        return t.slice(0, r).concat(t.slice(r + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let r = 0; r < t.length; r++)
      if (this.eq(t[r]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && ag(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let r in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, r) {
    if (!r)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = t.marks[r.type];
    if (!n)
      throw new RangeError(`There is no mark type ${r.type} in this schema`);
    return n.create(r.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, r) {
    if (t == r)
      return !0;
    if (t.length != r.length)
      return !1;
    for (let n = 0; n < t.length; n++)
      if (!t[n].eq(r[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return lg.none;
    if (t instanceof lg)
      return [t];
    let r = t.slice();
    return r.sort((n, o) => n.type.rank - o.type.rank), r;
  }
};
jr.none = [];
class R7 extends Error {
}
class we {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, r, n) {
    this.content = t, this.openStart = r, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, r) {
    let n = PC(this.content, t + this.openStart, r);
    return n && new we(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, r) {
    return new we(_C(this.content, t + this.openStart, r + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, r) {
    if (!r)
      return we.empty;
    let n = r.openStart || 0, o = r.openEnd || 0;
    if (typeof n != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new we(pe.fromJSON(t, r.content), n, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, r = !0) {
    let n = 0, o = 0;
    for (let i = t.firstChild; i && !i.isLeaf && (r || !i.type.spec.isolating); i = i.firstChild)
      n++;
    for (let i = t.lastChild; i && !i.isLeaf && (r || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new we(t, n, o);
  }
}
we.empty = new we(pe.empty, 0, 0);
function _C(e, t, r) {
  let { index: n, offset: o } = e.findIndex(t), i = e.maybeChild(n), { index: a, offset: l } = e.findIndex(r);
  if (o == t || i.isText) {
    if (l != r && !e.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(r));
  }
  if (n != a)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(n, i.copy(_C(i.content, t - o - 1, r - o - 1)));
}
function PC(e, t, r, n) {
  let { index: o, offset: i } = e.findIndex(t), a = e.maybeChild(o);
  if (i == t || a.isText)
    return n && !n.canReplace(o, o, r) ? null : e.cut(0, t).append(r).append(e.cut(t));
  let l = PC(a.content, t - i - 1, r);
  return l && e.replaceChild(o, a.copy(l));
}
class sg {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, r, n) {
    this.$from = t, this.$to = r, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
function _7(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let n = e[r];
    if (!n.hasDefault)
      return null;
    t[r] = n.default;
  }
  return t;
}
function P7(e, t) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let o = t && t[n];
    if (o === void 0) {
      let i = e[n];
      if (i.hasDefault)
        o = i.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    r[n] = o;
  }
  return r;
}
function B7(e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new F7(e[r]);
  return t;
}
class F7 {
  constructor(t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Km {
  /**
  @internal
  */
  constructor(t, r, n, o) {
    this.name = t, this.rank = r, this.schema = n, this.spec = o, this.attrs = B7(o.attrs), this.excluded = null;
    let i = _7(this.attrs);
    this.instance = i ? new jr(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new jr(this, P7(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, r) {
    let n = /* @__PURE__ */ Object.create(null), o = 0;
    return t.forEach((i, a) => n[i] = new Km(i, o++, r, a)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var r = 0; r < t.length; r++)
      t[r].type == this && (t = t.slice(0, r).concat(t.slice(r + 1)), r--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let r = 0; r < t.length; r++)
      if (t[r].type == this)
        return t[r];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class Kl {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, r) {
    this.schema = t, this.rules = r, this.tags = [], this.styles = [], r.forEach((n) => {
      n.tag ? this.tags.push(n) : n.style && this.styles.push(n);
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let o = t.nodes[n.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, r = {}) {
    let n = new hM(this, r, !1);
    return n.addAll(t, r.from, r.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, r = {}) {
    let n = new hM(this, r, !0);
    return n.addAll(t, r.from, r.to), we.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(t, r, n) {
    for (let o = n ? this.tags.indexOf(n) + 1 : 0; o < this.tags.length; o++) {
      let i = this.tags[o];
      if (Y7(t, i.tag) && (i.namespace === void 0 || t.namespaceURI == i.namespace) && (!i.context || r.matchesContext(i.context))) {
        if (i.getAttrs) {
          let a = i.getAttrs(t);
          if (a === !1)
            continue;
          i.attrs = a || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, r, n, o) {
    for (let i = o ? this.styles.indexOf(o) + 1 : 0; i < this.styles.length; i++) {
      let a = this.styles[i], l = a.style;
      if (!(l.indexOf(t) != 0 || a.context && !n.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      l.length > t.length && (l.charCodeAt(t.length) != 61 || l.slice(t.length + 1) != r))) {
        if (a.getAttrs) {
          let s = a.getAttrs(r);
          if (s === !1)
            continue;
          a.attrs = s || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let r = [];
    function n(o) {
      let i = o.priority == null ? 50 : o.priority, a = 0;
      for (; a < r.length; a++) {
        let l = r[a];
        if ((l.priority == null ? 50 : l.priority) < i)
          break;
      }
      r.splice(a, 0, o);
    }
    for (let o in t.marks) {
      let i = t.marks[o].spec.parseDOM;
      i && i.forEach((a) => {
        n(a = gM(a)), a.mark || a.ignore || a.clearMark || (a.mark = o);
      });
    }
    for (let o in t.nodes) {
      let i = t.nodes[o].spec.parseDOM;
      i && i.forEach((a) => {
        n(a = gM(a)), a.node || a.ignore || a.mark || (a.node = o);
      });
    }
    return r;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new Kl(t, Kl.schemaRules(t)));
  }
}
const BC = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, U7 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, FC = { ol: !0, ul: !0 }, Zu = 1, Gu = 2, gl = 4;
function pM(e, t, r) {
  return t != null ? (t ? Zu : 0) | (t === "full" ? Gu : 0) : e && e.whitespace == "pre" ? Zu | Gu : r & ~gl;
}
class Xs {
  constructor(t, r, n, o, i, a, l) {
    this.type = t, this.attrs = r, this.marks = n, this.pendingMarks = o, this.solid = i, this.options = l, this.content = [], this.activeMarks = jr.none, this.stashMarks = [], this.match = a || (l & gl ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let r = this.type.contentMatch.fillBefore(pe.from(t));
      if (r)
        this.match = this.type.contentMatch.matchFragment(r);
      else {
        let n = this.type.contentMatch, o;
        return (o = n.findWrapping(t.type)) ? (this.match = n, o) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & Zu)) {
      let n = this.content[this.content.length - 1], o;
      if (n && n.isText && (o = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let i = n;
        n.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - o[0].length));
      }
    }
    let r = pe.from(this.content);
    return !t && this.match && (r = r.append(this.match.fillBefore(pe.empty, !0))), this.type ? this.type.create(this.attrs, r, this.marks) : r;
  }
  popFromStashMark(t) {
    for (let r = this.stashMarks.length - 1; r >= 0; r--)
      if (t.eq(this.stashMarks[r]))
        return this.stashMarks.splice(r, 1)[0];
  }
  applyPending(t) {
    for (let r = 0, n = this.pendingMarks; r < n.length; r++) {
      let o = n[r];
      (this.type ? this.type.allowsMarkType(o.type) : Q7(o.type, t)) && !o.isInSet(this.activeMarks) && (this.activeMarks = o.addToSet(this.activeMarks), this.pendingMarks = o.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !BC.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class hM {
  constructor(t, r, n) {
    this.parser = t, this.options = r, this.isOpen = n, this.open = 0;
    let o = r.topNode, i, a = pM(null, r.preserveWhitespace, 0) | (n ? gl : 0);
    o ? i = new Xs(o.type, o.attrs, jr.none, jr.none, !0, r.topMatch || o.type.contentMatch, a) : n ? i = new Xs(null, null, jr.none, jr.none, !0, null, a) : i = new Xs(t.schema.topNodeType, null, jr.none, jr.none, !0, null, a), this.nodes = [i], this.find = r.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t) {
    t.nodeType == 3 ? this.addTextNode(t) : t.nodeType == 1 && this.addElement(t);
  }
  withStyleRules(t, r) {
    let n = t.getAttribute("style");
    if (!n)
      return r();
    let o = this.readStyles(W7(n));
    if (!o)
      return;
    let [i, a] = o, l = this.top;
    for (let s = 0; s < a.length; s++)
      this.removePendingMark(a[s], l);
    for (let s = 0; s < i.length; s++)
      this.addPendingMark(i[s]);
    r();
    for (let s = 0; s < i.length; s++)
      this.removePendingMark(i[s], l);
    for (let s = 0; s < a.length; s++)
      this.addPendingMark(a[s]);
  }
  addTextNode(t) {
    let r = t.nodeValue, n = this.top;
    if (n.options & Gu || n.inlineContext(t) || /[^ \t\r\n\u000c]/.test(r)) {
      if (n.options & Zu)
        n.options & Gu ? r = r.replace(/\r\n?/g, `
`) : r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let o = n.content[n.content.length - 1], i = t.previousSibling;
        (!o || i && i.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, r) {
    let n = t.nodeName.toLowerCase(), o;
    FC.hasOwnProperty(n) && this.parser.normalizeLists && H7(t);
    let i = this.options.ruleFromNode && this.options.ruleFromNode(t) || (o = this.parser.matchTag(t, this, r));
    if (i ? i.ignore : U7.hasOwnProperty(n))
      this.findInside(t), this.ignoreFallback(t);
    else if (!i || i.skip || i.closeParent) {
      i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (t = i.skip);
      let a, l = this.top, s = this.needsBlock;
      if (BC.hasOwnProperty(n))
        l.content.length && l.content[0].isInline && this.open && (this.open--, l = this.top), a = !0, l.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t);
        return;
      }
      i && i.skip ? this.addAll(t) : this.withStyleRules(t, () => this.addAll(t)), a && this.sync(l), this.needsBlock = s;
    } else
      this.withStyleRules(t, () => {
        this.addElementByRule(t, i, i.consuming === !1 ? o : void 0);
      });
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(t) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(t) {
    let r = jr.none, n = jr.none;
    for (let o = 0; o < t.length; o += 2)
      for (let i = void 0; ; ) {
        let a = this.parser.matchStyle(t[o], t[o + 1], this, i);
        if (!a)
          break;
        if (a.ignore)
          return null;
        if (a.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((l) => {
          a.clearMark(l) && (n = l.addToSet(n));
        }) : r = this.parser.schema.marks[a.mark].create(a.attrs).addToSet(r), a.consuming === !1)
          i = a;
        else
          break;
      }
    return [r, n];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, r, n) {
    let o, i, a;
    r.node ? (i = this.parser.schema.nodes[r.node], i.isLeaf ? this.insertNode(i.create(r.attrs)) || this.leafFallback(t) : o = this.enter(i, r.attrs || null, r.preserveWhitespace)) : (a = this.parser.schema.marks[r.mark].create(r.attrs), this.addPendingMark(a));
    let l = this.top;
    if (i && i.isLeaf)
      this.findInside(t);
    else if (n)
      this.addElement(t, n);
    else if (r.getContent)
      this.findInside(t), r.getContent(t, this.parser.schema).forEach((s) => this.insertNode(s));
    else {
      let s = t;
      typeof r.contentElement == "string" ? s = t.querySelector(r.contentElement) : typeof r.contentElement == "function" ? s = r.contentElement(t) : r.contentElement && (s = r.contentElement), this.findAround(t, s, !0), this.addAll(s);
    }
    o && this.sync(l) && this.open--, a && this.removePendingMark(a, l);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, r, n) {
    let o = r || 0;
    for (let i = r ? t.childNodes[r] : t.firstChild, a = n == null ? null : t.childNodes[n]; i != a; i = i.nextSibling, ++o)
      this.findAtPoint(t, o), this.addDOM(i);
    this.findAtPoint(t, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t) {
    let r, n;
    for (let o = this.open; o >= 0; o--) {
      let i = this.nodes[o], a = i.findWrapping(t);
      if (a && (!r || r.length > a.length) && (r = a, n = i, !a.length) || i.solid)
        break;
    }
    if (!r)
      return !1;
    this.sync(n);
    for (let o = 0; o < r.length; o++)
      this.enterInner(r[o], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && this.enterInner(r);
    }
    if (this.findPlace(t)) {
      this.closeExtra();
      let r = this.top;
      r.applyPending(t.type), r.match && (r.match = r.match.matchType(t.type));
      let n = r.activeMarks;
      for (let o = 0; o < t.marks.length; o++)
        (!r.type || r.type.allowsMarkType(t.marks[o].type)) && (n = t.marks[o].addToSet(n));
      return r.content.push(t.mark(n)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, r, n) {
    let o = this.findPlace(t.create(r));
    return o && this.enterInner(t, r, !0, n), o;
  }
  // Open a node of the given type
  enterInner(t, r = null, n = !1, o) {
    this.closeExtra();
    let i = this.top;
    i.applyPending(t), i.match = i.match && i.match.matchType(t);
    let a = pM(t, o, i.options);
    i.options & gl && i.content.length == 0 && (a |= gl), this.nodes.push(new Xs(t, r, i.activeMarks, i.pendingMarks, n, null, a)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let r = this.nodes.length - 1;
    if (r > this.open) {
      for (; r > this.open; r--)
        this.nodes[r - 1].content.push(this.nodes[r].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(t) {
    for (let r = this.open; r >= 0; r--)
      if (this.nodes[r] == t)
        return this.open = r, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let r = this.open; r >= 0; r--) {
      let n = this.nodes[r].content;
      for (let o = n.length - 1; o >= 0; o--)
        t += n[o].nodeSize;
      r && t++;
    }
    return t;
  }
  findAtPoint(t, r) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && this.find[n].offset == r && (this.find[n].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && t.nodeType == 1 && t.contains(this.find[r].node) && (this.find[r].pos = this.currentPos);
  }
  findAround(t, r, n) {
    if (t != r && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && t.nodeType == 1 && t.contains(this.find[o].node) && r.compareDocumentPosition(this.find[o].node) & (n ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && (this.find[r].pos = this.currentPos - (t.nodeValue.length - this.find[r].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let r = t.split("/"), n = this.options.context, o = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), i = -(n ? n.depth + 1 : 0) + (o ? 0 : 1), a = (l, s) => {
      for (; l >= 0; l--) {
        let c = r[l];
        if (c == "") {
          if (l == r.length - 1 || l == 0)
            continue;
          for (; s >= i; s--)
            if (a(l - 1, s))
              return !0;
          return !1;
        } else {
          let u = s > 0 || s == 0 && o ? this.nodes[s].type : n && s >= i ? n.node(s - i).type : null;
          if (!u || u.name != c && u.groups.indexOf(c) == -1)
            return !1;
          s--;
        }
      }
      return !0;
    };
    return a(r.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let r = t.depth; r >= 0; r--) {
        let n = t.node(r).contentMatchAt(t.indexAfter(r)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let r in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[r];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
  addPendingMark(t) {
    let r = V7(t, this.top.pendingMarks);
    r && this.top.stashMarks.push(r), this.top.pendingMarks = t.addToSet(this.top.pendingMarks);
  }
  removePendingMark(t, r) {
    for (let n = this.open; n >= 0; n--) {
      let o = this.nodes[n];
      if (o.pendingMarks.lastIndexOf(t) > -1)
        o.pendingMarks = t.removeFromSet(o.pendingMarks);
      else {
        o.activeMarks = t.removeFromSet(o.activeMarks);
        let a = o.popFromStashMark(t);
        a && o.type && o.type.allowsMarkType(a.type) && (o.activeMarks = a.addToSet(o.activeMarks));
      }
      if (o == r)
        break;
    }
  }
}
function H7(e) {
  for (let t = e.firstChild, r = null; t; t = t.nextSibling) {
    let n = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    n && FC.hasOwnProperty(n) && r ? (r.appendChild(t), t = r) : n == "li" ? r = t : n && (r = null);
  }
}
function Y7(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function W7(e) {
  let t = /\s*([\w-]+)\s*:\s*([^;]+)/g, r, n = [];
  for (; r = t.exec(e); )
    n.push(r[1], r[2].trim());
  return n;
}
function gM(e) {
  let t = {};
  for (let r in e)
    t[r] = e[r];
  return t;
}
function Q7(e, t) {
  let r = t.schema.nodes;
  for (let n in r) {
    let o = r[n];
    if (!o.allowsMarkType(e))
      continue;
    let i = [], a = (l) => {
      i.push(l);
      for (let s = 0; s < l.edgeCount; s++) {
        let { type: c, next: u } = l.edge(s);
        if (c == t || i.indexOf(u) < 0 && a(u))
          return !0;
      }
    };
    if (a(o.contentMatch))
      return !0;
  }
}
function V7(e, t) {
  for (let r = 0; r < t.length; r++)
    if (e.eq(t[r]))
      return t[r];
}
class Jo {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, r) {
    this.nodes = t, this.marks = r;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, r = {}, n) {
    n || (n = lf(r).createDocumentFragment());
    let o = n, i = [];
    return t.forEach((a) => {
      if (i.length || a.marks.length) {
        let l = 0, s = 0;
        for (; l < i.length && s < a.marks.length; ) {
          let c = a.marks[s];
          if (!this.marks[c.type.name]) {
            s++;
            continue;
          }
          if (!c.eq(i[l][0]) || c.type.spec.spanning === !1)
            break;
          l++, s++;
        }
        for (; l < i.length; )
          o = i.pop()[1];
        for (; s < a.marks.length; ) {
          let c = a.marks[s++], u = this.serializeMark(c, a.isInline, r);
          u && (i.push([c, o]), o.appendChild(u.dom), o = u.contentDOM || u.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(a, r));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(t, r) {
    let { dom: n, contentDOM: o } = Jo.renderSpec(lf(r), this.nodes[t.type.name](t));
    if (o) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, r, o);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, r = {}) {
    let n = this.serializeNodeInner(t, r);
    for (let o = t.marks.length - 1; o >= 0; o--) {
      let i = this.serializeMark(t.marks[o], t.isInline, r);
      i && ((i.contentDOM || i.dom).appendChild(n), n = i.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(t, r, n = {}) {
    let o = this.marks[t.type.name];
    return o && Jo.renderSpec(lf(n), o(t, r));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(t, r, n = null) {
    if (typeof r == "string")
      return { dom: t.createTextNode(r) };
    if (r.nodeType != null)
      return { dom: r };
    if (r.dom && r.dom.nodeType != null)
      return r;
    let o = r[0], i = o.indexOf(" ");
    i > 0 && (n = o.slice(0, i), o = o.slice(i + 1));
    let a, l = n ? t.createElementNS(n, o) : t.createElement(o), s = r[1], c = 1;
    if (s && typeof s == "object" && s.nodeType == null && !Array.isArray(s)) {
      c = 2;
      for (let u in s)
        if (s[u] != null) {
          let d = u.indexOf(" ");
          d > 0 ? l.setAttributeNS(u.slice(0, d), u.slice(d + 1), s[u]) : l.setAttribute(u, s[u]);
        }
    }
    for (let u = c; u < r.length; u++) {
      let d = r[u];
      if (d === 0) {
        if (u < r.length - 1 || u > c)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: l, contentDOM: l };
      } else {
        let { dom: f, contentDOM: p } = Jo.renderSpec(t, d, n);
        if (l.appendChild(f), p) {
          if (a)
            throw new RangeError("Multiple content holes");
          a = p;
        }
      }
    }
    return { dom: l, contentDOM: a };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Jo(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let r = mM(t.nodes);
    return r.text || (r.text = (n) => n.text), r;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return mM(t.marks);
  }
}
function mM(e) {
  let t = {};
  for (let r in e) {
    let n = e[r].spec.toDOM;
    n && (t[r] = n);
  }
  return t;
}
function lf(e) {
  return e.document || window.document;
}
const UC = 65535, HC = Math.pow(2, 16);
function Z7(e, t) {
  return e + t * HC;
}
function vM(e) {
  return e & UC;
}
function G7(e) {
  return (e - (e & UC)) / HC;
}
const YC = 1, WC = 2, yu = 4, QC = 8;
class ug {
  /**
  @internal
  */
  constructor(t, r, n) {
    this.pos = t, this.delInfo = r, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & QC) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (YC | yu)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (WC | yu)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & yu) > 0;
  }
}
class _r {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, r = !1) {
    if (this.ranges = t, this.inverted = r, !t.length && _r.empty)
      return _r.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let r = 0, n = vM(t);
    if (!this.inverted)
      for (let o = 0; o < n; o++)
        r += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[n * 3] + r + G7(t);
  }
  mapResult(t, r = 1) {
    return this._map(t, r, !1);
  }
  map(t, r = 1) {
    return this._map(t, r, !0);
  }
  /**
  @internal
  */
  _map(t, r, n) {
    let o = 0, i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let s = this.ranges[l] - (this.inverted ? o : 0);
      if (s > t)
        break;
      let c = this.ranges[l + i], u = this.ranges[l + a], d = s + c;
      if (t <= d) {
        let f = c ? t == s ? -1 : t == d ? 1 : r : r, p = s + o + (f < 0 ? 0 : u);
        if (n)
          return p;
        let h = t == (r < 0 ? s : d) ? null : Z7(l / 3, t - s), g = t == s ? WC : t == d ? YC : yu;
        return (r < 0 ? t != s : t != d) && (g |= QC), new ug(p, g, h);
      }
      o += u - c;
    }
    return n ? t + o : new ug(t + o, 0, null);
  }
  /**
  @internal
  */
  touches(t, r) {
    let n = 0, o = vM(r), i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let s = this.ranges[l] - (this.inverted ? n : 0);
      if (s > t)
        break;
      let c = this.ranges[l + i], u = s + c;
      if (t <= u && l == o * 3)
        return !0;
      n += this.ranges[l + a] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let r = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o], l = a - (this.inverted ? i : 0), s = a + (this.inverted ? 0 : i), c = this.ranges[o + r], u = this.ranges[o + n];
      t(l, l + c, s, s + u), i += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new _r(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? _r.empty : new _r(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
_r.empty = new _r([]);
class ml {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], r, n = 0, o = t.length) {
    this.maps = t, this.mirror = r, this.from = n, this.to = o;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, r = this.maps.length) {
    return new ml(this.maps, this.mirror, t, r);
  }
  /**
  @internal
  */
  copy() {
    return new ml(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, r) {
    this.to = this.maps.push(t), r != null && this.setMirror(this.maps.length - 1, r);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let r = 0, n = this.maps.length; r < t.maps.length; r++) {
      let o = t.getMirror(r);
      this.appendMap(t.maps[r], o != null && o < r ? n + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let r = 0; r < this.mirror.length; r++)
        if (this.mirror[r] == t)
          return this.mirror[r + (r % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, r) {
    this.mirror || (this.mirror = []), this.mirror.push(t, r);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let r = t.maps.length - 1, n = this.maps.length + t.maps.length; r >= 0; r--) {
      let o = t.getMirror(r);
      this.appendMap(t.maps[r].invert(), o != null && o > r ? n - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new ml();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, r = 1) {
    if (this.mirror)
      return this._map(t, r, !0);
    for (let n = this.from; n < this.to; n++)
      t = this.maps[n].map(t, r);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, r = 1) {
    return this._map(t, r, !1);
  }
  /**
  @internal
  */
  _map(t, r, n) {
    let o = 0;
    for (let i = this.from; i < this.to; i++) {
      let a = this.maps[i], l = a.mapResult(t, r);
      if (l.recover != null) {
        let s = this.getMirror(i);
        if (s != null && s > i && s < this.to) {
          i = s, t = this.maps[s].recover(l.recover);
          continue;
        }
      }
      o |= l.delInfo, t = l.pos;
    }
    return n ? t : new ug(t, o, null);
  }
}
const sf = /* @__PURE__ */ Object.create(null);
class fr {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return _r.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, r) {
    if (!r || !r.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = sf[r.stepType];
    if (!n)
      throw new RangeError(`No step type ${r.stepType} defined`);
    return n.fromJSON(t, r);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, r) {
    if (t in sf)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return sf[t] = r, r.prototype.jsonID = t, r;
  }
}
class Ft {
  /**
  @internal
  */
  constructor(t, r) {
    this.doc = t, this.failed = r;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new Ft(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new Ft(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, r, n, o) {
    try {
      return Ft.ok(t.replace(r, n, o));
    } catch (i) {
      if (i instanceof R7)
        return Ft.fail(i.message);
      throw i;
    }
  }
}
function qm(e, t, r) {
  let n = [];
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o);
    i.content.size && (i = i.copy(qm(i.content, t, i))), i.isInline && (i = t(i, r, o)), n.push(i);
  }
  return pe.fromArray(n);
}
class Mo extends fr {
  /**
  Create a mark step.
  */
  constructor(t, r, n) {
    super(), this.from = t, this.to = r, this.mark = n;
  }
  apply(t) {
    let r = t.slice(this.from, this.to), n = t.resolve(this.from), o = n.node(n.sharedDepth(this.to)), i = new we(qm(r.content, (a, l) => !a.isAtom || !l.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), o), r.openStart, r.openEnd);
    return Ft.fromReplace(t, this.from, this.to, i);
  }
  invert() {
    return new En(this.from, this.to, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new Mo(r.pos, n.pos, this.mark);
  }
  merge(t) {
    return t instanceof Mo && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Mo(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Mo(r.from, r.to, t.markFromJSON(r.mark));
  }
}
fr.jsonID("addMark", Mo);
class En extends fr {
  /**
  Create a mark-removing step.
  */
  constructor(t, r, n) {
    super(), this.from = t, this.to = r, this.mark = n;
  }
  apply(t) {
    let r = t.slice(this.from, this.to), n = new we(qm(r.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), t), r.openStart, r.openEnd);
    return Ft.fromReplace(t, this.from, this.to, n);
  }
  invert() {
    return new Mo(this.from, this.to, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new En(r.pos, n.pos, this.mark);
  }
  merge(t) {
    return t instanceof En && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new En(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new En(r.from, r.to, t.markFromJSON(r.mark));
  }
}
fr.jsonID("removeMark", En);
class yo extends fr {
  /**
  Create a node mark step.
  */
  constructor(t, r) {
    super(), this.pos = t, this.mark = r;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Ft.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.addToSet(r.marks));
    return Ft.fromReplace(t, this.pos, this.pos + 1, new we(pe.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(t) {
    let r = t.nodeAt(this.pos);
    if (r) {
      let n = this.mark.addToSet(r.marks);
      if (n.length == r.marks.length) {
        for (let o = 0; o < r.marks.length; o++)
          if (!r.marks[o].isInSet(n))
            return new yo(this.pos, r.marks[o]);
        return new yo(this.pos, this.mark);
      }
    }
    return new fa(this.pos, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new yo(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new yo(r.pos, t.markFromJSON(r.mark));
  }
}
fr.jsonID("addNodeMark", yo);
class fa extends fr {
  /**
  Create a mark-removing step.
  */
  constructor(t, r) {
    super(), this.pos = t, this.mark = r;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Ft.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.removeFromSet(r.marks));
    return Ft.fromReplace(t, this.pos, this.pos + 1, new we(pe.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(t) {
    let r = t.nodeAt(this.pos);
    return !r || !this.mark.isInSet(r.marks) ? this : new yo(this.pos, this.mark);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new fa(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new fa(r.pos, t.markFromJSON(r.mark));
  }
}
fr.jsonID("removeNodeMark", fa);
class er extends fr {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, r, n, o = !1) {
    super(), this.from = t, this.to = r, this.slice = n, this.structure = o;
  }
  apply(t) {
    return this.structure && cg(t, this.from, this.to) ? Ft.fail("Structure replace would overwrite content") : Ft.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new _r([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new er(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1);
    return r.deletedAcross && n.deletedAcross ? null : new er(r.pos, Math.max(r.pos, n.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof er) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let r = this.slice.size + t.slice.size == 0 ? we.empty : new we(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new er(this.from, this.to + (t.to - t.from), r, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let r = this.slice.size + t.slice.size == 0 ? we.empty : new we(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new er(t.from, this.to, r, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new er(r.from, r.to, we.fromJSON(t, r.slice), !!r.structure);
  }
}
fr.jsonID("replace", er);
class Kt extends fr {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, r, n, o, i, a, l = !1) {
    super(), this.from = t, this.to = r, this.gapFrom = n, this.gapTo = o, this.slice = i, this.insert = a, this.structure = l;
  }
  apply(t) {
    if (this.structure && (cg(t, this.from, this.gapFrom) || cg(t, this.gapTo, this.to)))
      return Ft.fail("Structure gap-replace would overwrite content");
    let r = t.slice(this.gapFrom, this.gapTo);
    if (r.openStart || r.openEnd)
      return Ft.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, r.content);
    return n ? Ft.fromReplace(t, this.from, this.to, n) : Ft.fail("Content does not fit in gap");
  }
  getMap() {
    return new _r([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let r = this.gapTo - this.gapFrom;
    return new Kt(this.from, this.from + this.slice.size + r, this.from + this.insert, this.from + this.insert + r, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let r = t.mapResult(this.from, 1), n = t.mapResult(this.to, -1), o = t.map(this.gapFrom, -1), i = t.map(this.gapTo, 1);
    return r.deletedAcross && n.deletedAcross || o < r.pos || i > n.pos ? null : new Kt(r.pos, n.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.from != "number" || typeof r.to != "number" || typeof r.gapFrom != "number" || typeof r.gapTo != "number" || typeof r.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Kt(r.from, r.to, r.gapFrom, r.gapTo, we.fromJSON(t, r.slice), r.insert, !!r.structure);
  }
}
fr.jsonID("replaceAround", Kt);
function cg(e, t, r) {
  let n = e.resolve(t), o = r - t, i = n.depth;
  for (; o > 0 && i > 0 && n.indexAfter(i) == n.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let a = n.node(i).maybeChild(n.indexAfter(i));
    for (; o > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, o--;
    }
  }
  return !1;
}
function K7(e, t, r, n) {
  let o = [], i = [], a, l;
  e.doc.nodesBetween(t, r, (s, c, u) => {
    if (!s.isInline)
      return;
    let d = s.marks;
    if (!n.isInSet(d) && u.type.allowsMarkType(n.type)) {
      let f = Math.max(c, t), p = Math.min(c + s.nodeSize, r), h = n.addToSet(d);
      for (let g = 0; g < d.length; g++)
        d[g].isInSet(h) || (a && a.to == f && a.mark.eq(d[g]) ? a.to = p : o.push(a = new En(f, p, d[g])));
      l && l.to == f ? l.to = p : i.push(l = new Mo(f, p, n));
    }
  }), o.forEach((s) => e.step(s)), i.forEach((s) => e.step(s));
}
function q7(e, t, r, n) {
  let o = [], i = 0;
  e.doc.nodesBetween(t, r, (a, l) => {
    if (!a.isInline)
      return;
    i++;
    let s = null;
    if (n instanceof Km) {
      let c = a.marks, u;
      for (; u = n.isInSet(c); )
        (s || (s = [])).push(u), c = u.removeFromSet(c);
    } else
      n ? n.isInSet(a.marks) && (s = [n]) : s = a.marks;
    if (s && s.length) {
      let c = Math.min(l + a.nodeSize, r);
      for (let u = 0; u < s.length; u++) {
        let d = s[u], f;
        for (let p = 0; p < o.length; p++) {
          let h = o[p];
          h.step == i - 1 && d.eq(o[p].style) && (f = h);
        }
        f ? (f.to = c, f.step = i) : o.push({ style: d, from: Math.max(l, t), to: c, step: i });
      }
    }
  }), o.forEach((a) => e.step(new En(a.from, a.to, a.style)));
}
function J7(e, t, r, n = r.contentMatch) {
  let o = e.doc.nodeAt(t), i = [], a = t + 1;
  for (let l = 0; l < o.childCount; l++) {
    let s = o.child(l), c = a + s.nodeSize, u = n.matchType(s.type);
    if (!u)
      i.push(new er(a, c, we.empty));
    else {
      n = u;
      for (let d = 0; d < s.marks.length; d++)
        r.allowsMarkType(s.marks[d].type) || e.step(new En(a, c, s.marks[d]));
      if (s.isText && !r.spec.code) {
        let d, f = /\r?\n|\r/g, p;
        for (; d = f.exec(s.text); )
          p || (p = new we(pe.from(r.schema.text(" ", r.allowedMarks(s.marks))), 0, 0)), i.push(new er(a + d.index, a + d.index + d[0].length, p));
      }
    }
    a = c;
  }
  if (!n.validEnd) {
    let l = n.fillBefore(pe.empty, !0);
    e.replace(a, a, new we(l, 0, 0));
  }
  for (let l = i.length - 1; l >= 0; l--)
    e.step(i[l]);
}
function X7(e, t, r) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (r == e.childCount || e.canReplace(0, r));
}
function Oa(e) {
  let r = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let n = e.depth; ; --n) {
    let o = e.$from.node(n), i = e.$from.index(n), a = e.$to.indexAfter(n);
    if (n < e.depth && o.canReplace(i, a, r))
      return n;
    if (n == 0 || o.type.spec.isolating || !X7(o, i, a))
      break;
  }
  return null;
}
function eH(e, t, r) {
  let { $from: n, $to: o, depth: i } = t, a = n.before(i + 1), l = o.after(i + 1), s = a, c = l, u = pe.empty, d = 0;
  for (let h = i, g = !1; h > r; h--)
    g || n.index(h) > 0 ? (g = !0, u = pe.from(n.node(h).copy(u)), d++) : s--;
  let f = pe.empty, p = 0;
  for (let h = i, g = !1; h > r; h--)
    g || o.after(h + 1) < o.end(h) ? (g = !0, f = pe.from(o.node(h).copy(f)), p++) : c++;
  e.step(new Kt(s, c, a, l, new we(u.append(f), d, p), u.size - d, !0));
}
function Jm(e, t, r = null, n = e) {
  let o = tH(e, t), i = o && rH(n, t);
  return i ? o.map(bM).concat({ type: t, attrs: r }).concat(i.map(bM)) : null;
}
function bM(e) {
  return { type: e, attrs: null };
}
function tH(e, t) {
  let { parent: r, startIndex: n, endIndex: o } = e, i = r.contentMatchAt(n).findWrapping(t);
  if (!i)
    return null;
  let a = i.length ? i[0] : t;
  return r.canReplaceWith(n, o, a) ? i : null;
}
function rH(e, t) {
  let { parent: r, startIndex: n, endIndex: o } = e, i = r.child(n), a = t.contentMatch.findWrapping(i.type);
  if (!a)
    return null;
  let s = (a.length ? a[a.length - 1] : t).contentMatch;
  for (let c = n; s && c < o; c++)
    s = s.matchType(r.child(c).type);
  return !s || !s.validEnd ? null : a;
}
function nH(e, t, r) {
  let n = pe.empty;
  for (let a = r.length - 1; a >= 0; a--) {
    if (n.size) {
      let l = r[a].type.contentMatch.matchFragment(n);
      if (!l || !l.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = pe.from(r[a].type.create(r[a].attrs, n));
  }
  let o = t.start, i = t.end;
  e.step(new Kt(o, i, o, i, new we(n, 0, 0), r.length, !0));
}
function oH(e, t, r, n, o) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = e.steps.length;
  e.doc.nodesBetween(t, r, (a, l) => {
    if (a.isTextblock && !a.hasMarkup(n, o) && iH(e.doc, e.mapping.slice(i).map(l), n)) {
      e.clearIncompatible(e.mapping.slice(i).map(l, 1), n);
      let s = e.mapping.slice(i), c = s.map(l, 1), u = s.map(l + a.nodeSize, 1);
      return e.step(new Kt(c, u, c + 1, u - 1, new we(pe.from(n.create(o, null, a.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function iH(e, t, r) {
  let n = e.resolve(t), o = n.index();
  return n.parent.canReplaceWith(o, o + 1, r);
}
function aH(e, t, r, n, o) {
  let i = e.doc.nodeAt(t);
  if (!i)
    throw new RangeError("No node at given position");
  r || (r = i.type);
  let a = r.create(n, null, o || i.marks);
  if (i.isLeaf)
    return e.replaceWith(t, t + i.nodeSize, a);
  if (!r.validContent(i.content))
    throw new RangeError("Invalid content for node type " + r.name);
  e.step(new Kt(t, t + i.nodeSize, t + 1, t + i.nodeSize - 1, new we(pe.from(a), 0, 0), 1, !0));
}
function ta(e, t, r = 1, n) {
  let o = e.resolve(t), i = o.depth - r, a = n && n[n.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !a.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let c = o.depth - 1, u = r - 2; c > i; c--, u--) {
    let d = o.node(c), f = o.index(c);
    if (d.type.spec.isolating)
      return !1;
    let p = d.content.cutByIndex(f, d.childCount), h = n && n[u + 1];
    h && (p = p.replaceChild(0, h.type.create(h.attrs)));
    let g = n && n[u] || d;
    if (!d.canReplace(f + 1, d.childCount) || !g.type.validContent(p))
      return !1;
  }
  let l = o.indexAfter(i), s = n && n[0];
  return o.node(i).canReplaceWith(l, l, s ? s.type : o.node(i + 1).type);
}
function lH(e, t, r = 1, n) {
  let o = e.doc.resolve(t), i = pe.empty, a = pe.empty;
  for (let l = o.depth, s = o.depth - r, c = r - 1; l > s; l--, c--) {
    i = pe.from(o.node(l).copy(i));
    let u = n && n[c];
    a = pe.from(u ? u.type.create(u.attrs, a) : o.node(l).copy(a));
  }
  e.step(new er(t, t, new we(i.append(a), r, r), !0));
}
function Eo(e, t) {
  let r = e.resolve(t), n = r.index();
  return VC(r.nodeBefore, r.nodeAfter) && r.parent.canReplace(n, n + 1);
}
function VC(e, t) {
  return !!(e && t && !e.isLeaf && e.canAppend(t));
}
function ad(e, t, r = -1) {
  let n = e.resolve(t);
  for (let o = n.depth; ; o--) {
    let i, a, l = n.index(o);
    if (o == n.depth ? (i = n.nodeBefore, a = n.nodeAfter) : r > 0 ? (i = n.node(o + 1), l++, a = n.node(o).maybeChild(l)) : (i = n.node(o).maybeChild(l - 1), a = n.node(o + 1)), i && !i.isTextblock && VC(i, a) && n.node(o).canReplace(l, l + 1))
      return t;
    if (o == 0)
      break;
    t = r < 0 ? n.before(o) : n.after(o);
  }
}
function sH(e, t, r) {
  let n = new er(t - r, t + r, we.empty, !0);
  e.step(n);
}
function uH(e, t, r) {
  let n = e.resolve(t);
  if (n.parent.canReplaceWith(n.index(), n.index(), r))
    return t;
  if (n.parentOffset == 0)
    for (let o = n.depth - 1; o >= 0; o--) {
      let i = n.index(o);
      if (n.node(o).canReplaceWith(i, i, r))
        return n.before(o + 1);
      if (i > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let o = n.depth - 1; o >= 0; o--) {
      let i = n.indexAfter(o);
      if (n.node(o).canReplaceWith(i, i, r))
        return n.after(o + 1);
      if (i < n.node(o).childCount)
        return null;
    }
  return null;
}
function cH(e, t, r) {
  let n = e.resolve(t);
  if (!r.content.size)
    return t;
  let o = r.content;
  for (let i = 0; i < r.openStart; i++)
    o = o.firstChild.content;
  for (let i = 1; i <= (r.openStart == 0 && r.size ? 2 : 1); i++)
    for (let a = n.depth; a >= 0; a--) {
      let l = a == n.depth ? 0 : n.pos <= (n.start(a + 1) + n.end(a + 1)) / 2 ? -1 : 1, s = n.index(a) + (l > 0 ? 1 : 0), c = n.node(a), u = !1;
      if (i == 1)
        u = c.canReplace(s, s, o);
      else {
        let d = c.contentMatchAt(s).findWrapping(o.firstChild.type);
        u = d && c.canReplaceWith(s, s, d[0]);
      }
      if (u)
        return l == 0 ? n.pos : l < 0 ? n.before(a + 1) : n.after(a + 1);
    }
  return null;
}
function Xm(e, t, r = t, n = we.empty) {
  if (t == r && !n.size)
    return null;
  let o = e.resolve(t), i = e.resolve(r);
  return ZC(o, i, n) ? new er(t, r, n) : new dH(o, i, n).fit();
}
function ZC(e, t, r) {
  return !r.openStart && !r.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), r.content);
}
class dH {
  constructor(t, r, n) {
    this.$from = t, this.$to = r, this.unplaced = n, this.frontier = [], this.placed = pe.empty;
    for (let o = 0; o <= t.depth; o++) {
      let i = t.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(t.indexAfter(o))
      });
    }
    for (let o = t.depth; o > 0; o--)
      this.placed = pe.from(t.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, n = this.$from, o = this.close(t < 0 ? this.$to : n.doc.resolve(t));
    if (!o)
      return null;
    let i = this.placed, a = n.depth, l = o.depth;
    for (; a && l && i.childCount == 1; )
      i = i.firstChild.content, a--, l--;
    let s = new we(i, a, l);
    return t > -1 ? new Kt(n.pos, t, this.$to.pos, this.$to.end(), s, r) : s.size || n.pos != this.$to.pos ? new er(n.pos, o.pos, s) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let r = this.unplaced.content, n = 0, o = this.unplaced.openEnd; n < t; n++) {
      let i = r.firstChild;
      if (r.childCount > 1 && (o = 0), i.type.spec.isolating && o <= n) {
        t = n;
        break;
      }
      r = i.content;
    }
    for (let r = 1; r <= 2; r++)
      for (let n = r == 1 ? t : this.unplaced.openStart; n >= 0; n--) {
        let o, i = null;
        n ? (i = uf(this.unplaced.content, n - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let a = o.firstChild;
        for (let l = this.depth; l >= 0; l--) {
          let { type: s, match: c } = this.frontier[l], u, d = null;
          if (r == 1 && (a ? c.matchType(a.type) || (d = c.fillBefore(pe.from(a), !1)) : i && s.compatibleContent(i.type)))
            return { sliceDepth: n, frontierDepth: l, parent: i, inject: d };
          if (r == 2 && a && (u = c.findWrapping(a.type)))
            return { sliceDepth: n, frontierDepth: l, parent: i, wrap: u };
          if (i && c.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: r, openEnd: n } = this.unplaced, o = uf(t, r);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new we(t, r + 1, Math.max(n, o.size + r >= t.size - n ? r + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: r, openEnd: n } = this.unplaced, o = uf(t, r);
    if (o.childCount <= 1 && r > 0) {
      let i = t.size - r <= r + o.size;
      this.unplaced = new we(rl(t, r - 1, 1), r - 1, i ? r - 1 : n);
    } else
      this.unplaced = new we(rl(t, r, 1), r, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: r, parent: n, inject: o, wrap: i }) {
    for (; this.depth > r; )
      this.closeFrontierNode();
    if (i)
      for (let g = 0; g < i.length; g++)
        this.openFrontierNode(i[g]);
    let a = this.unplaced, l = n ? n.content : a.content, s = a.openStart - t, c = 0, u = [], { match: d, type: f } = this.frontier[r];
    if (o) {
      for (let g = 0; g < o.childCount; g++)
        u.push(o.child(g));
      d = d.matchFragment(o);
    }
    let p = l.size + t - (a.content.size - a.openEnd);
    for (; c < l.childCount; ) {
      let g = l.child(c), m = d.matchType(g.type);
      if (!m)
        break;
      c++, (c > 1 || s == 0 || g.content.size) && (d = m, u.push(GC(g.mark(f.allowedMarks(g.marks)), c == 1 ? s : 0, c == l.childCount ? p : -1)));
    }
    let h = c == l.childCount;
    h || (p = -1), this.placed = nl(this.placed, r, pe.from(u)), this.frontier[r].match = d, h && p < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, m = l; g < p; g++) {
      let v = m.lastChild;
      this.frontier.push({ type: v.type, match: v.contentMatchAt(v.childCount) }), m = v.content;
    }
    this.unplaced = h ? t == 0 ? we.empty : new we(rl(a.content, t - 1, 1), t - 1, p < 0 ? a.openEnd : t - 1) : new we(rl(a.content, t, c), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], r;
    if (!t.type.isTextblock || !cf(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (r = this.findCloseLevel(this.$to)) && r.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, o = this.$to.after(n);
    for (; n > 1 && o == this.$to.end(--n); )
      ++o;
    return o;
  }
  findCloseLevel(t) {
    e:
      for (let r = Math.min(this.depth, t.depth); r >= 0; r--) {
        let { match: n, type: o } = this.frontier[r], i = r < t.depth && t.end(r + 1) == t.pos + (t.depth - (r + 1)), a = cf(t, r, o, n, i);
        if (a) {
          for (let l = r - 1; l >= 0; l--) {
            let { match: s, type: c } = this.frontier[l], u = cf(t, l, c, s, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: r, fit: a, move: i ? t.doc.resolve(t.after(r + 1)) : t };
        }
      }
  }
  close(t) {
    let r = this.findCloseLevel(t);
    if (!r)
      return null;
    for (; this.depth > r.depth; )
      this.closeFrontierNode();
    r.fit.childCount && (this.placed = nl(this.placed, r.depth, r.fit)), t = r.move;
    for (let n = r.depth + 1; n <= t.depth; n++) {
      let o = t.node(n), i = o.type.contentMatch.fillBefore(o.content, !0, t.index(n));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return t;
  }
  openFrontierNode(t, r = null, n) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(t), this.placed = nl(this.placed, this.depth, pe.from(t.create(r, n))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let r = this.frontier.pop().match.fillBefore(pe.empty, !0);
    r.childCount && (this.placed = nl(this.placed, this.frontier.length, r));
  }
}
function rl(e, t, r) {
  return t == 0 ? e.cutByIndex(r, e.childCount) : e.replaceChild(0, e.firstChild.copy(rl(e.firstChild.content, t - 1, r)));
}
function nl(e, t, r) {
  return t == 0 ? e.append(r) : e.replaceChild(e.childCount - 1, e.lastChild.copy(nl(e.lastChild.content, t - 1, r)));
}
function uf(e, t) {
  for (let r = 0; r < t; r++)
    e = e.firstChild.content;
  return e;
}
function GC(e, t, r) {
  if (t <= 0)
    return e;
  let n = e.content;
  return t > 1 && (n = n.replaceChild(0, GC(n.firstChild, t - 1, n.childCount == 1 ? r - 1 : 0))), t > 0 && (n = e.type.contentMatch.fillBefore(n).append(n), r <= 0 && (n = n.append(e.type.contentMatch.matchFragment(n).fillBefore(pe.empty, !0)))), e.copy(n);
}
function cf(e, t, r, n, o) {
  let i = e.node(t), a = o ? e.indexAfter(t) : e.index(t);
  if (a == i.childCount && !r.compatibleContent(i.type))
    return null;
  let l = n.fillBefore(i.content, !0, a);
  return l && !fH(r, i.content, a) ? l : null;
}
function fH(e, t, r) {
  for (let n = r; n < t.childCount; n++)
    if (!e.allowsMarks(t.child(n).marks))
      return !0;
  return !1;
}
function pH(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function hH(e, t, r, n) {
  if (!n.size)
    return e.deleteRange(t, r);
  let o = e.doc.resolve(t), i = e.doc.resolve(r);
  if (ZC(o, i, n))
    return e.step(new er(t, r, n));
  let a = qC(o, e.doc.resolve(r));
  a[a.length - 1] == 0 && a.pop();
  let l = -(o.depth + 1);
  a.unshift(l);
  for (let f = o.depth, p = o.pos - 1; f > 0; f--, p--) {
    let h = o.node(f).type.spec;
    if (h.defining || h.definingAsContext || h.isolating)
      break;
    a.indexOf(f) > -1 ? l = f : o.before(f) == p && a.splice(1, 0, -f);
  }
  let s = a.indexOf(l), c = [], u = n.openStart;
  for (let f = n.content, p = 0; ; p++) {
    let h = f.firstChild;
    if (c.push(h), p == n.openStart)
      break;
    f = h.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let p = c[f], h = pH(p.type);
    if (h && !p.sameMarkup(o.node(Math.abs(l) - 1)))
      u = f;
    else if (h || !p.type.isTextblock)
      break;
  }
  for (let f = n.openStart; f >= 0; f--) {
    let p = (f + u + 1) % (n.openStart + 1), h = c[p];
    if (h)
      for (let g = 0; g < a.length; g++) {
        let m = a[(g + s) % a.length], v = !0;
        m < 0 && (v = !1, m = -m);
        let M = o.node(m - 1), x = o.index(m - 1);
        if (M.canReplaceWith(x, x, h.type, h.marks))
          return e.replace(o.before(m), v ? i.after(m) : r, new we(KC(n.content, 0, n.openStart, p), p, n.openEnd));
      }
  }
  let d = e.steps.length;
  for (let f = a.length - 1; f >= 0 && (e.replace(t, r, n), !(e.steps.length > d)); f--) {
    let p = a[f];
    p < 0 || (t = o.before(p), r = i.after(p));
  }
}
function KC(e, t, r, n, o) {
  if (t < r) {
    let i = e.firstChild;
    e = e.replaceChild(0, i.copy(KC(i.content, t + 1, r, n, i)));
  }
  if (t > n) {
    let i = o.contentMatchAt(0), a = i.fillBefore(e).append(e);
    e = a.append(i.matchFragment(a).fillBefore(pe.empty, !0));
  }
  return e;
}
function gH(e, t, r, n) {
  if (!n.isInline && t == r && e.doc.resolve(t).parent.content.size) {
    let o = uH(e.doc, t, n.type);
    o != null && (t = r = o);
  }
  e.replaceRange(t, r, new we(pe.from(n), 0, 0));
}
function mH(e, t, r) {
  let n = e.doc.resolve(t), o = e.doc.resolve(r), i = qC(n, o);
  for (let a = 0; a < i.length; a++) {
    let l = i[a], s = a == i.length - 1;
    if (s && l == 0 || n.node(l).type.contentMatch.validEnd)
      return e.delete(n.start(l), o.end(l));
    if (l > 0 && (s || n.node(l - 1).canReplace(n.index(l - 1), o.indexAfter(l - 1))))
      return e.delete(n.before(l), o.after(l));
  }
  for (let a = 1; a <= n.depth && a <= o.depth; a++)
    if (t - n.start(a) == n.depth - a && r > n.end(a) && o.end(a) - r != o.depth - a)
      return e.delete(n.before(a), r);
  e.delete(t, r);
}
function qC(e, t) {
  let r = [], n = Math.min(e.depth, t.depth);
  for (let o = n; o >= 0; o--) {
    let i = e.start(o);
    if (i < e.pos - (e.depth - o) || t.end(o) > t.pos + (t.depth - o) || e.node(o).type.spec.isolating || t.node(o).type.spec.isolating)
      break;
    (i == t.start(o) || o == e.depth && o == t.depth && e.parent.inlineContent && t.parent.inlineContent && o && t.start(o - 1) == i - 1) && r.push(o);
  }
  return r;
}
class ra extends fr {
  /**
  Construct an attribute step.
  */
  constructor(t, r, n) {
    super(), this.pos = t, this.attr = r, this.value = n;
  }
  apply(t) {
    let r = t.nodeAt(this.pos);
    if (!r)
      return Ft.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in r.attrs)
      n[i] = r.attrs[i];
    n[this.attr] = this.value;
    let o = r.type.create(n, null, r.marks);
    return Ft.fromReplace(t, this.pos, this.pos + 1, new we(pe.from(o), 0, r.isLeaf ? 0 : 1));
  }
  getMap() {
    return _r.empty;
  }
  invert(t) {
    return new ra(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let r = t.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new ra(r.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, r) {
    if (typeof r.pos != "number" || typeof r.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new ra(r.pos, r.attr, r.value);
  }
}
fr.jsonID("attr", ra);
class ql extends fr {
  /**
  Construct an attribute step.
  */
  constructor(t, r) {
    super(), this.attr = t, this.value = r;
  }
  apply(t) {
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      r[o] = t.attrs[o];
    r[this.attr] = this.value;
    let n = t.type.create(r, t.content, t.marks);
    return Ft.ok(n);
  }
  getMap() {
    return _r.empty;
  }
  invert(t) {
    return new ql(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, r) {
    if (typeof r.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new ql(r.attr, r.value);
  }
}
fr.jsonID("docAttr", ql);
let pa = class extends Error {
};
pa = function e(t) {
  let r = Error.call(this, t);
  return r.__proto__ = e.prototype, r;
};
pa.prototype = Object.create(Error.prototype);
pa.prototype.constructor = pa;
pa.prototype.name = "TransformError";
class JC {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new ml();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let r = this.maybeStep(t);
    if (r.failed)
      throw new pa(r.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let r = t.apply(this.doc);
    return r.failed || this.addStep(t, r.doc), r;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, r) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = r;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, r = t, n = we.empty) {
    let o = Xm(this.doc, t, r, n);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, r, n) {
    return this.replace(t, r, new we(pe.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, r) {
    return this.replace(t, r, we.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, r) {
    return this.replaceWith(t, t, r);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, r, n) {
    return hH(this, t, r, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, r, n) {
    return gH(this, t, r, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, r) {
    return mH(this, t, r), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, r) {
    return eH(this, t, r), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, r = 1) {
    return sH(this, t, r), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, r) {
    return nH(this, t, r), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, r = t, n, o = null) {
    return oH(this, t, r, n, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, r, n = null, o) {
    return aH(this, t, r, n, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, r, n) {
    return this.step(new ra(t, r, n)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, r) {
    return this.step(new ql(t, r)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, r) {
    return this.step(new yo(t, r)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, r) {
    if (!(r instanceof jr)) {
      let n = this.doc.nodeAt(t);
      if (!n)
        throw new RangeError("No node at position " + t);
      if (r = r.isInSet(n.marks), !r)
        return this;
    }
    return this.step(new fa(t, r)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, r = 1, n) {
    return lH(this, t, r, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, r, n) {
    return K7(this, t, r, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, r, n) {
    return q7(this, t, r, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, r, n) {
    return J7(this, t, r, n), this;
  }
}
const df = /* @__PURE__ */ Object.create(null);
class Ze {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, r, n) {
    this.$anchor = t, this.$head = r, this.ranges = n || [new XC(t.min(r), t.max(r))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let r = 0; r < t.length; r++)
      if (t[r].$from.pos != t[r].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, r = we.empty) {
    let n = r.content.lastChild, o = null;
    for (let l = 0; l < r.openEnd; l++)
      o = n, n = n.lastChild;
    let i = t.steps.length, a = this.ranges;
    for (let l = 0; l < a.length; l++) {
      let { $from: s, $to: c } = a[l], u = t.mapping.slice(i);
      t.replaceRange(u.map(s.pos), u.map(c.pos), l ? we.empty : r), l == 0 && xM(t, i, (n ? n.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, r) {
    let n = t.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: a, $to: l } = o[i], s = t.mapping.slice(n), c = s.map(a.pos), u = s.map(l.pos);
      i ? t.deleteRange(c, u) : (t.replaceRangeWith(c, u, r), xM(t, n, r.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, r, n = !1) {
    let o = t.parent.inlineContent ? new Qe(t) : Yi(t.node(0), t.parent, t.pos, t.index(), r, n);
    if (o)
      return o;
    for (let i = t.depth - 1; i >= 0; i--) {
      let a = r < 0 ? Yi(t.node(0), t.node(i), t.before(i + 1), t.index(i), r, n) : Yi(t.node(0), t.node(i), t.after(i + 1), t.index(i) + 1, r, n);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, r = 1) {
    return this.findFrom(t, r) || this.findFrom(t, -r) || new gn(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return Yi(t, t, 0, 0, 1) || new gn(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return Yi(t, t, t.content.size, t.childCount, -1) || new gn(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, r) {
    if (!r || !r.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = df[r.type];
    if (!n)
      throw new RangeError(`No selection type ${r.type} defined`);
    return n.fromJSON(t, r);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, r) {
    if (t in df)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return df[t] = r, r.prototype.jsonID = t, r;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Qe.between(this.$anchor, this.$head).getBookmark();
  }
}
Ze.prototype.visible = !0;
class XC {
  /**
  Create a range.
  */
  constructor(t, r) {
    this.$from = t, this.$to = r;
  }
}
let MM = !1;
function yM(e) {
  !MM && !e.parent.inlineContent && (MM = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Qe extends Ze {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, r = t) {
    yM(t), yM(r), super(t, r);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, r) {
    let n = t.resolve(r.map(this.head));
    if (!n.parent.inlineContent)
      return Ze.near(n);
    let o = t.resolve(r.map(this.anchor));
    return new Qe(o.parent.inlineContent ? o : n, n);
  }
  replace(t, r = we.empty) {
    if (super.replace(t, r), r == we.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && t.ensureMarks(n);
    }
  }
  eq(t) {
    return t instanceof Qe && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new ld(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.anchor != "number" || typeof r.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Qe(t.resolve(r.anchor), t.resolve(r.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, r, n = r) {
    let o = t.resolve(r);
    return new this(o, n == r ? o : t.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, r, n) {
    let o = t.pos - r.pos;
    if ((!n || o) && (n = o >= 0 ? 1 : -1), !r.parent.inlineContent) {
      let i = Ze.findFrom(r, n, !0) || Ze.findFrom(r, -n, !0);
      if (i)
        r = i.$head;
      else
        return Ze.near(r, n);
    }
    return t.parent.inlineContent || (o == 0 ? t = r : (t = (Ze.findFrom(t, -n, !0) || Ze.findFrom(t, n, !0)).$anchor, t.pos < r.pos != o < 0 && (t = r))), new Qe(t, r);
  }
}
Ze.jsonID("text", Qe);
class ld {
  constructor(t, r) {
    this.anchor = t, this.head = r;
  }
  map(t) {
    return new ld(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return Qe.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class Pe extends Ze {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let r = t.nodeAfter, n = t.node(0).resolve(t.pos + r.nodeSize);
    super(t, n), this.node = r;
  }
  map(t, r) {
    let { deleted: n, pos: o } = r.mapResult(this.anchor), i = t.resolve(o);
    return n ? Ze.near(i) : new Pe(i);
  }
  content() {
    return new we(pe.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof Pe && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new e0(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, r) {
    if (typeof r.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Pe(t.resolve(r.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, r) {
    return new Pe(t.resolve(r));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
Pe.prototype.visible = !1;
Ze.jsonID("node", Pe);
class e0 {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: r, pos: n } = t.mapResult(this.anchor);
    return r ? new ld(n, n) : new e0(n);
  }
  resolve(t) {
    let r = t.resolve(this.anchor), n = r.nodeAfter;
    return n && Pe.isSelectable(n) ? new Pe(r) : Ze.near(r);
  }
}
class gn extends Ze {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, r = we.empty) {
    if (r == we.empty) {
      t.delete(0, t.doc.content.size);
      let n = Ze.atStart(t.doc);
      n.eq(t.selection) || t.setSelection(n);
    } else
      super.replace(t, r);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new gn(t);
  }
  map(t) {
    return new gn(t);
  }
  eq(t) {
    return t instanceof gn;
  }
  getBookmark() {
    return vH;
  }
}
Ze.jsonID("all", gn);
const vH = {
  map() {
    return this;
  },
  resolve(e) {
    return new gn(e);
  }
};
function Yi(e, t, r, n, o, i = !1) {
  if (t.inlineContent)
    return Qe.create(e, r);
  for (let a = n - (o > 0 ? 0 : 1); o > 0 ? a < t.childCount : a >= 0; a += o) {
    let l = t.child(a);
    if (l.isAtom) {
      if (!i && Pe.isSelectable(l))
        return Pe.create(e, r - (o < 0 ? l.nodeSize : 0));
    } else {
      let s = Yi(e, l, r + o, o < 0 ? l.childCount : 0, o, i);
      if (s)
        return s;
    }
    r += l.nodeSize * o;
  }
  return null;
}
function xM(e, t, r) {
  let n = e.steps.length - 1;
  if (n < t)
    return;
  let o = e.steps[n];
  if (!(o instanceof er || o instanceof Kt))
    return;
  let i = e.mapping.maps[n], a;
  i.forEach((l, s, c, u) => {
    a == null && (a = u);
  }), e.setSelection(Ze.near(e.doc.resolve(a), r));
}
function wM(e, t) {
  return !t || !e ? e : e.bind(t);
}
class eu {
  constructor(t, r, n) {
    this.name = t, this.init = wM(r.init, n), this.apply = wM(r.apply, n);
  }
}
new eu("doc", {
  init(e) {
    return e.doc || e.schema.topNodeType.createAndFill();
  },
  apply(e) {
    return e.doc;
  }
}), new eu("selection", {
  init(e, t) {
    return e.selection || Ze.atStart(t.doc);
  },
  apply(e) {
    return e.selection;
  }
}), new eu("storedMarks", {
  init(e) {
    return e.storedMarks || null;
  },
  apply(e, t, r, n) {
    return n.selection.$cursor ? e.storedMarks : null;
  }
}), new eu("scrollToSelection", {
  init() {
    return 0;
  },
  apply(e, t) {
    return e.scrolledIntoView ? t + 1 : t;
  }
});
function eI(e, t, r) {
  for (let n in e) {
    let o = e[n];
    o instanceof Function ? o = o.bind(t) : n == "handleDOMEvents" && (o = eI(o, t, {})), r[n] = o;
  }
  return r;
}
class Nr {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && eI(t.props, this, this.props), this.key = t.key ? t.key.key : tI("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const ff = /* @__PURE__ */ Object.create(null);
function tI(e) {
  return e in ff ? e + "$" + ++ff[e] : (ff[e] = 0, e + "$");
}
class pr {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = tI(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Ci = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, rI = function(e, t, r, n) {
  return r && (TM(e, t, r, n, -1) || TM(e, t, r, n, 1));
}, bH = /^(img|br|input|textarea|hr)$/i;
function TM(e, t, r, n, o) {
  for (; ; ) {
    if (e == r && t == n)
      return !0;
    if (t == (o < 0 ? 0 : Ku(e))) {
      let i = e.parentNode;
      if (!i || i.nodeType != 1 || t0(e) || bH.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = Ci(e) + (o < 0 ? 0 : 1), e = i;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (o < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = o < 0 ? Ku(e) : 0;
    } else
      return !1;
  }
}
function Ku(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function MH(e, t, r) {
  for (let n = t == 0, o = t == Ku(e); n || o; ) {
    if (e == r)
      return !0;
    let i = Ci(e);
    if (e = e.parentNode, !e)
      return !1;
    n = n && i == 0, o = o && i == Ku(e);
  }
}
function t0(e) {
  let t;
  for (let r = e; r && !(t = r.pmViewDesc); r = r.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const nI = function(e) {
  return e.focusNode && rI(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function oI(e, t) {
  let r = document.createEvent("Event");
  return r.initEvent("keydown", !0, !0), r.keyCode = e, r.key = r.code = t, r;
}
const Rn = typeof navigator < "u" ? navigator : null, NM = typeof document < "u" ? document : null, Lo = Rn && Rn.userAgent || "", dg = /Edge\/(\d+)/.exec(Lo), iI = /MSIE \d/.exec(Lo), fg = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Lo), Ss = !!(iI || fg || dg), aI = iI ? document.documentMode : fg ? +fg[1] : dg ? +dg[1] : 0, sd = !Ss && /gecko\/(\d+)/i.test(Lo);
sd && +(/Firefox\/(\d+)/.exec(Lo) || [0, 0])[1];
const pg = !Ss && /Chrome\/(\d+)/.exec(Lo), Ii = !!pg, yH = pg ? +pg[1] : 0, Ai = !Ss && !!Rn && /Apple Computer/.test(Rn.vendor), r0 = Ai && (/Mobile\/\w+/.test(Lo) || !!Rn && Rn.maxTouchPoints > 2), Jr = r0 || (Rn ? /Mac/.test(Rn.platform) : !1), xH = Rn ? /Win/.test(Rn.platform) : !1, Cs = /Android \d/.test(Lo), n0 = !!NM && "webkitFontSmoothing" in NM.documentElement.style, wH = n0 ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function TH(e, t = null) {
  let r = e.domSelectionRange(), n = e.state.doc;
  if (!r.focusNode)
    return null;
  let o = e.docView.nearestDesc(r.focusNode), i = o && o.size == 0, a = e.docView.posFromDOM(r.focusNode, r.focusOffset, 1);
  if (a < 0)
    return null;
  let l = n.resolve(a), s, c;
  if (nI(r)) {
    for (s = l; o && !o.node; )
      o = o.parent;
    let u = o.node;
    if (o && u.isAtom && Pe.isSelectable(u) && o.parent && !(u.isInline && MH(r.focusNode, r.focusOffset, o.dom))) {
      let d = o.posBefore;
      c = new Pe(a == d ? l : n.resolve(d));
    }
  } else {
    let u = e.docView.posFromDOM(r.anchorNode, r.anchorOffset, 1);
    if (u < 0)
      return null;
    s = n.resolve(u);
  }
  if (!c) {
    let u = t == "pointer" || e.state.selection.head < l.pos && !i ? 1 : -1;
    c = sI(e, s, l, u);
  }
  return c;
}
function lI(e) {
  return e.editable ? e.hasFocus() : IH(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function o0(e, t = !1) {
  let r = e.state.selection;
  if (CH(e, r), !!lI(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && Ii) {
      let n = e.domSelectionRange(), o = e.domObserver.currentSelection;
      if (n.anchorNode && o.anchorNode && rI(n.anchorNode, n.anchorOffset, o.anchorNode, o.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      SH(e);
    else {
      let { anchor: n, head: o } = r, i, a;
      SM && !(r instanceof Qe) && (r.$from.parent.inlineContent || (i = CM(e, r.from)), !r.empty && !r.$from.parent.inlineContent && (a = CM(e, r.to))), e.docView.setSelection(n, o, e.root, t), SM && (i && IM(i), a && IM(a)), r.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && NH(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const SM = Ai || Ii && yH < 63;
function CM(e, t) {
  let { node: r, offset: n } = e.docView.domFromPos(t, 0), o = n < r.childNodes.length ? r.childNodes[n] : null, i = n ? r.childNodes[n - 1] : null;
  if (Ai && o && o.contentEditable == "false")
    return pf(o);
  if ((!o || o.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (o)
      return pf(o);
    if (i)
      return pf(i);
  }
}
function pf(e) {
  return e.contentEditable = "true", Ai && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function IM(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function NH(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let r = e.domSelectionRange(), n = r.anchorNode, o = r.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (r.anchorNode != n || r.anchorOffset != o) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!lI(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function SH(e) {
  let t = e.domSelection(), r = document.createRange(), n = e.cursorWrapper.dom, o = n.nodeName == "IMG";
  o ? r.setEnd(n.parentNode, Ci(n) + 1) : r.setEnd(n, 0), r.collapse(!1), t.removeAllRanges(), t.addRange(r), !o && !e.state.selection.visible && Ss && aI <= 11 && (n.disabled = !0, n.disabled = !1);
}
function CH(e, t) {
  if (t instanceof Pe) {
    let r = e.docView.descAt(t.from);
    r != e.lastSelectedViewDesc && (AM(e), r && r.selectNode(), e.lastSelectedViewDesc = r);
  } else
    AM(e);
}
function AM(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function sI(e, t, r, n) {
  return e.someProp("createSelectionBetween", (o) => o(e, t, r)) || Qe.between(t, r, n);
}
function IH(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function hg(e, t) {
  let { $anchor: r, $head: n } = e.selection, o = t > 0 ? r.max(n) : r.min(n), i = o.parent.inlineContent ? o.depth ? e.doc.resolve(t > 0 ? o.after() : o.before()) : null : o;
  return i && Ze.findFrom(i, t);
}
function ho(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function DM(e, t, r) {
  let n = e.state.selection;
  if (n instanceof Qe)
    if (r.indexOf("s") > -1) {
      let { $head: o } = n, i = o.textOffset ? null : t < 0 ? o.nodeBefore : o.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let a = e.state.doc.resolve(o.pos + i.nodeSize * (t < 0 ? -1 : 1));
      return ho(e, new Qe(n.$anchor, a));
    } else if (n.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let o = hg(e.state, t);
        return o && o instanceof Pe ? ho(e, o) : !1;
      } else if (!(Jr && r.indexOf("m") > -1)) {
        let o = n.$head, i = o.textOffset ? null : t < 0 ? o.nodeBefore : o.nodeAfter, a;
        if (!i || i.isText)
          return !1;
        let l = t < 0 ? o.pos - i.nodeSize : o.pos;
        return i.isAtom || (a = e.docView.descAt(l)) && !a.contentDOM ? Pe.isSelectable(i) ? ho(e, new Pe(t < 0 ? e.state.doc.resolve(o.pos - i.nodeSize) : o)) : n0 ? ho(e, new Qe(e.state.doc.resolve(t < 0 ? l : l + i.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (n instanceof Pe && n.node.isInline)
      return ho(e, new Qe(t > 0 ? n.$to : n.$from));
    {
      let o = hg(e.state, t);
      return o ? ho(e, o) : !1;
    }
  }
}
function qu(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function vl(e, t) {
  let r = e.pmViewDesc;
  return r && r.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function Bi(e, t) {
  return t < 0 ? AH(e) : DH(e);
}
function AH(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let o, i, a = !1;
  for (sd && r.nodeType == 1 && n < qu(r) && vl(r.childNodes[n], -1) && (a = !0); ; )
    if (n > 0) {
      if (r.nodeType != 1)
        break;
      {
        let l = r.childNodes[n - 1];
        if (vl(l, -1))
          o = r, i = --n;
        else if (l.nodeType == 3)
          r = l, n = r.nodeValue.length;
        else
          break;
      }
    } else {
      if (uI(r))
        break;
      {
        let l = r.previousSibling;
        for (; l && vl(l, -1); )
          o = r.parentNode, i = Ci(l), l = l.previousSibling;
        if (l)
          r = l, n = qu(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = 0;
        }
      }
    }
  a ? gg(e, r, n) : o && gg(e, o, i);
}
function DH(e) {
  let t = e.domSelectionRange(), r = t.focusNode, n = t.focusOffset;
  if (!r)
    return;
  let o = qu(r), i, a;
  for (; ; )
    if (n < o) {
      if (r.nodeType != 1)
        break;
      let l = r.childNodes[n];
      if (vl(l, 1))
        i = r, a = ++n;
      else
        break;
    } else {
      if (uI(r))
        break;
      {
        let l = r.nextSibling;
        for (; l && vl(l, 1); )
          i = l.parentNode, a = Ci(l) + 1, l = l.nextSibling;
        if (l)
          r = l, n = 0, o = qu(r);
        else {
          if (r = r.parentNode, r == e.dom)
            break;
          n = o = 0;
        }
      }
    }
  i && gg(e, i, a);
}
function uI(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function kH(e, t) {
  for (; e && t == e.childNodes.length && !t0(e); )
    t = Ci(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let r = e.childNodes[t];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    e = r, t = 0;
  }
}
function EH(e, t) {
  for (; e && !t && !t0(e); )
    t = Ci(e), e = e.parentNode;
  for (; e && t; ) {
    let r = e.childNodes[t - 1];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    e = r, t = e.childNodes.length;
  }
}
function gg(e, t, r) {
  if (t.nodeType != 3) {
    let i, a;
    (a = kH(t, r)) ? (t = a, r = 0) : (i = EH(t, r)) && (t = i, r = i.nodeValue.length);
  }
  let n = e.domSelection();
  if (nI(n)) {
    let i = document.createRange();
    i.setEnd(t, r), i.setStart(t, r), n.removeAllRanges(), n.addRange(i);
  } else
    n.extend && n.extend(t, r);
  e.domObserver.setCurSelection();
  let { state: o } = e;
  setTimeout(() => {
    e.state == o && o0(e);
  }, 50);
}
function kM(e, t) {
  let r = e.state.doc.resolve(t);
  if (!(Ii || xH) && r.parent.inlineContent) {
    let o = e.coordsAtPos(t);
    if (t > r.start()) {
      let i = e.coordsAtPos(t - 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left < o.left ? "ltr" : "rtl";
    }
    if (t < r.end()) {
      let i = e.coordsAtPos(t + 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function EM(e, t, r) {
  let n = e.state.selection;
  if (n instanceof Qe && !n.empty || r.indexOf("s") > -1 || Jr && r.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: i } = n;
  if (!o.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let a = hg(e.state, t);
    if (a && a instanceof Pe)
      return ho(e, a);
  }
  if (!o.parent.inlineContent) {
    let a = t < 0 ? o : i, l = n instanceof gn ? Ze.near(a, t) : Ze.findFrom(a, t);
    return l ? ho(e, l) : !1;
  }
  return !1;
}
function LM(e, t) {
  if (!(e.state.selection instanceof Qe))
    return !0;
  let { $head: r, $anchor: n, empty: o } = e.state.selection;
  if (!r.sameParent(n))
    return !0;
  if (!o)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let i = !r.textOffset && (t < 0 ? r.nodeBefore : r.nodeAfter);
  if (i && !i.isText) {
    let a = e.state.tr;
    return t < 0 ? a.delete(r.pos - i.nodeSize, r.pos) : a.delete(r.pos, r.pos + i.nodeSize), e.dispatch(a), !0;
  }
  return !1;
}
function $M(e, t, r) {
  e.domObserver.stop(), t.contentEditable = r, e.domObserver.start();
}
function LH(e) {
  if (!Ai || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: r } = e.domSelectionRange();
  if (t && t.nodeType == 1 && r == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let n = t.firstChild;
    $M(e, n, "true"), setTimeout(() => $M(e, n, "false"), 20);
  }
  return !1;
}
function $H(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function zH(e, t) {
  let r = t.keyCode, n = $H(t);
  if (r == 8 || Jr && r == 72 && n == "c")
    return LM(e, -1) || Bi(e, -1);
  if (r == 46 && !t.shiftKey || Jr && r == 68 && n == "c")
    return LM(e, 1) || Bi(e, 1);
  if (r == 13 || r == 27)
    return !0;
  if (r == 37 || Jr && r == 66 && n == "c") {
    let o = r == 37 ? kM(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return DM(e, o, n) || Bi(e, o);
  } else if (r == 39 || Jr && r == 70 && n == "c") {
    let o = r == 39 ? kM(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return DM(e, o, n) || Bi(e, o);
  } else {
    if (r == 38 || Jr && r == 80 && n == "c")
      return EM(e, -1, n) || Bi(e, -1);
    if (r == 40 || Jr && r == 78 && n == "c")
      return LH(e) || EM(e, 1, n) || Bi(e, 1);
    if (n == (Jr ? "m" : "c") && (r == 66 || r == 73 || r == 89 || r == 90))
      return !0;
  }
  return !1;
}
function cI(e, t) {
  e.someProp("transformCopied", (p) => {
    t = p(t, e);
  });
  let r = [], { content: n, openStart: o, openEnd: i } = t;
  for (; o > 1 && i > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    o--, i--;
    let p = n.firstChild;
    r.push(p.type.name, p.attrs != p.type.defaultAttrs ? p.attrs : null), n = p.content;
  }
  let a = e.someProp("clipboardSerializer") || Jo.fromSchema(e.state.schema), l = mI(), s = l.createElement("div");
  s.appendChild(a.serializeFragment(n, { document: l }));
  let c = s.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = gI[c.nodeName.toLowerCase()]); ) {
    for (let p = u.length - 1; p >= 0; p--) {
      let h = l.createElement(u[p]);
      for (; s.firstChild; )
        h.appendChild(s.firstChild);
      s.appendChild(h), d++;
    }
    c = s.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${o} ${i}${d ? ` -${d}` : ""} ${JSON.stringify(r)}`);
  let f = e.someProp("clipboardTextSerializer", (p) => p(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: s, text: f };
}
function dI(e, t, r, n, o) {
  let i = o.parent.type.spec.code, a, l;
  if (!r && !t)
    return null;
  let s = t && (n || i || !r);
  if (s) {
    if (e.someProp("transformPastedText", (f) => {
      t = f(t, i || n, e);
    }), i)
      return t ? new we(pe.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : we.empty;
    let d = e.someProp("clipboardTextParser", (f) => f(t, o, n, e));
    if (d)
      l = d;
    else {
      let f = o.marks(), { schema: p } = e.state, h = Jo.fromSchema(p);
      a = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let m = a.appendChild(document.createElement("p"));
        g && m.appendChild(h.serializeNode(p.text(g, f)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (d) => {
      r = d(r, e);
    }), a = RH(r), n0 && _H(a);
  let c = a && a.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let f = a.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      a = f;
    }
  if (l || (l = (e.someProp("clipboardParser") || e.someProp("domParser") || Kl.fromSchema(e.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(s || u),
    context: o,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !OH.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    l = PH(zM(l, +u[1], +u[2]), u[4]);
  else if (l = we.maxOpen(jH(l.content, o), !0), l.openStart || l.openEnd) {
    let d = 0, f = 0;
    for (let p = l.content.firstChild; d < l.openStart && !p.type.spec.isolating; d++, p = p.firstChild)
      ;
    for (let p = l.content.lastChild; f < l.openEnd && !p.type.spec.isolating; f++, p = p.lastChild)
      ;
    l = zM(l, d, f);
  }
  return e.someProp("transformPasted", (d) => {
    l = d(l, e);
  }), l;
}
const OH = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function jH(e, t) {
  if (e.childCount < 2)
    return e;
  for (let r = t.depth; r >= 0; r--) {
    let o = t.node(r).contentMatchAt(t.index(r)), i, a = [];
    if (e.forEach((l) => {
      if (!a)
        return;
      let s = o.findWrapping(l.type), c;
      if (!s)
        return a = null;
      if (c = a.length && i.length && pI(s, i, l, a[a.length - 1], 0))
        a[a.length - 1] = c;
      else {
        a.length && (a[a.length - 1] = hI(a[a.length - 1], i.length));
        let u = fI(l, s);
        a.push(u), o = o.matchType(u.type), i = s;
      }
    }), a)
      return pe.from(a);
  }
  return e;
}
function fI(e, t, r = 0) {
  for (let n = t.length - 1; n >= r; n--)
    e = t[n].create(null, pe.from(e));
  return e;
}
function pI(e, t, r, n, o) {
  if (o < e.length && o < t.length && e[o] == t[o]) {
    let i = pI(e, t, r, n.lastChild, o + 1);
    if (i)
      return n.copy(n.content.replaceChild(n.childCount - 1, i));
    if (n.contentMatchAt(n.childCount).matchType(o == e.length - 1 ? r.type : e[o + 1]))
      return n.copy(n.content.append(pe.from(fI(r, e, o + 1))));
  }
}
function hI(e, t) {
  if (t == 0)
    return e;
  let r = e.content.replaceChild(e.childCount - 1, hI(e.lastChild, t - 1)), n = e.contentMatchAt(e.childCount).fillBefore(pe.empty, !0);
  return e.copy(r.append(n));
}
function mg(e, t, r, n, o, i) {
  let a = t < 0 ? e.firstChild : e.lastChild, l = a.content;
  return e.childCount > 1 && (i = 0), o < n - 1 && (l = mg(l, t, r, n, o + 1, i)), o >= r && (l = t < 0 ? a.contentMatchAt(0).fillBefore(l, i <= o).append(l) : l.append(a.contentMatchAt(a.childCount).fillBefore(pe.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(l));
}
function zM(e, t, r) {
  return t < e.openStart && (e = new we(mg(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), r < e.openEnd && (e = new we(mg(e.content, 1, r, e.openEnd, 0, 0), e.openStart, r)), e;
}
const gI = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let OM = null;
function mI() {
  return OM || (OM = document.implementation.createHTMLDocument("title"));
}
function RH(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let r = mI().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(e), o;
  if ((o = n && gI[n[1].toLowerCase()]) && (e = o.map((i) => "<" + i + ">").join("") + e + o.map((i) => "</" + i + ">").reverse().join("")), r.innerHTML = e, o)
    for (let i = 0; i < o.length; i++)
      r = r.querySelector(o[i]) || r;
  return r;
}
function _H(e) {
  let t = e.querySelectorAll(Ii ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let r = 0; r < t.length; r++) {
    let n = t[r];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), n);
  }
}
function PH(e, t) {
  if (!e.size)
    return e;
  let r = e.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: o, openStart: i, openEnd: a } = e;
  for (let l = n.length - 2; l >= 0; l -= 2) {
    let s = r.nodes[n[l]];
    if (!s || s.hasRequiredAttrs())
      break;
    o = pe.from(s.create(n[l + 1], o)), i++, a++;
  }
  return new we(o, i, a);
}
const wn = {}, Fr = {};
function xo(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
Fr.keydown = (e, t) => {
  let r = t;
  if (e.input.shiftKey = r.keyCode == 16 || r.shiftKey, !bI(e, r) && (e.input.lastKeyCode = r.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Cs && Ii && r.keyCode == 13)))
    if (r.keyCode != 229 && e.domObserver.forceFlush(), r0 && r.keyCode == 13 && !r.ctrlKey && !r.altKey && !r.metaKey) {
      let n = Date.now();
      e.input.lastIOSEnter = n, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == n && (e.someProp("handleKeyDown", (o) => o(e, oI(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else
      e.someProp("handleKeyDown", (n) => n(e, r)) || zH(e, r) ? r.preventDefault() : xo(e, "key");
};
Fr.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Fr.keypress = (e, t) => {
  let r = t;
  if (bI(e, r) || !r.charCode || r.ctrlKey && !r.altKey || Jr && r.metaKey)
    return;
  if (e.someProp("handleKeyPress", (o) => o(e, r))) {
    r.preventDefault();
    return;
  }
  let n = e.state.selection;
  if (!(n instanceof Qe) || !n.$from.sameParent(n.$to)) {
    let o = String.fromCharCode(r.charCode);
    !/[\r\n]/.test(o) && !e.someProp("handleTextInput", (i) => i(e, n.$from.pos, n.$to.pos, o)) && e.dispatch(e.state.tr.insertText(o).scrollIntoView()), r.preventDefault();
  }
};
function ud(e) {
  return { left: e.clientX, top: e.clientY };
}
function BH(e, t) {
  let r = t.x - e.clientX, n = t.y - e.clientY;
  return r * r + n * n < 100;
}
function i0(e, t, r, n, o) {
  if (n == -1)
    return !1;
  let i = e.state.doc.resolve(n);
  for (let a = i.depth + 1; a > 0; a--)
    if (e.someProp(t, (l) => a > i.depth ? l(e, r, i.nodeAfter, i.before(a), o, !0) : l(e, r, i.node(a), i.before(a), o, !1)))
      return !0;
  return !1;
}
function na(e, t, r) {
  e.focused || e.focus();
  let n = e.state.tr.setSelection(t);
  r == "pointer" && n.setMeta("pointer", !0), e.dispatch(n);
}
function FH(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.doc.resolve(t), n = r.nodeAfter;
  return n && n.isAtom && Pe.isSelectable(n) ? (na(e, new Pe(r), "pointer"), !0) : !1;
}
function UH(e, t) {
  if (t == -1)
    return !1;
  let r = e.state.selection, n, o;
  r instanceof Pe && (n = r.node);
  let i = e.state.doc.resolve(t);
  for (let a = i.depth + 1; a > 0; a--) {
    let l = a > i.depth ? i.nodeAfter : i.node(a);
    if (Pe.isSelectable(l)) {
      n && r.$from.depth > 0 && a >= r.$from.depth && i.before(r.$from.depth + 1) == r.$from.pos ? o = i.before(r.$from.depth) : o = i.before(a);
      break;
    }
  }
  return o != null ? (na(e, Pe.create(e.state.doc, o), "pointer"), !0) : !1;
}
function HH(e, t, r, n, o) {
  return i0(e, "handleClickOn", t, r, n) || e.someProp("handleClick", (i) => i(e, t, n)) || (o ? UH(e, r) : FH(e, r));
}
function YH(e, t, r, n) {
  return i0(e, "handleDoubleClickOn", t, r, n) || e.someProp("handleDoubleClick", (o) => o(e, t, n));
}
function WH(e, t, r, n) {
  return i0(e, "handleTripleClickOn", t, r, n) || e.someProp("handleTripleClick", (o) => o(e, t, n)) || QH(e, r, n);
}
function QH(e, t, r) {
  if (r.button != 0)
    return !1;
  let n = e.state.doc;
  if (t == -1)
    return n.inlineContent ? (na(e, Qe.create(n, 0, n.content.size), "pointer"), !0) : !1;
  let o = n.resolve(t);
  for (let i = o.depth + 1; i > 0; i--) {
    let a = i > o.depth ? o.nodeAfter : o.node(i), l = o.before(i);
    if (a.inlineContent)
      na(e, Qe.create(n, l + 1, l + 1 + a.content.size), "pointer");
    else if (Pe.isSelectable(a))
      na(e, Pe.create(n, l), "pointer");
    else
      continue;
    return !0;
  }
}
function a0(e) {
  return Ju(e);
}
const vI = Jr ? "metaKey" : "ctrlKey";
wn.mousedown = (e, t) => {
  let r = t;
  e.input.shiftKey = r.shiftKey;
  let n = a0(e), o = Date.now(), i = "singleClick";
  o - e.input.lastClick.time < 500 && BH(r, e.input.lastClick) && !r[vI] && (e.input.lastClick.type == "singleClick" ? i = "doubleClick" : e.input.lastClick.type == "doubleClick" && (i = "tripleClick")), e.input.lastClick = { time: o, x: r.clientX, y: r.clientY, type: i };
  let a = e.posAtCoords(ud(r));
  a && (i == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new VH(e, a, r, !!n)) : (i == "doubleClick" ? YH : WH)(e, a.pos, a.inside, r) ? r.preventDefault() : xo(e, "pointer"));
};
class VH {
  constructor(t, r, n, o) {
    this.view = t, this.pos = r, this.event = n, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!n[vI], this.allowDefault = n.shiftKey;
    let i, a;
    if (r.inside > -1)
      i = t.state.doc.nodeAt(r.inside), a = r.inside;
    else {
      let u = t.state.doc.resolve(r.pos);
      i = u.parent, a = u.depth ? u.before() : 0;
    }
    const l = o ? null : n.target, s = l ? t.docView.nearestDesc(l, !0) : null;
    this.target = s ? s.dom : null;
    let { selection: c } = t.state;
    (n.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof Pe && c.from <= a && c.to > a) && (this.mightDrag = {
      node: i,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && sd && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), xo(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => o0(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let r = this.pos;
    this.view.state.doc != this.startDoc && (r = this.view.posAtCoords(ud(t))), this.updateAllowDefault(t), this.allowDefault || !r ? xo(this.view, "pointer") : HH(this.view, r.pos, r.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Ai && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ii && !this.view.state.selection.visible && Math.min(Math.abs(r.pos - this.view.state.selection.from), Math.abs(r.pos - this.view.state.selection.to)) <= 2) ? (na(this.view, Ze.near(this.view.state.doc.resolve(r.pos)), "pointer"), t.preventDefault()) : xo(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), xo(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
wn.touchstart = (e) => {
  e.input.lastTouch = Date.now(), a0(e), xo(e, "pointer");
};
wn.touchmove = (e) => {
  e.input.lastTouch = Date.now(), xo(e, "pointer");
};
wn.contextmenu = (e) => a0(e);
function bI(e, t) {
  return e.composing ? !0 : Ai && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const ZH = Cs ? 5e3 : -1;
Fr.compositionstart = Fr.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, r = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !r.textOffset && r.parentOffset && r.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || r.marks(), Ju(e, !0), e.markCursor = null;
    else if (Ju(e), sd && t.selection.empty && r.parentOffset && !r.textOffset && r.nodeBefore.marks.length) {
      let n = e.domSelectionRange();
      for (let o = n.focusNode, i = n.focusOffset; o && o.nodeType == 1 && i != 0; ) {
        let a = i < 0 ? o.lastChild : o.childNodes[i - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          e.domSelection().collapse(a, a.nodeValue.length);
          break;
        } else
          o = a, i = -1;
      }
    }
    e.input.composing = !0;
  }
  MI(e, ZH);
};
Fr.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, MI(e, 20));
};
function MI(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => Ju(e), t));
}
function GH(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = KH()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function KH() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function Ju(e, t = !1) {
  if (!(Cs && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), GH(e), t || e.docView && e.docView.dirty) {
      let r = TH(e);
      return r && !r.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(r)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function qH(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.dom.parentNode.appendChild(document.createElement("div"));
  r.appendChild(t), r.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), o = document.createRange();
  o.selectNodeContents(t), e.dom.blur(), n.removeAllRanges(), n.addRange(o), setTimeout(() => {
    r.parentNode && r.parentNode.removeChild(r), e.focus();
  }, 50);
}
const Jl = Ss && aI < 15 || r0 && wH < 604;
wn.copy = Fr.cut = (e, t) => {
  let r = t, n = e.state.selection, o = r.type == "cut";
  if (n.empty)
    return;
  let i = Jl ? null : r.clipboardData, a = n.content(), { dom: l, text: s } = cI(e, a);
  i ? (r.preventDefault(), i.clearData(), i.setData("text/html", l.innerHTML), i.setData("text/plain", s)) : qH(e, l), o && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function JH(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function XH(e, t) {
  if (!e.dom.parentNode)
    return;
  let r = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, n = e.dom.parentNode.appendChild(document.createElement(r ? "textarea" : "div"));
  r || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus();
  let o = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), n.parentNode && n.parentNode.removeChild(n), r ? vg(e, n.value, null, o, t) : vg(e, n.textContent, n.innerHTML, o, t);
  }, 50);
}
function vg(e, t, r, n, o) {
  let i = dI(e, t, r, n, e.state.selection.$from);
  if (e.someProp("handlePaste", (s) => s(e, o, i || we.empty)))
    return !0;
  if (!i)
    return !1;
  let a = JH(i), l = a ? e.state.tr.replaceSelectionWith(a, n) : e.state.tr.replaceSelection(i);
  return e.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function yI(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let r = e.getData("text/uri-list");
  return r ? r.replace(/\r?\n/g, " ") : "";
}
Fr.paste = (e, t) => {
  let r = t;
  if (e.composing && !Cs)
    return;
  let n = Jl ? null : r.clipboardData, o = e.input.shiftKey && e.input.lastKeyCode != 45;
  n && vg(e, yI(n), n.getData("text/html"), o, r) ? r.preventDefault() : XH(e, r);
};
class eY {
  constructor(t, r, n) {
    this.slice = t, this.move = r, this.node = n;
  }
}
const xI = Jr ? "altKey" : "ctrlKey";
wn.dragstart = (e, t) => {
  let r = t, n = e.input.mouseDown;
  if (n && n.done(), !r.dataTransfer)
    return;
  let o = e.state.selection, i = o.empty ? null : e.posAtCoords(ud(r)), a;
  if (!(i && i.pos >= o.from && i.pos <= (o instanceof Pe ? o.to - 1 : o.to))) {
    if (n && n.mightDrag)
      a = Pe.create(e.state.doc, n.mightDrag.pos);
    else if (r.target && r.target.nodeType == 1) {
      let u = e.docView.nearestDesc(r.target, !0);
      u && u.node.type.spec.draggable && u != e.docView && (a = Pe.create(e.state.doc, u.posBefore));
    }
  }
  let l = (a || e.state.selection).content(), { dom: s, text: c } = cI(e, l);
  r.dataTransfer.clearData(), r.dataTransfer.setData(Jl ? "Text" : "text/html", s.innerHTML), r.dataTransfer.effectAllowed = "copyMove", Jl || r.dataTransfer.setData("text/plain", c), e.dragging = new eY(l, !r[xI], a);
};
wn.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Fr.dragover = Fr.dragenter = (e, t) => t.preventDefault();
Fr.drop = (e, t) => {
  let r = t, n = e.dragging;
  if (e.dragging = null, !r.dataTransfer)
    return;
  let o = e.posAtCoords(ud(r));
  if (!o)
    return;
  let i = e.state.doc.resolve(o.pos), a = n && n.slice;
  a ? e.someProp("transformPasted", (h) => {
    a = h(a, e);
  }) : a = dI(e, yI(r.dataTransfer), Jl ? null : r.dataTransfer.getData("text/html"), !1, i);
  let l = !!(n && !r[xI]);
  if (e.someProp("handleDrop", (h) => h(e, r, a || we.empty, l))) {
    r.preventDefault();
    return;
  }
  if (!a)
    return;
  r.preventDefault();
  let s = a ? cH(e.state.doc, i.pos, a) : i.pos;
  s == null && (s = i.pos);
  let c = e.state.tr;
  if (l) {
    let { node: h } = n;
    h ? h.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(s), d = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, f = c.doc;
  if (d ? c.replaceRangeWith(u, u, a.content.firstChild) : c.replaceRange(u, u, a), c.doc.eq(f))
    return;
  let p = c.doc.resolve(u);
  if (d && Pe.isSelectable(a.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(a.content.firstChild))
    c.setSelection(new Pe(p));
  else {
    let h = c.mapping.map(s);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((g, m, v, M) => h = M), c.setSelection(sI(e, p, c.doc.resolve(h)));
  }
  e.focus(), e.dispatch(c.setMeta("uiEvent", "drop"));
};
wn.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && o0(e);
  }, 20));
};
wn.blur = (e, t) => {
  let r = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), r.relatedTarget && e.dom.contains(r.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
wn.beforeinput = (e, t) => {
  if (Ii && Cs && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: n } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != n || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (i) => i(e, oI(8, "Backspace")))))
        return;
      let { $cursor: o } = e.state.selection;
      o && o.pos > 0 && e.dispatch(e.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Fr)
  wn[e] = Fr[e];
function Xl(e, t) {
  if (e == t)
    return !0;
  for (let r in e)
    if (e[r] !== t[r])
      return !1;
  for (let r in t)
    if (!(r in e))
      return !1;
  return !0;
}
class Xu {
  constructor(t, r) {
    this.toDOM = t, this.spec = r || oi, this.side = this.spec.side || 0;
  }
  map(t, r, n, o) {
    let { pos: i, deleted: a } = t.mapResult(r.from + o, this.side < 0 ? -1 : 1);
    return a ? null : new tn(i - n, i - n, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof Xu && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && Xl(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class To {
  constructor(t, r) {
    this.attrs = t, this.spec = r || oi;
  }
  map(t, r, n, o) {
    let i = t.map(r.from + o, this.spec.inclusiveStart ? -1 : 1) - n, a = t.map(r.to + o, this.spec.inclusiveEnd ? 1 : -1) - n;
    return i >= a ? null : new tn(i, a, this);
  }
  valid(t, r) {
    return r.from < r.to;
  }
  eq(t) {
    return this == t || t instanceof To && Xl(this.attrs, t.attrs) && Xl(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof To;
  }
  destroy() {
  }
}
class l0 {
  constructor(t, r) {
    this.attrs = t, this.spec = r || oi;
  }
  map(t, r, n, o) {
    let i = t.mapResult(r.from + o, 1);
    if (i.deleted)
      return null;
    let a = t.mapResult(r.to + o, -1);
    return a.deleted || a.pos <= i.pos ? null : new tn(i.pos - n, a.pos - n, this);
  }
  valid(t, r) {
    let { index: n, offset: o } = t.content.findIndex(r.from), i;
    return o == r.from && !(i = t.child(n)).isText && o + i.nodeSize == r.to;
  }
  eq(t) {
    return this == t || t instanceof l0 && Xl(this.attrs, t.attrs) && Xl(this.spec, t.spec);
  }
  destroy() {
  }
}
class tn {
  /**
  @internal
  */
  constructor(t, r, n) {
    this.from = t, this.to = r, this.type = n;
  }
  /**
  @internal
  */
  copy(t, r) {
    return new tn(t, r, this.type);
  }
  /**
  @internal
  */
  eq(t, r = 0) {
    return this.type.eq(t.type) && this.from + r == t.from && this.to + r == t.to;
  }
  /**
  @internal
  */
  map(t, r, n) {
    return this.type.map(t, this, r, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, r, n) {
    return new tn(t, t, new Xu(r, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, r, n, o) {
    return new tn(t, r, new To(n, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, r, n, o) {
    return new tn(t, r, new l0(n, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof To;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Xu;
  }
}
const Wi = [], oi = {};
class Pt {
  /**
  @internal
  */
  constructor(t, r) {
    this.local = t.length ? t : Wi, this.children = r.length ? r : Wi;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, r) {
    return r.length ? ec(r, t, 0, oi) : vr;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, r, n) {
    let o = [];
    return this.findInner(t ?? 0, r ?? 1e9, o, 0, n), o;
  }
  findInner(t, r, n, o, i) {
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      l.from <= r && l.to >= t && (!i || i(l.spec)) && n.push(l.copy(l.from + o, l.to + o));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < r && this.children[a + 1] > t) {
        let l = this.children[a] + 1;
        this.children[a + 2].findInner(t - l, r - l, n, o + l, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, r, n) {
    return this == vr || t.maps.length == 0 ? this : this.mapInner(t, r, 0, 0, n || oi);
  }
  /**
  @internal
  */
  mapInner(t, r, n, o, i) {
    let a;
    for (let l = 0; l < this.local.length; l++) {
      let s = this.local[l].map(t, n, o);
      s && s.type.valid(r, s) ? (a || (a = [])).push(s) : i.onRemove && i.onRemove(this.local[l].spec);
    }
    return this.children.length ? tY(this.children, a || [], t, r, n, o, i) : a ? new Pt(a.sort(ii), Wi) : vr;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, r) {
    return r.length ? this == vr ? Pt.create(t, r) : this.addInner(t, r, 0) : this;
  }
  addInner(t, r, n) {
    let o, i = 0;
    t.forEach((l, s) => {
      let c = s + n, u;
      if (u = TI(r, l, c)) {
        for (o || (o = this.children.slice()); i < o.length && o[i] < s; )
          i += 3;
        o[i] == s ? o[i + 2] = o[i + 2].addInner(l, u, c + 1) : o.splice(i, 0, s, s + l.nodeSize, ec(u, l, c + 1, oi)), i += 3;
      }
    });
    let a = wI(i ? NI(r) : r, -n);
    for (let l = 0; l < a.length; l++)
      a[l].type.valid(t, a[l]) || a.splice(l--, 1);
    return new Pt(a.length ? this.local.concat(a).sort(ii) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == vr ? this : this.removeInner(t, 0);
  }
  removeInner(t, r) {
    let n = this.children, o = this.local;
    for (let i = 0; i < n.length; i += 3) {
      let a, l = n[i] + r, s = n[i + 1] + r;
      for (let u = 0, d; u < t.length; u++)
        (d = t[u]) && d.from > l && d.to < s && (t[u] = null, (a || (a = [])).push(d));
      if (!a)
        continue;
      n == this.children && (n = this.children.slice());
      let c = n[i + 2].removeInner(a, l + 1);
      c != vr ? n[i + 2] = c : (n.splice(i, 3), i -= 3);
    }
    if (o.length) {
      for (let i = 0, a; i < t.length; i++)
        if (a = t[i])
          for (let l = 0; l < o.length; l++)
            o[l].eq(a, r) && (o == this.local && (o = this.local.slice()), o.splice(l--, 1));
    }
    return n == this.children && o == this.local ? this : o.length || n.length ? new Pt(o, n) : vr;
  }
  /**
  @internal
  */
  forChild(t, r) {
    if (this == vr)
      return this;
    if (r.isLeaf)
      return Pt.empty;
    let n, o;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= t) {
        this.children[l] == t && (n = this.children[l + 2]);
        break;
      }
    let i = t + 1, a = i + r.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let s = this.local[l];
      if (s.from < a && s.to > i && s.type instanceof To) {
        let c = Math.max(i, s.from) - i, u = Math.min(a, s.to) - i;
        c < u && (o || (o = [])).push(s.copy(c, u));
      }
    }
    if (o) {
      let l = new Pt(o.sort(ii), Wi);
      return n ? new Vo([l, n]) : l;
    }
    return n || vr;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof Pt) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let r = 0; r < this.local.length; r++)
      if (!this.local[r].eq(t.local[r]))
        return !1;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] != t.children[r] || this.children[r + 1] != t.children[r + 1] || !this.children[r + 2].eq(t.children[r + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return s0(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == vr)
      return Wi;
    if (t.inlineContent || !this.local.some(To.is))
      return this.local;
    let r = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof To || r.push(this.local[n]);
    return r;
  }
}
Pt.empty = new Pt([], []);
Pt.removeOverlap = s0;
const vr = Pt.empty;
class Vo {
  constructor(t) {
    this.members = t;
  }
  map(t, r) {
    const n = this.members.map((o) => o.map(t, r, oi));
    return Vo.from(n);
  }
  forChild(t, r) {
    if (r.isLeaf)
      return Pt.empty;
    let n = [];
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].forChild(t, r);
      i != vr && (i instanceof Vo ? n = n.concat(i.members) : n.push(i));
    }
    return Vo.from(n);
  }
  eq(t) {
    if (!(t instanceof Vo) || t.members.length != this.members.length)
      return !1;
    for (let r = 0; r < this.members.length; r++)
      if (!this.members[r].eq(t.members[r]))
        return !1;
    return !0;
  }
  locals(t) {
    let r, n = !0;
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].localsInner(t);
      if (i.length)
        if (!r)
          r = i;
        else {
          n && (r = r.slice(), n = !1);
          for (let a = 0; a < i.length; a++)
            r.push(i[a]);
        }
    }
    return r ? s0(n ? r : r.sort(ii)) : Wi;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return vr;
      case 1:
        return t[0];
      default:
        return new Vo(t.every((r) => r instanceof Pt) ? t : t.reduce((r, n) => r.concat(n instanceof Pt ? n : n.members), []));
    }
  }
}
function tY(e, t, r, n, o, i, a) {
  let l = e.slice();
  for (let c = 0, u = i; c < r.maps.length; c++) {
    let d = 0;
    r.maps[c].forEach((f, p, h, g) => {
      let m = g - h - (p - f);
      for (let v = 0; v < l.length; v += 3) {
        let M = l[v + 1];
        if (M < 0 || f > M + u - d)
          continue;
        let x = l[v] + u - d;
        p >= x ? l[v + 1] = f <= x ? -2 : -1 : f >= u && m && (l[v] += m, l[v + 1] += m);
      }
      d += m;
    }), u = r.maps[c].map(u, -1);
  }
  let s = !1;
  for (let c = 0; c < l.length; c += 3)
    if (l[c + 1] < 0) {
      if (l[c + 1] == -2) {
        s = !0, l[c + 1] = -1;
        continue;
      }
      let u = r.map(e[c] + i), d = u - o;
      if (d < 0 || d >= n.content.size) {
        s = !0;
        continue;
      }
      let f = r.map(e[c + 1] + i, -1), p = f - o, { index: h, offset: g } = n.content.findIndex(d), m = n.maybeChild(h);
      if (m && g == d && g + m.nodeSize == p) {
        let v = l[c + 2].mapInner(r, m, u + 1, e[c] + i + 1, a);
        v != vr ? (l[c] = d, l[c + 1] = p, l[c + 2] = v) : (l[c + 1] = -2, s = !0);
      } else
        s = !0;
    }
  if (s) {
    let c = rY(l, e, t, r, o, i, a), u = ec(c, n, 0, a);
    t = u.local;
    for (let d = 0; d < l.length; d += 3)
      l[d + 1] < 0 && (l.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < u.children.length; d += 3) {
      let p = u.children[d];
      for (; f < l.length && l[f] < p; )
        f += 3;
      l.splice(f, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new Pt(t.sort(ii), l);
}
function wI(e, t) {
  if (!t || !e.length)
    return e;
  let r = [];
  for (let n = 0; n < e.length; n++) {
    let o = e[n];
    r.push(new tn(o.from + t, o.to + t, o.type));
  }
  return r;
}
function rY(e, t, r, n, o, i, a) {
  function l(s, c) {
    for (let u = 0; u < s.local.length; u++) {
      let d = s.local[u].map(n, o, c);
      d ? r.push(d) : a.onRemove && a.onRemove(s.local[u].spec);
    }
    for (let u = 0; u < s.children.length; u += 3)
      l(s.children[u + 2], s.children[u] + c + 1);
  }
  for (let s = 0; s < e.length; s += 3)
    e[s + 1] == -1 && l(e[s + 2], t[s] + i + 1);
  return r;
}
function TI(e, t, r) {
  if (t.isLeaf)
    return null;
  let n = r + t.nodeSize, o = null;
  for (let i = 0, a; i < e.length; i++)
    (a = e[i]) && a.from > r && a.to < n && ((o || (o = [])).push(a), e[i] = null);
  return o;
}
function NI(e) {
  let t = [];
  for (let r = 0; r < e.length; r++)
    e[r] != null && t.push(e[r]);
  return t;
}
function ec(e, t, r, n) {
  let o = [], i = !1;
  t.forEach((l, s) => {
    let c = TI(e, l, s + r);
    if (c) {
      i = !0;
      let u = ec(c, l, r + s + 1, n);
      u != vr && o.push(s, s + l.nodeSize, u);
    }
  });
  let a = wI(i ? NI(e) : e, -r).sort(ii);
  for (let l = 0; l < a.length; l++)
    a[l].type.valid(t, a[l]) || (n.onRemove && n.onRemove(a[l].spec), a.splice(l--, 1));
  return a.length || o.length ? new Pt(a, o) : vr;
}
function ii(e, t) {
  return e.from - t.from || e.to - t.to;
}
function s0(e) {
  let t = e;
  for (let r = 0; r < t.length - 1; r++) {
    let n = t[r];
    if (n.from != n.to)
      for (let o = r + 1; o < t.length; o++) {
        let i = t[o];
        if (i.from == n.from) {
          i.to != n.to && (t == e && (t = e.slice()), t[o] = i.copy(i.from, n.to), jM(t, o + 1, i.copy(n.to, i.to)));
          continue;
        } else {
          i.from < n.to && (t == e && (t = e.slice()), t[r] = n.copy(n.from, i.from), jM(t, o, n.copy(i.from, n.to)));
          break;
        }
      }
  }
  return t;
}
function jM(e, t, r) {
  for (; t < e.length && ii(r, e[t]) > 0; )
    t++;
  e.splice(t, 0, r);
}
var Io = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, tc = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, nY = typeof navigator < "u" && /Mac/.test(navigator.platform), oY = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var tr = 0; tr < 10; tr++)
  Io[48 + tr] = Io[96 + tr] = String(tr);
for (var tr = 1; tr <= 24; tr++)
  Io[tr + 111] = "F" + tr;
for (var tr = 65; tr <= 90; tr++)
  Io[tr] = String.fromCharCode(tr + 32), tc[tr] = String.fromCharCode(tr);
for (var hf in Io)
  tc.hasOwnProperty(hf) || (tc[hf] = Io[hf]);
function iY(e) {
  var t = nY && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || oY && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", r = !t && e.key || (e.shiftKey ? tc : Io)[e.keyCode] || e.key || "Unidentified";
  return r == "Esc" && (r = "Escape"), r == "Del" && (r = "Delete"), r == "Left" && (r = "ArrowLeft"), r == "Up" && (r = "ArrowUp"), r == "Right" && (r = "ArrowRight"), r == "Down" && (r = "ArrowDown"), r;
}
const aY = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function lY(e) {
  let t = e.split(/-(?!$)/), r = t[t.length - 1];
  r == "Space" && (r = " ");
  let n, o, i, a;
  for (let l = 0; l < t.length - 1; l++) {
    let s = t[l];
    if (/^(cmd|meta|m)$/i.test(s))
      a = !0;
    else if (/^a(lt)?$/i.test(s))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      o = !0;
    else if (/^s(hift)?$/i.test(s))
      i = !0;
    else if (/^mod$/i.test(s))
      aY ? a = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + s);
  }
  return n && (r = "Alt-" + r), o && (r = "Ctrl-" + r), a && (r = "Meta-" + r), i && (r = "Shift-" + r), r;
}
function sY(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in e)
    t[lY(r)] = e[r];
  return t;
}
function gf(e, t, r = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), r && t.shiftKey && (e = "Shift-" + e), e;
}
function uY(e) {
  let t = sY(e);
  return function(r, n) {
    let o = iY(n), i, a = t[gf(o, n)];
    if (a && a(r.state, r.dispatch, r))
      return !0;
    if (o.length == 1 && o != " ") {
      if (n.shiftKey) {
        let l = t[gf(o, n, !1)];
        if (l && l(r.state, r.dispatch, r))
          return !0;
      }
      if ((n.shiftKey || n.altKey || n.metaKey || o.charCodeAt(0) > 127) && (i = Io[n.keyCode]) && i != o) {
        let l = t[gf(i, n)];
        if (l && l(r.state, r.dispatch, r))
          return !0;
      }
    }
    return !1;
  };
}
const cY = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function dY(e, t) {
  let { $cursor: r } = e.selection;
  return !r || (t ? !t.endOfTextblock("backward", e) : r.parentOffset > 0) ? null : r;
}
const fY = (e, t, r) => {
  let n = dY(e, r);
  if (!n)
    return !1;
  let o = SI(n);
  if (!o) {
    let a = n.blockRange(), l = a && Oa(a);
    return l == null ? !1 : (t && t(e.tr.lift(a, l).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (!i.type.spec.isolating && AI(e, o, t))
    return !0;
  if (n.parent.content.size == 0 && (ha(i, "end") || Pe.isSelectable(i))) {
    let a = Xm(e.doc, n.before(), n.after(), we.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let l = e.tr.step(a);
        l.setSelection(ha(i, "end") ? Ze.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : Pe.create(l.doc, o.pos - i.nodeSize)), t(l.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == n.depth - 1 ? (t && t(e.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0) : !1;
};
function ha(e, t, r = !1) {
  for (let n = e; n; n = t == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (r && n.childCount != 1)
      return !1;
  }
  return !1;
}
const pY = (e, t, r) => {
  let { $head: n, empty: o } = e.selection, i = n;
  if (!o)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("backward", e) : n.parentOffset > 0)
      return !1;
    i = SI(n);
  }
  let a = i && i.nodeBefore;
  return !a || !Pe.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(Pe.create(e.doc, i.pos - a.nodeSize)).scrollIntoView()), !0);
};
function SI(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function hY(e, t) {
  let { $cursor: r } = e.selection;
  return !r || (t ? !t.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size) ? null : r;
}
const gY = (e, t, r) => {
  let n = hY(e, r);
  if (!n)
    return !1;
  let o = CI(n);
  if (!o)
    return !1;
  let i = o.nodeAfter;
  if (AI(e, o, t))
    return !0;
  if (n.parent.content.size == 0 && (ha(i, "start") || Pe.isSelectable(i))) {
    let a = Xm(e.doc, n.before(), n.after(), we.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let l = e.tr.step(a);
        l.setSelection(ha(i, "start") ? Ze.findFrom(l.doc.resolve(l.mapping.map(o.pos)), 1) : Pe.create(l.doc, l.mapping.map(o.pos))), t(l.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == n.depth - 1 ? (t && t(e.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, mY = (e, t, r) => {
  let { $head: n, empty: o } = e.selection, i = n;
  if (!o)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size)
      return !1;
    i = CI(n);
  }
  let a = i && i.nodeAfter;
  return !a || !Pe.isSelectable(a) ? !1 : (t && t(e.tr.setSelection(Pe.create(e.doc, i.pos)).scrollIntoView()), !0);
};
function CI(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let r = e.node(t);
      if (e.index(t) + 1 < r.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (r.type.spec.isolating)
        break;
    }
  return null;
}
const vY = (e, t) => {
  let r = e.selection, n = r instanceof Pe, o;
  if (n) {
    if (r.node.isTextblock || !Eo(e.doc, r.from))
      return !1;
    o = r.from;
  } else if (o = ad(e.doc, r.from, -1), o == null)
    return !1;
  if (t) {
    let i = e.tr.join(o);
    n && i.setSelection(Pe.create(i.doc, o - e.doc.resolve(o).nodeBefore.nodeSize)), t(i.scrollIntoView());
  }
  return !0;
}, bY = (e, t) => {
  let r = e.selection, n;
  if (r instanceof Pe) {
    if (r.node.isTextblock || !Eo(e.doc, r.to))
      return !1;
    n = r.to;
  } else if (n = ad(e.doc, r.to, 1), n == null)
    return !1;
  return t && t(e.tr.join(n).scrollIntoView()), !0;
}, MY = (e, t) => {
  let { $from: r, $to: n } = e.selection, o = r.blockRange(n), i = o && Oa(o);
  return i == null ? !1 : (t && t(e.tr.lift(o, i).scrollIntoView()), !0);
}, yY = (e, t) => {
  let { $head: r, $anchor: n } = e.selection;
  return !r.parent.type.spec.code || !r.sameParent(n) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function II(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: r } = e.edge(t);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
const xY = (e, t) => {
  let { $head: r, $anchor: n } = e.selection;
  if (!r.parent.type.spec.code || !r.sameParent(n))
    return !1;
  let o = r.node(-1), i = r.indexAfter(-1), a = II(o.contentMatchAt(i));
  if (!a || !o.canReplaceWith(i, i, a))
    return !1;
  if (t) {
    let l = r.after(), s = e.tr.replaceWith(l, l, a.createAndFill());
    s.setSelection(Ze.near(s.doc.resolve(l), 1)), t(s.scrollIntoView());
  }
  return !0;
}, wY = (e, t) => {
  let r = e.selection, { $from: n, $to: o } = r;
  if (r instanceof gn || n.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let i = II(o.parent.contentMatchAt(o.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (t) {
    let a = (!n.parentOffset && o.index() < o.parent.childCount ? n : o).pos, l = e.tr.insert(a, i.createAndFill());
    l.setSelection(Qe.create(l.doc, a + 1)), t(l.scrollIntoView());
  }
  return !0;
}, TY = (e, t) => {
  let { $cursor: r } = e.selection;
  if (!r || r.parent.content.size)
    return !1;
  if (r.depth > 1 && r.after() != r.end(-1)) {
    let i = r.before();
    if (ta(e.doc, i))
      return t && t(e.tr.split(i).scrollIntoView()), !0;
  }
  let n = r.blockRange(), o = n && Oa(n);
  return o == null ? !1 : (t && t(e.tr.lift(n, o).scrollIntoView()), !0);
}, NY = (e, t) => {
  let { $from: r, to: n } = e.selection, o, i = r.sharedDepth(n);
  return i == 0 ? !1 : (o = r.before(i), t && t(e.tr.setSelection(Pe.create(e.doc, o))), !0);
};
function SY(e, t, r) {
  let n = t.nodeBefore, o = t.nodeAfter, i = t.index();
  return !n || !o || !n.type.compatibleContent(o.type) ? !1 : !n.content.size && t.parent.canReplace(i - 1, i) ? (r && r(e.tr.delete(t.pos - n.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(i, i + 1) || !(o.isTextblock || Eo(e.doc, t.pos)) ? !1 : (r && r(e.tr.clearIncompatible(t.pos, n.type, n.contentMatchAt(n.childCount)).join(t.pos).scrollIntoView()), !0);
}
function AI(e, t, r) {
  let n = t.nodeBefore, o = t.nodeAfter, i, a;
  if (n.type.spec.isolating || o.type.spec.isolating)
    return !1;
  if (SY(e, t, r))
    return !0;
  let l = t.parent.canReplace(t.index(), t.index() + 1);
  if (l && (i = (a = n.contentMatchAt(n.childCount)).findWrapping(o.type)) && a.matchType(i[0] || o.type).validEnd) {
    if (r) {
      let d = t.pos + o.nodeSize, f = pe.empty;
      for (let g = i.length - 1; g >= 0; g--)
        f = pe.from(i[g].create(null, f));
      f = pe.from(n.copy(f));
      let p = e.tr.step(new Kt(t.pos - 1, d, t.pos, d, new we(f, 1, 0), i.length, !0)), h = d + 2 * i.length;
      Eo(p.doc, h) && p.join(h), r(p.scrollIntoView());
    }
    return !0;
  }
  let s = Ze.findFrom(t, 1), c = s && s.$from.blockRange(s.$to), u = c && Oa(c);
  if (u != null && u >= t.depth)
    return r && r(e.tr.lift(c, u).scrollIntoView()), !0;
  if (l && ha(o, "start", !0) && ha(n, "end")) {
    let d = n, f = [];
    for (; f.push(d), !d.isTextblock; )
      d = d.lastChild;
    let p = o, h = 1;
    for (; !p.isTextblock; p = p.firstChild)
      h++;
    if (d.canReplace(d.childCount, d.childCount, p.content)) {
      if (r) {
        let g = pe.empty;
        for (let v = f.length - 1; v >= 0; v--)
          g = pe.from(f[v].copy(g));
        let m = e.tr.step(new Kt(t.pos - f.length, t.pos + o.nodeSize, t.pos + h, t.pos + o.nodeSize - h, new we(g, f.length, 0), 0, !0));
        r(m.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function DI(e) {
  return function(t, r) {
    let n = t.selection, o = e < 0 ? n.$from : n.$to, i = o.depth;
    for (; o.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return o.node(i).isTextblock ? (r && r(t.tr.setSelection(Qe.create(t.doc, e < 0 ? o.start(i) : o.end(i)))), !0) : !1;
  };
}
const CY = DI(-1), IY = DI(1);
function AY(e, t = null) {
  return function(r, n) {
    let { $from: o, $to: i } = r.selection, a = o.blockRange(i), l = a && Jm(a, e, t);
    return l ? (n && n(r.tr.wrap(a, l).scrollIntoView()), !0) : !1;
  };
}
function RM(e, t = null) {
  return function(r, n) {
    let o = !1;
    for (let i = 0; i < r.selection.ranges.length && !o; i++) {
      let { $from: { pos: a }, $to: { pos: l } } = r.selection.ranges[i];
      r.doc.nodesBetween(a, l, (s, c) => {
        if (o)
          return !1;
        if (!(!s.isTextblock || s.hasMarkup(e, t)))
          if (s.type == e)
            o = !0;
          else {
            let u = r.doc.resolve(c), d = u.index();
            o = u.parent.canReplaceWith(d, d + 1, e);
          }
      });
    }
    if (!o)
      return !1;
    if (n) {
      let i = r.tr;
      for (let a = 0; a < r.selection.ranges.length; a++) {
        let { $from: { pos: l }, $to: { pos: s } } = r.selection.ranges[a];
        i.setBlockType(l, s, e, t);
      }
      n(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function DY(e, t = null) {
  return function(r, n) {
    let { $from: o, $to: i } = r.selection, a = o.blockRange(i), l = !1, s = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && o.node(a.depth - 1).type.compatibleContent(e) && a.startIndex == 0) {
      if (o.index(a.depth - 1) == 0)
        return !1;
      let u = r.doc.resolve(a.start - 2);
      s = new sg(u, u, a.depth), a.endIndex < a.parent.childCount && (a = new sg(o, r.doc.resolve(i.end(a.depth)), a.depth)), l = !0;
    }
    let c = Jm(s, e, t, a);
    return c ? (n && n(kY(r.tr, a, c, l, e).scrollIntoView()), !0) : !1;
  };
}
function kY(e, t, r, n, o) {
  let i = pe.empty;
  for (let u = r.length - 1; u >= 0; u--)
    i = pe.from(r[u].type.create(r[u].attrs, i));
  e.step(new Kt(t.start - (n ? 2 : 0), t.end, t.start, t.end, new we(i, 0, 0), r.length, !0));
  let a = 0;
  for (let u = 0; u < r.length; u++)
    r[u].type == o && (a = u + 1);
  let l = r.length - a, s = t.start + r.length - (n ? 2 : 0), c = t.parent;
  for (let u = t.startIndex, d = t.endIndex, f = !0; u < d; u++, f = !1)
    !f && ta(e.doc, s, l) && (e.split(s, l), s += 2 * l), s += c.child(u).nodeSize;
  return e;
}
function EY(e) {
  return function(t, r) {
    let { $from: n, $to: o } = t.selection, i = n.blockRange(o, (a) => a.childCount > 0 && a.firstChild.type == e);
    return i ? r ? n.node(i.depth - 1).type == e ? LY(t, r, e, i) : $Y(t, r, i) : !0 : !1;
  };
}
function LY(e, t, r, n) {
  let o = e.tr, i = n.end, a = n.$to.end(n.depth);
  i < a && (o.step(new Kt(i - 1, a, i, a, new we(pe.from(r.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new sg(o.doc.resolve(n.$from.pos), o.doc.resolve(a), n.depth));
  const l = Oa(n);
  if (l == null)
    return !1;
  o.lift(n, l);
  let s = o.mapping.map(i, -1) - 1;
  return Eo(o.doc, s) && o.join(s), t(o.scrollIntoView()), !0;
}
function $Y(e, t, r) {
  let n = e.tr, o = r.parent;
  for (let p = r.end, h = r.endIndex - 1, g = r.startIndex; h > g; h--)
    p -= o.child(h).nodeSize, n.delete(p - 1, p + 1);
  let i = n.doc.resolve(r.start), a = i.nodeAfter;
  if (n.mapping.map(r.end) != r.start + i.nodeAfter.nodeSize)
    return !1;
  let l = r.startIndex == 0, s = r.endIndex == o.childCount, c = i.node(-1), u = i.index(-1);
  if (!c.canReplace(u + (l ? 0 : 1), u + 1, a.content.append(s ? pe.empty : pe.from(o))))
    return !1;
  let d = i.pos, f = d + a.nodeSize;
  return n.step(new Kt(d - (l ? 1 : 0), f + (s ? 1 : 0), d + 1, f - 1, new we((l ? pe.empty : pe.from(o.copy(pe.empty))).append(s ? pe.empty : pe.from(o.copy(pe.empty))), l ? 0 : 1, s ? 0 : 1), l ? 0 : 1)), t(n.scrollIntoView()), !0;
}
function zY(e) {
  return function(t, r) {
    let { $from: n, $to: o } = t.selection, i = n.blockRange(o, (c) => c.childCount > 0 && c.firstChild.type == e);
    if (!i)
      return !1;
    let a = i.startIndex;
    if (a == 0)
      return !1;
    let l = i.parent, s = l.child(a - 1);
    if (s.type != e)
      return !1;
    if (r) {
      let c = s.lastChild && s.lastChild.type == l.type, u = pe.from(c ? e.create() : null), d = new we(pe.from(e.create(null, pe.from(l.type.create(null, u)))), c ? 3 : 1, 0), f = i.start, p = i.end;
      r(t.tr.step(new Kt(f - (c ? 3 : 1), p, f, p, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function kI(e) {
  const { state: t, transaction: r } = e;
  let { selection: n } = r, { doc: o } = r, { storedMarks: i } = r;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    filterTransaction: t.filterTransaction,
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return i;
    },
    get selection() {
      return n;
    },
    get doc() {
      return o;
    },
    get tr() {
      return n = r.selection, o = r.doc, i = r.storedMarks, r;
    }
  };
}
class OY {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: r, state: n } = this, { view: o } = r, { tr: i } = n, a = this.buildProps(i);
    return Object.fromEntries(Object.entries(t).map(([l, s]) => [l, (...u) => {
      const d = s(...u)(a);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, r = !0) {
    const { rawCommands: n, editor: o, state: i } = this, { view: a } = o, l = [], s = !!t, c = t || i.tr, u = () => (!s && r && !c.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(c), l.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(n).map(([f, p]) => [f, (...g) => {
        const m = this.buildProps(c, r), v = p(...g)(m);
        return l.push(v), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(t) {
    const { rawCommands: r, state: n } = this, o = !1, i = t || n.tr, a = this.buildProps(i, o);
    return {
      ...Object.fromEntries(Object.entries(r).map(([s, c]) => [s, (...u) => c(...u)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(t, r = !0) {
    const { rawCommands: n, editor: o, state: i } = this, { view: a } = o, l = {
      tr: t,
      editor: o,
      view: a,
      state: kI({
        state: i,
        transaction: t
      }),
      dispatch: r ? () => {
      } : void 0,
      chain: () => this.createChain(t, r),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(n).map(([s, c]) => [s, (...u) => c(...u)(l)]));
      }
    };
    return l;
  }
}
function Wt(e, t, r) {
  return e.config[t] === void 0 && e.parent ? Wt(e.parent, t, r) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...r,
    parent: e.parent ? Wt(e.parent, t, r) : null
  }) : e.config[t];
}
function jY(e) {
  const t = e.filter((o) => o.type === "extension"), r = e.filter((o) => o.type === "node"), n = e.filter((o) => o.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: r,
    markExtensions: n
  };
}
function nr(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function lt(...e) {
  return e.filter((t) => !!t).reduce((t, r) => {
    const n = { ...t };
    return Object.entries(r).forEach(([o, i]) => {
      if (!n[o]) {
        n[o] = i;
        return;
      }
      if (o === "class") {
        const l = i ? i.split(" ") : [], s = n[o] ? n[o].split(" ") : [], c = l.filter((u) => !s.includes(u));
        n[o] = [...s, ...c].join(" ");
      } else
        o === "style" ? n[o] = [n[o], i].join("; ") : n[o] = i;
    }), n;
  }, {});
}
function RY(e) {
  return typeof e == "function";
}
function Dt(e, t = void 0, ...r) {
  return RY(e) ? t ? e.bind(t)(...r) : e(...r) : e;
}
function _Y(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class cd {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
class EI {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
function PY(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function mf(e) {
  return PY(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function dd(e, t) {
  const r = { ...e };
  return mf(e) && mf(t) && Object.keys(t).forEach((n) => {
    mf(t[n]) ? n in e ? r[n] = dd(e[n], t[n]) : Object.assign(r, { [n]: t[n] }) : Object.assign(r, { [n]: t[n] });
  }), r;
}
class dt {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Dt(Wt(this, "addOptions", {
      name: this.name
    }))), this.storage = Dt(Wt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new dt(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = dd(this.options, t), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new dt(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Dt(Wt(r, "addOptions", {
      name: r.name
    })), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
}
function BY(e, t, r) {
  const { from: n, to: o } = t, { blockSeparator: i = `

`, textSerializers: a = {} } = r || {};
  let l = "", s = !0;
  return e.nodesBetween(n, o, (c, u, d, f) => {
    var p;
    const h = a == null ? void 0 : a[c.type.name];
    h ? (c.isBlock && !s && (l += i, s = !0), d && (l += h({
      node: c,
      pos: u,
      parent: d,
      index: f,
      range: t
    }))) : c.isText ? (l += (p = c == null ? void 0 : c.text) === null || p === void 0 ? void 0 : p.slice(Math.max(n, u) - u, o - u), s = !1) : c.isBlock && !s && (l += i, s = !0);
  }), l;
}
function FY(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, r]) => [t, r.spec.toText]));
}
dt.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [
      new Nr({
        key: new pr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: r } = e, { doc: n, selection: o } = t, { ranges: i } = o, a = Math.min(...i.map((u) => u.$from.pos)), l = Math.max(...i.map((u) => u.$to.pos)), s = FY(r);
            return BY(n, { from: a, to: l }, {
              textSerializers: s
            });
          }
        }
      })
    ];
  }
});
const UY = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var r;
  e.isDestroyed || (t.dom.blur(), (r = window == null ? void 0 : window.getSelection()) === null || r === void 0 || r.removeAllRanges());
}), !0), HY = (e = !1) => ({ commands: t }) => t.setContent("", e), YY = () => ({ state: e, tr: t, dispatch: r }) => {
  const { selection: n } = t, { ranges: o } = n;
  return r && o.forEach(({ $from: i, $to: a }) => {
    e.doc.nodesBetween(i.pos, a.pos, (l, s) => {
      if (l.type.isText)
        return;
      const { doc: c, mapping: u } = t, d = c.resolve(u.map(s)), f = c.resolve(u.map(s + l.nodeSize)), p = d.blockRange(f);
      if (!p)
        return;
      const h = Oa(p);
      if (l.type.isTextblock) {
        const { defaultType: g } = d.parent.contentMatchAt(d.index());
        t.setNodeMarkup(p.start, g);
      }
      (h || h === 0) && t.lift(p, h);
    });
  }), !0;
}, WY = (e) => (t) => e(t), QY = () => ({ state: e, dispatch: t }) => wY(e, t), VY = (e, t) => ({ editor: r, tr: n }) => {
  const { state: o } = r, i = o.doc.slice(e.from, e.to);
  n.deleteRange(e.from, e.to);
  const a = n.mapping.map(t);
  return n.insert(a, i.content), n.setSelection(new Qe(n.doc.resolve(a - 1))), !0;
}, ZY = () => ({ tr: e, dispatch: t }) => {
  const { selection: r } = e, n = r.$anchor.node();
  if (n.content.size > 0)
    return !1;
  const o = e.selection.$anchor;
  for (let i = o.depth; i > 0; i -= 1)
    if (o.node(i).type === n.type) {
      if (t) {
        const l = o.before(i), s = o.after(i);
        e.delete(l, s).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, GY = (e) => ({ tr: t, state: r, dispatch: n }) => {
  const o = nr(e, r.schema), i = t.selection.$anchor;
  for (let a = i.depth; a > 0; a -= 1)
    if (i.node(a).type === o) {
      if (n) {
        const s = i.before(a), c = i.after(a);
        t.delete(s, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, KY = (e) => ({ tr: t, dispatch: r }) => {
  const { from: n, to: o } = e;
  return r && t.delete(n, o), !0;
}, qY = () => ({ state: e, dispatch: t }) => cY(e, t), JY = () => ({ commands: e }) => e.keyboardShortcut("Enter"), XY = () => ({ state: e, dispatch: t }) => xY(e, t);
function rc(e, t, r = { strict: !0 }) {
  const n = Object.keys(t);
  return n.length ? n.every((o) => r.strict ? t[o] === e[o] : _Y(t[o]) ? t[o].test(e[o]) : t[o] === e[o]) : !0;
}
function bg(e, t, r = {}) {
  return e.find((n) => n.type === t && rc(n.attrs, r));
}
function eW(e, t, r = {}) {
  return !!bg(e, t, r);
}
function u0(e, t, r = {}) {
  if (!e || !t)
    return;
  let n = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === n.offset && n.offset !== 0 && (n = e.parent.childBefore(e.parentOffset)), !n.node)
    return;
  const o = bg([...n.node.marks], t, r);
  if (!o)
    return;
  let i = n.index, a = e.start() + n.offset, l = i + 1, s = a + n.node.nodeSize;
  for (bg([...n.node.marks], t, r); i > 0 && o.isInSet(e.parent.child(i - 1).marks); )
    i -= 1, a -= e.parent.child(i).nodeSize;
  for (; l < e.parent.childCount && eW([...e.parent.child(l).marks], t, r); )
    s += e.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: s
  };
}
function $o(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const tW = (e, t = {}) => ({ tr: r, state: n, dispatch: o }) => {
  const i = $o(e, n.schema), { doc: a, selection: l } = r, { $from: s, from: c, to: u } = l;
  if (o) {
    const d = u0(s, i, t);
    if (d && d.from <= c && d.to >= u) {
      const f = Qe.create(a, d.from, d.to);
      r.setSelection(f);
    }
  }
  return !0;
}, rW = (e) => (t) => {
  const r = typeof e == "function" ? e(t) : e;
  for (let n = 0; n < r.length; n += 1)
    if (r[n](t))
      return !0;
  return !1;
};
function c0(e) {
  return e instanceof Qe;
}
function Zn(e = 0, t = 0, r = 0) {
  return Math.min(Math.max(e, t), r);
}
function nW(e, t = null) {
  if (!t)
    return null;
  const r = Ze.atStart(e), n = Ze.atEnd(e);
  if (t === "start" || t === !0)
    return r;
  if (t === "end")
    return n;
  const o = r.from, i = n.to;
  return t === "all" ? Qe.create(e, Zn(0, o, i), Zn(e.content.size, o, i)) : Qe.create(e, Zn(t, o, i), Zn(t, o, i));
}
function fd() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const oW = (e = null, t = {}) => ({ editor: r, view: n, tr: o, dispatch: i }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const a = () => {
    fd() && n.dom.focus(), requestAnimationFrame(() => {
      r.isDestroyed || (n.focus(), t != null && t.scrollIntoView && r.commands.scrollIntoView());
    });
  };
  if (n.hasFocus() && e === null || e === !1)
    return !0;
  if (i && e === null && !c0(r.state.selection))
    return a(), !0;
  const l = nW(o.doc, e) || r.state.selection, s = r.state.selection.eq(l);
  return i && (s || o.setSelection(l), s && o.storedMarks && o.setStoredMarks(o.storedMarks), a()), !0;
}, iW = (e, t) => (r) => e.every((n, o) => t(n, { ...r, index: o })), aW = (e, t) => ({ tr: r, commands: n }) => n.insertContentAt({ from: r.selection.from, to: r.selection.to }, e, t);
function _M(e) {
  const t = `<body>${e}</body>`;
  return new window.DOMParser().parseFromString(t, "text/html").body;
}
function nc(e, t, r) {
  if (r = {
    slice: !0,
    parseOptions: {},
    ...r
  }, typeof e == "object" && e !== null)
    try {
      return Array.isArray(e) && e.length > 0 ? pe.fromArray(e.map((n) => t.nodeFromJSON(n))) : t.nodeFromJSON(e);
    } catch (n) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", n), nc("", t, r);
    }
  if (typeof e == "string") {
    const n = Kl.fromSchema(t);
    return r.slice ? n.parseSlice(_M(e), r.parseOptions).content : n.parse(_M(e), r.parseOptions);
  }
  return nc("", t, r);
}
function lW(e, t, r) {
  const n = e.steps.length - 1;
  if (n < t)
    return;
  const o = e.steps[n];
  if (!(o instanceof er || o instanceof Kt))
    return;
  const i = e.mapping.maps[n];
  let a = 0;
  i.forEach((l, s, c, u) => {
    a === 0 && (a = u);
  }), e.setSelection(Ze.near(e.doc.resolve(a), r));
}
const sW = (e) => e.toString().startsWith("<"), uW = (e, t, r) => ({ tr: n, dispatch: o, editor: i }) => {
  if (o) {
    r = {
      parseOptions: {},
      updateSelection: !0,
      ...r
    };
    const a = nc(t, i.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...r.parseOptions
      }
    });
    if (a.toString() === "<>")
      return !0;
    let { from: l, to: s } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, c = !0, u = !0;
    if ((sW(a) ? a : [a]).forEach((f) => {
      f.check(), c = c ? f.isText && f.marks.length === 0 : !1, u = u ? f.isBlock : !1;
    }), l === s && u) {
      const { parent: f } = n.doc.resolve(l);
      f.isTextblock && !f.type.spec.code && !f.childCount && (l -= 1, s += 1);
    }
    c ? Array.isArray(t) ? n.insertText(t.map((f) => f.text || "").join(""), l, s) : typeof t == "object" && t && t.text ? n.insertText(t.text, l, s) : n.insertText(t, l, s) : n.replaceWith(l, s, a), r.updateSelection && lW(n, n.steps.length - 1, -1);
  }
  return !0;
}, cW = () => ({ state: e, dispatch: t }) => vY(e, t), dW = () => ({ state: e, dispatch: t }) => bY(e, t), fW = () => ({ state: e, dispatch: t }) => fY(e, t), pW = () => ({ state: e, dispatch: t }) => gY(e, t), hW = () => ({ tr: e, state: t, dispatch: r }) => {
  try {
    const n = ad(t.doc, t.selection.$from.pos, -1);
    return n == null ? !1 : (e.join(n, 2), r && r(e), !0);
  } catch {
    return !1;
  }
}, gW = () => ({ state: e, dispatch: t, tr: r }) => {
  try {
    const n = ad(e.doc, e.selection.$from.pos, 1);
    return n == null ? !1 : (r.join(n, 2), t && t(r), !0);
  } catch {
    return !1;
  }
};
function LI() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function mW(e) {
  const t = e.split(/-(?!$)/);
  let r = t[t.length - 1];
  r === "Space" && (r = " ");
  let n, o, i, a;
  for (let l = 0; l < t.length - 1; l += 1) {
    const s = t[l];
    if (/^(cmd|meta|m)$/i.test(s))
      a = !0;
    else if (/^a(lt)?$/i.test(s))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      o = !0;
    else if (/^s(hift)?$/i.test(s))
      i = !0;
    else if (/^mod$/i.test(s))
      fd() || LI() ? a = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${s}`);
  }
  return n && (r = `Alt-${r}`), o && (r = `Ctrl-${r}`), a && (r = `Meta-${r}`), i && (r = `Shift-${r}`), r;
}
const vW = (e) => ({ editor: t, view: r, tr: n, dispatch: o }) => {
  const i = mW(e).split(/-(?!$)/), a = i.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), l = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), s = t.captureTransaction(() => {
    r.someProp("handleKeyDown", (c) => c(r, l));
  });
  return s == null || s.steps.forEach((c) => {
    const u = c.map(n.mapping);
    u && o && n.maybeStep(u);
  }), !0;
};
function d0(e, t, r = {}) {
  const { from: n, to: o, empty: i } = e.selection, a = t ? nr(t, e.schema) : null, l = [];
  e.doc.nodesBetween(n, o, (d, f) => {
    if (d.isText)
      return;
    const p = Math.max(n, f), h = Math.min(o, f + d.nodeSize);
    l.push({
      node: d,
      from: p,
      to: h
    });
  });
  const s = o - n, c = l.filter((d) => a ? a.name === d.node.type.name : !0).filter((d) => rc(d.node.attrs, r, { strict: !1 }));
  return i ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= s;
}
const bW = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const o = nr(e, r.schema);
  return d0(r, o, t) ? MY(r, n) : !1;
}, MW = () => ({ state: e, dispatch: t }) => TY(e, t), yW = (e) => ({ state: t, dispatch: r }) => {
  const n = nr(e, t.schema);
  return EY(n)(t, r);
}, xW = () => ({ state: e, dispatch: t }) => yY(e, t);
function f0(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function PM(e, t) {
  const r = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((n, o) => (r.includes(o) || (n[o] = e[o]), n), {});
}
const wW = (e, t) => ({ tr: r, state: n, dispatch: o }) => {
  let i = null, a = null;
  const l = f0(typeof e == "string" ? e : e.name, n.schema);
  return l ? (l === "node" && (i = nr(e, n.schema)), l === "mark" && (a = $o(e, n.schema)), o && r.selection.ranges.forEach((s) => {
    n.doc.nodesBetween(s.$from.pos, s.$to.pos, (c, u) => {
      i && i === c.type && r.setNodeMarkup(u, void 0, PM(c.attrs, t)), a && c.marks.length && c.marks.forEach((d) => {
        a === d.type && r.addMark(u, u + c.nodeSize, a.create(PM(d.attrs, t)));
      });
    });
  }), !0) : !1;
}, TW = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), NW = () => ({ tr: e, commands: t }) => t.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), SW = () => ({ state: e, dispatch: t }) => pY(e, t), CW = () => ({ state: e, dispatch: t }) => mY(e, t), IW = () => ({ state: e, dispatch: t }) => NY(e, t), AW = () => ({ state: e, dispatch: t }) => IY(e, t), DW = () => ({ state: e, dispatch: t }) => CY(e, t);
function kW(e, t, r = {}) {
  return nc(e, t, { slice: !1, parseOptions: r });
}
const EW = (e, t = !1, r = {}) => ({ tr: n, editor: o, dispatch: i }) => {
  const { doc: a } = n, l = kW(e, o.schema, r);
  return i && n.replaceWith(0, a.content.size, l).setMeta("preventUpdate", !t), !0;
};
function p0(e, t) {
  const r = $o(t, e.schema), { from: n, to: o, empty: i } = e.selection, a = [];
  i ? (e.storedMarks && a.push(...e.storedMarks), a.push(...e.selection.$head.marks())) : e.doc.nodesBetween(n, o, (s) => {
    a.push(...s.marks);
  });
  const l = a.find((s) => s.type.name === r.name);
  return l ? { ...l.attrs } : {};
}
function LW(e, t) {
  const r = new JC(e);
  return t.forEach((n) => {
    n.steps.forEach((o) => {
      r.step(o);
    });
  }), r;
}
function $W(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: r } = e.edge(t);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
function zW(e, t, r) {
  const n = [];
  return e.nodesBetween(t.from, t.to, (o, i) => {
    r(o) && n.push({
      node: o,
      pos: i
    });
  }), n;
}
function $I(e, t) {
  for (let r = e.depth; r > 0; r -= 1) {
    const n = e.node(r);
    if (t(n))
      return {
        pos: r > 0 ? e.before(r) : 0,
        start: e.start(r),
        depth: r,
        node: n
      };
  }
}
function h0(e) {
  return (t) => $I(t.$from, e);
}
function OW(e, t) {
  const r = nr(t, e.schema), { from: n, to: o } = e.selection, i = [];
  e.doc.nodesBetween(n, o, (l) => {
    i.push(l);
  });
  const a = i.reverse().find((l) => l.type.name === r.name);
  return a ? { ...a.attrs } : {};
}
function jW(e, t) {
  const r = f0(typeof t == "string" ? t : t.name, e.schema);
  return r === "node" ? OW(e, t) : r === "mark" ? p0(e, t) : {};
}
function RW(e, t = JSON.stringify) {
  const r = {};
  return e.filter((n) => {
    const o = t(n);
    return Object.prototype.hasOwnProperty.call(r, o) ? !1 : r[o] = !0;
  });
}
function _W(e) {
  const t = RW(e);
  return t.length === 1 ? t : t.filter((r, n) => !t.filter((i, a) => a !== n).some((i) => r.oldRange.from >= i.oldRange.from && r.oldRange.to <= i.oldRange.to && r.newRange.from >= i.newRange.from && r.newRange.to <= i.newRange.to));
}
function PW(e) {
  const { mapping: t, steps: r } = e, n = [];
  return t.maps.forEach((o, i) => {
    const a = [];
    if (o.ranges.length)
      o.forEach((l, s) => {
        a.push({ from: l, to: s });
      });
    else {
      const { from: l, to: s } = r[i];
      if (l === void 0 || s === void 0)
        return;
      a.push({ from: l, to: s });
    }
    a.forEach(({ from: l, to: s }) => {
      const c = t.slice(i).map(l, -1), u = t.slice(i).map(s), d = t.invert().map(c, -1), f = t.invert().map(u);
      n.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), _W(n);
}
function oc(e, t, r) {
  const n = [];
  return e === t ? r.resolve(e).marks().forEach((o) => {
    const i = r.resolve(e - 1), a = u0(i, o.type);
    a && n.push({
      mark: o,
      ...a
    });
  }) : r.nodesBetween(e, t, (o, i) => {
    n.push(...o.marks.map((a) => ({
      from: i,
      to: i + o.nodeSize,
      mark: a
    })));
  }), n;
}
function xu(e, t, r) {
  return Object.fromEntries(Object.entries(r).filter(([n]) => {
    const o = e.find((i) => i.type === t && i.name === n);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function BW(e, t, r = {}) {
  const { empty: n, ranges: o } = e.selection, i = t ? $o(t, e.schema) : null;
  if (n)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((d) => i ? i.name === d.type.name : !0).find((d) => rc(d.attrs, r, { strict: !1 }));
  let a = 0;
  const l = [];
  if (o.forEach(({ $from: d, $to: f }) => {
    const p = d.pos, h = f.pos;
    e.doc.nodesBetween(p, h, (g, m) => {
      if (!g.isText && !g.marks.length)
        return;
      const v = Math.max(p, m), M = Math.min(h, m + g.nodeSize), x = M - v;
      a += x, l.push(...g.marks.map((b) => ({
        mark: b,
        from: v,
        to: M
      })));
    });
  }), a === 0)
    return !1;
  const s = l.filter((d) => i ? i.name === d.mark.type.name : !0).filter((d) => rc(d.mark.attrs, r, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = l.filter((d) => i ? d.mark.type !== i && d.mark.type.excludes(i) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (s > 0 ? s + c : s) >= a;
}
function BM(e, t) {
  const { nodeExtensions: r } = jY(t), n = r.find((a) => a.name === e);
  if (!n)
    return !1;
  const o = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, i = Dt(Wt(n, "group", o));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function FW(e) {
  return e instanceof Pe;
}
function zI(e, t, r) {
  const o = e.state.doc.content.size, i = Zn(t, 0, o), a = Zn(r, 0, o), l = e.coordsAtPos(i), s = e.coordsAtPos(a, -1), c = Math.min(l.top, s.top), u = Math.max(l.bottom, s.bottom), d = Math.min(l.left, s.left), f = Math.max(l.right, s.right), p = f - d, h = u - c, v = {
    top: c,
    bottom: u,
    left: d,
    right: f,
    width: p,
    height: h,
    x: d,
    y: c
  };
  return {
    ...v,
    toJSON: () => v
  };
}
function UW(e, t, r) {
  var n;
  const { selection: o } = t;
  let i = null;
  if (c0(o) && (i = o.$cursor), i) {
    const l = (n = e.storedMarks) !== null && n !== void 0 ? n : i.marks();
    return !!r.isInSet(l) || !l.some((s) => s.type.excludes(r));
  }
  const { ranges: a } = o;
  return a.some(({ $from: l, $to: s }) => {
    let c = l.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(r) : !1;
    return e.doc.nodesBetween(l.pos, s.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const p = !f || f.type.allowsMarkType(r), h = !!r.isInSet(u.marks) || !u.marks.some((g) => g.type.excludes(r));
        c = p && h;
      }
      return !c;
    }), c;
  });
}
const HW = (e, t = {}) => ({ tr: r, state: n, dispatch: o }) => {
  const { selection: i } = r, { empty: a, ranges: l } = i, s = $o(e, n.schema);
  if (o)
    if (a) {
      const c = p0(n, s);
      r.addStoredMark(s.create({
        ...c,
        ...t
      }));
    } else
      l.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        n.doc.nodesBetween(u, d, (f, p) => {
          const h = Math.max(p, u), g = Math.min(p + f.nodeSize, d);
          f.marks.find((v) => v.type === s) ? f.marks.forEach((v) => {
            s === v.type && r.addMark(h, g, s.create({
              ...v.attrs,
              ...t
            }));
          }) : r.addMark(h, g, s.create(t));
        });
      });
  return UW(n, r, s);
}, YW = (e, t) => ({ tr: r }) => (r.setMeta(e, t), !0), WW = (e, t = {}) => ({ state: r, dispatch: n, chain: o }) => {
  const i = nr(e, r.schema);
  return i.isTextblock ? o().command(({ commands: a }) => RM(i, t)(r) ? !0 : a.clearNodes()).command(({ state: a }) => RM(i, t)(a, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, QW = (e) => ({ tr: t, dispatch: r }) => {
  if (r) {
    const { doc: n } = t, o = Zn(e, 0, n.content.size), i = Pe.create(n, o);
    t.setSelection(i);
  }
  return !0;
}, VW = (e) => ({ tr: t, dispatch: r }) => {
  if (r) {
    const { doc: n } = t, { from: o, to: i } = typeof e == "number" ? { from: e, to: e } : e, a = Qe.atStart(n).from, l = Qe.atEnd(n).to, s = Zn(o, a, l), c = Zn(i, a, l), u = Qe.create(n, s, c);
    t.setSelection(u);
  }
  return !0;
}, ZW = (e) => ({ state: t, dispatch: r }) => {
  const n = nr(e, t.schema);
  return zY(n)(t, r);
};
function FM(e, t) {
  const r = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (r) {
    const n = r.filter((o) => t == null ? void 0 : t.includes(o.type.name));
    e.tr.ensureMarks(n);
  }
}
const GW = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: r, dispatch: n, editor: o }) => {
  const { selection: i, doc: a } = t, { $from: l, $to: s } = i, c = o.extensionManager.attributes, u = xu(c, l.node().type.name, l.node().attrs);
  if (i instanceof Pe && i.node.isBlock)
    return !l.parentOffset || !ta(a, l.pos) ? !1 : (n && (e && FM(r, o.extensionManager.splittableMarks), t.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  if (n) {
    const d = s.parentOffset === s.parent.content.size;
    i instanceof Qe && t.deleteSelection();
    const f = l.depth === 0 ? void 0 : $W(l.node(-1).contentMatchAt(l.indexAfter(-1)));
    let p = d && f ? [
      {
        type: f,
        attrs: u
      }
    ] : void 0, h = ta(t.doc, t.mapping.map(l.pos), 1, p);
    if (!p && !h && ta(t.doc, t.mapping.map(l.pos), 1, f ? [{ type: f }] : void 0) && (h = !0, p = f ? [
      {
        type: f,
        attrs: u
      }
    ] : void 0), h && (t.split(t.mapping.map(l.pos), 1, p), f && !d && !l.parentOffset && l.parent.type !== f)) {
      const g = t.mapping.map(l.before()), m = t.doc.resolve(g);
      l.node(-1).canReplaceWith(m.index(), m.index() + 1, f) && t.setNodeMarkup(t.mapping.map(l.before()), f);
    }
    e && FM(r, o.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return !0;
}, KW = (e) => ({ tr: t, state: r, dispatch: n, editor: o }) => {
  var i;
  const a = nr(e, r.schema), { $from: l, $to: s } = r.selection, c = r.selection.node;
  if (c && c.isBlock || l.depth < 2 || !l.sameParent(s))
    return !1;
  const u = l.node(-1);
  if (u.type !== a)
    return !1;
  const d = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (n) {
      let m = pe.empty;
      const v = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let y = l.depth - v; y >= l.depth - 3; y -= 1)
        m = pe.from(l.node(y).copy(m));
      const M = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, x = xu(d, l.node().type.name, l.node().attrs), b = ((i = a.contentMatch.defaultType) === null || i === void 0 ? void 0 : i.createAndFill(x)) || void 0;
      m = m.append(pe.from(a.createAndFill(null, b) || void 0));
      const T = l.before(l.depth - (v - 1));
      t.replace(T, l.after(-M), new we(m, 4 - v, 0));
      let w = -1;
      t.doc.nodesBetween(T, t.doc.content.size, (y, I) => {
        if (w > -1)
          return !1;
        y.isTextblock && y.content.size === 0 && (w = I + 1);
      }), w > -1 && t.setSelection(Qe.near(t.doc.resolve(w))), t.scrollIntoView();
    }
    return !0;
  }
  const f = s.pos === l.end() ? u.contentMatchAt(0).defaultType : null, p = xu(d, u.type.name, u.attrs), h = xu(d, l.node().type.name, l.node().attrs);
  t.delete(l.pos, s.pos);
  const g = f ? [
    { type: a, attrs: p },
    { type: f, attrs: h }
  ] : [{ type: a, attrs: p }];
  if (!ta(t.doc, l.pos, 2))
    return !1;
  if (n) {
    const { selection: m, storedMarks: v } = r, { splittableMarks: M } = o.extensionManager, x = v || m.$to.parentOffset && m.$from.marks();
    if (t.split(l.pos, 2, g).scrollIntoView(), !x || !n)
      return !0;
    const b = x.filter((T) => M.includes(T.type.name));
    t.ensureMarks(b);
  }
  return !0;
}, vf = (e, t) => {
  const r = h0((a) => a.type === t)(e.selection);
  if (!r)
    return !0;
  const n = e.doc.resolve(Math.max(0, r.pos - 1)).before(r.depth);
  if (n === void 0)
    return !0;
  const o = e.doc.nodeAt(n);
  return r.node.type === (o == null ? void 0 : o.type) && Eo(e.doc, r.pos) && e.join(r.pos), !0;
}, bf = (e, t) => {
  const r = h0((a) => a.type === t)(e.selection);
  if (!r)
    return !0;
  const n = e.doc.resolve(r.start).after(r.depth);
  if (n === void 0)
    return !0;
  const o = e.doc.nodeAt(n);
  return r.node.type === (o == null ? void 0 : o.type) && Eo(e.doc, n) && e.join(n), !0;
}, qW = (e, t, r, n = {}) => ({ editor: o, tr: i, state: a, dispatch: l, chain: s, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = o.extensionManager, p = nr(e, a.schema), h = nr(t, a.schema), { selection: g, storedMarks: m } = a, { $from: v, $to: M } = g, x = v.blockRange(M), b = m || g.$to.parentOffset && g.$from.marks();
  if (!x)
    return !1;
  const T = h0((w) => BM(w.type.name, d))(g);
  if (x.depth >= 1 && T && x.depth - T.depth <= 1) {
    if (T.node.type === p)
      return c.liftListItem(h);
    if (BM(T.node.type.name, d) && p.validContent(T.node.content) && l)
      return s().command(() => (i.setNodeMarkup(T.pos, p), !0)).command(() => vf(i, p)).command(() => bf(i, p)).run();
  }
  return !r || !b || !l ? s().command(() => u().wrapInList(p, n) ? !0 : c.clearNodes()).wrapInList(p, n).command(() => vf(i, p)).command(() => bf(i, p)).run() : s().command(() => {
    const w = u().wrapInList(p, n), y = b.filter((I) => f.includes(I.type.name));
    return i.ensureMarks(y), w ? !0 : c.clearNodes();
  }).wrapInList(p, n).command(() => vf(i, p)).command(() => bf(i, p)).run();
}, JW = (e, t = {}, r = {}) => ({ state: n, commands: o }) => {
  const { extendEmptyMarkRange: i = !1 } = r, a = $o(e, n.schema);
  return BW(n, a, t) ? o.unsetMark(a, { extendEmptyMarkRange: i }) : o.setMark(a, t);
}, XW = (e, t, r = {}) => ({ state: n, commands: o }) => {
  const i = nr(e, n.schema), a = nr(t, n.schema);
  return d0(n, i, r) ? o.setNode(a) : o.setNode(i, r);
}, eQ = (e, t = {}) => ({ state: r, commands: n }) => {
  const o = nr(e, r.schema);
  return d0(r, o, t) ? n.lift(o) : n.wrapIn(o, t);
}, tQ = () => ({ state: e, dispatch: t }) => {
  const r = e.plugins;
  for (let n = 0; n < r.length; n += 1) {
    const o = r[n];
    let i;
    if (o.spec.isInputRules && (i = o.getState(e))) {
      if (t) {
        const a = e.tr, l = i.transform;
        for (let s = l.steps.length - 1; s >= 0; s -= 1)
          a.step(l.steps[s].invert(l.docs[s]));
        if (i.text) {
          const s = a.doc.resolve(i.from).marks();
          a.replaceWith(i.from, i.to, e.schema.text(i.text, s));
        } else
          a.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, rQ = () => ({ tr: e, dispatch: t }) => {
  const { selection: r } = e, { empty: n, ranges: o } = r;
  return n || t && o.forEach((i) => {
    e.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, nQ = (e, t = {}) => ({ tr: r, state: n, dispatch: o }) => {
  var i;
  const { extendEmptyMarkRange: a = !1 } = t, { selection: l } = r, s = $o(e, n.schema), { $from: c, empty: u, ranges: d } = l;
  if (!o)
    return !0;
  if (u && a) {
    let { from: f, to: p } = l;
    const h = (i = c.marks().find((m) => m.type === s)) === null || i === void 0 ? void 0 : i.attrs, g = u0(c, s, h);
    g && (f = g.from, p = g.to), r.removeMark(f, p, s);
  } else
    d.forEach((f) => {
      r.removeMark(f.$from.pos, f.$to.pos, s);
    });
  return r.removeStoredMark(s), !0;
}, oQ = (e, t = {}) => ({ tr: r, state: n, dispatch: o }) => {
  let i = null, a = null;
  const l = f0(typeof e == "string" ? e : e.name, n.schema);
  return l ? (l === "node" && (i = nr(e, n.schema)), l === "mark" && (a = $o(e, n.schema)), o && r.selection.ranges.forEach((s) => {
    const c = s.$from.pos, u = s.$to.pos;
    n.doc.nodesBetween(c, u, (d, f) => {
      i && i === d.type && r.setNodeMarkup(f, void 0, {
        ...d.attrs,
        ...t
      }), a && d.marks.length && d.marks.forEach((p) => {
        if (a === p.type) {
          const h = Math.max(f, c), g = Math.min(f + d.nodeSize, u);
          r.addMark(h, g, a.create({
            ...p.attrs,
            ...t
          }));
        }
      });
    });
  }), !0) : !1;
}, iQ = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const o = nr(e, r.schema);
  return AY(o, t)(r, n);
}, aQ = (e, t = {}) => ({ state: r, dispatch: n }) => {
  const o = nr(e, r.schema);
  return DY(o, t)(r, n);
};
var lQ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: UY,
  clearContent: HY,
  clearNodes: YY,
  command: WY,
  createParagraphNear: QY,
  cut: VY,
  deleteCurrentNode: ZY,
  deleteNode: GY,
  deleteRange: KY,
  deleteSelection: qY,
  enter: JY,
  exitCode: XY,
  extendMarkRange: tW,
  first: rW,
  focus: oW,
  forEach: iW,
  insertContent: aW,
  insertContentAt: uW,
  joinUp: cW,
  joinDown: dW,
  joinBackward: fW,
  joinForward: pW,
  joinItemBackward: hW,
  joinItemForward: gW,
  keyboardShortcut: vW,
  lift: bW,
  liftEmptyBlock: MW,
  liftListItem: yW,
  newlineInCode: xW,
  resetAttributes: wW,
  scrollIntoView: TW,
  selectAll: NW,
  selectNodeBackward: SW,
  selectNodeForward: CW,
  selectParentNode: IW,
  selectTextblockEnd: AW,
  selectTextblockStart: DW,
  setContent: EW,
  setMark: HW,
  setMeta: YW,
  setNode: WW,
  setNodeSelection: QW,
  setTextSelection: VW,
  sinkListItem: ZW,
  splitBlock: GW,
  splitListItem: KW,
  toggleList: qW,
  toggleMark: JW,
  toggleNode: XW,
  toggleWrap: eQ,
  undoInputRule: tQ,
  unsetAllMarks: rQ,
  unsetMark: nQ,
  updateAttributes: oQ,
  wrapIn: iQ,
  wrapInList: aQ
});
dt.create({
  name: "commands",
  addCommands() {
    return {
      ...lQ
    };
  }
});
dt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Nr({
        key: new pr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
dt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Nr({
        key: new pr("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, r) => {
              e.isFocused = !0;
              const n = e.state.tr.setMeta("focus", { event: r }).setMeta("addToHistory", !1);
              return t.dispatch(n), !1;
            },
            blur: (t, r) => {
              e.isFocused = !1;
              const n = e.state.tr.setMeta("blur", { event: r }).setMeta("addToHistory", !1);
              return t.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
});
dt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: l }) => {
        const { selection: s, doc: c } = l, { empty: u, $anchor: d } = s, { pos: f, parent: p } = d, h = d.parent.isTextblock ? l.doc.resolve(f - 1) : d, g = h.parent.type.spec.isolating, m = d.pos - d.parentOffset, v = g && h.parent.childCount === 1 ? m === d.pos : Ze.atStart(c).from === f;
        return !u || !v || !p.type.isTextblock || p.textContent.length ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...n
    }, i = {
      ...n,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return fd() || LI() ? i : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Nr({
        key: new pr("clearDocument"),
        appendTransaction: (e, t, r) => {
          if (!(e.some((h) => h.docChanged) && !t.doc.eq(r.doc)))
            return;
          const { empty: o, from: i, to: a } = t.selection, l = Ze.atStart(t.doc).from, s = Ze.atEnd(t.doc).to;
          if (o || !(i === l && a === s) || !(r.doc.textBetween(0, r.doc.content.size, " ", " ").length === 0))
            return;
          const d = r.tr, f = kI({
            state: r,
            transaction: d
          }), { commands: p } = new OY({
            editor: this.editor,
            state: f
          });
          if (p.clearNodes(), !!d.steps.length)
            return d;
        }
      })
    ];
  }
});
dt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Nr({
        key: new pr("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function gi(e) {
  return new cd({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const o = Dt(e.getAttributes, void 0, n);
      if (o === !1 || o === null)
        return null;
      const { tr: i } = t, a = n[n.length - 1], l = n[0];
      if (a) {
        const s = l.search(/\S/), c = r.from + l.indexOf(a), u = c + a.length;
        if (oc(r.from, r.to, t.doc).filter((p) => p.mark.type.excluded.find((g) => g === e.type && g !== p.mark.type)).filter((p) => p.to > c).length)
          return null;
        u < r.to && i.delete(u, r.to), c > r.from && i.delete(r.from + s, c);
        const f = r.from + s + a.length;
        i.addMark(r.from + s, f, e.type.create(o || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
function sQ(e) {
  return new cd({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const o = Dt(e.getAttributes, void 0, n) || {}, { tr: i } = t, a = r.from;
      let l = r.to;
      const s = e.type.create(o);
      if (n[1]) {
        const c = n[0].lastIndexOf(n[1]);
        let u = a + c;
        u > l ? u = l : l = u + n[1].length;
        const d = n[0][n[0].length - 1];
        i.insertText(d, a + n[0].length - 1), i.replaceWith(u, l, s);
      } else
        n[0] && i.insert(a - 1, e.type.create(o)).delete(i.mapping.map(a), i.mapping.map(l));
      i.scrollIntoView();
    }
  });
}
function Mg(e) {
  return new cd({
    find: e.find,
    handler: ({ state: t, range: r, match: n }) => {
      const o = t.doc.resolve(r.from), i = Dt(e.getAttributes, void 0, n) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), e.type))
        return null;
      t.tr.delete(r.from, r.to).setBlockType(r.from, r.from, e.type, i);
    }
  });
}
function es(e) {
  return new cd({
    find: e.find,
    handler: ({ state: t, range: r, match: n, chain: o }) => {
      const i = Dt(e.getAttributes, void 0, n) || {}, a = t.tr.delete(r.from, r.to), s = a.doc.resolve(r.from).blockRange(), c = s && Jm(s, e.type, i);
      if (!c)
        return null;
      if (a.wrap(s, c), e.keepMarks && e.editor) {
        const { selection: d, storedMarks: f } = t, { splittableMarks: p } = e.editor.extensionManager, h = f || d.$to.parentOffset && d.$from.marks();
        if (h) {
          const g = h.filter((m) => p.includes(m.type.name));
          a.ensureMarks(g);
        }
      }
      if (e.keepAttributes) {
        const d = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(d, i).run();
      }
      const u = a.doc.resolve(r.from - 1).nodeBefore;
      u && u.type === e.type && Eo(a.doc, r.from - 1) && (!e.joinPredicate || e.joinPredicate(n, u)) && a.join(r.from - 1);
    }
  });
}
class Ur {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Dt(Wt(this, "addOptions", {
      name: this.name
    }))), this.storage = Dt(Wt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Ur(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = dd(this.options, t), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new Ur(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Dt(Wt(r, "addOptions", {
      name: r.name
    })), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  static handleExit({ editor: t, mark: r }) {
    const { tr: n } = t.state, o = t.state.selection.$from;
    if (o.pos === o.end()) {
      const a = o.marks();
      if (!!!a.find((c) => (c == null ? void 0 : c.type.name) === r.name))
        return !1;
      const s = a.find((c) => (c == null ? void 0 : c.type.name) === r.name);
      return s && n.removeStoredMark(s), n.insertText(" ", o.pos), t.view.dispatch(n), !0;
    }
    return !1;
  }
}
class Ot {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Dt(Wt(this, "addOptions", {
      name: this.name
    }))), this.storage = Dt(Wt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Ot(t);
  }
  configure(t = {}) {
    const r = this.extend();
    return r.options = dd(this.options, t), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  extend(t = {}) {
    const r = new Ot(t);
    return r.parent = this, this.child = r, r.name = t.name ? t.name : r.parent.name, t.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Dt(Wt(r, "addOptions", {
      name: r.name
    })), r.storage = Dt(Wt(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
}
function uQ() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
class cQ {
  constructor(t, r, n) {
    this.isDragging = !1, this.component = t, this.editor = r.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...n
    }, this.extension = r.extension, this.node = r.node, this.decorations = r.decorations, this.getPos = r.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(t) {
    var r, n, o, i, a, l, s;
    const { view: c } = this.editor, u = t.target, d = u.nodeType === 3 ? (r = u.parentElement) === null || r === void 0 ? void 0 : r.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((n = this.contentDOM) === null || n === void 0) && n.contains(u) || !d)
      return;
    let f = 0, p = 0;
    if (this.dom !== d) {
      const m = this.dom.getBoundingClientRect(), v = d.getBoundingClientRect(), M = (o = t.offsetX) !== null && o !== void 0 ? o : (i = t.nativeEvent) === null || i === void 0 ? void 0 : i.offsetX, x = (a = t.offsetY) !== null && a !== void 0 ? a : (l = t.nativeEvent) === null || l === void 0 ? void 0 : l.offsetY;
      f = v.x - m.x + M, p = v.y - m.y + x;
    }
    (s = t.dataTransfer) === null || s === void 0 || s.setDragImage(this.dom, f, p);
    const h = Pe.create(c.state.doc, this.getPos()), g = c.state.tr.setSelection(h);
    c.dispatch(g);
  }
  stopEvent(t) {
    var r;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: t });
    const n = t.target;
    if (!(this.dom.contains(n) && !(!((r = this.contentDOM) === null || r === void 0) && r.contains(n))))
      return !1;
    const i = t.type.startsWith("drag"), a = t.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(n.tagName) || n.isContentEditable) && !a && !i)
      return !0;
    const { isEditable: s } = this.editor, { isDragging: c } = this, u = !!this.node.type.spec.draggable, d = Pe.isSelectable(this.node), f = t.type === "copy", p = t.type === "paste", h = t.type === "cut", g = t.type === "mousedown";
    if (!u && d && i && t.preventDefault(), u && i && !c)
      return t.preventDefault(), !1;
    if (u && s && !c && g) {
      const m = n.closest("[data-drag-handle]");
      m && (this.dom === m || this.dom.contains(m)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(c || a || f || p || h || g && d);
  }
  ignoreMutation(t) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: t }) : this.node.isLeaf || this.node.isAtom ? !0 : t.type === "selection" || this.dom.contains(t.target) && t.type === "childList" && (fd() || uQ()) && this.editor.isFocused && [
      ...Array.from(t.addedNodes),
      ...Array.from(t.removedNodes)
    ].every((n) => n.isContentEditable) ? !1 : this.contentDOM === t.target && t.type === "attributes" ? !0 : !this.contentDOM.contains(t.target);
  }
  updateAttributes(t) {
    this.editor.commands.command(({ tr: r }) => {
      const n = this.getPos();
      return r.setNodeMarkup(n, void 0, {
        ...this.node.attrs,
        ...t
      }), !0;
    });
  }
  deleteNode() {
    const t = this.getPos(), r = t + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: t, to: r });
  }
}
function Ao(e) {
  return new EI({
    find: e.find,
    handler: ({ state: t, range: r, match: n, pasteEvent: o }) => {
      const i = Dt(e.getAttributes, void 0, n, o);
      if (i === !1 || i === null)
        return null;
      const { tr: a } = t, l = n[n.length - 1], s = n[0];
      let c = r.to;
      if (l) {
        const u = s.search(/\S/), d = r.from + s.indexOf(l), f = d + l.length;
        if (oc(r.from, r.to, t.doc).filter((h) => h.mark.type.excluded.find((m) => m === e.type && m !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        f < r.to && a.delete(f, r.to), d > r.from && a.delete(r.from + u, d), c = r.from + u + l.length, a.addMark(r.from + u, c, e.type.create(i || {})), a.removeStoredMark(e.type);
      }
    }
  });
}
function dQ(e) {
  return new EI({
    find: e.find,
    handler({ match: t, chain: r, range: n, pasteEvent: o }) {
      const i = Dt(e.getAttributes, void 0, t, o);
      if (i === !1 || i === null)
        return null;
      t.input && r().deleteRange(n).insertContentAt(n.from, {
        type: e.type.name,
        attrs: i
      });
    }
  });
}
const wu = Ot.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", lt(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
});
var fQ = function() {
  return Pn.Date.now();
};
const Mf = fQ;
var pQ = /\s/;
function hQ(e) {
  for (var t = e.length; t-- && pQ.test(e.charAt(t)); )
    ;
  return t;
}
var gQ = /^\s+/;
function mQ(e) {
  return e && e.slice(0, hQ(e) + 1).replace(gQ, "");
}
var UM = 0 / 0, vQ = /^[-+]0x[0-9a-f]+$/i, bQ = /^0b[01]+$/i, MQ = /^0o[0-7]+$/i, yQ = parseInt;
function HM(e) {
  if (typeof e == "number")
    return e;
  if (nd(e))
    return UM;
  if (ca(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ca(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = mQ(e);
  var r = bQ.test(e);
  return r || MQ.test(e) ? yQ(e.slice(2), r ? 2 : 8) : vQ.test(e) ? UM : +e;
}
var xQ = "Expected a function", wQ = Math.max, TQ = Math.min;
function NQ(e, t, r) {
  var n, o, i, a, l, s, c = 0, u = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(xQ);
  t = HM(t) || 0, ca(r) && (u = !!r.leading, d = "maxWait" in r, i = d ? wQ(HM(r.maxWait) || 0, t) : i, f = "trailing" in r ? !!r.trailing : f);
  function p(w) {
    var y = n, I = o;
    return n = o = void 0, c = w, a = e.apply(I, y), a;
  }
  function h(w) {
    return c = w, l = setTimeout(v, t), u ? p(w) : a;
  }
  function g(w) {
    var y = w - s, I = w - c, D = t - y;
    return d ? TQ(D, i - I) : D;
  }
  function m(w) {
    var y = w - s, I = w - c;
    return s === void 0 || y >= t || y < 0 || d && I >= i;
  }
  function v() {
    var w = Mf();
    if (m(w))
      return M(w);
    l = setTimeout(v, g(w));
  }
  function M(w) {
    return l = void 0, f && n ? p(w) : (n = o = void 0, a);
  }
  function x() {
    l !== void 0 && clearTimeout(l), c = 0, n = s = o = l = void 0;
  }
  function b() {
    return l === void 0 ? a : M(Mf());
  }
  function T() {
    var w = Mf(), y = m(w);
    if (n = arguments, o = this, s = w, y) {
      if (l === void 0)
        return h(s);
      if (d)
        return clearTimeout(l), l = setTimeout(v, t), p(s);
    }
    return l === void 0 && (l = setTimeout(v, t)), a;
  }
  return T.cancel = x, T.flush = b, T;
}
/*!
  * vue-color-kit v1.0.6
  * (c) 2023 
  * @license MIT
  */
function Fo(e) {
  let t = { r: 0, g: 0, b: 0, a: 1 };
  /#/.test(e) ? t = CQ(e) : /rgb/.test(e) ? t = YM(e) : typeof e == "string" ? t = YM(`rgba(${e})`) : Object.prototype.toString.call(e) === "[object Object]" && (t = e);
  const { r, g: n, b: o, a: i } = t, { h: a, s: l, v: s } = IQ(t);
  return { r, g: n, b: o, a: i === void 0 ? 1 : i, h: a, s: l, v: s };
}
function g0(e) {
  const t = document.createElement("canvas"), r = t.getContext("2d"), n = e * 2;
  return t.width = n, t.height = n, r.fillStyle = "#ffffff", r.fillRect(0, 0, n, n), r.fillStyle = "#ccd5db", r.fillRect(0, 0, e, e), r.fillRect(e, e, e, e), t;
}
function yg(e, t, r, n, o, i) {
  const a = e === "l", l = t.createLinearGradient(0, 0, a ? r : 0, a ? 0 : n);
  l.addColorStop(0.01, o), l.addColorStop(0.99, i), t.fillStyle = l, t.fillRect(0, 0, r, n);
}
function SQ({ r: e, g: t, b: r }, n) {
  const o = (a) => ("0" + Number(a).toString(16)).slice(-2), i = `#${o(e)}${o(t)}${o(r)}`;
  return n ? i.toUpperCase() : i;
}
function CQ(e) {
  e = e.slice(1);
  const t = (r) => parseInt(r, 16) || 0;
  return {
    r: t(e.slice(0, 2)),
    g: t(e.slice(2, 4)),
    b: t(e.slice(4, 6))
  };
}
function YM(e) {
  return typeof e == "string" ? (e = (/rgba?\((.*?)\)/.exec(e) || ["", "0,0,0,1"])[1].split(","), {
    r: Number(e[0]) || 0,
    g: Number(e[1]) || 0,
    b: Number(e[2]) || 0,
    a: Number(e[3] ? e[3] : 1)
  }) : e;
}
function IQ({ r: e, g: t, b: r }) {
  e = e / 255, t = t / 255, r = r / 255;
  const n = Math.max(e, t, r), o = Math.min(e, t, r), i = n - o;
  let a = 0;
  n === o ? a = 0 : n === e ? t >= r ? a = 60 * (t - r) / i : a = 60 * (t - r) / i + 360 : n === t ? a = 60 * (r - e) / i + 120 : n === r && (a = 60 * (e - t) / i + 240), a = Math.floor(a);
  let l = parseFloat((n === 0 ? 0 : 1 - o / n).toFixed(2)), s = parseFloat(n.toFixed(2));
  return { h: a, s: l, v: s };
}
var m0 = Z({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    hsv: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectSaturation"],
  data() {
    return {
      slideSaturationStyle: {}
    };
  },
  // Can’t monitor, otherwise the color will change when you change yourself
  // watch: {
  //     color() {
  //         this.renderColor()
  //     }
  // },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasSaturation, t = this.size, r = e.getContext("2d");
      e.width = t, e.height = t, r.fillStyle = this.color, r.fillRect(0, 0, t, t), yg("l", r, t, t, "#FFFFFF", "rgba(255,255,255,0)"), yg("p", r, t, t, "rgba(0,0,0,0)", "#000000");
    },
    renderSlide() {
      this.slideSaturationStyle = {
        left: this.hsv.s * this.size - 5 + "px",
        top: (1 - this.hsv.v) * this.size - 5 + "px"
      };
    },
    selectSaturation(e) {
      const { top: t, left: r } = this.$el.getBoundingClientRect(), n = e.target.getContext("2d"), o = (a) => {
        let l = a.clientX - r, s = a.clientY - t;
        l < 0 && (l = 0), s < 0 && (s = 0), l > this.size && (l = this.size), s > this.size && (s = this.size), this.slideSaturationStyle = {
          left: l - 5 + "px",
          top: s - 5 + "px"
        };
        const c = n.getImageData(Math.min(l, this.size - 1), Math.min(s, this.size - 1), 1, 1), [u, d, f] = c.data;
        this.$emit("selectSaturation", { r: u, g: d, b: f });
      };
      o(e);
      const i = () => {
        document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", i);
      };
      document.addEventListener("mousemove", o), document.addEventListener("mouseup", i);
    }
  }
});
const AQ = { ref: "canvasSaturation" };
function DQ(e, t, r, n, o, i) {
  return _(), se(
    "div",
    {
      class: "saturation",
      onMousedown: t[1] || (t[1] = em((...a) => e.selectSaturation && e.selectSaturation(...a), ["prevent", "stop"]))
    },
    [
      B(
        "canvas",
        AQ,
        null,
        512
        /* NEED_PATCH */
      ),
      B(
        "div",
        {
          style: e.slideSaturationStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
m0.render = DQ;
m0.__file = "src/color/Saturation.vue";
var v0 = Z({
  props: {
    hsv: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectHue"],
  data() {
    return {
      slideHueStyle: {}
    };
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasHue, t = this.width, r = this.height, n = e.getContext("2d");
      e.width = t, e.height = r;
      const o = n.createLinearGradient(0, 0, 0, r);
      o.addColorStop(0, "#FF0000"), o.addColorStop(0.17 * 1, "#FF00FF"), o.addColorStop(0.17 * 2, "#0000FF"), o.addColorStop(0.17 * 3, "#00FFFF"), o.addColorStop(0.17 * 4, "#00FF00"), o.addColorStop(0.17 * 5, "#FFFF00"), o.addColorStop(1, "#FF0000"), n.fillStyle = o, n.fillRect(0, 0, t, r);
    },
    renderSlide() {
      this.slideHueStyle = {
        top: (1 - this.hsv.h / 360) * this.height - 2 + "px"
      };
    },
    selectHue(e) {
      const { top: t } = this.$el.getBoundingClientRect(), r = e.target.getContext("2d"), n = (i) => {
        let a = i.clientY - t;
        a < 0 && (a = 0), a > this.height && (a = this.height), this.slideHueStyle = {
          top: a - 2 + "px"
        };
        const l = r.getImageData(0, Math.min(a, this.height - 1), 1, 1), [s, c, u] = l.data;
        this.$emit("selectHue", { r: s, g: c, b: u });
      };
      n(e);
      const o = () => {
        document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", o);
      };
      document.addEventListener("mousemove", n), document.addEventListener("mouseup", o);
    }
  }
});
const kQ = { ref: "canvasHue" };
function EQ(e, t, r, n, o, i) {
  return _(), se(
    "div",
    {
      class: "hue",
      onMousedown: t[1] || (t[1] = em((...a) => e.selectHue && e.selectHue(...a), ["prevent", "stop"]))
    },
    [
      B(
        "canvas",
        kQ,
        null,
        512
        /* NEED_PATCH */
      ),
      B(
        "div",
        {
          style: e.slideHueStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
v0.render = EQ;
v0.__file = "src/color/Hue.vue";
var b0 = Z({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    rgba: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectAlpha"],
  data() {
    return {
      slideAlphaStyle: {},
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    },
    "rgba.a"() {
      this.renderSlide();
    }
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasAlpha, t = this.width, r = this.height, n = this.alphaSize, o = g0(n), i = e.getContext("2d");
      e.width = t, e.height = r, i.fillStyle = i.createPattern(o, "repeat"), i.fillRect(0, 0, t, r), yg("p", i, t, r, "rgba(255,255,255,0)", this.color);
    },
    renderSlide() {
      this.slideAlphaStyle = {
        top: this.rgba.a * this.height - 2 + "px"
      };
    },
    selectAlpha(e) {
      const { top: t } = this.$el.getBoundingClientRect(), r = (o) => {
        let i = o.clientY - t;
        i < 0 && (i = 0), i > this.height && (i = this.height);
        let a = parseFloat((i / this.height).toFixed(2));
        this.$emit("selectAlpha", a);
      };
      r(e);
      const n = () => {
        document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", n);
      };
      document.addEventListener("mousemove", r), document.addEventListener("mouseup", n);
    }
  }
});
const LQ = { ref: "canvasAlpha" };
function $Q(e, t, r, n, o, i) {
  return _(), se(
    "div",
    {
      class: "color-alpha",
      onMousedown: t[1] || (t[1] = em((...a) => e.selectAlpha && e.selectAlpha(...a), ["prevent", "stop"]))
    },
    [
      B(
        "canvas",
        LQ,
        null,
        512
        /* NEED_PATCH */
      ),
      B(
        "div",
        {
          style: e.slideAlphaStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
b0.render = $Q;
b0.__file = "src/color/Alpha.vue";
var M0 = Z({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    }
  },
  mounted() {
    this.renderColor();
  },
  methods: {
    renderColor() {
      const e = this.$el, t = this.width, r = this.height, n = this.alphaSize, o = g0(n), i = e.getContext("2d");
      e.width = t, e.height = r, i.fillStyle = i.createPattern(o, "repeat"), i.fillRect(0, 0, t, r), i.fillStyle = this.color, i.fillRect(0, 0, t, r);
    }
  }
});
function zQ(e, t, r, n, o, i) {
  return _(), se("canvas");
}
M0.render = zQ;
M0.__file = "src/color/Preview.vue";
var y0 = Z({
  props: {
    suckerCanvas: {
      type: Object,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenSucker: !1,
      suckerPreview: null,
      isSucking: !1
    };
  },
  watch: {
    suckerCanvas(e) {
      this.isSucking = !1, this.suckColor(e);
    }
  },
  methods: {
    openSucker() {
      this.isOpenSucker ? this.keydownHandler({ keyCode: 27 }) : (this.isOpenSucker = !0, this.isSucking = !0, this.$emit("openSucker", !0), document.addEventListener("keydown", this.keydownHandler));
    },
    keydownHandler(e) {
      e.keyCode === 27 && (this.isOpenSucker = !1, this.isSucking = !1, this.$emit("openSucker", !1), document.removeEventListener("keydown", this.keydownHandler), document.removeEventListener("mousemove", this.mousemoveHandler), document.removeEventListener("mouseup", this.mousemoveHandler), this.suckerPreview && (document.body.removeChild(this.suckerPreview), this.suckerPreview = null));
    },
    mousemoveHandler(e) {
      const { clientX: t, clientY: r } = e, { top: n, left: o, width: i, height: a } = this.suckerCanvas.getBoundingClientRect(), l = t - o, s = r - n, u = this.suckerCanvas.getContext("2d").getImageData(Math.min(l, i - 1), Math.min(s, a - 1), 1, 1);
      let [d, f, p, h] = u.data;
      h = parseFloat((h / 255).toFixed(2));
      const g = this.suckerPreview.style;
      Object.assign(g, {
        position: "absolute",
        left: t + 20 + "px",
        top: r - 36 + "px",
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        border: "2px solid #fff",
        boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
        background: `rgba(${d}, ${f}, ${p}, ${h})`,
        zIndex: 95
      }), this.suckerArea.length && // @ts-ignore
      t >= this.suckerArea[0] && // @ts-ignore
      r >= this.suckerArea[1] && // @ts-ignore
      t <= this.suckerArea[2] && // @ts-ignore
      r <= this.suckerArea[3] ? g.display = "" : g.display = "none";
    },
    suckColor(e) {
      e && e.tagName !== "CANVAS" || (this.suckerPreview = document.createElement("div"), this.suckerPreview && document.body.appendChild(this.suckerPreview), document.addEventListener("mousemove", this.mousemoveHandler), document.addEventListener("mouseup", this.mousemoveHandler), e.addEventListener("click", (t) => {
        const { clientX: r, clientY: n } = t, { top: o, left: i, width: a, height: l } = e.getBoundingClientRect(), s = r - i, c = n - o, d = e.getContext("2d").getImageData(Math.min(s, a - 1), Math.min(c, l - 1), 1, 1);
        let [f, p, h, g] = d.data;
        g = parseFloat((g / 255).toFixed(2)), this.$emit("selectSucker", { r: f, g: p, b: h, a: g });
      }));
    }
  }
});
const OQ = /* @__PURE__ */ B(
  "path",
  { d: "M13.1,8.2l5.6,5.6c0.4,0.4,0.5,1.1,0.1,1.5s-1.1,0.5-1.5,0.1c0,0-0.1,0-0.1-0.1l-1.4-1.4l-7.7,7.7C7.9,21.9,7.6,22,7.3,22H3.1C2.5,22,2,21.5,2,20.9l0,0v-4.2c0-0.3,0.1-0.6,0.3-0.8l5.8-5.8C8.5,9.7,9.2,9.6,9.7,10s0.5,1.1,0.1,1.5c0,0,0,0.1-0.1,0.1l-5.5,5.5v2.7h2.7l7.4-7.4L8.7,6.8c-0.5-0.4-0.5-1-0.1-1.5s1.1-0.5,1.5-0.1c0,0,0.1,0,0.1,0.1l1.4,1.4l3.5-3.5c1.6-1.6,4.1-1.6,5.8-0.1c1.6,1.6,1.6,4.1,0.1,5.8L20.9,9l-3.6,3.6c-0.4,0.4-1.1,0.5-1.5,0.1" },
  null,
  -1
  /* HOISTED */
), jQ = {
  key: 1,
  class: "sucker",
  viewBox: "-16 -16 68 68",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#9099a4"
}, RQ = /* @__PURE__ */ B(
  "g",
  {
    fill: "none",
    "fill-rule": "evenodd"
  },
  [
    /* @__PURE__ */ B("g", {
      transform: "translate(1 1)",
      "stroke-width": "4"
    }, [
      /* @__PURE__ */ B("circle", {
        "stroke-opacity": ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }),
      /* @__PURE__ */ B("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
        /* @__PURE__ */ B("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      ])
    ])
  ],
  -1
  /* HOISTED */
);
function _Q(e, t, r, n, o, i) {
  return _(), se("div", null, [
    e.isSucking ? Oe("v-if", !0) : (_(), se(
      "svg",
      {
        key: 0,
        class: [{ active: e.isOpenSucker }, "sucker"],
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-12 -12 48 48",
        onClick: t[1] || (t[1] = (...a) => e.openSucker && e.openSucker(...a))
      },
      [
        OQ
      ],
      2
      /* CLASS */
    )),
    e.isSucking ? (_(), se("svg", jQ, [
      RQ
    ])) : Oe("v-if", !0)
  ]);
}
y0.render = _Q;
y0.__file = "src/color/Sucker.vue";
var x0 = Z({
  props: {
    name: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  emits: ["inputColor", "inputFocus", "inputBlur"],
  setup(e, { emit: t }) {
    return {
      modelColor: W({
        get() {
          return e.color || "";
        },
        set(i) {
          t("inputColor", i);
        }
      }),
      handleFocus: (i) => {
        t("inputFocus", i);
      },
      handleBlur: (i) => {
        t("inputBlur", i);
      }
    };
  }
});
const PQ = { class: "color-type" }, BQ = { class: "name" };
function FQ(e, t, r, n, o, i) {
  return _(), se("div", PQ, [
    B(
      "span",
      BQ,
      kt(e.name),
      1
      /* TEXT */
    ),
    on(B(
      "input",
      {
        "onUpdate:modelValue": t[1] || (t[1] = (a) => e.modelColor = a),
        class: "value",
        onFocus: t[2] || (t[2] = (...a) => e.handleFocus && e.handleFocus(...a)),
        onBlur: t[3] || (t[3] = (...a) => e.handleBlur && e.handleBlur(...a))
      },
      null,
      544
      /* HYDRATE_EVENTS, NEED_PATCH */
    ), [
      [b4, e.modelColor]
    ])
  ]);
}
x0.render = FQ;
x0.__file = "src/color/Box.vue";
var w0 = Z({
  name: "ColorPicker",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    colorsDefault: {
      type: Array,
      default: () => []
    },
    colorsHistoryKey: {
      type: String,
      default: ""
    }
  },
  emits: ["selectColor"],
  setup(e, { emit: t }) {
    const r = L(), n = L([]), o = L();
    e.colorsHistoryKey && localStorage && (n.value = JSON.parse(localStorage.getItem(e.colorsHistoryKey)) || []), o.value = g0(4).toDataURL(), v4(() => {
      i(r.value);
    });
    function i(l) {
      if (!l)
        return;
      const s = n.value || [], c = s.indexOf(l);
      c >= 0 && s.splice(c, 1), s.length >= 8 && (s.length = 7), s.unshift(l), n.value = s || [], localStorage && e.colorsHistoryKey && localStorage.setItem(e.colorsHistoryKey, JSON.stringify(s));
    }
    function a(l) {
      t("selectColor", l);
    }
    return {
      setColorsHistory: i,
      colorsHistory: n,
      color: r,
      imgAlphaBase64: o,
      selectColor: a
    };
  }
});
const UQ = { class: "colors" }, HQ = {
  key: 0,
  class: "colors history"
};
function YQ(e, t, r, n, o, i) {
  return _(), se("div", null, [
    B("ul", UQ, [
      (_(!0), se(
        qt,
        null,
        jl(e.colorsDefault, (a) => (_(), se("li", {
          key: a,
          class: "item",
          onClick: (l) => e.selectColor(a)
        }, [
          B(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          B(
            "div",
            {
              style: { background: a },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    e.colorsHistory.length ? (_(), se("ul", HQ, [
      (_(!0), se(
        qt,
        null,
        jl(e.colorsHistory, (a) => (_(), se("li", {
          key: a,
          class: "item",
          onClick: (l) => e.selectColor(a)
        }, [
          B(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          B(
            "div",
            {
              style: { background: a },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : Oe("v-if", !0)
  ]);
}
w0.render = YQ;
w0.__file = "src/color/Colors.vue";
var oa = Z({
  components: {
    Saturation: m0,
    Hue: v0,
    Alpha: b0,
    Preview: M0,
    Sucker: y0,
    Box: x0,
    Colors: w0
  },
  emits: ["changeColor", "openSucker", "inputFocus", "inputBlur"],
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    theme: {
      type: String,
      default: "dark"
    },
    suckerHide: {
      type: Boolean,
      default: !0
    },
    suckerCanvas: {
      type: null,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    },
    colorsDefault: {
      type: Array,
      default: () => [
        "#000000",
        "#FFFFFF",
        "#FF1900",
        "#F47365",
        "#FFB243",
        "#FFE623",
        "#6EFF2A",
        "#1BC7B1",
        "#00BEFF",
        "#2E81FF",
        "#5D61FF",
        "#FF89CF",
        "#FC3CAD",
        "#BF3DCE",
        "#8E00A7",
        "rgba(0,0,0,0)"
      ]
    },
    colorsHistoryKey: {
      type: String,
      default: "vue-colorpicker-history"
    }
  },
  data() {
    return {
      hueWidth: 15,
      hueHeight: 152,
      previewHeight: 30,
      modelRgba: "",
      modelHex: "",
      r: 0,
      g: 0,
      b: 0,
      a: 1,
      h: 0,
      s: 0,
      v: 0
    };
  },
  computed: {
    isLightTheme() {
      return this.theme === "light";
    },
    totalWidth() {
      return this.hueHeight + (this.hueWidth + 8) * 2;
    },
    previewWidth() {
      return this.totalWidth - (this.suckerHide ? 0 : this.previewHeight);
    },
    rgba() {
      return {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a
      };
    },
    hsv() {
      return {
        h: this.h,
        s: this.s,
        v: this.v
      };
    },
    rgbString() {
      return `rgb(${this.r}, ${this.g}, ${this.b})`;
    },
    rgbaStringShort() {
      return `${this.r}, ${this.g}, ${this.b}, ${this.a}`;
    },
    rgbaString() {
      return `rgba(${this.rgbaStringShort})`;
    },
    hexString() {
      return SQ(this.rgba, !0);
    }
  },
  created() {
    Object.assign(this, Fo(this.color)), this.setText(), this.$watch("rgba", () => {
      this.$emit("changeColor", {
        rgba: this.rgba,
        hsv: this.hsv,
        hex: this.modelHex
      });
    });
  },
  methods: {
    selectSaturation(e) {
      const { r: t, g: r, b: n, h: o, s: i, v: a } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, h: o, s: i, v: a }), this.setText();
    },
    handleFocus(e) {
      this.$emit("inputFocus", e);
    },
    handleBlur(e) {
      this.$emit("inputBlur", e);
    },
    selectHue(e) {
      const { r: t, g: r, b: n, h: o, s: i, v: a } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, h: o, s: i, v: a }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide();
      });
    },
    selectAlpha(e) {
      this.a = e, this.setText();
    },
    inputHex(e) {
      const { r: t, g: r, b: n, a: o, h: i, s: a, v: l } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, a: o, h: i, s: a, v: l }), this.modelHex = e, this.modelRgba = this.rgbaStringShort, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    inputRgba(e) {
      const { r: t, g: r, b: n, a: o, h: i, s: a, v: l } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, a: o, h: i, s: a, v: l }), this.modelHex = this.hexString, this.modelRgba = e, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    setText() {
      this.modelHex = this.hexString, this.modelRgba = this.rgbaStringShort;
    },
    openSucker(e) {
      this.$emit("openSucker", e);
    },
    selectSucker(e) {
      const { r: t, g: r, b: n, a: o, h: i, s: a, v: l } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, a: o, h: i, s: a, v: l }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    selectColor(e) {
      const { r: t, g: r, b: n, a: o, h: i, s: a, v: l } = Fo(e);
      Object.assign(this, { r: t, g: r, b: n, a: o, h: i, s: a, v: l }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    }
  }
});
const WQ = { class: "color-set" };
function QQ(e, t, r, n, o, i) {
  const a = Po("Saturation"), l = Po("Hue"), s = Po("Alpha"), c = Po("Preview"), u = Po("Sucker"), d = Po("Box"), f = Po("Colors");
  return _(), se(
    "div",
    {
      class: ["hu-color-picker", { light: e.isLightTheme }],
      style: { width: e.totalWidth + "px" }
    },
    [
      B("div", WQ, [
        B(a, {
          ref: "saturation",
          color: e.rgbString,
          hsv: e.hsv,
          size: e.hueHeight,
          onSelectSaturation: e.selectSaturation
        }, null, 8, ["color", "hsv", "size", "onSelectSaturation"]),
        B(l, {
          ref: "hue",
          hsv: e.hsv,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectHue: e.selectHue
        }, null, 8, ["hsv", "width", "height", "onSelectHue"]),
        B(s, {
          ref: "alpha",
          color: e.rgbString,
          rgba: e.rgba,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectAlpha: e.selectAlpha
        }, null, 8, ["color", "rgba", "width", "height", "onSelectAlpha"])
      ]),
      B(
        "div",
        {
          style: { height: e.previewHeight + "px" },
          class: "color-show"
        },
        [
          B(c, {
            color: e.rgbaString,
            width: e.previewWidth,
            height: e.previewHeight
          }, null, 8, ["color", "width", "height"]),
          e.suckerHide ? Oe("v-if", !0) : (_(), se(u, {
            key: 0,
            "sucker-canvas": e.suckerCanvas,
            "sucker-area": e.suckerArea,
            onOpenSucker: e.openSucker,
            onSelectSucker: e.selectSucker
          }, null, 8, ["sucker-canvas", "sucker-area", "onOpenSucker", "onSelectSucker"]))
        ],
        4
        /* STYLE */
      ),
      B(d, {
        name: "HEX",
        color: e.modelHex,
        onInputColor: e.inputHex,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      B(d, {
        name: "RGBA",
        color: e.modelRgba,
        onInputColor: e.inputRgba,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      B(f, {
        color: e.rgbaString,
        "colors-default": e.colorsDefault,
        "colors-history-key": e.colorsHistoryKey,
        onSelectColor: e.selectColor
      }, null, 8, ["color", "colors-default", "colors-history-key", "onSelectColor"]),
      Oe(" custom options "),
      Re(e.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
oa.render = QQ;
oa.__file = "src/color/ColorPicker.vue";
oa.install = (e) => {
  e.component(oa.name, oa);
};
const VQ = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xNy41IDE5TDEyLjUgNEgxMS41TDYuNSAxOU03LjgzMzMzIDE1SDE2LjE2NjciIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg==", ZQ = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PgoNPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgR2VuZXJhdG9yOiBTVkcgUmVwbyBNaXhlciBUb29scyAtLT4KPHN2ZyBmaWxsPSIjMDAwMDAwIiB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoNPGcgaWQ9IkhpZ2hsaWdodGVyX3BlbiI+Cg08cGF0aCBkPSJNNDUxLjQ2OTIsMTI1LjQwNDEsMzgwLjU2NTYsNTQuNTAxNmExMy4xMDkzLDEzLjEwOTMsMCwwLDAtMTcuNzQ1Ny0uNzMyN0wxNjQuOTk4NSwyMjEuMzcyMiwyODQuNjAxOCwzNDAuOTc0NGwxNjcuNi0xOTcuODIyNUExMy4xMSwxMy4xMSwwLDAsMCw0NTEuNDY5MiwxMjUuNDA0MVoiLz4KDTxyZWN0IGhlaWdodD0iMTcyLjc2MDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjYuMDQxNiAyMjcuNjE0OCkgcm90YXRlKC00NSkiIHdpZHRoPSI0MS4wMTQzIiB4PSIxNzEuMjI3NCIgeT0iMjI3Ljg1NjkiLz4KDTxwYXRoIGQ9Ik05NC41NTIxLDM2My43MzA2LDE0Mi4yNDEzLDQxMS40MmMxOC41MjMyLTExLjAwOCw0MC42NS0xNS41OCw2My4xNjE5LTE3LjM5MTFsLTkzLjQ2LTkzLjQ2QzExMC4xMzE2LDMyMy4wOCwxMDUuNTYsMzQ1LjIwNzMsOTQuNTUyMSwzNjMuNzMwNloiLz4KDTxwYXRoIGQ9Ik01OC42MTQzLDQwMy42Mjc5YTYuNTc0Myw2LjU3NDMsMCwwLDAtMS4yNzMyLDcuNTAxM2wyMi4zNzQ4LDQ2LjQ4NjZhNi41NzQ2LDYuNTc0NiwwLDAsMCwxMC41NzIzLDEuNzk2NWwzMS40MTExLTMxLjQxMTFMNzcuOTcwNiwzODQuMjcyNloiLz4KDTwvZz4KDTwvc3ZnPg==", GQ = { class: "ghl-color-picker__container" }, KQ = {
  key: 1,
  class: "ghl-color-picker__trigger"
}, qQ = ["src"], JQ = {
  name: "RTEControlColorPicker",
  inheritAttrs: !1,
  components: { ToolbarButton: Je }
}, bl = /* @__PURE__ */ Z({
  ...JQ,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    swatches: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    colorFor: {
      type: String,
      default: "text"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    pickerPosition: {
      type: String,
      default: "bottom"
    },
    language: {
      type: String,
      default: pt.English_US
    },
    type: {
      type: String,
      default: "rgba"
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = L(), i = L(), a = L(), l = L(!1), s = wr(), c = (g) => {
      var M, x, b, T, w, y;
      const m = ["hex", "rgba"].includes(t.type) ? t.type : "rgba", v = t.type === "hex" ? g[m] : r7(g[m]);
      switch (t.colorFor) {
        case "highlight":
          return l.value ? (M = t == null ? void 0 : t.editor) == null ? void 0 : M.chain().setHighlight({ color: v }).run() : (x = t == null ? void 0 : t.editor) == null ? void 0 : x.chain().focus().setHighlight({ color: v }).run();
        case "text":
        default: {
          const { from: I, to: D } = t.editor.state.selection, O = t.editor.state.doc.textBetween(I, D), $ = t.editor.state.selection.$from.node(
            t.editor.state.selection.$from.depth
          ).textContent;
          return t.editor.isActive(wu.name) && ($ === O || O.length > $.length) ? l.value ? (b = t == null ? void 0 : t.editor) == null ? void 0 : b.chain().setColor(v).updateAttributes(wu.name, {
            listColor: v
          }).run() : (T = t == null ? void 0 : t.editor) == null ? void 0 : T.chain().focus().setColor(v).updateAttributes(wu.name, { listColor: v }).run() : l.value ? (w = t == null ? void 0 : t.editor) == null ? void 0 : w.chain().setColor(v).run() : (y = t == null ? void 0 : t.editor) == null ? void 0 : y.chain().focus().setColor(v).run();
        }
      }
    }, u = ({
      editor: g
    }) => {
      const m = g.getAttributes(
        "textStyle"
      ), v = g.getAttributes(
        "highlight"
      );
      o.value = void 0, i.value = void 0, m && (o.value = m == null ? void 0 : m.color), v && (i.value = v == null ? void 0 : v.color), t.colorFor === "highlight" ? a.value = v == null ? void 0 : v.color : a.value = m == null ? void 0 : m.color;
    }, d = () => {
      t.editor && (t.colorFor === "text" ? n.value = !Ht({
        editor: t.editor,
        name: "Text Color",
        deps: ["color"]
      }) : n.value = !Ht({
        editor: t.editor,
        name: "Text Highlight",
        deps: ["highlight"]
      }));
    };
    et(() => {
      var g;
      d(), (g = t == null ? void 0 : t.editor) == null || g.on("transaction", u);
    }), wa(() => {
      var g;
      (g = t == null ? void 0 : t.editor) == null || g.off("transaction", u);
    }), Zt(() => {
      var g;
      d(), (g = t == null ? void 0 : t.editor) == null || g.on("transaction", u);
    }), vt(() => {
      var g;
      (g = t == null ? void 0 : t.editor) == null || g.off("transaction", u);
    });
    const f = () => {
      l.value = !0;
    }, p = () => {
      l.value = !1;
    };
    at(
      () => l.value,
      NQ(() => {
        var g, m;
        !l.value && !((g = t == null ? void 0 : t.editor) != null && g.isFocused) && ((m = t.editor) == null || m.chain().focus().run());
      }, 200)
    );
    const h = W(() => t.tooltipLabel ? t.tooltipLabel : t.colorFor === "highlight" ? r.color.textHighlight : r.color.textColor);
    return (g, m) => (_(), be("div", GQ, [
      B(N(jP), {
        raw: "",
        trigger: "click",
        placement: e.pickerPosition
      }, {
        trigger: Q(() => [
          de("div", null, [
            B(Je, {
              id: N(Ue).toolbarButtonColorPicker,
              "tooltip-label": h.value,
              tooltipPosition: e.tooltipPosition,
              disabled: e.disabled ?? n.value
            }, {
              default: Q(() => [
                N(s).trigger ? Re(g.$slots, "trigger", {
                  key: 0,
                  color: a.value,
                  disabled: n.value
                }) : (_(), be("div", KQ, [
                  de("img", {
                    src: t.colorFor === "highlight" ? N(ZQ) : N(VQ),
                    class: "toolbar-button__icon"
                  }, null, 8, qQ),
                  de("span", {
                    style: Fc({ "border-color": a.value || "#000" })
                  }, null, 4)
                ]))
              ]),
              _: 3
            }, 8, ["id", "tooltip-label", "tooltipPosition", "disabled"])
          ])
        ]),
        default: Q(() => [
          B(N(oa), {
            theme: "light",
            color: a.value,
            colorsDefault: e.swatches,
            "sucker-hide": !0,
            onChangeColor: c,
            onInputFocus: f,
            onInputBlur: p
          }, null, 8, ["color", "colorsDefault"])
        ]),
        _: 3
      }, 8, ["placement"])
    ]));
  }
});
bl.install = (e) => {
  e.component(bl.name, bl);
};
const XQ = {
  name: "RTEControlCustomSelect",
  inheritAttrs: !1,
  components: {}
}, eV = /* @__PURE__ */ Z({
  ...XQ,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: String,
      default: "click"
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: "body"
    }
  },
  setup(e) {
    const t = wr(), r = e, n = (i) => {
      var a;
      i && ((a = r == null ? void 0 : r.editor) == null || a.chain().focus().insertContent(i).run());
    }, o = [
      {
        label: "No options available",
        value: "",
        disabled: !0
      }
    ];
    return (i, a) => (_(!0), be(qt, null, jl(e.customMenus, (l) => (_(), se(N(Sw), {
      key: l.menuId,
      id: l.menuId,
      options: l.items.length ? l.items : o,
      onOnSelect: n,
      to: e.to,
      size: "small"
    }, {
      trigger: Q(() => [
        N(t).trigger ? Re(i.$slots, "trigger", {
          key: 0,
          title: l.menuTitle,
          icon: l.icon
        }, void 0, !0) : (_(), se(N(Lr), {
          key: 1,
          id: l.menuId,
          size: "small",
          class: "custom-menu__button mx-1"
        }, {
          default: Q(() => [
            de("span", null, kt(l.menuTitle), 1)
          ]),
          _: 2
        }, 1032, ["id"]))
      ]),
      _: 2
    }, 1032, ["id", "options", "to"]))), 128));
  }
});
const Tu = /* @__PURE__ */ Yr(eV, [["__scopeId", "data-v-9c1ea8e8"]]);
Tu.install = (e) => {
  e.component(Tu.name, Tu);
};
function OI(e) {
  if (!e)
    throw new Error("Editor is not available!");
  const t = L(void 0), r = (a, l) => {
    if (!l.src)
      return !1;
    e == null || e.chain().focus().setImage({
      ...l,
      title: l.alt,
      "data-image-link": LC(l["data-image-link"])
    }).run(), a === "CREATE" && (e == null || e.chain().focus().createParagraphNear().run());
  }, n = (a, l) => {
    o(a === "WRAP" ? { "data-wrap": l, "data-alignment": void 0 } : { "data-alignment": l, "data-wrap": void 0 });
  }, o = (a) => {
    if (!t.value)
      return !1;
    e == null || e.chain().focus().setImage({
      ...t.value,
      ...a
    }).run();
  }, i = () => {
    e == null || e.commands.deleteSelection();
  };
  return e == null || e.on("transaction", ({ editor: a }) => {
    const l = a.getAttributes("image"), s = a.getAttributes(
      "paragraph"
    );
    t.value = void 0, !Mr(l) && Mr(s) && (t.value = {
      ...l
    });
  }), {
    imageValues: t,
    onImageAdd: r,
    handleImagePosition: n,
    onRemove: i
  };
}
var kr = "top", ln = "bottom", sn = "right", Er = "left", T0 = "auto", Is = [kr, ln, sn, Er], ga = "start", ts = "end", tV = "clippingParents", jI = "viewport", Ja = "popper", rV = "reference", WM = /* @__PURE__ */ Is.reduce(function(e, t) {
  return e.concat([t + "-" + ga, t + "-" + ts]);
}, []), RI = /* @__PURE__ */ [].concat(Is, [T0]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ga, t + "-" + ts]);
}, []), nV = "beforeRead", oV = "read", iV = "afterRead", aV = "beforeMain", lV = "main", sV = "afterMain", uV = "beforeWrite", cV = "write", dV = "afterWrite", fV = [nV, oV, iV, aV, lV, sV, uV, cV, dV];
function _n(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Hr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function mi(e) {
  var t = Hr(e).Element;
  return e instanceof t || e instanceof Element;
}
function nn(e) {
  var t = Hr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function N0(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Hr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function pV(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, i = t.elements[r];
    !nn(i) || !_n(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function hV(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], i = t.attributes[n] || {}, a = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = a.reduce(function(s, c) {
        return s[c] = "", s;
      }, {});
      !nn(o) || !_n(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const _I = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: pV,
  effect: hV,
  requires: ["computeStyles"]
};
function $n(e) {
  return e.split("-")[0];
}
var ai = Math.max, ic = Math.min, ma = Math.round;
function xg() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function PI() {
  return !/^((?!chrome|android).)*safari/i.test(xg());
}
function va(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, i = 1;
  t && nn(e) && (o = e.offsetWidth > 0 && ma(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && ma(n.height) / e.offsetHeight || 1);
  var a = mi(e) ? Hr(e) : window, l = a.visualViewport, s = !PI() && r, c = (n.left + (s && l ? l.offsetLeft : 0)) / o, u = (n.top + (s && l ? l.offsetTop : 0)) / i, d = n.width / o, f = n.height / i;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function S0(e) {
  var t = va(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function BI(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && N0(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function eo(e) {
  return Hr(e).getComputedStyle(e);
}
function gV(e) {
  return ["table", "td", "th"].indexOf(_n(e)) >= 0;
}
function zo(e) {
  return ((mi(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function pd(e) {
  return _n(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (N0(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zo(e)
  );
}
function QM(e) {
  return !nn(e) || // https://github.com/popperjs/popper-core/issues/837
  eo(e).position === "fixed" ? null : e.offsetParent;
}
function mV(e) {
  var t = /firefox/i.test(xg()), r = /Trident/i.test(xg());
  if (r && nn(e)) {
    var n = eo(e);
    if (n.position === "fixed")
      return null;
  }
  var o = pd(e);
  for (N0(o) && (o = o.host); nn(o) && ["html", "body"].indexOf(_n(o)) < 0; ) {
    var i = eo(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function As(e) {
  for (var t = Hr(e), r = QM(e); r && gV(r) && eo(r).position === "static"; )
    r = QM(r);
  return r && (_n(r) === "html" || _n(r) === "body" && eo(r).position === "static") ? t : r || mV(e) || t;
}
function C0(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ml(e, t, r) {
  return ai(e, ic(t, r));
}
function vV(e, t, r) {
  var n = Ml(e, t, r);
  return n > r ? r : n;
}
function FI() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function UI(e) {
  return Object.assign({}, FI(), e);
}
function HI(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var bV = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, UI(typeof t != "number" ? t : HI(t, Is));
};
function MV(e) {
  var t, r = e.state, n = e.name, o = e.options, i = r.elements.arrow, a = r.modifiersData.popperOffsets, l = $n(r.placement), s = C0(l), c = [Er, sn].indexOf(l) >= 0, u = c ? "height" : "width";
  if (!(!i || !a)) {
    var d = bV(o.padding, r), f = S0(i), p = s === "y" ? kr : Er, h = s === "y" ? ln : sn, g = r.rects.reference[u] + r.rects.reference[s] - a[s] - r.rects.popper[u], m = a[s] - r.rects.reference[s], v = As(i), M = v ? s === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, x = g / 2 - m / 2, b = d[p], T = M - f[u] - d[h], w = M / 2 - f[u] / 2 + x, y = Ml(b, w, T), I = s;
    r.modifiersData[n] = (t = {}, t[I] = y, t.centerOffset = y - w, t);
  }
}
function yV(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || BI(t.elements.popper, o) && (t.elements.arrow = o));
}
const xV = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: MV,
  effect: yV,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ba(e) {
  return e.split("-")[1];
}
var wV = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function TV(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: ma(r * o) / o || 0,
    y: ma(n * o) / o || 0
  };
}
function VM(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, s = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = a.x, p = f === void 0 ? 0 : f, h = a.y, g = h === void 0 ? 0 : h, m = typeof u == "function" ? u({
    x: p,
    y: g
  }) : {
    x: p,
    y: g
  };
  p = m.x, g = m.y;
  var v = a.hasOwnProperty("x"), M = a.hasOwnProperty("y"), x = Er, b = kr, T = window;
  if (c) {
    var w = As(r), y = "clientHeight", I = "clientWidth";
    if (w === Hr(r) && (w = zo(r), eo(w).position !== "static" && l === "absolute" && (y = "scrollHeight", I = "scrollWidth")), w = w, o === kr || (o === Er || o === sn) && i === ts) {
      b = ln;
      var D = d && w === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[y]
      );
      g -= D - n.height, g *= s ? 1 : -1;
    }
    if (o === Er || (o === kr || o === ln) && i === ts) {
      x = sn;
      var O = d && w === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[I]
      );
      p -= O - n.width, p *= s ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: l
  }, c && wV), z = u === !0 ? TV({
    x: p,
    y: g
  }, Hr(r)) : {
    x: p,
    y: g
  };
  if (p = z.x, g = z.y, s) {
    var Y;
    return Object.assign({}, $, (Y = {}, Y[b] = M ? "0" : "", Y[x] = v ? "0" : "", Y.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + g + "px)" : "translate3d(" + p + "px, " + g + "px, 0)", Y));
  }
  return Object.assign({}, $, (t = {}, t[b] = M ? g + "px" : "", t[x] = v ? p + "px" : "", t.transform = "", t));
}
function NV(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, i = r.adaptive, a = i === void 0 ? !0 : i, l = r.roundOffsets, s = l === void 0 ? !0 : l, c = {
    placement: $n(t.placement),
    variation: ba(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, VM(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, VM(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const SV = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: NV,
  data: {}
};
var tu = {
  passive: !0
};
function CV(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, i = o === void 0 ? !0 : o, a = n.resize, l = a === void 0 ? !0 : a, s = Hr(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", r.update, tu);
  }), l && s.addEventListener("resize", r.update, tu), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", r.update, tu);
    }), l && s.removeEventListener("resize", r.update, tu);
  };
}
const IV = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: CV,
  data: {}
};
var AV = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Nu(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return AV[t];
  });
}
var DV = {
  start: "end",
  end: "start"
};
function ZM(e) {
  return e.replace(/start|end/g, function(t) {
    return DV[t];
  });
}
function I0(e) {
  var t = Hr(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function A0(e) {
  return va(zo(e)).left + I0(e).scrollLeft;
}
function kV(e, t) {
  var r = Hr(e), n = zo(e), o = r.visualViewport, i = n.clientWidth, a = n.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    var c = PI();
    (c || !c && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + A0(e),
    y: s
  };
}
function EV(e) {
  var t, r = zo(e), n = I0(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = ai(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = ai(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + A0(e), s = -n.scrollTop;
  return eo(o || r).direction === "rtl" && (l += ai(r.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function D0(e) {
  var t = eo(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function YI(e) {
  return ["html", "body", "#document"].indexOf(_n(e)) >= 0 ? e.ownerDocument.body : nn(e) && D0(e) ? e : YI(pd(e));
}
function yl(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = YI(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Hr(n), a = o ? [i].concat(i.visualViewport || [], D0(n) ? n : []) : n, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(yl(pd(a)))
  );
}
function wg(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function LV(e, t) {
  var r = va(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function GM(e, t, r) {
  return t === jI ? wg(kV(e, r)) : mi(t) ? LV(t, r) : wg(EV(zo(e)));
}
function $V(e) {
  var t = yl(pd(e)), r = ["absolute", "fixed"].indexOf(eo(e).position) >= 0, n = r && nn(e) ? As(e) : e;
  return mi(n) ? t.filter(function(o) {
    return mi(o) && BI(o, n) && _n(o) !== "body";
  }) : [];
}
function zV(e, t, r, n) {
  var o = t === "clippingParents" ? $V(e) : [].concat(t), i = [].concat(o, [r]), a = i[0], l = i.reduce(function(s, c) {
    var u = GM(e, c, n);
    return s.top = ai(u.top, s.top), s.right = ic(u.right, s.right), s.bottom = ic(u.bottom, s.bottom), s.left = ai(u.left, s.left), s;
  }, GM(e, a, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function WI(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? $n(n) : null, i = n ? ba(n) : null, a = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, s;
  switch (o) {
    case kr:
      s = {
        x: a,
        y: t.y - r.height
      };
      break;
    case ln:
      s = {
        x: a,
        y: t.y + t.height
      };
      break;
    case sn:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Er:
      s = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var c = o ? C0(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case ga:
        s[c] = s[c] - (t[u] / 2 - r[u] / 2);
        break;
      case ts:
        s[c] = s[c] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return s;
}
function rs(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, i = r.strategy, a = i === void 0 ? e.strategy : i, l = r.boundary, s = l === void 0 ? tV : l, c = r.rootBoundary, u = c === void 0 ? jI : c, d = r.elementContext, f = d === void 0 ? Ja : d, p = r.altBoundary, h = p === void 0 ? !1 : p, g = r.padding, m = g === void 0 ? 0 : g, v = UI(typeof m != "number" ? m : HI(m, Is)), M = f === Ja ? rV : Ja, x = e.rects.popper, b = e.elements[h ? M : f], T = zV(mi(b) ? b : b.contextElement || zo(e.elements.popper), s, u, a), w = va(e.elements.reference), y = WI({
    reference: w,
    element: x,
    strategy: "absolute",
    placement: o
  }), I = wg(Object.assign({}, x, y)), D = f === Ja ? I : w, O = {
    top: T.top - D.top + v.top,
    bottom: D.bottom - T.bottom + v.bottom,
    left: T.left - D.left + v.left,
    right: D.right - T.right + v.right
  }, $ = e.modifiersData.offset;
  if (f === Ja && $) {
    var z = $[o];
    Object.keys(O).forEach(function(Y) {
      var j = [sn, ln].indexOf(Y) >= 0 ? 1 : -1, q = [kr, ln].indexOf(Y) >= 0 ? "y" : "x";
      O[Y] += z[q] * j;
    });
  }
  return O;
}
function OV(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, i = r.rootBoundary, a = r.padding, l = r.flipVariations, s = r.allowedAutoPlacements, c = s === void 0 ? RI : s, u = ba(n), d = u ? l ? WM : WM.filter(function(h) {
    return ba(h) === u;
  }) : Is, f = d.filter(function(h) {
    return c.indexOf(h) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(h, g) {
    return h[g] = rs(e, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[$n(g)], h;
  }, {});
  return Object.keys(p).sort(function(h, g) {
    return p[h] - p[g];
  });
}
function jV(e) {
  if ($n(e) === T0)
    return [];
  var t = Nu(e);
  return [ZM(e), t, ZM(t)];
}
function RV(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !0 : a, s = r.fallbackPlacements, c = r.padding, u = r.boundary, d = r.rootBoundary, f = r.altBoundary, p = r.flipVariations, h = p === void 0 ? !0 : p, g = r.allowedAutoPlacements, m = t.options.placement, v = $n(m), M = v === m, x = s || (M || !h ? [Nu(m)] : jV(m)), b = [m].concat(x).reduce(function(Ce, ze) {
      return Ce.concat($n(ze) === T0 ? OV(t, {
        placement: ze,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: h,
        allowedAutoPlacements: g
      }) : ze);
    }, []), T = t.rects.reference, w = t.rects.popper, y = /* @__PURE__ */ new Map(), I = !0, D = b[0], O = 0; O < b.length; O++) {
      var $ = b[O], z = $n($), Y = ba($) === ga, j = [kr, ln].indexOf(z) >= 0, q = j ? "width" : "height", ee = rs(t, {
        placement: $,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), re = j ? Y ? sn : Er : Y ? ln : kr;
      T[q] > w[q] && (re = Nu(re));
      var le = Nu(re), ye = [];
      if (i && ye.push(ee[z] <= 0), l && ye.push(ee[re] <= 0, ee[le] <= 0), ye.every(function(Ce) {
        return Ce;
      })) {
        D = $, I = !1;
        break;
      }
      y.set($, ye);
    }
    if (I)
      for (var Me = h ? 3 : 1, Ee = function(ze) {
        var ke = b.find(function(tt) {
          var Ge = y.get(tt);
          if (Ge)
            return Ge.slice(0, ze).every(function(Ne) {
              return Ne;
            });
        });
        if (ke)
          return D = ke, "break";
      }, ne = Me; ne > 0; ne--) {
        var ue = Ee(ne);
        if (ue === "break")
          break;
      }
    t.placement !== D && (t.modifiersData[n]._skip = !0, t.placement = D, t.reset = !0);
  }
}
const _V = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: RV,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function KM(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function qM(e) {
  return [kr, sn, ln, Er].some(function(t) {
    return e[t] >= 0;
  });
}
function PV(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = rs(t, {
    elementContext: "reference"
  }), l = rs(t, {
    altBoundary: !0
  }), s = KM(a, n), c = KM(l, o, i), u = qM(s), d = qM(c);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const BV = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: PV
};
function FV(e, t, r) {
  var n = $n(e), o = [Er, kr].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [Er, sn].indexOf(n) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function UV(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, i = o === void 0 ? [0, 0] : o, a = RI.reduce(function(u, d) {
    return u[d] = FV(d, t.rects, i), u;
  }, {}), l = a[t.placement], s = l.x, c = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += c), t.modifiersData[n] = a;
}
const HV = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: UV
};
function YV(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = WI({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const WV = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: YV,
  data: {}
};
function QV(e) {
  return e === "x" ? "y" : "x";
}
function VV(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, i = o === void 0 ? !0 : o, a = r.altAxis, l = a === void 0 ? !1 : a, s = r.boundary, c = r.rootBoundary, u = r.altBoundary, d = r.padding, f = r.tether, p = f === void 0 ? !0 : f, h = r.tetherOffset, g = h === void 0 ? 0 : h, m = rs(t, {
    boundary: s,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), v = $n(t.placement), M = ba(t.placement), x = !M, b = C0(v), T = QV(b), w = t.modifiersData.popperOffsets, y = t.rects.reference, I = t.rects.popper, D = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, O = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, z = {
    x: 0,
    y: 0
  };
  if (w) {
    if (i) {
      var Y, j = b === "y" ? kr : Er, q = b === "y" ? ln : sn, ee = b === "y" ? "height" : "width", re = w[b], le = re + m[j], ye = re - m[q], Me = p ? -I[ee] / 2 : 0, Ee = M === ga ? y[ee] : I[ee], ne = M === ga ? -I[ee] : -y[ee], ue = t.elements.arrow, Ce = p && ue ? S0(ue) : {
        width: 0,
        height: 0
      }, ze = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : FI(), ke = ze[j], tt = ze[q], Ge = Ml(0, y[ee], Ce[ee]), Ne = x ? y[ee] / 2 - Me - Ge - ke - O.mainAxis : Ee - Ge - ke - O.mainAxis, Ye = x ? -y[ee] / 2 + Me + Ge + tt + O.mainAxis : ne + Ge + tt + O.mainAxis, Se = t.elements.arrow && As(t.elements.arrow), _e = Se ? b === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, Fe = (Y = $ == null ? void 0 : $[b]) != null ? Y : 0, ot = re + Ne - Fe - _e, Nt = re + Ye - Fe, A = Ml(p ? ic(le, ot) : le, re, p ? ai(ye, Nt) : ye);
      w[b] = A, z[b] = A - re;
    }
    if (l) {
      var C, E = b === "x" ? kr : Er, J = b === "x" ? ln : sn, H = w[T], X = T === "y" ? "height" : "width", me = H + m[E], Te = H - m[J], G = [kr, Er].indexOf(v) !== -1, ae = (C = $ == null ? void 0 : $[T]) != null ? C : 0, Xe = G ? me : H - y[X] - I[X] - ae + O.altAxis, gt = G ? H + y[X] + I[X] - ae - O.altAxis : Te, yt = p && G ? vV(Xe, H, gt) : Ml(p ? Xe : me, H, p ? gt : Te);
      w[T] = yt, z[T] = yt - H;
    }
    t.modifiersData[n] = z;
  }
}
const ZV = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: VV,
  requiresIfExists: ["offset"]
};
function GV(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function KV(e) {
  return e === Hr(e) || !nn(e) ? I0(e) : GV(e);
}
function qV(e) {
  var t = e.getBoundingClientRect(), r = ma(t.width) / e.offsetWidth || 1, n = ma(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function JV(e, t, r) {
  r === void 0 && (r = !1);
  var n = nn(t), o = nn(t) && qV(t), i = zo(t), a = va(e, o, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((_n(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  D0(i)) && (l = KV(t)), nn(t) ? (s = va(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = A0(i))), {
    x: a.left + l.scrollLeft - s.x,
    y: a.top + l.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function XV(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    r.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!r.has(l)) {
        var s = t.get(l);
        s && o(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || o(i);
  }), n;
}
function eZ(e) {
  var t = XV(e);
  return fV.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function tZ(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function rZ(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var JM = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function XM() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function nZ(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, i = o === void 0 ? JM : o;
  return function(l, s, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, JM, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: u,
      setOptions: function(v) {
        var M = typeof v == "function" ? v(u.options) : v;
        g(), u.options = Object.assign({}, i, u.options, M), u.scrollParents = {
          reference: mi(l) ? yl(l) : l.contextElement ? yl(l.contextElement) : [],
          popper: yl(s)
        };
        var x = eZ(rZ([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(b) {
          return b.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = u.elements, M = v.reference, x = v.popper;
          if (XM(M, x)) {
            u.rects = {
              reference: JV(M, As(x), u.options.strategy === "fixed"),
              popper: S0(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(O) {
              return u.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var b = 0; b < u.orderedModifiers.length; b++) {
              if (u.reset === !0) {
                u.reset = !1, b = -1;
                continue;
              }
              var T = u.orderedModifiers[b], w = T.fn, y = T.options, I = y === void 0 ? {} : y, D = T.name;
              typeof w == "function" && (u = w({
                state: u,
                options: I,
                name: D,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: tZ(function() {
        return new Promise(function(m) {
          p.forceUpdate(), m(u);
        });
      }),
      destroy: function() {
        g(), f = !0;
      }
    };
    if (!XM(l, s))
      return p;
    p.setOptions(c).then(function(m) {
      !f && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function h() {
      u.orderedModifiers.forEach(function(m) {
        var v = m.name, M = m.options, x = M === void 0 ? {} : M, b = m.effect;
        if (typeof b == "function") {
          var T = b({
            state: u,
            name: v,
            instance: p,
            options: x
          }), w = function() {
          };
          d.push(T || w);
        }
      });
    }
    function g() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return p;
  };
}
var oZ = [IV, WV, SV, _I, HV, _V, ZV, xV, BV], iZ = /* @__PURE__ */ nZ({
  defaultModifiers: oZ
}), aZ = "tippy-box", QI = "tippy-content", lZ = "tippy-backdrop", VI = "tippy-arrow", ZI = "tippy-svg-arrow", Yo = {
  passive: !0,
  capture: !0
}, GI = function() {
  return document.body;
};
function sZ(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function yf(e, t, r) {
  if (Array.isArray(e)) {
    var n = e[t];
    return n ?? (Array.isArray(r) ? r[t] : r);
  }
  return e;
}
function k0(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function KI(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function ey(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(n) {
    clearTimeout(r), r = setTimeout(function() {
      e(n);
    }, t);
  };
}
function uZ(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(n) {
    delete r[n];
  }), r;
}
function cZ(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Qi(e) {
  return [].concat(e);
}
function ty(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function dZ(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function fZ(e) {
  return e.split("-")[0];
}
function ac(e) {
  return [].slice.call(e);
}
function ry(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function xl() {
  return document.createElement("div");
}
function ns(e) {
  return ["Element", "Fragment"].some(function(t) {
    return k0(e, t);
  });
}
function pZ(e) {
  return k0(e, "NodeList");
}
function hZ(e) {
  return k0(e, "MouseEvent");
}
function gZ(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function mZ(e) {
  return ns(e) ? [e] : pZ(e) ? ac(e) : Array.isArray(e) ? e : ac(document.querySelectorAll(e));
}
function xf(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function ny(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function vZ(e) {
  var t, r = Qi(e), n = r[0];
  return n != null && (t = n.ownerDocument) != null && t.body ? n.ownerDocument : document;
}
function bZ(e, t) {
  var r = t.clientX, n = t.clientY;
  return e.every(function(o) {
    var i = o.popperRect, a = o.popperState, l = o.props, s = l.interactiveBorder, c = fZ(a.placement), u = a.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, p = c === "right" ? u.left.x : 0, h = c === "left" ? u.right.x : 0, g = i.top - n + d > s, m = n - i.bottom - f > s, v = i.left - r + p > s, M = r - i.right - h > s;
    return g || m || v || M;
  });
}
function wf(e, t, r) {
  var n = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    e[n](o, r);
  });
}
function oy(e, t) {
  for (var r = t; r; ) {
    var n;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (n = r.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var kn = {
  isTouch: !1
}, iy = 0;
function MZ() {
  kn.isTouch || (kn.isTouch = !0, window.performance && document.addEventListener("mousemove", qI));
}
function qI() {
  var e = performance.now();
  e - iy < 20 && (kn.isTouch = !1, document.removeEventListener("mousemove", qI)), iy = e;
}
function yZ() {
  var e = document.activeElement;
  if (gZ(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function xZ() {
  document.addEventListener("touchstart", MZ, Yo), window.addEventListener("blur", yZ);
}
var wZ = typeof window < "u" && typeof document < "u", TZ = wZ ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Fi(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function ay(e) {
  var t = /[ \t]{2,}/g, r = /^[ \t]*/gm;
  return e.replace(t, " ").replace(r, "").trim();
}
function NZ(e) {
  return ay(`
  %ctippy.js

  %c` + ay(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function JI(e) {
  return [
    NZ(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var is;
process.env.NODE_ENV !== "production" && SZ();
function SZ() {
  is = /* @__PURE__ */ new Set();
}
function Vn(e, t) {
  if (e && !is.has(t)) {
    var r;
    is.add(t), (r = console).warn.apply(r, JI(t));
  }
}
function Tg(e, t) {
  if (e && !is.has(t)) {
    var r;
    is.add(t), (r = console).error.apply(r, JI(t));
  }
}
function CZ(e) {
  var t = !e, r = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  Tg(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Tg(r, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var XI = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, IZ = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Pr = Object.assign({
  appendTo: GI,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, XI, IZ), AZ = Object.keys(Pr), DZ = function(t) {
  process.env.NODE_ENV !== "production" && tA(t, []);
  var r = Object.keys(t);
  r.forEach(function(n) {
    Pr[n] = t[n];
  });
};
function eA(e) {
  var t = e.plugins || [], r = t.reduce(function(n, o) {
    var i = o.name, a = o.defaultValue;
    if (i) {
      var l;
      n[i] = e[i] !== void 0 ? e[i] : (l = Pr[i]) != null ? l : a;
    }
    return n;
  }, {});
  return Object.assign({}, e, r);
}
function kZ(e, t) {
  var r = t ? Object.keys(eA(Object.assign({}, Pr, {
    plugins: t
  }))) : AZ, n = r.reduce(function(o, i) {
    var a = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!a)
      return o;
    if (i === "content")
      o[i] = a;
    else
      try {
        o[i] = JSON.parse(a);
      } catch {
        o[i] = a;
      }
    return o;
  }, {});
  return n;
}
function ly(e, t) {
  var r = Object.assign({}, t, {
    content: KI(t.content, [e])
  }, t.ignoreAttributes ? {} : kZ(e, t.plugins));
  return r.aria = Object.assign({}, Pr.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
function tA(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var r = Object.keys(e);
  r.forEach(function(n) {
    var o = uZ(Pr, Object.keys(XI)), i = !sZ(o, n);
    i && (i = t.filter(function(a) {
      return a.name === n;
    }).length === 0), Vn(i, ["`" + n + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var EZ = function() {
  return "innerHTML";
};
function Ng(e, t) {
  e[EZ()] = t;
}
function sy(e) {
  var t = xl();
  return e === !0 ? t.className = VI : (t.className = ZI, ns(e) ? t.appendChild(e) : Ng(t, e)), t;
}
function uy(e, t) {
  ns(t.content) ? (Ng(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Ng(e, t.content) : e.textContent = t.content);
}
function Sg(e) {
  var t = e.firstElementChild, r = ac(t.children);
  return {
    box: t,
    content: r.find(function(n) {
      return n.classList.contains(QI);
    }),
    arrow: r.find(function(n) {
      return n.classList.contains(VI) || n.classList.contains(ZI);
    }),
    backdrop: r.find(function(n) {
      return n.classList.contains(lZ);
    })
  };
}
function rA(e) {
  var t = xl(), r = xl();
  r.className = aZ, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var n = xl();
  n.className = QI, n.setAttribute("data-state", "hidden"), uy(n, e.props), t.appendChild(r), r.appendChild(n), o(e.props, e.props);
  function o(i, a) {
    var l = Sg(t), s = l.box, c = l.content, u = l.arrow;
    a.theme ? s.setAttribute("data-theme", a.theme) : s.removeAttribute("data-theme"), typeof a.animation == "string" ? s.setAttribute("data-animation", a.animation) : s.removeAttribute("data-animation"), a.inertia ? s.setAttribute("data-inertia", "") : s.removeAttribute("data-inertia"), s.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? s.setAttribute("role", a.role) : s.removeAttribute("role"), (i.content !== a.content || i.allowHTML !== a.allowHTML) && uy(c, e.props), a.arrow ? u ? i.arrow !== a.arrow && (s.removeChild(u), s.appendChild(sy(a.arrow))) : s.appendChild(sy(a.arrow)) : u && s.removeChild(u);
  }
  return {
    popper: t,
    onUpdate: o
  };
}
rA.$$tippy = !0;
var LZ = 1, ru = [], Tf = [];
function $Z(e, t) {
  var r = ly(e, Object.assign({}, Pr, eA(ry(t)))), n, o, i, a = !1, l = !1, s = !1, c = !1, u, d, f, p = [], h = ey(ot, r.interactiveDebounce), g, m = LZ++, v = null, M = dZ(r.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, b = {
    // properties
    id: m,
    reference: e,
    popper: xl(),
    popperInstance: v,
    props: r,
    state: x,
    plugins: M,
    // methods
    clearDelayTimeouts: Xe,
    setProps: gt,
    setContent: yt,
    show: or,
    hide: Xt,
    hideWithInteractivity: jt,
    enable: G,
    disable: ae,
    unmount: ir,
    destroy: gr
  };
  if (!r.render)
    return process.env.NODE_ENV !== "production" && Tg(!0, "render() function has not been supplied."), b;
  var T = r.render(b), w = T.popper, y = T.onUpdate;
  w.setAttribute("data-tippy-root", ""), w.id = "tippy-" + b.id, b.popper = w, e._tippy = b, w._tippy = b;
  var I = M.map(function(K) {
    return K.fn(b);
  }), D = e.hasAttribute("aria-expanded");
  return Se(), Me(), re(), le("onCreate", [b]), r.showOnCreate && me(), w.addEventListener("mouseenter", function() {
    b.props.interactive && b.state.isVisible && b.clearDelayTimeouts();
  }), w.addEventListener("mouseleave", function() {
    b.props.interactive && b.props.trigger.indexOf("mouseenter") >= 0 && j().addEventListener("mousemove", h);
  }), b;
  function O() {
    var K = b.props.touch;
    return Array.isArray(K) ? K : [K, 0];
  }
  function $() {
    return O()[0] === "hold";
  }
  function z() {
    var K;
    return !!((K = b.props.render) != null && K.$$tippy);
  }
  function Y() {
    return g || e;
  }
  function j() {
    var K = Y().parentNode;
    return K ? vZ(K) : document;
  }
  function q() {
    return Sg(w);
  }
  function ee(K) {
    return b.state.isMounted && !b.state.isVisible || kn.isTouch || u && u.type === "focus" ? 0 : yf(b.props.delay, K ? 0 : 1, Pr.delay);
  }
  function re(K) {
    K === void 0 && (K = !1), w.style.pointerEvents = b.props.interactive && !K ? "" : "none", w.style.zIndex = "" + b.props.zIndex;
  }
  function le(K, P, k) {
    if (k === void 0 && (k = !0), I.forEach(function(ie) {
      ie[K] && ie[K].apply(ie, P);
    }), k) {
      var U;
      (U = b.props)[K].apply(U, P);
    }
  }
  function ye() {
    var K = b.props.aria;
    if (K.content) {
      var P = "aria-" + K.content, k = w.id, U = Qi(b.props.triggerTarget || e);
      U.forEach(function(ie) {
        var xe = ie.getAttribute(P);
        if (b.state.isVisible)
          ie.setAttribute(P, xe ? xe + " " + k : k);
        else {
          var Ie = xe && xe.replace(k, "").trim();
          Ie ? ie.setAttribute(P, Ie) : ie.removeAttribute(P);
        }
      });
    }
  }
  function Me() {
    if (!(D || !b.props.aria.expanded)) {
      var K = Qi(b.props.triggerTarget || e);
      K.forEach(function(P) {
        b.props.interactive ? P.setAttribute("aria-expanded", b.state.isVisible && P === Y() ? "true" : "false") : P.removeAttribute("aria-expanded");
      });
    }
  }
  function Ee() {
    j().removeEventListener("mousemove", h), ru = ru.filter(function(K) {
      return K !== h;
    });
  }
  function ne(K) {
    if (!(kn.isTouch && (s || K.type === "mousedown"))) {
      var P = K.composedPath && K.composedPath()[0] || K.target;
      if (!(b.props.interactive && oy(w, P))) {
        if (Qi(b.props.triggerTarget || e).some(function(k) {
          return oy(k, P);
        })) {
          if (kn.isTouch || b.state.isVisible && b.props.trigger.indexOf("click") >= 0)
            return;
        } else
          le("onClickOutside", [b, K]);
        b.props.hideOnClick === !0 && (b.clearDelayTimeouts(), b.hide(), l = !0, setTimeout(function() {
          l = !1;
        }), b.state.isMounted || ke());
      }
    }
  }
  function ue() {
    s = !0;
  }
  function Ce() {
    s = !1;
  }
  function ze() {
    var K = j();
    K.addEventListener("mousedown", ne, !0), K.addEventListener("touchend", ne, Yo), K.addEventListener("touchstart", Ce, Yo), K.addEventListener("touchmove", ue, Yo);
  }
  function ke() {
    var K = j();
    K.removeEventListener("mousedown", ne, !0), K.removeEventListener("touchend", ne, Yo), K.removeEventListener("touchstart", Ce, Yo), K.removeEventListener("touchmove", ue, Yo);
  }
  function tt(K, P) {
    Ne(K, function() {
      !b.state.isVisible && w.parentNode && w.parentNode.contains(w) && P();
    });
  }
  function Ge(K, P) {
    Ne(K, P);
  }
  function Ne(K, P) {
    var k = q().box;
    function U(ie) {
      ie.target === k && (wf(k, "remove", U), P());
    }
    if (K === 0)
      return P();
    wf(k, "remove", d), wf(k, "add", U), d = U;
  }
  function Ye(K, P, k) {
    k === void 0 && (k = !1);
    var U = Qi(b.props.triggerTarget || e);
    U.forEach(function(ie) {
      ie.addEventListener(K, P, k), p.push({
        node: ie,
        eventType: K,
        handler: P,
        options: k
      });
    });
  }
  function Se() {
    $() && (Ye("touchstart", Fe, {
      passive: !0
    }), Ye("touchend", Nt, {
      passive: !0
    })), cZ(b.props.trigger).forEach(function(K) {
      if (K !== "manual")
        switch (Ye(K, Fe), K) {
          case "mouseenter":
            Ye("mouseleave", Nt);
            break;
          case "focus":
            Ye(TZ ? "focusout" : "blur", A);
            break;
          case "focusin":
            Ye("focusout", A);
            break;
        }
    });
  }
  function _e() {
    p.forEach(function(K) {
      var P = K.node, k = K.eventType, U = K.handler, ie = K.options;
      P.removeEventListener(k, U, ie);
    }), p = [];
  }
  function Fe(K) {
    var P, k = !1;
    if (!(!b.state.isEnabled || C(K) || l)) {
      var U = ((P = u) == null ? void 0 : P.type) === "focus";
      u = K, g = K.currentTarget, Me(), !b.state.isVisible && hZ(K) && ru.forEach(function(ie) {
        return ie(K);
      }), K.type === "click" && (b.props.trigger.indexOf("mouseenter") < 0 || a) && b.props.hideOnClick !== !1 && b.state.isVisible ? k = !0 : me(K), K.type === "click" && (a = !k), k && !U && Te(K);
    }
  }
  function ot(K) {
    var P = K.target, k = Y().contains(P) || w.contains(P);
    if (!(K.type === "mousemove" && k)) {
      var U = X().concat(w).map(function(ie) {
        var xe, Ie = ie._tippy, Ae = (xe = Ie.popperInstance) == null ? void 0 : xe.state;
        return Ae ? {
          popperRect: ie.getBoundingClientRect(),
          popperState: Ae,
          props: r
        } : null;
      }).filter(Boolean);
      bZ(U, K) && (Ee(), Te(K));
    }
  }
  function Nt(K) {
    var P = C(K) || b.props.trigger.indexOf("click") >= 0 && a;
    if (!P) {
      if (b.props.interactive) {
        b.hideWithInteractivity(K);
        return;
      }
      Te(K);
    }
  }
  function A(K) {
    b.props.trigger.indexOf("focusin") < 0 && K.target !== Y() || b.props.interactive && K.relatedTarget && w.contains(K.relatedTarget) || Te(K);
  }
  function C(K) {
    return kn.isTouch ? $() !== K.type.indexOf("touch") >= 0 : !1;
  }
  function E() {
    J();
    var K = b.props, P = K.popperOptions, k = K.placement, U = K.offset, ie = K.getReferenceClientRect, xe = K.moveTransition, Ie = z() ? Sg(w).arrow : null, Ae = ie ? {
      getBoundingClientRect: ie,
      contextElement: ie.contextElement || Y()
    } : e, Le = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Wr) {
        var $r = Wr.state;
        if (z()) {
          var jo = q(), un = jo.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Qr) {
            Qr === "placement" ? un.setAttribute("data-placement", $r.placement) : $r.attributes.popper["data-popper-" + Qr] ? un.setAttribute("data-" + Qr, "") : un.removeAttribute("data-" + Qr);
          }), $r.attributes.popper = {};
        }
      }
    }, rt = [{
      name: "offset",
      options: {
        offset: U
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !xe
      }
    }, Le];
    z() && Ie && rt.push({
      name: "arrow",
      options: {
        element: Ie,
        padding: 3
      }
    }), rt.push.apply(rt, (P == null ? void 0 : P.modifiers) || []), b.popperInstance = iZ(Ae, w, Object.assign({}, P, {
      placement: k,
      onFirstUpdate: f,
      modifiers: rt
    }));
  }
  function J() {
    b.popperInstance && (b.popperInstance.destroy(), b.popperInstance = null);
  }
  function H() {
    var K = b.props.appendTo, P, k = Y();
    b.props.interactive && K === GI || K === "parent" ? P = k.parentNode : P = KI(K, [k]), P.contains(w) || P.appendChild(w), b.state.isMounted = !0, E(), process.env.NODE_ENV !== "production" && Vn(b.props.interactive && K === Pr.appendTo && k.nextElementSibling !== w, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function X() {
    return ac(w.querySelectorAll("[data-tippy-root]"));
  }
  function me(K) {
    b.clearDelayTimeouts(), K && le("onTrigger", [b, K]), ze();
    var P = ee(!0), k = O(), U = k[0], ie = k[1];
    kn.isTouch && U === "hold" && ie && (P = ie), P ? n = setTimeout(function() {
      b.show();
    }, P) : b.show();
  }
  function Te(K) {
    if (b.clearDelayTimeouts(), le("onUntrigger", [b, K]), !b.state.isVisible) {
      ke();
      return;
    }
    if (!(b.props.trigger.indexOf("mouseenter") >= 0 && b.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(K.type) >= 0 && a)) {
      var P = ee(!1);
      P ? o = setTimeout(function() {
        b.state.isVisible && b.hide();
      }, P) : i = requestAnimationFrame(function() {
        b.hide();
      });
    }
  }
  function G() {
    b.state.isEnabled = !0;
  }
  function ae() {
    b.hide(), b.state.isEnabled = !1;
  }
  function Xe() {
    clearTimeout(n), clearTimeout(o), cancelAnimationFrame(i);
  }
  function gt(K) {
    if (process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("setProps")), !b.state.isDestroyed) {
      le("onBeforeUpdate", [b, K]), _e();
      var P = b.props, k = ly(e, Object.assign({}, P, ry(K), {
        ignoreAttributes: !0
      }));
      b.props = k, Se(), P.interactiveDebounce !== k.interactiveDebounce && (Ee(), h = ey(ot, k.interactiveDebounce)), P.triggerTarget && !k.triggerTarget ? Qi(P.triggerTarget).forEach(function(U) {
        U.removeAttribute("aria-expanded");
      }) : k.triggerTarget && e.removeAttribute("aria-expanded"), Me(), re(), y && y(P, k), b.popperInstance && (E(), X().forEach(function(U) {
        requestAnimationFrame(U._tippy.popperInstance.forceUpdate);
      })), le("onAfterUpdate", [b, K]);
    }
  }
  function yt(K) {
    b.setProps({
      content: K
    });
  }
  function or() {
    process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("show"));
    var K = b.state.isVisible, P = b.state.isDestroyed, k = !b.state.isEnabled, U = kn.isTouch && !b.props.touch, ie = yf(b.props.duration, 0, Pr.duration);
    if (!(K || P || k || U) && !Y().hasAttribute("disabled") && (le("onShow", [b], !1), b.props.onShow(b) !== !1)) {
      if (b.state.isVisible = !0, z() && (w.style.visibility = "visible"), re(), ze(), b.state.isMounted || (w.style.transition = "none"), z()) {
        var xe = q(), Ie = xe.box, Ae = xe.content;
        xf([Ie, Ae], 0);
      }
      f = function() {
        var rt;
        if (!(!b.state.isVisible || c)) {
          if (c = !0, w.offsetHeight, w.style.transition = b.props.moveTransition, z() && b.props.animation) {
            var At = q(), Wr = At.box, $r = At.content;
            xf([Wr, $r], ie), ny([Wr, $r], "visible");
          }
          ye(), Me(), ty(Tf, b), (rt = b.popperInstance) == null || rt.forceUpdate(), le("onMount", [b]), b.props.animation && z() && Ge(ie, function() {
            b.state.isShown = !0, le("onShown", [b]);
          });
        }
      }, H();
    }
  }
  function Xt() {
    process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("hide"));
    var K = !b.state.isVisible, P = b.state.isDestroyed, k = !b.state.isEnabled, U = yf(b.props.duration, 1, Pr.duration);
    if (!(K || P || k) && (le("onHide", [b], !1), b.props.onHide(b) !== !1)) {
      if (b.state.isVisible = !1, b.state.isShown = !1, c = !1, a = !1, z() && (w.style.visibility = "hidden"), Ee(), ke(), re(!0), z()) {
        var ie = q(), xe = ie.box, Ie = ie.content;
        b.props.animation && (xf([xe, Ie], U), ny([xe, Ie], "hidden"));
      }
      ye(), Me(), b.props.animation ? z() && tt(U, b.unmount) : b.unmount();
    }
  }
  function jt(K) {
    process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("hideWithInteractivity")), j().addEventListener("mousemove", h), ty(ru, h), h(K);
  }
  function ir() {
    process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("unmount")), b.state.isVisible && b.hide(), b.state.isMounted && (J(), X().forEach(function(K) {
      K._tippy.unmount();
    }), w.parentNode && w.parentNode.removeChild(w), Tf = Tf.filter(function(K) {
      return K !== b;
    }), b.state.isMounted = !1, le("onHidden", [b]));
  }
  function gr() {
    process.env.NODE_ENV !== "production" && Vn(b.state.isDestroyed, Fi("destroy")), !b.state.isDestroyed && (b.clearDelayTimeouts(), b.unmount(), _e(), delete e._tippy, b.state.isDestroyed = !0, le("onDestroy", [b]));
  }
}
function ja(e, t) {
  t === void 0 && (t = {});
  var r = Pr.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (CZ(e), tA(t, r)), xZ();
  var n = Object.assign({}, t, {
    plugins: r
  }), o = mZ(e);
  if (process.env.NODE_ENV !== "production") {
    var i = ns(n.content), a = o.length > 1;
    Vn(i && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var l = o.reduce(function(s, c) {
    var u = c && $Z(c, n);
    return u && s.push(u), s;
  }, []);
  return ns(e) ? l[0] : l;
}
ja.defaultProps = Pr;
ja.setDefaultProps = DZ;
ja.currentInput = kn;
Object.assign({}, _I, {
  effect: function(t) {
    var r = t.state, n = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow);
  }
});
ja.setDefaultProps({
  render: rA
});
class zZ {
  constructor({ editor: t, element: r, view: n, tippyOptions: o = {}, updateDelay: i = 250, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: l, state: s, from: c, to: u }) => {
      const { doc: d, selection: f } = s, { empty: p } = f, h = !d.textBetween(c, u).length && c0(s.selection), g = this.element.contains(document.activeElement);
      return !(!(l.hasFocus() || g) || p || h || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: l }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      l != null && l.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(l.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (l) => {
      this.blurHandler({ event: l });
    }, this.handleDebouncedUpdate = (l, s) => {
      const c = !(s != null && s.selection.eq(l.state.selection)), u = !(s != null && s.doc.eq(l.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(l, c, u, s);
      }, this.updateDelay));
    }, this.updateHandler = (l, s, c, u) => {
      var d, f, p;
      const { state: h, composing: g } = l, { selection: m } = h;
      if (g || !s && !c)
        return;
      this.createTooltip();
      const { ranges: M } = m, x = Math.min(...M.map((w) => w.$from.pos)), b = Math.max(...M.map((w) => w.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        view: l,
        state: h,
        oldState: u,
        from: x,
        to: b
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((p = this.tippyOptions) === null || p === void 0 ? void 0 : p.getReferenceClientRect) || (() => {
          if (FW(h.selection)) {
            let w = l.nodeDOM(x);
            const y = w.dataset.nodeViewWrapper ? w : w.querySelector("[data-node-view-wrapper]");
            if (y && (w = y.firstChild), w)
              return w.getBoundingClientRect();
          }
          return zI(l, x, b);
        })
      }), this.show();
    }, this.editor = t, this.element = r, this.view = n, this.updateDelay = i, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, r = !!t.parentElement;
    this.tippy || !r || (this.tippy = ja(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, r) {
    const { state: n } = t, o = n.selection.$from.pos !== n.selection.$to.pos;
    if (this.updateDelay > 0 && o) {
      this.handleDebouncedUpdate(t, r);
      return;
    }
    const i = !(r != null && r.selection.eq(t.state.selection)), a = !(r != null && r.doc.eq(t.state.doc));
    this.updateHandler(t, i, a, r);
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, r;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (r = this.tippy) === null || r === void 0 || r.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const nA = (e) => new Nr({
  key: typeof e.pluginKey == "string" ? new pr(e.pluginKey) : e.pluginKey,
  view: (t) => new zZ({ view: t, ...e })
});
dt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      nA({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class OZ {
  constructor({ editor: t, element: r, view: n, tippyOptions: o = {}, shouldShow: i }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l }) => {
      const { selection: s } = l, { $anchor: c, empty: u } = s, d = c.depth === 1, f = c.parent.isTextblock && !c.parent.type.spec.code && !c.parent.textContent;
      return !(!a.hasFocus() || !u || !d || !f || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(a.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.editor = t, this.element = r, this.view = n, i && (this.shouldShow = i), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: t } = this.editor.options, r = !!t.parentElement;
    this.tippy || !r || (this.tippy = ja(t, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(t, r) {
    var n, o, i;
    const { state: a } = t, { doc: l, selection: s } = a, { from: c, to: u } = s;
    if (r && r.doc.eq(l) && r.selection.eq(s))
      return;
    if (this.createTooltip(), !((n = this.shouldShow) === null || n === void 0 ? void 0 : n.call(this, {
      editor: this.editor,
      view: t,
      state: a,
      oldState: r
    }))) {
      this.hide();
      return;
    }
    (o = this.tippy) === null || o === void 0 || o.setProps({
      getReferenceClientRect: ((i = this.tippyOptions) === null || i === void 0 ? void 0 : i.getReferenceClientRect) || (() => zI(t, c, u))
    }), this.show();
  }
  show() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.show();
  }
  hide() {
    var t;
    (t = this.tippy) === null || t === void 0 || t.hide();
  }
  destroy() {
    var t, r;
    !((t = this.tippy) === null || t === void 0) && t.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (r = this.tippy) === null || r === void 0 || r.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const oA = (e) => new Nr({
  key: typeof e.pluginKey == "string" ? new pr(e.pluginKey) : e.pluginKey,
  view: (t) => new OZ({ view: t, ...e })
});
dt.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      oA({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
const iA = Z({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const r = L(null);
    return et(() => {
      const { updateDelay: n, editor: o, pluginKey: i, shouldShow: a, tippyOptions: l } = e;
      o.registerPlugin(nA({
        updateDelay: n,
        editor: o,
        element: r.value,
        pluginKey: i,
        shouldShow: a,
        tippyOptions: l
      }));
    }), vt(() => {
      const { pluginKey: n, editor: o } = e;
      o.unregisterPlugin(n);
    }), () => {
      var n;
      return S("div", { ref: r }, (n = t.default) === null || n === void 0 ? void 0 : n.call(t));
    };
  }
}), jZ = Z({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const t = L(), r = xa();
    return rr(() => {
      const n = e.editor;
      n && n.options.element && t.value && mn(() => {
        if (!t.value || !n.options.element.firstChild)
          return;
        const o = N(t.value);
        t.value.append(...n.options.element.childNodes), n.contentComponent = r.ctx._, n.setOptions({
          element: o
        }), n.createNodeViews();
      });
    }), vt(() => {
      const n = e.editor;
      if (!n || (n.isDestroyed || n.view.setProps({
        nodeViews: {}
      }), n.contentComponent = null, !n.options.element.firstChild))
        return;
      const o = document.createElement("div");
      o.append(...n.options.element.childNodes), n.setOptions({
        element: o
      });
    }), { rootEl: t };
  },
  render() {
    const e = [];
    return this.editor && this.editor.vueRenderers.forEach((t) => {
      const r = S(N1, {
        to: t.teleportElement,
        key: t.id
      }, S(t.component, {
        ref: t.id,
        ...t.props
      }));
      e.push(r);
    }), S("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    }, ...e);
  }
});
Z({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: t }) {
    const r = L(null);
    return et(() => {
      const { pluginKey: n, editor: o, tippyOptions: i, shouldShow: a } = e;
      o.registerPlugin(oA({
        pluginKey: n,
        editor: o,
        element: r.value,
        tippyOptions: i,
        shouldShow: a
      }));
    }), vt(() => {
      const { pluginKey: n, editor: o } = e;
      o.unregisterPlugin(n);
    }), () => {
      var n;
      return S("div", { ref: r }, (n = t.default) === null || n === void 0 ? void 0 : n.call(t));
    };
  }
});
Z({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return S(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
const RZ = Z({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, t;
    return S(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (t = (e = this.$slots).default) === null || t === void 0 ? void 0 : t.call(e));
  }
});
class _Z {
  constructor(t, { props: r = {}, editor: n }) {
    if (this.id = Math.floor(Math.random() * 4294967295).toString(), this.editor = n, this.component = M4(t), this.teleportElement = document.createElement("div"), this.element = this.teleportElement, this.props = y4(r), this.editor.vueRenderers.set(this.id, this), this.editor.contentComponent) {
      if (this.editor.contentComponent.update(), this.teleportElement.children.length !== 1)
        throw Error("VueRenderer doesn’t support multiple child elements.");
      this.element = this.teleportElement.firstElementChild;
    }
  }
  get ref() {
    var t;
    return (t = this.editor.contentComponent) === null || t === void 0 ? void 0 : t.refs[this.id];
  }
  updateProps(t = {}) {
    Object.entries(t).forEach(([r, n]) => {
      this.props[r] = n;
    });
  }
  destroy() {
    this.editor.vueRenderers.delete(this.id);
  }
}
class PZ extends cQ {
  mount() {
    const t = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      selected: !1,
      extension: this.extension,
      getPos: () => this.getPos(),
      updateAttributes: (o = {}) => this.updateAttributes(o),
      deleteNode: () => this.deleteNode()
    }, r = this.onDragStart.bind(this);
    this.decorationClasses = L(this.getDecorationClasses());
    const n = Z({
      extends: { ...this.component },
      props: Object.keys(t),
      template: this.component.template,
      setup: (o) => {
        var i, a;
        return Et("onDragStart", r), Et("decorationClasses", this.decorationClasses), (a = (i = this.component).setup) === null || a === void 0 ? void 0 : a.call(i, o, {
          expose: () => {
          }
        });
      },
      // add support for scoped styles
      // @ts-ignore
      // eslint-disable-next-line
      __scopeId: this.component.__scopeId,
      // add support for CSS Modules
      // @ts-ignore
      // eslint-disable-next-line
      __cssModules: this.component.__cssModules,
      // add support for vue devtools
      // @ts-ignore
      // eslint-disable-next-line
      __name: this.component.__name,
      // @ts-ignore
      // eslint-disable-next-line
      __file: this.component.__file
    });
    this.renderer = new _Z(n, {
      editor: this.editor,
      props: t
    });
  }
  get dom() {
    if (!this.renderer.element.hasAttribute("data-node-view-wrapper"))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  get contentDOM() {
    return this.node.isLeaf ? null : this.dom.querySelector("[data-node-view-content]") || this.dom;
  }
  update(t, r) {
    const n = (o) => {
      this.decorationClasses.value = this.getDecorationClasses(), this.renderer.updateProps(o);
    };
    if (typeof this.options.update == "function") {
      const o = this.node, i = this.decorations;
      return this.node = t, this.decorations = r, this.options.update({
        oldNode: o,
        oldDecorations: i,
        newNode: t,
        newDecorations: r,
        updateProps: () => n({ node: t, decorations: r })
      });
    }
    return t.type !== this.node.type ? !1 : (t === this.node && this.decorations === r || (this.node = t, this.decorations = r, n({ node: t, decorations: r })), !0);
  }
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  getDecorationClasses() {
    return this.decorations.map((t) => t.type.attrs.class).flat().join(" ");
  }
  destroy() {
    this.renderer.destroy();
  }
}
function BZ(e, t) {
  return (r) => r.editor.contentComponent ? new PZ(e, r, t) : {};
}
const aA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTcuMDgzMyA3LjVIMy43NVYxMi41SDE3LjA4MzNWNy41WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNSAxNi4yNUgxMy4zMzMzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy41IDMuNzVIMTMuMzMzMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", lA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMy4zMzM5OCAxNUg5LjE2NzMyTTMuMzMzOTggNUgxNi42NjczVjEwSDMuMzMzOThWNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", sA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTYuNjY2IDE1SDEwLjgzMjdNMTYuNjY2IDVIMy4zMzI2OFYxMEgxNi42NjZWNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", uA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTUxOV8xNTc5OSkiPgo8cGF0aCBkPSJNOC45NDQyIDguMTAxNTZDOS4wODIyNyA4LjEwMTU2IDkuMTk0MiA4LjIxMzQ5IDkuMTk0MiA4LjM1MTU2VjEyLjQ3NjJDOS4xOTQyIDEyLjYxNDMgOS4wODIyNyAxMi43MjYyIDguOTQ0MiAxMi43MjYySDYuMzQ3MUgzLjc1QzMuNjExOTMgMTIuNzI2MiAzLjUgMTIuNjE0MyAzLjUgMTIuNDc2MlY4LjM1MTU2QzMuNSA4LjIxMzQ5IDMuNjExOTMgOC4xMDE1NiAzLjc1IDguMTAxNTZIOC45NDQyWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuNSAxNi40OTQxSDE3LjQ5OTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjUgNC4zMzU5NEgxNy40OTk3IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuMjcxNSA4LjA2NjQxTDE3LjQ5OTkgOC4wNjY0MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEyLjI3MTUgMTIuNzczNEgxNS4xMzI5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE1MTlfMTU3OTkiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", cA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTEuMDU2IDguMTAxNTRDMTAuOTE3OSA4LjEwMTU0IDEwLjgwNiA4LjIxMzQ2IDEwLjgwNiA4LjM1MTUzVjEyLjQ3NjFDMTAuODA2IDEyLjYxNDIgMTAuOTE3OSAxMi43MjYxIDExLjA1NiAxMi43MjYxSDEzLjY1M0gxNi4yNUMxNi4zODgxIDEyLjcyNjEgMTYuNSAxMi42MTQyIDE2LjUgMTIuNDc2MVY4LjM1MTUzQzE2LjUgOC4yMTM0NiAxNi4zODgxIDguMTAxNTQgMTYuMjUgOC4xMDE1NEgxMS4wNTZaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuNSAxNi40OTQxSDIuNTAwNjMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy41IDQuMzM1OTRIMi41MDA2MyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuNzI4NTIgOC4wNjY0MUwyLjUwMDIxIDguMDY2NDEiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjcyODUyIDEyLjc3MzRINC44NjcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
var Cg;
try {
  Cg = Map;
} catch {
}
var Ig;
try {
  Ig = Set;
} catch {
}
function dA(e, t, r) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(Ag);
  if (Cg && e instanceof Cg)
    return new Map(Array.from(e.entries()));
  if (Ig && e instanceof Ig)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var n = Object.create(e);
    r.push(n);
    for (var o in e) {
      var i = t.findIndex(function(a) {
        return a === e[o];
      });
      n[o] = i > -1 ? r[i] : dA(e[o], t, r);
    }
    return n;
  }
  return e;
}
function Ag(e) {
  return dA(e, [], []);
}
const FZ = Object.prototype.toString, UZ = Error.prototype.toString, HZ = RegExp.prototype.toString, YZ = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", WZ = /^Symbol\((.*)\)(.*)$/;
function QZ(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function cy(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const r = typeof e;
  if (r === "number")
    return QZ(e);
  if (r === "string")
    return t ? `"${e}"` : e;
  if (r === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol")
    return YZ.call(e).replace(WZ, "Symbol($1)");
  const n = FZ.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + UZ.call(e) + "]" : n === "RegExp" ? HZ.call(e) : null;
}
function as(e, t) {
  let r = cy(e, t);
  return r !== null ? r : JSON.stringify(e, function(n, o) {
    let i = cy(this[n], t);
    return i !== null ? i : o;
  }, 2);
}
let Wo = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: n
  }) => {
    let o = n != null && n !== r, i = `${e} must be a \`${t}\` type, but the final value was: \`${as(r, !0)}\`` + (o ? ` (cast from the value \`${as(n, !0)}\`).` : ".");
    return r === null && (i += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), i;
  },
  defined: "${path} must be defined"
}, pn = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, po = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Dg = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, VZ = {
  isValue: "${path} field must be ${value}"
}, ZZ = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, GZ = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Wo,
  string: pn,
  number: po,
  date: Dg,
  object: ZZ,
  array: GZ,
  boolean: VZ
});
var KZ = Object.prototype, qZ = KZ.hasOwnProperty;
function JZ(e, t) {
  return e != null && qZ.call(e, t);
}
var XZ = JZ, eG = Array.isArray, Oo = eG, tG = typeof Zs == "object" && Zs && Zs.Object === Object && Zs, fA = tG, rG = fA, nG = typeof self == "object" && self && self.Object === Object && self, oG = rG || nG || Function("return this")(), io = oG, iG = io, aG = iG.Symbol, hd = aG, dy = hd, pA = Object.prototype, lG = pA.hasOwnProperty, sG = pA.toString, Xa = dy ? dy.toStringTag : void 0;
function uG(e) {
  var t = lG.call(e, Xa), r = e[Xa];
  try {
    e[Xa] = void 0;
    var n = !0;
  } catch {
  }
  var o = sG.call(e);
  return n && (t ? e[Xa] = r : delete e[Xa]), o;
}
var cG = uG, dG = Object.prototype, fG = dG.toString;
function pG(e) {
  return fG.call(e);
}
var hG = pG, fy = hd, gG = cG, mG = hG, vG = "[object Null]", bG = "[object Undefined]", py = fy ? fy.toStringTag : void 0;
function MG(e) {
  return e == null ? e === void 0 ? bG : vG : py && py in Object(e) ? gG(e) : mG(e);
}
var Ds = MG;
function yG(e) {
  return e != null && typeof e == "object";
}
var ks = yG, xG = Ds, wG = ks, TG = "[object Symbol]";
function NG(e) {
  return typeof e == "symbol" || wG(e) && xG(e) == TG;
}
var E0 = NG, SG = Oo, CG = E0, IG = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, AG = /^\w*$/;
function DG(e, t) {
  if (SG(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || CG(e) ? !0 : AG.test(e) || !IG.test(e) || t != null && e in Object(t);
}
var L0 = DG;
function kG(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var $0 = kG, EG = Ds, LG = $0, $G = "[object AsyncFunction]", zG = "[object Function]", OG = "[object GeneratorFunction]", jG = "[object Proxy]";
function RG(e) {
  if (!LG(e))
    return !1;
  var t = EG(e);
  return t == zG || t == OG || t == $G || t == jG;
}
var hA = RG, _G = io, PG = _G["__core-js_shared__"], BG = PG, Nf = BG, hy = function() {
  var e = /[^.]+$/.exec(Nf && Nf.keys && Nf.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function FG(e) {
  return !!hy && hy in e;
}
var UG = FG, HG = Function.prototype, YG = HG.toString;
function WG(e) {
  if (e != null) {
    try {
      return YG.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var gA = WG, QG = hA, VG = UG, ZG = $0, GG = gA, KG = /[\\^$.*+?()[\]{}|]/g, qG = /^\[object .+?Constructor\]$/, JG = Function.prototype, XG = Object.prototype, eK = JG.toString, tK = XG.hasOwnProperty, rK = RegExp(
  "^" + eK.call(tK).replace(KG, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function nK(e) {
  if (!ZG(e) || VG(e))
    return !1;
  var t = QG(e) ? rK : qG;
  return t.test(GG(e));
}
var oK = nK;
function iK(e, t) {
  return e == null ? void 0 : e[t];
}
var aK = iK, lK = oK, sK = aK;
function uK(e, t) {
  var r = sK(e, t);
  return lK(r) ? r : void 0;
}
var Di = uK, cK = Di, dK = cK(Object, "create"), gd = dK, gy = gd;
function fK() {
  this.__data__ = gy ? gy(null) : {}, this.size = 0;
}
var pK = fK;
function hK(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var gK = hK, mK = gd, vK = "__lodash_hash_undefined__", bK = Object.prototype, MK = bK.hasOwnProperty;
function yK(e) {
  var t = this.__data__;
  if (mK) {
    var r = t[e];
    return r === vK ? void 0 : r;
  }
  return MK.call(t, e) ? t[e] : void 0;
}
var xK = yK, wK = gd, TK = Object.prototype, NK = TK.hasOwnProperty;
function SK(e) {
  var t = this.__data__;
  return wK ? t[e] !== void 0 : NK.call(t, e);
}
var CK = SK, IK = gd, AK = "__lodash_hash_undefined__";
function DK(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = IK && t === void 0 ? AK : t, this;
}
var kK = DK, EK = pK, LK = gK, $K = xK, zK = CK, OK = kK;
function Ra(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ra.prototype.clear = EK;
Ra.prototype.delete = LK;
Ra.prototype.get = $K;
Ra.prototype.has = zK;
Ra.prototype.set = OK;
var jK = Ra;
function RK() {
  this.__data__ = [], this.size = 0;
}
var _K = RK;
function PK(e, t) {
  return e === t || e !== e && t !== t;
}
var mA = PK, BK = mA;
function FK(e, t) {
  for (var r = e.length; r--; )
    if (BK(e[r][0], t))
      return r;
  return -1;
}
var md = FK, UK = md, HK = Array.prototype, YK = HK.splice;
function WK(e) {
  var t = this.__data__, r = UK(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : YK.call(t, r, 1), --this.size, !0;
}
var QK = WK, VK = md;
function ZK(e) {
  var t = this.__data__, r = VK(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var GK = ZK, KK = md;
function qK(e) {
  return KK(this.__data__, e) > -1;
}
var JK = qK, XK = md;
function eq(e, t) {
  var r = this.__data__, n = XK(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var tq = eq, rq = _K, nq = QK, oq = GK, iq = JK, aq = tq;
function _a(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
_a.prototype.clear = rq;
_a.prototype.delete = nq;
_a.prototype.get = oq;
_a.prototype.has = iq;
_a.prototype.set = aq;
var vd = _a, lq = Di, sq = io, uq = lq(sq, "Map"), z0 = uq, my = jK, cq = vd, dq = z0;
function fq() {
  this.size = 0, this.__data__ = {
    hash: new my(),
    map: new (dq || cq)(),
    string: new my()
  };
}
var pq = fq;
function hq(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var gq = hq, mq = gq;
function vq(e, t) {
  var r = e.__data__;
  return mq(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var bd = vq, bq = bd;
function Mq(e) {
  var t = bq(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var yq = Mq, xq = bd;
function wq(e) {
  return xq(this, e).get(e);
}
var Tq = wq, Nq = bd;
function Sq(e) {
  return Nq(this, e).has(e);
}
var Cq = Sq, Iq = bd;
function Aq(e, t) {
  var r = Iq(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var Dq = Aq, kq = pq, Eq = yq, Lq = Tq, $q = Cq, zq = Dq;
function Pa(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Pa.prototype.clear = kq;
Pa.prototype.delete = Eq;
Pa.prototype.get = Lq;
Pa.prototype.has = $q;
Pa.prototype.set = zq;
var O0 = Pa, vA = O0, Oq = "Expected a function";
function j0(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Oq);
  var r = function() {
    var n = arguments, o = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, n);
    return r.cache = i.set(o, a) || i, a;
  };
  return r.cache = new (j0.Cache || vA)(), r;
}
j0.Cache = vA;
var jq = j0, Rq = jq, _q = 500;
function Pq(e) {
  var t = Rq(e, function(n) {
    return r.size === _q && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Bq = Pq, Fq = Bq, Uq = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Hq = /\\(\\)?/g, Yq = Fq(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Uq, function(r, n, o, i) {
    t.push(o ? i.replace(Hq, "$1") : n || r);
  }), t;
}), Wq = Yq;
function Qq(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
    o[r] = t(e[r], r, e);
  return o;
}
var Vq = Qq, vy = hd, Zq = Vq, Gq = Oo, Kq = E0, qq = 1 / 0, by = vy ? vy.prototype : void 0, My = by ? by.toString : void 0;
function bA(e) {
  if (typeof e == "string")
    return e;
  if (Gq(e))
    return Zq(e, bA) + "";
  if (Kq(e))
    return My ? My.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -qq ? "-0" : t;
}
var Jq = bA, Xq = Jq;
function eJ(e) {
  return e == null ? "" : Xq(e);
}
var tJ = eJ, rJ = Oo, nJ = L0, oJ = Wq, iJ = tJ;
function aJ(e, t) {
  return rJ(e) ? e : nJ(e, t) ? [e] : oJ(iJ(e));
}
var MA = aJ, lJ = Ds, sJ = ks, uJ = "[object Arguments]";
function cJ(e) {
  return sJ(e) && lJ(e) == uJ;
}
var dJ = cJ, yy = dJ, fJ = ks, yA = Object.prototype, pJ = yA.hasOwnProperty, hJ = yA.propertyIsEnumerable, gJ = yy(function() {
  return arguments;
}()) ? yy : function(e) {
  return fJ(e) && pJ.call(e, "callee") && !hJ.call(e, "callee");
}, xA = gJ, mJ = 9007199254740991, vJ = /^(?:0|[1-9]\d*)$/;
function bJ(e, t) {
  var r = typeof e;
  return t = t ?? mJ, !!t && (r == "number" || r != "symbol" && vJ.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var wA = bJ, MJ = 9007199254740991;
function yJ(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= MJ;
}
var R0 = yJ, xJ = E0, wJ = 1 / 0;
function TJ(e) {
  if (typeof e == "string" || xJ(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -wJ ? "-0" : t;
}
var Md = TJ, NJ = MA, SJ = xA, CJ = Oo, IJ = wA, AJ = R0, DJ = Md;
function kJ(e, t, r) {
  t = NJ(t, e);
  for (var n = -1, o = t.length, i = !1; ++n < o; ) {
    var a = DJ(t[n]);
    if (!(i = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return i || ++n != o ? i : (o = e == null ? 0 : e.length, !!o && AJ(o) && IJ(a, o) && (CJ(e) || SJ(e)));
}
var TA = kJ, EJ = XZ, LJ = TA;
function $J(e, t) {
  return e != null && LJ(e, t, EJ);
}
var zJ = $J;
const OJ = /* @__PURE__ */ QS(zJ), NA = (e) => e && e.__isYupSchema__;
class jJ {
  constructor(t, r) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!OJ(r, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: o,
      otherwise: i
    } = r, a = typeof n == "function" ? n : (...l) => l.every((s) => s === n);
    this.fn = function(...l) {
      let s = l.pop(), c = l.pop(), u = a(...l) ? o : i;
      if (u)
        return typeof u == "function" ? u(c) : c.concat(u.resolve(s));
    };
  }
  resolve(t, r) {
    let n = this.refs.map((i) => i.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)), o = this.fn.apply(t, n.concat(t, r));
    if (o === void 0 || o === t)
      return t;
    if (!NA(o))
      throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
}
function SA(e) {
  return e == null ? [] : [].concat(e);
}
function kg() {
  return kg = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kg.apply(this, arguments);
}
let RJ = /\$\{\s*(\w+)\s*\}/g;
class rn extends Error {
  static formatError(t, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = kg({}, r, {
      path: n
    })), typeof t == "string" ? t.replace(RJ, (o, i) => as(r[i])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, n, o) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = r, this.path = n, this.type = o, this.errors = [], this.inner = [], SA(t).forEach((i) => {
      rn.isError(i) ? (this.errors.push(...i.errors), this.inner = this.inner.concat(i.inner.length ? i.inner : i)) : this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, rn);
  }
}
const _J = (e) => {
  let t = !1;
  return (...r) => {
    t || (t = !0, e(...r));
  };
};
function xy(e, t) {
  let {
    endEarly: r,
    tests: n,
    args: o,
    value: i,
    errors: a,
    sort: l,
    path: s
  } = e, c = _J(t), u = n.length;
  const d = [];
  if (a = a || [], !u)
    return a.length ? c(new rn(a, i, s)) : c(null, i);
  for (let f = 0; f < n.length; f++) {
    const p = n[f];
    p(o, function(g) {
      if (g) {
        if (!rn.isError(g))
          return c(g, i);
        if (r)
          return g.value = i, c(g, i);
        d.push(g);
      }
      if (--u <= 0) {
        if (d.length && (l && d.sort(l), a.length && d.push(...a), a = d), a.length) {
          c(new rn(a, i, s), i);
          return;
        }
        c(null, i);
      }
    });
  }
}
var PJ = Di, BJ = function() {
  try {
    var e = PJ(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), FJ = BJ, wy = FJ;
function UJ(e, t, r) {
  t == "__proto__" && wy ? wy(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var HJ = UJ;
function YJ(e) {
  return function(t, r, n) {
    for (var o = -1, i = Object(t), a = n(t), l = a.length; l--; ) {
      var s = a[e ? l : ++o];
      if (r(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var WJ = YJ, QJ = WJ, VJ = QJ(), ZJ = VJ;
function GJ(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var KJ = GJ, lc = { exports: {} };
function qJ() {
  return !1;
}
var JJ = qJ;
lc.exports;
(function(e, t) {
  var r = io, n = JJ, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, l = a ? r.Buffer : void 0, s = l ? l.isBuffer : void 0, c = s || n;
  e.exports = c;
})(lc, lc.exports);
var CA = lc.exports, XJ = Ds, eX = R0, tX = ks, rX = "[object Arguments]", nX = "[object Array]", oX = "[object Boolean]", iX = "[object Date]", aX = "[object Error]", lX = "[object Function]", sX = "[object Map]", uX = "[object Number]", cX = "[object Object]", dX = "[object RegExp]", fX = "[object Set]", pX = "[object String]", hX = "[object WeakMap]", gX = "[object ArrayBuffer]", mX = "[object DataView]", vX = "[object Float32Array]", bX = "[object Float64Array]", MX = "[object Int8Array]", yX = "[object Int16Array]", xX = "[object Int32Array]", wX = "[object Uint8Array]", TX = "[object Uint8ClampedArray]", NX = "[object Uint16Array]", SX = "[object Uint32Array]", Tt = {};
Tt[vX] = Tt[bX] = Tt[MX] = Tt[yX] = Tt[xX] = Tt[wX] = Tt[TX] = Tt[NX] = Tt[SX] = !0;
Tt[rX] = Tt[nX] = Tt[gX] = Tt[oX] = Tt[mX] = Tt[iX] = Tt[aX] = Tt[lX] = Tt[sX] = Tt[uX] = Tt[cX] = Tt[dX] = Tt[fX] = Tt[pX] = Tt[hX] = !1;
function CX(e) {
  return tX(e) && eX(e.length) && !!Tt[XJ(e)];
}
var IX = CX;
function AX(e) {
  return function(t) {
    return e(t);
  };
}
var DX = AX, sc = { exports: {} };
sc.exports;
(function(e, t) {
  var r = fA, n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, i = o && o.exports === n, a = i && r.process, l = function() {
    try {
      var s = o && o.require && o.require("util").types;
      return s || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(sc, sc.exports);
var kX = sc.exports, EX = IX, LX = DX, Ty = kX, Ny = Ty && Ty.isTypedArray, $X = Ny ? LX(Ny) : EX, IA = $X, zX = KJ, OX = xA, jX = Oo, RX = CA, _X = wA, PX = IA, BX = Object.prototype, FX = BX.hasOwnProperty;
function UX(e, t) {
  var r = jX(e), n = !r && OX(e), o = !r && !n && RX(e), i = !r && !n && !o && PX(e), a = r || n || o || i, l = a ? zX(e.length, String) : [], s = l.length;
  for (var c in e)
    (t || FX.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    _X(c, s))) && l.push(c);
  return l;
}
var HX = UX, YX = Object.prototype;
function WX(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || YX;
  return e === r;
}
var QX = WX;
function VX(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ZX = VX, GX = ZX, KX = GX(Object.keys, Object), qX = KX, JX = QX, XX = qX, eee = Object.prototype, tee = eee.hasOwnProperty;
function ree(e) {
  if (!JX(e))
    return XX(e);
  var t = [];
  for (var r in Object(e))
    tee.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var nee = ree, oee = hA, iee = R0;
function aee(e) {
  return e != null && iee(e.length) && !oee(e);
}
var lee = aee, see = HX, uee = nee, cee = lee;
function dee(e) {
  return cee(e) ? see(e) : uee(e);
}
var _0 = dee, fee = ZJ, pee = _0;
function hee(e, t) {
  return e && fee(e, t, pee);
}
var gee = hee, mee = vd;
function vee() {
  this.__data__ = new mee(), this.size = 0;
}
var bee = vee;
function Mee(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var yee = Mee;
function xee(e) {
  return this.__data__.get(e);
}
var wee = xee;
function Tee(e) {
  return this.__data__.has(e);
}
var Nee = Tee, See = vd, Cee = z0, Iee = O0, Aee = 200;
function Dee(e, t) {
  var r = this.__data__;
  if (r instanceof See) {
    var n = r.__data__;
    if (!Cee || n.length < Aee - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Iee(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var kee = Dee, Eee = vd, Lee = bee, $ee = yee, zee = wee, Oee = Nee, jee = kee;
function Ba(e) {
  var t = this.__data__ = new Eee(e);
  this.size = t.size;
}
Ba.prototype.clear = Lee;
Ba.prototype.delete = $ee;
Ba.prototype.get = zee;
Ba.prototype.has = Oee;
Ba.prototype.set = jee;
var AA = Ba, Ree = "__lodash_hash_undefined__";
function _ee(e) {
  return this.__data__.set(e, Ree), this;
}
var Pee = _ee;
function Bee(e) {
  return this.__data__.has(e);
}
var Fee = Bee, Uee = O0, Hee = Pee, Yee = Fee;
function uc(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Uee(); ++t < r; )
    this.add(e[t]);
}
uc.prototype.add = uc.prototype.push = Hee;
uc.prototype.has = Yee;
var Wee = uc;
function Qee(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Vee = Qee;
function Zee(e, t) {
  return e.has(t);
}
var Gee = Zee, Kee = Wee, qee = Vee, Jee = Gee, Xee = 1, ete = 2;
function tte(e, t, r, n, o, i) {
  var a = r & Xee, l = e.length, s = t.length;
  if (l != s && !(a && s > l))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, p = r & ete ? new Kee() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < l; ) {
    var h = e[d], g = t[d];
    if (n)
      var m = a ? n(g, h, d, t, e, i) : n(h, g, d, e, t, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!qee(t, function(v, M) {
        if (!Jee(p, M) && (h === v || o(h, v, r, n, i)))
          return p.push(M);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === g || o(h, g, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var DA = tte, rte = io, nte = rte.Uint8Array, ote = nte;
function ite(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, o) {
    r[++t] = [o, n];
  }), r;
}
var ate = ite;
function lte(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var ste = lte, Sy = hd, Cy = ote, ute = mA, cte = DA, dte = ate, fte = ste, pte = 1, hte = 2, gte = "[object Boolean]", mte = "[object Date]", vte = "[object Error]", bte = "[object Map]", Mte = "[object Number]", yte = "[object RegExp]", xte = "[object Set]", wte = "[object String]", Tte = "[object Symbol]", Nte = "[object ArrayBuffer]", Ste = "[object DataView]", Iy = Sy ? Sy.prototype : void 0, Sf = Iy ? Iy.valueOf : void 0;
function Cte(e, t, r, n, o, i, a) {
  switch (r) {
    case Ste:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Nte:
      return !(e.byteLength != t.byteLength || !i(new Cy(e), new Cy(t)));
    case gte:
    case mte:
    case Mte:
      return ute(+e, +t);
    case vte:
      return e.name == t.name && e.message == t.message;
    case yte:
    case wte:
      return e == t + "";
    case bte:
      var l = dte;
    case xte:
      var s = n & pte;
      if (l || (l = fte), e.size != t.size && !s)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      n |= hte, a.set(e, t);
      var u = cte(l(e), l(t), n, o, i, a);
      return a.delete(e), u;
    case Tte:
      if (Sf)
        return Sf.call(e) == Sf.call(t);
  }
  return !1;
}
var Ite = Cte;
function Ate(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n; )
    e[o + r] = t[r];
  return e;
}
var Dte = Ate, kte = Dte, Ete = Oo;
function Lte(e, t, r) {
  var n = t(e);
  return Ete(e) ? n : kte(n, r(e));
}
var $te = Lte;
function zte(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (i[o++] = a);
  }
  return i;
}
var Ote = zte;
function jte() {
  return [];
}
var Rte = jte, _te = Ote, Pte = Rte, Bte = Object.prototype, Fte = Bte.propertyIsEnumerable, Ay = Object.getOwnPropertySymbols, Ute = Ay ? function(e) {
  return e == null ? [] : (e = Object(e), _te(Ay(e), function(t) {
    return Fte.call(e, t);
  }));
} : Pte, Hte = Ute, Yte = $te, Wte = Hte, Qte = _0;
function Vte(e) {
  return Yte(e, Qte, Wte);
}
var Zte = Vte, Dy = Zte, Gte = 1, Kte = Object.prototype, qte = Kte.hasOwnProperty;
function Jte(e, t, r, n, o, i) {
  var a = r & Gte, l = Dy(e), s = l.length, c = Dy(t), u = c.length;
  if (s != u && !a)
    return !1;
  for (var d = s; d--; ) {
    var f = l[d];
    if (!(a ? f in t : qte.call(t, f)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var m = a; ++d < s; ) {
    f = l[d];
    var v = e[f], M = t[f];
    if (n)
      var x = a ? n(M, v, f, t, e, i) : n(v, M, f, e, t, i);
    if (!(x === void 0 ? v === M || o(v, M, r, n, i) : x)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var b = e.constructor, T = t.constructor;
    b != T && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof T == "function" && T instanceof T) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var Xte = Jte, ere = Di, tre = io, rre = ere(tre, "DataView"), nre = rre, ore = Di, ire = io, are = ore(ire, "Promise"), lre = are, sre = Di, ure = io, cre = sre(ure, "Set"), dre = cre, fre = Di, pre = io, hre = fre(pre, "WeakMap"), gre = hre, Eg = nre, Lg = z0, $g = lre, zg = dre, Og = gre, kA = Ds, Fa = gA, ky = "[object Map]", mre = "[object Object]", Ey = "[object Promise]", Ly = "[object Set]", $y = "[object WeakMap]", zy = "[object DataView]", vre = Fa(Eg), bre = Fa(Lg), Mre = Fa($g), yre = Fa(zg), xre = Fa(Og), Qo = kA;
(Eg && Qo(new Eg(new ArrayBuffer(1))) != zy || Lg && Qo(new Lg()) != ky || $g && Qo($g.resolve()) != Ey || zg && Qo(new zg()) != Ly || Og && Qo(new Og()) != $y) && (Qo = function(e) {
  var t = kA(e), r = t == mre ? e.constructor : void 0, n = r ? Fa(r) : "";
  if (n)
    switch (n) {
      case vre:
        return zy;
      case bre:
        return ky;
      case Mre:
        return Ey;
      case yre:
        return Ly;
      case xre:
        return $y;
    }
  return t;
});
var wre = Qo, Cf = AA, Tre = DA, Nre = Ite, Sre = Xte, Oy = wre, jy = Oo, Ry = CA, Cre = IA, Ire = 1, _y = "[object Arguments]", Py = "[object Array]", nu = "[object Object]", Are = Object.prototype, By = Are.hasOwnProperty;
function Dre(e, t, r, n, o, i) {
  var a = jy(e), l = jy(t), s = a ? Py : Oy(e), c = l ? Py : Oy(t);
  s = s == _y ? nu : s, c = c == _y ? nu : c;
  var u = s == nu, d = c == nu, f = s == c;
  if (f && Ry(e)) {
    if (!Ry(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new Cf()), a || Cre(e) ? Tre(e, t, r, n, o, i) : Nre(e, t, s, r, n, o, i);
  if (!(r & Ire)) {
    var p = u && By.call(e, "__wrapped__"), h = d && By.call(t, "__wrapped__");
    if (p || h) {
      var g = p ? e.value() : e, m = h ? t.value() : t;
      return i || (i = new Cf()), o(g, m, r, n, i);
    }
  }
  return f ? (i || (i = new Cf()), Sre(e, t, r, n, o, i)) : !1;
}
var kre = Dre, Ere = kre, Fy = ks;
function EA(e, t, r, n, o) {
  return e === t ? !0 : e == null || t == null || !Fy(e) && !Fy(t) ? e !== e && t !== t : Ere(e, t, r, n, EA, o);
}
var LA = EA, Lre = AA, $re = LA, zre = 1, Ore = 2;
function jre(e, t, r, n) {
  var o = r.length, i = o, a = !n;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var l = r[o];
    if (a && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    l = r[o];
    var s = l[0], c = e[s], u = l[1];
    if (a && l[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var d = new Lre();
      if (n)
        var f = n(c, u, s, e, t, d);
      if (!(f === void 0 ? $re(u, c, zre | Ore, n, d) : f))
        return !1;
    }
  }
  return !0;
}
var Rre = jre, _re = $0;
function Pre(e) {
  return e === e && !_re(e);
}
var $A = Pre, Bre = $A, Fre = _0;
function Ure(e) {
  for (var t = Fre(e), r = t.length; r--; ) {
    var n = t[r], o = e[n];
    t[r] = [n, o, Bre(o)];
  }
  return t;
}
var Hre = Ure;
function Yre(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var zA = Yre, Wre = Rre, Qre = Hre, Vre = zA;
function Zre(e) {
  var t = Qre(e);
  return t.length == 1 && t[0][2] ? Vre(t[0][0], t[0][1]) : function(r) {
    return r === e || Wre(r, e, t);
  };
}
var Gre = Zre, Kre = MA, qre = Md;
function Jre(e, t) {
  t = Kre(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[qre(t[r++])];
  return r && r == n ? e : void 0;
}
var OA = Jre, Xre = OA;
function ene(e, t, r) {
  var n = e == null ? void 0 : Xre(e, t);
  return n === void 0 ? r : n;
}
var tne = ene;
function rne(e, t) {
  return e != null && t in Object(e);
}
var nne = rne, one = nne, ine = TA;
function ane(e, t) {
  return e != null && ine(e, t, one);
}
var lne = ane, sne = LA, une = tne, cne = lne, dne = L0, fne = $A, pne = zA, hne = Md, gne = 1, mne = 2;
function vne(e, t) {
  return dne(e) && fne(t) ? pne(hne(e), t) : function(r) {
    var n = une(r, e);
    return n === void 0 && n === t ? cne(r, e) : sne(t, n, gne | mne);
  };
}
var bne = vne;
function Mne(e) {
  return e;
}
var yne = Mne;
function xne(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var wne = xne, Tne = OA;
function Nne(e) {
  return function(t) {
    return Tne(t, e);
  };
}
var Sne = Nne, Cne = wne, Ine = Sne, Ane = L0, Dne = Md;
function kne(e) {
  return Ane(e) ? Cne(Dne(e)) : Ine(e);
}
var Ene = kne, Lne = Gre, $ne = bne, zne = yne, One = Oo, jne = Ene;
function Rne(e) {
  return typeof e == "function" ? e : e == null ? zne : typeof e == "object" ? One(e) ? $ne(e[0], e[1]) : Lne(e) : jne(e);
}
var _ne = Rne, Pne = HJ, Bne = gee, Fne = _ne;
function Une(e, t) {
  var r = {};
  return t = Fne(t), Bne(e, function(n, o, i) {
    Pne(r, o, t(n, o, i));
  }), r;
}
var Hne = Une;
const Yne = /* @__PURE__ */ QS(Hne);
function ki(e) {
  this._maxSize = e, this.clear();
}
ki.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
ki.prototype.get = function(e) {
  return this._values[e];
};
ki.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var Wne = /[^.^\]^[]+|(?=\[\]|\.\.)/g, jA = /^\d+$/, Qne = /^\d/, Vne = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Zne = /^\s*(['"]?)(.*?)(\1)\s*$/, P0 = 512, Uy = new ki(P0), Hy = new ki(P0), Yy = new ki(P0), RA = {
  Cache: ki,
  split: jg,
  normalizePath: If,
  setter: function(e) {
    var t = If(e);
    return Hy.get(e) || Hy.set(e, function(n, o) {
      for (var i = 0, a = t.length, l = n; i < a - 1; ) {
        var s = t[i];
        if (s === "__proto__" || s === "constructor" || s === "prototype")
          return n;
        l = l[t[i++]];
      }
      l[t[i]] = o;
    });
  },
  getter: function(e, t) {
    var r = If(e);
    return Yy.get(e) || Yy.set(e, function(o) {
      for (var i = 0, a = r.length; i < a; )
        if (o != null || !t)
          o = o[r[i++]];
        else
          return;
      return o;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (B0(r) || jA.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    Gne(Array.isArray(e) ? e : jg(e), t, r);
  }
};
function If(e) {
  return Uy.get(e) || Uy.set(
    e,
    jg(e).map(function(t) {
      return t.replace(Zne, "$2");
    })
  );
}
function jg(e) {
  return e.match(Wne) || [""];
}
function Gne(e, t, r) {
  var n = e.length, o, i, a, l;
  for (i = 0; i < n; i++)
    o = e[i], o && (Jne(o) && (o = '"' + o + '"'), l = B0(o), a = !l && /^\d+$/.test(o), t.call(r, o, l, a, i, e));
}
function B0(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function Kne(e) {
  return e.match(Qne) && !e.match(jA);
}
function qne(e) {
  return Vne.test(e);
}
function Jne(e) {
  return !B0(e) && (Kne(e) || qne(e));
}
const ou = {
  context: "$",
  value: "."
};
class li {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === ou.context, this.isValue = this.key[0] === ou.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? ou.context : this.isValue ? ou.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && RA.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, n) {
    let o = this.isContext ? n : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
li.prototype.__isYupRef = !0;
function cc() {
  return cc = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cc.apply(this, arguments);
}
function Xne(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function iu(e) {
  function t(r, n) {
    let {
      value: o,
      path: i = "",
      label: a,
      options: l,
      originalValue: s,
      sync: c
    } = r, u = Xne(r, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: d,
      test: f,
      params: p,
      message: h
    } = e;
    let {
      parent: g,
      context: m
    } = l;
    function v(w) {
      return li.isRef(w) ? w.getValue(o, g, m) : w;
    }
    function M(w = {}) {
      const y = Yne(cc({
        value: o,
        originalValue: s,
        label: a,
        path: w.path || i
      }, p, w.params), v), I = new rn(rn.formatError(w.message || h, y), o, y.path, w.type || d);
      return I.params = y, I;
    }
    let x = cc({
      path: i,
      parent: g,
      type: d,
      createError: M,
      resolve: v,
      options: l,
      originalValue: s
    }, u);
    if (!c) {
      try {
        Promise.resolve(f.call(x, o, x)).then((w) => {
          rn.isError(w) ? n(w) : w ? n(null, w) : n(M());
        }).catch(n);
      } catch (w) {
        n(w);
      }
      return;
    }
    let b;
    try {
      var T;
      if (b = f.call(x, o, x), typeof ((T = b) == null ? void 0 : T.then) == "function")
        throw new Error(`Validation test of type: "${x.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (w) {
      n(w);
      return;
    }
    rn.isError(b) ? n(b) : b ? n(null, b) : n(M());
  }
  return t.OPTIONS = e, t;
}
let eoe = (e) => e.substr(0, e.length - 1).substr(1);
function toe(e, t, r, n = r) {
  let o, i, a;
  return t ? (RA.forEach(t, (l, s, c) => {
    let u = s ? eoe(l) : l;
    if (e = e.resolve({
      context: n,
      parent: o,
      value: r
    }), e.innerType) {
      let d = c ? parseInt(u, 10) : 0;
      if (r && d >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${l}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[d], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[u])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${a} which is a type: "${e._type}")`);
      o = r, r = r && r[u], e = e.fields[u];
    }
    i = u, a = s ? "[" + l + "]" : "." + l;
  }), {
    schema: e,
    parent: o,
    parentPath: i
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
class dc {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const r of this.list)
      t.push(r);
    for (const [, r] of this.refs)
      t.push(r.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((r, n) => r.concat(li.isRef(n) ? t(n) : n), []);
  }
  add(t) {
    li.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    li.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new dc();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, r) {
    const n = this.clone();
    return t.list.forEach((o) => n.add(o)), t.refs.forEach((o) => n.add(o)), r.list.forEach((o) => n.delete(o)), r.refs.forEach((o) => n.delete(o)), n;
  }
}
function qr() {
  return qr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qr.apply(this, arguments);
}
class Mn {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new dc(), this._blacklist = new dc(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Wo.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = qr({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeError = this._typeError, r._whitelistError = this._whitelistError, r._blacklistError = this._blacklistError, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.exclusiveTests = qr({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Ag(qr({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = r, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, n = t.clone();
    const o = qr({}, r.spec, n.spec);
    return n.spec = o, n._typeError || (n._typeError = r._typeError), n._whitelistError || (n._whitelistError = r._whitelistError), n._blacklistError || (n._blacklistError = r._blacklistError), n._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((i) => {
      t.tests.forEach((a) => {
        i.test(a.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((o, i) => i.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, r = {}) {
    let n = this.resolve(qr({
      value: t
    }, r)), o = n._cast(t, r);
    if (t !== void 0 && r.assert !== !1 && n.isType(o) !== !0) {
      let i = as(t), a = as(o);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n._type}". 

attempted value: ${i} 
` + (a !== i ? `result of cast: ${a}` : ""));
    }
    return o;
  }
  _cast(t, r) {
    let n = t === void 0 ? t : this.transforms.reduce((o, i) => i.call(this, o, t, this), t);
    return n === void 0 && (n = this.getDefault()), n;
  }
  _validate(t, r = {}, n) {
    let {
      sync: o,
      path: i,
      from: a = [],
      originalValue: l = t,
      strict: s = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = r, u = t;
    s || (u = this._cast(u, qr({
      assert: !1
    }, r)));
    let d = {
      value: u,
      path: i,
      options: r,
      originalValue: l,
      schema: this,
      label: this.spec.label,
      sync: o,
      from: a
    }, f = [];
    this._typeError && f.push(this._typeError);
    let p = [];
    this._whitelistError && p.push(this._whitelistError), this._blacklistError && p.push(this._blacklistError), xy({
      args: d,
      value: u,
      path: i,
      sync: o,
      tests: f,
      endEarly: c
    }, (h) => {
      if (h)
        return void n(h, u);
      xy({
        tests: this.tests.concat(p),
        args: d,
        path: i,
        sync: o,
        value: u,
        endEarly: c
      }, n);
    });
  }
  validate(t, r, n) {
    let o = this.resolve(qr({}, r, {
      value: t
    }));
    return typeof n == "function" ? o._validate(t, r, n) : new Promise((i, a) => o._validate(t, r, (l, s) => {
      l ? a(l) : i(s);
    }));
  }
  validateSync(t, r) {
    let n = this.resolve(qr({}, r, {
      value: t
    })), o;
    return n._validate(t, qr({}, r, {
      sync: !0
    }), (i, a) => {
      if (i)
        throw i;
      o = a;
    }), o;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (n) => {
      if (rn.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (n) {
      if (rn.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : Ag(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let r = this.clone();
    return r.spec.strict = t, r;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Wo.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(r) {
        return r !== void 0;
      }
    });
  }
  required(t = Wo.required) {
    return this.clone({
      presence: "required"
    }).withMutation((r) => r.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(n) {
        return this.schema._isPresent(n);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Wo.default), typeof r.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), o = iu(r), i = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((a) => !(a.OPTIONS.name === r.name && (i || a.OPTIONS.test === o.OPTIONS.test))), n.tests.push(o), n;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let n = this.clone(), o = SA(t).map((i) => new li(i));
    return o.forEach((i) => {
      i.isSibling && n.deps.push(i.key);
    }), n.conditions.push(new jJ(o, r)), n;
  }
  typeError(t) {
    let r = this.clone();
    return r._typeError = iu({
      message: t,
      name: "typeError",
      test(n) {
        return n !== void 0 && !this.schema.isType(n) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), r;
  }
  oneOf(t, r = Wo.oneOf) {
    let n = this.clone();
    return t.forEach((o) => {
      n._whitelist.add(o), n._blacklist.delete(o);
    }), n._whitelistError = iu({
      message: r,
      name: "oneOf",
      test(o) {
        if (o === void 0)
          return !0;
        let i = this.schema._whitelist, a = i.resolveAll(this.resolve);
        return a.includes(o) ? !0 : this.createError({
          params: {
            values: i.toArray().join(", "),
            resolved: a
          }
        });
      }
    }), n;
  }
  notOneOf(t, r = Wo.notOneOf) {
    let n = this.clone();
    return t.forEach((o) => {
      n._blacklist.add(o), n._whitelist.delete(o);
    }), n._blacklistError = iu({
      message: r,
      name: "notOneOf",
      test(o) {
        let i = this.schema._blacklist, a = i.resolveAll(this.resolve);
        return a.includes(o) ? this.createError({
          params: {
            values: i.toArray().join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  describe() {
    const t = this.clone(), {
      label: r,
      meta: n
    } = t.spec;
    return {
      meta: n,
      label: r,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((i) => ({
        name: i.OPTIONS.name,
        params: i.OPTIONS.params
      })).filter((i, a, l) => l.findIndex((s) => s.name === i.name) === a)
    };
  }
}
Mn.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  Mn.prototype[`${e}At`] = function(t, r, n = {}) {
    const {
      parent: o,
      parentPath: i,
      schema: a
    } = toe(this, t, r, n.context);
    return a[e](o && o[i], qr({}, n, {
      parent: o,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  Mn.prototype[e] = Mn.prototype.oneOf;
for (const e of ["not", "nope"])
  Mn.prototype[e] = Mn.prototype.notOneOf;
Mn.prototype.optional = Mn.prototype.notRequired;
const Gt = (e) => e == null;
let roe = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, noe = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, ooe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, ioe = (e) => Gt(e) || e === e.trim(), aoe = {}.toString();
function Gn() {
  return new _A();
}
class _A extends Mn {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t))
          return t;
        const r = t != null && t.toString ? t.toString() : t;
        return r === aoe ? t : r;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, r = pn.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(n) {
        return Gt(n) || n.length === this.resolve(t);
      }
    });
  }
  min(t, r = pn.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return Gt(n) || n.length >= this.resolve(t);
      }
    });
  }
  max(t, r = pn.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      test(n) {
        return Gt(n) || n.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let n = !1, o, i;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: o,
      name: i
    } = r : o = r), this.test({
      name: i || "matches",
      message: o || pn.matches,
      params: {
        regex: t
      },
      test: (a) => Gt(a) || a === "" && n || a.search(t) !== -1
    });
  }
  email(t = pn.email) {
    return this.matches(roe, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = pn.url) {
    return this.matches(noe, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = pn.uuid) {
    return this.matches(ooe, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = pn.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: ioe
    });
  }
  lowercase(t = pn.lowercase) {
    return this.transform((r) => Gt(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => Gt(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = pn.uppercase) {
    return this.transform((r) => Gt(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (r) => Gt(r) || r === r.toUpperCase()
    });
  }
}
Gn.prototype = _A.prototype;
let loe = (e) => e != +e;
function si() {
  return new PA();
}
class PA extends Mn {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let r = t;
        if (typeof r == "string") {
          if (r = r.replace(/\s/g, ""), r === "")
            return NaN;
          r = +r;
        }
        return this.isType(r) ? r : parseFloat(r);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !loe(t);
  }
  min(t, r = po.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return Gt(n) || n >= this.resolve(t);
      }
    });
  }
  max(t, r = po.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(n) {
        return Gt(n) || n <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = po.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(n) {
        return Gt(n) || n < this.resolve(t);
      }
    });
  }
  moreThan(t, r = po.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(n) {
        return Gt(n) || n > this.resolve(t);
      }
    });
  }
  positive(t = po.positive) {
    return this.moreThan(0, t);
  }
  negative(t = po.negative) {
    return this.lessThan(0, t);
  }
  integer(t = po.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (r) => Gt(r) || Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => Gt(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let n = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc")
      return this.truncate();
    if (n.indexOf(t.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform((o) => Gt(o) ? o : Math[t](o));
  }
}
si.prototype = PA.prototype;
var soe = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function uoe(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], r = 0, n, o;
  if (o = soe.exec(e)) {
    for (var i = 0, a; a = t[i]; ++i)
      o[a] = +o[a] || 0;
    o[2] = (+o[2] || 1) - 1, o[3] = +o[3] || 1, o[7] = o[7] ? String(o[7]).substr(0, 3) : 0, (o[8] === void 0 || o[8] === "") && (o[9] === void 0 || o[9] === "") ? n = +new Date(o[1], o[2], o[3], o[4], o[5], o[6], o[7]) : (o[8] !== "Z" && o[9] !== void 0 && (r = o[10] * 60 + o[11], o[9] === "+" && (r = 0 - r)), n = Date.UTC(o[1], o[2], o[3], o[4], o[5] + r, o[6], o[7]));
  } else
    n = Date.parse ? Date.parse(e) : NaN;
  return n;
}
let BA = /* @__PURE__ */ new Date(""), coe = (e) => Object.prototype.toString.call(e) === "[object Date]";
class doe extends Mn {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = uoe(t), isNaN(t) ? BA : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return coe(t) && !isNaN(t.getTime());
  }
  prepareParam(t, r) {
    let n;
    if (li.isRef(t))
      n = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o))
        throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = o;
    }
    return n;
  }
  min(t, r = Dg.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(o) {
        return Gt(o) || o >= this.resolve(n);
      }
    });
  }
  max(t, r = Dg.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(o) {
        return Gt(o) || o <= this.resolve(n);
      }
    });
  }
}
doe.INVALID_DATE = BA;
var FA = { exports: {} };
FA.exports = function(e) {
  return UA(foe(e), e);
};
FA.exports.array = UA;
function UA(e, t) {
  var r = e.length, n = new Array(r), o = {}, i = r, a = poe(t), l = hoe(e);
  for (t.forEach(function(c) {
    if (!l.has(c[0]) || !l.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    o[i] || s(e[i], i, /* @__PURE__ */ new Set());
  return n;
  function s(c, u, d) {
    if (d.has(c)) {
      var f;
      try {
        f = ", node was:" + JSON.stringify(c);
      } catch {
        f = "";
      }
      throw new Error("Cyclic dependency" + f);
    }
    if (!l.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!o[u]) {
      o[u] = !0;
      var p = a.get(c) || /* @__PURE__ */ new Set();
      if (p = Array.from(p), u = p.length) {
        d.add(c);
        do {
          var h = p[--u];
          s(h, l.get(h), d);
        } while (u);
        d.delete(c);
      }
      n[--r] = c;
    }
  }
}
function foe(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, n = e.length; r < n; r++) {
    var o = e[r];
    t.add(o[0]), t.add(o[1]);
  }
  return Array.from(t);
}
function poe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++) {
    var o = e[r];
    t.has(o[0]) || t.set(o[0], /* @__PURE__ */ new Set()), t.has(o[1]) || t.set(o[1], /* @__PURE__ */ new Set()), t.get(o[0]).add(o[1]);
  }
  return t;
}
function hoe(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++)
    t.set(e[r], r);
  return t;
}
function HA(e, t, r) {
  if (!e || !NA(e.prototype))
    throw new TypeError("You must provide a yup schema constructor function");
  if (typeof t != "string")
    throw new TypeError("A Method name must be provided");
  if (typeof r != "function")
    throw new TypeError("Method function must be provided");
  e.prototype[t] = r;
}
const YA = (e) => (x4("data-v-ca5eea0b"), e = e(), w4(), e), goe = { class: "dimensions" }, moe = /* @__PURE__ */ YA(() => /* @__PURE__ */ de("span", { class: "suffix" }, "px", -1)), voe = /* @__PURE__ */ YA(() => /* @__PURE__ */ de("span", { class: "suffix" }, "px", -1)), boe = /* @__PURE__ */ Z({
  __name: "ImagePicker",
  props: {
    modalType: String,
    showModal: Boolean,
    initialValues: Object,
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedImage: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: [
    "onSave",
    "onModalClose",
    "onRemove",
    "triggerExternalEmbed"
  ],
  setup(e, { emit: t }) {
    const r = e, n = De("locale") ?? ht[r.language], o = t, i = [
      {
        value: "_self",
        label: n.imageEmbed.labels.target_self
      },
      {
        value: "_blank",
        label: n.imageEmbed.labels.target_blank
      }
    ], a = {
      src: void 0,
      width: void 0,
      height: void 0,
      alt: void 0,
      "data-image-link": void 0,
      "data-image-link-target": "_self"
    }, l = L(null), s = L(
      r.initialValues ? r.initialValues : Object.create(a)
    ), c = {
      src: {
        required: !0,
        trigger: ["change"],
        message: n.imageEmbed.validations.url,
        validator: (h, g) => g ? Gn().test(
          "customOrWebURL",
          n.common.invalidURL,
          ig
        ).isValidSync(g) : !0
      },
      width: {
        type: "number",
        required: !1,
        trigger: ["change"],
        message: n.imageEmbed.validations.width,
        validator: (h, g) => g ? si().validate(g) : !0
      },
      height: {
        type: "number",
        required: !1,
        trigger: ["change"],
        message: n.imageEmbed.validations.height,
        validator: (h, g) => g ? si().validate(g) : !0
      },
      alt: {
        required: !0,
        message: n.imageEmbed.validations.alt,
        trigger: ["change"],
        validator: (h, g) => Gn().trim().required().validate(g)
      },
      "data-image-link": {
        required: !1,
        trigger: ["change"],
        message: n.imageEmbed.validations.imageLink,
        validator: (h, g) => g ? Gn().test(
          "customOrWebURL",
          n.common.invalidURL,
          ig
        ).isValidSync(g) : !0
      },
      "data-image-link-target": {
        required: !1,
        trigger: ["change"],
        message: n.common.invalidOption,
        validator: (h, g) => g ? Gn().oneOf(["_self", "_blank"]).validate(g) : !0
      }
    }, u = () => {
      s.value = Object.create(a);
    }, d = () => {
      var h;
      (h = l.value) == null || h.getForm().validate().then(() => {
        const g = {
          ...s.value,
          width: s.value.width ? Number(s.value.width) : null,
          height: s.value.height ? Number(s.value.height) : null
        };
        o("onSave", r.modalType, g), u();
      }).catch();
    }, f = () => {
      u(), o("onModalClose", r.modalType);
    }, p = () => {
      u(), o("onModalClose", r.modalType), o("onRemove");
    };
    return at(
      () => r.externalEmbeddedImage,
      (h) => {
        s.value.src = h;
      }
    ), (h, g) => (_(), se(N(Kc), {
      id: "editor_image-picker",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: Q(() => [
        B(N(Jc), {
          id: "warning-confirmation",
          type: "warning",
          title: e.modalType === "EDIT" ? N(n).imageEmbed.editTitle : N(n).imageEmbed.embedTitle,
          onClose: f
        }, null, 8, ["title"])
      ]),
      footer: Q(() => [
        B(N(qc), {
          id: "editor__image-picker-footer",
          "positive-text": r.modalType === "EDIT" ? N(n).common.update : N(n).common.save,
          "negative-text": N(n).common.cancel,
          disabled: !s.value.src,
          onPositiveClick: d,
          onNegativeClick: f
        }, {
          actionLeft: Q(() => [
            r.modalType === "EDIT" ? (_(), se(N(Lr), {
              key: 0,
              id: "editor__image-picker--remove",
              type: "error",
              onClick: p,
              size: "small"
            }, {
              default: Q(() => [
                Qt(kt(N(n).common.remove), 1)
              ]),
              _: 1
            })) : Oe("", !0)
          ]),
          _: 1
        }, 8, ["positive-text", "negative-text", "disabled"])
      ]),
      default: Q(() => [
        B(N(Pm), null, {
          default: Q(() => [
            B(N(Om), {
              id: "image-picker_form",
              ref_key: "formRef",
              ref: l,
              model: s.value,
              rules: c
            }, {
              default: Q(() => [
                B(N(Rr), {
                  label: N(n).imageEmbed.labels.url,
                  path: "src"
                }, {
                  default: Q(() => [
                    B(N(fw), null, {
                      default: Q(() => [
                        B(N(ni), {
                          id: "editor_image-picker-url",
                          modelValue: s.value.src,
                          "onUpdate:modelValue": g[0] || (g[0] = (m) => s.value.src = m),
                          placeholder: N(n).imageEmbed.placeholders.url,
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"]),
                        e.enableExternalEmbed ? (_(), se(N(Lr), {
                          key: 0,
                          id: "editor_image-picker-url-trigger",
                          onClick: g[1] || (g[1] = (m) => o("triggerExternalEmbed", !0))
                        }, {
                          default: Q(() => [
                            Qt(kt(e.externalEmbedText ?? N(n).common.externalEmbed), 1)
                          ]),
                          _: 1
                        })) : Oe("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                de("div", goe, [
                  B(N(Rr), {
                    label: N(n).imageEmbed.labels.width,
                    path: "width"
                  }, {
                    default: Q(() => [
                      B(N(Yu), {
                        id: "editor_image-picker-width",
                        modelValue: s.value.width,
                        "onUpdate:modelValue": g[2] || (g[2] = (m) => s.value.width = m),
                        size: "large",
                        min: 0,
                        "show-button": !1,
                        style: { width: "250px" },
                        placeholder: N(n).videoEmbed.width
                      }, {
                        suffix: Q(() => [
                          moe
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  B(N(Rr), {
                    label: N(n).imageEmbed.labels.height,
                    path: "height"
                  }, {
                    default: Q(() => [
                      B(N(Yu), {
                        id: "editor_image-picker-height",
                        modelValue: s.value.height,
                        "onUpdate:modelValue": g[3] || (g[3] = (m) => s.value.height = m),
                        size: "large",
                        min: 0,
                        "show-button": !1,
                        style: { width: "250px" },
                        placeholder: N(n).videoEmbed.height
                      }, {
                        suffix: Q(() => [
                          voe
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                B(N(Rr), {
                  label: N(n).imageEmbed.labels.alt,
                  path: "alt"
                }, {
                  default: Q(() => [
                    B(N(ni), {
                      id: "editor_image-picker-alt",
                      modelValue: s.value.alt,
                      "onUpdate:modelValue": g[4] || (g[4] = (m) => s.value.alt = m),
                      placeholder: N(n).videoEmbed.alt,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                B(N(Rr), {
                  label: N(n).imageEmbed.labels.imageLink,
                  path: "data-image-link"
                }, {
                  default: Q(() => [
                    B(N(ni), {
                      id: "editor_image-picker-link",
                      value: s.value["data-image-link"],
                      "onUpdate:value": g[5] || (g[5] = (m) => s.value["data-image-link"] = m),
                      placeholder: N(n).videoEmbed.imageLink,
                      clearable: ""
                    }, null, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                B(N(Rr), {
                  label: N(n).imageEmbed.labels.target,
                  path: "data-image-link-target"
                }, {
                  default: Q(() => [
                    B(N(Da), {
                      id: "editor_link-embed-target",
                      value: s.value["data-image-link-target"],
                      "onUpdate:value": g[6] || (g[6] = (m) => s.value["data-image-link-target"] = m),
                      disabled: !s.value["data-image-link"],
                      options: i,
                      size: "large"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const F0 = /* @__PURE__ */ Yr(boe, [["__scopeId", "data-v-ca5eea0b"]]), Moe = { key: 0 }, yoe = { class: "flex_container float-menu" }, xoe = ["src"], woe = ["src"], Toe = ["src"], Noe = ["src"], Soe = ["src"], Coe = /* @__PURE__ */ Z({
  __name: "ImageMenu",
  props: {
    editor: { type: Object },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!1), { onImageAdd: o, onRemove: i, imageValues: a } = OI(t.editor), l = (u, d) => {
      c(u === "WRAP" ? { "data-wrap": d, "data-alignment": void 0 } : { "data-alignment": d, "data-wrap": void 0 });
    }, s = (u, d) => {
      n.value = !1, o(u, d);
    }, c = (u) => {
      var d;
      if (!a.value)
        return !1;
      (d = t == null ? void 0 : t.editor) == null || d.chain().focus().setImage({
        ...a.value,
        ...u
      }).run();
    };
    return (u, d) => (_(), be(qt, null, [
      e.editor ? (_(), be("div", Moe, [
        e.editor ? on((_(), se(N(iA), {
          key: 0,
          editor: e.editor,
          "tippy-options": { duration: 100 }
        }, {
          default: Q(() => {
            var f, p, h, g, m, v;
            return [
              de("div", yoe, [
                B(Je, {
                  id: N(Ue).floatingMenuImageAlignLeft,
                  active: (f = e.editor) == null ? void 0 : f.isActive({ "data-alignment": "left" }),
                  onOnClick: d[0] || (d[0] = (M) => l("ALIGN", "left")),
                  "tooltip-label": N(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    N(r).common.left
                  )
                }, {
                  default: Q(() => [
                    de("img", {
                      src: N(lA),
                      class: "toolbar-button__icon"
                    }, null, 8, xoe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                B(Je, {
                  id: N(Ue).floatingMenuImageAlignCenter,
                  active: (p = e.editor) == null ? void 0 : p.isActive({ "data-alignment": "center" }),
                  onOnClick: d[1] || (d[1] = (M) => l("ALIGN", "center")),
                  "tooltip-label": N(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    N(r).common.center
                  )
                }, {
                  default: Q(() => [
                    de("img", {
                      src: N(aA),
                      class: "toolbar-button__icon"
                    }, null, 8, woe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                B(Je, {
                  id: N(Ue).floatingMenuImageAlignRight,
                  active: (h = e.editor) == null ? void 0 : h.isActive({ "data-alignment": "right" }),
                  onOnClick: d[2] || (d[2] = (M) => l("ALIGN", "right")),
                  "tooltip-label": N(r).imageEmbed.alignmentTooltip.replace(
                    "{align}",
                    N(r).common.right
                  )
                }, {
                  default: Q(() => [
                    de("img", {
                      src: N(sA),
                      class: "toolbar-button__icon"
                    }, null, 8, Toe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                B(Je, {
                  id: N(Ue).floatingMenuImageJustifyLeft,
                  active: (g = e.editor) == null ? void 0 : g.isActive({ "data-wrap": "left" }),
                  onOnClick: d[3] || (d[3] = (M) => l("WRAP", "left")),
                  "tooltip-label": N(r).imageEmbed.wrapTooltip.replace(
                    "{align}",
                    N(r).common.right
                  )
                }, {
                  default: Q(() => [
                    de("img", {
                      src: N(uA),
                      class: "toolbar-button__icon"
                    }, null, 8, Noe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                B(Je, {
                  id: N(Ue).floatingMenuImageAlignRight,
                  active: (m = e.editor) == null ? void 0 : m.isActive({ "data-wrap": "right" }),
                  onOnClick: d[4] || (d[4] = (M) => l("WRAP", "right")),
                  "tooltip-label": N(r).imageEmbed.wrapTooltip.replace("{align}", N(r).common.left)
                }, {
                  default: Q(() => [
                    de("img", {
                      src: N(cA),
                      class: "toolbar-button__icon"
                    }, null, 8, Soe)
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"]),
                B(Je, {
                  id: N(Ue).floatingMenuImageShowPicker,
                  active: (v = e.editor) == null ? void 0 : v.isActive("Image"),
                  onOnClick: d[5] || (d[5] = (M) => n.value = !0),
                  "tooltip-label": N(r).imageEmbed.editTitle
                }, {
                  default: Q(() => [
                    B(N(zC), { class: "toolbar-button__icon" })
                  ]),
                  _: 1
                }, 8, ["id", "active", "tooltip-label"])
              ])
            ];
          }),
          _: 1
        }, 8, ["editor"])), [
          [ci, !N(Mr)(N(a)) && !n.value]
        ]) : Oe("", !0)
      ])) : Oe("", !0),
      n.value ? (_(), se(F0, {
        key: 1,
        "show-modal": n.value,
        "initial-values": N(a),
        "modal-type": "EDIT",
        onOnModalClose: d[6] || (d[6] = (f) => n.value = !1),
        onOnSave: s,
        onOnRemove: N(i)
      }, null, 8, ["show-modal", "initial-values", "onOnRemove"])) : Oe("", !0)
    ], 64));
  }
});
const WA = /* @__PURE__ */ Yr(Coe, [["__scopeId", "data-v-adf9c26d"]]), Ioe = {
  name: "RTEControlEmbedImage",
  inheritAttrs: !1,
  components: { ImagePicker: F0, ImageMenu: WA, ToolbarButton: Je }
}, wl = /* @__PURE__ */ Z({
  ...Ioe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    enableFloatingMenu: {
      type: Boolean,
      default: !0
    },
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedImage: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String,
      default: null
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: ["triggerExternalEmbed"],
  setup(e, { emit: t }) {
    const r = e, n = De("locale") ?? ht[r.language], o = t, i = L(!1), { onImageAdd: a, onRemove: l, imageValues: s } = OI(r.editor), c = (d, f) => {
      i.value = !1, a(d, f);
    }, u = (d) => {
      o("triggerExternalEmbed", d);
    };
    return (d, f) => {
      var p, h;
      return _(), be(qt, null, [
        e.enableFloatingMenu ? (_(), se(WA, {
          key: 0,
          editor: e.editor
        }, null, 8, ["editor"])) : Oe("", !0),
        B(Je, {
          id: N(Ue).toolbarButtonShowLinkEmbed,
          disabled: (p = e.editor) == null ? void 0 : p.isActive("link"),
          active: (h = e.editor) == null ? void 0 : h.isActive("image"),
          onOnClick: f[0] || (f[0] = (g) => i.value = !0),
          "tooltip-label": e.tooltipLabel ?? N(n).imageEmbed.tooltip,
          "tooltip-position": e.tooltipPosition
        }, {
          default: Q(() => [
            B(N(zC), { class: "toolbar-button__icon" })
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        i.value ? (_(), se(F0, {
          key: 1,
          "show-modal": i.value,
          "initial-values": N(s),
          "enable-external-embed": e.enableExternalEmbed,
          "external-embedded-image": e.externalEmbeddedImage,
          "modal-container": e.modalContainer,
          "modal-type": N(Mr)(N(s)) ? "CREATE" : "EDIT",
          "external-embed-text": e.externalEmbedText,
          onOnSave: c,
          onOnModalClose: f[1] || (f[1] = (g) => i.value = !1),
          onOnRemove: N(l),
          onTriggerExternalEmbed: u
        }, null, 8, ["show-modal", "initial-values", "enable-external-embed", "external-embedded-image", "modal-container", "modal-type", "external-embed-text", "onOnRemove"])) : Oe("", !0)
      ], 64);
    };
  }
});
wl.install = (e) => {
  e.component(wl.name, wl);
};
const QA = "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTAgNi42NjY2N0wxMy4wMzUyIDUuMTQ5MDdDMTMuNDc4NSA0LjkyNzQ0IDE0IDUuMjQ5NzcgMTQgNS43NDUzNlYxMC4yNTQ2QzE0IDEwLjc1MDIgMTMuNDc4NSAxMS4wNzI2IDEzLjAzNTIgMTAuODUwOUwxMCA5LjMzMzMzTTMuMzMzMzMgMTJIOC42NjY2N0M5LjQwMzA1IDEyIDEwIDExLjQwMyAxMCAxMC42NjY3VjUuMzMzMzNDMTAgNC41OTY5NSA5LjQwMzA1IDQgOC42NjY2NyA0SDMuMzMzMzNDMi41OTY5NSA0IDIgNC41OTY5NSAyIDUuMzMzMzNWMTAuNjY2N0MyIDExLjQwMyAyLjU5Njk1IDEyIDMuMzMzMzMgMTJaIiAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
var Ar = /* @__PURE__ */ ((e) => (e.YOUTUBE = "YOUTUBE", e.NATIVE = "NATIVE", e))(Ar || {});
const U0 = (e) => {
  if (!(e == null || e === "100%"))
    return e.includes("px") ? Number(e.trim().replace("px", "")) : Number(e);
}, H0 = (e) => {
  if (!(e == null || e === "auto"))
    return e.includes("px") ? Number(e.trim().replace("px", "")) : Number(e);
}, Y0 = (e) => {
  switch (e) {
    case "right":
      return "margin-right: 0; margin-left: auto; display:block;";
    case "center":
      return "margin: auto; display:block;";
    case "left":
    default:
      return "margin-left: 0; margin-right: auto; display:block;";
  }
}, W0 = (e) => {
  switch (e) {
    case "right":
      return "float: right; margin-left: 1rem;";
    case "left":
      return "float: left; margin-right: 1rem;";
    default:
      return "";
  }
}, Aoe = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(.+)?$/, Doe = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(.+)?$/g, Rg = (e) => e.match(Aoe), Wy = (e) => e ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/", VA = (e) => {
  const { url: t, controls: r, nocookie: n, startAt: o } = e;
  if (t.includes("/embed/"))
    return t;
  if (t.includes("youtu.be")) {
    const c = t.split("/").pop();
    return c ? `${Wy(n)}${c}` : null;
  }
  const a = /v=([-\w]+)/gm.exec(t);
  if (!a || !a[1])
    return null;
  let l = `${Wy(n)}${a[1]}`;
  const s = [];
  return r || s.push("controls=0"), o && s.push(`start=${o}`), s.length && (l += `?${s.join("&")}`), l;
}, koe = () => {
  const e = document.querySelectorAll("[data-video-embed]");
  if (e.length)
    for (let t = 0; t < e.length; t++) {
      const r = e[t];
      r.addEventListener("play", () => {
        r.pause(), r.currentTime = 0;
      });
    }
}, ZA = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/, GA = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g, KA = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/, qA = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g, JA = (e) => {
  if (!e || typeof e != "string")
    return "";
  const t = e == null ? void 0 : e.trim();
  return t ? t.endsWith(";") ? t : `${t};` : "";
}, hr = () => ({
  class: {
    rendered: !0,
    default: null,
    parseHTML: (e) => e.getAttribute("class"),
    renderHTML: (e) => {
      if (e.class)
        return {
          class: e.class
        };
    }
  },
  style: {
    rendered: !0,
    default: null,
    parseHTML: (e) => e.getAttribute("style"),
    renderHTML: (e) => {
      if (e.style)
        return {
          style: e.style
        };
    }
  }
});
function XA(e, t) {
  return new Nr({
    key: new pr("handleClickLink"),
    props: {
      handleClick: (r, n, o) => {
        var l;
        const i = jW(r.state, e.type.name), a = (l = o.target) == null ? void 0 : l.closest(t);
        return t === "video" && koe(), !1;
      }
    }
  });
}
const Eoe = Ot.create({
  name: "video",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      controls: {
        default: !0
      },
      width: {
        default: "100%"
      },
      height: {
        default: "auto"
      },
      autoplay: {
        default: !1,
        renderHTML: (e) => e.autoplay === !1 ? {} : { autoplay: e.autoplay }
      },
      "data-width": {
        default: null
      },
      "data-height": {
        default: null
      },
      "data-video-embed": {
        default: ""
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      },
      ...hr()
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "video[src]" : 'video[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var o, i;
    const r = U0((o = e.attrs.width) == null ? void 0 : o.toString()), n = H0((i = e.attrs.height) == null ? void 0 : i.toString());
    return t.style = JA(e.attrs.style), t.style += `width: ${r ? r + "px" : "100%"}; max-width: 100%;`, t.style += `height: ${n ? n + "px" : "auto"};`, t.style += "clear:both;", t.width = r, t.height = n, t.alt = e.attrs.alt, t.title = e.attrs.alt, e.attrs["data-wrap"] && (t.style += W0(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += Y0(e.attrs["data-alignment"]), t.style += "float: none;", t["data-alignment"] = e.attrs["data-alignment"]), [
      "video",
      lt(this.options.HTMLAttributes, t)
    ];
  },
  addCommands() {
    return {
      addVideo: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addProseMirrorPlugins() {
    const e = [];
    return e.push(
      XA(
        {
          type: this.type
        },
        "video"
      )
    ), e;
  }
}), Loe = `
position: absolute;
top: 46%;
left: 0;
right: 0;
background: #f00;
color: #fff;
width: 70px;
font-size: 23px;
text-align: center;
margin: 0 auto;
border-radius: 10px;
padding: 22px 0px;
line-height: 0;`, $oe = Ot.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: !0,
      allowFullscreen: !1,
      controls: !0,
      height: 480,
      HTMLAttributes: {},
      inline: !1,
      nocookie: !1,
      width: 640
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0,
        rendered: !1
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      },
      "data-youtube-video": {
        default: "",
        rendered: !1
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      },
      ...hr()
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video]"
      },
      {
        tag: "div[data-youtube-video='iframe']"
      },
      {
        tag: "div[data-youtube-video='external']"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (e) => ({ commands: t }) => Rg(e.src) ? t.insertContent({
        type: this.name,
        attrs: e
      }) : !1
    };
  },
  addPasteRules() {
    return this.options.addPasteHandler ? [
      dQ({
        find: Doe,
        type: this.type,
        getAttributes: (e) => ({ src: e.input })
      })
    ] : [];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var a, l;
    const r = VA({
      url: t.src,
      controls: this.options.controls,
      nocookie: this.options.nocookie,
      startAt: t.start || 0
    }), n = U0((a = e.attrs.width) == null ? void 0 : a.toString()), o = H0((l = e.attrs.height) == null ? void 0 : l.toString());
    t.style = `width: ${n ? n + "px" : "100%"}; max-width: 100%;`, t.style += `height: ${o ? o + "px" : "auto"};`, t.style += "clear:both;", t.width = n, t.height = o, t.src = r, e.attrs["data-wrap"] && (t.style += W0(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += Y0(e.attrs["data-alignment"]), t.style += "float: none; clear:both;", t["data-alignment"] = e.attrs["data-alignment"]), this.options.renderAs === "newTab" && (t.style += "position:relative;");
    const i = (s) => `http://img.youtube.com/vi/${s.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop()}/0.jpg`;
    return this.options.renderAs === "newTab" ? [
      "div",
      {
        ...lt(this.options.HTMLAttributes, t),
        "data-youtube-video": "newTab"
        /* newTab */
      },
      [
        "a",
        { href: t == null ? void 0 : t.src, target: "blank" },
        [
          "img",
          {
            ...lt(this.options.HTMLAttributes, t),
            src: i(t == null ? void 0 : t.src)
          }
        ],
        ["p", { style: Loe, class: "video__preview-icon" }, "▶"]
      ]
    ] : [
      "div",
      {
        ...lt(this.options.HTMLAttributes, t),
        "data-youtube-video": "iframe"
        /* iframe */
      },
      [
        "iframe",
        lt(
          this.options.HTMLAttributes,
          {
            width: this.options.width,
            height: this.options.height,
            allowfullscreen: this.options.allowFullscreen
          },
          t
        )
      ]
    ];
  }
});
function eD(e) {
  if (!e)
    throw new Error("Editor is not available!");
  const t = L(void 0), r = (l, s) => {
    if (!s.src)
      return !1;
    s.linkSource === Ar.YOUTUBE ? e == null || e.commands.setYoutubeVideo({
      src: s.src,
      width: Math.max(320, (s == null ? void 0 : s.width) || 640),
      height: Math.max(180, (s == null ? void 0 : s.height) || 480)
    }) : e == null || e.chain().focus().addVideo(s).run(), l === "CREATE" && (e == null || e.chain().focus().createParagraphNear().run());
  }, n = (l) => {
    var s;
    if (!t.value)
      return !1;
    ((s = t.value) == null ? void 0 : s.linkSource) === Ar.YOUTUBE ? e == null || e.chain().focus().setYoutubeVideo({
      ...t.value,
      ...l
    }).run() : e == null || e.chain().focus().addVideo({
      ...t.value,
      ...l
    }).run();
  }, o = (l, s) => {
    n(l === "WRAP" ? { "data-wrap": s, "data-alignment": void 0 } : { "data-alignment": s, "data-wrap": void 0 });
  }, i = () => {
    e == null || e.commands.deleteSelection();
  };
  return e == null || e.on("transaction", ({ editor: l }) => {
    const s = l.getAttributes("video"), c = l.getAttributes("youtube"), u = l.getAttributes(
      "paragraph"
    );
    t.value = void 0, !Mr(c) && Mr(u) && (t.value = {
      ...c,
      linkSource: Ar.YOUTUBE
    }), !Mr(s) && Mr(u) && (t.value = {
      ...s,
      linkSource: Ar.NATIVE
    });
  }), {
    videoValues: t,
    onVideoAdd: r,
    handleVideoPosition: o,
    onRemove: i,
    convertToLinkHandler: () => {
      const { from: l, to: s } = e.state.selection, c = VA({ url: t.value.src });
      e.chain().focus().insertContentAt(
        {
          from: l,
          to: s
        },
        `${c} `
      ).run();
    }
  };
}
const zoe = { key: 0 }, Ooe = { class: "flex_container float-menu" }, joe = ["src"], Roe = ["src"], _oe = ["src"], Poe = ["src"], Boe = ["src"], Foe = ["src"], Uoe = /* @__PURE__ */ Z({
  __name: "VideoMenu",
  props: {
    editor: { type: Object },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: ["showVideoPicker"],
  setup(e, { emit: t }) {
    const r = e, n = De("locale") ?? ht[r.language], o = t, i = L(!1), { videoValues: a, handleVideoPosition: l, convertToLinkHandler: s } = eD(
      r.editor
    );
    return (c, u) => e.editor ? (_(), be("div", zoe, [
      e.editor ? on((_(), se(N(iA), {
        key: 0,
        editor: e.editor,
        "tippy-options": { duration: 100 }
      }, {
        default: Q(() => {
          var d, f, p, h, g;
          return [
            de("div", Ooe, [
              B(Je, {
                id: N(Ue).floatingMenuVideoAlignLeft,
                active: (d = e.editor) == null ? void 0 : d.isActive({ "data-alignment": "left" }),
                onOnClick: u[0] || (u[0] = (m) => N(l)("ALIGN", "left")),
                "tooltip-label": N(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  N(n).common.left
                )
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(lA),
                    class: "toolbar-button__icon"
                  }, null, 8, joe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoAlignCenter,
                active: (f = e.editor) == null ? void 0 : f.isActive({ "data-alignment": "center" }),
                onOnClick: u[1] || (u[1] = (m) => N(l)("ALIGN", "center")),
                "tooltip-label": N(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  N(n).common.center
                )
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(aA),
                    class: "toolbar-button__icon"
                  }, null, 8, Roe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoAlignRight,
                active: (p = e.editor) == null ? void 0 : p.isActive({ "data-alignment": "right" }),
                onOnClick: u[2] || (u[2] = (m) => N(l)("ALIGN", "right")),
                "tooltip-label": N(n).videoEmbed.alignmentTooltip.replace(
                  "{align}",
                  N(n).common.right
                )
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(sA),
                    class: "toolbar-button__icon"
                  }, null, 8, _oe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoJustifyLeft,
                active: (h = e.editor) == null ? void 0 : h.isActive({ "data-wrap": "left" }),
                onOnClick: u[3] || (u[3] = (m) => N(l)("WRAP", "left")),
                "tooltip-label": N(n).videoEmbed.wrapTooltip.replace(
                  "{align}",
                  N(n).common.right
                )
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(uA),
                    class: "toolbar-button__icon"
                  }, null, 8, Poe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoAlignRight,
                active: (g = e.editor) == null ? void 0 : g.isActive({ "data-wrap": "right" }),
                onOnClick: u[4] || (u[4] = (m) => N(l)("WRAP", "right")),
                "tooltip-label": N(n).videoEmbed.wrapTooltip.replace("{align}", N(n).common.left)
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(cA),
                    class: "toolbar-button__icon"
                  }, null, 8, Boe)
                ]),
                _: 1
              }, 8, ["id", "active", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoShowPicker,
                onOnClick: N(s),
                "tooltip-label": N(n).videoEmbed.convertLinkTitle
              }, {
                default: Q(() => [
                  B(N(OC), { class: "toolbar-button__icon" })
                ]),
                _: 1
              }, 8, ["id", "onOnClick", "tooltip-label"]),
              B(Je, {
                id: N(Ue).floatingMenuVideoShowPicker,
                onOnClick: u[5] || (u[5] = (m) => o("showVideoPicker")),
                "tooltip-label": N(n).videoEmbed.editTitle
              }, {
                default: Q(() => [
                  de("img", {
                    src: N(QA),
                    class: "toolbar-button__icon"
                  }, null, 8, Foe)
                ]),
                _: 1
              }, 8, ["id", "tooltip-label"])
            ])
          ];
        }),
        _: 1
      }, 8, ["editor"])), [
        [ci, !N(Mr)(N(a)) && !i.value]
      ]) : Oe("", !0)
    ])) : Oe("", !0);
  }
});
const tD = /* @__PURE__ */ Yr(Uoe, [["__scopeId", "data-v-3843e37d"]]), Hoe = { class: "ghl-editor_video--source" }, Yoe = { class: "ghl-editor_video--dimensions" }, Woe = /* @__PURE__ */ Z({
  __name: "VideoPicker",
  props: {
    modalType: String,
    showModal: Boolean,
    initialValues: Object,
    fileLimitInBytes: Number,
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String
    },
    externalEmbeddedVideo: {
      type: String,
      default: null
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: [
    "onSave",
    "onModalClose",
    "onRemove",
    "triggerExternalEmbed"
  ],
  setup(e, { emit: t }) {
    HA(si, "handleEmpty", function() {
      return this.transform((M) => isNaN(M) ? void 0 : M);
    });
    const r = e, n = De("locale") ?? ht[r.language], o = t, i = L(!1), a = L(void 0), l = [
      {
        value: Ar.NATIVE,
        label: n.videoEmbed.labels.source_native
      },
      {
        value: Ar.YOUTUBE,
        label: n.videoEmbed.labels.source_youtube
      }
    ], s = {
      linkSource: Ar.NATIVE,
      src: "",
      width: void 0,
      height: void 0
    }, c = L(null), u = L(
      r.initialValues ? r.initialValues : Object.create(s)
    ), d = {
      linkSource: {
        required: !0,
        validator: (M, x) => Gn().oneOf([Ar.NATIVE, Ar.YOUTUBE]).validate(x)
      },
      src: {
        required: !0,
        trigger: ["change", "blur"],
        validator: (M, x) => f(x)
        // Conscious type casting to avoid complicated conversions
      },
      width: {
        type: "number",
        validator: (M, x) => si().handleEmpty().validate(x)
      },
      height: {
        type: "number",
        validator: (M, x) => si().handleEmpty().validate(x)
      }
    }, f = (M) => {
      if (Gn().url().validate(M)) {
        if (u.value.linkSource === Ar.YOUTUBE && Rg(M))
          return !0;
        if (u.value.linkSource === Ar.NATIVE && !Rg(M))
          return p(M);
      }
      return "Invalid URL provided";
    }, p = async (M) => new Promise((x, b) => {
      M && (a.value = void 0, Gn().url().validate(M).then(() => {
        if (u.value.linkSource === Ar.NATIVE)
          try {
            t7(M).then(({ resourceDetails: T }) => {
              a.value = (T == null ? void 0 : T.size) ?? void 0, T.size > r.fileLimitInBytes ? b(
                `Allowed size is Approx. ${dM(
                  r.fileLimitInBytes
                )}MB and video size is ${dM(
                  a.value
                )}MB`
              ) : x(T == null ? void 0 : T.size);
            }).catch(() => {
              b("Invalid File type");
            });
          } catch {
            b("Invalid File type");
          }
      }).catch(() => {
        b("t('postEditor.videoModal.videoValidationUrlError')");
      }));
    }), h = () => {
      var M;
      (M = c.value) == null || M.getForm().validate().then(() => {
        const x = {
          ...u.value,
          width: u.value.width ? Number(u.value.width) : null,
          height: u.value.width ? Number(u.value.height) : null
        };
        o("onSave", r.modalType, x), m();
      }).catch();
    }, g = () => {
      u.value = Object.create(s);
    }, m = () => {
      g(), o("onModalClose", r.modalType);
    }, v = () => {
      g(), o("onModalClose", r.modalType), o("onRemove");
    };
    return Zt(() => {
      r.initialValues && (u.value.width = r.initialValues.width, u.value.height = r.initialValues.height);
    }), at(
      () => r.externalEmbeddedVideo,
      (M) => {
        u.value.src = M;
      }
    ), (M, x) => (_(), se(N(Kc), {
      id: "blog-editor_video-picker",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: Q(() => [
        B(N(Jc), {
          id: "warning-confirmation",
          type: "warning",
          title: e.modalType === "EDIT" ? N(n).videoEmbed.editTitle : N(n).videoEmbed.tooltip,
          onClose: m
        }, null, 8, ["title"])
      ]),
      footer: Q(() => [
        B(N(qc), {
          id: "editor__video-picker-footer",
          "positive-text": r.modalType === "EDIT" ? N(n).videoEmbed.updateVideo : N(n).videoEmbed.tooltip,
          "negative-text": N(n).common.cancel,
          loading: i.value,
          disabled: !u.value.src,
          onPositiveClick: h,
          onNegativeClick: m
        }, {
          actionLeft: Q(() => [
            r.modalType === "EDIT" ? (_(), se(N(Lr), {
              key: 0,
              id: "editor__video-picker--remove",
              type: "error",
              onClick: v
            }, {
              default: Q(() => [
                Qt(kt(N(n).common.remove), 1)
              ]),
              _: 1
            })) : Oe("", !0)
          ]),
          _: 1
        }, 8, ["positive-text", "negative-text", "loading", "disabled"])
      ]),
      default: Q(() => [
        B(N(Pm), null, {
          default: Q(() => [
            B(N(Om), {
              id: "video-picker_form",
              ref_key: "formRef",
              ref: c,
              model: u.value,
              rules: d
            }, {
              default: Q(() => [
                B(N(Rr), {
                  label: N(n).videoEmbed.labels.linkSource,
                  path: "linkSource"
                }, {
                  default: Q(() => [
                    B(N(aP), {
                      value: u.value.linkSource,
                      "onUpdate:value": x[0] || (x[0] = (b) => u.value.linkSource = b),
                      name: "linkSource"
                    }, {
                      default: Q(() => [
                        de("div", Hoe, [
                          (_(), be(qt, null, jl(l, (b) => de("div", {
                            key: b.value
                          }, [
                            B(N(nP), {
                              id: b.value,
                              value: b.value
                            }, {
                              default: Q(() => [
                                Qt(kt(b.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["id", "value"])
                          ])), 64))
                        ])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                B(N(Rr), {
                  label: N(n).videoEmbed.labels.src,
                  path: "src"
                }, {
                  default: Q(() => [
                    B(N(fw), null, {
                      default: Q(() => [
                        B(N(ni), {
                          id: "editor_video-picker-url",
                          modelValue: u.value.src,
                          "onUpdate:modelValue": x[1] || (x[1] = (b) => u.value.src = b),
                          placeholder: ""
                        }, null, 8, ["modelValue"]),
                        u.value.linkSource === N(Ar).NATIVE ? (_(), se(N(Lr), {
                          key: 0,
                          id: "editor_video-picker-url-trigger",
                          onClick: x[2] || (x[2] = (b) => o("triggerExternalEmbed", !0)),
                          type: "primary"
                        }, {
                          default: Q(() => [
                            Qt(kt(e.externalEmbedText ?? N(n).common.externalEmbed), 1)
                          ]),
                          _: 1
                        })) : Oe("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                de("div", Yoe, [
                  de("div", null, [
                    B(N(Rr), {
                      label: N(n).videoEmbed.labels.width,
                      path: "width"
                    }, {
                      default: Q(() => [
                        B(N(Yu), {
                          id: "editor_video-picker-width",
                          modelValue: u.value.width,
                          "onUpdate:modelValue": x[3] || (x[3] = (b) => u.value.width = b),
                          size: "large",
                          min: 0,
                          placeholder: u.value.width ? void 0 : N(n).videoEmbed.placeholders.width,
                          "show-button": !1
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  de("div", null, [
                    B(N(Rr), {
                      label: N(n).videoEmbed.labels.height,
                      path: "height"
                    }, {
                      default: Q(() => [
                        B(N(Yu), {
                          id: "editor_video-picker-height",
                          modelValue: u.value.height,
                          "onUpdate:modelValue": x[4] || (x[4] = (b) => u.value.height = b),
                          size: "large",
                          min: 0,
                          placeholder: u.value.height ? void 0 : N(n).videoEmbed.placeholders.height,
                          "show-button": !1
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const rD = /* @__PURE__ */ Yr(Woe, [["__scopeId", "data-v-33d88577"]]), Qoe = ["src"], Voe = {
  name: "RTEControlEmbedVideo",
  inheritAttrs: !1,
  components: { VideoPicker: rD, ToolbarButton: Je, VideoMenu: tD }
}, Tl = /* @__PURE__ */ Z({
  ...Voe,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    enableFloatingMenu: {
      type: Boolean,
      default: !0
    },
    enableExternalEmbed: {
      type: Boolean,
      default: !0
    },
    externalEmbeddedVideo: {
      type: String,
      default: null
    },
    modalContainer: {
      type: String,
      default: null
    },
    externalEmbedText: {
      type: String,
      default: null
    },
    fileLimitInBytes: Number,
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: ["triggerExternalEmbed"],
  setup(e, { emit: t }) {
    const r = e, n = De("locale") ?? ht[r.language], o = t, i = L(!1), { onVideoAdd: a, onRemove: l, videoValues: s } = eD(r.editor), c = (d, f) => {
      i.value = !1, a(d, f);
    }, u = (d) => {
      o("triggerExternalEmbed", d);
    };
    return (d, f) => {
      var p, h;
      return _(), be(qt, null, [
        !i.value && e.enableFloatingMenu ? (_(), se(tD, {
          key: 0,
          editor: e.editor,
          onShowVideoPicker: f[0] || (f[0] = (g) => i.value = !0)
        }, null, 8, ["editor"])) : Oe("", !0),
        B(Je, {
          id: N(Ue).toolbarButtonShowLinkEmbed,
          disabled: (p = e.editor) == null ? void 0 : p.isActive("link"),
          active: (h = e.editor) == null ? void 0 : h.isActive("video"),
          "tooltip-label": e.tooltipLabel ?? N(n).videoEmbed.tooltip,
          "tooltip-position": e.tooltipPosition,
          onOnClick: f[1] || (f[1] = (g) => i.value = !0)
        }, {
          default: Q(() => [
            de("img", {
              src: N(QA),
              class: "toolbar-button__icon"
            }, null, 8, Qoe)
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        i.value ? (_(), se(rD, {
          key: 1,
          "show-modal": i.value,
          "initial-values": N(s),
          "file-limit-in-bytes": e.fileLimitInBytes,
          "enable-external-embed": e.enableExternalEmbed,
          "external-embedded-Video": e.externalEmbeddedVideo,
          "external-embed-text": e.externalEmbedText,
          "modal-container": e.modalContainer,
          "modal-type": N(Mr)(N(s)) ? "CREATE" : "EDIT",
          onOnSave: c,
          onOnModalClose: f[2] || (f[2] = (g) => i.value = !1),
          onOnRemove: N(l),
          onTriggerExternalEmbed: u
        }, null, 8, ["show-modal", "initial-values", "file-limit-in-bytes", "enable-external-embed", "external-embedded-Video", "external-embed-text", "modal-container", "modal-type", "onOnRemove"])) : Oe("", !0)
      ], 64);
    };
  }
});
Tl.install = (e) => {
  e.component(Tl.name, Tl);
};
function Zoe() {
  this.__data__ = new no(), this.size = 0;
}
function Goe(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Koe(e) {
  return this.__data__.get(e);
}
function qoe(e) {
  return this.__data__.has(e);
}
var Joe = 200;
function Xoe(e, t) {
  var r = this.__data__;
  if (r instanceof no) {
    var n = r.__data__;
    if (!Gl || n.length < Joe - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new oo(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function qn(e) {
  var t = this.__data__ = new no(e);
  this.size = t.size;
}
qn.prototype.clear = Zoe;
qn.prototype.delete = Goe;
qn.prototype.get = Koe;
qn.prototype.has = qoe;
qn.prototype.set = Xoe;
function eie(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var tie = 1, rie = 2;
function nD(e, t, r, n, o, i) {
  var a = r & tie, l = e.length, s = t.length;
  if (l != s && !(a && s > l))
    return !1;
  var c = i.get(e), u = i.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, f = !0, p = r & rie ? new da() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < l; ) {
    var h = e[d], g = t[d];
    if (n)
      var m = a ? n(g, h, d, t, e, i) : n(h, g, d, e, t, i);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!eie(t, function(v, M) {
        if (!Hm(p, M) && (h === v || o(h, v, r, n, i)))
          return p.push(M);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === g || o(h, g, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var nie = Pn.Uint8Array;
const Qy = nie;
function oie(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, o) {
    r[++t] = [o, n];
  }), r;
}
function Q0(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var iie = 1, aie = 2, lie = "[object Boolean]", sie = "[object Date]", uie = "[object Error]", cie = "[object Map]", die = "[object Number]", fie = "[object RegExp]", pie = "[object Set]", hie = "[object String]", gie = "[object Symbol]", mie = "[object ArrayBuffer]", vie = "[object DataView]", Vy = jn ? jn.prototype : void 0, Af = Vy ? Vy.valueOf : void 0;
function bie(e, t, r, n, o, i, a) {
  switch (r) {
    case vie:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case mie:
      return !(e.byteLength != t.byteLength || !i(new Qy(e), new Qy(t)));
    case lie:
    case sie:
    case die:
      return gC(+e, +t);
    case uie:
      return e.name == t.name && e.message == t.message;
    case fie:
    case hie:
      return e == t + "";
    case cie:
      var l = oie;
    case pie:
      var s = n & iie;
      if (l || (l = Q0), e.size != t.size && !s)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      n |= aie, a.set(e, t);
      var u = nD(l(e), l(t), n, o, i, a);
      return a.delete(e), u;
    case gie:
      if (Af)
        return Af.call(e) == Af.call(t);
  }
  return !1;
}
function Mie(e, t, r) {
  var n = t(e);
  return bn(e) ? n : yC(n, r(e));
}
function yie(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
    var a = e[r];
    t(a, r, e) && (i[o++] = a);
  }
  return i;
}
function xie() {
  return [];
}
var wie = Object.prototype, Tie = wie.propertyIsEnumerable, Zy = Object.getOwnPropertySymbols, Nie = Zy ? function(e) {
  return e == null ? [] : (e = Object(e), yie(Zy(e), function(t) {
    return Tie.call(e, t);
  }));
} : xie;
const Sie = Nie;
function Cie(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Iie = 9007199254740991, Aie = /^(?:0|[1-9]\d*)$/;
function oD(e, t) {
  var r = typeof e;
  return t = t ?? Iie, !!t && (r == "number" || r != "symbol" && Aie.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Die = Object.prototype, kie = Die.hasOwnProperty;
function Eie(e, t) {
  var r = bn(e), n = !r && rd(e), o = !r && !n && Vu(e), i = !r && !n && !o && Gm(e), a = r || n || o || i, l = a ? Cie(e.length, String) : [], s = l.length;
  for (var c in e)
    (t || kie.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    oD(c, s))) && l.push(c);
  return l;
}
function iD(e) {
  return Vm(e) ? Eie(e) : IC(e);
}
function Gy(e) {
  return Mie(e, iD, Sie);
}
var Lie = 1, $ie = Object.prototype, zie = $ie.hasOwnProperty;
function Oie(e, t, r, n, o, i) {
  var a = r & Lie, l = Gy(e), s = l.length, c = Gy(t), u = c.length;
  if (s != u && !a)
    return !1;
  for (var d = s; d--; ) {
    var f = l[d];
    if (!(a ? f in t : zie.call(t, f)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var m = a; ++d < s; ) {
    f = l[d];
    var v = e[f], M = t[f];
    if (n)
      var x = a ? n(M, v, f, t, e, i) : n(v, M, f, e, t, i);
    if (!(x === void 0 ? v === M || o(v, M, r, n, i) : x)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var b = e.constructor, T = t.constructor;
    b != T && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof T == "function" && T instanceof T) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var jie = 1, Ky = "[object Arguments]", qy = "[object Array]", au = "[object Object]", Rie = Object.prototype, Jy = Rie.hasOwnProperty;
function _ie(e, t, r, n, o, i) {
  var a = bn(e), l = bn(t), s = a ? qy : og(e), c = l ? qy : og(t);
  s = s == Ky ? au : s, c = c == Ky ? au : c;
  var u = s == au, d = c == au, f = s == c;
  if (f && Vu(e)) {
    if (!Vu(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return i || (i = new qn()), a || Gm(e) ? nD(e, t, r, n, o, i) : bie(e, t, s, r, n, o, i);
  if (!(r & jie)) {
    var p = u && Jy.call(e, "__wrapped__"), h = d && Jy.call(t, "__wrapped__");
    if (p || h) {
      var g = p ? e.value() : e, m = h ? t.value() : t;
      return i || (i = new qn()), o(g, m, r, n, i);
    }
  }
  return f ? (i || (i = new qn()), Oie(e, t, r, n, o, i)) : !1;
}
function V0(e, t, r, n, o) {
  return e === t ? !0 : e == null || t == null || !hi(e) && !hi(t) ? e !== e && t !== t : _ie(e, t, r, n, V0, o);
}
var Pie = 1, Bie = 2;
function Fie(e, t, r, n) {
  var o = r.length, i = o, a = !n;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var l = r[o];
    if (a && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    l = r[o];
    var s = l[0], c = e[s], u = l[1];
    if (a && l[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var d = new qn();
      if (n)
        var f = n(c, u, s, e, t, d);
      if (!(f === void 0 ? V0(u, c, Pie | Bie, n, d) : f))
        return !1;
    }
  }
  return !0;
}
function aD(e) {
  return e === e && !ca(e);
}
function Uie(e) {
  for (var t = iD(e), r = t.length; r--; ) {
    var n = t[r], o = e[n];
    t[r] = [n, o, aD(o)];
  }
  return t;
}
function lD(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function Hie(e) {
  var t = Uie(e);
  return t.length == 1 && t[0][2] ? lD(t[0][0], t[0][1]) : function(r) {
    return r === e || Fie(r, e, t);
  };
}
function Yie(e, t) {
  return e != null && t in Object(e);
}
function sD(e, t, r) {
  t = NC(t, e);
  for (var n = -1, o = t.length, i = !1; ++n < o; ) {
    var a = id(t[n]);
    if (!(i = e != null && r(e, a)))
      break;
    e = e[a];
  }
  return i || ++n != o ? i : (o = e == null ? 0 : e.length, !!o && Qm(o) && oD(a, o) && (bn(e) || rd(e)));
}
function Wie(e, t) {
  return e != null && sD(e, t, Yie);
}
var Qie = 1, Vie = 2;
function Zie(e, t) {
  return Zm(e) && aD(t) ? lD(id(e), t) : function(r) {
    var n = Zi(r, e);
    return n === void 0 && n === t ? Wie(r, e) : V0(t, n, Qie | Vie);
  };
}
function Gie(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Kie(e) {
  return function(t) {
    return SC(t, e);
  };
}
function qie(e) {
  return Zm(e) ? Gie(id(e)) : Kie(e);
}
function Jie(e) {
  return typeof e == "function" ? e : e == null ? Wm : typeof e == "object" ? bn(e) ? Zie(e[0], e[1]) : Hie(e) : qie(e);
}
function Xie() {
}
var eae = 1 / 0, tae = Xi && 1 / Q0(new Xi([, -0]))[1] == eae ? function(e) {
  return new Xi(e);
} : Xie;
const rae = tae;
var nae = 200;
function uD(e, t, r) {
  var n = -1, o = mC, i = e.length, a = !0, l = [], s = l;
  if (r)
    a = !1, o = vC;
  else if (i >= nae) {
    var c = t ? null : rae(e);
    if (c)
      return Q0(c);
    a = !1, o = Hm, s = new da();
  } else
    s = t ? [] : l;
  e:
    for (; ++n < i; ) {
      var u = e[n], d = t ? t(u) : u;
      if (u = r || u !== 0 ? u : 0, a && d === d) {
        for (var f = s.length; f--; )
          if (s[f] === d)
            continue e;
        t && s.push(d), l.push(u);
      } else
        o(s, d, r) || (s !== l && s.push(d), l.push(u));
    }
  return l;
}
function oae(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var iae = wC(function(e) {
  var t = oae(e);
  return Qu(t) && (t = void 0), uD(Ym(e, 1, Qu, !0), Jie(t));
});
const cD = iae, ol = {
  "andale mono": "Andale Mono",
  arial: "Arial",
  "arial black": "Arial Black",
  "book antiqua": "Book Antiqua",
  "comic sans ms": "Comic Sans MS",
  "courier new": "Courier New",
  cursive: "cursive",
  // garamond: 'Garamond',
  georgia: "Georgia",
  helvetica: "Helvetica",
  "helvetica neue": "Helvetica Neue",
  impact: "Impact",
  monospace: "monospace",
  "noto sans": "Noto Sans",
  // roboto: 'Roboto',
  "sans-serif": "Sans-serif",
  // 'segoe ui': 'Segoe UI',
  serif: "serif",
  tahoma: "Tahoma",
  terminal: "Terminal",
  "times new roman": "Times New Roman",
  "trebuchet ms": "Trebuchet MS",
  verdana: "Verdana"
}, aae = [
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64
], lae = ol.verdana, sae = 16, uae = {
  name: "RTEControlFontFamily",
  inheritAttrs: !1
}, cae = /* @__PURE__ */ Z({
  ...uae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    fallbackFont: { type: String, default: lae },
    fontFamilyOptions: {
      type: Array
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: !1
    },
    className: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const r = e, n = De("locale") ?? ht[r.language], o = L(r.fallbackFont), i = L(!0), a = wr(), l = W(
      () => r.fontFamilyOptions ? r.fontFamilyOptions : cD(
        [o.value, ...Object.keys(ol)].filter(String).map((f) => ({
          label: ol[f] ? ol[f] : l7(f),
          value: f,
          style: {
            fontFamily: f
          }
        })),
        "value"
      )
    ), s = t, c = (f) => {
      var p;
      (p = r == null ? void 0 : r.editor.chain().focus()) == null || p.setFontFamily(f).run(), s("update:value", f);
    }, u = ({
      editor: f
    }) => {
      var g;
      const p = f.getAttributes(
        "textStyle"
      );
      o.value = r.fallbackFont;
      const h = ((g = p == null ? void 0 : p.fontFamily) == null ? void 0 : g.trim()) ?? "";
      if (h)
        if (r.fontFamilyOptions)
          o.value = h;
        else if (h != null && h.includes(",")) {
          const m = h.split(",").map((x) => x.trim().toLowerCase()), v = Object.keys(ol), M = m.find(
            (x) => v.includes(x)
          );
          M && (o.value = M);
        } else
          o.value = h;
    }, d = () => {
      r.editor && (i.value = !Ht({
        editor: r.editor,
        name: "Font Family",
        deps: ["fontFamily"]
      }));
    };
    return et(() => {
      var f;
      d(), (f = r == null ? void 0 : r.editor) == null || f.on("transaction", u), r.fallbackFont && (r == null || r.editor.setOptions({
        editorProps: {
          attributes: (p) => ({
            ...p.doc.attrs,
            style: "font-family:" + r.fallbackFont
            // Default font-family
          })
        }
      }));
    }), wa(() => {
      var f;
      (f = r == null ? void 0 : r.editor) == null || f.off("transaction", u);
    }), Zt(() => {
      var f;
      d(), (f = r == null ? void 0 : r.editor) == null || f.on("transaction", u);
    }), vt(() => {
      var f;
      (f = r == null ? void 0 : r.editor) == null || f.off("transaction", u);
    }), (f, p) => (_(), se(N(Da), {
      id: N(Ue).toolbarSelectFontFamily,
      placeholder: N(n).placeholders.fontFamily,
      value: o.value,
      options: l.value,
      disabled: i.value,
      "render-label": e.renderLabel,
      filterable: e.filterable,
      size: "small",
      class: br(["font-family", e.className]),
      "onUpdate:value": c
    }, {
      action: Q(() => [
        N(a).action ? Re(f.$slots, "action", { key: 0 }, void 0, !0) : Oe("", !0)
      ]),
      header: Q(() => [
        N(a).header ? Re(f.$slots, "header", { key: 0 }, void 0, !0) : Oe("", !0)
      ]),
      _: 3
    }, 8, ["id", "placeholder", "value", "options", "disabled", "render-label", "filterable", "class"]));
  }
});
const Nl = /* @__PURE__ */ Yr(cae, [["__scopeId", "data-v-5f121832"]]);
Nl.install = (e) => {
  e.component(Nl.name, Nl);
};
const dae = {
  name: "RTEControlFontSize",
  inheritAttrs: !1
}, fae = /* @__PURE__ */ Z({
  ...dae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    fontSizes: Array,
    fallbackFontSize: {
      type: Number
    },
    fallbackTextBlockFontSize: Object,
    className: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = W(() => {
      let u = t.fallbackFontSize ?? sae;
      if (t.fallbackTextBlockFontSize && t.editor) {
        const d = t.editor.getAttributes(
          "heading"
        );
        t.fallbackTextBlockFontSize[d.level] && (u = t.fallbackTextBlockFontSize[d.level]);
      }
      return u;
    }), i = L(Number(o.value)), a = W(
      () => cD(
        [i.value, ...t.fontSizes ?? aae].filter(Number).sort((u, d) => u - d).map((u) => {
          const d = Number(u).toString();
          return {
            label: `${d}px`,
            value: d
          };
        }),
        "value"
      )
    ), l = (u) => {
      t != null && t.editor && t.editor.chain().focus().setFontSize(`${u}px`).run();
    }, s = ({
      editor: u
    }) => {
      var p, h;
      const d = u.getAttributes(
        "textStyle"
      );
      i.value = o.value;
      const f = (p = d == null ? void 0 : d.fontSize) != null && p.trim() ? (h = d == null ? void 0 : d.fontSize) == null ? void 0 : h.replace("px", "") : o.value;
      f && !isNaN(Number(f)) ? i.value = Number(f) : i.value = f;
    }, c = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Font Size",
        deps: ["fontSize"]
      }));
    };
    return et(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), wa(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    }), Zt(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), vt(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    }), (u, d) => (_(), se(N(Da), {
      id: N(Ue).toolbarSelectFontSize,
      placeholder: N(r).placeholders.fontSize,
      value: i.value.toString(),
      options: a.value,
      size: "small",
      class: br(["font-size", e.className]),
      disabled: n.value,
      "onUpdate:value": l
    }, null, 8, ["id", "placeholder", "value", "options", "class", "disabled"]));
  }
});
const Sl = /* @__PURE__ */ Yr(fae, [["__scopeId", "data-v-e6cb95fc"]]);
Sl.install = (e) => {
  e.component(Sl.name, Sl);
};
const pae = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjgzNDgyIDEuMTM0OTNDMTAuMDE0NiAwLjk1NTAyMiAxMC4zMDYzIDAuOTU1MDIyIDEwLjQ4NjEgMS4xMzQ5M0wxMi41MzMxIDMuMTgxOTVMMTIuNTc0NCAzLjIyOTEzQzEyLjcxMTcgMy40MDk2NSAxMi42OTggMy42Njg0MiAxMi41MzMxIDMuODMzMjNMMTAuNDg2MSA1Ljg4MDI1TDEwLjQzODkgNS45MjE1NEMxMC4yNTg0IDYuMDU4ODcgOS45OTk2MyA2LjA0NTE4IDkuODM0ODIgNS44ODAyNUw5Ljc5MzU0IDUuODMzMDhDOS42NTYyMSA1LjY1MjU2IDkuNjY5OSA1LjM5Mzc5IDkuODM0ODIgNS4yMjg5N0wxMS4wOTQ5IDMuOTY3ODhMNC43ODcwMiAzLjk2ODE4QzMuMjA0MjkgMy45NjgxOCAxLjkyMTIgNS4yNTEyOCAxLjkyMTIgNi44MzQwMUMxLjkyMTIgOC4zNzkwOCAzLjE0MzkxIDkuNjM4NjggNC42NzQ0NCA5LjY5NzU0TDQuNzg2OTggOS42OTk3M0g2LjgzNEM3LjA4ODM4IDkuNjk5NzMgNy4yOTQ1OCA5LjkwNTk0IDcuMjk0NTggMTAuMTYwM0M3LjI5NDU4IDEwLjM5NTEgNy4xMTg4NyAxMC41ODg5IDYuODkxNzggMTAuNjE3M0w2LjgzNDAxIDEwLjYyMDlINC43ODY5OUMyLjY5NTUgMTAuNjIwOSAxIDguOTI1MzkgMSA2LjgzMzlDMSA0Ljc4NDI3IDIuNjI4MzMgMy4xMTQ5NyA0LjY2MTg2IDMuMDQ4OTZMNC43ODY5IDMuMDQ2OTZMMTEuMDkzOCAzLjA0NjM2TDkuODM0NTcgMS43ODYxNkw5Ljc5MzI5IDEuNzM4OThDOS42NTU5NiAxLjU1ODQ3IDkuNjY5NjUgMS4yOTk2OSA5LjgzNDU3IDEuMTM0ODhMOS44MzQ4MiAxLjEzNDkzWiIgZmlsbD0iIzExMTgyNyIgc3Ryb2tlPSIjMTExODI3Ii8+Cjwvc3ZnPgo=", hae = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE2NTE4IDEuMTM0OTNDMy45ODUzNyAwLjk1NTAyMiAzLjY5MzcgMC45NTUwMjIgMy41MTM5IDEuMTM0OTNMMS40NjY4OCAzLjE4MTk1TDEuNDI1NiAzLjIyOTEzQzEuMjg4MjYgMy40MDk2NSAxLjMwMTk2IDMuNjY4NDIgMS40NjY4OCAzLjgzMzIzTDMuNTEzOSA1Ljg4MDI1TDMuNTYxMDggNS45MjE1NEMzLjc0MTU5IDYuMDU4ODcgNC4wMDAzNyA2LjA0NTE4IDQuMTY1MTggNS44ODAyNUw0LjIwNjQ2IDUuODMzMDhDNC4zNDM3OSA1LjY1MjU2IDQuMzMwMSA1LjM5Mzc5IDQuMTY1MTggNS4yMjg5N0wyLjkwNTA4IDMuOTY3ODhMOS4yMTI5OCAzLjk2ODE4QzEwLjc5NTcgMy45NjgxOCAxMi4wNzg4IDUuMjUxMjggMTIuMDc4OCA2LjgzNDAxQzEyLjA3ODggOC4zNzkwOCAxMC44NTYxIDkuNjM4NjggOS4zMjU1NiA5LjY5NzU0TDkuMjEzMDIgOS42OTk3M0g3LjE2NkM2LjkxMTYyIDkuNjk5NzMgNi43MDU0MiA5LjkwNTk0IDYuNzA1NDIgMTAuMTYwM0M2LjcwNTQyIDEwLjM5NTEgNi44ODExMyAxMC41ODg5IDcuMTA4MjIgMTAuNjE3M0w3LjE2NTk5IDEwLjYyMDlIOS4yMTMwMUMxMS4zMDQ1IDEwLjYyMDkgMTMgOC45MjUzOSAxMyA2LjgzMzlDMTMgNC43ODQyNyAxMS4zNzE3IDMuMTE0OTcgOS4zMzgxNCAzLjA0ODk2TDkuMjEzMSAzLjA0Njk2TDIuOTA2MjMgMy4wNDYzNkw0LjE2NTQzIDEuNzg2MTZMNC4yMDY3MSAxLjczODk4QzQuMzQ0MDQgMS41NTg0NyA0LjMzMDM1IDEuMjk5NjkgNC4xNjU0MyAxLjEzNDg4TDQuMTY1MTggMS4xMzQ5M1oiIGZpbGw9IiMxMTE4MjciIHN0cm9rZT0iIzExMTgyNyIvPgo8L3N2Zz4K", gae = ["src"], mae = {
  name: "RTEControlHistory",
  inheritAttrs: !1,
  components: { ToolbarButton: Je }
}, ia = /* @__PURE__ */ Z({
  ...mae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    type: {
      string: String,
      required: !0,
      default: "undo"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = wr(), r = e, n = De("locale") ?? ht[r.language], o = (s) => {
      var c, u;
      s === "undo" ? (c = r == null ? void 0 : r.editor) == null || c.commands.undo() : s === "redo" && ((u = r == null ? void 0 : r.editor) == null || u.commands.redo());
    }, i = L(!0), a = () => {
      r.editor && (i.value = !Ht({
        editor: r.editor,
        name: "History",
        deps: ["history"]
      }));
    }, l = W(() => r.type === "redo" ? !(r != null && r.editor.can().redo()) : !(r != null && r.editor.can().undo()));
    return et(() => {
      a();
    }), Zt(() => {
      a();
    }), (s, c) => (_(), se(Je, {
      id: e.type === "undo" ? N(Ue).toolbarButtonUndo : N(Ue).toolbarButtonRedo,
      disabled: i.value || l.value,
      onOnClick: c[0] || (c[0] = (u) => o(e.type)),
      "tooltip-label": e.tooltipLabel ?? e.type === "undo" ? N(n).history.undo : N(n).history.redo,
      "tooltip-position": e.tooltipPosition
    }, {
      default: Q(() => [
        N(t).icon ? Re(s.$slots, "icon", { key: 0 }) : (_(), be("img", {
          key: 1,
          src: e.type === "undo" ? N(hae) : N(pae),
          class: "toolbar-button__icon"
        }, null, 8, gae))
      ]),
      _: 3
    }, 8, ["id", "disabled", "tooltip-label", "tooltip-position"]));
  }
});
ia.install = (e) => {
  e.component(ia.name, ia);
};
const vae = {
  name: "RTEControlItalic",
  inheritAttrs: !1
}, Cl = /* @__PURE__ */ Z({
  ...vae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Italic",
        deps: ["italic"]
      }));
    };
    return et(() => {
      o();
    }), Zt(() => {
      o();
    }), (i, a) => {
      var l;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonItalic,
        active: (l = e.editor) == null ? void 0 : l.isActive("italic"),
        "tooltip-label": e.tooltipLabel ?? N(r).common.italic,
        "tooltip-position": e.tooltipPosition,
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (s) => {
          var c;
          return (c = e.editor) == null ? void 0 : c.chain().focus().toggleItalic().run();
        })
      }, {
        default: Q(() => [
          B(N(T7), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "tooltip-label", "tooltip-position", "disabled"]);
    };
  }
});
Cl.install = (e) => {
  e.component(Cl.name, Cl);
};
var bae = Object.prototype, Mae = bae.hasOwnProperty;
function yae(e, t) {
  return e != null && Mae.call(e, t);
}
function lu(e, t) {
  return e != null && sD(e, t, yae);
}
const xae = { key: 0 }, wae = {
  name: "RTEControlLineHeight",
  inheritAttrs: !1
}, Tae = /* @__PURE__ */ Z({
  ...wae,
  props: {
    editor: { type: Object },
    fallbackLineHeight: {
      type: String,
      default: "1.5"
    },
    lineHeightOptions: {
      type: Array
    },
    language: {
      type: String,
      default: pt.English_US
    },
    tooltipLabel: {
      type: String
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = L(t.fallbackLineHeight), i = ["1", "1.15", "1.5", "2"], a = W(() => t.lineHeightOptions || i.map((d) => ({ label: d, value: d }))), l = (u) => {
      var d, f;
      u ? (d = t == null ? void 0 : t.editor) == null || d.chain().focus().setLineHeight(u).run() : (f = t == null ? void 0 : t.editor) == null || f.chain().focus().setLineHeight("inherit").run();
    }, s = ({
      editor: u
    }) => {
      const d = u.getAttributes(
        "paragraph"
      ), f = u.getAttributes(
        "heading"
      ), p = u.getAttributes(
        "blockquote"
      ), h = u.getAttributes(
        "listItem"
      );
      if (o.value = void 0, lu(d, "lineHeight") || lu(f, "lineHeight") || lu(p, "lineHeight") || lu(h, "lineHeight")) {
        const g = (Zi(d, "lineHeight") ?? Zi(f, "lineHeight") ?? Zi(p, "lineHeight") ?? Zi(h, "lineHeight") ?? "inherit").toString();
        g === "inherit" ? (o.value = "Line height", t.fallbackLineHeight && (o.value = t.fallbackLineHeight)) : o.value = g;
      }
    }, c = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Line Height",
        deps: ["lineHeight"]
      }));
    };
    return et(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), wa(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    }), Zt(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), vt(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    }), (u, d) => e.editor ? (_(), be("div", xae, [
      B(N(gs), null, {
        trigger: Q(() => [
          de("div", null, [
            B(N(Da), {
              id: N(Ue).toolbarSelectLineHeight,
              class: "editor__line-height",
              placeholder: "Line height",
              value: o.value,
              options: a.value,
              disabled: n.value,
              "onUpdate:value": l,
              size: "small"
            }, null, 8, ["id", "value", "options", "disabled"])
          ])
        ]),
        default: Q(() => [
          de("span", null, kt(t.tooltipLabel || N(r).lineHeight.tooltip), 1)
        ]),
        _: 1
      })
    ])) : Oe("", !0);
  }
});
const Il = /* @__PURE__ */ Yr(Tae, [["__scopeId", "data-v-71a560d1"]]);
Il.install = (e) => {
  e.component(Il.name, Il);
};
const Nae = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNzEwNDUgMTMuMzE1MkgxMy42MjYyQzEzLjgzODYgMTMuMzE1MiAxNC4wMTIzIDEzLjE0MTUgMTQuMDEyMyAxMi45MjkxVjEyLjI1MzNDMTQuMDEyMyAxMi4wNDA5IDEzLjgzODUgMTEuODY3MiAxMy42MjYyIDExLjg2NzJINS43MTA0NUM1LjQ5ODA3IDExLjg2NzIgNS4zMjQzNSAxMi4wNDA5IDUuMzI0MzUgMTIuMjUzM0w1LjMyNDIyIDEyLjkyOTFDNS4zMjQyMiAxMy4xNDE1IDUuNDk4MDggMTMuMzE1MiA1LjcxMDQ2IDEzLjMxNTJINS43MTA0NVoiIGZpbGw9IiMwNDBFMTMiLz4KPHBhdGggZD0iTTUuNzE0MjIgOC4yNDQ4N0gxMy42Mjk5QzEzLjg0MjMgOC4yNDQ4NyAxNC4wMTYgOC4wNzExNCAxNC4wMTYgNy44NTg3N1Y3LjE4Mjk3QzE0LjAxNiA2Ljk3MDU5IDEzLjg0MjMgNi43OTY4OCAxMy42Mjk5IDYuNzk2ODhINS43MTQyMkM1LjUwMTg0IDYuNzk2ODggNS4zMjgxMyA2Ljk3MDYgNS4zMjgxMyA3LjE4Mjk3VjcuODU4NzdDNS4zMjc5OSA4LjA3MTE1IDUuNTAxODUgOC4yNDQ4NyA1LjcxNDIyIDguMjQ0ODdWOC4yNDQ4N1oiIGZpbGw9IiMwNDBFMTMiLz4KPHBhdGggZD0iTTUuNzEwNDUgMy4xODIzN0gxMy42MjYyQzEzLjgzODYgMy4xODIzNyAxNC4wMTIzIDMuMDA4NjQgMTQuMDEyMyAyLjc5NjI3TDE0LjAxMjEgMi4xMjA0N0MxNC4wMTIxIDEuOTA4MDkgMTMuODM4NCAxLjczNDM4IDEzLjYyNiAxLjczNDM4SDUuNzEwMzJDNS40OTc5NCAxLjczNDM4IDUuMzI0MjIgMS45MDgxIDUuMzI0MjIgMi4xMjA0N1YyLjc5NjI3QzUuMzI0MjIgMy4wMDg2NSA1LjQ5ODA4IDMuMTgyMzcgNS43MTA0NiAzLjE4MjM3SDUuNzEwNDVaIiBmaWxsPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDJMMiAzTDQgMSIgc3Ryb2tlPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDdMMiA4TDQgNiIgc3Ryb2tlPSIjMDQwRTEzIi8+CjxwYXRoIGQ9Ik0xIDEyTDIgMTNMNCAxMSIgc3Ryb2tlPSIjMDQwRTEzIi8+Cjwvc3ZnPgo=", Sae = "data:image/svg+xml;base64,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", Cae = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uLWxpc3QtYnVsbC1kZWZhdWx0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIxNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIyNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBmaWxsPSIjMDAwMDAwIiBjeD0iMTEiIGN5PSIzNCIgcj0iMyI+PC9jaXJjbGU+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMTIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMjIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMC43IiB4PSIxOCIgeT0iMzIiIHdpZHRoPSIyMiIgaGVpZ2h0PSI0Ij48L3JlY3Q+CiAgICA8L2c+Cjwvc3ZnPg==", Iae = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uLWxpc3QtYnVsbC1zcXVhcmU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiB4PSI4IiB5PSIxMSIgd2lkdGg9IjYiIGhlaWdodD0iNiI+PC9yZWN0PgogICAgICAgIDxyZWN0IGZpbGw9IiMwMDAwMDAiIHg9IjgiIHk9IjIxIiB3aWR0aD0iNiIgaGVpZ2h0PSI2Ij48L3JlY3Q+CiAgICAgICAgPHJlY3QgZmlsbD0iIzAwMDAwMCIgeD0iOCIgeT0iMzEiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIxMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIyMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgICAgICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIwLjciIHg9IjE4IiB5PSIzMiIgd2lkdGg9IjIyIiBoZWlnaHQ9IjQiPjwvcmVjdD4KICAgIDwvZz4KPC9zdmc+", Aae = "data:image/svg+xml;base64,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", Dae = "data:image/svg+xml;base64,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", kae = "data:image/svg+xml;base64,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", Eae = "data:image/svg+xml;base64,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", Lae = "data:image/svg+xml;base64,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", $ae = "data:image/svg+xml;base64,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";
var ct = /* @__PURE__ */ ((e) => (e.OrderedList = "orderedList", e.BulletList = "bulletList", e.TaskList = "taskList", e.CircleList = "circleList", e.SquareList = "squareList", e.LowerAlphaList = "lowerAlphaList", e.LowerGreekList = "lowerGreekList", e.LowerRomanList = "lowerRomanList", e.UpperAlphaList = "upperAlphaList", e.UpperRomanList = "upperRomanList", e))(ct || {});
const zae = ["src"], Oae = {
  name: "RTEControlList",
  inheritAttrs: !1
}, Or = /* @__PURE__ */ Z({
  ...Oae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    listType: {
      type: String,
      default: ct.BulletList
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = W(() => {
      switch (t.listType) {
        case ct.BulletList:
          return Ue.toolbarButtonUnOrderedList;
        case ct.OrderedList:
          return Ue.toolbarButtonOrderedList;
        case ct.TaskList:
          return Ue.toolbarButtonTaskList;
        case ct.CircleList:
          return Ue.toolbarButtonCircleList;
        case ct.SquareList:
          return Ue.toolbarButtonSquareList;
        case ct.LowerAlphaList:
          return Ue.toolbarButtonLowerAlphaList;
        case ct.LowerGreekList:
          return Ue.toolbarButtonLowerGreekList;
        case ct.LowerRomanList:
          return Ue.toolbarButtonLowerRomanList;
        case ct.UpperAlphaList:
          return Ue.toolbarButtonUpperAlphaList;
        case ct.UpperRomanList:
          return Ue.toolbarButtonUpperRomanList;
        default:
          return Ue.toolbarButtonUnOrderedList;
      }
    }), i = W(() => {
      switch (t.listType) {
        case ct.CircleList:
          return r.list.circleList;
        case ct.SquareList:
          return r.list.squareList;
        case ct.BulletList:
          return r.list.discList;
        case ct.OrderedList:
          return r.list.decimalList;
        case ct.LowerAlphaList:
          return r.list.lowerAlphaList;
        case ct.LowerGreekList:
          return r.list.lowerGreekList;
        case ct.LowerRomanList:
          return r.list.lowerRomanList;
        case ct.UpperAlphaList:
          return r.list.upperAlphaList;
        case ct.UpperRomanList:
          return r.list.upperRomanList;
        default:
          return r.list.list;
      }
    }), a = {
      bulletList: "disc",
      circleList: "circle",
      squareList: "square"
    }, l = {
      orderedList: "decimal",
      lowerAlphaList: "lower-alpha",
      lowerGreekList: "lower-greek",
      lowerRomanList: "lower-roman",
      upperAlphaList: "upper-alpha",
      upperRomanList: "upper-roman"
    }, s = {
      bulletList: Cae,
      circleList: Sae,
      squareList: Iae,
      orderedList: Aae,
      lowerAlphaList: Dae,
      lowerGreekList: kae,
      lowerRomanList: Eae,
      upperAlphaList: Lae,
      upperRomanList: $ae,
      taskList: Nae
    }, c = () => {
      var f, p, h, g, m, v;
      if (t.listType === "taskList")
        return (p = (f = t == null ? void 0 : t.editor) == null ? void 0 : f.chain().focus()) == null ? void 0 : p.toggleTaskList().run();
      if (Object.keys(a).includes(t.listType))
        return (g = (h = t == null ? void 0 : t.editor) == null ? void 0 : h.chain().focus()) == null ? void 0 : g.toggleCustomBulletList({ type: a[t.listType] }).run();
      (v = (m = t == null ? void 0 : t.editor) == null ? void 0 : m.chain().focus()) == null || v.toggleCustomOrderedList({ type: l[t.listType] }).run();
    }, u = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: t.listType,
        deps: ["bulletList", "orderedList", "listItem"],
        condition: "any"
      }));
    };
    et(() => {
      u();
    }), Zt(() => {
      u();
    });
    const d = (f) => {
      var h, g;
      const p = { listStyle: "" };
      return f === "taskList" ? (h = t.editor) == null ? void 0 : h.isActive("taskList") : (p.listStyle = { ...a, ...l }[f], (g = t.editor) == null ? void 0 : g.isActive(p));
    };
    return (f, p) => (_(), se(Je, {
      id: o.value,
      "tooltip-label": e.tooltipLabel ?? i.value,
      "tooltip-position": e.tooltipPosition,
      active: d(e.listType),
      disabled: n.value,
      onOnClick: c
    }, {
      default: Q(() => [
        de("img", {
          src: s[e.listType],
          class: "toolbar-button__icon--medium"
        }, null, 8, zae)
      ]),
      _: 1
    }, 8, ["id", "tooltip-label", "tooltip-position", "active", "disabled"]));
  }
});
Or.install = (e) => {
  e.component(Or.name, Or);
};
const jae = "data:image/svg+xml;base64,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", Rae = ["src"], _ae = {
  name: "RTEControlResetStyles",
  inheritAttrs: !1
}, aa = /* @__PURE__ */ Z({
  ..._ae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    reset: {
      type: String,
      default: "selected"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = (o) => {
      var i, a, l, s;
      switch (o) {
        case "document": {
          (i = t == null ? void 0 : t.editor) == null || i.commands.selectAll(), (a = t == null ? void 0 : t.editor) == null || a.chain().focus().unsetAllMarks().run(), (l = t == null ? void 0 : t.editor) == null || l.commands.blur();
          break;
        }
        case "selected":
        default: {
          (s = t == null ? void 0 : t.editor) == null || s.chain().focus().unsetAllMarks().run();
          break;
        }
      }
    };
    return (o, i) => (_(), se(Je, {
      id: N(Ue).toolbarButtonFormatStyles,
      onOnClick: i[0] || (i[0] = (a) => n(e.reset)),
      "tooltip-label": e.tooltipLabel ?? e.reset === "document" ? N(r).resetStyles.formatAllTooltip : N(r).resetStyles.formatSelectedTooltip,
      "tooltip-position": e.tooltipPosition
    }, {
      default: Q(() => [
        e.reset === "document" ? (_(), be("img", {
          key: 0,
          src: N(jae),
          class: "toolbar-button__icon"
        }, null, 8, Rae)) : (_(), se(N($7), {
          key: 1,
          class: "toolbar-button__icon"
        }))
      ]),
      _: 1
    }, 8, ["id", "tooltip-label", "tooltip-position"]));
  }
});
aa.install = (e) => {
  e.component(aa.name, aa);
};
const Pae = {
  name: "RTEControlStrike",
  inheritAttrs: !1
}, Al = /* @__PURE__ */ Z({
  ...Pae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Strike",
        deps: ["strike"]
      }));
    };
    return et(() => {
      o();
    }), Zt(() => {
      o();
    }), (i, a) => {
      var l;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonStrike,
        active: (l = e.editor) == null ? void 0 : l.isActive("strike"),
        disabled: n.value,
        onOnClick: a[0] || (a[0] = (s) => {
          var c;
          return (c = e.editor) == null ? void 0 : c.chain().focus().toggleStrike().run();
        }),
        "tooltip-label": e.tooltipLabel ?? N(r).common.strike,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          B(N(k7), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
Al.install = (e) => {
  e.component(Al.name, Al);
};
const Bae = "data:image/svg+xml;base64,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", Fae = ["src"], Uae = {
  name: "RTEControlSubscript",
  inheritAttrs: !1
}, Dl = /* @__PURE__ */ Z({
  ...Uae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = wr(), o = L(!0), i = () => {
      t.editor && (o.value = !Ht({
        editor: t.editor,
        name: "Subscript",
        deps: ["subscript"]
      }));
    };
    return et(() => {
      i();
    }), Zt(() => {
      i();
    }), (a, l) => {
      var s;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonSub,
        active: (s = e.editor) == null ? void 0 : s.isActive("subscript"),
        disabled: o.value,
        onOnClick: l[0] || (l[0] = (c) => {
          var u;
          return (u = e.editor) == null ? void 0 : u.chain().focus().toggleSubscript().run();
        }),
        "tooltip-label": e.tooltipLabel ?? N(r).textAlign.subScript,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          N(n).icon ? Re(a.$slots, "icon", { key: 0 }) : (_(), be("img", {
            key: 1,
            src: N(Bae),
            class: "toolbar-button__icon"
          }, null, 8, Fae))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
Dl.install = (e) => {
  e.component(Dl.name, Dl);
};
const Hae = "data:image/svg+xml;base64,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", Yae = ["src"], Wae = {
  name: "RTEControlSuperscript",
  inheritAttrs: !1
}, kl = /* @__PURE__ */ Z({
  ...Wae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = wr(), o = L(!0), i = () => {
      t.editor && (o.value = !Ht({
        editor: t.editor,
        name: "Superscript",
        deps: ["superscript"]
      }));
    };
    return et(() => {
      i();
    }), Zt(() => {
      i();
    }), (a, l) => {
      var s;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonSuper,
        active: (s = e.editor) == null ? void 0 : s.isActive("superscript"),
        disabled: o.value,
        onOnClick: l[0] || (l[0] = (c) => {
          var u;
          return (u = e.editor) == null ? void 0 : u.chain().focus().toggleSuperscript().run();
        }),
        "tooltip-label": e.tooltipLabel ?? N(r).textAlign.superScript,
        "tooltip-position": e.tooltipPosition
      }, {
        default: Q(() => [
          N(n).icon ? Re(a.$slots, "icon", { key: 0 }) : (_(), be("img", {
            key: 1,
            src: N(Hae),
            class: "toolbar-button__icon"
          }, null, 8, Yae))
        ]),
        _: 3
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
kl.install = (e) => {
  e.component(kl.name, kl);
};
var He = /* @__PURE__ */ ((e) => (e.AddColumnAfter = "addColumnAfter", e.AddColumnBefore = "addColumnBefore", e.AddRowAfter = "addRowAfter", e.AddRowBefore = "addRowBefore", e.DeleteColumn = "deleteColumn", e.DeleteRow = "deleteRow", e.DeleteTable = "deleteTable", e.InsertTable = "insertTable", e.MergeCells = "mergeCells", e.SplitCell = "splitCell", e))(He || {});
const Qae = {
  name: "RTEControlTable",
  inheritAttrs: !1
}, Ir = /* @__PURE__ */ Z({
  ...Qae,
  props: {
    editor: { type: Object },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    action: {
      type: String,
      required: !0,
      default: He.InsertTable
    },
    defaultRows: {
      type: Number,
      default: 3
    },
    defaultColumns: {
      type: Number,
      default: 3
    },
    withHeader: {
      type: Boolean,
      default: !0
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = L(!0), n = () => {
      t.editor && (r.value = !Ht({
        editor: t.editor,
        name: "Text Alignment",
        deps: [
          "tableRow",
          "tableHeader",
          "tableCell",
          "table",
          "_requiredExtensions"
        ]
      }));
    };
    et(() => {
      n();
    }), Zt(() => {
      n();
    });
    const o = (s) => {
      const c = t.editor.chain().focus(), u = {
        [He.InsertTable]: () => c.insertTable({
          rows: t.defaultRows,
          cols: t.defaultColumns,
          withHeaderRow: t.withHeader
        }).updateAttributes("table", { class: "rte-table" }).run(),
        [He.AddColumnBefore]: () => c.addColumnBefore().run(),
        [He.AddColumnAfter]: () => c.addColumnAfter().run(),
        [He.AddRowBefore]: () => c.addRowBefore().run(),
        [He.AddRowAfter]: () => c.addRowAfter().run(),
        [He.DeleteTable]: () => c.deleteTable().run(),
        [He.MergeCells]: () => c.mergeCells().run(),
        [He.SplitCell]: () => c.splitCell().run(),
        [He.DeleteRow]: () => c.deleteRow().run(),
        [He.DeleteColumn]: () => c.deleteColumn().run()
      };
      (u[s] || u[He.InsertTable])();
    }, i = (s) => {
      const c = {
        [He.InsertTable]: N7,
        [He.AddColumnBefore]: c7,
        [He.AddColumnAfter]: d7,
        [He.AddRowBefore]: p7,
        [He.AddRowAfter]: f7,
        [He.DeleteTable]: E7,
        [He.MergeCells]: I7,
        [He.SplitCell]: D7,
        [He.DeleteRow]: A7,
        [He.DeleteColumn]: x7
      };
      return c[s] ?? c[He.InsertTable];
    }, a = De("locale") ?? ht[t.language], l = (s) => {
      const c = {
        [He.InsertTable]: a.table.insertTable,
        [He.AddColumnBefore]: a.table.addColumnBefore,
        [He.AddColumnAfter]: a.table.addColumnAfter,
        [He.AddRowBefore]: a.table.addRowBefore,
        [He.AddRowAfter]: a.table.addRowAfter,
        [He.DeleteTable]: a.table.deleteTable,
        [He.MergeCells]: a.table.mergeCell,
        [He.SplitCell]: a.table.splitCell,
        [He.DeleteRow]: a.table.deleteRow,
        [He.DeleteColumn]: a.table.deleteColumn
      };
      return c[s] ?? c[He.InsertTable];
    };
    return (s, c) => (_(), se(Je, {
      id: `table-${t.action}`,
      "tooltip-label": e.tooltipLabel ?? l(t.action),
      "tooltip-position": "top",
      onOnClick: c[0] || (c[0] = (u) => o(t.action))
    }, {
      default: Q(() => [
        (_(), se(Jn(i(e.action)), { class: "toolbar-button__icon" }))
      ]),
      _: 1
    }, 8, ["id", "tooltip-label"]));
  }
});
Ir.install = (e) => {
  e.component(Ir.name, Ir);
};
const Vae = {
  name: "RTEControlTextAlignment",
  inheritAttrs: !1
}, wo = /* @__PURE__ */ Z({
  ...Vae,
  props: {
    editor: { type: Object },
    align: {
      type: String,
      default: "left"
    },
    tooltipLabel: String,
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = function() {
      switch (t.align) {
        case "right":
          return r.common.right;
        case "left":
          return r.common.left;
        case "center":
          return r.common.center;
      }
    }(), i = W(() => t.tooltipLabel ? t.tooltipLabel : t.align !== "justify" ? r.textAlign.alignTooltip.replace("{align}", o) : r.common.justify), a = [
      "heading",
      "paragraph",
      "_requiredExtensions",
      "textAlign"
    ], l = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Text Alignment",
        deps: a
      }));
    };
    return et(() => {
      l();
    }), Zt(() => {
      l();
    }), (s, c) => {
      var u;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonTextAlignCenter,
        active: (u = e.editor) == null ? void 0 : u.isActive({ textAlign: s.$props.align }),
        "tooltip-label": i.value,
        "tooltip-position": e.tooltipPosition,
        disabled: n.value,
        onOnClick: c[0] || (c[0] = (d) => {
          var f, p;
          (p = (f = e.editor) == null ? void 0 : f.chain().focus()) == null || p.setTextAlign(s.$props.align).run();
        })
      }, {
        default: Q(() => [
          e.align === "left" ? (_(), se(N(m7), {
            key: 0,
            class: "toolbar-button__icon"
          })) : Oe("", !0),
          e.align === "center" ? (_(), se(N(h7), {
            key: 1,
            class: "toolbar-button__icon"
          })) : Oe("", !0),
          e.align === "right" ? (_(), se(N(v7), {
            key: 2,
            class: "toolbar-button__icon"
          })) : Oe("", !0),
          e.align === "justify" ? (_(), se(N(g7), {
            key: 3,
            class: "toolbar-button__icon"
          })) : Oe("", !0)
        ]),
        _: 1
      }, 8, ["id", "active", "tooltip-label", "tooltip-position", "disabled"]);
    };
  }
});
wo.install = (e) => {
  e.component(wo.name, wo);
};
function Zae(e) {
  return e && e.length ? uD(e) : [];
}
const Gae = {
  name: "RTEControlTextBlocks",
  inheritAttrs: !1
}, Kae = /* @__PURE__ */ Z({
  ...Gae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    language: {
      type: String,
      default: pt.English_US
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = {
      fontWeight: "bold",
      fontStyle: "normal"
    }, o = {
      Heading1: {
        label: r.paragraph.heading1,
        value: "1",
        style: {
          fontSize: "32px",
          ...n
        }
      },
      Heading2: {
        label: r.paragraph.heading2,
        value: "2",
        style: {
          fontSize: "24px",
          ...n
        }
      },
      Heading3: {
        label: r.paragraph.heading3,
        value: "3",
        style: {
          fontSize: "18.72px",
          ...n
        }
      },
      Heading4: {
        label: r.paragraph.heading4,
        value: "4",
        style: {
          fontSize: "16px",
          ...n
        }
      },
      Heading5: {
        label: r.paragraph.heading5,
        value: "5",
        style: {
          fontSize: "13.28px",
          ...n
        }
      },
      Div: {
        label: "div",
        value: "-1"
      },
      Pre: {
        label: "pre",
        value: "-2"
      },
      Paragraph: {
        label: r.paragraph.paragraph,
        value: "0",
        style: {
          fontSize: "18px",
          fontWeight: 400,
          fontStyle: "normal"
        }
      }
    }, i = o.Paragraph.value, a = L(!0), l = L(), s = {
      0: {
        name: "paragraph",
        handler: "setCustomParagraph"
      },
      "-1": {
        name: "divTag",
        handler: "setDivTag"
      },
      "-2": {
        name: "preTag",
        handler: "setPreTag"
      },
      default: {
        name: "heading",
        handler: "toggleHeading"
      }
    }, c = ({
      editor: v
    }) => {
      const M = v.getAttributes(
        "heading"
      );
      l.value = v.isActive("divTag") ? "-1" : v.isActive("preTag") ? "-2" : i, Mr(M) || (l.value = String(M.level) ?? i), t.options.length > 0 && g();
    }, u = (v) => {
      var b, T, w;
      const M = t.editor.getAttributes(
        ((b = s[v]) == null ? void 0 : b.name) || s.default.name
      ), x = (T = t.editor.getAttributes("textStyle")) == null ? void 0 : T.fontFamily;
      if (t != null && t.editor) {
        const y = ((w = s[v]) == null ? void 0 : w.handler) || s.default.handler;
        y === "toggleHeading" ? t.editor.chain().focus().unsetFontSize().setHeading({
          ...M,
          level: Number(v)
        }).run() : t.editor.chain().focus()[y](M).run(), x && t.editor.chain().setFontFamily(x).run();
      }
    }, d = () => {
      t.editor && (a.value = !Ht({
        editor: t.editor,
        name: "Heading",
        deps: ["heading"]
      }));
    }, f = L([]);
    et(() => {
      var v;
      d(), (v = t == null ? void 0 : t.editor) == null || v.on("transaction", c), h();
    }), wa(() => {
      var v;
      (v = t == null ? void 0 : t.editor) == null || v.off("transaction", c);
    }), Zt(() => {
      var v;
      d(), (v = t == null ? void 0 : t.editor) == null || v.on("transaction", c);
    }), vt(() => {
      var v;
      (v = t == null ? void 0 : t.editor) == null || v.off("transaction", c);
    });
    const p = (v) => S("div", {}, [
      S("p", { style: { margin: 0 } }, [v.label])
    ]), h = () => {
      if (t.options.length === 0)
        f.value = Object.values(o);
      else {
        const v = Zae(t.options).filter(
          (M) => M in o
        );
        f.value = v.map(
          (M) => o[M]
        );
      }
      l.value = i, m();
    }, g = () => {
      const v = Object.keys(o).find(
        (M) => o[M].value === l.value
      );
      v && !f.value.includes(o[v]) && (f.value.push(o[v]), m());
    }, m = () => {
      const v = Object.keys(o);
      f.value.sort((M, x) => {
        const b = v.find((w) => o[w].value === M.value), T = v.find((w) => o[w].value === x.value);
        return v.indexOf(b) - v.indexOf(T);
      });
    };
    return (v, M) => (_(), se(N(Da), {
      id: N(Ue).toolbarSelectTextBlock,
      placeholder: "Paragraph",
      value: l.value,
      options: f.value,
      disabled: a.value,
      class: "text-blocks",
      size: "small",
      "onUpdate:value": u,
      renderLabel: p
    }, null, 8, ["id", "value", "options", "disabled"]));
  }
});
const El = /* @__PURE__ */ Yr(Kae, [["__scopeId", "data-v-64d938bf"]]);
El.install = (e) => {
  e.component(El.name, El);
};
const qae = {
  name: "RTEControlUnderline",
  inheritAttrs: !1
}, Ll = /* @__PURE__ */ Z({
  ...qae,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!0), o = () => {
      t.editor && (n.value = !Ht({
        editor: t.editor,
        name: "Underline",
        deps: ["underline"]
      }));
    };
    return et(() => {
      o();
    }), Zt(() => {
      o();
    }), (i, a) => {
      var l;
      return _(), se(Je, {
        id: N(Ue).toolbarButtonUnderline,
        active: (l = e.editor) == null ? void 0 : l.isActive("underline"),
        disabled: n.value,
        "tooltip-label": e.tooltipLabel ?? N(r).common.underline,
        "tooltip-position": e.tooltipPosition,
        onOnClick: a[0] || (a[0] = (s) => {
          var c;
          return (c = e.editor) == null ? void 0 : c.chain().focus().toggleUnderline().run();
        })
      }, {
        default: Q(() => [
          B(N(z7), { class: "toolbar-button__icon" })
        ]),
        _: 1
      }, 8, ["id", "active", "disabled", "tooltip-label", "tooltip-position"]);
    };
  }
});
Ll.install = (e) => {
  e.component(Ll.name, Ll);
};
const Jae = Z({
  name: "UIMenuWrapper"
}), Xae = /* @__PURE__ */ Z({
  ...Jae,
  props: {
    padding: {
      type: Object,
      default: () => ({
        top: null,
        bottom: null,
        left: null,
        right: null
      })
    },
    borderSide: {
      type: String,
      default: "right"
    }
  },
  setup(e) {
    const t = e, r = W(() => {
      var n, o, i, a;
      return {
        borderRight: t.borderSide === "right" || t.borderSide === "both" ? "1px solid #ccc" : "none",
        borderLeft: t.borderSide === "left" || t.borderSide === "both" ? "1px solid #ccc" : "none",
        paddingTop: (n = t.padding) == null ? void 0 : n.top,
        paddingBottom: (o = t.padding) == null ? void 0 : o.bottom,
        paddingLeft: (i = t.padding) == null ? void 0 : i.left,
        paddingRight: (a = t.padding) == null ? void 0 : a.right
      };
    });
    return (n, o) => (_(), be("div", {
      style: Fc(r.value),
      class: "menuWrapper"
    }, [
      Re(n.$slots, "default", {}, void 0, !0)
    ], 4));
  }
});
const ele = /* @__PURE__ */ Yr(Xae, [["__scopeId", "data-v-b6c72ee5"]]), tle = {
  key: 0,
  id: "editor-toolbar",
  class: "flex_container toolbar_container border_bottom"
}, rle = {
  name: "UIRichTextEditor",
  inheritAttrs: !1
}, nle = /* @__PURE__ */ Z({
  ...rle,
  props: {
    editor: { type: Object },
    containerClass: {
      type: String,
      default: () => ""
    },
    language: {
      type: String,
      default: pt.English_US
    },
    formatOnPaste: Boolean
  },
  setup(e) {
    const t = e, r = wr(), n = L(!1), o = L(null), i = De("locale") ?? ht[t.language];
    Wb(t.language), at(
      () => t.language,
      (c) => {
        Wb(c);
      }
    );
    const a = () => {
      n.value = !1;
      const { from: c, to: u } = t.editor.state.selection;
      try {
        const d = o.value.content.toJSON().map((f) => (f != null && f.content && f.content.map((p) => {
          if (p.type === "text" && Ji.isURL(p.text)) {
            const h = [
              {
                type: "link",
                attrs: {
                  href: p.text,
                  target: "_blank"
                }
              }
            ];
            return p.marks = h;
          }
          return p;
        }), f));
        t.editor.chain().focus().insertContentAt({ from: c, to: u }, d).run();
      } catch {
        t.editor.chain().focus().insertContentAt({ from: c, to: u }, o.value.content.toJSON()).run();
      }
    }, l = () => {
      n.value = !1;
      const { from: c, to: u } = t.editor.state.selection;
      try {
        const d = o.value.content.toJSON().map((f) => {
          if (f != null && f.content)
            f.content.map((p) => {
              if (p != null && p.marks) {
                const h = p.marks.filter(
                  (g) => g.type !== "textStyle"
                );
                return p.marks = h;
              } else if (p.type === "text" && Ji.isURL(p.text)) {
                const h = [
                  {
                    type: "link",
                    attrs: {
                      href: p.text,
                      target: "_blank"
                    }
                  }
                ];
                return p.marks = h;
              }
              return p;
            });
          else if (f != null && f.marks) {
            const p = f.marks.filter((h) => h.type !== "textStyle");
            f.marks = p;
          }
          return f;
        });
        t.editor.chain().focus().insertContentAt({ from: c, to: u }, d).setTextSelection({
          from: c,
          to: c + o.value.content.size
        }).run();
      } catch {
        t.editor.chain().focus().insertContentAt({ from: c, to: u }, o.value.content.toJSON()).setTextSelection({
          from: c,
          to: c + o.value.content.size
        }).run();
      }
    }, s = function(c, u) {
      return n.value = !0, o.value = c, c;
    };
    return et(() => {
      t.formatOnPaste && (t == null || t.editor.setOptions({
        editorProps: {
          handlePaste: function(c, u) {
            return !0;
          },
          transformPasted: s
        }
      }));
    }), (c, u) => e.editor ? (_(), be("div", {
      key: 0,
      class: br(["editor-container", e.containerClass])
    }, [
      N(r).toolbar ? (_(), be("div", tle, [
        Re(c.$slots, "toolbar", {}, void 0, !0)
      ])) : Oe("", !0),
      B(N(jZ), {
        editor: e.editor,
        class: "editor-wrapper"
      }, null, 8, ["editor"]),
      B(N(Kc), {
        autoFocus: !0,
        maskClosable: !0,
        show: n.value,
        "onUpdate:show": u[1] || (u[1] = (d) => n.value = d),
        className: "fixed top-10 left-0 right-0 flex justify-center"
      }, {
        header: Q(() => [
          B(N(Jc), {
            title: N(i).common.pasteFormattingOptions,
            description: N(i).common.pasteMessage,
            id: "modal-header",
            onClose: u[0] || (u[0] = (d) => n.value = !1)
          }, null, 8, ["title", "description"])
        ]),
        footer: Q(() => [
          B(N(qc), {
            positiveText: N(i).common.keepFormatting,
            negativeText: N(i).common.removeFormatting,
            onPositiveClick: a,
            onNegativeClick: l,
            id: "modal-footer",
            type: "primary"
          }, null, 8, ["positiveText", "negativeText"])
        ]),
        _: 1
      }, 8, ["show"])
    ], 2)) : Oe("", !0);
  }
});
const ole = /* @__PURE__ */ Yr(nle, [["__scopeId", "data-v-7ab402ed"]]), ile = { class: "toolbar-container" }, ale = { class: "visible-toolbar-items" }, lle = { class: "expandable-toolbar-items" }, sle = { class: "expandable-toolbar-items" }, ule = Z({
  name: "UITextEditorToolbar"
}), cle = /* @__PURE__ */ Z({
  ...ule,
  props: {
    editor: { type: Object }
  },
  setup(e) {
    const t = L(!1), r = () => {
      t.value = !t.value;
    };
    return (n, o) => {
      var i, a, l, s, c, u, d, f, p;
      return _(), be("div", ile, [
        de("div", ale, [
          B(N(ia), {
            type: "undo",
            editor: e.editor
          }, null, 8, ["editor"]),
          B(N(ia), {
            type: "redo",
            editor: e.editor
          }, null, 8, ["editor"]),
          B(N(Nl), { editor: e.editor }, null, 8, ["editor"]),
          B(N(El), { editor: e.editor }, null, 8, ["editor"]),
          B(N(Sl), { editor: e.editor }, null, 8, ["editor"]),
          B(N(hl), { editor: e.editor }, null, 8, ["editor"]),
          B(N(Cl), { editor: e.editor }, null, 8, ["editor"]),
          B(N(Ll), { editor: e.editor }, null, 8, ["editor"]),
          B(Je, {
            id: N(Ue).toolbarButtonDots,
            "tooltip-label": "Reveal or hide additional toolbar items",
            "tooltip-position": "top",
            onOnClick: r
          }, {
            default: Q(() => [
              B(N(w7), { class: "toolbar-button__icon" })
            ]),
            _: 1
          }, 8, ["id"])
        ]),
        de("div", {
          class: br(["expandable-toolbar-container", [
            t.value ? "show-expanded-items" : "hide-expanded-items"
          ]])
        }, [
          de("div", lle, [
            B(N(wo), {
              editor: e.editor,
              align: "left"
            }, null, 8, ["editor"]),
            B(N(wo), {
              editor: e.editor,
              align: "center"
            }, null, 8, ["editor"]),
            B(N(wo), {
              editor: e.editor,
              align: "right"
            }, null, 8, ["editor"]),
            B(N(wo), {
              editor: e.editor,
              align: "justify"
            }, null, 8, ["editor"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).OrderedList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).BulletList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).CircleList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).SquareList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).LowerAlphaList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).LowerGreekList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).LowerRomanList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).UpperAlphaList
            }, null, 8, ["editor", "listType"]),
            B(N(Or), {
              editor: e.editor,
              listType: N(ct).UpperRomanList
            }, null, 8, ["editor", "listType"]),
            B(N(Cu), { editor: e.editor }, null, 8, ["editor"]),
            B(N(wl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(Tl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(Il), { editor: e.editor }, null, 8, ["editor"]),
            B(N(Al), { editor: e.editor }, null, 8, ["editor"]),
            B(N(bl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(pl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(aa), { editor: e.editor }, null, 8, ["editor"]),
            B(N(aa), {
              editor: e.editor,
              reset: "document"
            }, null, 8, ["editor"])
          ]),
          de("div", sle, [
            B(N(Dl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(kl), { editor: e.editor }, null, 8, ["editor"]),
            B(N(ea), { editor: e.editor }, null, 8, ["editor"]),
            B(N(ea), {
              editor: e.editor,
              type: "block"
            }, null, 8, ["editor"]),
            B(N(Ir), {
              editor: e.editor,
              action: N(He).InsertTable
            }, null, 8, ["editor", "action"]),
            (i = e.editor) != null && i.isActive("table") ? (_(), se(N(Ir), {
              key: 0,
              editor: e.editor,
              action: N(He).DeleteTable
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (a = e.editor) != null && a.isActive("table") ? (_(), se(N(Ir), {
              key: 1,
              editor: e.editor,
              action: N(He).DeleteColumn
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (l = e.editor) != null && l.isActive("table") ? (_(), se(N(Ir), {
              key: 2,
              editor: e.editor,
              action: N(He).DeleteRow
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (s = e.editor) != null && s.isActive("table") ? (_(), se(N(Ir), {
              key: 3,
              editor: e.editor,
              action: N(He).AddColumnBefore
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (c = e.editor) != null && c.isActive("table") ? (_(), se(N(Ir), {
              key: 4,
              editor: e.editor,
              action: N(He).AddColumnAfter
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (u = e.editor) != null && u.isActive("table") ? (_(), se(N(Ir), {
              key: 5,
              editor: e.editor,
              action: N(He).AddRowBefore
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (d = e.editor) != null && d.isActive("table") ? (_(), se(N(Ir), {
              key: 6,
              editor: e.editor,
              action: N(He).AddRowAfter
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (f = e.editor) != null && f.isActive("table") ? (_(), se(N(Ir), {
              key: 7,
              editor: e.editor,
              action: N(He).MergeCells
            }, null, 8, ["editor", "action"])) : Oe("", !0),
            (p = e.editor) != null && p.isActive("table") ? (_(), se(N(Ir), {
              key: 8,
              editor: e.editor,
              action: N(He).SplitCell
            }, null, 8, ["editor", "action"])) : Oe("", !0)
          ])
        ], 2)
      ]);
    };
  }
});
const dle = /* @__PURE__ */ Yr(cle, [["__scopeId", "data-v-d8ddea8b"]]);
var Su = /* @__PURE__ */ ((e) => (e.Image = "image", e.Link = "link", e))(Su || {}), _g = /* @__PURE__ */ ((e) => (e.Custom = "custom", e.Default = "default", e))(_g || {});
const dD = /* @__PURE__ */ Z({
  __name: "LinkModal",
  props: {
    editor: {
      type: Object,
      required: !0
    },
    showModal: Boolean,
    initialValues: Object,
    modalContainer: {
      type: String,
      default: null
    },
    customValues: {
      type: Array,
      required: !1,
      default: () => []
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  emits: ["onSave", "onModalClose", "onRemove"],
  setup(e, { emit: t }) {
    const r = {
      href: "",
      target: "_blank",
      title: ""
    };
    HA(si, "handleEmpty", function() {
      return this.transform((g) => isNaN(g) ? void 0 : g);
    });
    const n = e, o = De("locale") ?? ht[n.language], i = [
      {
        value: "_self",
        label: o.link.self
      },
      {
        value: "_blank",
        label: o.link.newWindow
      }
    ], a = t, l = L(null), s = L(
      n.initialValues ? n.initialValues : Object.create(r)
    ), c = L(!1), u = {
      href: {
        required: !0,
        trigger: ["change"],
        message: o.common.invalidURL,
        validator: (g, m) => Gn().test(
          "customOrWebURL",
          o.common.invalidURL,
          ig
        ).isValidSync(m)
      },
      target: {
        required: !0,
        trigger: ["change"],
        message: o.common.targetNeeded
      },
      title: { required: !1, trigger: ["change"] }
    };
    et(() => {
      const { view: g, state: m } = n.editor, { from: v, to: M } = g.state.selection, x = m.doc.textBetween(v, M, `
`).trim();
      x && x.includes(`
`) ? (c.value = !0, s.value = {
        ...s.value,
        title: ""
      }) : x && !x.includes(`
`) && (c.value = !1, s.value = {
        ...s.value,
        title: x
      });
    });
    const d = () => {
      var g;
      s.value = Object.create(r), (g = l.value) == null || g.getForm().restoreValidation(), a("onModalClose");
    }, f = () => {
      var m;
      const g = {
        ...s.value,
        type: n.customValues.length ? _g.Custom : _g.Default
      };
      c.value || (g.title = s.value.title ? s.value.title : s.value.href), (m = l.value) == null || m.getForm().validate().then(() => {
        a("onSave", g), d();
      }).catch();
    }, p = () => {
      a("onRemove"), d();
    }, h = (g) => {
      if (s.value.title.trim().length || c.value)
        s.value.href = g;
      else {
        const m = i7(n.customValues, g);
        s.value = {
          ...s.value,
          href: g,
          title: m[0].label
        };
      }
    };
    return at(
      () => s.value.href,
      (g, m) => {
        if (!n.customValues.length) {
          const v = s.value.title.trim();
          (v.length === 0 && !c.value || g && m && v === m.trim()) && (s.value = {
            ...s.value,
            title: g
          });
        }
      }
    ), (g, m) => (_(), se(N(Kc), {
      id: "blog-editor_link-embed",
      show: e.showModal,
      to: e.modalContainer
    }, {
      header: Q(() => [
        B(N(Jc), {
          id: "warning-confirmation",
          type: "warning",
          title: N(o).linkEmbed.title,
          onClose: d
        }, null, 8, ["title"])
      ]),
      footer: Q(() => [
        B(N(qc), {
          id: "editor__link-embed-footer",
          "positive-text": N(o).common.save,
          "negative-text": N(o).common.cancel,
          disabled: !s.value.href,
          onPositiveClick: f,
          onNegativeClick: d
        }, {
          actionLeft: Q(() => {
            var v;
            return [
              (v = e.initialValues) != null && v.href ? (_(), se(N(Lr), {
                key: 0,
                id: "editor__video-picker--remove",
                type: "error",
                onClick: p
              }, {
                default: Q(() => [
                  Qt(kt(N(o).common.remove), 1)
                ]),
                _: 1
              })) : Oe("", !0)
            ];
          }),
          _: 1
        }, 8, ["positive-text", "negative-text", "disabled"])
      ]),
      default: Q(() => [
        B(N(Pm), null, {
          default: Q(() => [
            B(N(Om), {
              id: "link-embed_form",
              ref_key: "formRef",
              ref: l,
              model: s.value,
              rules: u
            }, {
              default: Q(() => [
                B(N(Rr), {
                  label: N(o).common.url,
                  path: "href"
                }, {
                  default: Q(() => [
                    B(N(ni), {
                      id: "editor_link-embed-href",
                      modelValue: s.value.href,
                      "onUpdate:modelValue": m[0] || (m[0] = (v) => s.value.href = v),
                      size: "large",
                      min: 0
                    }, Xg({ _: 2 }, [
                      e.customValues.length ? {
                        name: "suffix",
                        fn: Q(() => [
                          B(N(Sw), {
                            options: e.customValues,
                            onOnSelect: h
                          }, {
                            trigger: Q(() => [
                              B(N(Lr), {
                                id: "customValuesTrigger",
                                quaternary: ""
                              }, {
                                default: Q(() => [
                                  B(N(L7), { class: "icon" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["options"])
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1032, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                c.value ? Oe("", !0) : (_(), se(N(Rr), {
                  key: 0,
                  label: "Text to display",
                  path: "title"
                }, {
                  default: Q(() => [
                    B(N(ni), {
                      id: "editor_link-embed-title",
                      modelValue: s.value.title,
                      "onUpdate:modelValue": m[1] || (m[1] = (v) => s.value.title = v),
                      size: "large",
                      min: 0
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })),
                B(N(Rr), {
                  label: N(o).common.action,
                  path: "target"
                }, {
                  default: Q(() => [
                    B(N(Da), {
                      id: "editor_link-embed-target",
                      value: s.value.target,
                      "onUpdate:value": m[2] || (m[2] = (v) => s.value.target = v),
                      options: i,
                      disabled: !s.value.href,
                      size: "large",
                      min: 0
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "to"]));
  }
});
const fle = {
  name: "RTEControlEmbedLink",
  inheritAttrs: !1,
  components: { LinkModal: dD, ToolbarButton: Je }
}, Cu = /* @__PURE__ */ Z({
  ...fle,
  props: {
    editor: {
      type: Object,
      required: !0
    },
    modalContainer: {
      type: String,
      default: null
    },
    tooltipLabel: {
      type: String
    },
    tooltipPosition: {
      type: String,
      default: "top"
    },
    customValues: {
      type: Array,
      required: !1
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = function() {
      if (!De("locale")) {
        const u = ht[t.language];
        return Et("locale", u), u;
      }
      return De("locale");
    }(), n = L(!1), o = L(void 0), i = L(!0), a = (u) => {
      var d;
      if (u.href) {
        const f = LC(u.href), p = () => {
          var g;
          (g = t == null ? void 0 : t.editor) == null || g.chain().focus().extendMarkRange(Su.Link).setLink({
            href: f,
            target: u.target
          }).run();
        }, h = () => {
          var T;
          const { view: g, state: m } = t.editor, { from: v, to: M } = g.state.selection, x = m.doc.textBetween(v, M, ""), b = () => m.selection.empty ? u.title && u.title.trim().length > 0 ? u.title : u.href : u.title && u.title.trim().length > 0 ? u.title : x;
          (T = t == null ? void 0 : t.editor) == null || T.chain().focus().extendMarkRange(Su.Link).setLink({
            href: f,
            target: u.target,
            title: u.title.trim()
          }).insertContentAt(
            {
              from: v,
              to: M
            },
            b()
          ).run();
        };
        u.href && u.title.length === 0 ? p() : h();
      } else
        (d = t == null ? void 0 : t.editor) == null || d.chain().focus().unsetLink().run();
    }, l = () => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.chain().focus().unsetLink().run();
    }, s = ({
      editor: u
    }) => {
      const d = u.getAttributes("link");
      o.value = void 0, Mr(d) || (o.value = d);
    };
    et(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), wa(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    }), Zt(() => {
      var u;
      c(), (u = t == null ? void 0 : t.editor) == null || u.on("transaction", s);
    }), vt(() => {
      var u;
      (u = t == null ? void 0 : t.editor) == null || u.off("transaction", s);
    });
    const c = () => {
      t.editor && (i.value = !Ht({
        editor: t.editor,
        name: "Link",
        deps: ["link"]
      }));
    };
    return (u, d) => {
      var f;
      return _(), be(qt, null, [
        B(Je, {
          id: N(Ue).toolbarButtonShowLinkEmbed,
          disabled: i.value,
          active: (f = e.editor) == null ? void 0 : f.isActive(N(Su).Link),
          onOnClick: d[0] || (d[0] = (p) => n.value = !0),
          "tooltip-label": e.tooltipLabel ?? N(r).linkEmbed.tooltip,
          "tooltip-position": e.tooltipPosition
        }, {
          default: Q(() => [
            B(N(OC), { class: "toolbar-button__icon" })
          ]),
          _: 1
        }, 8, ["id", "disabled", "active", "tooltip-label", "tooltip-position"]),
        n.value ? (_(), se(dD, {
          key: 0,
          editor: e.editor,
          "show-modal": n.value,
          "initial-values": o.value,
          "modal-container": e.modalContainer,
          customValues: t.customValues,
          onOnSave: a,
          onOnModalClose: d[1] || (d[1] = (p) => n.value = !1),
          onOnRemove: l
        }, null, 8, ["editor", "show-modal", "initial-values", "modal-container", "customValues"])) : Oe("", !0)
      ], 64);
    };
  }
});
Cu.install = (e) => {
  e.component(Cu.name, Cu);
};
const ple = Ot.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "blockquote",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      es({
        find: gD,
        type: this.type
      })
    ];
  }
}), hle = Ur.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "strong",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      gi({
        find: ZA,
        type: this.type
      }),
      gi({
        find: KA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ao({
        find: GA,
        type: this.type
      }),
      Ao({
        find: qA,
        type: this.type
      })
    ];
  }
}), gle = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))$/, mle = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))/g, fD = Ur.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !0,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      },
      ...hr()
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return e.style && (e.style = $C(e.style)), [
      "mark",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: t }) => t.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      gi({
        find: gle,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ao({
        find: mle,
        type: this.type
      })
    ];
  }
}), ls = Ur.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "span",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: t }) => {
        const r = p0(e, this.type);
        return Object.entries(r).some(
          ([, o]) => !!o
        ) ? !0 : t.unsetMark(this.name);
      }
    };
  }
}), pD = dt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.color) == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark(ls.name, { color: `${e} !important` }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark(ls.name, { color: null }).removeEmptyTextStyle().run()
    };
  }
}), kue = dt.create({
  name: "color",
  addExtensions() {
    return [pD, ls, fD];
  }
}), vle = dt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (e) => {
              var t;
              return (t = e.style.fontFamily) == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), hD = Ot.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      },
      ...hr()
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    const n = this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0];
    return t.style && (t.style = $C(t.style)), [
      `h${n}`,
      lt(this.options.HTMLAttributes, t),
      0
    ];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "heading", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, t) => ({
        ...e,
        [`Mod-Alt-${t}`]: () => {
          let r = this.editor.getAttributes("heading");
          Mr(r) && (r = this.editor.getAttributes("paragraph")), this.editor.commands.toggleHeading({ ...r, level: t });
        }
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => Mg({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), ble = Ur.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "em",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      gi({
        find: ZA,
        type: this.type
      }),
      gi({
        find: KA,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ao({
        find: GA,
        type: this.type
      }),
      Ao({
        find: qA,
        type: this.type
      })
    ];
  }
}), Mle = dt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["paragraph", "heading"],
      defaultLineHeight: "inherit"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: this.options.defaultLineHeight,
            parseHTML: (e) => e.style.lineHeight || this.options.defaultLineHeight,
            renderHTML: (e) => e.lineHeight === this.options.defaultLineHeight ? {} : { style: `line-height: ${e.lineHeight}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ commands: t }) => this.options.types.every(
        (r) => t.updateAttributes(r, { lineHeight: e })
      )
    };
  }
}), gD = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/, yle = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g, xle = Ur.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "s",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-x": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      gi({
        find: gD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ao({
        find: yle,
        type: this.type
      })
    ];
  }
}), wle = Ur.create({
  name: "subscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sub"
      },
      {
        style: "vertical-align",
        getAttrs(e) {
          return e !== "sub" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "sub",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleSubscript: () => ({ commands: e }) => e.toggleMark(this.name)
    };
  }
}), Tle = Ur.create({
  name: "superscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sup"
      },
      {
        style: "vertical-align",
        getAttrs(e) {
          return e !== "super" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "sup",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleSuperscript: () => ({ commands: e }) => e.toggleMark(this.name)
    };
  }
}), mD = Ot.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "p",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setCustomParagraph: (e) => ({ commands: t }) => t.setNode(this.name, e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => {
        let e = this.editor.getAttributes("heading");
        return Mr(e) && (e = this.editor.getAttributes("paragraph")), this.editor.commands.setCustomParagraph({ ...e });
      }
    };
  }
}), Eue = dt.create({
  name: "textBlocks",
  addExtensions() {
    const e = [];
    return e.push(mD, hD), e;
  }
}), vD = dt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (e) => e.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (e) => e.fontSize ? (e.fontSize = a7(e.fontSize), {
              style: `font-size: ${e.fontSize}`
            }) : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), Lue = dt.create({
  name: "textSize",
  addExtensions() {
    const e = [];
    return e.push(vD, ls), e;
  }
}), Nle = Ur.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "u",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), Sle = dt.create({
  name: "placeholder",
  addOptions() {
    return {
      showForAllNodes: !0,
      color: "#adb5bd",
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Nr({
        key: new pr("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const r = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: n } = t, o = [];
            if (!r)
              return null;
            const i = e.type.createAndFill(), a = (i == null ? void 0 : i.sameMarkup(e)) && i.content.findDiffStart(e.content) === null;
            return e.descendants((l, s) => {
              const c = n >= s && n <= s + l.nodeSize, u = !l.isLeaf && !l.childCount;
              if ((c || !this.options.showOnlyCurrent) && u) {
                const d = [];
                a && d.push(this.options.emptyEditorClass), this.options.showForAllNodes && d.push(this.options.emptyNodeClass);
                const f = tn.node(s, s + l.nodeSize, {
                  class: d.join(" "),
                  style: `--text-color:${this.options.color};`,
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: l,
                    pos: s,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                o.push(f);
              }
              return this.options.includeChildren;
            }), Pt.create(e, o);
          }
        }
      })
    ];
  }
}), Cle = dt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: (e) => e.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${e.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.every(
        (r) => t.updateAttributes(r, { textAlign: e })
      ) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.every(
        (t) => e.resetAttributes(t, "textAlign")
      )
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), ss = dt.create({
  name: "_textExtensions",
  addExtensions() {
    var e;
    return [
      hle.configure(this.options.bold),
      ble.configure((e = this.options) == null ? void 0 : e.italic),
      Nle.configure(this.options.underline),
      xle.configure(this.options.strike),
      wle.configure(this.options.subScript),
      Tle.configure(this.options.superScript),
      vD.configure(this.options.fontSize),
      ple.configure(this.options.blockQuote),
      vle.configure(this.options.fontFamily),
      hD.configure(this.options.heading),
      Cle.configure(this.options.textAlignment),
      pD,
      ls,
      fD,
      Mle.configure(this.options.lineHeight),
      Sle.configure(this.options.placeholder)
    ];
  }
}), Ile = /^```([a-z]+)?[\s\n]$/, Ale = /^~~~([a-z]+)?[\s\n]$/, bD = Ot.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      ...hr(),
      language: {
        default: null,
        parseHTML: (e) => {
          var i;
          const { languageClassPrefix: t } = this.options, o = [...((i = e.firstElementChild) == null ? void 0 : i.classList) || []].filter((a) => a.startsWith(t)).map((a) => a.replace(t, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    const r = {
      style: "background: #0d0d0d;color: #fff;font-family: 'JetBrainsMono', monospace;padding: 0.75rem 1rem;border-radius: 0.5rem;",
      ...t
    };
    return [
      "pre",
      lt(this.options.HTMLAttributes, r),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null,
          style: "color: inherit;padding: 0;background: none;font-size: 0.8rem;"
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, r = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : r || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: r } = t, { $from: n, empty: o } = r;
        if (!o || n.parent.type !== this.type)
          return !1;
        const i = n.parentOffset === n.parent.nodeSize - 2, a = n.parent.textContent.endsWith(`

`);
        return !i || !a ? !1 : e.chain().command(({ tr: l }) => (l.delete(n.pos - 2, n.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: r, doc: n } = t, { $from: o, empty: i } = r;
        if (!i || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const l = o.after();
        return l === void 0 || n.nodeAt(l) ? !1 : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Mg({
        find: Ile,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Mg({
        find: Ale,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Nr({
        key: new pr("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const r = t.clipboardData.getData("text/plain"), n = t.clipboardData.getData("vscode-editor-data"), o = n ? JSON.parse(n) : void 0, i = o == null ? void 0 : o.mode;
            if (!r || !i)
              return !1;
            const { tr: a } = e.state;
            return a.replaceSelectionWith(this.type.create({ language: i })), a.setSelection(
              Qe.near(
                a.doc.resolve(Math.max(0, a.selection.from - 2))
              )
            ), a.insertText(r.replace(/\r\n?/g, `
`)), a.setMeta("paste", !0), e.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), Dle = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/, kle = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g, MD = Ur.create({
  name: "inlineCode",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    const t = {
      style: "background-color: rgba(97, 97, 97, 0.1);color: #616161;",
      ...e
    };
    return ["code", lt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setInlineCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleInlineCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetInlineCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleInlineCode()
    };
  },
  addInputRules() {
    return [
      gi({
        find: Dle,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Ao({
        find: kle,
        type: this.type
      })
    ];
  }
}), $ue = dt.create({
  name: "codeFormats",
  addExtensions() {
    return [MD, bD];
  }
}), Ele = dt.create({
  name: "_codeExtensions",
  addExtensions() {
    return [
      MD.configure(this.options.inlineCode),
      bD.configure(this.options.codeBlock)
    ];
  }
}), Lle = Ot.create({
  name: "divTag",
  addOptions() {
    return {
      preserveWhitespace: "full",
      inline: !1,
      HTMLAttributes: {}
    };
  },
  priority: 1e3,
  content() {
    return `${this.options.inline ? "inline" : "block"}*`;
  },
  group: "block",
  addAttributes() {
    return {
      ...hr(),
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div",
        preserveWhitespace: this.options.preserveWhitespace
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "div",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setDivTag: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleDivTag: (e) => ({ commands: t }) => t.toggleNode(this.name, "divTag", e)
    };
  }
}), $le = Ot.create({
  name: "preTag",
  priority: 1e3,
  content() {
    return `${this.options.inline ? "inline" : "block"}*`;
  },
  group: "block",
  addOptions() {
    return {
      preserveWhitespace: "full",
      inline: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      ...hr(),
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: this.options.preserveWhitespace
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "pre",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setPreTag: (e) => ({ commands: t }) => t.setNode(this.name, e),
      togglePreTag: (e) => ({ commands: t }) => t.toggleNode(this.name, "preTag", e)
    };
  }
}), zle = dt.create({
  name: "_customTags",
  addExtensions() {
    return [
      Lle.configure(this.options.divTag),
      $le.configure(this.options.preTag)
    ];
  }
}), Ole = Ot.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", lt(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: r, editor: n }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: o, storedMarks: i } = r;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: l } = n.extensionManager, s = i || o.$to.parentOffset && o.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && s && a) {
              const d = s.filter(
                (f) => l.includes(f.type.name)
              );
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), Z0 = wu.extend({
  addAttributes() {
    return {
      ...hr(),
      textAlign: {
        default: null,
        parseHTML: (e) => e.style.textAlign || null,
        renderHTML: (e) => e.textAlign ? {
          style: `text-align:${e.textAlign}`
        } : {}
      },
      listColor: {
        default: null,
        parseHTML: (e) => e.style.color,
        renderHTML: (e) => e.listColor ? {
          style: `color: ${e.listColor}`
        } : {}
      }
    };
  }
}), jle = dt.create({
  name: "_listExtensions",
  addExtensions() {
    return [
      Kse.configure(this.options.bulletList),
      mue.configure(this.options.orderedList),
      Z0.configure(this.options.customList)
    ];
  }
}), Rle = ["href", "rel"], _le = { key: 2 }, Ple = /* @__PURE__ */ Z({
  __name: "ImageResizer",
  props: {
    editor: {
      type: Object,
      required: !0
    },
    node: {
      type: Object,
      required: !0
    },
    updateAttributes: {
      type: Function,
      required: !0
    },
    language: {
      type: String,
      default: pt.English_US
    }
  },
  setup(e) {
    const t = e, r = De("locale") ?? ht[t.language], n = L(!1), o = L(!1), i = L(null), a = L({ width: 0, height: 0 }), l = L(-1), s = L(-1), c = L(null), u = L(0), d = W(() => `;width: ${t.node.attrs.width}px;height: ${t.node.attrs.height}px;`), f = W(() => {
      const w = t.node.attrs["data-wrap"] ?? null, y = t.node.attrs["data-alignment"] ?? null;
      return w ? ` wrap-${w} ` : y ? ` alignment-${y} ` : "";
    }), p = (w) => x(w, "horizontal"), h = (w) => x(w, "vertical"), g = (w) => {
      n.value = !0, l.value = w.clientX, document.addEventListener("mousemove", p), document.addEventListener("mouseup", m);
    }, m = () => {
      n.value = !1, l.value = -1, document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", m);
    }, v = (w) => {
      o.value = !0, s.value = w.clientY, document.addEventListener("mousemove", h), document.addEventListener("mouseup", M);
    }, M = () => {
      o.value = !0, s.value = -1, document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", M);
    };
    et(() => {
      const w = document.querySelector(".ProseMirror");
      w && (u.value = w == null ? void 0 : w.clientWidth), c.value && (c.value.onload = () => {
        var I;
        const y = (I = c.value.getClientRects()) == null ? void 0 : I[0];
        y && (a.value = {
          width: y.width,
          height: y.height
        }), y.width && y.height ? i.value = Math.abs(y.width / y.height) ?? null : console.warn(
          `text-editor - unable to set aspect ratio with dimensions :${y}`
        );
      });
    });
    const x = (w, y) => {
      var I, D, O, $;
      switch (y) {
        case "horizontal":
        default: {
          const { clientX: z } = w, Y = l.value - z;
          l.value = z;
          const j = {
            width: (I = c.value) == null ? void 0 : I.width,
            height: (D = c.value) == null ? void 0 : D.height
          };
          Y > 0 ? j.width = j.width - Math.abs(Y) > 1 ? j.width - Math.abs(Y) : 1 : j.width = j.width + Math.abs(Y), i.value && (j.height = j.width / i.value), j.width > u.value && (j.width = u.value), t.updateAttributes(j);
          break;
        }
        case "vertical": {
          if (!o.value)
            return;
          const { clientY: z } = w, Y = s.value - z;
          if (s.value = z, Y === 0)
            return;
          const j = Y > 0 ? "up" : "down";
          if (!c.value) {
            console.error("Media ref is undefined|null", {
              resizableImg: c.value
            });
            return;
          }
          const q = {
            width: (O = c.value) == null ? void 0 : O.width,
            height: ($ = c.value) == null ? void 0 : $.height
          };
          j === "up" ? q.height = q.height - Math.abs(Y) > 1 ? q.height - Math.abs(Y) : 1 : q.height = q.height + Math.abs(Y), i.value && (q.width = q.height * i.value), t.updateAttributes(q);
        }
      }
    }, b = () => {
      var w, y;
      i.value = i.value ? null : Math.abs(((w = c.value) == null ? void 0 : w.width) / ((y = c.value) == null ? void 0 : y.height));
    }, T = W(() => {
      var w, y;
      return ((w = t.node.attrs) == null ? void 0 : w.width) > 30 && ((y = t.node.attrs) == null ? void 0 : y.height) > 30;
    });
    return (w, y) => (_(), se(N(RZ), {
      as: "article",
      class: br(["draggable__wrapper", T.value ? "" : "inline-block"])
    }, {
      default: Q(() => [
        de("div", {
          class: br(
            [
              "draggable__container",
              f.value,
              e.editor.isActive("image") ? "active" : null
            ].join(" ")
          ),
          style: Fc(d.value)
        }, [
          e.node.attrs["data-image-link"] ? (_(), be("a", {
            key: 0,
            href: e.node.attrs["data-image-link"],
            rel: e.node.attrs["data-image-link-rel"],
            target: "_blank"
          }, [
            de("img", Ut(e.node.attrs, {
              ref_key: "resizableImg",
              ref: c,
              class: "draggable__media",
              draggable: "true",
              "data-drag-handle": "",
              style: d.value
            }), null, 16)
          ], 8, Rle)) : (_(), be("img", Ut({ key: 1 }, e.node.attrs, {
            ref_key: "resizableImg",
            ref: c,
            class: "draggable__media",
            draggable: "true",
            "data-drag-handle": "",
            style: d.value
          }), null, 16)),
          e.editor.isActive("image") ? (_(), be("div", _le, [
            de("div", {
              class: "draggable__controls draggable__controls--right",
              onMousedown: g,
              onMouseup: m
            }, null, 32),
            de("div", {
              class: "draggable__controls draggable__controls--bottom",
              onMousedown: v,
              onMouseup: M
            }, null, 32),
            B(N(gs), {
              disabled: !T.value
            }, {
              trigger: Q(() => [
                on(de("div", {
                  class: "draggable__aspect-ratio",
                  onClick: b
                }, [
                  i.value ? (_(), se(N(S7), {
                    key: 0,
                    class: "icon"
                  })) : (_(), se(N(C7), {
                    key: 1,
                    class: "icon"
                  }))
                ], 512), [
                  [ci, T.value]
                ])
              ]),
              default: Q(() => [
                de("span", null, kt(i.value ? N(r).imageEmbed.unlockAspect : N(r).imageEmbed.lockAspect), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])) : Oe("", !0)
        ], 6)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function Ble(e) {
  return new Nr({
    key: new pr("handleClickLink"),
    props: {
      handleClick: (t, r, n) => {
        var o;
        if (e.type.name === "image") {
          const i = (o = n.target) == null ? void 0 : o.closest("a");
          i == null || i.addEventListener("click", (a) => {
            a.preventDefault();
          }), i && n.preventDefault();
        }
      },
      handleDOMEvents: {
        drop(t, r) {
          if (!(r.dataTransfer && r.dataTransfer.files && r.dataTransfer.files.length))
            return;
          const o = Array.from(r.dataTransfer.files).filter(
            (l) => /image/i.test(l.type)
          );
          if (o.length === 0)
            return;
          r.preventDefault();
          const { schema: i } = t.state, a = t.posAtCoords({
            left: r.clientX,
            top: r.clientY
          });
          e.uploadHandler ? (async () => {
            const s = await e.uploadHandler(r), c = i.nodes.image.create({
              src: s
            }), u = t.state.tr.insert(a.pos, c);
            t.dispatch(u);
          })() : o.forEach((l) => {
            const s = new FileReader();
            s.onload = (c) => {
              const u = i.nodes.image.create({
                src: c.target.result
              }), d = t.state.tr.insert(a.pos, u);
              t.dispatch(d);
            }, s.readAsDataURL(l);
          });
        }
      }
    }
  });
}
const Fle = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, Ule = Ot.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resizable: !0,
      uploadHandler: void 0
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      ...hr(),
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null,
        rendered: !1
      },
      height: {
        default: null,
        rendered: !1
      },
      "data-alignment": {
        default: null,
        rendered: !1
      },
      "data-wrap": {
        default: null,
        rendered: !1
      },
      "data-image-link": {
        default: null,
        rendered: !1
      },
      "data-image-link-rel": {
        default: null,
        rendered: !1
      },
      "data-image-link-target": {
        default: "_self",
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    var o, i;
    const r = U0((o = e.attrs.width) == null ? void 0 : o.toString()), n = H0((i = e.attrs.height) == null ? void 0 : i.toString());
    return t.style = JA(e.attrs.style), t.style += `width: ${r ? r + "px" : "auto"}; max-width: 100%;`, t.style += `height: ${n ? n + "px" : "auto"};`, t.style += "clear:both;", t.width = r, t.height = n, t.alt = e.attrs.alt, t.title = e.attrs.alt, e.attrs["data-wrap"] && (t.style += W0(e.attrs["data-wrap"]), t["data-wrap"] = e.attrs["data-wrap"]), e.attrs["data-alignment"] && (t.style += Y0(e.attrs["data-alignment"]), t.style += "float: none;", t["data-alignment"] = e.attrs["data-alignment"]), e.attrs["data-image-link"] ? (t["data-image-link"] = e.attrs["data-image-link"], t["data-image-link-rel"] = e.attrs["data-image-link-rel"], t["data-image-link-target"] = e.attrs["data-image-link-target"], [
      "a",
      {
        href: e.attrs["data-image-link"],
        rel: e.attrs["data-image-link-rel"],
        target: e.attrs["data-image-link-target"]
      },
      ["img", lt(this.options.HTMLAttributes, t)]
    ]) : ["img", lt(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      sQ({
        find: Fle,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, r, n] = e;
          return { src: r, alt: t, title: n };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return e.push(
      Ble({
        type: this.type,
        uploadHandler: this.options.uploadHandler
      })
    ), e;
  },
  addNodeView() {
    return this.options.resizable ? BZ(Ple) : ({ node: e }) => e;
  }
}), Hle = dt.create({
  name: "_mediaExtensions",
  addExtensions() {
    var e, t;
    return [
      Eoe.configure((e = this.options) == null ? void 0 : e.video),
      $oe.configure(this.options.youtube),
      Ule.configure((t = this.options) == null ? void 0 : t.image),
      gue
    ];
  }
}), Yle = Ot.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), Wle = Ot.create({
  name: "text",
  group: "inline"
}), Qle = dt.create({
  name: "_requiredExtensions",
  addExtensions() {
    var e;
    return [Yle, Wle, mD.configure((e = this.options) == null ? void 0 : e.paragraph)];
  }
});
var Pg, Bg;
if (typeof WeakMap < "u") {
  let e = /* @__PURE__ */ new WeakMap();
  Pg = (t) => e.get(t), Bg = (t, r) => (e.set(t, r), r);
} else {
  const e = [];
  let r = 0;
  Pg = (n) => {
    for (let o = 0; o < e.length; o += 2)
      if (e[o] == n)
        return e[o + 1];
  }, Bg = (n, o) => (r == 10 && (r = 0), e[r++] = n, e[r++] = o);
}
var Lt = class {
  constructor(e, t, r, n) {
    this.width = e, this.height = t, this.map = r, this.problems = n;
  }
  // Find the dimensions of the cell at the given position.
  findCell(e) {
    for (let t = 0; t < this.map.length; t++) {
      const r = this.map[t];
      if (r != e)
        continue;
      const n = t % this.width, o = t / this.width | 0;
      let i = n + 1, a = o + 1;
      for (let l = 1; i < this.width && this.map[t + l] == r; l++)
        i++;
      for (let l = 1; a < this.height && this.map[t + this.width * l] == r; l++)
        a++;
      return { left: n, top: o, right: i, bottom: a };
    }
    throw new RangeError(`No cell with offset ${e} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(e) {
    for (let t = 0; t < this.map.length; t++)
      if (this.map[t] == e)
        return t % this.width;
    throw new RangeError(`No cell with offset ${e} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(e, t, r) {
    const { left: n, right: o, top: i, bottom: a } = this.findCell(e);
    return t == "horiz" ? (r < 0 ? n == 0 : o == this.width) ? null : this.map[i * this.width + (r < 0 ? n - 1 : o)] : (r < 0 ? i == 0 : a == this.height) ? null : this.map[n + this.width * (r < 0 ? i - 1 : a)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(e, t) {
    const {
      left: r,
      right: n,
      top: o,
      bottom: i
    } = this.findCell(e), {
      left: a,
      right: l,
      top: s,
      bottom: c
    } = this.findCell(t);
    return {
      left: Math.min(r, a),
      top: Math.min(o, s),
      right: Math.max(n, l),
      bottom: Math.max(i, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(e) {
    const t = [], r = {};
    for (let n = e.top; n < e.bottom; n++)
      for (let o = e.left; o < e.right; o++) {
        const i = n * this.width + o, a = this.map[i];
        r[a] || (r[a] = !0, !(o == e.left && o && this.map[i - 1] == a || n == e.top && n && this.map[i - this.width] == a) && t.push(a));
      }
    return t;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(e, t, r) {
    for (let n = 0, o = 0; ; n++) {
      const i = o + r.child(n).nodeSize;
      if (n == e) {
        let a = t + e * this.width;
        const l = (e + 1) * this.width;
        for (; a < l && this.map[a] < o; )
          a++;
        return a == l ? i - 1 : this.map[a];
      }
      o = i;
    }
  }
  // Find the table map for the given table node.
  static get(e) {
    return Pg(e) || Bg(e, Vle(e));
  }
};
function Vle(e) {
  if (e.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + e.type.name);
  const t = Zle(e), r = e.childCount, n = [];
  let o = 0, i = null;
  const a = [];
  for (let c = 0, u = t * r; c < u; c++)
    n[c] = 0;
  for (let c = 0, u = 0; c < r; c++) {
    const d = e.child(c);
    u++;
    for (let h = 0; ; h++) {
      for (; o < n.length && n[o] != 0; )
        o++;
      if (h == d.childCount)
        break;
      const g = d.child(h), { colspan: m, rowspan: v, colwidth: M } = g.attrs;
      for (let x = 0; x < v; x++) {
        if (x + c >= r) {
          (i || (i = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: v - x
          });
          break;
        }
        const b = o + x * t;
        for (let T = 0; T < m; T++) {
          n[b + T] == 0 ? n[b + T] = u : (i || (i = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: m - T
          });
          const w = M && M[T];
          if (w) {
            const y = (b + T) % t * 2, I = a[y];
            I == null || I != w && a[y + 1] == 1 ? (a[y] = w, a[y + 1] = 1) : I == w && a[y + 1]++;
          }
        }
      }
      o += m, u += g.nodeSize;
    }
    const f = (c + 1) * t;
    let p = 0;
    for (; o < f; )
      n[o++] == 0 && p++;
    p && (i || (i = [])).push({ type: "missing", row: c, n: p }), u++;
  }
  const l = new Lt(t, r, n, i);
  let s = !1;
  for (let c = 0; !s && c < a.length; c += 2)
    a[c] != null && a[c + 1] < r && (s = !0);
  return s && Gle(l, a, e), l;
}
function Zle(e) {
  let t = -1, r = !1;
  for (let n = 0; n < e.childCount; n++) {
    const o = e.child(n);
    let i = 0;
    if (r)
      for (let a = 0; a < n; a++) {
        const l = e.child(a);
        for (let s = 0; s < l.childCount; s++) {
          const c = l.child(s);
          a + c.attrs.rowspan > n && (i += c.attrs.colspan);
        }
      }
    for (let a = 0; a < o.childCount; a++) {
      const l = o.child(a);
      i += l.attrs.colspan, l.attrs.rowspan > 1 && (r = !0);
    }
    t == -1 ? t = i : t != i && (t = Math.max(t, i));
  }
  return t;
}
function Gle(e, t, r) {
  e.problems || (e.problems = []);
  const n = {};
  for (let o = 0; o < e.map.length; o++) {
    const i = e.map[o];
    if (n[i])
      continue;
    n[i] = !0;
    const a = r.nodeAt(i);
    if (!a)
      throw new RangeError(`No cell with offset ${i} found`);
    let l = null;
    const s = a.attrs;
    for (let c = 0; c < s.colspan; c++) {
      const u = (o + c) % e.width, d = t[u * 2];
      d != null && (!s.colwidth || s.colwidth[c] != d) && ((l || (l = Kle(s)))[c] = d);
    }
    l && e.problems.unshift({
      type: "colwidth mismatch",
      pos: i,
      colwidth: l
    });
  }
}
function Kle(e) {
  if (e.colwidth)
    return e.colwidth.slice();
  const t = [];
  for (let r = 0; r < e.colspan; r++)
    t.push(0);
  return t;
}
function cr(e) {
  let t = e.cached.tableNodeTypes;
  if (!t) {
    t = e.cached.tableNodeTypes = {};
    for (const r in e.nodes) {
      const n = e.nodes[r], o = n.spec.tableRole;
      o && (t[o] = n);
    }
  }
  return t;
}
var mo = new pr("selectingCells");
function Ua(e) {
  for (let t = e.depth - 1; t > 0; t--)
    if (e.node(t).type.spec.tableRole == "row")
      return e.node(0).resolve(e.before(t + 1));
  return null;
}
function qle(e) {
  for (let t = e.depth; t > 0; t--) {
    const r = e.node(t).type.spec.tableRole;
    if (r === "cell" || r === "header_cell")
      return e.node(t);
  }
  return null;
}
function Tn(e) {
  const t = e.selection.$head;
  for (let r = t.depth; r > 0; r--)
    if (t.node(r).type.spec.tableRole == "row")
      return !0;
  return !1;
}
function yd(e) {
  const t = e.selection;
  if ("$anchorCell" in t && t.$anchorCell)
    return t.$anchorCell.pos > t.$headCell.pos ? t.$anchorCell : t.$headCell;
  if ("node" in t && t.node && t.node.type.spec.tableRole == "cell")
    return t.$anchor;
  const r = Ua(t.$head) || Jle(t.$head);
  if (r)
    return r;
  throw new RangeError(`No cell found around position ${t.head}`);
}
function Jle(e) {
  for (let t = e.nodeAfter, r = e.pos; t; t = t.firstChild, r++) {
    const n = t.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return e.doc.resolve(r);
  }
  for (let t = e.nodeBefore, r = e.pos; t; t = t.lastChild, r--) {
    const n = t.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return e.doc.resolve(r - t.nodeSize);
  }
}
function Fg(e) {
  return e.parent.type.spec.tableRole == "row" && !!e.nodeAfter;
}
function Xle(e) {
  return e.node(0).resolve(e.pos + e.nodeAfter.nodeSize);
}
function G0(e, t) {
  return e.depth == t.depth && e.pos >= t.start(-1) && e.pos <= t.end(-1);
}
function yD(e, t, r) {
  const n = e.node(-1), o = Lt.get(n), i = e.start(-1), a = o.nextCell(e.pos - i, t, r);
  return a == null ? null : e.node(0).resolve(i + a);
}
function vi(e, t, r = 1) {
  const n = { ...e, colspan: e.colspan - r };
  return n.colwidth && (n.colwidth = n.colwidth.slice(), n.colwidth.splice(t, r), n.colwidth.some((o) => o > 0) || (n.colwidth = null)), n;
}
function xD(e, t, r = 1) {
  const n = { ...e, colspan: e.colspan + r };
  if (n.colwidth) {
    n.colwidth = n.colwidth.slice();
    for (let o = 0; o < r; o++)
      n.colwidth.splice(t, 0, 0);
  }
  return n;
}
function ese(e, t, r) {
  const n = cr(t.type.schema).header_cell;
  for (let o = 0; o < e.height; o++)
    if (t.nodeAt(e.map[r + o * e.width]).type != n)
      return !1;
  return !0;
}
var Mt = class Wn extends Ze {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(t, r = t) {
    const n = t.node(-1), o = Lt.get(n), i = t.start(-1), a = o.rectBetween(
      t.pos - i,
      r.pos - i
    ), l = t.node(0), s = o.cellsInRect(a).filter((u) => u != r.pos - i);
    s.unshift(r.pos - i);
    const c = s.map((u) => {
      const d = n.nodeAt(u);
      if (!d)
        throw RangeError(`No cell with offset ${u} found`);
      const f = i + u + 1;
      return new XC(
        l.resolve(f),
        l.resolve(f + d.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = t, this.$headCell = r;
  }
  map(t, r) {
    const n = t.resolve(r.map(this.$anchorCell.pos)), o = t.resolve(r.map(this.$headCell.pos));
    if (Fg(n) && Fg(o) && G0(n, o)) {
      const i = this.$anchorCell.node(-1) != n.node(-1);
      return i && this.isRowSelection() ? Wn.rowSelection(n, o) : i && this.isColSelection() ? Wn.colSelection(n, o) : new Wn(n, o);
    }
    return Qe.between(n, o);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const t = this.$anchorCell.node(-1), r = Lt.get(t), n = this.$anchorCell.start(-1), o = r.rectBetween(
      this.$anchorCell.pos - n,
      this.$headCell.pos - n
    ), i = {}, a = [];
    for (let s = o.top; s < o.bottom; s++) {
      const c = [];
      for (let u = s * r.width + o.left, d = o.left; d < o.right; d++, u++) {
        const f = r.map[u];
        if (i[f])
          continue;
        i[f] = !0;
        const p = r.findCell(f);
        let h = t.nodeAt(f);
        if (!h)
          throw RangeError(`No cell with offset ${f} found`);
        const g = o.left - p.left, m = p.right - o.right;
        if (g > 0 || m > 0) {
          let v = h.attrs;
          if (g > 0 && (v = vi(v, 0, g)), m > 0 && (v = vi(
            v,
            v.colspan - m,
            m
          )), p.left < o.left) {
            if (h = h.type.createAndFill(v), !h)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(v)}`
              );
          } else
            h = h.type.create(v, h.content);
        }
        if (p.top < o.top || p.bottom > o.bottom) {
          const v = {
            ...h.attrs,
            rowspan: Math.min(p.bottom, o.bottom) - Math.max(p.top, o.top)
          };
          p.top < o.top ? h = h.type.createAndFill(v) : h = h.type.create(v, h.content);
        }
        c.push(h);
      }
      a.push(t.child(s).copy(pe.from(c)));
    }
    const l = this.isColSelection() && this.isRowSelection() ? t : a;
    return new we(pe.from(l), 1, 1);
  }
  replace(t, r = we.empty) {
    const n = t.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      const { $from: l, $to: s } = o[a], c = t.mapping.slice(n);
      t.replace(
        c.map(l.pos),
        c.map(s.pos),
        a ? we.empty : r
      );
    }
    const i = Ze.findFrom(
      t.doc.resolve(t.mapping.slice(n).map(this.to)),
      -1
    );
    i && t.setSelection(i);
  }
  replaceWith(t, r) {
    this.replace(t, new we(pe.from(r), 0, 0));
  }
  forEachCell(t) {
    const r = this.$anchorCell.node(-1), n = Lt.get(r), o = this.$anchorCell.start(-1), i = n.cellsInRect(
      n.rectBetween(
        this.$anchorCell.pos - o,
        this.$headCell.pos - o
      )
    );
    for (let a = 0; a < i.length; a++)
      t(r.nodeAt(i[a]), o + i[a]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const t = this.$anchorCell.index(-1), r = this.$headCell.index(-1);
    if (Math.min(t, r) > 0)
      return !1;
    const n = t + this.$anchorCell.nodeAfter.attrs.rowspan, o = r + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(n, o) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(t, r = t) {
    const n = t.node(-1), o = Lt.get(n), i = t.start(-1), a = o.findCell(t.pos - i), l = o.findCell(r.pos - i), s = t.node(0);
    return a.top <= l.top ? (a.top > 0 && (t = s.resolve(i + o.map[a.left])), l.bottom < o.height && (r = s.resolve(
      i + o.map[o.width * (o.height - 1) + l.right - 1]
    ))) : (l.top > 0 && (r = s.resolve(i + o.map[l.left])), a.bottom < o.height && (t = s.resolve(
      i + o.map[o.width * (o.height - 1) + a.right - 1]
    ))), new Wn(t, r);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const t = this.$anchorCell.node(-1), r = Lt.get(t), n = this.$anchorCell.start(-1), o = r.colCount(this.$anchorCell.pos - n), i = r.colCount(this.$headCell.pos - n);
    if (Math.min(o, i) > 0)
      return !1;
    const a = o + this.$anchorCell.nodeAfter.attrs.colspan, l = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(a, l) == r.width;
  }
  eq(t) {
    return t instanceof Wn && t.$anchorCell.pos == this.$anchorCell.pos && t.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(t, r = t) {
    const n = t.node(-1), o = Lt.get(n), i = t.start(-1), a = o.findCell(t.pos - i), l = o.findCell(r.pos - i), s = t.node(0);
    return a.left <= l.left ? (a.left > 0 && (t = s.resolve(
      i + o.map[a.top * o.width]
    )), l.right < o.width && (r = s.resolve(
      i + o.map[o.width * (l.top + 1) - 1]
    ))) : (l.left > 0 && (r = s.resolve(i + o.map[l.top * o.width])), a.right < o.width && (t = s.resolve(
      i + o.map[o.width * (a.top + 1) - 1]
    ))), new Wn(t, r);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(t, r) {
    return new Wn(t.resolve(r.anchor), t.resolve(r.head));
  }
  static create(t, r, n = r) {
    return new Wn(t.resolve(r), t.resolve(n));
  }
  getBookmark() {
    return new tse(this.$anchorCell.pos, this.$headCell.pos);
  }
};
Mt.prototype.visible = !1;
Ze.jsonID("cell", Mt);
var tse = class wD {
  constructor(t, r) {
    this.anchor = t, this.head = r;
  }
  map(t) {
    return new wD(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    const r = t.resolve(this.anchor), n = t.resolve(this.head);
    return r.parent.type.spec.tableRole == "row" && n.parent.type.spec.tableRole == "row" && r.index() < r.parent.childCount && n.index() < n.parent.childCount && G0(r, n) ? new Mt(r, n) : Ze.near(n, 1);
  }
};
function rse(e) {
  if (!(e.selection instanceof Mt))
    return null;
  const t = [];
  return e.selection.forEachCell((r, n) => {
    t.push(
      tn.node(n, n + r.nodeSize, { class: "selectedCell" })
    );
  }), Pt.create(e.doc, t);
}
function nse({ $from: e, $to: t }) {
  if (e.pos == t.pos || e.pos < e.pos - 6)
    return !1;
  let r = e.pos, n = t.pos, o = e.depth;
  for (; o >= 0 && !(e.after(o + 1) < e.end(o)); o--, r++)
    ;
  for (let i = t.depth; i >= 0 && !(t.before(i + 1) > t.start(i)); i--, n--)
    ;
  return r == n && /row|table/.test(e.node(o).type.spec.tableRole);
}
function ose({ $from: e, $to: t }) {
  let r, n;
  for (let o = e.depth; o > 0; o--) {
    const i = e.node(o);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      r = i;
      break;
    }
  }
  for (let o = t.depth; o > 0; o--) {
    const i = t.node(o);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      n = i;
      break;
    }
  }
  return r !== n && t.parentOffset === 0;
}
function ise(e, t, r) {
  const n = (t || e).selection, o = (t || e).doc;
  let i, a;
  if (n instanceof Pe && (a = n.node.type.spec.tableRole)) {
    if (a == "cell" || a == "header_cell")
      i = Mt.create(o, n.from);
    else if (a == "row") {
      const l = o.resolve(n.from + 1);
      i = Mt.rowSelection(l, l);
    } else if (!r) {
      const l = Lt.get(n.node), s = n.from + 1, c = s + l.map[l.width * l.height - 1];
      i = Mt.create(o, s + 1, c);
    }
  } else
    n instanceof Qe && nse(n) ? i = Qe.create(o, n.from) : n instanceof Qe && ose(n) && (i = Qe.create(o, n.$from.start(), n.$from.end()));
  return i && (t || (t = e.tr)).setSelection(i), t;
}
var ase = new pr("fix-tables");
function TD(e, t, r, n) {
  const o = e.childCount, i = t.childCount;
  e:
    for (let a = 0, l = 0; a < i; a++) {
      const s = t.child(a);
      for (let c = l, u = Math.min(o, a + 3); c < u; c++)
        if (e.child(c) == s) {
          l = c + 1, r += s.nodeSize;
          continue e;
        }
      n(s, r), l < o && e.child(l).sameMarkup(s) ? TD(e.child(l), s, r + 1, n) : s.nodesBetween(0, s.content.size, n, r + 1), r += s.nodeSize;
    }
}
function ND(e, t) {
  let r;
  const n = (o, i) => {
    o.type.spec.tableRole == "table" && (r = lse(e, o, i, r));
  };
  return t ? t.doc != e.doc && TD(t.doc, e.doc, 0, n) : e.doc.descendants(n), r;
}
function lse(e, t, r, n) {
  const o = Lt.get(t);
  if (!o.problems)
    return n;
  n || (n = e.tr);
  const i = [];
  for (let s = 0; s < o.height; s++)
    i.push(0);
  for (let s = 0; s < o.problems.length; s++) {
    const c = o.problems[s];
    if (c.type == "collision") {
      const u = t.nodeAt(c.pos);
      if (!u)
        continue;
      const d = u.attrs;
      for (let f = 0; f < d.rowspan; f++)
        i[c.row + f] += c.n;
      n.setNodeMarkup(
        n.mapping.map(r + 1 + c.pos),
        null,
        vi(d, d.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      i[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const u = t.nodeAt(c.pos);
      if (!u)
        continue;
      n.setNodeMarkup(n.mapping.map(r + 1 + c.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const u = t.nodeAt(c.pos);
      if (!u)
        continue;
      n.setNodeMarkup(n.mapping.map(r + 1 + c.pos), null, {
        ...u.attrs,
        colwidth: c.colwidth
      });
    }
  }
  let a, l;
  for (let s = 0; s < i.length; s++)
    i[s] && (a == null && (a = s), l = s);
  for (let s = 0, c = r + 1; s < o.height; s++) {
    const u = t.child(s), d = c + u.nodeSize, f = i[s];
    if (f > 0) {
      let p = "cell";
      u.firstChild && (p = u.firstChild.type.spec.tableRole);
      const h = [];
      for (let m = 0; m < f; m++) {
        const v = cr(e.schema)[p].createAndFill();
        v && h.push(v);
      }
      const g = (s == 0 || a == s - 1) && l == s ? c + 1 : d - 1;
      n.insert(n.mapping.map(g), h);
    }
    c = d;
  }
  return n.setMeta(ase, { fixTables: !0 });
}
function sse(e) {
  if (!e.size)
    return null;
  let { content: t, openStart: r, openEnd: n } = e;
  for (; t.childCount == 1 && (r > 0 && n > 0 || t.child(0).type.spec.tableRole == "table"); )
    r--, n--, t = t.child(0).content;
  const o = t.child(0), i = o.type.spec.tableRole, a = o.type.schema, l = [];
  if (i == "row")
    for (let s = 0; s < t.childCount; s++) {
      let c = t.child(s).content;
      const u = s ? 0 : Math.max(0, r - 1), d = s < t.childCount - 1 ? 0 : Math.max(0, n - 1);
      (u || d) && (c = Ug(
        cr(a).row,
        new we(c, u, d)
      ).content), l.push(c);
    }
  else if (i == "cell" || i == "header_cell")
    l.push(
      r || n ? Ug(
        cr(a).row,
        new we(t, r, n)
      ).content : t
    );
  else
    return null;
  return use(a, l);
}
function use(e, t) {
  const r = [];
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    for (let a = i.childCount - 1; a >= 0; a--) {
      const { rowspan: l, colspan: s } = i.child(a).attrs;
      for (let c = o; c < o + l; c++)
        r[c] = (r[c] || 0) + s;
    }
  }
  let n = 0;
  for (let o = 0; o < r.length; o++)
    n = Math.max(n, r[o]);
  for (let o = 0; o < r.length; o++)
    if (o >= t.length && t.push(pe.empty), r[o] < n) {
      const i = cr(e).cell.createAndFill(), a = [];
      for (let l = r[o]; l < n; l++)
        a.push(i);
      t[o] = t[o].append(pe.from(a));
    }
  return { height: t.length, width: n, rows: t };
}
function Ug(e, t) {
  const r = e.createAndFill();
  return new JC(r).replace(0, r.content.size, t).doc;
}
function cse({ width: e, height: t, rows: r }, n, o) {
  if (e != n) {
    const i = [], a = [];
    for (let l = 0; l < r.length; l++) {
      const s = r[l], c = [];
      for (let u = i[l] || 0, d = 0; u < n; d++) {
        let f = s.child(d % s.childCount);
        u + f.attrs.colspan > n && (f = f.type.createChecked(
          vi(
            f.attrs,
            f.attrs.colspan,
            u + f.attrs.colspan - n
          ),
          f.content
        )), c.push(f), u += f.attrs.colspan;
        for (let p = 1; p < f.attrs.rowspan; p++)
          i[l + p] = (i[l + p] || 0) + f.attrs.colspan;
      }
      a.push(pe.from(c));
    }
    r = a, e = n;
  }
  if (t != o) {
    const i = [];
    for (let a = 0, l = 0; a < o; a++, l++) {
      const s = [], c = r[l % t];
      for (let u = 0; u < c.childCount; u++) {
        let d = c.child(u);
        a + d.attrs.rowspan > o && (d = d.type.create(
          {
            ...d.attrs,
            rowspan: Math.max(1, o - d.attrs.rowspan)
          },
          d.content
        )), s.push(d);
      }
      i.push(pe.from(s));
    }
    r = i, t = o;
  }
  return { width: e, height: t, rows: r };
}
function dse(e, t, r, n, o, i, a) {
  const l = e.doc.type.schema, s = cr(l);
  let c, u;
  if (o > t.width)
    for (let d = 0, f = 0; d < t.height; d++) {
      const p = r.child(d);
      f += p.nodeSize;
      const h = [];
      let g;
      p.lastChild == null || p.lastChild.type == s.cell ? g = c || (c = s.cell.createAndFill()) : g = u || (u = s.header_cell.createAndFill());
      for (let m = t.width; m < o; m++)
        h.push(g);
      e.insert(e.mapping.slice(a).map(f - 1 + n), h);
    }
  if (i > t.height) {
    const d = [];
    for (let h = 0, g = (t.height - 1) * t.width; h < Math.max(t.width, o); h++) {
      const m = h >= t.width ? !1 : r.nodeAt(t.map[g + h]).type == s.header_cell;
      d.push(
        m ? u || (u = s.header_cell.createAndFill()) : c || (c = s.cell.createAndFill())
      );
    }
    const f = s.row.create(null, pe.from(d)), p = [];
    for (let h = t.height; h < i; h++)
      p.push(f);
    e.insert(e.mapping.slice(a).map(n + r.nodeSize - 2), p);
  }
  return !!(c || u);
}
function Xy(e, t, r, n, o, i, a, l) {
  if (a == 0 || a == t.height)
    return !1;
  let s = !1;
  for (let c = o; c < i; c++) {
    const u = a * t.width + c, d = t.map[u];
    if (t.map[u - t.width] == d) {
      s = !0;
      const f = r.nodeAt(d), { top: p, left: h } = t.findCell(d);
      e.setNodeMarkup(e.mapping.slice(l).map(d + n), null, {
        ...f.attrs,
        rowspan: a - p
      }), e.insert(
        e.mapping.slice(l).map(t.positionAt(a, h, r)),
        f.type.createAndFill({
          ...f.attrs,
          rowspan: p + f.attrs.rowspan - a
        })
      ), c += f.attrs.colspan - 1;
    }
  }
  return s;
}
function e1(e, t, r, n, o, i, a, l) {
  if (a == 0 || a == t.width)
    return !1;
  let s = !1;
  for (let c = o; c < i; c++) {
    const u = c * t.width + a, d = t.map[u];
    if (t.map[u - 1] == d) {
      s = !0;
      const f = r.nodeAt(d), p = t.colCount(d), h = e.mapping.slice(l).map(d + n);
      e.setNodeMarkup(
        h,
        null,
        vi(
          f.attrs,
          a - p,
          f.attrs.colspan - (a - p)
        )
      ), e.insert(
        h + f.nodeSize,
        f.type.createAndFill(
          vi(f.attrs, 0, a - p)
        )
      ), c += f.attrs.rowspan - 1;
    }
  }
  return s;
}
function t1(e, t, r, n, o) {
  let i = r ? e.doc.nodeAt(r - 1) : e.doc;
  if (!i)
    throw new Error("No table found");
  let a = Lt.get(i);
  const { top: l, left: s } = n, c = s + o.width, u = l + o.height, d = e.tr;
  let f = 0;
  function p() {
    if (i = r ? d.doc.nodeAt(r - 1) : d.doc, !i)
      throw new Error("No table found");
    a = Lt.get(i), f = d.mapping.maps.length;
  }
  dse(d, a, i, r, c, u, f) && p(), Xy(d, a, i, r, s, c, l, f) && p(), Xy(d, a, i, r, s, c, u, f) && p(), e1(d, a, i, r, l, u, s, f) && p(), e1(d, a, i, r, l, u, c, f) && p();
  for (let h = l; h < u; h++) {
    const g = a.positionAt(h, s, i), m = a.positionAt(h, c, i);
    d.replace(
      d.mapping.slice(f).map(g + r),
      d.mapping.slice(f).map(m + r),
      new we(o.rows[h - l], 0, 0)
    );
  }
  p(), d.setSelection(
    new Mt(
      d.doc.resolve(r + a.positionAt(l, s, i)),
      d.doc.resolve(r + a.positionAt(u - 1, c - 1, i))
    )
  ), t(d);
}
var fse = uY({
  ArrowLeft: su("horiz", -1),
  ArrowRight: su("horiz", 1),
  ArrowUp: su("vert", -1),
  ArrowDown: su("vert", 1),
  "Shift-ArrowLeft": uu("horiz", -1),
  "Shift-ArrowRight": uu("horiz", 1),
  "Shift-ArrowUp": uu("vert", -1),
  "Shift-ArrowDown": uu("vert", 1),
  Backspace: cu,
  "Mod-Backspace": cu,
  Delete: cu,
  "Mod-Delete": cu
});
function Iu(e, t, r) {
  return r.eq(e.selection) ? !1 : (t && t(e.tr.setSelection(r).scrollIntoView()), !0);
}
function su(e, t) {
  return (r, n, o) => {
    if (!o)
      return !1;
    const i = r.selection;
    if (i instanceof Mt)
      return Iu(
        r,
        n,
        Ze.near(i.$headCell, t)
      );
    if (e != "horiz" && !i.empty)
      return !1;
    const a = SD(o, e, t);
    if (a == null)
      return !1;
    if (e == "horiz")
      return Iu(
        r,
        n,
        Ze.near(r.doc.resolve(i.head + t), t)
      );
    {
      const l = r.doc.resolve(a), s = yD(l, e, t);
      let c;
      return s ? c = Ze.near(s, 1) : t < 0 ? c = Ze.near(r.doc.resolve(l.before(-1)), -1) : c = Ze.near(r.doc.resolve(l.after(-1)), 1), Iu(r, n, c);
    }
  };
}
function uu(e, t) {
  return (r, n, o) => {
    if (!o)
      return !1;
    const i = r.selection;
    let a;
    if (i instanceof Mt)
      a = i;
    else {
      const s = SD(o, e, t);
      if (s == null)
        return !1;
      a = new Mt(r.doc.resolve(s));
    }
    const l = yD(a.$headCell, e, t);
    return l ? Iu(
      r,
      n,
      new Mt(a.$anchorCell, l)
    ) : !1;
  };
}
function cu(e, t) {
  const r = e.selection;
  if (!(r instanceof Mt))
    return !1;
  if (t) {
    const n = e.tr, o = cr(e.schema).cell.createAndFill().content;
    r.forEachCell((i, a) => {
      i.content.eq(o) || n.replace(
        n.mapping.map(a + 1),
        n.mapping.map(a + i.nodeSize - 1),
        new we(o, 0, 0)
      );
    }), n.docChanged && t(n);
  }
  return !0;
}
function pse(e, t) {
  const r = e.state.doc, n = Ua(r.resolve(t));
  return n ? (e.dispatch(e.state.tr.setSelection(new Mt(n))), !0) : !1;
}
function hse(e, t, r) {
  if (!Tn(e.state))
    return !1;
  let n = sse(r);
  const o = e.state.selection;
  if (o instanceof Mt) {
    n || (n = {
      width: 1,
      height: 1,
      rows: [
        pe.from(
          Ug(cr(e.state.schema).cell, r)
        )
      ]
    });
    const i = o.$anchorCell.node(-1), a = o.$anchorCell.start(-1), l = Lt.get(i).rectBetween(
      o.$anchorCell.pos - a,
      o.$headCell.pos - a
    );
    return n = cse(n, l.right - l.left, l.bottom - l.top), t1(e.state, e.dispatch, a, l, n), !0;
  } else if (n) {
    const i = yd(e.state), a = i.start(-1);
    return t1(
      e.state,
      e.dispatch,
      a,
      Lt.get(i.node(-1)).findCell(i.pos - a),
      n
    ), !0;
  } else
    return !1;
}
function gse(e, t) {
  var r;
  if (t.ctrlKey || t.metaKey)
    return;
  const n = r1(e, t.target);
  let o;
  if (t.shiftKey && e.state.selection instanceof Mt)
    i(e.state.selection.$anchorCell, t), t.preventDefault();
  else if (t.shiftKey && n && (o = Ua(e.state.selection.$anchor)) != null && ((r = Df(e, t)) == null ? void 0 : r.pos) != o.pos)
    i(o, t), t.preventDefault();
  else if (!n)
    return;
  function i(s, c) {
    let u = Df(e, c);
    const d = mo.getState(e.state) == null;
    if (!u || !G0(s, u))
      if (d)
        u = s;
      else
        return;
    const f = new Mt(s, u);
    if (d || !e.state.selection.eq(f)) {
      const p = e.state.tr.setSelection(f);
      d && p.setMeta(mo, s.pos), e.dispatch(p);
    }
  }
  function a() {
    e.root.removeEventListener("mouseup", a), e.root.removeEventListener("dragstart", a), e.root.removeEventListener("mousemove", l), mo.getState(e.state) != null && e.dispatch(e.state.tr.setMeta(mo, -1));
  }
  function l(s) {
    const c = s, u = mo.getState(e.state);
    let d;
    if (u != null)
      d = e.state.doc.resolve(u);
    else if (r1(e, c.target) != n && (d = Df(e, t), !d))
      return a();
    d && i(d, c);
  }
  e.root.addEventListener("mouseup", a), e.root.addEventListener("dragstart", a), e.root.addEventListener("mousemove", l);
}
function SD(e, t, r) {
  if (!(e.state.selection instanceof Qe))
    return null;
  const { $head: n } = e.state.selection;
  for (let o = n.depth - 1; o >= 0; o--) {
    const i = n.node(o);
    if ((r < 0 ? n.index(o) : n.indexAfter(o)) != (r < 0 ? 0 : i.childCount))
      return null;
    if (i.type.spec.tableRole == "cell" || i.type.spec.tableRole == "header_cell") {
      const l = n.before(o), s = t == "vert" ? r > 0 ? "down" : "up" : r > 0 ? "right" : "left";
      return e.endOfTextblock(s) ? l : null;
    }
  }
  return null;
}
function r1(e, t) {
  for (; t && t != e.dom; t = t.parentNode)
    if (t.nodeName == "TD" || t.nodeName == "TH")
      return t;
  return null;
}
function Df(e, t) {
  const r = e.posAtCoords({
    left: t.clientX,
    top: t.clientY
  });
  return r && r ? Ua(e.state.doc.resolve(r.pos)) : null;
}
var mse = class {
  constructor(t, r) {
    this.node = t, this.cellMinWidth = r, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), Hg(t, this.colgroup, this.table, r), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type != this.node.type ? !1 : (this.node = t, Hg(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    return t.type == "attributes" && (t.target == this.table || this.colgroup.contains(t.target));
  }
};
function Hg(e, t, r, n, o, i) {
  var a;
  let l = 0, s = !0, c = t.firstChild;
  const u = e.firstChild;
  if (u) {
    for (let d = 0, f = 0; d < u.childCount; d++) {
      const { colspan: p, colwidth: h } = u.child(d).attrs;
      for (let g = 0; g < p; g++, f++) {
        const m = o == f ? i : h && h[g], v = m ? m + "px" : "";
        l += m || n, m || (s = !1), c ? (c.style.width != v && (c.style.width = v), c = c.nextSibling) : t.appendChild(document.createElement("col")).style.width = v;
      }
    }
    for (; c; ) {
      const d = c.nextSibling;
      (a = c.parentNode) == null || a.removeChild(c), c = d;
    }
    s ? (r.style.width = l + "px", r.style.minWidth = "") : (r.style.width = "", r.style.minWidth = l + "px");
  }
}
var en = new pr(
  "tableColumnResizing"
);
function vse({
  handleWidth: e = 5,
  cellMinWidth: t = 25,
  View: r = mse,
  lastColumnResizable: n = !0
} = {}) {
  const o = new Nr({
    key: en,
    state: {
      init(i, a) {
        return o.spec.props.nodeViews[cr(a.schema).table.name] = (l, s) => new r(l, t, s), new bse(-1, !1);
      },
      apply(i, a) {
        return a.apply(i);
      }
    },
    props: {
      attributes: (i) => {
        const a = en.getState(i);
        return a && a.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (i, a) => {
          Mse(
            i,
            a,
            e,
            t,
            n
          );
        },
        mouseleave: (i) => {
          yse(i);
        },
        mousedown: (i, a) => {
          xse(i, a, t);
        }
      },
      decorations: (i) => {
        const a = en.getState(i);
        if (a && a.activeHandle > -1)
          return Ise(i, a.activeHandle);
      },
      nodeViews: {}
    }
  });
  return o;
}
var bse = class Au {
  constructor(t, r) {
    this.activeHandle = t, this.dragging = r;
  }
  apply(t) {
    const r = this, n = t.getMeta(en);
    if (n && n.setHandle != null)
      return new Au(n.setHandle, !1);
    if (n && n.setDragging !== void 0)
      return new Au(r.activeHandle, n.setDragging);
    if (r.activeHandle > -1 && t.docChanged) {
      let o = t.mapping.map(r.activeHandle, -1);
      return Fg(t.doc.resolve(o)) || (o = -1), new Au(o, r.dragging);
    }
    return r;
  }
};
function Mse(e, t, r, n, o) {
  const i = en.getState(e.state);
  if (i && !i.dragging) {
    const a = Tse(t.target);
    let l = -1;
    if (a) {
      const { left: s, right: c } = a.getBoundingClientRect();
      t.clientX - s <= r ? l = n1(e, t, "left", r) : c - t.clientX <= r && (l = n1(e, t, "right", r));
    }
    if (l != i.activeHandle) {
      if (!o && l !== -1) {
        const s = e.state.doc.resolve(l), c = s.node(-1), u = Lt.get(c), d = s.start(-1);
        if (u.colCount(s.pos - d) + s.nodeAfter.attrs.colspan - 1 == u.width - 1)
          return;
      }
      CD(e, l);
    }
  }
}
function yse(e) {
  const t = en.getState(e.state);
  t && t.activeHandle > -1 && !t.dragging && CD(e, -1);
}
function xse(e, t, r) {
  const n = en.getState(e.state);
  if (!n || n.activeHandle == -1 || n.dragging)
    return !1;
  const o = e.state.doc.nodeAt(n.activeHandle), i = wse(e, n.activeHandle, o.attrs);
  e.dispatch(
    e.state.tr.setMeta(en, {
      setDragging: { startX: t.clientX, startWidth: i }
    })
  );
  function a(s) {
    window.removeEventListener("mouseup", a), window.removeEventListener("mousemove", l);
    const c = en.getState(e.state);
    c != null && c.dragging && (Nse(
      e,
      c.activeHandle,
      o1(c.dragging, s, r)
    ), e.dispatch(
      e.state.tr.setMeta(en, { setDragging: null })
    ));
  }
  function l(s) {
    if (!s.which)
      return a(s);
    const c = en.getState(e.state);
    if (c && c.dragging) {
      const u = o1(c.dragging, s, r);
      Sse(e, c.activeHandle, u, r);
    }
  }
  return window.addEventListener("mouseup", a), window.addEventListener("mousemove", l), t.preventDefault(), !0;
}
function wse(e, t, { colspan: r, colwidth: n }) {
  const o = n && n[n.length - 1];
  if (o)
    return o;
  const i = e.domAtPos(t);
  let l = i.node.childNodes[i.offset].offsetWidth, s = r;
  if (n)
    for (let c = 0; c < r; c++)
      n[c] && (l -= n[c], s--);
  return l / s;
}
function Tse(e) {
  for (; e && e.nodeName != "TD" && e.nodeName != "TH"; )
    e = e.classList && e.classList.contains("ProseMirror") ? null : e.parentNode;
  return e;
}
function n1(e, t, r, n) {
  const o = r == "right" ? -n : n, i = e.posAtCoords({
    left: t.clientX + o,
    top: t.clientY
  });
  if (!i)
    return -1;
  const { pos: a } = i, l = Ua(e.state.doc.resolve(a));
  if (!l)
    return -1;
  if (r == "right")
    return l.pos;
  const s = Lt.get(l.node(-1)), c = l.start(-1), u = s.map.indexOf(l.pos - c);
  return u % s.width == 0 ? -1 : c + s.map[u - 1];
}
function o1(e, t, r) {
  const n = t.clientX - e.startX;
  return Math.max(r, e.startWidth + n);
}
function CD(e, t) {
  e.dispatch(
    e.state.tr.setMeta(en, { setHandle: t })
  );
}
function Nse(e, t, r) {
  const n = e.state.doc.resolve(t), o = n.node(-1), i = Lt.get(o), a = n.start(-1), l = i.colCount(n.pos - a) + n.nodeAfter.attrs.colspan - 1, s = e.state.tr;
  for (let c = 0; c < i.height; c++) {
    const u = c * i.width + l;
    if (c && i.map[u] == i.map[u - i.width])
      continue;
    const d = i.map[u], f = o.nodeAt(d).attrs, p = f.colspan == 1 ? 0 : l - i.colCount(d);
    if (f.colwidth && f.colwidth[p] == r)
      continue;
    const h = f.colwidth ? f.colwidth.slice() : Cse(f.colspan);
    h[p] = r, s.setNodeMarkup(a + d, null, { ...f, colwidth: h });
  }
  s.docChanged && e.dispatch(s);
}
function Sse(e, t, r, n) {
  const o = e.state.doc.resolve(t), i = o.node(-1), a = o.start(-1), l = Lt.get(i).colCount(o.pos - a) + o.nodeAfter.attrs.colspan - 1;
  let s = e.domAtPos(o.start(-1)).node;
  for (; s && s.nodeName != "TABLE"; )
    s = s.parentNode;
  s && Hg(
    i,
    s.firstChild,
    s,
    n,
    l,
    r
  );
}
function Cse(e) {
  return Array(e).fill(0);
}
function Ise(e, t) {
  const r = [], n = e.doc.resolve(t), o = n.node(-1);
  if (!o)
    return Pt.empty;
  const i = Lt.get(o), a = n.start(-1), l = i.colCount(n.pos - a) + n.nodeAfter.attrs.colspan;
  for (let s = 0; s < i.height; s++) {
    const c = l + s * i.width - 1;
    if ((l == i.width || i.map[c] != i.map[c + 1]) && (s == 0 || i.map[c] != i.map[c - i.width])) {
      const u = i.map[c], d = a + u + o.nodeAt(u).nodeSize - 1, f = document.createElement("div");
      f.className = "column-resize-handle", r.push(tn.widget(d, f));
    }
  }
  return Pt.create(e.doc, r);
}
function Bn(e) {
  const t = e.selection, r = yd(e), n = r.node(-1), o = r.start(-1), i = Lt.get(n);
  return { ...t instanceof Mt ? i.rectBetween(
    t.$anchorCell.pos - o,
    t.$headCell.pos - o
  ) : i.findCell(r.pos - o), tableStart: o, map: i, table: n };
}
function ID(e, { map: t, tableStart: r, table: n }, o) {
  let i = o > 0 ? -1 : 0;
  ese(t, n, o + i) && (i = o == 0 || o == t.width ? null : 0);
  for (let a = 0; a < t.height; a++) {
    const l = a * t.width + o;
    if (o > 0 && o < t.width && t.map[l - 1] == t.map[l]) {
      const s = t.map[l], c = n.nodeAt(s);
      e.setNodeMarkup(
        e.mapping.map(r + s),
        null,
        xD(c.attrs, o - t.colCount(s))
      ), a += c.attrs.rowspan - 1;
    } else {
      const s = i == null ? cr(n.type.schema).cell : n.nodeAt(t.map[l + i]).type, c = t.positionAt(a, o, n);
      e.insert(e.mapping.map(r + c), s.createAndFill());
    }
  }
  return e;
}
function Ase(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e);
    t(ID(e.tr, r, r.left));
  }
  return !0;
}
function Dse(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e);
    t(ID(e.tr, r, r.right));
  }
  return !0;
}
function kse(e, { map: t, table: r, tableStart: n }, o) {
  const i = e.mapping.maps.length;
  for (let a = 0; a < t.height; ) {
    const l = a * t.width + o, s = t.map[l], c = r.nodeAt(s), u = c.attrs;
    if (o > 0 && t.map[l - 1] == s || o < t.width - 1 && t.map[l + 1] == s)
      e.setNodeMarkup(
        e.mapping.slice(i).map(n + s),
        null,
        vi(u, o - t.colCount(s))
      );
    else {
      const d = e.mapping.slice(i).map(n + s);
      e.delete(d, d + c.nodeSize);
    }
    a += u.rowspan;
  }
}
function Ese(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e), n = e.tr;
    if (r.left == 0 && r.right == r.map.width)
      return !1;
    for (let o = r.right - 1; kse(n, r, o), o != r.left; o--) {
      const i = r.tableStart ? n.doc.nodeAt(r.tableStart - 1) : n.doc;
      if (!i)
        throw RangeError("No table found");
      r.table = i, r.map = Lt.get(i);
    }
    t(n);
  }
  return !0;
}
function Lse(e, t, r) {
  var n;
  const o = cr(t.type.schema).header_cell;
  for (let i = 0; i < e.width; i++)
    if (((n = t.nodeAt(e.map[i + r * e.width])) == null ? void 0 : n.type) != o)
      return !1;
  return !0;
}
function AD(e, { map: t, tableStart: r, table: n }, o) {
  var i;
  let a = r;
  for (let c = 0; c < o; c++)
    a += n.child(c).nodeSize;
  const l = [];
  let s = o > 0 ? -1 : 0;
  Lse(t, n, o + s) && (s = o == 0 || o == t.height ? null : 0);
  for (let c = 0, u = t.width * o; c < t.width; c++, u++)
    if (o > 0 && o < t.height && t.map[u] == t.map[u - t.width]) {
      const d = t.map[u], f = n.nodeAt(d).attrs;
      e.setNodeMarkup(r + d, null, {
        ...f,
        rowspan: f.rowspan + 1
      }), c += f.colspan - 1;
    } else {
      const d = s == null ? cr(n.type.schema).cell : (i = n.nodeAt(t.map[u + s * t.width])) == null ? void 0 : i.type, f = d == null ? void 0 : d.createAndFill();
      f && l.push(f);
    }
  return e.insert(a, cr(n.type.schema).row.create(null, l)), e;
}
function $se(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e);
    t(AD(e.tr, r, r.top));
  }
  return !0;
}
function zse(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e);
    t(AD(e.tr, r, r.bottom));
  }
  return !0;
}
function Ose(e, { map: t, table: r, tableStart: n }, o) {
  let i = 0;
  for (let c = 0; c < o; c++)
    i += r.child(c).nodeSize;
  const a = i + r.child(o).nodeSize, l = e.mapping.maps.length;
  e.delete(i + n, a + n);
  const s = /* @__PURE__ */ new Set();
  for (let c = 0, u = o * t.width; c < t.width; c++, u++) {
    const d = t.map[u];
    if (!s.has(d)) {
      if (s.add(d), o > 0 && d == t.map[u - t.width]) {
        const f = r.nodeAt(d).attrs;
        e.setNodeMarkup(e.mapping.slice(l).map(d + n), null, {
          ...f,
          rowspan: f.rowspan - 1
        }), c += f.colspan - 1;
      } else if (o < t.height && d == t.map[u + t.width]) {
        const f = r.nodeAt(d), p = f.attrs, h = f.type.create(
          { ...p, rowspan: f.attrs.rowspan - 1 },
          f.content
        ), g = t.positionAt(o + 1, c, r);
        e.insert(e.mapping.slice(l).map(n + g), h), c += p.colspan - 1;
      }
    }
  }
}
function jse(e, t) {
  if (!Tn(e))
    return !1;
  if (t) {
    const r = Bn(e), n = e.tr;
    if (r.top == 0 && r.bottom == r.map.height)
      return !1;
    for (let o = r.bottom - 1; Ose(n, r, o), o != r.top; o--) {
      const i = r.tableStart ? n.doc.nodeAt(r.tableStart - 1) : n.doc;
      if (!i)
        throw RangeError("No table found");
      r.table = i, r.map = Lt.get(r.table);
    }
    t(n);
  }
  return !0;
}
function i1(e) {
  const t = e.content;
  return t.childCount == 1 && t.child(0).isTextblock && t.child(0).childCount == 0;
}
function Rse({ width: e, height: t, map: r }, n) {
  let o = n.top * e + n.left, i = o, a = (n.bottom - 1) * e + n.left, l = o + (n.right - n.left - 1);
  for (let s = n.top; s < n.bottom; s++) {
    if (n.left > 0 && r[i] == r[i - 1] || n.right < e && r[l] == r[l + 1])
      return !0;
    i += e, l += e;
  }
  for (let s = n.left; s < n.right; s++) {
    if (n.top > 0 && r[o] == r[o - e] || n.bottom < t && r[a] == r[a + e])
      return !0;
    o++, a++;
  }
  return !1;
}
function a1(e, t) {
  const r = e.selection;
  if (!(r instanceof Mt) || r.$anchorCell.pos == r.$headCell.pos)
    return !1;
  const n = Bn(e), { map: o } = n;
  if (Rse(o, n))
    return !1;
  if (t) {
    const i = e.tr, a = {};
    let l = pe.empty, s, c;
    for (let u = n.top; u < n.bottom; u++)
      for (let d = n.left; d < n.right; d++) {
        const f = o.map[u * o.width + d], p = n.table.nodeAt(f);
        if (!(a[f] || !p))
          if (a[f] = !0, s == null)
            s = f, c = p;
          else {
            i1(p) || (l = l.append(p.content));
            const h = i.mapping.map(f + n.tableStart);
            i.delete(h, h + p.nodeSize);
          }
      }
    if (s == null || c == null)
      return !0;
    if (i.setNodeMarkup(s + n.tableStart, null, {
      ...xD(
        c.attrs,
        c.attrs.colspan,
        n.right - n.left - c.attrs.colspan
      ),
      rowspan: n.bottom - n.top
    }), l.size) {
      const u = s + 1 + c.content.size, d = i1(c) ? s + 1 : u;
      i.replaceWith(d + n.tableStart, u + n.tableStart, l);
    }
    i.setSelection(
      new Mt(i.doc.resolve(s + n.tableStart))
    ), t(i);
  }
  return !0;
}
function l1(e, t) {
  const r = cr(e.schema);
  return _se(({ node: n }) => r[n.type.spec.tableRole])(e, t);
}
function _se(e) {
  return (t, r) => {
    var n;
    const o = t.selection;
    let i, a;
    if (o instanceof Mt) {
      if (o.$anchorCell.pos != o.$headCell.pos)
        return !1;
      i = o.$anchorCell.nodeAfter, a = o.$anchorCell.pos;
    } else {
      if (i = qle(o.$from), !i)
        return !1;
      a = (n = Ua(o.$from)) == null ? void 0 : n.pos;
    }
    if (i == null || a == null || i.attrs.colspan == 1 && i.attrs.rowspan == 1)
      return !1;
    if (r) {
      let l = i.attrs;
      const s = [], c = l.colwidth;
      l.rowspan > 1 && (l = { ...l, rowspan: 1 }), l.colspan > 1 && (l = { ...l, colspan: 1 });
      const u = Bn(t), d = t.tr;
      for (let p = 0; p < u.right - u.left; p++)
        s.push(
          c ? {
            ...l,
            colwidth: c && c[p] ? [c[p]] : null
          } : l
        );
      let f;
      for (let p = u.top; p < u.bottom; p++) {
        let h = u.map.positionAt(p, u.left, u.table);
        p == u.top && (h += i.nodeSize);
        for (let g = u.left, m = 0; g < u.right; g++, m++)
          g == u.left && p == u.top || d.insert(
            f = d.mapping.map(h + u.tableStart, 1),
            e({ node: i, row: p, col: g }).createAndFill(s[m])
          );
      }
      d.setNodeMarkup(
        a,
        e({ node: i, row: u.top, col: u.left }),
        s[0]
      ), o instanceof Mt && d.setSelection(
        new Mt(
          d.doc.resolve(o.$anchorCell.pos),
          f ? d.doc.resolve(f) : void 0
        )
      ), r(d);
    }
    return !0;
  };
}
function Pse(e, t) {
  return function(r, n) {
    if (!Tn(r))
      return !1;
    const o = yd(r);
    if (o.nodeAfter.attrs[e] === t)
      return !1;
    if (n) {
      const i = r.tr;
      r.selection instanceof Mt ? r.selection.forEachCell((a, l) => {
        a.attrs[e] !== t && i.setNodeMarkup(l, null, {
          ...a.attrs,
          [e]: t
        });
      }) : i.setNodeMarkup(o.pos, null, {
        ...o.nodeAfter.attrs,
        [e]: t
      }), n(i);
    }
    return !0;
  };
}
function Bse(e) {
  return function(t, r) {
    if (!Tn(t))
      return !1;
    if (r) {
      const n = cr(t.schema), o = Bn(t), i = t.tr, a = o.map.cellsInRect(
        e == "column" ? {
          left: o.left,
          top: 0,
          right: o.right,
          bottom: o.map.height
        } : e == "row" ? {
          left: 0,
          top: o.top,
          right: o.map.width,
          bottom: o.bottom
        } : o
      ), l = a.map((s) => o.table.nodeAt(s));
      for (let s = 0; s < a.length; s++)
        l[s].type == n.header_cell && i.setNodeMarkup(
          o.tableStart + a[s],
          n.cell,
          l[s].attrs
        );
      if (i.steps.length == 0)
        for (let s = 0; s < a.length; s++)
          i.setNodeMarkup(
            o.tableStart + a[s],
            n.header_cell,
            l[s].attrs
          );
      r(i);
    }
    return !0;
  };
}
function s1(e, t, r) {
  const n = t.map.cellsInRect({
    left: 0,
    top: 0,
    right: e == "row" ? t.map.width : 1,
    bottom: e == "column" ? t.map.height : 1
  });
  for (let o = 0; o < n.length; o++) {
    const i = t.table.nodeAt(n[o]);
    if (i && i.type !== r.header_cell)
      return !1;
  }
  return !0;
}
function us(e, t) {
  return t = t || { useDeprecatedLogic: !1 }, t.useDeprecatedLogic ? Bse(e) : function(r, n) {
    if (!Tn(r))
      return !1;
    if (n) {
      const o = cr(r.schema), i = Bn(r), a = r.tr, l = s1("row", i, o), s = s1(
        "column",
        i,
        o
      ), u = (e === "column" ? l : e === "row" ? s : !1) ? 1 : 0, d = e == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: i.map.height
      } : e == "row" ? {
        left: u,
        top: 0,
        right: i.map.width,
        bottom: 1
      } : i, f = e == "column" ? s ? o.cell : o.header_cell : e == "row" ? l ? o.cell : o.header_cell : o.cell;
      i.map.cellsInRect(d).forEach((p) => {
        const h = p + i.tableStart, g = a.doc.nodeAt(h);
        g && a.setNodeMarkup(h, f, g.attrs);
      }), n(a);
    }
    return !0;
  };
}
us("row", {
  useDeprecatedLogic: !0
});
us("column", {
  useDeprecatedLogic: !0
});
var Fse = us("cell", {
  useDeprecatedLogic: !0
});
function Use(e, t) {
  if (t < 0) {
    const r = e.nodeBefore;
    if (r)
      return e.pos - r.nodeSize;
    for (let n = e.index(-1) - 1, o = e.before(); n >= 0; n--) {
      const i = e.node(-1).child(n), a = i.lastChild;
      if (a)
        return o - 1 - a.nodeSize;
      o -= i.nodeSize;
    }
  } else {
    if (e.index() < e.parent.childCount - 1)
      return e.pos + e.nodeAfter.nodeSize;
    const r = e.node(-1);
    for (let n = e.indexAfter(-1), o = e.after(); n < r.childCount; n++) {
      const i = r.child(n);
      if (i.childCount)
        return o + 1;
      o += i.nodeSize;
    }
  }
  return null;
}
function u1(e) {
  return function(t, r) {
    if (!Tn(t))
      return !1;
    const n = Use(yd(t), e);
    if (n == null)
      return !1;
    if (r) {
      const o = t.doc.resolve(n);
      r(
        t.tr.setSelection(Qe.between(o, Xle(o))).scrollIntoView()
      );
    }
    return !0;
  };
}
function Hse(e, t) {
  const r = e.selection.$anchor;
  for (let n = r.depth; n > 0; n--)
    if (r.node(n).type.spec.tableRole == "table")
      return t && t(
        e.tr.delete(r.before(n), r.after(n)).scrollIntoView()
      ), !0;
  return !1;
}
function Yse({
  allowTableNodeSelection: e = !1
} = {}) {
  return new Nr({
    key: mo,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(t, r) {
        const n = t.getMeta(mo);
        if (n != null)
          return n == -1 ? null : n;
        if (r == null || !t.docChanged)
          return r;
        const { deleted: o, pos: i } = t.mapping.mapResult(r);
        return o ? null : i;
      }
    },
    props: {
      decorations: rse,
      handleDOMEvents: {
        mousedown: gse
      },
      createSelectionBetween(t) {
        return mo.getState(t.state) != null ? t.state.selection : null;
      },
      handleTripleClick: pse,
      handleKeyDown: fse,
      handlePaste: hse
    },
    appendTransaction(t, r, n) {
      return ise(
        n,
        ND(n, r),
        e
      );
    }
  });
}
function c1(e, t, r, n, o, i) {
  let a = 0, l = !0, s = t.firstChild;
  const c = e.firstChild;
  for (let u = 0, d = 0; u < c.childCount; u += 1) {
    const { colspan: f, colwidth: p } = c.child(u).attrs;
    for (let h = 0; h < f; h += 1, d += 1) {
      const g = o === d ? i : p && p[h], m = g ? `${g}px` : "";
      a += g || n, g || (l = !1), s ? (s.style.width !== m && (s.style.width = m), s = s.nextSibling) : t.appendChild(document.createElement("col")).style.width = m;
    }
  }
  for (; s; ) {
    const u = s.nextSibling;
    s.parentNode.removeChild(s), s = u;
  }
  l ? (r.style.width = `${a}px`, r.style.minWidth = "") : (r.style.width = "", r.style.minWidth = `${a}px`);
}
class Wse {
  constructor(t, r) {
    _o(this, "node");
    _o(this, "cellMinWidth");
    _o(this, "dom");
    _o(this, "table");
    _o(this, "colgroup");
    _o(this, "contentDOM");
    this.node = t, this.cellMinWidth = r, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), c1(t, this.colgroup, this.table, r), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type !== this.node.type ? !1 : (this.node = t, c1(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    return t.type === "attributes" && (t.target === this.table || this.colgroup.contains(t.target));
  }
}
function d1(e, t) {
  return t ? e.createChecked(null, t) : e.createAndFill();
}
function Qse(e) {
  if (e.cached.tableNodeTypes)
    return e.cached.tableNodeTypes;
  const t = {};
  return Object.keys(e.nodes).forEach((r) => {
    const n = e.nodes[r];
    n.spec.tableRole && (t[n.spec.tableRole] = n);
  }), e.cached.tableNodeTypes = t, t;
}
function Vse(e, t, r, n, o) {
  const i = Qse(e), a = [], l = [];
  for (let c = 0; c < r; c += 1) {
    const u = d1(i.cell, o);
    if (u && l.push(u), n) {
      const d = d1(i.header_cell, o);
      d && a.push(d);
    }
  }
  const s = [];
  for (let c = 0; c < t; c += 1)
    s.push(
      i.row.createChecked(
        null,
        n && c === 0 ? a : l
      )
    );
  return i.table.createChecked(null, s);
}
function Zse(e) {
  return e instanceof Mt;
}
const du = ({
  editor: e
}) => {
  const { selection: t } = e.state;
  if (!Zse(t))
    return !1;
  let r = 0;
  const n = $I(t.ranges[0].$from, (i) => i.type.name === "table");
  return n == null || n.node.descendants((i) => {
    if (i.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(i.type.name) && (r += 1);
  }), r === t.ranges.length ? (e.commands.deleteTable(), !0) : !1;
}, DD = Ot.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: Wse,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  addAttributes() {
    return hr();
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "table",
      lt(this.options.HTMLAttributes, e),
      ["tbody", 0]
    ];
  },
  addCommands() {
    return {
      insertTable: ({ rows: e = 3, cols: t = 3, withHeaderRow: r = !0 } = {}) => ({ tr: n, dispatch: o, editor: i }) => {
        const a = Vse(i.schema, e, t, r);
        if (o) {
          const l = n.selection.anchor + 1;
          n.replaceSelectionWith(a).scrollIntoView().setSelection(Qe.near(n.doc.resolve(l)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: e, dispatch: t }) => Ase(e, t),
      addColumnAfter: () => ({ state: e, dispatch: t }) => Dse(e, t),
      deleteColumn: () => ({ state: e, dispatch: t }) => Ese(e, t),
      addRowBefore: () => ({ state: e, dispatch: t }) => $se(e, t),
      addRowAfter: () => ({ state: e, dispatch: t }) => zse(e, t),
      deleteRow: () => ({ state: e, dispatch: t }) => jse(e, t),
      deleteTable: () => ({ state: e, dispatch: t }) => Hse(e, t),
      mergeCells: () => ({ state: e, dispatch: t }) => a1(e, t),
      splitCell: () => ({ state: e, dispatch: t }) => l1(e, t),
      toggleHeaderColumn: () => ({ state: e, dispatch: t }) => us("column")(e, t),
      toggleHeaderRow: () => ({ state: e, dispatch: t }) => us("row")(e, t),
      toggleHeaderCell: () => ({ state: e, dispatch: t }) => Fse(e, t),
      mergeOrSplit: () => ({ state: e, dispatch: t }) => a1(e, t) ? !0 : l1(e, t),
      setCellAttribute: (e, t) => ({ state: r, dispatch: n }) => Pse(e, t)(r, n),
      goToNextCell: () => ({ state: e, dispatch: t }) => u1(1)(e, t),
      goToPreviousCell: () => ({ state: e, dispatch: t }) => u1(-1)(e, t),
      fixTables: () => ({ state: e, dispatch: t }) => (t && ND(e), !0),
      setCellSelection: (e) => ({ tr: t, dispatch: r }) => {
        if (r) {
          const n = Mt.create(
            t.doc,
            e.anchorCell,
            e.headCell
          );
          t.setSelection(n);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: du,
      "Mod-Backspace": du,
      Delete: du,
      "Mod-Delete": du
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        vse({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          // @ts-ignore (incorrect type)
          View: this.options.View,
          // TODO: PR for @types/prosemirror-tables
          // @ts-ignore (incorrect type)
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      Yse({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(e) {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      tableRole: Dt(
        Wt(e, "tableRole", t)
      )
    };
  }
}), kD = Ot.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? [parseInt(t, 10)] : null;
        }
      },
      ...hr()
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "td",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  }
}), ED = Ot.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? [parseInt(t, 10)] : null;
        }
      },
      ...hr()
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "th",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  }
}), LD = Ot.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return hr();
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "tr",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  }
}), Oue = dt.create({
  name: "tableExtensions",
  addExtensions() {
    return [DD, kD, ED, LD];
  }
}), Gse = dt.create({
  name: "_tableExtensions",
  addExtensions() {
    return [
      DD.configure(this.options.table),
      kD.configure(this.options.tableCell),
      ED.configure(this.options.tableHeader),
      LD.configure(this.options.tableRow)
    ];
  }
}), jue = dt.create({
  name: "_allExtensions",
  addExtensions() {
    return [
      Qle.configure(this.options),
      ss.configure(this.options),
      jle.configure(this.options),
      zle.configure(this.options),
      Hle.configure(this.options),
      Ele.configure(this.options),
      Gse.configure(this.options),
      Ole.configure(this.options)
    ];
  }
}), f1 = /^\s*([-+*])\s$/, Kse = Ot.create({
  name: "bulletList",
  addAttributes() {
    return {
      ...hr(),
      listStyle: {
        default: null,
        parseHTML: (e) => e.style.listStyleType ?? "disc",
        renderHTML: (e) => e.listStyle ? {
          style: `list-style-type:${e.listStyle}`
        } : {}
      }
    };
  },
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  content() {
    return `${this.options.itemTypeName}+`;
  },
  group: "block list",
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "ul",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      toggleCustomBulletList: (e) => ({ chain: t }) => {
        var n;
        const r = (n = this.editor.getAttributes("bulletList")) == null ? void 0 : n.listStyle;
        return r !== void 0 && r !== e.type ? t().updateAttributes("bulletList", { listStyle: e.type }).run() : this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName).updateAttributes(
          Z0.name,
          this.editor.getAttributes(ss.name)
        ).run() : t().toggleList(this.name, this.options.itemTypeName).updateAttributes("bulletList", { listStyle: e.type }).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleCustomBulletList()
    };
  },
  addInputRules() {
    let e = es({
      find: f1,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = es({
      find: f1,
      type: this.type,
      getAttributes: () => this.editor.getAttributes(ss.name)
    })), [e];
  }
}), qse = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", Jse = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Ma = (e, t) => {
  for (const r in t)
    e[r] = t[r];
  return e;
}, Yg = "numeric", Wg = "ascii", Qg = "alpha", Du = "asciinumeric", fu = "alphanumeric", Vg = "domain", $D = "emoji", Xse = "scheme", eue = "slashscheme", p1 = "whitespace";
function tue(e, t) {
  return e in t || (t[e] = []), t[e];
}
function Xo(e, t, r) {
  t[Yg] && (t[Du] = !0, t[fu] = !0), t[Wg] && (t[Du] = !0, t[Qg] = !0), t[Du] && (t[fu] = !0), t[Qg] && (t[fu] = !0), t[fu] && (t[Vg] = !0), t[$D] && (t[Vg] = !0);
  for (const n in t) {
    const o = tue(n, r);
    o.indexOf(e) < 0 && o.push(e);
  }
}
function rue(e, t) {
  const r = {};
  for (const n in t)
    t[n].indexOf(e) >= 0 && (r[n] = !0);
  return r;
}
function Dr(e) {
  e === void 0 && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
Dr.groups = {};
Dr.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, r = t.j[e];
    if (r)
      return r;
    for (let n = 0; n < t.jr.length; n++) {
      const o = t.jr[n][0], i = t.jr[n][1];
      if (i && o.test(e))
        return i;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t) {
    return t === void 0 && (t = !1), t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, r, n) {
    for (let o = 0; o < e.length; o++)
      this.tt(e[o], t, r, n);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, r, n) {
    n = n || Dr.groups;
    let o;
    return t && t.j ? o = t : (o = new Dr(t), r && n && Xo(t, r, n)), this.jr.push([e, o]), o;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, r, n) {
    let o = this;
    const i = e.length;
    if (!i)
      return o;
    for (let a = 0; a < i - 1; a++)
      o = o.tt(e[a]);
    return o.tt(e[i - 1], t, r, n);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, r, n) {
    n = n || Dr.groups;
    const o = this;
    if (t && t.j)
      return o.j[e] = t, t;
    const i = t;
    let a, l = o.go(e);
    if (l ? (a = new Dr(), Ma(a.j, l.j), a.jr.push.apply(a.jr, l.jr), a.jd = l.jd, a.t = l.t) : a = new Dr(), i) {
      if (n)
        if (a.t && typeof a.t == "string") {
          const s = Ma(rue(a.t, n), r);
          Xo(i, s, n);
        } else
          r && Xo(i, r, n);
      a.t = i;
    }
    return o.j[e] = a, a;
  }
};
const Ke = (e, t, r, n, o) => e.ta(t, r, n, o), Gr = (e, t, r, n, o) => e.tr(t, r, n, o), h1 = (e, t, r, n, o) => e.ts(t, r, n, o), ge = (e, t, r, n, o) => e.tt(t, r, n, o), Qn = "WORD", Zg = "UWORD", cs = "LOCALHOST", Gg = "TLD", Kg = "UTLD", ku = "SCHEME", Vi = "SLASH_SCHEME", K0 = "NUM", zD = "WS", q0 = "NL", $l = "OPENBRACE", zl = "CLOSEBRACE", fc = "OPENBRACKET", pc = "CLOSEBRACKET", hc = "OPENPAREN", gc = "CLOSEPAREN", mc = "OPENANGLEBRACKET", vc = "CLOSEANGLEBRACKET", bc = "FULLWIDTHLEFTPAREN", Mc = "FULLWIDTHRIGHTPAREN", yc = "LEFTCORNERBRACKET", xc = "RIGHTCORNERBRACKET", wc = "LEFTWHITECORNERBRACKET", Tc = "RIGHTWHITECORNERBRACKET", Nc = "FULLWIDTHLESSTHAN", Sc = "FULLWIDTHGREATERTHAN", Cc = "AMPERSAND", Ic = "APOSTROPHE", Ac = "ASTERISK", go = "AT", Dc = "BACKSLASH", kc = "BACKTICK", Ec = "CARET", vo = "COLON", J0 = "COMMA", Lc = "DOLLAR", In = "DOT", $c = "EQUALS", X0 = "EXCLAMATION", An = "HYPHEN", zc = "PERCENT", Oc = "PIPE", jc = "PLUS", Rc = "POUND", _c = "QUERY", ev = "QUOTE", tv = "SEMI", Dn = "SLASH", Ol = "TILDE", Pc = "UNDERSCORE", OD = "EMOJI", Bc = "SYM";
var jD = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Qn,
  UWORD: Zg,
  LOCALHOST: cs,
  TLD: Gg,
  UTLD: Kg,
  SCHEME: ku,
  SLASH_SCHEME: Vi,
  NUM: K0,
  WS: zD,
  NL: q0,
  OPENBRACE: $l,
  CLOSEBRACE: zl,
  OPENBRACKET: fc,
  CLOSEBRACKET: pc,
  OPENPAREN: hc,
  CLOSEPAREN: gc,
  OPENANGLEBRACKET: mc,
  CLOSEANGLEBRACKET: vc,
  FULLWIDTHLEFTPAREN: bc,
  FULLWIDTHRIGHTPAREN: Mc,
  LEFTCORNERBRACKET: yc,
  RIGHTCORNERBRACKET: xc,
  LEFTWHITECORNERBRACKET: wc,
  RIGHTWHITECORNERBRACKET: Tc,
  FULLWIDTHLESSTHAN: Nc,
  FULLWIDTHGREATERTHAN: Sc,
  AMPERSAND: Cc,
  APOSTROPHE: Ic,
  ASTERISK: Ac,
  AT: go,
  BACKSLASH: Dc,
  BACKTICK: kc,
  CARET: Ec,
  COLON: vo,
  COMMA: J0,
  DOLLAR: Lc,
  DOT: In,
  EQUALS: $c,
  EXCLAMATION: X0,
  HYPHEN: An,
  PERCENT: zc,
  PIPE: Oc,
  PLUS: jc,
  POUND: Rc,
  QUERY: _c,
  QUOTE: ev,
  SEMI: tv,
  SLASH: Dn,
  TILDE: Ol,
  UNDERSCORE: Pc,
  EMOJI: OD,
  SYM: Bc
});
const Ui = /[a-z]/, kf = /\p{L}/u, Ef = /\p{Emoji}/u, Lf = /\d/, g1 = /\s/, m1 = `
`, nue = "️", oue = "‍";
let pu = null, hu = null;
function iue(e) {
  e === void 0 && (e = []);
  const t = {};
  Dr.groups = t;
  const r = new Dr();
  pu == null && (pu = v1(qse)), hu == null && (hu = v1(Jse)), ge(r, "'", Ic), ge(r, "{", $l), ge(r, "}", zl), ge(r, "[", fc), ge(r, "]", pc), ge(r, "(", hc), ge(r, ")", gc), ge(r, "<", mc), ge(r, ">", vc), ge(r, "（", bc), ge(r, "）", Mc), ge(r, "「", yc), ge(r, "」", xc), ge(r, "『", wc), ge(r, "』", Tc), ge(r, "＜", Nc), ge(r, "＞", Sc), ge(r, "&", Cc), ge(r, "*", Ac), ge(r, "@", go), ge(r, "`", kc), ge(r, "^", Ec), ge(r, ":", vo), ge(r, ",", J0), ge(r, "$", Lc), ge(r, ".", In), ge(r, "=", $c), ge(r, "!", X0), ge(r, "-", An), ge(r, "%", zc), ge(r, "|", Oc), ge(r, "+", jc), ge(r, "#", Rc), ge(r, "?", _c), ge(r, '"', ev), ge(r, "/", Dn), ge(r, ";", tv), ge(r, "~", Ol), ge(r, "_", Pc), ge(r, "\\", Dc);
  const n = Gr(r, Lf, K0, {
    [Yg]: !0
  });
  Gr(n, Lf, n);
  const o = Gr(r, Ui, Qn, {
    [Wg]: !0
  });
  Gr(o, Ui, o);
  const i = Gr(r, kf, Zg, {
    [Qg]: !0
  });
  Gr(i, Ui), Gr(i, kf, i);
  const a = Gr(r, g1, zD, {
    [p1]: !0
  });
  ge(r, m1, q0, {
    [p1]: !0
  }), ge(a, m1), Gr(a, g1, a);
  const l = Gr(r, Ef, OD, {
    [$D]: !0
  });
  Gr(l, Ef, l), ge(l, nue, l);
  const s = ge(l, oue);
  Gr(s, Ef, l);
  const c = [[Ui, o]], u = [[Ui, null], [kf, i]];
  for (let d = 0; d < pu.length; d++)
    fo(r, pu[d], Gg, Qn, c);
  for (let d = 0; d < hu.length; d++)
    fo(r, hu[d], Kg, Zg, u);
  Xo(Gg, {
    tld: !0,
    ascii: !0
  }, t), Xo(Kg, {
    utld: !0,
    alpha: !0
  }, t), fo(r, "file", ku, Qn, c), fo(r, "mailto", ku, Qn, c), fo(r, "http", Vi, Qn, c), fo(r, "https", Vi, Qn, c), fo(r, "ftp", Vi, Qn, c), fo(r, "ftps", Vi, Qn, c), Xo(ku, {
    scheme: !0,
    ascii: !0
  }, t), Xo(Vi, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((d, f) => d[0] > f[0] ? 1 : -1);
  for (let d = 0; d < e.length; d++) {
    const f = e[d][0], h = e[d][1] ? {
      [Xse]: !0
    } : {
      [eue]: !0
    };
    f.indexOf("-") >= 0 ? h[Vg] = !0 : Ui.test(f) ? Lf.test(f) ? h[Du] = !0 : h[Wg] = !0 : h[Yg] = !0, h1(r, f, f, h);
  }
  return h1(r, "localhost", cs, {
    ascii: !0
  }), r.jd = new Dr(Bc), {
    start: r,
    tokens: Ma({
      groups: t
    }, jD)
  };
}
function aue(e, t) {
  const r = lue(t.replace(/[A-Z]/g, (l) => l.toLowerCase())), n = r.length, o = [];
  let i = 0, a = 0;
  for (; a < n; ) {
    let l = e, s = null, c = 0, u = null, d = -1, f = -1;
    for (; a < n && (s = l.go(r[a])); )
      l = s, l.accepts() ? (d = 0, f = 0, u = l) : d >= 0 && (d += r[a].length, f++), c += r[a].length, i += r[a].length, a++;
    i -= d, a -= f, c -= d, o.push({
      t: u.t,
      // token type/name
      v: t.slice(i - c, i),
      // string value
      s: i - c,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return o;
}
function lue(e) {
  const t = [], r = e.length;
  let n = 0;
  for (; n < r; ) {
    let o = e.charCodeAt(n), i, a = o < 55296 || o > 56319 || n + 1 === r || (i = e.charCodeAt(n + 1)) < 56320 || i > 57343 ? e[n] : e.slice(n, n + 2);
    t.push(a), n += a.length;
  }
  return t;
}
function fo(e, t, r, n, o) {
  let i;
  const a = t.length;
  for (let l = 0; l < a - 1; l++) {
    const s = t[l];
    e.j[s] ? i = e.j[s] : (i = new Dr(n), i.jr = o.slice(), e.j[s] = i), e = i;
  }
  return i = new Dr(r), i.jr = o.slice(), e.j[t[a - 1]] = i, i;
}
function v1(e) {
  const t = [], r = [];
  let n = 0, o = "0123456789";
  for (; n < e.length; ) {
    let i = 0;
    for (; o.indexOf(e[n + i]) >= 0; )
      i++;
    if (i > 0) {
      t.push(r.join(""));
      for (let a = parseInt(e.substring(n, n + i), 10); a > 0; a--)
        r.pop();
      n += i;
    } else
      r.push(e[n]), n++;
  }
  return t;
}
const ds = {
  defaultProtocol: "http",
  events: null,
  format: b1,
  formatHref: b1,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function rv(e, t) {
  t === void 0 && (t = null);
  let r = Ma({}, ds);
  e && (r = Ma(r, e instanceof rv ? e.o : e));
  const n = r.ignoreTags, o = [];
  for (let i = 0; i < n.length; i++)
    o.push(n[i].toUpperCase());
  this.o = r, t && (this.defaultRender = t), this.ignoreTags = o;
}
rv.prototype = {
  o: ds,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, r) {
    const n = t != null;
    let o = this.o[e];
    return o && (typeof o == "object" ? (o = r.t in o ? o[r.t] : ds[e], typeof o == "function" && n && (o = o(t, r))) : typeof o == "function" && n && (o = o(t, r.t, r)), o);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, r) {
    let n = this.o[e];
    return typeof n == "function" && t != null && (n = n(t, r.t, r)), n;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function b1(e) {
  return e;
}
function RD(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
RD.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), r = e.get("truncate", t, this), n = e.get("format", t, this);
    return r && n.length > r ? n.substring(0, r) + "…" : n;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e) {
    return e === void 0 && (e = ds.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, r = this.toHref(e.get("defaultProtocol")), n = e.get("formatHref", r, this), o = e.get("tagName", r, t), i = this.toFormattedString(e), a = {}, l = e.get("className", r, t), s = e.get("target", r, t), c = e.get("rel", r, t), u = e.getObj("attributes", r, t), d = e.getObj("events", r, t);
    return a.href = n, l && (a.class = l), s && (a.target = s), c && (a.rel = c), u && Ma(a, u), {
      tagName: o,
      attributes: a,
      content: i,
      eventListeners: d
    };
  }
};
function xd(e, t) {
  class r extends RD {
    constructor(o, i) {
      super(o, i), this.t = e;
    }
  }
  for (const n in t)
    r.prototype[n] = t[n];
  return r.t = e, r;
}
const M1 = xd("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), y1 = xd("text"), sue = xd("nl"), gu = xd("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e) {
    return e === void 0 && (e = ds.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== cs && e[1].t === vo;
  }
}), Kr = (e) => new Dr(e);
function uue(e) {
  let {
    groups: t
  } = e;
  const r = t.domain.concat([Cc, Ac, go, Dc, kc, Ec, Lc, $c, An, K0, zc, Oc, jc, Rc, Dn, Bc, Ol, Pc]), n = [Ic, vo, J0, In, X0, _c, ev, tv, mc, vc, $l, zl, pc, fc, hc, gc, bc, Mc, yc, xc, wc, Tc, Nc, Sc], o = [Cc, Ic, Ac, Dc, kc, Ec, Lc, $c, An, $l, zl, zc, Oc, jc, Rc, _c, Dn, Bc, Ol, Pc], i = Kr(), a = ge(i, Ol);
  Ke(a, o, a), Ke(a, t.domain, a);
  const l = Kr(), s = Kr(), c = Kr();
  Ke(i, t.domain, l), Ke(i, t.scheme, s), Ke(i, t.slashscheme, c), Ke(l, o, a), Ke(l, t.domain, l);
  const u = ge(l, go);
  ge(a, go, u), ge(s, go, u), ge(c, go, u);
  const d = ge(a, In);
  Ke(d, o, a), Ke(d, t.domain, a);
  const f = Kr();
  Ke(u, t.domain, f), Ke(f, t.domain, f);
  const p = ge(f, In);
  Ke(p, t.domain, f);
  const h = Kr(M1);
  Ke(p, t.tld, h), Ke(p, t.utld, h), ge(u, cs, h);
  const g = ge(f, An);
  Ke(g, t.domain, f), Ke(h, t.domain, f), ge(h, In, p), ge(h, An, g);
  const m = ge(h, vo);
  Ke(m, t.numeric, M1);
  const v = ge(l, An), M = ge(l, In);
  Ke(v, t.domain, l), Ke(M, o, a), Ke(M, t.domain, l);
  const x = Kr(gu);
  Ke(M, t.tld, x), Ke(M, t.utld, x), Ke(x, t.domain, l), Ke(x, o, a), ge(x, In, M), ge(x, An, v), ge(x, go, u);
  const b = ge(x, vo), T = Kr(gu);
  Ke(b, t.numeric, T);
  const w = Kr(gu), y = Kr();
  Ke(w, r, w), Ke(w, n, y), Ke(y, r, w), Ke(y, n, y), ge(x, Dn, w), ge(T, Dn, w);
  const I = ge(s, vo), D = ge(c, vo), O = ge(D, Dn), $ = ge(O, Dn);
  Ke(s, t.domain, l), ge(s, In, M), ge(s, An, v), Ke(c, t.domain, l), ge(c, In, M), ge(c, An, v), Ke(I, t.domain, w), ge(I, Dn, w), Ke($, t.domain, w), Ke($, r, w), ge($, Dn, w);
  const z = [
    [$l, zl],
    // {}
    [fc, pc],
    // []
    [hc, gc],
    // ()
    [mc, vc],
    // <>
    [bc, Mc],
    // （）
    [yc, xc],
    // 「」
    [wc, Tc],
    // 『』
    [Nc, Sc]
    // ＜＞
  ];
  for (let Y = 0; Y < z.length; Y++) {
    const [j, q] = z[Y], ee = ge(w, j);
    ge(y, j, ee), ge(ee, q, w);
    const re = Kr(gu);
    Ke(ee, r, re);
    const le = Kr();
    Ke(ee, n), Ke(re, r, re), Ke(re, n, le), Ke(le, r, re), Ke(le, n, le), ge(re, q, w), ge(le, q, w);
  }
  return ge(i, cs, x), ge(i, q0, sue), {
    start: i,
    tokens: jD
  };
}
function cue(e, t, r) {
  let n = r.length, o = 0, i = [], a = [];
  for (; o < n; ) {
    let l = e, s = null, c = null, u = 0, d = null, f = -1;
    for (; o < n && !(s = l.go(r[o].t)); )
      a.push(r[o++]);
    for (; o < n && (c = s || l.go(r[o].t)); )
      s = null, l = c, l.accepts() ? (f = 0, d = l) : f >= 0 && f++, o++, u++;
    if (f < 0)
      o -= u, o < n && (a.push(r[o]), o++);
    else {
      a.length > 0 && (i.push($f(y1, t, a)), a = []), o -= f, u -= f;
      const p = d.t, h = r.slice(o - u, o);
      i.push($f(p, t, h));
    }
  }
  return a.length > 0 && i.push($f(y1, t, a)), i;
}
function $f(e, t, r) {
  const n = r[0].s, o = r[r.length - 1].e, i = t.slice(n, o);
  return new e(i, r);
}
const Rt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function due() {
  Dr.groups = {}, Rt.scanner = null, Rt.parser = null, Rt.tokenQueue = [], Rt.pluginQueue = [], Rt.customSchemes = [], Rt.initialized = !1;
}
function fue() {
  Rt.scanner = iue(Rt.customSchemes);
  for (let e = 0; e < Rt.tokenQueue.length; e++)
    Rt.tokenQueue[e][1]({
      scanner: Rt.scanner
    });
  Rt.parser = uue(Rt.scanner.tokens);
  for (let e = 0; e < Rt.pluginQueue.length; e++)
    Rt.pluginQueue[e][1]({
      scanner: Rt.scanner,
      parser: Rt.parser
    });
  Rt.initialized = !0;
}
function _D(e) {
  return Rt.initialized || fue(), cue(Rt.parser.start, e, aue(Rt.scanner.start, e));
}
function nv(e, t, r) {
  if (t === void 0 && (t = null), r === void 0 && (r = null), t && typeof t == "object") {
    if (r)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    r = t, t = null;
  }
  const n = new rv(r), o = _D(e), i = [];
  for (let a = 0; a < o.length; a++) {
    const l = o[a];
    l.isLink && (!t || l.t === t) && n.check(l) && i.push(l.toFormattedObject(n));
  }
  return i;
}
function x1(e, t) {
  t === void 0 && (t = null);
  const r = _D(e);
  return r.length === 1 && r[0].isLink && (!t || r[0].t === t);
}
function pue(e) {
  return new Nr({
    key: new pr("autolink"),
    appendTransaction: (t, r, n) => {
      const o = t.some((u) => u.docChanged) && !r.doc.eq(n.doc), i = t.some(
        (u) => u.getMeta("preventAutolink")
      );
      if (!o || i)
        return;
      const { tr: a } = n, l = LW(r.doc, [...t]), { mapping: s } = l;
      if (PW(l).forEach(({ oldRange: u, newRange: d }) => {
        oc(u.from, u.to, r.doc).filter((g) => g.mark.type === e.type).forEach((g) => {
          const m = s.map(g.from), v = s.map(g.to), M = oc(
            m,
            v,
            n.doc
          ).filter((I) => I.mark.type === e.type);
          if (!M.length)
            return;
          const x = M[0], b = r.doc.textBetween(
            g.from,
            g.to,
            void 0,
            " "
          ), T = n.doc.textBetween(
            x.from,
            x.to,
            void 0,
            " "
          ), w = x1(b), y = x1(T);
          w && !y && a.removeMark(x.from, x.to, e.type);
        });
        const f = zW(
          n.doc,
          d,
          (g) => g.isTextblock
        );
        let p, h;
        if (f.length > 1 ? (p = f[0], h = n.doc.textBetween(
          p.pos,
          p.pos + p.node.nodeSize,
          void 0,
          " "
        )) : f.length && // We want to make sure to include the block seperator argument to treat hard breaks like spaces
        n.doc.textBetween(d.from, d.to, " ", " ").endsWith(" ") && (p = f[0], h = n.doc.textBetween(
          p.pos,
          d.to,
          void 0,
          " "
        )), p && h) {
          const g = h.split(" ").filter((M) => M !== "");
          if (g.length <= 0)
            return !1;
          const m = g[g.length - 1], v = p.pos + h.lastIndexOf(m);
          if (!m)
            return !1;
          nv(m).filter((M) => M.isLink).filter((M) => e.validate ? e.validate(M.value) : !0).map((M) => ({
            ...M,
            from: v + M.start + 1,
            to: v + M.end + 1
          })).forEach((M) => {
            a.addMark(
              M.from,
              M.to,
              e.type.create({
                href: M.href
              })
            );
          });
        }
      }), !!a.steps.length)
        return a;
    }
  });
}
function hue(e) {
  return new Nr({
    key: new pr("handlePasteLink"),
    props: {
      handlePaste: (t, r, n) => {
        const { state: o } = t, { selection: i } = o, { empty: a } = i;
        if (a)
          return !1;
        let l = "";
        n.content.forEach((c) => {
          l += c.textContent;
        });
        const s = nv(l).find(
          (c) => c.isLink && c.value === l
        );
        return !l || !s ? !1 : (e.editor.commands.setMark(e.type, {
          href: s.href
        }), !0);
      }
    }
  });
}
const gue = Ur.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onDestroy() {
    due();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        title: "",
        class: void 0
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      title: {
        default: null
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      ...hr()
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return [
      "a",
      lt(this.options.HTMLAttributes, e),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => t().setMark(this.name, e).setMeta("preventAutolink", !0).run(),
      toggleLink: (e) => ({ chain: t }) => t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Ao({
        find: (e) => nv(e).filter((t) => this.options.validate ? this.options.validate(t.value) : !0).filter((t) => t.isLink).map((t) => ({
          text: t.value,
          index: t.start,
          data: t
        })),
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) == null ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return this.options.autolink && e.push(
      pue({
        type: this.type,
        validate: (t) => !!/^(http(s)?:\/\/)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.+~#?&//=]*)$/.test(t)
      })
    ), this.options.openOnClick && e.push(
      XA(
        {
          type: this.type
        },
        "a"
      )
    ), this.options.linkOnPaste && e.push(
      hue({
        editor: this.editor,
        type: this.type
      })
    ), e;
  }
}), w1 = /^(\d+)\.\s$/, mue = Ot.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      ...hr(),
      listStyle: {
        default: null,
        parseHTML: (e) => e.style.listStyleType ?? "decimal",
        renderHTML: (e) => e.listStyle ? {
          style: `list-style-type:${e.listStyle}`
        } : {}
      },
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...r } = e;
    return t === 1 ? [
      "ol",
      lt(this.options.HTMLAttributes, r),
      0
    ] : ["ol", lt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleCustomOrderedList: (e) => ({ chain: t }) => {
        var n;
        const r = (n = this.editor.getAttributes("orderedList")) == null ? void 0 : n.listStyle;
        return r !== void 0 && r !== e.type ? t().updateAttributes("orderedList", { listStyle: e.type }).run() : this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName).updateAttributes(
          Z0.name,
          this.editor.getAttributes(ss.name)
        ).run() : t().toggleList(this.name, this.options.itemTypeName).updateAttributes("orderedList", { listStyle: e.type }).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = es({
      find: w1,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, r) => r.childCount + r.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = es({
      find: w1,
      type: this.type,
      getAttributes: (t) => ({
        start: +t[1],
        ...this.editor.getAttributes(ss.name)
      }),
      joinPredicate: (t, r) => r.childCount + r.attrs.start === +t[1]
    })), [e];
  }
}), zf = {
  RTEControlBold: hl,
  RTEControlItalic: Cl,
  RTEControlUnderline: Ll,
  RTEControlStrike: Al,
  RTEControlTextBlocks: El,
  RTEControlTextAlignment: wo,
  RTEControlFontFamily: Nl,
  RTEControlLineHeight: Il,
  RTEControlCustomSelect: Tu,
  RTEControlEmbedVideo: Tl,
  RTEControlEmbedImage: wl,
  RTEControlFontSize: Sl,
  UIRichTextEditor: ole,
  RTEControlResetStyles: aa,
  RTEControlList: Or,
  RTEControlColorPicker: bl,
  RTEControlHistory: ia,
  RTEControlCode: ea,
  RTEControlSuperscript: kl,
  RTEControlSubscript: Dl,
  RTEControl: Je,
  RTEControlBlockQuote: pl,
  RTEControlTable: Ir,
  UIMenuWrapper: ele,
  UITextEditorToolbar: dle
};
function vue(e) {
  for (const t in zf)
    e.component(zf[t].name, zf[t]);
}
const Rue = { install: vue };
export {
  jue as AllExtensions,
  ple as Blockquote,
  hle as Bold,
  Kse as BulletList,
  bD as CodeBlock,
  $ue as CodeFormats,
  kue as Color,
  Lle as DivTag,
  vle as FontFamily,
  Ole as HardBreak,
  hD as Heading,
  Ule as Image,
  MD as InlineCode,
  ble as Italic,
  Mle as LineHeight,
  gue as Link,
  Z0 as ListItem,
  mue as OrderedList,
  Sle as Placeholder,
  $le as PreTag,
  Je as RTEControl,
  pl as RTEControlBlockQuote,
  hl as RTEControlBold,
  ea as RTEControlCode,
  bl as RTEControlColorPicker,
  Tu as RTEControlCustomSelect,
  wl as RTEControlEmbedImage,
  Cu as RTEControlEmbedLink,
  Tl as RTEControlEmbedVideo,
  Nl as RTEControlFontFamily,
  Sl as RTEControlFontSize,
  ia as RTEControlHistory,
  Cl as RTEControlItalic,
  Il as RTEControlLineHeight,
  Or as RTEControlList,
  aa as RTEControlResetStyles,
  Al as RTEControlStrike,
  Dl as RTEControlSubscript,
  kl as RTEControlSuperscript,
  Ir as RTEControlTable,
  wo as RTEControlTextAlignment,
  El as RTEControlTextBlocks,
  Ll as RTEControlUnderline,
  Qle as RequiredExtensions,
  xle as Strike,
  wle as Subscript,
  Tle as Superscript,
  DD as Table,
  kD as TableCell,
  He as TableControlActions,
  Oue as TableExtensions,
  ED as TableHeader,
  LD as TableRow,
  Cle as TextAlign,
  Eue as TextBlocks,
  ss as TextExtensions,
  Lue as TextSize,
  ele as UIMenuWrapper,
  ole as UIRichTextEditor,
  dle as UITextEditorToolbar,
  Nle as Underline,
  Eoe as Video,
  $oe as Youtube,
  Aue as cleanHTMLForEmail,
  Cue as convertStringToHTML,
  Rue as default,
  Due as formatHTMLForTipTap,
  Iue as getEditorStyles,
  Sue as getEditorText
};
